/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 369);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(376);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(379)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return configure; });
/* unused harmony export globalize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __; });
/* unused harmony export __mf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __n; });
/* unused harmony export __l */
/* unused harmony export __h */
/* unused harmony export onLocaleChange */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return setLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getLocale; });
/* unused harmony export getLocales */
/* unused harmony export getCatalog */
/* unused harmony export addLocale */
/* unused harmony export removeLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sprintf_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_sprintf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_sprintf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_math_interval_parser__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_math_interval_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_math_interval_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_make_plural_make_plural__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_make_plural_make_plural___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_make_plural_make_plural__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_make_plural_data_plurals_json__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_make_plural_data_plurals_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_make_plural_data_plurals_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_messageformat__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mustache__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_mustache___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_mustache__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_url__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_url__);












var global$1 = typeof global !== "undefined" ? global :
            typeof self !== "undefined" ? self :
            typeof window !== "undefined" ? window : {};

__WEBPACK_IMPORTED_MODULE_6_make_plural_make_plural___default.a.load(__WEBPACK_IMPORTED_MODULE_7_make_plural_data_plurals_json___default.a);

var localeChangeListener = function localeChangeListener() {};
var defaultLocale = 'en';
var locales = {};
var fallbacks = {};
var cookiename = null;
var objectNotation = false;

var MessageFormatInstanceForLocale = {};
var PluralsForLocale = {};

// Silent configure if I18N object is exist.
if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(global$1.I18N) == 'object') {
	configure(global$1.I18N);
}

/**
 * Configure i18n with given options.
 *
 * @param  {Object} options
 */
function configure(options) {

	// read languages locales
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(options.locales) == 'object') {
		locales = options.locales;
	}

	// sets a custom cookie name to parse locale settings from
	if (typeof options.cookie == 'string') {
		cookiename = options.cookie;
	}

	// setting defaultLocale
	if (typeof options.defaultLocale == 'string') {
		defaultLocale = options.defaultLocale;
	}

	// enable object notation?
	if (typeof options.objectNotation != 'undefined') {
		objectNotation = options.objectNotation;
	}

	if (objectNotation === true) {
		objectNotation = '.';
	}

	// read language fallback map
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(options.fallbacks) == 'object') {
		fallbacks = options.fallbacks;
	}

	// globalize
	if (options.globalize === true) {
		globalize();
	}

	defaultLocale = getCookie(cookiename) || defaultLocale;

	// get default locale from url
	var typeofQueryParameter = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(options.queryParameter);

	if (typeofQueryParameter != 'undefined' && typeof location != 'undefined') {

		var queryParameter = typeofQueryParameter == 'string' ? options.queryParameter : 'locale';

		var localeFromQuery = __WEBPACK_IMPORTED_MODULE_10_url___default()(location.href).query[queryParameter];

		if (typeof localeFromQuery == 'string') {
			defaultLocale = localeFromQuery;
		}
	}
}

/**
 * Inject `__`, `__n` and other functions to global scope.
 *
 */
function globalize() {
	global$1.__ = applyAPItoObject(__);
	global$1.__n = applyAPItoObject(__n);
	global$1.__l = applyAPItoObject(__l);
	global$1.__h = applyAPItoObject(__h);
	global$1.__mf = applyAPItoObject(__mf);
}

/**
 * Translates a single phrase and adds it to locales if unknown.
 * Returns translated parsed and substituted string.
 *
 * @param  {String}    phrase
 * @param  {...Object} params
 * @return {String}    translate
 */
function __(_phrase) {

	var phrase = preProcess(_phrase);

	var translated = null,
	    namedValues = null;

	// Accept an object with named values as the last parameter

	for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
		params[_key - 1] = arguments[_key];
	}

	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(params[params.length - 1]) == 'object') {
		namedValues = params.pop();
	}

	// called like __({phrase: "Hello", locale: "en"})
	if ((typeof phrase === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(phrase)) === 'object') {

		if (typeof phrase.locale === 'string' && typeof phrase.phrase === 'string') {
			translated = translate(phrase.locale, phrase.phrase);
		}

		// called like __("Hello")
	} else {
		// get translated message with locale
		translated = translate(defaultLocale, phrase);
	}

	// postprocess to get compatible to plurals
	if ((typeof translated === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(translated)) === 'object' && typeof translated.one != 'undefined') {
		translated = translated.one;
	}

	// in case there is no 'one' but an 'other' rule
	if ((typeof translated === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(translated)) === 'object' && typeof translated.other != 'undefined') {
		translated = translated.other;
	}

	return postProcess(translated, namedValues, params);
}

/**
 * Supports the advanced MessageFormat as provided by excellent messageformat module.
 * You should definetly head over to messageformat.github.io for a guide to MessageFormat.
 * i18n takes care of new MessageFormat('en').compile(msg);
 * with the current msg loaded from it's json files and cache that complied fn in memory.
 * So in short you might use it similar to __() plus extra object to accomblish MessageFormat's formating.
 *
 * @param  {String}    phrase
 * @param  {...Object} params
 * @return {String}    translate
 */
function __mf(_phrase) {

	var phrase = _phrase,
	    targetLocale = defaultLocale,
	    namedValues = null,
	    mf = null,
	    f = null;

	// Accept an object with named values as the last parameter

	for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		params[_key2 - 1] = arguments[_key2];
	}

	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(params[params.length - 1]) == 'object') {
		namedValues = params.pop();
	}

	// called like __mf({phrase: "Hello", locale: "en"})
	if ((typeof phrase === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(phrase)) === 'object') {

		if (typeof phrase.locale === 'string' && typeof phrase.phrase === 'string') {
			targetLocale = phrase.locale;
			phrase = phrase.phrase;
		}
	}
	// else called like __mf("Hello")

	var translated = translate(targetLocale, phrase);
	// --- end get translate

	// now head over to MessageFormat
	// and try to cache instance
	if (MessageFormatInstanceForLocale[targetLocale]) {
		mf = MessageFormatInstanceForLocale[targetLocale];
	} else {
		mf = new __WEBPACK_IMPORTED_MODULE_8_messageformat___default.a(targetLocale);
		mf.compiledFunctions = {};
		MessageFormatInstanceForLocale[targetLocale] = mf;
	}

	// let's try to cache that function
	if (mf.compiledFunctions[translated]) {
		f = mf.compiledFunctions[translated];
	} else {
		f = mf.compile(translated);
		mf.compiledFunctions[translated] = f;
	}

	return postProcess(f(namedValues), namedValues, params);
}

/**
 * Plurals translation of a single phrase.
 * Singular and plural forms will get added to locales if unknown.
 * Returns translated parsed and substituted string based on `count` parameter.
 *
 * @param  {String}    singular
 * @param  {String}    plural
 * @param  {Number}    count
 * @param  {...Object} params
 * @return {String}    translate
 */
function __n(_singular, _plural, _count) {

	var singular = preProcess(_singular);

	var plural = _plural,
	    count = _count,
	    translated = null,
	    namedValues = null,
	    targetLocale = null;

	// Accept an object with named values as the last parameter

	for (var _len3 = arguments.length, params = Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
		params[_key3 - 3] = arguments[_key3];
	}

	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(params[params.length - 1]) == 'object') {
		namedValues = params.pop();
	}

	// called like __n({singular: "%s cat", plural: "%s cats", locale: "en"}, 3)
	if ((typeof singular === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(singular)) === 'object') {

		if (typeof singular.locale === 'string' && typeof singular.singular === 'string' && typeof singular.plural === 'string') {
			translated = translate(targetLocale = singular.locale, singular.singular, singular.plural);
		}

		params.unshift(count);

		// some template engines pass all values as strings -> so we try to convert them to numbers
		if (typeof plural === 'number' || '' + parseInt(plural, 10) === plural) {
			count = plural;
		}

		// called like __n({singular: "%s cat", plural: "%s cats", locale: "en", count: 3})
		if (typeof singular.count === 'number' || typeof singular.count === 'string') {
			count = singular.count;
			params.unshift(plural);
		}
	} else {
		// called like	__n('cat', 3)
		if (typeof plural === 'number' || String(parseInt(plural, 10)) === plural) {
			count = plural;

			// we add same string as default
			// which efectivly copies the key to the plural.value
			// this is for initialization of new empty translations
			plural = singular;

			params.unshift(count);
			params.unshift(plural);
		}
		// called like __n('%s cat', '%s cats', 3)
		// get translated message with locale from scope (deprecated) or object
		translated = translate(targetLocale = defaultLocale, singular, plural);
	}

	if (count === null) {
		count = namedValues.count;
	}

	// enforce number
	count = parseInt(count, 10);

	// find the correct plural rule for given locale
	if ((typeof translated === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(translated)) === 'object') {

		var p = null;

		// create a new Plural for locale
		// and try to cache instance
		if (PluralsForLocale[targetLocale]) {
			p = PluralsForLocale[targetLocale];
		} else {
			p = new __WEBPACK_IMPORTED_MODULE_6_make_plural_make_plural___default.a(targetLocale);
			PluralsForLocale[targetLocale] = p;
		}

		// fallback to 'other' on case of missing translations
		translated = translated[p(count)] || translated.other;
	}

	return postProcess(translated, namedValues, params, count);
}

/**
 * Returns a list of translations for a given phrase in each language.
 *
 * @param  {String} phrase
 * @return {Array<String>}
 */
function __l(phrase) {
	return getLocales().sort().map(function (locale) {
		return __({
			phrase: phrase, locale: locale
		});
	});
}

/**
 * Returns a hashed list of translations for a given phrase in each language.
 *
 * @param  {String} phrase
 * @return {Array<Object>}
 */
function __h(phrase) {
	return getLocales().sort().map(function (locale) {
		return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({}, locale, __({
			phrase: phrase, locale: locale
		}));
	});
}

/**
 * Set function to call when locale was change.
 *
 * @param  {Function} listener
 */
function onLocaleChange(listener) {
	localeChangeListener = listener;
}

/**
 * Set current locale.
 *
 * @param  {String} locale
 * @return {String} locale
 */
function setLocale(_locale) {

	var locale = _locale;

	var fallback = fallbacks[locale];

	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[locale]) != 'object' && typeof fallback == 'string') {
		locale = fallback;
	}

	// called like setLocale('en')
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[locale]) == 'object') {

		defaultLocale = locale;

		if (cookiename !== null) {
			setCookie(cookiename, defaultLocale, {
				expires: 3600 * 24 * 31 * 12 * 100,
				path: '/'
			});
		}

		localeChangeListener(defaultLocale);
	}

	return defaultLocale;
}

/**
 * Get current locale.
 *
 * @return {String}
 */
function getLocale() {
	return defaultLocale;
}

/**
 * Get array of available locales.
 *
 * @return {Array<String>}
 */
function getLocales() {
	return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(locales).filter(function (_) {
		return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[_]) == 'object';
	});
}

/**
 * Returns a whole catalog optionally based on given locale.
 *
 * @param  {String} locale
 * @return {Object|Array}
 */
function getCatalog(_locale) {

	var locale = _locale;

	if (typeof locale == 'undefined') {
		return locales;
	}

	var fallback = fallbacks[locale];

	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[locale]) != 'object' && typeof fallback == 'string') {
		locale = fallback;
	}

	var catalog = locales[locale];

	// called like setLocale('en')
	if ((typeof catalog === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(catalog)) == 'object') {
		return catalog;
	}

	return false;
}

/**
 * Add new translations.
 *
 * @param {String} locale
 * @param {Object} catalog
 */
function addLocale(locale, catalog) {
	locales[locale] = catalog;
}

/**
 * Remove translations.
 *
 * @param  {String}
 */
function removeLocale(locale) {
	locales[locale] = false;
}

function applyAPItoObject(object) {

	object.onLocaleChange = onLocaleChange;
	object.setLocale = setLocale;
	object.getLocale = getLocale;
	object.getLocales = getLocales;
	object.getCatalog = getCatalog;
	object.addLocale = addLocale;
	object.removeLocale = removeLocale;

	return object;
}

function setCookie(name, value) {
	var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


	if (typeof document == 'undefined') {
		return;
	}

	var expires = options.expires;

	if (typeof expires == 'number' && expires) {

		var d = new Date();

		d.setTime(d.getTime() + expires * 1000);
		expires = options.expires = d;
	}

	if (expires && expires.toUTCString) {
		options.expires = expires.toUTCString();
	}

	var updatedCookie = name + '=' + encodeURIComponent(value);

	for (var propName in options) {

		updatedCookie += '; ' + propName;

		var propValue = options[propName];

		if (propValue !== true) {
			updatedCookie += '=' + propValue;
		}
	}

	document.cookie = updatedCookie;
}

function getCookie(name) {

	if (typeof document == 'undefined' || name == null) {
		return false;
	}

	var matches = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[]\\\/+^])/g, '\\$1') + '=([^;]*)'));

	return matches ? decodeURIComponent(matches[1]) : false;
}

function preProcess(text) {

	if (Array.isArray(text) && text.hasOwnProperty('raw')) {
		return text.join('%s');
	}

	return text;
}

function postProcess(_text, namedValues, params, count) {

	var text = _text;

	// test for parsable interval string
	if (/\|/.test(text)) {
		text = parsePluralInterval(text, count);
	}

	// replace the counter
	if (typeof count == 'number') {
		text = Object(__WEBPACK_IMPORTED_MODULE_4_sprintf_js__["vsprintf"])(text, [parseInt(count, 10)]);
	}

	// if the text string contains {{Mustache}} patterns we render it as a mini tempalate
	if (/\{\{.*\}\}/.test(text)) {
		text = __WEBPACK_IMPORTED_MODULE_9_mustache___default.a.render(text, namedValues);
	}

	// if we have extra arguments with values to get replaced,
	// an additional substition injects those strings afterwards
	if (/%/.test(text) && params.length) {
		text = Object(__WEBPACK_IMPORTED_MODULE_4_sprintf_js__["vsprintf"])(text, params);
	}

	return text;
}

/**
 * splits and parses a phrase for mathematical interval expressions
 */
function parsePluralInterval(phrase, count) {

	var phrases = phrase.split(/\|/);

	var returnPhrase = phrase;

	// some() breaks on 1st true
	phrases.some(function (p) {
		var _p$match = p.match(/^\s*([()[]\d,]+)?\s*(.*)$/),
		    _p$match2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_p$match, 2),
		    m1 = _p$match2[0],
		    m2 = _p$match2[1];

		// not the same as in combined condition


		if (m1) {

			if (matchInterval(count, m1) === true) {
				returnPhrase = m2;
				return true;
			}
		} else {
			returnPhrase = p;
		}

		return false;
	});

	return returnPhrase;
}

/**
 * test a number to match mathematical interval expressions
 * [0,2] - 0 to 2 (including, matches: 0, 1, 2)
 * ]0,3[ - 0 to 3 (excluding, matches: 1, 2)
 * [1]   - 1 (matches: 1)
 * [20,] - all numbers ≥20 (matches: 20, 21, 22, ...)
 * [,20] - all numbers ≤20 (matches: 20, 21, 22, ...)
 */
function matchInterval(number, _interval) {

	var interval = __WEBPACK_IMPORTED_MODULE_5_math_interval_parser___default()(_interval);

	if (interval && typeof number == 'number') {
		var _interval$from = interval.from,
		    fromIncluded = _interval$from.included,
		    fromValue = _interval$from.value,
		    _interval$to = interval.to,
		    toIncluded = _interval$to.included,
		    toValue = _interval$to.value;


		if (fromValue === number) {
			return fromIncluded;
		}

		if (toValue === number) {
			return toIncluded;
		}

		return Math.min(fromValue, number) === fromValue && Math.max(toValue, number) === toValue;
	}

	return false;
}

function translate(_locale, _singular, _plural) {

	var fallback = fallbacks[_locale];

	var locale = _locale,
	    singular = _singular,
	    plural = _plural,
	    defaultSingular = singular,
	    defaultPlural = plural;

	if (typeof locale == 'undefined') {
		locale = defaultLocale;
	}

	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[locale]) != 'object' && typeof fallback == 'string') {
		locale = fallback;
	}

	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[locale]) != 'object') {
		locale = defaultLocale;
	}

	if (objectNotation) {

		var indexOfColon = singular.indexOf(':');
		// We compare against 0 instead of -1 because we don't really expect the string to start with ':'.

		if (indexOfColon > 0) {
			defaultSingular = singular.substring(indexOfColon + 1);
			singular = singular.substring(0, indexOfColon);
		}

		if (plural && typeof plural !== 'number') {

			indexOfColon = plural.indexOf(':');

			if (indexOfColon > 0) {
				defaultPlural = plural.substring(indexOfColon + 1);
				plural = plural.substring(0, indexOfColon);
			}
		}
	}

	var accessor = localeAccessor(locale, singular),
	    mutator = localeMutator(locale, singular);

	if (plural && !accessor()) {
		mutator({
			'one': defaultSingular || singular,
			'other': defaultPlural || plural
		});
	}

	if (!accessor()) {
		mutator(defaultSingular || singular);
	}

	return accessor();
}

/**
 * Allows delayed access to translations nested inside objects.
 * @param {String} locale The locale to use.
 * @param {String} singular The singular term to look up.
 * @param {Boolean} [allowDelayedTraversal=true] Is delayed traversal of the tree allowed?
 * This parameter is used internally. It allows to signal the accessor that
 * a translation was not found in the initial lookup and that an invocation
 * of the accessor may trigger another traversal of the tree.
 * @returns {Function} A function that, when invoked, returns the current value stored
 * in the object at the requested location.
 */
function localeAccessor(locale, singular, _allowDelayedTraversal) {

	var allowDelayedTraversal = _allowDelayedTraversal;

	// Bail out on non-existent locales to defend against internal errors.
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[locale]) != 'object') {
		return Function.prototype;
	}

	// Handle object lookup notation
	var indexOfDot = objectNotation && singular.lastIndexOf(objectNotation);

	if (objectNotation && 0 < indexOfDot && indexOfDot < singular.length - 1) {

		// If delayed traversal wasn't specifically forbidden, it is allowed.
		if (typeof allowDelayedTraversal == 'undefined') {
			allowDelayedTraversal = true;
		}

		// The accessor we're trying to find and which we want to return.
		var accessor = null;
		// An accessor that returns null.
		var nullAccessor = function nullAccessor() {
			return null;
		};
		// Do we need to re-traverse the tree upon invocation of the accessor?
		var reTraverse = false;

		// Split the provided term and run the callback for each subterm.
		singular.split(objectNotation).reduce(function (object, index) {
			// Make the accessor return null.
			accessor = nullAccessor;
			// If our current target object (in the locale tree) doesn't exist or
			// it doesn't have the next subterm as a member...
			if (object === null || !object.hasOwnProperty(index)) {
				// ...remember that we need retraversal (because we didn't find our target).
				reTraverse = allowDelayedTraversal;
				// Return null to avoid deeper iterations.
				return null;
			}
			// We can traverse deeper, so we generate an accessor for this current level.
			accessor = function accessor() {
				return object[index];
			};
			// Return a reference to the next deeper level in the locale tree.
			return object[index];
		}, locales[locale]);

		// Return the requested accessor.
		return function () {
			return (
				// If we need to re-traverse (because we didn't find our target term)
				// traverse again and return the new result (but don't allow further iterations)
				// or return the previously found accessor if it was already valid.
				reTraverse ? localeAccessor(locale, singular, false)() : accessor()
			);
		};
	} else {
		// No object notation, just return an accessor that performs array lookup.
		return function () {
			return locales[locale][singular];
		};
	}
}

/**
 * Allows delayed mutation of a translation nested inside objects.
 * @description Construction of the mutator will attempt to locate the requested term
 * inside the object, but if part of the branch does not exist yet, it will not be
 * created until the mutator is actually invoked. At that point, re-traversal of the
 * tree is performed and missing parts along the branch will be created.
 * @param {String} locale The locale to use.
 * @param {String} singular The singular term to look up.
 * @param {Boolean} [allowBranching=false] Is the mutator allowed to create previously
 * non-existent branches along the requested locale path?
 * @returns {Function} A function that takes one argument. When the function is
 * invoked, the targeted translation term will be set to the given value inside the locale table.
 */
function localeMutator(locale, singular, _allowBranching) {

	var allowBranching = _allowBranching;

	// Bail out on non-existent locales to defend against internal errors.
	if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(locales[locale]) != 'object') {
		return Function.prototype;
	}

	// Handle object lookup notation
	var indexOfDot = objectNotation && singular.lastIndexOf(objectNotation);

	if (objectNotation && 0 < indexOfDot && indexOfDot < singular.length - 1) {

		// If branching wasn't specifically allowed, disable it.
		if (typeof allowBranching == 'undefined') {
			allowBranching = false;
		}

		// This will become the function we want to return.
		var accessor = null;
		// An accessor that takes one argument and returns null.
		var nullAccessor = function nullAccessor() {
			return null;
		};
		// Fix object path.
		var fixObject = function fixObject() {
			return {};
		};
		// Are we going to need to re-traverse the tree when the mutator is invoked?
		var reTraverse = false;

		// Split the provided term and run the callback for each subterm.
		singular.split(objectNotation).reduce(function (_object, index) {

			var object = _object;

			// Make the mutator do nothing.
			accessor = nullAccessor;
			// If our current target object (in the locale tree) doesn't exist or
			// it doesn't have the next subterm as a member...
			if (object === null || !object.hasOwnProperty(index)) {
				// ...check if we're allowed to create new branches.
				if (allowBranching) {
					// Fix `object` if `object` is not Object.
					if (object === null || (typeof object === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(object)) != 'object') {
						object = fixObject();
					}
					// If we are allowed to, create a new object along the path.
					object[index] = {};
				} else {
					// If we aren't allowed, remember that we need to re-traverse later on and...
					reTraverse = true;
					// ...return null to make the next iteration bail our early on.
					return null;
				}
			}
			// Generate a mutator for the current level.
			accessor = function accessor(value) {
				return object[index] = value;
			};
			// Generate a fixer for the current level.
			fixObject = function fixObject() {
				return object[index] = {};
			};
			// Return a reference to the next deeper level in the locale tree.
			return object[index];
		}, locales[locale]);

		// Return the final mutator.
		return function (value) {
			return (
				// If we need to re-traverse the tree
				// invoke the search again, but allow branching this time (because here the mutator is being invoked)
				// otherwise, just change the value directly.
				reTraverse ? localeMutator(locale, singular, true)(value) : accessor(value)
			);
		};
	} else {
		// No object notation, just return a mutator that performs array lookup and changes the value.
		return function (value) {
			return locales[locale][singular] = value;
		};
	}
}


//# sourceMappingURL=index.es.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assertString;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function assertString(input) {
  var isString = typeof input === 'string' || input instanceof String;

  if (!isString) {
    var invalidType;

    if (input === null) {
      invalidType = 'null';
    } else {
      invalidType = _typeof(input);

      if (invalidType === 'object' && input.constructor && input.constructor.hasOwnProperty('name')) {
        invalidType = input.constructor.name;
      } else {
        invalidType = "a ".concat(invalidType);
      }
    }

    throw new TypeError("Expected string but received ".concat(invalidType, "."));
  }
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(7);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 5 */
/***/ (function(module, exports) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = apiCall;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_glxl_helpers__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var auth=new __WEBPACK_IMPORTED_MODULE_1_glxl_helpers__["Authorization"]();function apiCall(path){var body=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var method=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'GET';var opts=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var unauthorizedRedirect=arguments.length>4&&arguments[4]!==undefined?arguments[4]:true;var details={method:method,headers:{}};details.crossDomain=true;details.headers.Authorization=sessionStorage.getItem('token')||auth.getAuthString();if(body){if(body instanceof FormData){details.body=body;}else{details.body=JSON.stringify(body);details.headers['Content-Type']='application/json';}}details.headers=_extends({},details.headers,opts.headers);return fetch(__WEBPACK_IMPORTED_MODULE_0__config___default.a.apiUrl+path,details).then(function(resp){// Handle forbidden
if(resp.status===401){sessionStorage.setItem('tweedeinlog','true');}if((resp.status===403||resp.status===401)&&unauthorizedRedirect){auth.setAuthToken('');// cookie.setCookie('i18n', '');
sessionStorage.removeItem('redirect');sessionStorage.removeItem('prevLocation');sessionStorage.removeItem('noMobile');window.location.href='/login';return;}var contentType=resp.headers.get("content-type");if(contentType&&contentType.indexOf("application/json")!==-1){return resp.json();}return resp.blob();});}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(394);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export cursor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return beleidskeuzes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return icons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return belastingIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return groupIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return mapColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return mapElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ministryIcons; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img_icons_land_groen_svg__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__img_icons_land_groen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__img_icons_land_groen_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_icons_land_blauw_svg__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_icons_land_blauw_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_icons_land_blauw_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_icons_land_geel_svg__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_icons_land_geel_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_icons_land_geel_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_icons_land_oranje_svg__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_icons_land_oranje_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_icons_land_oranje_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_icons_land_paars_svg__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_icons_land_paars_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_icons_land_paars_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_icons_land_rood_svg__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__img_icons_land_rood_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__img_icons_land_rood_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_icons_camera_svg__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__img_icons_camera_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__img_icons_camera_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_icons_checklist_svg__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__img_icons_checklist_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__img_icons_checklist_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_icons_bonus_svg__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__img_icons_bonus_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__img_icons_bonus_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_icons_movie_svg__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__img_icons_movie_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__img_icons_movie_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_icons_economy_team_svg__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__img_icons_economy_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__img_icons_economy_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_medal_svg__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__img_medal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__img_medal_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_icons_lock_svg__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__img_icons_lock_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__img_icons_lock_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_icons_Lock_grey_svg__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__img_icons_Lock_grey_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__img_icons_Lock_grey_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_icons_pen_svg__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__img_icons_pen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__img_icons_pen_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_icons_locked_svg__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__img_icons_locked_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__img_icons_locked_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__img_icons_add_svg__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__img_icons_add_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__img_icons_add_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__img_icons_play2_svg__ = __webpack_require__(618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__img_icons_play2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__img_icons_play2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_icons_opstart_svg__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__img_icons_opstart_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__img_icons_opstart_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__img_icons_pdf_svg__ = __webpack_require__(620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__img_icons_pdf_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__img_icons_pdf_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__img_icons_delete_svg__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__img_icons_delete_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__img_icons_delete_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__img_icons_globas_svg__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__img_icons_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__img_icons_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__img_icons_beleidskeuze_svg__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__img_icons_beleidskeuze_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__img_icons_beleidskeuze_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__img_icons_belasting_6_svg__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__img_icons_belasting_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__img_icons_belasting_6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__img_thumbs_up_svg__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__img_thumbs_up_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__img_thumbs_up_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__img_thumbs_down_svg__ = __webpack_require__(623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__img_thumbs_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__img_thumbs_down_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__img_megafoon_svg__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__img_megafoon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__img_megafoon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__img_icons_check_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__img_icons_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__img_icons_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__img_icons_pauze_svg__ = __webpack_require__(625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__img_icons_pauze_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__img_icons_pauze_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__img_icons_download_svg__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__img_icons_download_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__img_icons_download_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__img_fairaway_logo_png__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__img_fairaway_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__img_fairaway_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__img_icons_link_svg__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__img_icons_link_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__img_icons_link_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__img_icons_popup_print_png__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__img_icons_popup_print_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__img_icons_popup_print_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__img_icons_belasting_1_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__img_icons_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__img_icons_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__img_icons_belasting_2_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__img_icons_belasting_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__img_icons_belasting_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__img_icons_belasting_3_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__img_icons_belasting_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__img_icons_belasting_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__img_icons_belasting_4_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__img_icons_belasting_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__img_icons_belasting_4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__img_icons_belasting_5_svg__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__img_icons_belasting_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__img_icons_belasting_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__img_icons_L_belasting_1_svg__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__img_icons_L_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__img_icons_L_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__img_icons_ministries_WI_svg__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__img_icons_ministries_WI_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__img_icons_ministries_WI_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__img_icons_ministries_GZ_svg__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__img_icons_ministries_GZ_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__img_icons_ministries_GZ_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__img_icons_ministries_OW_svg__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__img_icons_ministries_OW_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__img_icons_ministries_OW_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__img_icons_ministries_OT_svg__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__img_icons_ministries_OT_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__img_icons_ministries_OT_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__img_icons_ministries_VR_svg__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__img_icons_ministries_VR_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__img_icons_ministries_VR_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__img_icons_ministries_IE_svg__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__img_icons_ministries_IE_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__img_icons_ministries_IE_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__img_icons_ministries_FB_svg__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__img_icons_ministries_FB_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__img_icons_ministries_FB_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__img_icons_ministries_LV_svg__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__img_icons_ministries_LV_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__img_icons_ministries_LV_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__img_icons_ministries_KN_svg__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__img_icons_ministries_KN_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__img_icons_ministries_KN_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__img_icons_ministries_OH_svg__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__img_icons_ministries_OH_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__img_icons_ministries_OH_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__img_icons_ministries_WS_svg__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__img_icons_ministries_WS_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__img_icons_ministries_WS_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__img_icons_ministries_HB_svg__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__img_icons_ministries_HB_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__img_icons_ministries_HB_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__img_icons_ministries_EH_svg__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__img_icons_ministries_EH_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__img_icons_ministries_EH_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__img_icons_ministries_MC_svg__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__img_icons_ministries_MC_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__img_icons_ministries_MC_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__img_icons_ministries_edge_WI_png__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__img_icons_ministries_edge_WI_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__img_icons_ministries_edge_WI_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__img_icons_ministries_edge_GZ_png__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__img_icons_ministries_edge_GZ_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__img_icons_ministries_edge_GZ_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__img_icons_ministries_edge_OW_png__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__img_icons_ministries_edge_OW_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__img_icons_ministries_edge_OW_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__img_icons_ministries_edge_OT_png__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__img_icons_ministries_edge_OT_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__img_icons_ministries_edge_OT_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__img_icons_ministries_edge_VR_png__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__img_icons_ministries_edge_VR_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__img_icons_ministries_edge_VR_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__img_icons_ministries_edge_IE_png__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__img_icons_ministries_edge_IE_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__img_icons_ministries_edge_IE_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__img_icons_ministries_edge_FB_png__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__img_icons_ministries_edge_FB_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__img_icons_ministries_edge_FB_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__img_icons_ministries_edge_LV_png__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__img_icons_ministries_edge_LV_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__img_icons_ministries_edge_LV_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__img_icons_ministries_edge_KN_png__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__img_icons_ministries_edge_KN_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__img_icons_ministries_edge_KN_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__img_icons_ministries_edge_OH_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__img_icons_ministries_edge_OH_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__img_icons_ministries_edge_OH_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__img_icons_ministries_edge_WS_png__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__img_icons_ministries_edge_WS_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__img_icons_ministries_edge_WS_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__img_icons_ministries_edge_HB_png__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__img_icons_ministries_edge_HB_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__img_icons_ministries_edge_HB_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__img_icons_ministries_edge_EH_png__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__img_icons_ministries_edge_EH_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__img_icons_ministries_edge_EH_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__img_icons_ministries_edge_MC_png__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__img_icons_ministries_edge_MC_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__img_icons_ministries_edge_MC_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__img_MapElements_Beleidskeuzes_png__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__img_MapElements_Beleidskeuzes_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__img_MapElements_Beleidskeuzes_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__img_MapElements_Economy_png__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__img_MapElements_Economy_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__img_MapElements_Economy_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__img_MapElements_FB_FB1_png__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__img_MapElements_FB_FB1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__img_MapElements_FB_FB1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__img_MapElements_FB_FB1_2x_png__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__img_MapElements_FB_FB1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__img_MapElements_FB_FB1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__img_MapElements_FB_FB2_png__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__img_MapElements_FB_FB2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__img_MapElements_FB_FB2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__img_MapElements_FB_FB2_2x_png__ = __webpack_require__(635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__img_MapElements_FB_FB2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__img_MapElements_FB_FB2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__img_MapElements_FB_FB3_png__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__img_MapElements_FB_FB3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__img_MapElements_FB_FB3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__img_MapElements_FB_FB3_2x_png__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__img_MapElements_FB_FB3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__img_MapElements_FB_FB3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__img_MapElements_FB_FB4_png__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__img_MapElements_FB_FB4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__img_MapElements_FB_FB4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__img_MapElements_FB_FB4_2x_png__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__img_MapElements_FB_FB4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__img_MapElements_FB_FB4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__img_MapElements_FB_FB5_png__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__img_MapElements_FB_FB5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__img_MapElements_FB_FB5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__img_MapElements_FB_FB5_2x_png__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__img_MapElements_FB_FB5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__img_MapElements_FB_FB5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__img_MapElements_GZ_GZ1_png__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__img_MapElements_GZ_GZ1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__img_MapElements_GZ_GZ1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__img_MapElements_GZ_GZ1_2x_png__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__img_MapElements_GZ_GZ1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__img_MapElements_GZ_GZ1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__img_MapElements_GZ_GZ2_png__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__img_MapElements_GZ_GZ2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__img_MapElements_GZ_GZ2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__img_MapElements_GZ_GZ2_2x_png__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__img_MapElements_GZ_GZ2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84__img_MapElements_GZ_GZ2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__img_MapElements_GZ_GZ3_png__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__img_MapElements_GZ_GZ3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85__img_MapElements_GZ_GZ3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__img_MapElements_GZ_GZ3_2x_png__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__img_MapElements_GZ_GZ3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86__img_MapElements_GZ_GZ3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__img_MapElements_GZ_GZ4_png__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__img_MapElements_GZ_GZ4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87__img_MapElements_GZ_GZ4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__img_MapElements_GZ_GZ4_2x_png__ = __webpack_require__(649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__img_MapElements_GZ_GZ4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88__img_MapElements_GZ_GZ4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__img_MapElements_GZ_GZ5_png__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__img_MapElements_GZ_GZ5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89__img_MapElements_GZ_GZ5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__img_MapElements_GZ_GZ5_2x_png__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__img_MapElements_GZ_GZ5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90__img_MapElements_GZ_GZ5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__img_MapElements_HB_HB1_png__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__img_MapElements_HB_HB1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91__img_MapElements_HB_HB1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__img_MapElements_HB_HB1_2x_png__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__img_MapElements_HB_HB1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92__img_MapElements_HB_HB1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__img_MapElements_HB_HB2_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__img_MapElements_HB_HB2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93__img_MapElements_HB_HB2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__img_MapElements_HB_HB2_2x_png__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__img_MapElements_HB_HB2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94__img_MapElements_HB_HB2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__img_MapElements_HB_HB3_png__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__img_MapElements_HB_HB3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95__img_MapElements_HB_HB3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__img_MapElements_HB_HB3_2x_png__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__img_MapElements_HB_HB3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96__img_MapElements_HB_HB3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__img_MapElements_HB_HB4_png__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__img_MapElements_HB_HB4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97__img_MapElements_HB_HB4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__img_MapElements_HB_HB4_2x_png__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__img_MapElements_HB_HB4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_98__img_MapElements_HB_HB4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__img_MapElements_IE_IE1_png__ = __webpack_require__(652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__img_MapElements_IE_IE1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_99__img_MapElements_IE_IE1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__img_MapElements_IE_IE1_2x_png__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__img_MapElements_IE_IE1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_100__img_MapElements_IE_IE1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__img_MapElements_IE_IE2_png__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__img_MapElements_IE_IE2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_101__img_MapElements_IE_IE2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__img_MapElements_IE_IE2_2x_png__ = __webpack_require__(655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__img_MapElements_IE_IE2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_102__img_MapElements_IE_IE2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__img_MapElements_IE_IE3_png__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__img_MapElements_IE_IE3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_103__img_MapElements_IE_IE3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__img_MapElements_IE_IE3_2x_png__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__img_MapElements_IE_IE3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104__img_MapElements_IE_IE3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__img_MapElements_IE_IE4_png__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__img_MapElements_IE_IE4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105__img_MapElements_IE_IE4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__img_MapElements_IE_IE4_2x_png__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__img_MapElements_IE_IE4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106__img_MapElements_IE_IE4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__img_MapElements_IE_IE5_png__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__img_MapElements_IE_IE5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__img_MapElements_IE_IE5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__img_MapElements_IE_IE5_2x_png__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__img_MapElements_IE_IE5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_108__img_MapElements_IE_IE5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__img_MapElements_KN_KN1_png__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__img_MapElements_KN_KN1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_109__img_MapElements_KN_KN1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__img_MapElements_KN_KN1_2x_png__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__img_MapElements_KN_KN1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_110__img_MapElements_KN_KN1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__img_MapElements_KN_KN2_png__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__img_MapElements_KN_KN2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_111__img_MapElements_KN_KN2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__img_MapElements_KN_KN2_2x_png__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__img_MapElements_KN_KN2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_112__img_MapElements_KN_KN2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__img_MapElements_KN_KN3_png__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__img_MapElements_KN_KN3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_113__img_MapElements_KN_KN3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__img_MapElements_KN_KN3_2x_png__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__img_MapElements_KN_KN3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_114__img_MapElements_KN_KN3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__img_MapElements_KN_KN4_png__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__img_MapElements_KN_KN4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_115__img_MapElements_KN_KN4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__img_MapElements_KN_KN4_2x_png__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__img_MapElements_KN_KN4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_116__img_MapElements_KN_KN4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__img_MapElements_LV_LV1_png__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__img_MapElements_LV_LV1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_117__img_MapElements_LV_LV1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__img_MapElements_LV_LV1_2x_png__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__img_MapElements_LV_LV1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_118__img_MapElements_LV_LV1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__img_MapElements_LV_LV1_3x_png__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__img_MapElements_LV_LV1_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_119__img_MapElements_LV_LV1_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__img_MapElements_LV_LV1_4x_png__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__img_MapElements_LV_LV1_4x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_120__img_MapElements_LV_LV1_4x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__img_MapElements_LV_LV2_png__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__img_MapElements_LV_LV2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_121__img_MapElements_LV_LV2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__img_MapElements_LV_LV2_2x_png__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__img_MapElements_LV_LV2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_122__img_MapElements_LV_LV2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__img_MapElements_LV_LV2_3x_png__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__img_MapElements_LV_LV2_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_123__img_MapElements_LV_LV2_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__img_MapElements_LV_LV2_4x_png__ = __webpack_require__(677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__img_MapElements_LV_LV2_4x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_124__img_MapElements_LV_LV2_4x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__img_MapElements_LV_LV3_png__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__img_MapElements_LV_LV3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_125__img_MapElements_LV_LV3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__img_MapElements_LV_LV3_2x_png__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__img_MapElements_LV_LV3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_126__img_MapElements_LV_LV3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__img_MapElements_LV_LV3_3x_png__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__img_MapElements_LV_LV3_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_127__img_MapElements_LV_LV3_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__img_MapElements_LV_LV3_4x_png__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__img_MapElements_LV_LV3_4x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_128__img_MapElements_LV_LV3_4x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__img_MapElements_LV_LV4_png__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__img_MapElements_LV_LV4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_129__img_MapElements_LV_LV4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__img_MapElements_LV_LV4_2x_png__ = __webpack_require__(683);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__img_MapElements_LV_LV4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_130__img_MapElements_LV_LV4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__img_MapElements_LV_LV4_3x_png__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__img_MapElements_LV_LV4_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_131__img_MapElements_LV_LV4_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__img_MapElements_LV_LV4_4x_png__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__img_MapElements_LV_LV4_4x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_132__img_MapElements_LV_LV4_4x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__img_MapElements_LV_LV5_png__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__img_MapElements_LV_LV5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_133__img_MapElements_LV_LV5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__img_MapElements_LV_LV5_2x_png__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__img_MapElements_LV_LV5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_134__img_MapElements_LV_LV5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__img_MapElements_LV_LV5_3x_png__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__img_MapElements_LV_LV5_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_135__img_MapElements_LV_LV5_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__img_MapElements_LV_LV5_4x_png__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__img_MapElements_LV_LV5_4x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_136__img_MapElements_LV_LV5_4x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__img_MapElements_MC_MC1_png__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__img_MapElements_MC_MC1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_137__img_MapElements_MC_MC1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__img_MapElements_MC_MC1_2x_png__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__img_MapElements_MC_MC1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_138__img_MapElements_MC_MC1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__img_MapElements_MC_MC2_png__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__img_MapElements_MC_MC2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_139__img_MapElements_MC_MC2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__img_MapElements_MC_MC2_2x_png__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__img_MapElements_MC_MC2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_140__img_MapElements_MC_MC2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__img_MapElements_MC_MC3_png__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__img_MapElements_MC_MC3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_141__img_MapElements_MC_MC3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__img_MapElements_MC_MC3_2x_png__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__img_MapElements_MC_MC3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_142__img_MapElements_MC_MC3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__img_MapElements_MC_MC4_png__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__img_MapElements_MC_MC4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_143__img_MapElements_MC_MC4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__img_MapElements_MC_MC4_2x_png__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__img_MapElements_MC_MC4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_144__img_MapElements_MC_MC4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__img_MapElements_MC_MC5_png__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__img_MapElements_MC_MC5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_145__img_MapElements_MC_MC5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__img_MapElements_MC_MC5_2x_png__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__img_MapElements_MC_MC5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_146__img_MapElements_MC_MC5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__img_MapElements_OH_OH1_png__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__img_MapElements_OH_OH1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_147__img_MapElements_OH_OH1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__img_MapElements_OH_OH1_2x_png__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__img_MapElements_OH_OH1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_148__img_MapElements_OH_OH1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__img_MapElements_OH_OH2_png__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__img_MapElements_OH_OH2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_149__img_MapElements_OH_OH2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__img_MapElements_OH_OH2_2x_png__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__img_MapElements_OH_OH2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_150__img_MapElements_OH_OH2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__img_MapElements_OH_OH3_png__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__img_MapElements_OH_OH3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_151__img_MapElements_OH_OH3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__img_MapElements_OH_OH3_2x_png__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__img_MapElements_OH_OH3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_152__img_MapElements_OH_OH3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__img_MapElements_OH_OH4_png__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__img_MapElements_OH_OH4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_153__img_MapElements_OH_OH4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__img_MapElements_OH_OH4_2x_png__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__img_MapElements_OH_OH4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_154__img_MapElements_OH_OH4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__img_MapElements_OT_OT1_png__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__img_MapElements_OT_OT1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_155__img_MapElements_OT_OT1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__img_MapElements_OT_OT1_2x_png__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__img_MapElements_OT_OT1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_156__img_MapElements_OT_OT1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__img_MapElements_OT_OT2_png__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__img_MapElements_OT_OT2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_157__img_MapElements_OT_OT2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__img_MapElements_OT_OT2_2x_png__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__img_MapElements_OT_OT2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_158__img_MapElements_OT_OT2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__img_MapElements_OT_OT3_png__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__img_MapElements_OT_OT3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_159__img_MapElements_OT_OT3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__img_MapElements_OT_OT3_2x_png__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__img_MapElements_OT_OT3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_160__img_MapElements_OT_OT3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__img_MapElements_OT_OT4_png__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__img_MapElements_OT_OT4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_161__img_MapElements_OT_OT4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__img_MapElements_OT_OT4_2x_png__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__img_MapElements_OT_OT4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_162__img_MapElements_OT_OT4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__img_MapElements_OW_OW1_png__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__img_MapElements_OW_OW1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_163__img_MapElements_OW_OW1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__img_MapElements_OW_OW1_2x_png__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_164__img_MapElements_OW_OW1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_164__img_MapElements_OW_OW1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__img_MapElements_OW_OW2_png__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_165__img_MapElements_OW_OW2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_165__img_MapElements_OW_OW2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__img_MapElements_OW_OW2_2x_png__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_166__img_MapElements_OW_OW2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_166__img_MapElements_OW_OW2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__img_MapElements_OW_OW3_png__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_167__img_MapElements_OW_OW3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_167__img_MapElements_OW_OW3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__img_MapElements_OW_OW3_2x_png__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_168__img_MapElements_OW_OW3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_168__img_MapElements_OW_OW3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__img_MapElements_OW_OW4_png__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_169__img_MapElements_OW_OW4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_169__img_MapElements_OW_OW4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__img_MapElements_OW_OW4_2x_png__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_170__img_MapElements_OW_OW4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_170__img_MapElements_OW_OW4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__img_MapElements_OW_OW5_png__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_171__img_MapElements_OW_OW5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_171__img_MapElements_OW_OW5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__img_MapElements_OW_OW5_2x_png__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_172__img_MapElements_OW_OW5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_172__img_MapElements_OW_OW5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__img_MapElements_VR_VR1_png__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_173__img_MapElements_VR_VR1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_173__img_MapElements_VR_VR1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__img_MapElements_VR_VR1_2x_png__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_174__img_MapElements_VR_VR1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_174__img_MapElements_VR_VR1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__img_MapElements_VR_VR2_png__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_175__img_MapElements_VR_VR2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_175__img_MapElements_VR_VR2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__img_MapElements_VR_VR2_2x_png__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_176__img_MapElements_VR_VR2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_176__img_MapElements_VR_VR2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__img_MapElements_VR_VR3_png__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_177__img_MapElements_VR_VR3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_177__img_MapElements_VR_VR3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__img_MapElements_VR_VR3_2x_png__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_178__img_MapElements_VR_VR3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_178__img_MapElements_VR_VR3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__img_MapElements_VR_VR4_png__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_179__img_MapElements_VR_VR4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_179__img_MapElements_VR_VR4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__img_MapElements_VR_VR4_2x_png__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_180__img_MapElements_VR_VR4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_180__img_MapElements_VR_VR4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__img_MapElements_VR_VR5_png__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_181__img_MapElements_VR_VR5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_181__img_MapElements_VR_VR5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__img_MapElements_VR_VR5_2x_png__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_182__img_MapElements_VR_VR5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_182__img_MapElements_VR_VR5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__img_MapElements_WI_WI1_png__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_183__img_MapElements_WI_WI1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_183__img_MapElements_WI_WI1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__img_MapElements_WI_WI1_2x_png__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_184__img_MapElements_WI_WI1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_184__img_MapElements_WI_WI1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__img_MapElements_WI_WI2_png__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_185__img_MapElements_WI_WI2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_185__img_MapElements_WI_WI2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__img_MapElements_WI_WI2_2x_png__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_186__img_MapElements_WI_WI2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_186__img_MapElements_WI_WI2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__img_MapElements_WI_WI3_png__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_187__img_MapElements_WI_WI3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_187__img_MapElements_WI_WI3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__img_MapElements_WI_WI3_2x_png__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_188__img_MapElements_WI_WI3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_188__img_MapElements_WI_WI3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__img_MapElements_WI_WI4_png__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_189__img_MapElements_WI_WI4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_189__img_MapElements_WI_WI4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__img_MapElements_WI_WI4_2x_png__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_190__img_MapElements_WI_WI4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_190__img_MapElements_WI_WI4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__img_MapElements_WI_WI5_png__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_191__img_MapElements_WI_WI5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_191__img_MapElements_WI_WI5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__img_MapElements_WI_WI5_2x_png__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_192__img_MapElements_WI_WI5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_192__img_MapElements_WI_WI5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__img_MapElements_WS_WS1_png__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_193__img_MapElements_WS_WS1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_193__img_MapElements_WS_WS1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__img_MapElements_WS_WS1_2x_png__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_194__img_MapElements_WS_WS1_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_194__img_MapElements_WS_WS1_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__img_MapElements_WS_WS2_png__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_195__img_MapElements_WS_WS2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_195__img_MapElements_WS_WS2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__img_MapElements_WS_WS2_2x_png__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_196__img_MapElements_WS_WS2_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_196__img_MapElements_WS_WS2_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__img_MapElements_WS_WS3_png__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_197__img_MapElements_WS_WS3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_197__img_MapElements_WS_WS3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__img_MapElements_WS_WS3_2x_png__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_198__img_MapElements_WS_WS3_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_198__img_MapElements_WS_WS3_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__img_MapElements_WS_WS4_png__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_199__img_MapElements_WS_WS4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_199__img_MapElements_WS_WS4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__img_MapElements_WS_WS4_2x_png__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_200__img_MapElements_WS_WS4_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_200__img_MapElements_WS_WS4_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__img_MapElements_WS_WS5_png__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_201__img_MapElements_WS_WS5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_201__img_MapElements_WS_WS5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__img_MapElements_WS_WS5_2x_png__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_202__img_MapElements_WS_WS5_2x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_202__img_MapElements_WS_WS5_2x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__img_MapElements_highlight_png__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_203__img_MapElements_highlight_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_203__img_MapElements_highlight_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__img_MapElements_shadow_png__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_204__img_MapElements_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_204__img_MapElements_shadow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__img_cursor_png__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_205__img_cursor_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_205__img_cursor_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__img_icons_beleidskeuzes_basic_1_1_png__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_206__img_icons_beleidskeuzes_basic_1_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_206__img_icons_beleidskeuzes_basic_1_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__img_icons_beleidskeuzes_basic_1_2_png__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_207__img_icons_beleidskeuzes_basic_1_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_207__img_icons_beleidskeuzes_basic_1_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__img_icons_beleidskeuzes_basic_1_3_png__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_208__img_icons_beleidskeuzes_basic_1_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_208__img_icons_beleidskeuzes_basic_1_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__img_icons_beleidskeuzes_basic_1_4_png__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_209__img_icons_beleidskeuzes_basic_1_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_209__img_icons_beleidskeuzes_basic_1_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__img_icons_beleidskeuzes_basic_1_5_png__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_210__img_icons_beleidskeuzes_basic_1_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_210__img_icons_beleidskeuzes_basic_1_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__img_icons_beleidskeuzes_basic_1_6_png__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_211__img_icons_beleidskeuzes_basic_1_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_211__img_icons_beleidskeuzes_basic_1_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__img_icons_beleidskeuzes_basic_2_1_png__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_212__img_icons_beleidskeuzes_basic_2_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_212__img_icons_beleidskeuzes_basic_2_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__img_icons_beleidskeuzes_basic_2_2_png__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_213__img_icons_beleidskeuzes_basic_2_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_213__img_icons_beleidskeuzes_basic_2_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__img_icons_beleidskeuzes_basic_2_3_png__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_214__img_icons_beleidskeuzes_basic_2_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_214__img_icons_beleidskeuzes_basic_2_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__img_icons_beleidskeuzes_basic_2_4_png__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_215__img_icons_beleidskeuzes_basic_2_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_215__img_icons_beleidskeuzes_basic_2_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__img_icons_beleidskeuzes_basic_2_5_png__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_216__img_icons_beleidskeuzes_basic_2_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_216__img_icons_beleidskeuzes_basic_2_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__img_icons_beleidskeuzes_basic_2_6_png__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_217__img_icons_beleidskeuzes_basic_2_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_217__img_icons_beleidskeuzes_basic_2_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__img_icons_beleidskeuzes_basic_3_1_png__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_218__img_icons_beleidskeuzes_basic_3_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_218__img_icons_beleidskeuzes_basic_3_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__img_icons_beleidskeuzes_basic_3_2_png__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_219__img_icons_beleidskeuzes_basic_3_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_219__img_icons_beleidskeuzes_basic_3_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__img_icons_beleidskeuzes_basic_3_3_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_220__img_icons_beleidskeuzes_basic_3_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_220__img_icons_beleidskeuzes_basic_3_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__img_icons_beleidskeuzes_basic_3_4_png__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_221__img_icons_beleidskeuzes_basic_3_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_221__img_icons_beleidskeuzes_basic_3_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__img_icons_beleidskeuzes_basic_3_5_png__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_222__img_icons_beleidskeuzes_basic_3_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_222__img_icons_beleidskeuzes_basic_3_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__img_icons_beleidskeuzes_basic_3_6_png__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_223__img_icons_beleidskeuzes_basic_3_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_223__img_icons_beleidskeuzes_basic_3_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__img_icons_beleidskeuzes_basic_4_1_png__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_224__img_icons_beleidskeuzes_basic_4_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_224__img_icons_beleidskeuzes_basic_4_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__img_icons_beleidskeuzes_basic_4_2_png__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_225__img_icons_beleidskeuzes_basic_4_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_225__img_icons_beleidskeuzes_basic_4_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__img_icons_beleidskeuzes_basic_4_3_png__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_226__img_icons_beleidskeuzes_basic_4_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_226__img_icons_beleidskeuzes_basic_4_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__img_icons_beleidskeuzes_basic_4_4_png__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_227__img_icons_beleidskeuzes_basic_4_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_227__img_icons_beleidskeuzes_basic_4_4_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__img_icons_beleidskeuzes_basic_4_5_png__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_228__img_icons_beleidskeuzes_basic_4_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_228__img_icons_beleidskeuzes_basic_4_5_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__img_icons_beleidskeuzes_basic_4_6_png__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_229__img_icons_beleidskeuzes_basic_4_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_229__img_icons_beleidskeuzes_basic_4_6_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__img_icons_groepsbewerk_svg__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_230__img_icons_groepsbewerk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_230__img_icons_groepsbewerk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__img_icons_testen_svg__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_231__img_icons_testen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_231__img_icons_testen_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__img_MapElements_Plateau_H_1_svg__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_232__img_MapElements_Plateau_H_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_232__img_MapElements_Plateau_H_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__img_MapElements_Plateau_H_2_svg__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_233__img_MapElements_Plateau_H_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_233__img_MapElements_Plateau_H_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__img_MapElements_Plateau_H_3_svg__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_234__img_MapElements_Plateau_H_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_234__img_MapElements_Plateau_H_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__img_MapElements_Plateau_L_1_svg__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_235__img_MapElements_Plateau_L_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_235__img_MapElements_Plateau_L_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__img_MapElements_Plateau_L_2_svg__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_236__img_MapElements_Plateau_L_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_236__img_MapElements_Plateau_L_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__img_MapElements_Plateau_L_3_svg__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_237__img_MapElements_Plateau_L_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_237__img_MapElements_Plateau_L_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__img_MapElements_Plateau_L_4_svg__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_238__img_MapElements_Plateau_L_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_238__img_MapElements_Plateau_L_4_svg__);
//Kopie van handel en bedrijven voor eerlijke handel
var cursor=__WEBPACK_IMPORTED_MODULE_205__img_cursor_png___default.a;var beleidskeuzes={'NLLB1-1':__WEBPACK_IMPORTED_MODULE_206__img_icons_beleidskeuzes_basic_1_1_png___default.a,'NLLB1-2':__WEBPACK_IMPORTED_MODULE_207__img_icons_beleidskeuzes_basic_1_2_png___default.a,'NLLB1-3':__WEBPACK_IMPORTED_MODULE_208__img_icons_beleidskeuzes_basic_1_3_png___default.a,'NLLB1-4':__WEBPACK_IMPORTED_MODULE_209__img_icons_beleidskeuzes_basic_1_4_png___default.a,'NLLB1-5':__WEBPACK_IMPORTED_MODULE_210__img_icons_beleidskeuzes_basic_1_5_png___default.a,'NLLB1-6':__WEBPACK_IMPORTED_MODULE_211__img_icons_beleidskeuzes_basic_1_6_png___default.a,'NLLB2-1':__WEBPACK_IMPORTED_MODULE_212__img_icons_beleidskeuzes_basic_2_1_png___default.a,'NLLB2-2':__WEBPACK_IMPORTED_MODULE_213__img_icons_beleidskeuzes_basic_2_2_png___default.a,'NLLB2-3':__WEBPACK_IMPORTED_MODULE_214__img_icons_beleidskeuzes_basic_2_3_png___default.a,'NLLB2-4':__WEBPACK_IMPORTED_MODULE_215__img_icons_beleidskeuzes_basic_2_4_png___default.a,'NLLB2-5':__WEBPACK_IMPORTED_MODULE_216__img_icons_beleidskeuzes_basic_2_5_png___default.a,'NLLB2-6':__WEBPACK_IMPORTED_MODULE_217__img_icons_beleidskeuzes_basic_2_6_png___default.a,'NLLB3-1':__WEBPACK_IMPORTED_MODULE_218__img_icons_beleidskeuzes_basic_3_1_png___default.a,'NLLB3-2':__WEBPACK_IMPORTED_MODULE_219__img_icons_beleidskeuzes_basic_3_2_png___default.a,'NLLB3-3':__WEBPACK_IMPORTED_MODULE_220__img_icons_beleidskeuzes_basic_3_3_png___default.a,'NLLB3-4':__WEBPACK_IMPORTED_MODULE_221__img_icons_beleidskeuzes_basic_3_4_png___default.a,'NLLB3-5':__WEBPACK_IMPORTED_MODULE_222__img_icons_beleidskeuzes_basic_3_5_png___default.a,'NLLB3-6':__WEBPACK_IMPORTED_MODULE_223__img_icons_beleidskeuzes_basic_3_6_png___default.a,'NLLB4-1':__WEBPACK_IMPORTED_MODULE_224__img_icons_beleidskeuzes_basic_4_1_png___default.a,'NLLB4-2':__WEBPACK_IMPORTED_MODULE_225__img_icons_beleidskeuzes_basic_4_2_png___default.a,'NLLB4-3':__WEBPACK_IMPORTED_MODULE_226__img_icons_beleidskeuzes_basic_4_3_png___default.a,'NLLB4-4':__WEBPACK_IMPORTED_MODULE_227__img_icons_beleidskeuzes_basic_4_4_png___default.a,'NLLB4-5':__WEBPACK_IMPORTED_MODULE_228__img_icons_beleidskeuzes_basic_4_5_png___default.a,'NLLB4-6':__WEBPACK_IMPORTED_MODULE_229__img_icons_beleidskeuzes_basic_4_6_png___default.a};var icons={print:__WEBPACK_IMPORTED_MODULE_34__img_icons_popup_print_png___default.a,fairaway:__WEBPACK_IMPORTED_MODULE_32__img_fairaway_logo_png___default.a,globas:__WEBPACK_IMPORTED_MODULE_21__img_icons_globas_svg___default.a,checklist:__WEBPACK_IMPORTED_MODULE_7__img_icons_checklist_svg___default.a,bonus:__WEBPACK_IMPORTED_MODULE_8__img_icons_bonus_svg___default.a,movie:__WEBPACK_IMPORTED_MODULE_9__img_icons_movie_svg___default.a,camera:__WEBPACK_IMPORTED_MODULE_6__img_icons_camera_svg___default.a,team:__WEBPACK_IMPORTED_MODULE_10__img_icons_economy_team_svg___default.a,medal:__WEBPACK_IMPORTED_MODULE_11__img_medal_svg___default.a,pen:__WEBPACK_IMPORTED_MODULE_14__img_icons_pen_svg___default.a,lock:__WEBPACK_IMPORTED_MODULE_12__img_icons_lock_svg___default.a,locked:__WEBPACK_IMPORTED_MODULE_15__img_icons_locked_svg___default.a,download:__WEBPACK_IMPORTED_MODULE_31__img_icons_download_svg___default.a,add:__WEBPACK_IMPORTED_MODULE_16__img_icons_add_svg___default.a,play2:__WEBPACK_IMPORTED_MODULE_17__img_icons_play2_svg___default.a,startup:__WEBPACK_IMPORTED_MODULE_18__img_icons_opstart_svg___default.a,pdf:__WEBPACK_IMPORTED_MODULE_19__img_icons_pdf_svg___default.a,trash:__WEBPACK_IMPORTED_MODULE_20__img_icons_delete_svg___default.a,beleidskeuze:__WEBPACK_IMPORTED_MODULE_22__img_icons_beleidskeuze_svg___default.a,minGlobas:__WEBPACK_IMPORTED_MODULE_24__img_icons_economy_min_globas_svg___default.a,upGlobas:__WEBPACK_IMPORTED_MODULE_25__img_icons_economy_up_globas_svg___default.a,gift:__WEBPACK_IMPORTED_MODULE_23__img_icons_belasting_6_svg___default.a,thumbsDown:__WEBPACK_IMPORTED_MODULE_27__img_thumbs_down_svg___default.a,thumbsUp:__WEBPACK_IMPORTED_MODULE_26__img_thumbs_up_svg___default.a,megafoon:__WEBPACK_IMPORTED_MODULE_28__img_megafoon_svg___default.a,check:__WEBPACK_IMPORTED_MODULE_29__img_icons_check_svg___default.a,groepsbewerk:__WEBPACK_IMPORTED_MODULE_230__img_icons_groepsbewerk_svg___default.a,testen:__WEBPACK_IMPORTED_MODULE_231__img_icons_testen_svg___default.a,pauze:__WEBPACK_IMPORTED_MODULE_30__img_icons_pauze_svg___default.a,link:__WEBPACK_IMPORTED_MODULE_33__img_icons_link_svg___default.a,greyLock:__WEBPACK_IMPORTED_MODULE_13__img_icons_Lock_grey_svg___default.a};var belastingIcons={AB:__WEBPACK_IMPORTED_MODULE_35__img_icons_belasting_1_svg___default.a,CB:__WEBPACK_IMPORTED_MODULE_37__img_icons_belasting_3_svg___default.a,BB:__WEBPACK_IMPORTED_MODULE_36__img_icons_belasting_2_svg___default.a,VVB:__WEBPACK_IMPORTED_MODULE_38__img_icons_belasting_4_svg___default.a,VB:__WEBPACK_IMPORTED_MODULE_39__img_icons_belasting_5_svg___default.a,LB:__WEBPACK_IMPORTED_MODULE_40__img_icons_L_belasting_1_svg___default.a};var groupIcons={groen:__WEBPACK_IMPORTED_MODULE_0__img_icons_land_groen_svg___default.a,blauw:__WEBPACK_IMPORTED_MODULE_1__img_icons_land_blauw_svg___default.a,geel:__WEBPACK_IMPORTED_MODULE_2__img_icons_land_geel_svg___default.a,oranje:__WEBPACK_IMPORTED_MODULE_3__img_icons_land_oranje_svg___default.a,paars:__WEBPACK_IMPORTED_MODULE_4__img_icons_land_paars_svg___default.a,rood:__WEBPACK_IMPORTED_MODULE_5__img_icons_land_rood_svg___default.a};var mapColors={pro_red:__WEBPACK_IMPORTED_MODULE_232__img_MapElements_Plateau_H_1_svg___default.a,pro_yellow:__WEBPACK_IMPORTED_MODULE_233__img_MapElements_Plateau_H_2_svg___default.a,pro_green:__WEBPACK_IMPORTED_MODULE_234__img_MapElements_Plateau_H_3_svg___default.a,basic_red:__WEBPACK_IMPORTED_MODULE_235__img_MapElements_Plateau_L_1_svg___default.a,basic_lowOrange:__WEBPACK_IMPORTED_MODULE_236__img_MapElements_Plateau_L_2_svg___default.a,basic_lowYellow:__WEBPACK_IMPORTED_MODULE_237__img_MapElements_Plateau_L_3_svg___default.a,basic_green:__WEBPACK_IMPORTED_MODULE_238__img_MapElements_Plateau_L_4_svg___default.a};var mapElements={map_Beleidskeuzes:__WEBPACK_IMPORTED_MODULE_69__img_MapElements_Beleidskeuzes_png___default.a,map_Economy:__WEBPACK_IMPORTED_MODULE_70__img_MapElements_Economy_png___default.a,map_FB__FB1:__WEBPACK_IMPORTED_MODULE_71__img_MapElements_FB_FB1_png___default.a,map_FB__FB12x:__WEBPACK_IMPORTED_MODULE_72__img_MapElements_FB_FB1_2x_png___default.a,map_FB__FB2:__WEBPACK_IMPORTED_MODULE_73__img_MapElements_FB_FB2_png___default.a,map_FB__FB22x:__WEBPACK_IMPORTED_MODULE_74__img_MapElements_FB_FB2_2x_png___default.a,map_FB__FB3:__WEBPACK_IMPORTED_MODULE_75__img_MapElements_FB_FB3_png___default.a,map_FB__FB32x:__WEBPACK_IMPORTED_MODULE_76__img_MapElements_FB_FB3_2x_png___default.a,map_FB__FB4:__WEBPACK_IMPORTED_MODULE_77__img_MapElements_FB_FB4_png___default.a,map_FB__FB42x:__WEBPACK_IMPORTED_MODULE_78__img_MapElements_FB_FB4_2x_png___default.a,map_FB__FB5:__WEBPACK_IMPORTED_MODULE_79__img_MapElements_FB_FB5_png___default.a,map_FB__FB52x:__WEBPACK_IMPORTED_MODULE_80__img_MapElements_FB_FB5_2x_png___default.a,map_GZ__GZ1:__WEBPACK_IMPORTED_MODULE_81__img_MapElements_GZ_GZ1_png___default.a,map_GZ__GZ12x:__WEBPACK_IMPORTED_MODULE_82__img_MapElements_GZ_GZ1_2x_png___default.a,map_GZ__GZ2:__WEBPACK_IMPORTED_MODULE_83__img_MapElements_GZ_GZ2_png___default.a,map_GZ__GZ22x:__WEBPACK_IMPORTED_MODULE_84__img_MapElements_GZ_GZ2_2x_png___default.a,map_GZ__GZ3:__WEBPACK_IMPORTED_MODULE_85__img_MapElements_GZ_GZ3_png___default.a,map_GZ__GZ32x:__WEBPACK_IMPORTED_MODULE_86__img_MapElements_GZ_GZ3_2x_png___default.a,map_GZ__GZ4:__WEBPACK_IMPORTED_MODULE_87__img_MapElements_GZ_GZ4_png___default.a,map_GZ__GZ42x:__WEBPACK_IMPORTED_MODULE_88__img_MapElements_GZ_GZ4_2x_png___default.a,map_GZ__GZ5:__WEBPACK_IMPORTED_MODULE_89__img_MapElements_GZ_GZ5_png___default.a,map_GZ__GZ52x:__WEBPACK_IMPORTED_MODULE_90__img_MapElements_GZ_GZ5_2x_png___default.a,map_HB__HB1:__WEBPACK_IMPORTED_MODULE_91__img_MapElements_HB_HB1_png___default.a,map_HB__HB12x:__WEBPACK_IMPORTED_MODULE_92__img_MapElements_HB_HB1_2x_png___default.a,map_HB__HB2:__WEBPACK_IMPORTED_MODULE_93__img_MapElements_HB_HB2_png___default.a,map_HB__HB22x:__WEBPACK_IMPORTED_MODULE_94__img_MapElements_HB_HB2_2x_png___default.a,map_HB__HB3:__WEBPACK_IMPORTED_MODULE_95__img_MapElements_HB_HB3_png___default.a,map_HB__HB32x:__WEBPACK_IMPORTED_MODULE_96__img_MapElements_HB_HB3_2x_png___default.a,map_HB__HB4:__WEBPACK_IMPORTED_MODULE_97__img_MapElements_HB_HB4_png___default.a,map_HB__HB42x:__WEBPACK_IMPORTED_MODULE_98__img_MapElements_HB_HB4_2x_png___default.a,map_IE__IE1:__WEBPACK_IMPORTED_MODULE_99__img_MapElements_IE_IE1_png___default.a,map_IE__IE12x:__WEBPACK_IMPORTED_MODULE_100__img_MapElements_IE_IE1_2x_png___default.a,map_IE__IE2:__WEBPACK_IMPORTED_MODULE_101__img_MapElements_IE_IE2_png___default.a,map_IE__IE22x:__WEBPACK_IMPORTED_MODULE_102__img_MapElements_IE_IE2_2x_png___default.a,map_IE__IE3:__WEBPACK_IMPORTED_MODULE_103__img_MapElements_IE_IE3_png___default.a,map_IE__IE32x:__WEBPACK_IMPORTED_MODULE_104__img_MapElements_IE_IE3_2x_png___default.a,map_IE__IE4:__WEBPACK_IMPORTED_MODULE_105__img_MapElements_IE_IE4_png___default.a,map_IE__IE42x:__WEBPACK_IMPORTED_MODULE_106__img_MapElements_IE_IE4_2x_png___default.a,map_IE__IE5:__WEBPACK_IMPORTED_MODULE_107__img_MapElements_IE_IE5_png___default.a,map_IE__IE52x:__WEBPACK_IMPORTED_MODULE_108__img_MapElements_IE_IE5_2x_png___default.a,map_KN__KN1:__WEBPACK_IMPORTED_MODULE_109__img_MapElements_KN_KN1_png___default.a,map_KN__KN12x:__WEBPACK_IMPORTED_MODULE_110__img_MapElements_KN_KN1_2x_png___default.a,map_KN__KN2:__WEBPACK_IMPORTED_MODULE_111__img_MapElements_KN_KN2_png___default.a,map_KN__KN22x:__WEBPACK_IMPORTED_MODULE_112__img_MapElements_KN_KN2_2x_png___default.a,map_KN__KN3:__WEBPACK_IMPORTED_MODULE_113__img_MapElements_KN_KN3_png___default.a,map_KN__KN32x:__WEBPACK_IMPORTED_MODULE_114__img_MapElements_KN_KN3_2x_png___default.a,map_KN__KN4:__WEBPACK_IMPORTED_MODULE_115__img_MapElements_KN_KN4_png___default.a,map_KN__KN42x:__WEBPACK_IMPORTED_MODULE_116__img_MapElements_KN_KN4_2x_png___default.a,map_LV__LV1:__WEBPACK_IMPORTED_MODULE_117__img_MapElements_LV_LV1_png___default.a,map_LV__LV12x:__WEBPACK_IMPORTED_MODULE_118__img_MapElements_LV_LV1_2x_png___default.a,map_LV__LV13x:__WEBPACK_IMPORTED_MODULE_119__img_MapElements_LV_LV1_3x_png___default.a,map_LV__LV14x:__WEBPACK_IMPORTED_MODULE_120__img_MapElements_LV_LV1_4x_png___default.a,map_LV__LV2:__WEBPACK_IMPORTED_MODULE_121__img_MapElements_LV_LV2_png___default.a,map_LV__LV22x:__WEBPACK_IMPORTED_MODULE_122__img_MapElements_LV_LV2_2x_png___default.a,map_LV__LV23x:__WEBPACK_IMPORTED_MODULE_123__img_MapElements_LV_LV2_3x_png___default.a,map_LV__LV24x:__WEBPACK_IMPORTED_MODULE_124__img_MapElements_LV_LV2_4x_png___default.a,map_LV__LV3:__WEBPACK_IMPORTED_MODULE_125__img_MapElements_LV_LV3_png___default.a,map_LV__LV32x:__WEBPACK_IMPORTED_MODULE_126__img_MapElements_LV_LV3_2x_png___default.a,map_LV__LV33x:__WEBPACK_IMPORTED_MODULE_127__img_MapElements_LV_LV3_3x_png___default.a,map_LV__LV34x:__WEBPACK_IMPORTED_MODULE_128__img_MapElements_LV_LV3_4x_png___default.a,map_LV__LV4:__WEBPACK_IMPORTED_MODULE_129__img_MapElements_LV_LV4_png___default.a,map_LV__LV42x:__WEBPACK_IMPORTED_MODULE_130__img_MapElements_LV_LV4_2x_png___default.a,map_LV__LV43x:__WEBPACK_IMPORTED_MODULE_131__img_MapElements_LV_LV4_3x_png___default.a,map_LV__LV44x:__WEBPACK_IMPORTED_MODULE_132__img_MapElements_LV_LV4_4x_png___default.a,map_LV__LV5:__WEBPACK_IMPORTED_MODULE_133__img_MapElements_LV_LV5_png___default.a,map_LV__LV52x:__WEBPACK_IMPORTED_MODULE_134__img_MapElements_LV_LV5_2x_png___default.a,map_LV__LV53x:__WEBPACK_IMPORTED_MODULE_135__img_MapElements_LV_LV5_3x_png___default.a,map_LV__LV54x:__WEBPACK_IMPORTED_MODULE_136__img_MapElements_LV_LV5_4x_png___default.a,map_MC__MC1:__WEBPACK_IMPORTED_MODULE_137__img_MapElements_MC_MC1_png___default.a,map_MC__MC12x:__WEBPACK_IMPORTED_MODULE_138__img_MapElements_MC_MC1_2x_png___default.a,map_MC__MC2:__WEBPACK_IMPORTED_MODULE_139__img_MapElements_MC_MC2_png___default.a,map_MC__MC22x:__WEBPACK_IMPORTED_MODULE_140__img_MapElements_MC_MC2_2x_png___default.a,map_MC__MC3:__WEBPACK_IMPORTED_MODULE_141__img_MapElements_MC_MC3_png___default.a,map_MC__MC32x:__WEBPACK_IMPORTED_MODULE_142__img_MapElements_MC_MC3_2x_png___default.a,map_MC__MC4:__WEBPACK_IMPORTED_MODULE_143__img_MapElements_MC_MC4_png___default.a,map_MC__MC42x:__WEBPACK_IMPORTED_MODULE_144__img_MapElements_MC_MC4_2x_png___default.a,map_MC__MC5:__WEBPACK_IMPORTED_MODULE_145__img_MapElements_MC_MC5_png___default.a,map_MC__MC52x:__WEBPACK_IMPORTED_MODULE_146__img_MapElements_MC_MC5_2x_png___default.a,map_OH__OH1:__WEBPACK_IMPORTED_MODULE_147__img_MapElements_OH_OH1_png___default.a,map_OH__OH12x:__WEBPACK_IMPORTED_MODULE_148__img_MapElements_OH_OH1_2x_png___default.a,map_OH__OH2:__WEBPACK_IMPORTED_MODULE_149__img_MapElements_OH_OH2_png___default.a,map_OH__OH22x:__WEBPACK_IMPORTED_MODULE_150__img_MapElements_OH_OH2_2x_png___default.a,map_OH__OH3:__WEBPACK_IMPORTED_MODULE_151__img_MapElements_OH_OH3_png___default.a,map_OH__OH32x:__WEBPACK_IMPORTED_MODULE_152__img_MapElements_OH_OH3_2x_png___default.a,map_OH__OH4:__WEBPACK_IMPORTED_MODULE_153__img_MapElements_OH_OH4_png___default.a,map_OH__OH42x:__WEBPACK_IMPORTED_MODULE_154__img_MapElements_OH_OH4_2x_png___default.a,map_OT__OT1:__WEBPACK_IMPORTED_MODULE_155__img_MapElements_OT_OT1_png___default.a,map_OT__OT12x:__WEBPACK_IMPORTED_MODULE_156__img_MapElements_OT_OT1_2x_png___default.a,map_OT__OT2:__WEBPACK_IMPORTED_MODULE_157__img_MapElements_OT_OT2_png___default.a,map_OT__OT22x:__WEBPACK_IMPORTED_MODULE_158__img_MapElements_OT_OT2_2x_png___default.a,map_OT__OT3:__WEBPACK_IMPORTED_MODULE_159__img_MapElements_OT_OT3_png___default.a,map_OT__OT32x:__WEBPACK_IMPORTED_MODULE_160__img_MapElements_OT_OT3_2x_png___default.a,map_OT__OT4:__WEBPACK_IMPORTED_MODULE_161__img_MapElements_OT_OT4_png___default.a,map_OT__OT42x:__WEBPACK_IMPORTED_MODULE_162__img_MapElements_OT_OT4_2x_png___default.a,map_OW__OW1:__WEBPACK_IMPORTED_MODULE_163__img_MapElements_OW_OW1_png___default.a,map_OW__OW12x:__WEBPACK_IMPORTED_MODULE_164__img_MapElements_OW_OW1_2x_png___default.a,map_OW__OW2:__WEBPACK_IMPORTED_MODULE_165__img_MapElements_OW_OW2_png___default.a,map_OW__OW22x:__WEBPACK_IMPORTED_MODULE_166__img_MapElements_OW_OW2_2x_png___default.a,map_OW__OW3:__WEBPACK_IMPORTED_MODULE_167__img_MapElements_OW_OW3_png___default.a,map_OW__OW32x:__WEBPACK_IMPORTED_MODULE_168__img_MapElements_OW_OW3_2x_png___default.a,map_OW__OW4:__WEBPACK_IMPORTED_MODULE_169__img_MapElements_OW_OW4_png___default.a,map_OW__OW42x:__WEBPACK_IMPORTED_MODULE_170__img_MapElements_OW_OW4_2x_png___default.a,map_OW__OW5:__WEBPACK_IMPORTED_MODULE_171__img_MapElements_OW_OW5_png___default.a,map_OW__OW52x:__WEBPACK_IMPORTED_MODULE_172__img_MapElements_OW_OW5_2x_png___default.a,map_VR__VR1:__WEBPACK_IMPORTED_MODULE_173__img_MapElements_VR_VR1_png___default.a,map_VR__VR12x:__WEBPACK_IMPORTED_MODULE_174__img_MapElements_VR_VR1_2x_png___default.a,map_VR__VR2:__WEBPACK_IMPORTED_MODULE_175__img_MapElements_VR_VR2_png___default.a,map_VR__VR22x:__WEBPACK_IMPORTED_MODULE_176__img_MapElements_VR_VR2_2x_png___default.a,map_VR__VR3:__WEBPACK_IMPORTED_MODULE_177__img_MapElements_VR_VR3_png___default.a,map_VR__VR32x:__WEBPACK_IMPORTED_MODULE_178__img_MapElements_VR_VR3_2x_png___default.a,map_VR__VR4:__WEBPACK_IMPORTED_MODULE_179__img_MapElements_VR_VR4_png___default.a,map_VR__VR42x:__WEBPACK_IMPORTED_MODULE_180__img_MapElements_VR_VR4_2x_png___default.a,map_VR__VR5:__WEBPACK_IMPORTED_MODULE_181__img_MapElements_VR_VR5_png___default.a,map_VR__VR52x:__WEBPACK_IMPORTED_MODULE_182__img_MapElements_VR_VR5_2x_png___default.a,map_WI__WI1:__WEBPACK_IMPORTED_MODULE_183__img_MapElements_WI_WI1_png___default.a,map_WI__WI12x:__WEBPACK_IMPORTED_MODULE_184__img_MapElements_WI_WI1_2x_png___default.a,map_WI__WI2:__WEBPACK_IMPORTED_MODULE_185__img_MapElements_WI_WI2_png___default.a,map_WI__WI22x:__WEBPACK_IMPORTED_MODULE_186__img_MapElements_WI_WI2_2x_png___default.a,map_WI__WI3:__WEBPACK_IMPORTED_MODULE_187__img_MapElements_WI_WI3_png___default.a,map_WI__WI32x:__WEBPACK_IMPORTED_MODULE_188__img_MapElements_WI_WI3_2x_png___default.a,map_WI__WI4:__WEBPACK_IMPORTED_MODULE_189__img_MapElements_WI_WI4_png___default.a,map_WI__WI42x:__WEBPACK_IMPORTED_MODULE_190__img_MapElements_WI_WI4_2x_png___default.a,map_WI__WI5:__WEBPACK_IMPORTED_MODULE_191__img_MapElements_WI_WI5_png___default.a,map_WI__WI52x:__WEBPACK_IMPORTED_MODULE_192__img_MapElements_WI_WI5_2x_png___default.a,map_WS__WS1:__WEBPACK_IMPORTED_MODULE_193__img_MapElements_WS_WS1_png___default.a,map_WS__WS12x:__WEBPACK_IMPORTED_MODULE_194__img_MapElements_WS_WS1_2x_png___default.a,map_WS__WS2:__WEBPACK_IMPORTED_MODULE_195__img_MapElements_WS_WS2_png___default.a,map_WS__WS22x:__WEBPACK_IMPORTED_MODULE_196__img_MapElements_WS_WS2_2x_png___default.a,map_WS__WS3:__WEBPACK_IMPORTED_MODULE_197__img_MapElements_WS_WS3_png___default.a,map_WS__WS32x:__WEBPACK_IMPORTED_MODULE_198__img_MapElements_WS_WS3_2x_png___default.a,map_WS__WS4:__WEBPACK_IMPORTED_MODULE_199__img_MapElements_WS_WS4_png___default.a,map_WS__WS42x:__WEBPACK_IMPORTED_MODULE_200__img_MapElements_WS_WS4_2x_png___default.a,map_WS__WS5:__WEBPACK_IMPORTED_MODULE_201__img_MapElements_WS_WS5_png___default.a,map_WS__WS52x:__WEBPACK_IMPORTED_MODULE_202__img_MapElements_WS_WS5_2x_png___default.a,map_highlight:__WEBPACK_IMPORTED_MODULE_203__img_MapElements_highlight_png___default.a,map_shadow:__WEBPACK_IMPORTED_MODULE_204__img_MapElements_shadow_png___default.a,map_EH__EH1:__WEBPACK_IMPORTED_MODULE_91__img_MapElements_HB_HB1_png___default.a,map_EH__EH12x:__WEBPACK_IMPORTED_MODULE_92__img_MapElements_HB_HB1_2x_png___default.a,map_EH__EH2:__WEBPACK_IMPORTED_MODULE_93__img_MapElements_HB_HB2_png___default.a,map_EH__EH22x:__WEBPACK_IMPORTED_MODULE_94__img_MapElements_HB_HB2_2x_png___default.a,map_EH__EH3:__WEBPACK_IMPORTED_MODULE_95__img_MapElements_HB_HB3_png___default.a,map_EH__EH32x:__WEBPACK_IMPORTED_MODULE_96__img_MapElements_HB_HB3_2x_png___default.a,map_EH__EH4:__WEBPACK_IMPORTED_MODULE_97__img_MapElements_HB_HB4_png___default.a,map_EH__EH42x:__WEBPACK_IMPORTED_MODULE_98__img_MapElements_HB_HB4_2x_png___default.a};var prepMinistryIcons={WI:__WEBPACK_IMPORTED_MODULE_41__img_icons_ministries_WI_svg___default.a,GZ:__WEBPACK_IMPORTED_MODULE_42__img_icons_ministries_GZ_svg___default.a,OW:__WEBPACK_IMPORTED_MODULE_43__img_icons_ministries_OW_svg___default.a,OT:__WEBPACK_IMPORTED_MODULE_44__img_icons_ministries_OT_svg___default.a,VR:__WEBPACK_IMPORTED_MODULE_45__img_icons_ministries_VR_svg___default.a,IE:__WEBPACK_IMPORTED_MODULE_46__img_icons_ministries_IE_svg___default.a,FB:__WEBPACK_IMPORTED_MODULE_47__img_icons_ministries_FB_svg___default.a,LV:__WEBPACK_IMPORTED_MODULE_48__img_icons_ministries_LV_svg___default.a,KN:__WEBPACK_IMPORTED_MODULE_49__img_icons_ministries_KN_svg___default.a,OH:__WEBPACK_IMPORTED_MODULE_50__img_icons_ministries_OH_svg___default.a,WS:__WEBPACK_IMPORTED_MODULE_51__img_icons_ministries_WS_svg___default.a,HB:__WEBPACK_IMPORTED_MODULE_52__img_icons_ministries_HB_svg___default.a,MC:__WEBPACK_IMPORTED_MODULE_54__img_icons_ministries_MC_svg___default.a,EH:__WEBPACK_IMPORTED_MODULE_53__img_icons_ministries_EH_svg___default.a};if(window.navigator.userAgent.indexOf("Edge")>-1){prepMinistryIcons={WI:__WEBPACK_IMPORTED_MODULE_55__img_icons_ministries_edge_WI_png___default.a,GZ:__WEBPACK_IMPORTED_MODULE_56__img_icons_ministries_edge_GZ_png___default.a,OW:__WEBPACK_IMPORTED_MODULE_57__img_icons_ministries_edge_OW_png___default.a,OT:__WEBPACK_IMPORTED_MODULE_58__img_icons_ministries_edge_OT_png___default.a,VR:__WEBPACK_IMPORTED_MODULE_59__img_icons_ministries_edge_VR_png___default.a,IE:__WEBPACK_IMPORTED_MODULE_60__img_icons_ministries_edge_IE_png___default.a,FB:__WEBPACK_IMPORTED_MODULE_61__img_icons_ministries_edge_FB_png___default.a,LV:__WEBPACK_IMPORTED_MODULE_62__img_icons_ministries_edge_LV_png___default.a,KN:__WEBPACK_IMPORTED_MODULE_63__img_icons_ministries_edge_KN_png___default.a,OH:__WEBPACK_IMPORTED_MODULE_64__img_icons_ministries_edge_OH_png___default.a,WS:__WEBPACK_IMPORTED_MODULE_65__img_icons_ministries_edge_WS_png___default.a,HB:__WEBPACK_IMPORTED_MODULE_66__img_icons_ministries_edge_HB_png___default.a,MC:__WEBPACK_IMPORTED_MODULE_68__img_icons_ministries_edge_MC_png___default.a,EH:__WEBPACK_IMPORTED_MODULE_67__img_icons_ministries_edge_EH_png___default.a};}var ministryIcons=prepMinistryIcons;

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__user__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__feedback__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gameState__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gameStateInput__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popup__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__project__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__schoolClass__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__group__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__policyChoice__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ghettoRadio__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__bankNotification__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__timer__ = __webpack_require__(801);
/* unused harmony reexport user */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__feedback__["a"]; });
/* unused harmony reexport gameState */
/* unused harmony reexport project */
/* unused harmony reexport schoolClass */
/* unused harmony reexport group */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__gameStateInput__["a"]; });
/* unused harmony reexport popup */
/* unused harmony reexport policyChoice */
/* unused harmony reexport ghettoRadio */
/* unused harmony reexport bankNotification */
/* unused harmony reexport timer */
/* harmony default export */ __webpack_exports__["a"] = ({user:__WEBPACK_IMPORTED_MODULE_0__user__["a" /* default */],feedback:__WEBPACK_IMPORTED_MODULE_1__feedback__["a" /* default */],gameState:__WEBPACK_IMPORTED_MODULE_2__gameState__["a" /* default */],project:__WEBPACK_IMPORTED_MODULE_5__project__["a" /* default */],schoolClass:__WEBPACK_IMPORTED_MODULE_6__schoolClass__["a" /* default */],group:__WEBPACK_IMPORTED_MODULE_7__group__["a" /* default */],gameStateInput:__WEBPACK_IMPORTED_MODULE_3__gameStateInput__["a" /* default */],popup:__WEBPACK_IMPORTED_MODULE_4__popup__["a" /* default */],policyChoice:__WEBPACK_IMPORTED_MODULE_8__policyChoice__["a" /* default */],ghettoRadio:__WEBPACK_IMPORTED_MODULE_9__ghettoRadio__["a" /* default */],bankNotification:__WEBPACK_IMPORTED_MODULE_10__bankNotification__["a" /* default */],timer:__WEBPACK_IMPORTED_MODULE_11__timer__["a" /* default */]});

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getFeedback; });
/* unused harmony export getFeedbackMinistery */
/* unused harmony export getMinisteryFeedback */
/* unused harmony export getMinistryEffectFeedback */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getLowMinistryFeedbackLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getEconomieFeedbackFormatted; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return getUnreadWinstGlobas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return getUnreadVerliesGlobas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return renderMinistryFeedbackList; });
/* unused harmony export extractWgVg */
/* unused harmony export subString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getFeedbackTitle; });
/* unused harmony export isDisaster */
/* unused harmony export getLastChar */
/* unused harmony export getFeedbackOverview */
/* unused harmony export getFeedbackOverviewList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return checkRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return getMinistryARating; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return getMinistryColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return getMinistryStatusBarRatings; });
/* unused harmony export getSamenWerkingenForMinisterie */
/* unused harmony export getOverigeEffecten */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return getSubtitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkIfCollab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getCollaborations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return getPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getImageText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return getText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return getSideEffects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ministryOverfinanced; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getEconomieFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return getUnreadCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return getPolicyChoiceCollaborations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return reduceMinistryCollabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return ministryHasDisaster; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return getOverigeInkomsten; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return simulateDebitCreditOutcome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateDebitCreditOutcome; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateDebitCreditOutcomeBasic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return unreadCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return getPolicyChoiceFeedback; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return getPolicyChoiceTotalPoints; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_budget_svg__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_budget_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_budget_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_grondstoffen_svg__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_grondstoffen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_grondstoffen_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_lenen_land_svg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_lenen_land_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_lenen_land_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_uitlenen_land_svg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_uitlenen_land_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_uitlenen_land_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_bank_svg__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_bank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_bank_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_schenken_land_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_schenken_land_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_schenken_land_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__bankHelper__ = __webpack_require__(84);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};/**
* Feedback sorting algorithm
*/function getOrderIndex(fb){if(fb.oe){//Effect
return 3;}if(fb.type==="ALGEMEEN"||fb.type==="RAMP"){//Budgetkeuze
return 1;}if(fb.type==="BELEIDSKEUZE"){return 2;}return 3;}var sorter=function sorter(a,b){var valA=getOrderIndex(a);var valB=getOrderIndex(b);if(valA<valB){return-1;}if(valA>valB){return 1;}return 0;};/**
 * get feedback by id (omschrijving)
 */function getFeedback(){var feedbacks=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var feedbackId=arguments[1];var item=feedbacks.find(function(fb){return fb.omschrijving===feedbackId;});return _extends({},item);}/**
 * Method to check if a feedback item has been read or not
 * @param {object} feedback
 * @param {bool} oe
 * @param {number} oe_index
 * @param {bool} economie
 * @return {bool}
 */function checkRead(feedback){var oe=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var oe_index=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var economie=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;// Invalid feedback, mark as read because there is no feedback to read
if(!feedback.id&&!feedback.reference){return true;}if(oe){return feedback.read['readOe_'+oe_index];}if(economie){return feedback.read.economie?feedback.read.economie:false;}return feedback.read.read;}function subString(){var string=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'';var maxLength=arguments[1];var tail=arguments[2];var maxString=string.substr(0,maxLength);maxString=maxString.substr(0,Math.min(maxString.length,maxString.lastIndexOf(" ")));return maxString+(string.length>maxLength?tail:"");}/**
 * Method that takes an array of feedback
 * as input and reduces it to a single unread
 * feedback count.
 * @param {Array<{ read: { read: Bool } }>} feedback
 * @param {bool} economie
 * @returns {Number} - count
 */function unreadCount(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var economie=arguments[1];var isPolicy=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;return feedback.reduce(function(count,fb){if(!economie){if(!checkRead(fb)){count+=1;}}if(!economie&&!isPolicy){fb.overigeEffecten.forEach(function(oe,i){if(!checkRead(fb,true,i)){count+=1;}});}if(fb.economie&&!isPolicy){if(!checkRead(fb,false,0,true)){count+=1;}}return count;},0);}function getCollaborationPoints(ranges,collabs){var range=ranges.find(function(range){var r=range.match(/(\d-\d)/g);var val=r&&r[0]?r[0].split('-'):null;if(Array.isArray(val)){return parseInt(val[0],10)<=collabs||collabs<=parseInt(val[1],10);}return false;});if(range){return parseInt(range.split('=')[1],10)||0;}return 0;}/**
 * Method to filter and map feedback items which are relevant for your ministry
 * @param {array<{}>} feedback
 * @param {string} ministry
 * @param {object} gameState
 * @return {array<{}>} relevant feedback
 */function getMinistryFeedbackItems(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var ministry=arguments[1];var gameState=arguments[2];var gameStateInput=arguments[3];return feedback.filter(function(fb){return fb.ministerie===ministry;}).map(function(fb){var icon=__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie],to='/ministries/'+fb.ministerie.toLowerCase()+'/'+fb.omschrijving+'/',points=fb.puntenscore,title=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(getFeedbackTitle(fb));if(Array.isArray(points)&&points[0].match(/^SW\d-\d=\d*$/)){points=getCollaborationPoints(points,getCollaborations(fb,gameStateInput).length);}if(fb.type==='BELEIDSKEUZE'){title+=fb['titel_beleidskeuze_'+gameState.language]?': '+fb['titel_beleidskeuze_'+gameState.language]:'';icon=__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["d" /* icons */].beleidskeuze;}if(fb.type==='ALGEMEEN'||fb.type==='RAMP'){icon=__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["d" /* icons */].globas;points=gameState.prevRound.gameStateSum[ministry+'_points_raw'];}if(fb.type==='STARTSITUATIE'){icon=null;}return _extends({},fb,{icon:icon,to:to,points:points,title:title});});}function getOverigeEffecten(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var ministry=arguments[1];return feedback.reduce(function(effects,fb){if(fb.overigeEffecten.length){fb.overigeEffecten.forEach(function(oe,i){var title=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_effect_vanuit')+': ';var icon=__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie];if(fb.belastingNaam){title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.belastingsoort);icon=__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["a" /* belastingIcons */][fb.belastingsoort];}else{title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.ministerie);}if(oe.ministerie===ministry){effects.push(_extends({},oe,{icon:icon,to:'/ministries/overigEffect/'+fb.omschrijving+'/'+i+'/'+oe.ministerie.toLowerCase(),title:title,id:'oe-'+fb.omschrijving,omschrijving:fb.omschrijving,read:fb.read,points:oe.puntenscore,oe:true,index:i}));}});}return effects;},[]);}function getOverigeInkomsten(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var gameState=arguments[1];var minPolicyChoices=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var oi=feedback.reduce(function(overigeInkomsten,fb){if(fb.overigeInkomsten){console.log(fb);if(fb.type==='BELEIDSKEUZE'&&gameState.difficulty==='BASIC'){overigeInkomsten.push(_extends({},fb.overigeInkomsten,{icon:__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["b" /* beleidskeuzes */][fb['img']],title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_effect_vanuit')+': '+fb['titel_oplossing_'+gameState.language]}));}else{overigeInkomsten.push(_extends({},fb.overigeInkomsten,{icon:__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie]||__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["a" /* belastingIcons */][fb.belastingsoort],title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_effect_vanuit')+': '+Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.ministerie||fb.belastingsoort)}));}}return overigeInkomsten;},[]);// Budget over van vorige ronde
if(gameState.budgetLeft){oi.push({icon:__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_budget_svg___default.a,title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_budget_uit_vorige_spelronde'),tekst:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_budget_uit_vorige_spelronde_omschrijving'),winstverliesglobas:gameState.budgetLeft});}// Implement basic OI
var basicOI=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].basicOI[gameState.difficulty][gameState.theme][gameState.currentRound]||{};var winstverliesglobas=0;var tekst=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(basicOI.tekst);if(gameState.difficulty==='PRO'){winstverliesglobas=String(basicOI.winstverliesglobas);}else{winstverliesglobas=Math.round(minPolicyChoices*2+basicOI.sum);tekst=tekst.replace('[x]',winstverliesglobas);}return[{icon:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_grondstoffen_svg___default.a,title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_grondstoffen')+': '+Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(basicOI.title),tekst:tekst,winstverliesglobas:winstverliesglobas}].concat(oi);}function getEconomieFeedback(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var type=arguments[1];feedback=feedback.filter(function(fb){return fb.economie;});if(type==='profit'){return feedback.filter(function(fb){return parseInt(fb.economie.winstverliesglobas,10)>=0;});}else if(type==='loss'){return feedback.filter(function(fb){return parseInt(fb.economie.winstverliesglobas,10)<0;});}return feedback;}function getPolicyChoiceFeedback(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];return feedback.filter(function(fb){return fb.type==='BELEIDSKEUZE';});}function getTitle(fb,lang){var title=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_effect_vanuit')+': ';if(fb.belastingNaam){return title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.belastingsoort);}if(fb.type==='BELASTING'&&fb.niveau==='Basic'){return title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belastinginkomsten');}if(fb.type==='BELEIDSKEUZE'&&fb.niveau==='Basic'){return title+=fb['titel_oplossing_'+lang];}return title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.ministerie);}function getEconomieFeedbackFormatted(feedback,type,gameState){var fb=getEconomieFeedback(feedback,type).sort(sorter);return fb.map(function(feedback){var img=getImage(feedback.economie);if(img.indexOf('.jpg')!==-1){img=img.slice(0,img.length-4);}else if(img.indexOf('.jpeg')!==-1){img=img.slice(0,img.length-5);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{key:feedback.id,to:'/ministries/economie/'+feedback.omschrijving+'/'+type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_elements_ListButton__["a" /* default */],{read:checkRead(feedback,false,0,true),bgColor:'grey',title:getTitle(feedback,gameState.language),desc:subString(getText(feedback.economie,gameState.language),80,"...</p>"),icon:getIcon(feedback,true),arrow:true,feedback:true,thumbnail:''+__WEBPACK_IMPORTED_MODULE_13__config___default.a.mediaUrl+img.replace('+','%2B')+'.jpeg',points:(type==='profit'?'+ ':null)+feedback.economie.winstverliesglobas,isGlobas:true}));});}/**
 * Jesse zei dat het klaar was, dus ik heb deze regel gewoon weggehaald. Haha. Hij zei letterlijk: "het is klaar".
 * "Mijn naam is haas", aldus Jorrit.
 * @name renderMinistryFeedbackList
 * @param {array<{}>} feedback
 * @param {string} ministry
 * @return {array<jsx>} array of feedback items to render
 */function renderMinistryFeedbackList(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var ministry=arguments[1];var gameState=arguments[2];var gameStateInput=arguments[3];var currentItem=arguments.length>4&&arguments[4]!==undefined?arguments[4]:"";var items=[].concat(getMinistryFeedbackItems(feedback,ministry,gameState,gameStateInput),getOverigeEffecten(feedback,ministry,gameState)).sort(sorter);// Merge feedback and OE
return items.map(function(fb){var img='';if(fb.img){if(fb.img.indexOf('.jpg')!==-1){img=fb.img.slice(0,fb.img.length-4);}else if(fb.img.indexOf('.jpeg')!==-1){img=fb.img.slice(0,fb.img.length-5);}else{img=fb.img;}}console.log(fb.to);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{key:fb.id,to:fb.to},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_elements_ListButton__["a" /* default */],{read:checkRead(fb,fb.oe,fb.index),bgColor:'grey',title:fb.title,className:fb.omschrijving===currentItem?'show':'',desc:subString(getText(fb,gameState.language),80,"...</p>"),icon:fb.icon,arrow:true,feedback:true,thumbnail:''+__WEBPACK_IMPORTED_MODULE_13__config___default.a.mediaUrl+img.replace('+','%2B')+'.jpeg',points:fb.points,disaster:fb.type==='RAMP'}));});}function getLowMinistryFeedbackLink(){var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var ministry=arguments[1];var gameState=arguments[2];var gameStateInput=arguments[3];var debug=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var items=[].concat(getMinistryFeedbackItems(feedback,ministry.toUpperCase(),gameState,gameStateInput),getOverigeEffecten(feedback,ministry.toUpperCase(),gameState)).sort(sorter);// Merge feedback and OE
return items.map(function(fb){return fb.to;});}function getFeedbackOverviewList(roundObject,self){if(self.props.feedback.prevRoundFeedbackData){var result=getFeedbackOverview(self.state.type,self.props.feedback.prevRoundFeedbackData).sort(sorter);var feedbackOverview=result.map(function(feedback){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{key:feedback.Omschrijving,to:'/ministries/overview/'+self.state.type+"/"+feedback.Ministerie.toLowerCase()+'/'+feedback.Omschrijving+'/'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_elements_ListButton__["a" /* default */],{read:checkRead(feedback),bgColor:'grey',title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(getFeedbackTitle(feedback)),desc:subString(feedback.tekst_NL,80,"...</p>"),icon:__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][feedback.Ministerie],arrow:true,feedback:true,thumbnail:feedback.img,points:feedback.winstverliesglobas,isGlobas:true}));});return feedbackOverview;}}function getFeedbackMinistery(feedback){if(feedback.type==='RAMP'){return feedback.ministerie;}return feedback.omschrijving.substr(3,2);}function getFeedbackContainsEffectMinistery(feedback,ministry){var key='Output: Ander ministerie [OE]';if(feedback[key]===""){return null;}var suffix_underscore="";var suffix="";while(key+suffix_underscore+suffix in feedback&&feedback[key+suffix_underscore+suffix]!==""){var totalSuffix=suffix_underscore+suffix;if(feedback['Output: Ander ministerie [OE]'+totalSuffix]===ministry){return{feedback:feedback,suffix:totalSuffix};}//Set feedback for next loop
suffix_underscore="_";if(suffix===""){suffix=2;}else{suffix=suffix+=1;}}return false;}function getMinisteryFeedback(min,feedbackList){var unreadOnly=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(!feedbackList)return 0;var result=feedbackList.filter(function(f){return getFeedbackMinistery(f)===min;});if(!unreadOnly){return result;}else{return result.filter(function(current){return current.read['read']!==true;});}}function getFeedbackOverview(type,feedbackList){var unreadOnly=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(!feedbackList)return 0;var result=void 0;if(type==='profit'){result=feedbackList.filter(function(f){return f.winstverliesglobas>0;});}else{result=feedbackList.filter(function(f){return f.winstverliesglobas<0;});}if(!unreadOnly){return result;}else{return result.filter(function(current){return current.read['read']!==true;});}}function getMinistryEffectFeedback(min,feedbackList){var unreadOnly=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(!feedbackList)return 0;var result=feedbackList.map(function(f){return getFeedbackContainsEffectMinistery(f,min);}).filter(function(f){return f!==false&&f!==null;});if(!unreadOnly){return result;}else{return result.filter(function(current){return current.feedback.read['fb'+current.suffix+"_read"]!==true;});}}function getUnreadWinstGlobas(feedbackList){var winstGlobasFeedback=getEconomieFeedback(feedbackList,'profit');if(!winstGlobasFeedback.length)return[];return winstGlobasFeedback.filter(function(f){return!checkRead(f,false,0,true);});}function getUnreadVerliesGlobas(feedbackList){var verliesGlobasFeedback=getEconomieFeedback(feedbackList,'loss');if(!verliesGlobasFeedback.length)return[];return verliesGlobasFeedback.filter(function(f){return!checkRead(f,false,0,true);});}function getLastChar(feedback){return feedback.toLowerCase().replace(/[^a-z]+/g,"").slice(-1);}function isDisaster(feedback){return getLastChar(feedback)==='r';}function ministryHasDisaster(min,feedback){return feedback.prevRoundFeedbackData.find(function(fb){return fb.ministerie===min&&fb.type==='RAMP';});}function getFeedbackTitle(fb){switch(fb.type){case'RAMP':case'ALGEMEEN':return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_budgetkeuze');case'BELEIDSKEUZE':return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',1);case'STARTSITUATIE':return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_startsituatie');case'BELASTING':if(fb.niveau==='Basic'){return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belastingkeuze');}return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.belastingsoort);case'OVERIGEFFECT':return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_effect_vanuit')+':';default:return'';}}/**
 *
 * @param feedbackList
 * @returns {{wg: *, vg: *}}
 */function extractWgVg(feedbackList){var wg=feedbackList.filter(function(f){return f.winstverliesglobas&&f.winstverliesglobas>0;});var vg=feedbackList.filter(function(f){return f.winstverliesglobas&&f.winstverliesglobas<0;});return{wg:wg,vg:vg};}/**
 * Check wether a ministry has been overfinanced or not
 * @param {String} ministry
 * @param {Object} gameState
 * @param {Number} roundNumber
 * @returns {Bool}
 */function ministryOverfinanced(ministry,_ref,roundNumber){var difficulty=_ref.difficulty,Rounds=_ref.Rounds,prevRound=_ref.prevRound;var round=typeof roundNumber==='undefined'?prevRound:Rounds[roundNumber];if(!round)return;var overfinanced=false;var states=round.GameStates.filter(function(gs){return gs.type!=='TEACHER_INTERVENTION'&&gs.type!=='BONUS_ASSIGNMENT';});if(states&&states.length>0){var lastGameState=states[states.length-1];overfinanced=lastGameState.OneTimeEffect.overfinanced.includes(ministry);}return overfinanced;/**
   * Old code kept here in case the new part doesnt work.
   * Case was that the first onetimeeffect is the same as
   * the last one, so a ministry is overfinanced for two
   * rounds.
   */// return round.GameStates.find(
//   gs => gs.OneTimeEffect.overfinanced
//     && gs.OneTimeEffect.overfinanced.length
//     && (gs.OneTimeEffect.overfinanced || []).includes(ministry)
// );
}function getMinistryARating(difficulty,ministryName,value,feedbackList){var buckets=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].ministryValueBucket[difficulty][ministryName];var type=buckets.findIndex(function(val){return value<=val;});if(type===-1)type=buckets.length-1;return type;}function getMinistryStatusBarRatings(min,gameState,gameStateInput){var arr=[];var fn=function fn(val){return value<=val;};var value=0;if(gameState.difficulty==='PRO'){var sw=getSamenWerkingenForMinisterie(min,gameStateInput);//Loop through all rounds in the game (= 5 including startsituation)
for(var c=0;c<5;c++){//Return null when the round is bigger than the current round
//Round has not been played yet.
if(c>=gameState.currentRound){arr.push(null);continue;}//Get the calculated ministryvalue
value+=gameState.Rounds[c].gameStateSum[min+'_value'];//Get the defined status buckets for the ministry in question.
var statusBuckets=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].statusBars.pro[min];//Determine whether the there is a collaboration array to use.
//Always take the second array when collaboration because
//international ministries have two arrays in the defines and
//are the only ones that can collaborate.
//If there is no collaboration, always take the first array.
statusBuckets=sw?statusBuckets[1]:statusBuckets[0];var pos=statusBuckets.findIndex(fn);//If value exceeds bucket
if(value>statusBuckets[statusBuckets.length-1]){//Highest value
value=statusBuckets[statusBuckets.length-1]-1;pos=statusBuckets.length;}else if(value<statusBuckets[0]){//Lowest value
value=statusBuckets[0];pos=0;}var val=void 0;if(value===0){//A value of 0 is displayed as a negative so sets value to -0
val=-0;}else if(pos<5){//Index of smaller than five indicates a negative value
//Value has to be inverted to calculate the height of
//the statusbar displayed so 5 is subtracted.
val=5-pos;}else{//Index bigger than five indicates a positive value
//Value has to be reduced by five to compensate
//for the negative values in the array.
val=pos-5;}var percentage=Math.abs(val)*10;arr.push(pos<=5?percentage*-1:percentage);}}else{var _sw=getSamenWerkingenForMinisterie(min,gameStateInput);//Loop through all rounds in the game (= 5 including startsituation)
for(var _c=0;_c<5;_c++){//Return null when the round is bigger than the current round
//Round has not been played yet.
if(_c>=gameState.currentRound){arr.push(null);continue;}//Get the calculated ministryvalue
value+=gameState.Rounds[_c].gameStateSum[min+'_value'];//Get the defined status buckets for the ministry in question.
var _statusBuckets=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].statusBars.basic;//Determine whether the there is a collaboration array to use.
//Always take the second array when collaboration because
//international ministries have two arrays in the defines and
//are the only ones that can collaborate.
//If there is no collaboration, always take the first array.
if(['ot','kn','oh','eh'].includes(min.toLowerCase())){_statusBuckets=_sw?_statusBuckets.national[0]:_statusBuckets.international[0];}else{_statusBuckets=_statusBuckets.national[0];}var _pos=_statusBuckets.findIndex(fn);//If value exceeds bucket
if(value>_statusBuckets[_statusBuckets.length-1]){//Highest value
value=_statusBuckets[_statusBuckets.length-1]-1;_pos=_statusBuckets.length;}else if(value<_statusBuckets[0]){//Lowest value
value=_statusBuckets[0];_pos=0;}var _val=void 0;if(value===0){//A value of 0 is displayed as a negative so sets value to -0
_val=-0;}else if(_pos<5){//Index of smaller than five indicates a negative value
//Value has to be inverted to calculate the height of
//the statusbar displayed so 5 is subtracted.
_val=5-_pos;}else{//Index bigger than five indicates a positive value
//Value has to be reduced by five to compensate
//for the negative values in the array.
_val=_pos-5;if(['ot','kn','oh','eh'].includes(min.toLowerCase())&&_sw<1){_val=_val>3?3:_val;}}var _percentage=Math.abs(_val)*10;arr.push(_pos<=5?_percentage*-1:_percentage);}}return arr;}function getSamenWerkingenForMinisterie(min,_ref2){var ministryCollaborations=_ref2.ministryCollaborations;var roundOffset=arguments.length>2&&arguments[2]!==undefined?arguments[2]:-1;if(__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].i18nMinistries.indexOf(min)===-1)return 0;if(!ministryCollaborations[min])return 0;return ministryCollaborations[min].length;}function getMinistryColor(difficulty,ministryName,_ref3,gameStateInput,feedBackList){var sumUpToPrevRound=_ref3.sumUpToPrevRound,currentRound=_ref3.currentRound;var teaminfo=arguments.length>5&&arguments[5]!==undefined?arguments[5]:false;var value=sumUpToPrevRound[ministryName+'_value']||0;var roundPoints=sumUpToPrevRound[ministryName+'_points']||0;if((teaminfo&&currentRound===0||!teaminfo&&currentRound===1)&&value>0&&__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].i18nMinistries.indexOf(ministryName)!==-1)return'green';var rating=getMinistryARating(difficulty,ministryName,value,feedBackList);var samenwerking=getSamenWerkingenForMinisterie(ministryName,gameStateInput);if(difficulty==='basic')return getMinistryColorBasic(rating,samenwerking,ministryName);var _Defines$ministryColo=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].ministryColors[ministryName].find(function(_ref4){var c=_ref4.c;return c.find(function(_ref5){var _ref6=_slicedToArray(_ref5,3),status=_ref6[0],points=_ref6[1],sw=_ref6[2];if(__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].i18nMinistries.indexOf(ministryName)!==-1){if(rating<1){rating=1;}if(rating>2){rating=2;}return rating===status&&(points===undefined||roundPoints<points)&&(sw===undefined||(samenwerking||0)<=sw);}return rating===status&&(points===undefined||roundPoints<points);});}),color=_Defines$ministryColo.color;return color;}function getMinistryColorBasic(rating,samenwerking,ministryName){// Internationaal ministerie (samenwerken)
if(__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].i18nMinistries.indexOf(ministryName)>-1){if(!samenwerking&&rating<=1)return'red';if(samenwerking&&rating<=1)return'lowOrange';if(!samenwerking&&rating<=3)return'lowOrange';if(samenwerking&&rating>1)return'green';}else{switch(rating){case 0:return'red';case 1:return'lowOrange';case 2:return'lowYellow';case 3:default:return'green';}}}/**
 * Get subtitle from fb
 * @param {object} fb
 * @param {string} lang
 * @return {string} subtitle
 */function getSubtitle(fb){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';if(fb.type==='BELEIDSKEUZE'){return fb['titel_beleidskeuze_'+lang]?': '+fb['titel_beleidskeuze_'+lang]:'';}if(fb.type==='OVERIGEFFECT'){if(fb.belastingNaam){return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.belastingsoort);}else if(fb.ministerie){return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.ministerie);}else if(fb.niveau==='Basic'){return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belastinginkomsten');}}return'';}/**
 * Get icon
 * @param {object} fb
 * @param {bool} economie
 * @return {*} img ref
 */function getIcon(fb){var economie=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(fb.type==='STARTSITUATIE'){if(window.innerWidth<1024)return null;return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie];}if(fb.type==='ALGEMEEN'){if(economie&&fb.ministerie){return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie];}return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["d" /* icons */].globas;}if(fb.type==='RAMP'){return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["d" /* icons */].globas;}if(fb.type==='BELEIDSKEUZE'){if(fb.niveau==='Basic'){return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["d" /* icons */].beleidskeuze;}else if(economie&&fb.ministerie){return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie];}return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["d" /* icons */].beleidskeuze;}if(fb.type==='BELASTING'){if(fb.niveau==='Basic'){return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["a" /* belastingIcons */]['LB'];}return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["a" /* belastingIcons */][fb.belastingsoort];}if(fb.type==='OVERIGEFFECT'){return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie]||(__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["a" /* belastingIcons */][fb.belastingsoort]?__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["a" /* belastingIcons */][fb.belastingsoort]:__WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["a" /* belastingIcons */]['LB']);}return __WEBPACK_IMPORTED_MODULE_4__assets_assets_js__["g" /* ministryIcons */][fb.ministerie];}/**
 * get costs
 * @param {object} fb
 * @param {object} gameState
 * @return {number} cost
 */function getCosts(fb,gameState){var costs=fb.kosten_globas;if(Array.isArray(costs)){if(checkIfCollab(fb)){costs=fb.kosten_globas[1];}else{costs=fb.kosten_globas[0];}}if(fb.type==='BELEIDSKEUZE'){return costs||0;}if(fb.type==='BELASTING'){return gameState.prevRoundSum[fb.belastingsoort+'_globas']||0;}if(!gameState||!gameState.prevRound.gameStateInput)return 0;return gameState.prevRound.gameStateInput.ministerieGlobaVerdeling[fb.ministerie]||0;}/**
 * check if item contains collaboration
 * @param {object} fb
 * @return {bool} whether item contains collaboration or nah.
 */function checkIfCollab(fb){if(fb.samenwerking.reduce(function(total,collab){return total+collab;})>0){return true;}return false;}/**
 * get collabs
 * @param {object} fb
 * @param {object} gameStateInput
 * @return {array<string>} array of group theme names
 */function getCollaborations(fb,gameStateInput){if(fb.type==='BELEIDSKEUZE'){return gameStateInput.policyChoiceCollaborations[fb.omschrijving.split('SW')[0]]||[];}var order=['red','orange','yellow','green','blue','purple'];var res=gameStateInput.ministryCollaborations[fb.ministerie];if(res){res.sort(function(a,b){if(order.indexOf(a.toLowerCase())>order.indexOf(b.toLowerCase())){return 1;}if(order.indexOf(a.toLowerCase())<order.indexOf(b.toLowerCase())){return-1;}return 0;});}return res||[];}/**
 * get points
 * @param {object} fb
 * @param {object} gameState
 * @param {number} collaborations
 * @return {number} points
 */function getPoints(fb,gameState){var collaborations=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;if(collaborations&&Array.isArray(fb.puntenscore)&&fb.puntenscore[0].match(/^SW\d-\d=\d*$/)){return getCollaborationPoints(fb.puntenscore,collaborations);}if(['ALGEMEEN','RAMP'].indexOf(fb.type)!==-1){return gameState.prevRoundSum[fb.ministerie+'_points_raw'];}if(fb.type==='BELASTING'){return gameState.prevRoundSum[fb.belastingsoort+'_points']||0;}return fb.puntenscore||0;}/**
 * get image text
 * @param {object} fb
 * @param {string} lang
 * @return {string} image text
 */function getImageText(fb){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';return fb['img_tekst_'+lang];}/**
 * get image
 * @param {object} fb
 * @returns {string} img src
 */function getImage(fb){if(fb){if(fb.img){return fb.img.replace('+','%2B');}else if(fb.omschrijving){return fb.omschrijving.replace('+','%2B');}}return'';}/**
 * get text
 * @param {object} fb
 * @param {string} lang
 * @return {string} text
 */function getText(fb){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';return fb['tekst_'+lang]||fb.tekst;}/**
 * get OE
 * @param {object} fb
 * @return {array<{}>} overige effecten
 */function getSideEffects(fb){return fb.overigeEffecten||[];}function getUnreadCount(ministry,prevRoundFeedbackData){return getMinisteryFeedback(ministry,prevRoundFeedbackData,true).length+getOverigeEffecten(prevRoundFeedbackData,ministry).filter(function(i){return!checkRead(i,i.oe,i.index,i.economie);}).length;}function getPolicyChoiceCollaborations(s){var roundNum=arguments.length>1&&arguments[1]!==undefined?arguments[1]:s.myState.roundNumber-1;var round=s.states[roundNum];// previous round number
if(round&&round[s.groupId]){return Object.keys(round[s.groupId].policyChoices||{}).filter(function(pcKey){return round[s.groupId].policyChoices[pcKey].collaboration.length;}).reduce(function(collabs,pcKey){var myCollabs=round[s.groupId].policyChoices[pcKey].collaboration;myCollabs.forEach(function(color){var id=Object.keys(round).find(function(id){return round[id].theme===color;});var group=round[id];if(group&&group.policyChoices[pcKey]&&group.policyChoices[pcKey].collaboration.includes(round[s.groupId].theme)){var keyWithoutSW=pcKey.split('SW')[0];if(!collabs[keyWithoutSW])collabs[keyWithoutSW]=[];collabs[keyWithoutSW].push(color);}});return collabs;},{});}}function reduceMinistryCollabs(mKey,s){var roundNumber=arguments.length>2&&arguments[2]!==undefined?arguments[2]:s.myState.roundNumber-1;var key=mKey+'SW';if(roundNumber>0&&s.states[roundNumber][s.groupId]&&s.states[roundNumber][s.groupId].ministerieGlobaVerdeling&&Array.isArray(s.states[roundNumber][s.groupId].ministerieGlobaVerdeling[key])){return s.states[roundNumber][s.groupId].ministerieGlobaVerdeling[key].reduce(function(arr,val){var group=Object.keys(s.states[roundNumber]).find(function(id){return s.states[roundNumber][id].theme===val;});if(group&&Array.isArray(s.states[roundNumber][group].ministerieGlobaVerdeling[key])&&s.states[roundNumber][group].ministerieGlobaVerdeling[key].includes(s.myState.theme)){// assuming you won't change theme after one round :P
if(s.states[roundNumber][group].ministerieGlobaVerdeling[mKey]===s.states[roundNumber][s.groupId].ministerieGlobaVerdeling[mKey]){arr.push(val);}}return arr;},[]);}return[];}var debitCreditIcons={stortenSpaargeld:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_bank_svg___default.a,opnemenSpaargeld:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_bank_svg___default.a,lenenVanLand:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_lenen_land_svg___default.a,lenenAanLand:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_uitlenen_land_svg___default.a,lenenVanBank:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_bank_svg___default.a,schenkAanland:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_schenken_land_svg___default.a};function simulateDebitCreditOutcome(obj){var outcome=calculateDebitCreditOutcome(obj);if(!outcome)return null;return{newDebt:_extends({},obj,{payed:(obj.payed||0)+outcome.amount,round:obj.round+1}),outcome:outcome};}function calculateDebitCreditOutcome(_ref7){var amount=_ref7.amount,_ref7$payed=_ref7.payed,payed=_ref7$payed===undefined?0:_ref7$payed,interest=_ref7.interest,key=_ref7.key,round=_ref7.round,otherCountry=_ref7.otherCountry,interestInPercent=_ref7.interestInPercent,bankDisabledPayout=_ref7.bankDisabledPayout;var currentRound=arguments.length>1&&arguments[1]!==undefined?arguments[1]:-1;var bankDisabled=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;if(amount+interest===payed)return null;//old
var roundMethod=amount<0?Math.floor:Math.ceil;var ret={icon:debitCreditIcons[key],key:key};if(otherCountry){ret.title=amount>0?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_betalen_aan_land_procent'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_ontvangen_van_land');ret.title=ret.title.replace('%',Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(otherCountry));ret.icon=Object(__WEBPACK_IMPORTED_MODULE_14__bankHelper__["a" /* getCountryIcon */])(otherCountry);//groupIcons[__(otherCountry).toLocaleLowerCase()];
}else{roundMethod=payed>0?Math.floor:Math.ceil;ret.title=amount>0?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_betalen_aan_bank'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_ontvangen_van_bank');}interest=interestInPercent?amount*interest:interest;if(interest>0&&interest<1)interest=1;var halfInterest=interest/2;if(halfInterest>0&&halfInterest<1)halfInterest=1;if(currentRound>=4&&payed===0&&key!=='stortenSpaargeld'){ret.amount=roundMethod(amount+interest);return ret;}if(key==='stortenSpaargeld'){if(bankDisabledPayout||bankDisabled){ret.amount=roundMethod(amount+interest);}else{ret.amount=roundMethod(interest);}ret.title=ret.amount>0?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_betalen_aan_bank'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_ontvangen_van_bank');return ret;}if(bankDisabled){ret.amount=amount+interest-payed;ret.amount=roundMethod(ret.amount);return ret;}// always payed back in two rounds, so any time anything has been payed back, we'll pay the rest
ret.amount=payed?amount+interest-payed:amount/2+halfInterest;ret.amount=roundMethod(ret.amount);return ret;}function calculateDebitCreditOutcomeBasic(_ref8){var amount=_ref8.amount,_ref8$payed=_ref8.payed,payed=_ref8$payed===undefined?0:_ref8$payed,interest=_ref8.interest,key=_ref8.key,round=_ref8.round,otherCountry=_ref8.otherCountry,interestInPercent=_ref8.interestInPercent,bankDisabledPayout=_ref8.bankDisabledPayout;var bankDisabled=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(amount+interest===payed)return null;//old
var ret={icon:debitCreditIcons[key],key:key};if(otherCountry){ret.title=amount>0?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_betalen_aan_land_procent'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_ontvangen_van_land');ret.title=ret.title.replace('%',Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(otherCountry));ret.icon=__WEBPACK_IMPORTED_MODULE_12__assets_assets__["c" /* groupIcons */][Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(otherCountry).toLocaleLowerCase()];}else{ret.title=amount>0?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_betalen_aan_bank'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_ontvangen_van_bank');}interest=interestInPercent?amount*interest:interest;if(interest>0&&interest<1)interest=1;if(round>=3){ret.amount=amount+interest;return ret;}if(key==='stortenSpaargeld'){if(bankDisabledPayout||bankDisabled){ret.amount=amount+interest;}else{ret.amount=interest;}ret.title=ret.amount>0?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_betalen_aan_bank'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_te_ontvangen_van_bank');return ret;}// always payed back in two rounds, so any time anything has been payed back, we'll pay the rest
ret.amount=amount+interest;return ret;}function getPolicyChoiceTotalPoints(fb){return getPolicyChoiceFeedback(fb).reduce(function(points,item){points+=item.puntenscore||0;return points;},0);}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContentContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ContentContainer=(_temp=_class=function(_Component){_inherits(ContentContainer,_Component);function ContentContainer(props){_classCallCheck(this,ContentContainer);var _this=_possibleConstructorReturn(this,(ContentContainer.__proto__||Object.getPrototypeOf(ContentContainer)).call(this,props));_this.state={transitionDelay:_this.props.transitionDelay,showComponent:false};return _this;}_createClass(ContentContainer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-outer '+(this.props.outerClassName?this.props.outerClassName:"")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.props.onClick,style:this.props.style,className:'content-container '+(this.state.transitionDelay?this.state.transitionDelay:'')+' '+this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'+(this.props.darkBg?' darkBg':'')}),this.props.children));}}]);return ContentContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={style:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func},_class.defaultProps={style:{},className:'',onClick:function onClick(){}},_temp);

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_QuestionButton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg__);
var PopupTitle=function PopupTitle(_ref){var title=_ref.title,popupId=_ref.popupId,lang=_ref.lang,tag=_ref.tag,global=_ref.global,customClass=_ref.customClass,onlyQ=_ref.onlyQ;var Tag=tag||'h2';if(onlyQ){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_QuestionButton__["a" /* default */],{popupId:popupId});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tag,{className:'popup-heading-tag '+(customClass?customClass:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_QuestionButton__["a" /* default */],{popupId:popupId},global?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'globalIcon',className:'global-icon',src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg___default.a}):'',' ',(title?title:Object(__WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__["i" /* getTitle */])(popupId,lang)||'').replace(/Bonus opdrachten/g,"Bonusopdrachten")));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{lang:state.gameState.language};})(PopupTitle));

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_close_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_video_react__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_video_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PopUp=(_temp=_class=function(_React$Component){_inherits(PopUp,_React$Component);function PopUp(props){_classCallCheck(this,PopUp);var _this=_possibleConstructorReturn(this,(PopUp.__proto__||Object.getPrototypeOf(PopUp)).call(this,props));_this.showNext=function(ev,nextId){var state=_this.state;ev.stopPropagation();var history=state.history,cur=state.cur;history.push(nextId);cur++;_this.setState({history:history,cur:cur});};_this.showPrev=function(ev){ev.stopPropagation();var _this$state=_this.state,history=_this$state.history,cur=_this$state.cur;history.pop();--cur;_this.setState({history:history,cur:cur});};_this.popupSettings=function(popupId){if(popupId&&popupId.substr(3,1)==='m'){var popup=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].popups[popupId];if(!popup)return;switch(popup.Type){case"A":_this.setState({interactive:true,hideClose:false});break;case"B":_this.setState({interactive:false,hideClose:true,confirmButtons:true,confirmButtonsSave:true});break;case"H":_this.setState({interactive:false,hideClose:true,buttonText:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_terug_naar_startscherm')});break;case"I":_this.setState({interactive:false,hideClose:true,confirmButtons:true,confirmButtonsSave:false});break;case"J":_this.setState({interactive:false,hideClose:true,cancelButtons:true});break;default:return;}}};_this.closePopup=function(e){console.log("CLOOOOSSEEEEEEE");_this.setShowPopup();_this.props.closePopUpClick(e);};_this.setShowPopup=function(){var key=_this.props.showIfUnread;if(key){sessionStorage.setItem(key,'true');}};_this.getShowPopup=function(){var key=_this.props.showIfUnread;if(key){var res=sessionStorage.getItem(key);if(res&&res==='true'){return false;}else{return true;}}return true;};_this.state={history:[props.id],count:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_popupHelper__["b" /* getAllTourPopups */])(props.id),cur:1,isFullscreen:false,interactive:_this.props.interactive,hideClose:_this.props.hideClose,confirmButtons:false,buttonText:_this.props.buttonText};_this.handleClick=_this.handleClick.bind(_this);_this.handleKeyPress=_this.handleKeyPress.bind(_this);return _this;}_createClass(PopUp,[{key:'componentWillMount',value:function componentWillMount(){if(!this.props.popUpFooter){document.body.classList.add('noScroll');}if(this.props.showHeader){document.body.classList.add('popup--showHeader');}this.popupSettings(this.props.id);}},{key:'componentDidMount',value:function componentDidMount(){var first=this.props.id;var tourCount=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_popupHelper__["b" /* getAllTourPopups */])(first);if(this.props.showHeader){document.body.classList.add('popup--showHeader');}this.setState({count:tourCount});document.addEventListener("keydown",this.handleKeyPress);if((this.props.popUpFooter||this.props.customButton)&&!this.props.closePopUpCross){window.addEventListener('mousedown',this.props.closePopUpClick);}if(this.state.interactive){window.addEventListener('mousedown',this.handleClick);}if(this.refs.player){this.refs.player.subscribeToStateChange(this.handleStateChange.bind(this));}}},{key:'handleStateChange',value:function handleStateChange(state){var isFullscreen=this.state.isFullscreen;if(state.isFullscreen!==isFullscreen){this.setState({isFullscreen:state.isFullscreen});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(!this.props.popUpFooter){document.body.classList.remove('noScroll');}if(this.props.showHeader){document.body.classList.remove('popup--showHeader');}document.removeEventListener("keydown",this.handleKeyPress);if((this.props.popUpFooter||this.props.customButton)&&!this.props.closePopUpCross){window.removeEventListener('mousedown',this.props.closePopUpClick);}if(this.state.interactive){window.removeEventListener('mousedown',this.handleClick);}}},{key:'handleClick',value:function handleClick(event){if(document.getElementsByClassName('popup').length&&!document.getElementsByClassName('popup')[0].contains(event.target)){this.props.closePopUpClick();}}},{key:'handleKeyPress',value:function handleKeyPress(event){if(event.keyCode===27){if(!this.state.hideClose){this.props.closePopUpClick();}}}/**
   * Method to show next popup
   *//**
   * Method to show previous popup
   */},{key:'render',value:function render(){var _this2=this;var props=this.props,showPrev=this.showPrev,showNext=this.showNext,state=this.state;var isFullscreen=state.isFullscreen;var popupId=state.history[state.history.length-1];var isPortal=window.location.pathname.indexOf('portal')!==-1||window.location.pathname.indexOf('login')!==-1;var nextId='';if(popupId){nextId=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_popupHelper__["f" /* getNext */])(popupId);}if(!this.getShowPopup())return null;var centerPopupIds=['mhgvtintro_welkom','dhgvtintro_welkom','mlgvtintro_welkom','dlgvtintro_welkom','dhbvtintro_welkom','dlbvtintro_welkom','dhbvtghettoradio_1','dlbvtghettoradio_1','mhbvtintro_welkom','mlbvtintro_welkom','mhbvtghettoradio_1','mlbvtghettoradio_1'];var popup=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].popups[popupId];var language=props.gameState.loaded?props.gameState.language:(Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["d" /* getLocale */])()||'NL').toUpperCase();return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.props.zIndex?{zIndex:this.props.zIndex}:{},className:"popup-container"+(props.showPopUp?' show':'')+(props.popUpFooter?' footer':'')+(isPortal?' is-portal':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-spacer-desktop'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'align-right-two-third'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"popup"+(props.video?' video-popup':'')+(props.className?' '+props.className:''),ref:function ref(node){return _this2.node=node;}},this.props.closePopUpCross&&!this.state.hideClose?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(e){return _this2.closePopup(e);},className:'top-right-close-button close-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_img_close_png___default.a,height:'15',alt:''}))):null,(nextId<1||!nextId)&&nextId!==''&&state.history.length<2&&!this.state.hideClose&&!props.popUpFooter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(e){return _this2.closePopup(e);},className:'top-right-close-button close-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_img_close_png___default.a,height:'15',alt:''}))):null,popupId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-content',style:centerPopupIds.indexOf(popupId)>-1?{textAlign:'center'}:{},dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_popupHelper__["d" /* getContent */])(popupId,language)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-navigation '+('type-'+String(popup.Type).toLowerCase())},state.history.length>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:"button--white tut-prev",onClick:function onClick(ev){showPrev(ev);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_vorige_button'))):null,state.count>1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tutorial-counter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,state.cur),'/',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,state.count)):null,nextId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'tut-next',onClick:function onClick(ev){showNext(ev,nextId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_volgende_button'))):null,state.count>1&&state.count===state.cur?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'tut-close',onClick:function onClick(e){return _this2.closePopup(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_aan_de_slag_button'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},state.buttonText?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return _this2.closePopup(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(state.buttonText))):null),!this.state.confirmButtons?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(_){return props.closePopUpClick(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(this.state.confirmButtonsSave?'sim_button_ja_terug':'Nee'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(_){return props.closePopUpClick(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(this.state.confirmButtonsSave?'sim_button_nee_opslaan':'Ja')))),!this.state.cancelButtons?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(_){return props.closePopUpClick(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_annuleren'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(_){return props.closePopUpClick(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'Ok'))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.img?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'popup',className:props.imgClass?props.imgClass:'',src:props.img}):null,props.video?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){props.closePopUpClick();},className:'top-right-close-button close-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_img_close_png___default.a,height:'15',alt:''}))):null,props.video?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_video_react__["Player"],{autoPlay:true,muted:true,className:'videoframe '+(isFullscreen?' fullscreen':''),ref:'player',src:props.video},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_video_react__["ControlBar"],{autoHide:isFullscreen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_video_react__["VolumeMenuButton"],{vertical:true}))):null,props.title?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(props.title)):null,props.description?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(props.description)}}):null,props.children?props.children:null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'button-container'},state.buttonText?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(e){return _this2.closePopup(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(state.buttonText))):null,props.customButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:props.customButton.action,onTouchStart:props.customButton.action},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(props.customButton.text))):null)))))),document.body);}}]);return PopUp;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={closePopUpClick:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,id:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,elementFocus:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,showPopUp:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,description:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,// description for custom popup
title:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,// title for custom popup
img:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,// img for custom popup
buttonText:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,hideClose:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,popUpFooter:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,closePopUpCross:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,customButton:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({text:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,action:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func}),zIndex:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number},_class.defaultProps={closePopUpClick:function closePopUpClick(){},hideClose:false,interactive:false,closePopUpCross:false,zIndex:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{gameState:state.gameState};})(PopUp));

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FETCH_USER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return UPDATE_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LOGOUT_USER; });
/* unused harmony export FETCH_PROJECT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return UPDATE_PROJECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UPDATE_SCHOOLCLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_GROUP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADD_SCHOOLCLASS_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REMOVE_SCHOOLCLASS_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_SCHOOLCLASS_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REMOVE_SCHOOLCLASS_PHOTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SET_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UPDATE_GROUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return UPDATE_GHETTORADIO_GROUPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UPDATE_GHETTORADIO_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return UPDATE_GHETTORADIO_LOCKED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return UPDATE_GHETTORADIO_HANDLING_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_GHETTORADIO_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_GAMESTATE; });
/* unused harmony export UPDATE_GAMESTATE_SWITCH_ACTIVE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SET_STEP; });
/* unused harmony export SET_ROUND_STATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FINISHED_STEP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UPDATE_HANDLING_ROUND_STATE_CHANGE; });
/* unused harmony export FETCH_FEEDBACK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_FEEDBACK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_ROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_FEEDBACK_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return UPDATE_INPUT_STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return UPDATE_MY_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SUBMIT_MY_STATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return UPDATE_POPUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_BANKNOTIFICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return UPDATE_POLICY_CHOICE_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return UPDATE_TIMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_REMOVED_CURRENT_ROUND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FORCE_LANGUAGE; });
// User
var FETCH_USER='FETCH_USER';var UPDATE_USER='UPDATE_USER';var LOGOUT_USER='LOGOUT_USER';// Project
var FETCH_PROJECT='FETCH_PROJECT';var UPDATE_PROJECT='UPDATE_PROJECT';// Schoolclass
var UPDATE_SCHOOLCLASS='UPDATE_SCHOOLCLASS';var SET_GROUP_ID='SET_GROUP_ID';var ADD_SCHOOLCLASS_VIDEO='ADD_SCHOOLCLASS_VIDEO';var REMOVE_SCHOOLCLASS_VIDEO='REMOVE_SCHOOLCLASS_VIDEO';var ADD_SCHOOLCLASS_PHOTO='ADD_SCHOOLCLASS_PHOTO';var REMOVE_SCHOOLCLASS_PHOTO='REMOVE_SCHOOLCLASS_PHOTO';var SET_TIMER='SET_TIMER';// Group
var UPDATE_GROUP='UPDATE_GROUP';var UPDATE_GHETTORADIO_GROUPS='UPDATE_GHETTORADIO_GROUPS';var UPDATE_GHETTORADIO_TIMER='UPDATE_GHETTORADIO_TIMER';var UPDATE_GHETTORADIO_LOCKED='UPDATE_GHETTORADIO_LOCKED';var UPDATE_GHETTORADIO_HANDLING_ACTION='UPDATE_GHETTORADIO_HANDLING_ACTION';var UPDATE_GHETTORADIO_ACTIVE='UPDATE_GHETTORADIO_ACTIVE';// GameState
var UPDATE_GAMESTATE='UPDATE_GAMESTATE';var UPDATE_GAMESTATE_SWITCH_ACTIVE='UPDATE_GAMESTATE_SWITCH_ACTIVE';var SET_STEP='SET_STEP';var SET_ROUND_STATE='SET_ROUND_STATE';var FINISHED_STEP='FINISHED_STEP';var UPDATE_HANDLING_ROUND_STATE_CHANGE='UPDATE_HANDLING_ROUND_STATE_CHANGE';// Feedback
var FETCH_FEEDBACK='FETCH_FEEDBACK';var UPDATE_FEEDBACK='UPDATE_FEEDBACK';var SET_ROUND='SET_ROUND';var UPDATE_FEEDBACK_READ='UPDATE_FEEDBACK_READ';// GameStateInput
var UPDATE_INPUT_STATES='UPDATE_INPUT_STATES';var UPDATE_MY_STATE='UPDATE_MY_STATE';var SUBMIT_MY_STATE='SUBMIT_MY_STATE';// Popup
var UPDATE_POPUP='UPDATE_POPUP';// bankNotifications
var UPDATE_BANKNOTIFICATION='UPDATE_BANKNOTIFICATION';var UPDATE_POLICY_CHOICE_OPTIONS='UPDATE_POLICY_CHOICE_OPTIONS';var UPDATE_TIMER='UPDATE_TIMER';var SET_REMOVED_CURRENT_ROUND='SET_REMOVED_CURRENT_ROUND';var FORCE_LANGUAGE='FORCE_LANGUAGE';/* unused harmony default export */ var _unused_webpack_default_export = ({FETCH_USER:FETCH_USER,UPDATE_USER:UPDATE_USER,LOGOUT_USER:LOGOUT_USER,FETCH_PROJECT:FETCH_PROJECT,UPDATE_PROJECT:UPDATE_PROJECT,UPDATE_SCHOOLCLASS:UPDATE_SCHOOLCLASS,ADD_SCHOOLCLASS_VIDEO:ADD_SCHOOLCLASS_VIDEO,REMOVE_SCHOOLCLASS_VIDEO:REMOVE_SCHOOLCLASS_VIDEO,ADD_SCHOOLCLASS_PHOTO:ADD_SCHOOLCLASS_PHOTO,REMOVE_SCHOOLCLASS_PHOTO:REMOVE_SCHOOLCLASS_PHOTO,SET_GROUP_ID:SET_GROUP_ID,UPDATE_GROUP:UPDATE_GROUP,UPDATE_GHETTORADIO_GROUPS:UPDATE_GHETTORADIO_GROUPS,UPDATE_GHETTORADIO_TIMER:UPDATE_GHETTORADIO_TIMER,UPDATE_GHETTORADIO_LOCKED:UPDATE_GHETTORADIO_LOCKED,UPDATE_GAMESTATE:UPDATE_GAMESTATE,UPDATE_GAMESTATE_SWITCH_ACTIVE:UPDATE_GAMESTATE_SWITCH_ACTIVE,SET_STEP:SET_STEP,SET_ROUND_STATE:SET_ROUND_STATE,SET_TIMER:SET_TIMER,FETCH_FEEDBACK:FETCH_FEEDBACK,UPDATE_FEEDBACK:UPDATE_FEEDBACK,UPDATE_FEEDBACK_READ:UPDATE_FEEDBACK_READ,SET_ROUND:SET_ROUND,UPDATE_INPUT_STATES:UPDATE_INPUT_STATES,UPDATE_MY_STATE:UPDATE_MY_STATE,SUBMIT_MY_STATE:SUBMIT_MY_STATE,UPDATE_POPUP:UPDATE_POPUP,UPDATE_POLICY_CHOICE_OPTIONS:UPDATE_POLICY_CHOICE_OPTIONS,FINISHED_STEP:FINISHED_STEP,UPDATE_BANKNOTIFICATION:UPDATE_BANKNOTIFICATION,UPDATE_TIMER:UPDATE_TIMER,SET_REMOVED_CURRENT_ROUND:SET_REMOVED_CURRENT_ROUND,UPDATE_GHETTORADIO_HANDLING_ACTION:UPDATE_GHETTORADIO_HANDLING_ACTION,UPDATE_GHETTORADIO_ACTIVE:UPDATE_GHETTORADIO_ACTIVE,UPDATE_HANDLING_ROUND_STATE_CHANGE:UPDATE_HANDLING_ROUND_STATE_CHANGE,FORCE_LANGUAGE:FORCE_LANGUAGE});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var config={host:''+"globalandxl.nl",protocol:''+"http:",port:''+"",apiPath:''+"/api",adminPath:''+"/admin",adminUrl:''+("https://globalandxl.nl/admin"||'https://globalandxl.nl/admin'),development:"production"==='development',mediaUrl:''+"http://uploads.globalandxl.nl/assets/pics/",uploadsUrl:''+"http://uploads.globalandxl.nl"||'http://uploads.globalandxl.nl',disableDesktop:''+"false"};config.ghettoRadioUrl= true?"https://ghettoradio.globalandxl.nl":config.protocol+'//ghettoradio}.'+config.host;config.apiUrl= true?"https://globalandxl.nl/api":config.protocol+'//'+config.host+config.apiPath;// eslint-disable-next-line
config.socketIoHost=/([a-z]+):\/\/([^\/]+)/.exec(config.apiUrl)[0];config.socketIoOptions={path:"/api/socket.io"||'/api/socket.io'};config.socketIoUrl=config.socketIoHost+config.socketIoOptions.path+'/socket.io.js';module.exports=config;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_ministries_FB_svg__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_ministries_FB_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_ministries_FB_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ministries_GZ_svg__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ministries_GZ_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ministries_GZ_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_ministries_HB_svg__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_ministries_HB_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_ministries_HB_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_ministries_IE_svg__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_ministries_IE_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_ministries_IE_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_ministries_LV_svg__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_ministries_LV_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_ministries_LV_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_ministries_MC_svg__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_ministries_MC_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_ministries_MC_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ministries_KN_svg__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ministries_KN_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ministries_KN_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_ministries_OH_svg__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_ministries_OH_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_ministries_OH_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_ministries_OT_svg__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_ministries_OT_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_ministries_OT_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_ministries_OW_svg__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_ministries_OW_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_ministries_OW_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_ministries_VR_svg__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_ministries_VR_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_ministries_VR_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_ministries_WI_svg__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_ministries_WI_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_ministries_WI_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_ministries_WS_svg__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_ministries_WS_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_ministries_WS_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_ministries_EH_svg__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_ministries_EH_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_ministries_EH_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_ministries_edge_WI_png__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_ministries_edge_WI_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_ministries_edge_WI_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_ministries_edge_GZ_png__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_ministries_edge_GZ_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_ministries_edge_GZ_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_ministries_edge_OW_png__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_ministries_edge_OW_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_ministries_edge_OW_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_ministries_edge_OT_png__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_ministries_edge_OT_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_ministries_edge_OT_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_ministries_edge_VR_png__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_ministries_edge_VR_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_ministries_edge_VR_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_ministries_edge_IE_png__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_ministries_edge_IE_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_ministries_edge_IE_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_ministries_edge_FB_png__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_ministries_edge_FB_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_img_icons_ministries_edge_FB_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_ministries_edge_LV_png__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_ministries_edge_LV_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_ministries_edge_LV_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_img_icons_ministries_edge_KN_png__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_img_icons_ministries_edge_KN_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_img_icons_ministries_edge_KN_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_img_icons_ministries_edge_OH_png__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_img_icons_ministries_edge_OH_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_img_icons_ministries_edge_OH_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_img_icons_ministries_edge_WS_png__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_img_icons_ministries_edge_WS_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_img_icons_ministries_edge_WS_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_img_icons_ministries_edge_HB_png__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_img_icons_ministries_edge_HB_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__assets_img_icons_ministries_edge_HB_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_img_icons_ministries_edge_EH_png__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__assets_img_icons_ministries_edge_EH_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__assets_img_icons_ministries_edge_EH_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_img_icons_ministries_edge_MC_png__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__assets_img_icons_ministries_edge_MC_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__assets_img_icons_ministries_edge_MC_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_img_ghettoradio_png__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__assets_img_ghettoradio_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__assets_img_ghettoradio_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_img_escaperoute_png__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__assets_img_escaperoute_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__assets_img_escaperoute_png__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// @todo needs more assets
var auth=new __WEBPACK_IMPORTED_MODULE_2_glxl_helpers__["Authorization"]();var prepIcons={FB:__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_ministries_FB_svg___default.a,GZ:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ministries_GZ_svg___default.a,HB:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_ministries_HB_svg___default.a,IE:__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_ministries_IE_svg___default.a,LV:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_ministries_LV_svg___default.a,MC:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_ministries_MC_svg___default.a,KN:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ministries_KN_svg___default.a,OH:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_ministries_OH_svg___default.a,OT:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_ministries_OT_svg___default.a,OW:__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_ministries_OW_svg___default.a,VR:__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_ministries_VR_svg___default.a,WI:__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_ministries_WI_svg___default.a,WS:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_ministries_WS_svg___default.a,EH:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_ministries_EH_svg___default.a};if(window.navigator.userAgent.indexOf("Edge")>-1){prepIcons={FB:__WEBPACK_IMPORTED_MODULE_23__assets_img_icons_ministries_edge_FB_png___default.a,GZ:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_ministries_edge_GZ_png___default.a,HB:__WEBPACK_IMPORTED_MODULE_28__assets_img_icons_ministries_edge_HB_png___default.a,IE:__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_ministries_edge_IE_png___default.a,LV:__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_ministries_edge_LV_png___default.a,MC:__WEBPACK_IMPORTED_MODULE_30__assets_img_icons_ministries_edge_MC_png___default.a,KN:__WEBPACK_IMPORTED_MODULE_25__assets_img_icons_ministries_edge_KN_png___default.a,OH:__WEBPACK_IMPORTED_MODULE_26__assets_img_icons_ministries_edge_OH_png___default.a,OT:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_ministries_edge_OT_png___default.a,OW:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_ministries_edge_OW_png___default.a,VR:__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_ministries_edge_VR_png___default.a,WI:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_ministries_edge_WI_png___default.a,WS:__WEBPACK_IMPORTED_MODULE_27__assets_img_icons_ministries_edge_WS_png___default.a,EH:__WEBPACK_IMPORTED_MODULE_29__assets_img_icons_ministries_edge_EH_png___default.a};}var icons=prepIcons;var gameIcons={GR:__WEBPACK_IMPORTED_MODULE_31__assets_img_ghettoradio_png___default.a,ER:__WEBPACK_IMPORTED_MODULE_32__assets_img_escaperoute_png___default.a};var position={//Economie
"economy":{"pro":{"left":50,"top":0},"basic":{"left":35,"top":0}},//beleidskeuzes
"policy":{"left":65,"top":0},//Werk en inkomen
"WI":{"pro":{"left":61.5,"top":14.9},"basic":{"left":61.8,"top":15.6}},//Gezondheidszorg
"GZ":{"pro":{"left":51.6,"top":31},"basic":{"left":47.6,"top":54.5}},//Onderwijs
"OW":{"pro":{"left":68.4,"top":28.1},"basic":{"left":71,"top":29.2}},//Oorlog en terrorisme
"OT":{"pro":{"left":28.7,"top":35.6},"basic":{"left":28.5,"top":36}},//Veiligheid en recht
"VR":{"pro":{"left":59.5,"top":60.7},"basic":{"left":59.5,"top":60.9}},//Infrastructuur en Energie
"IE":{"pro":{"left":48.3,"top":14.9},"basic":{"left":49.8,"top":15}},//Financien en bestuur
"FB":{"pro":{"left":36.5,"top":18.7}},//Landbouw en voedsel
"LV":{"pro":{"left":61.1,"top":42.1},"basic":{"left":59.7,"top":39.5}},//Klimaat, natuur en milieu
"KN":{"pro":{"left":50.4,"top":71.5},"basic":{"left":50.5,"top":71.5}},//Ontwikkelingshulp
"OH":{"pro":{"left":31.9,"top":57},"basic":{"left":31.9,"top":57}},//Wonen en samenleven
"WS":{"pro":{"left":41.8,"top":41.2},"basic":{"left":44,"top":35.1}},//Handel en bedrijven
"HB":{"pro":{"left":47.2,"top":57.5}},//Eerlijke handel
"EH":{"basic":{"left":36,"top":18}},//Media, cultuur en sport
"MC":{"pro":{"left":71.4,"top":48.9},"basic":{"left":71.5,"top":49.2}}};var popupLocations={"startscherm":"/portal/group","teaminfo":"/portal/teaminfo","listviewstap1":"/ministries","winstgloba'soverzicht":"/ministries/overview/profit","verliesgloba'soverzicht":"/ministries/overview/loss","ministerieoverzicht":"/ministries/wi","listviewstap2":"/taxes","arbeidsbelastinguitvouwscherm":"/taxes/ab","bedrijvenbelastinguitvouwscherm":"/taxes/bb","consumentenbelastinguitvouwscherm":"/taxes/cb","mens-enmilieubelastinguitvouwscherm":"/taxes/mb","vermogensbelastinguitvouwscherm":"/taxes/vb","listviewstap3":"/ministries","overzichtsparenenlenen":"/bank","ministeriepaginastap3":"/ministries/budget/ot","extraopdrachten":"/portal/classleader/bonuspoints","ghettoradiospel-tussenscherm":"","filmquizspel-tussenscherm":"","escaperoutespelscherm":"","detectivesspel-tussenscherm":"","overzichtstap2":"/taxes","startschermbegeleider":"/portal/classleader","voorbereidingbegeleider":"/portal/classleader/prepare","opstartprojectbegeleiderspagina":"/portal/classleader/prepare/startup","extraopdrachtenbegeleiderspagina":"/portal/classleader/bonuspoints","foto'sbegeleiderspagina":"/portal/classleader/pictures","filmpjesbegeleiderspagina":"/portal/classleader/videos","globa'sverdelenbegeleiderspagina":"/portal/classleader/verdelen","ghettoradiobegeleiderspaginaverdienspel":"/portal/classleader/verdienen/2","escaperoutebegeleiderspaginaverdienspel":"/portal/classleader/verdienen/4","filmquizbegeleiderspagina":"/portal/classleader/verdienen/5","filmquizbegeleiderspaginaverdienspel":"/portal/classleader/verdienen/5","detectivesbegeleiderspaginaverdienspel":"/portal/classleader/verdienen/6"};var popupLocationsDesktop={"startscherm":"/portal/group","teaminfo":"/portal/teaminfo","listviewstap1":"/","winstgloba'soverzicht":"/ministries/overview/profit","verliesgloba'soverzicht":"/ministries/overview/loss","ministerieoverzicht":"/ministries/wi","listviewstap2":"/taxes","arbeidsbelastinguitvouwscherm":"/taxes/ab","bedrijvenbelastinguitvouwscherm":"/taxes/bb","consumentenbelastinguitvouwscherm":"/taxes/cb","mens-enmilieubelastinguitvouwscherm":"/taxes/mb","vermogensbelastinguitvouwscherm":"/taxes/vb","listviewstap3":"/","overzichtsparenenlenen":"/bank","ministeriepaginastap3":"/ministries/budget/ot","extraopdrachten":"/portal/classleader/bonuspoints","ghettoradiospel-tussenscherm":"","filmquizspel-tussenscherm":"","escaperoutespelscherm":"","detectivesspel-tussenscherm":"","overzichtstap2":"/taxes","startschermbegeleider":"/portal/classleader","voorbereidingbegeleider":"/portal/classleader/prepare","opstartprojectbegeleiderspagina":"/portal/classleader/prepare/startup","extraopdrachtenbegeleiderspagina":"/portal/classleader/bonuspoints","foto'sbegeleiderspagina":"/portal/classleader/pictures","filmpjesbegeleiderspagina":"/portal/classleader/videos","globa'sverdelenbegeleiderspagina":"/portal/classleader/verdelen","ghettoradiobegeleiderspaginaverdienspel":"/portal/classleader/verdienen/2","escaperoutebegeleiderspaginaverdienspel":"/portal/classleader/verdienen/4","filmquizbegeleiderspagina":"/portal/classleader/verdienen/5","filmquizbegeleiderspaginaverdienspel":"/portal/classleader/verdienen/5","detectivesbegeleiderspaginaverdienspel":"/portal/classleader/verdienen/6"};function matchCase(original,replacement){// Alles uppercase
if(original===original.toUpperCase()){return replacement.toUpperCase();}// Eerste letter uppercase (Title case)
if(original[0]===original[0].toUpperCase()){return replacement.charAt(0).toUpperCase()+replacement.slice(1);}// Anders lowercase
return replacement.toLowerCase();}var Defines=function(){function Defines(){_classCallCheck(this,Defines);}_createClass(Defines,null,[{key:'fetch',value:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var data,popups,games;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/define/simulationgame?simulationgame=true');case 2:data=_context.sent;_context.next=5;return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/simulatiespel/popups?simulationgame=true');case 5:popups=_context.sent;if(popups&&(typeof popups==='undefined'?'undefined':_typeof(popups))==="object"){popups=JSON.parse(JSON.stringify(popups).replace(/extra opdracht(en)?/gi,function(match,plural){var base=plural?"bonusopdrachten":"bonusopdracht";return matchCase(match,base);}).replace(/foto['’]s en filmpjes/gi,function(match){return matchCase(match,"foto's");}).replace(/photos and videos/gi,function(match){return matchCase(match,"Photos");}));console.log("POPUPS",popups);}games=[];if(!((sessionStorage.getItem('token')||auth.getAuthString()).length>15)){_context.next=13;break;}if(window.location.pathname.startsWith('/login')){_context.next=13;break;}_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/game');case 12:games=_context.sent;case 13:Object.keys(data).forEach(function(key){Defines[key]=data[key];});Defines.icons=icons;Defines.gameLogos=games.map(function(game){return{id:game.id,logo:game.Logo?game.Logo.url:"",abbreviation:game.abbreviation};});Defines.gamePageGames=games.filter(function(game){return game.abbreviation!=='BO'&&game.abbreviation!=='SS';});Defines.gameIcons=gameIcons;Defines.position=position;Defines.popupLocations=popupLocations;Defines.popupLocationsDesktop=popupLocationsDesktop;// Fetch popups
Defines.popups=popups;return _context.abrupt('return',data);case 23:case'end':return _context.stop();}}},_callee,this);}));function fetch(){return _ref.apply(this,arguments);}return fetch;}()},{key:'applyLiteOverrides',value:function applyLiteOverrides(){if(!Defines.popups)return;var keys=Object.keys(Defines.popups);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=keys[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var key=_step.value;if(key.endsWith('lite')){var baseKey=key.slice(0,-4);if(Defines.popups[baseKey]){Defines.popups[baseKey]=_extends({},Defines.popups[key]);}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}}]);return Defines;}();/* harmony default export */ __webpack_exports__["a"] = (Defines);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(587);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getPopupDeviceDifficulty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPopupCurrentGame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getNext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getAuto; });
/* unused harmony export getRoute */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return setLocalRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getLocalRead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dispatchUnreadPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllTourPopups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__(9);
var updatePopups=__WEBPACK_IMPORTED_MODULE_1__actions__["a" /* default */].popup.updatePopups;/**
 * Get title from popup
 * @param {string} id
 * @param {string} lang NL || EN
 * @return {string}
 */var getTitle=function getTitle(id,lang){var popup=__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popups[id]||{};return popup['Titel vraagteken '+lang]||popup['Titel vraagteken']||'';};/**
 * Get device info (m or d) & difficulty (h or l)
 * @param {int} diff  1 || 2
 */var getPopupDeviceDifficulty=function getPopupDeviceDifficulty(diff){var device=document.querySelector('#root').clientWidth>=1240?'d':'m';var difficulty=diff===1?'h':'l';return device+difficulty;};/**
 * Get device info (m or d) & difficulty (h or l)
 * @param {int} game
 */var getPopupCurrentGame=function getPopupCurrentGame(game){var gameToCheck=void 0;if(isNaN(parseInt(game,10))){gameToCheck=game.toLowerCase();}else{gameToCheck=parseInt(game,10);}switch(gameToCheck){case 1:case'ss':return'landbesturen';case 2:case'gr':return'ghettoradio';case 3:case'bo':return'extraopdrachten';case 4:case'er':return'escaperoute';case 5:case'fq':return'filmquiz';case 6:case'dt':return'detectives';case 7:case'mf':return'moviefactory';case 8:case'mc':return'makeachange';case 9:case'ht':return'hennatattoos';case 10:case'ar':return'africanadventurerace';case 11:case'tc':return'truecomics';// case 15:
// case 'ts':
//   return 'urlstopsecret';
case 16:case'hl':return'hotlist';case 17:case'sa':return'streetart';case 18:case'wq':return'wordquest';case 19:case'vm':return'votematch';case 20:case'ga':return'guessagain';case 23:case'wa':return'wanted';case 24:case'tr':return'totalrecall';case 25:case'fc':return'factcheck';case 26:case'rm':return'readtheminds';case 27:case'fq2':return'filmquiz2';default:return false;}};/**
 * Get content from popup
 * @param {string} id
 * @param {string} lang  NL || EN
 * @return {string}
 */var getContent=function getContent(id,lang){console.log("ID:",id);var popup=__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popups[id]||{};return(popup['Tekst '+lang]||popup['Tekst']||'').replace(/http(s)?:\/\//g,'//');};/**
 * Get next popup
 * @param {string} id
 * @return {string} next popup id
 */var getNext=function getNext(id){var tutorial=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var popup=__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popups[id]||{};if(tutorial){return popup['Tutorial volgende'];}else{return popup['Volgende'];}};/**
 * Get if popup is auto (show once or more)
 * @param {string} id
 * @return {boolean} is auto or not
 */var getAuto=function getAuto(id){var popup=__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popups[id]||{};return popup['Auto?']!==""&&popup['Auto?']!==undefined?true:false;};/**
 * Get if popup is read
 * @param {string} id
 * @return {boolean} is read or not
 */var getLocalRead=function getLocalRead(id){var localReadJSON=sessionStorage.getItem('localRead')||'{}';var localRead=JSON.parse(localReadJSON);return id in localRead&&localRead[id]?true:false;};/**
 * Get if popup is read
 * @param {string} id
 * @return {boolean} is read or not
 */var dispatchUnreadPopup=function dispatchUnreadPopup(id,dispatch){var closeable=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var desktop=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var isDesktop=document.querySelector('#root').clientWidth>=1240;var popupId=!isDesktop?id:'d'+id.substring(1);if(sessionStorage.getItem('governAsClassleader')==='true'&&getAuto(id)){return false;}if(!getLocalRead(popupId)){dispatch(updatePopups({popupId:popupId,isDesktop:desktop,closeable:closeable,tutorial:true}));return true;}else{return false;}};/**
 * Get location route of popup
 * @param {string} id
 * @return {string} location pathname -or- null if invalid
 */var getRoute=function getRoute(id){var desktop=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var popup=__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popups[id]||{};popup=popup['Locatie'];if(!popup||popup===undefined){//PopupID bestaat niet.
return"/";}var rawLocation=popup.replace(/\s/g,'').toLowerCase();var locations=desktop?__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popupLocationsDesktop:__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popupLocations;if(rawLocation in locations){return locations[rawLocation];}return null;};/**
 * Set localpopup read
 * @param {string} id
 * @return {boolean} success true false
 */var setLocalRead=function setLocalRead(id){var localReadJSON=sessionStorage.getItem('localRead')||'{}';var localRead=JSON.parse(localReadJSON);localRead[id]=true;localReadJSON=JSON.stringify(localRead);sessionStorage.setItem('localRead',localReadJSON);};/**
 * Get next popup
 * @param {string} id
 * @return {int} count of tutorial popups
 */var getAllTourPopups=function getAllTourPopups(id){var tutorial=arguments.length>1&&arguments[1]!==undefined?arguments[1]:true;var total=1;var allPopups=__WEBPACK_IMPORTED_MODULE_0__Defines__["a" /* default */].popups||{};var checkNext=function checkNext(item){if(item){var next=tutorial?item['Tutorial volgende']:item['Volgende'];if(next){total++;return checkNext(allPopups[next]);}else{if(total>1){return total;}return 1;}}else{if(total>1){return total;}return null;}};return checkNext(allPopups[id]);};

/***/ }),
/* 20 */
/***/ (function(module, exports) {

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(290);
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_star_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_beleidskeuze_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_beleidskeuze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_beleidskeuze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_globas_trimmed_png__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_globas_trimmed_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_globas_trimmed_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ramp_png__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ramp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ramp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_disaster_png__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_disaster_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_disaster_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__config__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var ListButton=(_temp=_class=function(_Component){_inherits(ListButton,_Component);function ListButton(props){_classCallCheck(this,ListButton);var _this=_possibleConstructorReturn(this,(ListButton.__proto__||Object.getPrototypeOf(ListButton)).call(this,props));_this.handleClick=function(){if(!_this.props.disabled){_this.props.onClick();}};_this.additionalClasses=_this.props.className;return _this;}_createClass(ListButton,[{key:'addStars',value:function addStars(amount){var stars=[];for(var i=0;i<amount;i++){stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'star',className:'star-icon',key:i,src:__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_star_svg___default.a}));}return stars;}/**
   * @name handleClick
   * @description Method to handle click event
   */},{key:'render',value:function render(){var props=this.props;var schoolClass=props.schoolClass,ministry=props.ministry,gameState=props.gameState,gameStateInput=props.gameStateInput,feedbackItems=props.feedbackItems;var groupBadge=function groupBadge(name,i){var matchedGroup=schoolClass.Groups.find(function(g){return g.GroupTheme.color===name;});if(matchedGroup)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:i,className:'collab-inline-item-badge',src:''+__WEBPACK_IMPORTED_MODULE_13__config___default.a.apiUrl+matchedGroup.GroupTheme.badge,alt:'badge'});};var bgColor=this.props.feedback&&!this.props.read&&this.props.bgColor==='grey'?'white':this.props.bgColor;var difficulty=this.props.project.difficulty.toLowerCase();var unreadCount=this.props.feedbackCount;var _props=this.props,disaster=_props.disaster,hidePoints=_props.hidePoints,points=_props.points;var id="false";if(ministry){id=("scrollto-"+ministry).toLowerCase();bgColor=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["p" /* getMinistryColor */])(difficulty,ministry,gameState,gameStateInput,feedbackItems.prevRoundFeedbackData);unreadCount=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["z" /* getUnreadCount */])(ministry,feedbackItems.prevRoundFeedbackData);disaster=gameState.currentStep===1&&Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["C" /* ministryHasDisaster */])(ministry,feedbackItems);if(gameState.currentRound===1){points=false;hidePoints=true;}}else if(this.props.className.indexOf("total-economy-list-button")>-1){id="scrollto-economy";}else if(this.props.className.indexOf("beleidskeuze-listbutton-laag")>-1){id="scrollto-beleidskeuzes";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:id,onClick:this.handleClick,className:'list-button'+(this.props.disabled?' disabled':'')+' '+bgColor+' '+(this.props.policy?' policy':'')+' '+(this.props.arrow?' arrow':'')+' '+(disaster&&!this.props.hideDisaster?' disaster':'')+' '+(this.props.bigArrow?' big-arrow':'')+' '+this.additionalClasses},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-list-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},this.props.thumbnail!==undefined&&this.props.thumbnail!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Imagio',style:{backgroundImage:'url('+this.props.thumbnail+')'}},this.props.icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:this.props.icon}):null):this.props.icon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:this.props.icon}):null,unreadCount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-count'+(this.props.redNotification?' red':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,unreadCount))):'',this.props.checked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'check',src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg___default.a}):''),this.props.feedback?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block title-feedback'+(this.props.read===undefined||!this.props.read?" unread":"")},this.props.popupId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PopupTitle__["a" /* default */],{popupId:this.props.popupId,tag:'h4'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:this.props.hideOverflow?"hide-overflow":""},this.props.title.charAt(0).toUpperCase()+this.props.title.slice(1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:this.props.desc}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},gameState.difficulty==='PRO'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stars-container'},this.addStars(this.props.stars)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:this.props.hideOverflow?"hide-overflow":""},this.props.global?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'globalIcon',className:'global-icon',src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_global_svg___default.a}):'',' ',this.props.title),this.props.popupId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PopupTitle__["a" /* default */],{onlyQ:true,popupId:this.props.popupId}):null,this.props.subtitle.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'subtitle'},this.props.subtitle):null),this.props.budgetSet||this.props.policySet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policy-img'},this.props.budgetSet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_globas_trimmed_png___default.a,className:'budget-flag',alt:'Budget'}):'',this.props.policySet?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_beleidskeuze_png___default.a,className:'policy-flag',alt:'Policy'}):''):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'point-holder '+(this.props.reverseGlobasPoints?'reverse':'')},this.props.globas!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:this.props.globas<0?'- '+Math.abs(this.props.globas):this.props.globas},this.props.globas<0?'- '+Math.abs(this.props.globas):this.props.globas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard'))):'',points!==undefined&&points!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,this.props.dashForZero?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:points==='+0'||points==='-0'?'-':points},points==='+0'||points==='-0'?'-':points):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:points<0?'- '+Math.abs(points):points},points<0?'- '+Math.abs(points):points),this.props.isGlobas!==undefined&&this.props.isGlobas!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten')},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))):'',points===undefined&&hidePoints===undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'placeholder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:'0'},'0'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten')},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))):''),this.props.collaboration?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collab-icons'},this.props.collaboration.map(function(group,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},groupBadge(group,i));})):null,disaster&&!this.props.hideDisaster?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'disaster-icon',src:this.props.gameState.language==="NL"?__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_ramp_png___default.a:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_disaster_png___default.a,alt:'disaster'}):null,this.props.arrow||this.props.bigArrow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'arrow-block'}):'',this.props.children?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policy-data'},this.props.children):''));}}]);return ListButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={opacity:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,bgColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,ministry:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,subtitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,reverseGlobasPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={reverseGlobasPoints:false,opacity:false,bgColor:'',className:'',disabled:false,subtitle:'',hideDisaster:false,onClick:function onClick(){}},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var schoolClass=_ref.schoolClass,gameState=_ref.gameState,gameStateInput=_ref.gameStateInput,feedback=_ref.feedback,project=_ref.project;return{schoolClass:schoolClass,gameState:gameState,gameStateInput:gameStateInput,feedbackItems:feedback,project:project};})(ListButton));

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(122)["default"];
function _interopRequireWildcard(e, t) {
  if ("function" == typeof WeakMap) var r = new WeakMap(),
    n = new WeakMap();
  return (module.exports = _interopRequireWildcard = function _interopRequireWildcard(e, t) {
    if (!t && e && e.__esModule) return e;
    var o,
      i,
      f = {
        __proto__: null,
        "default": e
      };
    if (null === e || "object" != _typeof(e) && "function" != typeof e) return f;
    if (o = t ? n : r) {
      if (o.has(e)) return o.get(e);
      o.set(e, f);
    }
    for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]);
    return f;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports)(e, t);
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_close_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var desktop=document.querySelector('#root').clientWidth>=1240;var GoBackButton=(_temp=_class=function(_Component){_inherits(GoBackButton,_Component);function GoBackButton(props){_classCallCheck(this,GoBackButton);var _this=_possibleConstructorReturn(this,(GoBackButton.__proto__||Object.getPrototypeOf(GoBackButton)).call(this,props));_this.handlePolicyPopup=function(){var polChoicesToMake=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_policyChoiceHelper__["a" /* choicesToMake */])(_this.props.policyChoice,_this.props.gameStateInput.myState.policyChoices,_this.props.project.minPolicyChoices);if(polChoicesToMake>0){_this.setState({showPopup:true,popupId:'mlgmstap3beleidskeuzes'});}else{_this.goBack(null,true);}};_this.closePopup=function(answer){_this.setState({showPopup:false,popupId:null});if(!answer){_this.goBack(null,true);}};_this.state={showPopup:false,popupId:null};_this.goBack=_this.goBack.bind(_this);return _this;}_createClass(GoBackButton,[{key:"goBack",value:function goBack(ev){var accepted=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(this.props.gameState.activatedStep===3&&this.props.project.difficulty==='BASIC'&&__WEBPACK_IMPORTED_MODULE_4__history__["a" /* default */].location.pathname.startsWith('/beleidskeuzes')){if(!accepted){this.handlePolicyPopup();}else{if(sessionStorage.getItem('toMin')==="list"){this.props.history.push('/ministries');}else{this.props.history.push('/');}}return;}if(__WEBPACK_IMPORTED_MODULE_4__history__["a" /* default */].location.pathname.startsWith('/bank')){var target=sessionStorage.getItem('prevLocation');if(target){this.props.history.push(target);return;}}if(typeof this.props.onClick==='function'){if(this.props.onClick()){return;}}if(this.props.closeWindow){window.close();return;}var path=this.props.history.location.pathname;if(this.props.customHandler){this.props.customHandler();return;}if(this.props.forceLocation){this.props.history.push(this.props.forceLocation);}else if(desktop&&path.indexOf('portal')===-1){this.props.history.push('/');}else if(path.indexOf('bank')!==-1){this.props.history.push(window.sessionStorage.getItem('prevLocation'));}else{this.props.history.goBack();}}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:this.goBack,className:"close-button"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"close-icon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_1__assets_img_close_png___default.a,height:"15",alt:""}))),this.state.showPopup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PopUp__["a" /* default */],{id:this.state.popupId,closePopUpClick:function closePopUpClick(res){_this2.closePopup(res);}}):null);}}]);return GoBackButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}).isRequired,closeWindow:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,customHandler:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func},_class.defaultProps={closeWindow:false,forceLocation:false,customHandler:null},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function(_ref){var policyChoice=_ref.policyChoice,gameStateInput=_ref.gameStateInput,project=_ref.project,feedback=_ref.feedback,gameState=_ref.gameState;return{policyChoice:policyChoice,gameStateInput:gameStateInput,project:project,feedback:feedback,gameState:gameState};})(GoBackButton));

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(122)["default"];
var assertThisInitialized = __webpack_require__(26);
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return assertThisInitialized(t);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

function _getPrototypeOf(t) {
  return module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _getPrototypeOf(t);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(811);
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && setPrototypeOf(t, e);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(405);
/* unused harmony reexport BrowserRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(410);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(196);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(411);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(413);
/* unused harmony reexport NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(415);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(197);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(419);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(423);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(424);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getProbleemTekst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getOplossingTekst; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getOplossingTitle; });
/* unused harmony export getChosenSolutionByCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return getTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return groupByProblem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return policiesForMinisterie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getSelectedPolicyChoicesCount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getOplossingen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getSolutionByCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return getTotalCosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return choicesToMake; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_assets__ = __webpack_require__(8);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function policiesForMinisterie(pols,min){return pols.filter(function(p){return p.ministerie===min;});}/**
 * Get a count for the selected policy choices
 * @param {object} [policyChoices={}] - policyChoices from reducer (state.policyChoices)
 * @return {number} Selected policy choices count
 */function getSelectedPolicyChoicesCount(){var policyChoices=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return Object.values(policyChoices).reduce(function(acc,o){return acc+(o.selected?1:0);},0);}function getIcon(beleidskeuze){return __WEBPACK_IMPORTED_MODULE_0__assets_assets__["b" /* beleidskeuzes */][beleidskeuze.Nummer||beleidskeuze.nummer];}function getTitle(beleidskeuze){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';return beleidskeuze['titel_probleem_'+lang]||'';}function getOplossingTitle(beleidskeuze){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';return beleidskeuze['titel_oplossing_'+lang]||'';}function getImage(beleidskeuze){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';return beleidskeuze['afbeelding_'+lang]||beleidskeuze.img;}function getProbleemTekst(beleidskeuze){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';return beleidskeuze['tekst_probleem_'+lang]||'';}function getOplossingTekst(beleidskeuze){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';return beleidskeuze['tekst_oplossing_'+lang]||'';}function getOplossingen(beleidskeuzes,nummer){var lang=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'NL';return beleidskeuzes.filter(function(bk){return bk.Nummer===nummer;}).map(function(bk){return{id:bk.oplossing_code,titel:bk['titel_oplossing_'+lang]||'',tekst:bk['tekst_oplossing_'+lang]||'',kosten:bk.kosten_globas||0};});}function getChosenSolutionByCode(beleidskeuzes,myPolicyChoices,nummer){var lang=arguments.length>3&&arguments[3]!==undefined?arguments[3]:'NL';return beleidskeuzes.filter(function(bk){return bk.Nummer===nummer;}).map(function(bk){return{id:bk.oplossing_code,titel:bk['titel_oplossing_'+lang]||'',tekst:bk['tekst_oplossing_'+lang]||'',kosten:bk.kosten_globas||0};});}function getSolutionByCode(code,choices){var lang=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'NL';var solution=choices.find(function(c){return c.oplossing_code===code;});if(solution){return{id:solution.oplossing_code,titel:solution['titel_oplossing_'+lang]||'',tekst:solution['tekst_oplossing_'+lang]||'',kosten:solution.kosten_globas||0};}return false;}function getTotalCosts(){var input=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var policyChoices=arguments[1];return Object.values(input).reduce(function(total,code){var solution=getSolutionByCode(code,policyChoices);if(solution){total+=solution.kosten;}return total;},0);}function groupByProblem(){var beleidskeuzes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var grouped=[];beleidskeuzes.forEach(function(pc){var exists=grouped.find(function(fpc){return fpc.Nummer===pc.Nummer;});if(!exists){grouped.push(_extends({},pc));}});return grouped;}function choicesToMake(){var beleidskeuzes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var input=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var minPolicyChoices=arguments.length>2&&arguments[2]!==undefined?arguments[2]:3;var choicesMade=Object.keys(input).reduce(function(total,key){return total+=input[key]?1:0;},0);var toMake=minPolicyChoices-choicesMade;if(toMake>0){return toMake;}return 0;}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(396);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 33 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return calculateBudgetPRO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return calculateSavingsAndLoans; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calculateBudgetBASIC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getMinistryGlobasSpent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getGlobasSpent; });
/* unused harmony export getTotalPoints */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bankHelper__ = __webpack_require__(84);
/**
 * PRO Method to calculate the spendable budget (globas)
 * @param {object} [totalGameStateSum={}] - totalGameStateSum object from gameState reducer (state.gameState.totalGameStateSum)
 * @param {object} [policyChoices={}] - policyChoices object from reducer (state.policyChoices)
 * @param {object} [ministryGlobaDivision={}] - ministerieGlobaVerdeling object from gameStateInput reducer (state.gameStateInput.myState.ministerieGlobaVerdeling)
 * @param {number} [savingAndLonas=0] - Total of savings and lonas to be added to the budget sum (!! USE calculateSavingsAndLoans method in calculationsHelper)
 * @return {number} budget (globas)
 */function calculateBudgetPRO(gameState,gameStateInput){var policyChoices=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var ministryGlobaDivision=arguments.length>3&&arguments[3]!==undefined?arguments[3]:{};var savingsAndLoans=arguments.length>4&&arguments[4]!==undefined?arguments[4]:0;var totalGameStateSum=gameState.totalGameStateSum,history=gameState.history;var globas=totalGameStateSum.globas;if(history)return globas;// Add policy choice costs to budget globas
globas-=Object.values(policyChoices).reduce(function(acc,o){return acc+o.globas;},0);// Add ministry globa devision cost to budget globas
globas-=Object.values(ministryGlobaDivision).filter(function(i){return parseInt(i,10);}).reduce(function(acc,i){return acc+i;},0);// Add loans and savings to globas budget sum
globas+=savingsAndLoans;return globas;}/**
 * PRO Calculate savings and loans sum
 * @param {object} myState - myState object from gameStateInput reducer (state.gameStateInput.myState)
 * @param {array<object>} [schoolClasses=[]] - SchoolClasses array from project reducer (state.project.SchoolClasses)
 * @return {number} Total sum of savings and loans
 */function calculateSavingsAndLoans(gameStateInput){if(gameStateInput===undefined)return;var saveLoanOverview=Object(__WEBPACK_IMPORTED_MODULE_1__bankHelper__["b" /* getOverview */])(gameStateInput);var plus=saveLoanOverview[0].items[0].items.reduce(function(accumilator,current){if(!current.pending&&!isNaN(parseFloat(current.points))){accumilator+=current.points;}return accumilator;},0);var min=saveLoanOverview[0].items[1].items.reduce(function(accumilator,current){if(!isNaN(parseFloat(current.points))){if(current.key==='lenenAanLand'&&current.pending===true){return accumilator;}accumilator+=current.points;}return accumilator;},0);return plus-min;}/**
 * BASIC Method to calculate the spendable budget (globas)
 * @param {object} [totalGameStateSum={}] - totalGameStateSum object from gameState reducer (state.gameState.totalGameStateSum)
 * @param {object} [policyChoices={}] - policyChoices object from reducer (state.policyChoices)
 * @param {object} [ministryGlobaDivision={}] - ministerieGlobaVerdeling object from gameStateInput reducer (state.gameStateInput.myState.ministerieGlobaVerdeling)
 * @param {number} [savingAndLonas=0] - Total of savings and lonas to be added to the budget sum (!! USE calculateSavingsAndLoans method in calculationsHelper)
 * @return {number} budget (globas)
 */function calculateBudgetBASIC(_ref){var totalGameStateSum=_ref.totalGameStateSum,history=_ref.history;var policyChoices=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var ministryGlobaDivision=arguments.length>2&&arguments[2]!==undefined?arguments[2]:{};var savingsAndLoans=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0;var beleidskeuzes=arguments.length>4&&arguments[4]!==undefined?arguments[4]:[];var globas=totalGameStateSum.globas;if(history)return globas;// @todo Add policy choice costs to budget globas
globas-=Object(__WEBPACK_IMPORTED_MODULE_0__policyChoiceHelper__["k" /* getTotalCosts */])(policyChoices,beleidskeuzes);// Add ministry globa devision cost to budget globas
globas-=Object.values(ministryGlobaDivision).filter(function(i){return parseInt(i,10);}).reduce(function(acc,i){return acc+i;},0);// Add loans and savings to globas budget sum
globas+=savingsAndLoans;return globas;}/**
 * Calculate spent globas on ministry (this round)
 * @param {Object} ministerieGlobaVerdeling
 * @param {string} ministry
 * @param {number} currentStep
 * @param {Object[]} policyChoices
 * @returns {number} total cost
 */function getMinistryGlobasSpent(ministerieGlobaVerdeling,ministry,currentStep,policyChoices){var pcsCosts=0;if(Array.isArray(policyChoices)){pcsCosts=policyChoices.filter(function(pc){return pc.ministry===ministry;}).reduce(function(cost,pc){return cost+=pc.globas||0;},0);}if(currentStep===3){return(ministerieGlobaVerdeling[ministry]||0)+pcsCosts;}return;}function getGlobasSpent(gameStateInput){var beleidskeuzes=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var spent=0;if(gameStateInput.myState.niveau==='Pro'){spent+=Object.values(gameStateInput.myState.policyChoices).reduce(function(acc,o){return acc+o.globas;},0);// Add ministry globa devision cost to budget globas
spent+=Object.values(gameStateInput.myState.ministerieGlobaVerdeling).filter(function(i){return parseInt(i,10);}).reduce(function(acc,i){return acc+i;},0);}else if(gameStateInput.myState.niveau==='Basic'){spent+=Object(__WEBPACK_IMPORTED_MODULE_0__policyChoiceHelper__["k" /* getTotalCosts */])(gameStateInput.myState.policyChoices,beleidskeuzes);// Add ministry globa devision cost to budget globas
spent+=Object.values(gameStateInput.myState.ministerieGlobaVerdeling).filter(function(i){return parseInt(i,10);}).reduce(function(acc,i){return acc+i;},0);}spent-=calculateSavingsAndLoans(gameStateInput);return spent;}function getTotalPoints(group){return group.Rounds.reduce(function(points,round){points+=round.earnedPoints||0;if(Array.isArray(round.GameStates)){points+=round.GameStates.reduce(function(p,gs){p+=gs.points;return p;},0);}return points;},0);}

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__history_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_save_svg__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_save_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_save_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_bankHelper__ = __webpack_require__(84);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var desktop=false;if(document.querySelector('#root').clientWidth>=1240){desktop=true;}var _actions$gameStateInp=__WEBPACK_IMPORTED_MODULE_6__actions__["a" /* default */].gameStateInput,submitMyState=_actions$gameStateInp.submitMyState,updateMyState=_actions$gameStateInp.updateMyState;var NextStep=(_temp=_class=function(_Component){_inherits(NextStep,_Component);function NextStep(props){_classCallCheck(this,NextStep);var _this=_possibleConstructorReturn(this,(NextStep.__proto__||Object.getPrototypeOf(NextStep)).call(this,props));_this.togglePopUp=function(){if(!_this.unlocked){_this.setState({showPopUp:!_this.state.showPopUp});}};_this.handleClick=function(){var gameState=_this.props.gameState;if(!_this.unlocked){_this.togglePopUp();return;}_this.props.dispatch(updateMyState({activatedStep:gameState.currentStep+=1}));// window.location.reload();
};_this.getDescription=function(){var _this$props=_this.props,gameState=_this$props.gameState,feedback=_this$props.feedback,project=_this$props.project;var unreadCount=_this.unreadFeedback(feedback.prevRoundFeedbackData.concat(feedback.feedbackData),gameState.currentStep);var message={desc:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_pas_verder_met_stap_warning_part_1')+' '+(gameState.currentStep+1)+' '+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_pas_verder_met_stap_warning_part_2')};if(gameState.currentStep+1===2){message={id:'dhgmstap2'};if(unreadCount>0){return{id:'dhgmstap2_2'};}}else if(gameState.currentStep+1===3){console.log(gameState,unreadCount);if(unreadCount>0||gameState.roundData.state.startsWith('SIMULATION_TAX')){return{id:project.difficulty==='PRO'?'dhgmstap3':'dlgmstap3'};}else{return{id:project.difficulty==='PRO'?'dhgmstap3_2':'dlgmstap3_2'};}}return message;};_this.allowSave=function(){var _this$props2=_this.props,gameState=_this$props2.gameState,gameStateInput=_this$props2.gameStateInput,policyChoice=_this$props2.policyChoice;//Min policy cost
var problems=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["l" /* groupByProblem */])(policyChoice);var minChoices=_this.props.project.minPolicyChoices;var minGlb=0;for(var i=0;i<minChoices;i++){if(!problems||!problems[i])continue;minGlb+=Math.min.apply(Math,_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["f" /* getOplossingen */])(policyChoice,problems[i].Nummer,gameState.language).map(function(c){return parseInt(c.kosten,10);})))||null;}//Startbudget
var budget=gameState.totalGameStateSum.globas+Object(__WEBPACK_IMPORTED_MODULE_12__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,[]);if(minGlb>budget&&minGlb!==0){return true;}if(gameState.difficulty==='BASIC'&&Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,gameStateInput.myState.policyChoices,_this.props.project.minPolicyChoices)>0){return false;}return true;};_this.getSaveButton=function(desktop){var _this$props3=_this.props,gameState=_this$props3.gameState,policyChoice=_this$props3.policyChoice,gameStateInput=_this$props3.gameStateInput;var myState=gameStateInput.myState;if(!myState)return null;var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);if(_this.props.gameState.difficulty==="PRO"){//Pro
var globas=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["b" /* calculateBudgetPRO */])(gameState,gameStateInput,myState.policyChoices,ministerieGlobaVerdeling,savingsAndLoans);if(gameState.currentStep===3&&gameState.roundData.state==='SIMULATION_SPENDING'&&myState.SIMULATION_SPENDING!=='PROCESSED'){if(desktop){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonWrap desktop'},_this.props.user.role==='groupleader'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){ev.preventDefault();if(globas>0){_this.setState({showWarningId:'dhgmstap3verdelingopslaan'});return;}// @todo conditional
if(globas<=0&&_this.props.user.role==='groupleader'&&!gameStateInput.preventInputChanges){_this.props.dispatch(submitMyState('SIMULATION_SPENDING'));}},className:'main-save-button button'+(globas<=0&&!gameStateInput.preventInputChanges?'':' disabled pointer-events')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_verdling_opslaan_button'))):null);}else{if(window.location.pathname!=='/'||_this.props.user.role!=='groupleader')return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-next-step saveStep '+(globas<=0&&!gameStateInput.preventInputChanges?'':' inactive disabled pointer-events')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'triangle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stepcircle',onClick:function onClick(ev){ev.preventDefault();if(globas>0){_this.setState({showWarningId:'dhgmstap3verdelingopslaan'});return;}// @todo conditional
if(globas<=0&&_this.props.user.role==='groupleader'&&!gameStateInput.preventInputChanges){_this.props.dispatch(submitMyState('SIMULATION_SPENDING'));}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle-bg save'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_img_save_svg___default.a,alt:'Save'}))));}}}else{//Basic
var _globas=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,myState.policyChoices,ministerieGlobaVerdeling,savingsAndLoans,policyChoice);if(gameState.currentStep===3&&gameState.roundData.state==='SIMULATION_SPENDING'&&myState.SIMULATION_SPENDING!=='PROCESSED'){if(desktop){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonWrap desktop'},_this.props.user.role==='groupleader'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){ev.preventDefault();if(_globas>0){_this.setState({showWarningId:'dlgmstap3verdelingopslaan'});return;}if(_globas<=0&&!_this.allowSave()){_this.setState({showWarningId:'dlgmstap3verdelingopslaan_1'});return;}// @todo conditional
if(_globas<=0&&_this.allowSave()&&_this.props.user.role==='groupleader'&&!gameStateInput.preventInputChanges){_this.props.dispatch(submitMyState('SIMULATION_SPENDING'));}},className:'main-save-button button'+(_globas<=0&&_this.allowSave()&&!gameStateInput.preventInputChanges?'':' disabled pointer-events')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_verdling_opslaan_button'))):null);}else{if(window.location.pathname!=='/'||_this.props.user.role!=='groupleader')return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'footer-next-step saveStep '+(_globas<=0&&_this.allowSave()&&!gameStateInput.preventInputChanges?'':' inactive disabled pointer-events')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'triangle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stepcircle',onClick:function onClick(ev){ev.preventDefault();if(_globas>0){_this.setState({showWarningId:'dlgmstap3verdelingopslaan'});return;}if(_globas<=0&&!_this.allowSave()){_this.setState({showWarningId:'dlgmstap3verdelingopslaan_1'});return;}// @todo conditional
if(_globas<=0&&_this.allowSave()&&_this.props.user.role==='groupleader'&&!gameStateInput.preventInputChanges){_this.props.dispatch(submitMyState('SIMULATION_SPENDING'));}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle-bg save'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_img_save_svg___default.a,alt:'Save'}))));}}}return null;};_this.state={showPopUp:false,showWarning:'',showWarningId:''};_this.togglePopUp=_this.togglePopUp.bind(_this);return _this;}// Getter to check if next step is available
_createClass(NextStep,[{key:'unreadFeedback',value:function unreadFeedback(){var _this2=this;var feedback=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var currentStep=arguments[1];return feedback.reduce(function(count,fb){if(currentStep===1){if(fb.type!=='BELASTING'){count+=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["d" /* checkRead */])(fb)?0:1;}fb.overigeEffecten.forEach(function(oe,i){if(!Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["d" /* checkRead */])(fb,true,i)){count+=1;}});}if(fb.economie||fb.type==='BELASTING'){if(!Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["d" /* checkRead */])(fb,false,0,_this2.props.gameState.currentStep!==2&&fb.economie)){count+=1;}}return count;},0);}},{key:'render',value:function render(){var _this3=this;var showPopUp=this.state.showPopUp;var gameState=this.props.gameState;if(!gameState.loaded||gameState.currentRound>4){//Terug naar startscherm button
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"footer-next-step footer-next-step--portal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(){return __WEBPACK_IMPORTED_MODULE_4__history_js__["a" /* default */].push('/portal');}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_terug_naar_startscherm"))));};if(gameState.currentStep>=3){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.getSaveButton(desktop),this.state.showWarning.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(this.state.showWarning),closePopUpClick:function closePopUpClick(){return _this3.setState({showWarning:''});}}):null,this.state.showWarningId.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_warning_svg___default.a,popUpFooter:true,id:this.state.showWarningId,closePopUpClick:function closePopUpClick(){return _this3.setState({showWarningId:''});}}):null);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"footer-next-step"+(this.unlocked?'':' inactive')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'triangle'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stepcircle',onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_stap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,gameState.currentStep+1))))),showPopUp&&!this.unlocked?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{popUpFooter:true,id:this.getDescription().id?this.getDescription().id:undefined,description:this.getDescription().desc?this.getDescription().desc:undefined,closePopUpClick:this.togglePopUp}):null);}},{key:'unlocked',get:function get(){var _props=this.props,gameState=_props.gameState,feedback=_props.feedback,unlocked=_props.unlocked,gameStateInput=_props.gameStateInput;var unreadCount=this.unreadFeedback(feedback.prevRoundFeedbackData.concat(feedback.feedbackData),gameState.currentStep);if(gameState.activatedStep===2&&!gameState.roundData.step3Active){return false;}return!gameStateInput.preventInputChanges&&unlocked&&gameState.nextStepUnlocked&&unreadCount===0;}}]);return NextStep;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={unlocked:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool},_class.defaultProps={unlocked:true},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{gameState:state.gameState,gameStateInput:state.gameStateInput,feedback:state.feedback,user:state.user,project:state.project,policyChoice:state.policyChoice};})(NextStep));

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(108);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(880);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(884);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(108);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_TopBar__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GameTopBar__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_TitleBar__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepThree_BudgetHeader__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_i18n_for_browser__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Header=(_temp=_class=function(_Component){_inherits(Header,_Component);function Header(props){_classCallCheck(this,Header);var _this=_possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).call(this,props));_this.state={};return _this;}_createClass(Header,[{key:'render',value:function render(){var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,props.desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{history:this.props.history},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_TopBar__["a" /* default */],null),this.props.showTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"desktop-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"desktop-title-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_TitleBar__["a" /* default */],null))):null,this.props.showGameTopBar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GameTopBar__["a" /* default */],{match:this.props.match,history:this.props.history,buttonType:this.props.buttonType,viewType:this.props.viewType}):null,this.props.showBudget?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StepThree_BudgetHeader__["a" /* default */],{history:this.props.history,desktop:this.props.desktop}):null),this.props.historic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'historic'}):null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{history:this.props.history},this.props.showGameTopBar?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GameTopBar__["a" /* default */],{match:this.props.match,history:this.props.history,buttonType:this.props.buttonType,viewType:this.props.viewType}):null,this.props.showTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_TitleBar__["a" /* default */],null):null,this.props.showBudget?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StepThree_BudgetHeader__["a" /* default */],{history:this.props.history,desktop:this.props.desktop}):null),this.props.historic?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'historic'}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ministry-popup-container'},['SUBMITTED','PROCESSED'].includes(props.gameStateInput.myState.SIMULATION_SPENDING)&&!props.gameState.history?this.props.gameState.currentRound===4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_8_i18n_for_browser__["a" /* __ */])('sim_verdeling_opgeslagen'),hideClose:true,id:props.gameStateInput.myState.forceUpdate?'dlgmstap3verdelingopslaan_4':'dlgmstap3verdelingopslaan_3',closePopUpClick:function closePopUpClick(){window.location.href='/portal';},customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_8_i18n_for_browser__["a" /* __ */])('sim_terug_naar_startscherm'),action:function action(){window.location.href='/portal';}}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_8_i18n_for_browser__["a" /* __ */])('sim_verdeling_opgeslagen'),hideClose:true,id:props.gameStateInput.myState.forceUpdate?'dlgmstap3verdelingopslaan_4':'dlgmstap3verdelingopslaan_2',closePopUpClick:function closePopUpClick(){window.location.href='/portal';},customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_8_i18n_for_browser__["a" /* __ */])('sim_terug_naar_startscherm'),action:function action(){window.location.href='/portal';}}}):null));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={dispatch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,buttonType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,viewType:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,showTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,showGameTopBar:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool},_class.defaultProps={showTitle:true,desktop:false,showGameTopBar:true,showBudget:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref){var gameState=_ref.gameState,gameStateInput=_ref.gameStateInput;return{gameState:gameState,gameStateInput:gameStateInput};})(Header));

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(876);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Require classes
 */
var HttpRequest = __webpack_require__(520);
var Authorization = __webpack_require__(521);

/** 
 * Require utilities
*/
var cookie = __webpack_require__(163);
var date = __webpack_require__(522);
var validation = __webpack_require__(524);

module.exports = {
  cookie: cookie,
  date: date,
  validation: validation,
  HttpRequest: HttpRequest,
  Authorization: Authorization
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/min-globas.7e301037.svg";

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/up-globas.3bd0b487.svg";

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DifficultyAwareComponent=function(_React$Component){_inherits(DifficultyAwareComponent,_React$Component);function DifficultyAwareComponent(){_classCallCheck(this,DifficultyAwareComponent);return _possibleConstructorReturn(this,(DifficultyAwareComponent.__proto__||Object.getPrototypeOf(DifficultyAwareComponent)).apply(this,arguments));}_createClass(DifficultyAwareComponent,[{key:'render',value:function render(){if(!this.props.project)console.warn('Redux state `project` is required for difficulty aware rendering');if(!this.props.project||this.props.project.difficulty==="PRO")return this.renderHoog();return this.renderLaag();}},{key:'renderHoog',value:function renderHoog(){console.error('Difficulty aware rendering is not implemented in extended component.');}},{key:'renderLaag',value:function renderLaag(){console.error('Difficulty aware rendering is not implemented in extended component.');}}]);return DifficultyAwareComponent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (DifficultyAwareComponent);

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _bowser = _interopRequireDefault(__webpack_require__(399));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _NativeScrollbar = _interopRequireDefault(__webpack_require__(400));

var _Thumb = _interopRequireDefault(__webpack_require__(401));

var _Track = _interopRequireWildcard(__webpack_require__(195));

var _getInnerSizes = __webpack_require__(402);

var _getScrollbarWidth = _interopRequireDefault(__webpack_require__(403));

var _LoopController = _interopRequireDefault(__webpack_require__(404));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var browser = global.window && global.window.navigator && _bowser.default.getParser(global.window.navigator.userAgent);

var engine = browser && browser.getEngine().name;
var defaultStyles = {
  holder: {
    position: "relative",
    display: "flex"
  },
  wrapper: {
    flexGrow: 1
  },
  content: {
    position: "absolute",
    top: 0,
    bottom: 0,
    right: 0,
    left: 0
  },
  track: {
    common: {
      position: "absolute",
      overflow: "hidden",
      borderRadius: 4,
      background: "rgba(0,0,0,.1)",
      userSelect: "none"
    },
    x: {
      height: 8,
      width: "calc(100% - 16px)",
      bottom: 0,
      left: 8
    },
    y: {
      width: 8,
      height: "calc(100% - 16px)",
      top: 8
    }
  },
  thumb: {
    common: {
      cursor: "pointer",
      borderRadius: 4,
      background: "rgba(0,0,0,.4)"
    },
    x: {
      height: "100%"
    },
    y: {
      width: "100%"
    }
  }
};
/**
 * @typedef {object} ScrollValues
 *
 * @property {number|null} clientHeight - content's native clientHeight parameter
 * @property {number|null} clientWidth - content's native clientWidth parameter
 * @property {number|null} scrollHeight - content's native scrollHeight parameter
 * @property {number|null} scrollWidth - content's native scrollWidth parameter
 * @property {number|null} scrollTop - content's native scrollTop parameter
 * @property {number|null} scrollLeft - content's native scrollLeft parameter
 * @property {boolean|null} scrollYBlocked - Indicates whether vertical scroll blocked via properties
 * @property {boolean|null} scrollXBlocked - Indicates whether horizontal scroll blocked via properties
 * @property {boolean|null} scrollYPossible - Indicates whether the content overflows vertically and scrolling not blocked
 * @property {boolean|null} scrollXPossible - Indicates whether the content overflows horizontally and scrolling not blocked
 * @property {boolean|null} trackYVisible - Indicates whether vertical track is visible
 * @property {boolean|null} trackXVisible - Indicates whether horizontal track is visible
 * @property {boolean|null} isRtl - Indicates whether display direction is right-to-left
 */

var Scrollbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Scrollbar, _React$Component);

  _createClass(Scrollbar, null, [{
    key: "computeThumbSize",

    /**
     * Compute the thumb size
     *
     * @param {number} trackSize
     * @param {number} scrollableSize
     * @param {number} viewportSize
     * @param {number} minimalSize
     * @return {number}
     */
    value: function computeThumbSize(trackSize, scrollableSize, viewportSize, minimalSize) {
      var size = Math.ceil(viewportSize / scrollableSize * trackSize) || 0;
      return trackSize === size ? 0 : Math.max(size, minimalSize);
    }
    /**
     * Compute the thumb offset from scroll value
     *
     * @param {number} trackSize
     * @param {number} thumbSize
     * @param {number} scrollableSize
     * @param {number} viewportSize
     * @param {number} scrollValue
     * @return {number}
     */

  }, {
    key: "computeThumbOffset",
    value: function computeThumbOffset(trackSize, thumbSize, scrollableSize, viewportSize, scrollValue) {
      return thumbSize && scrollValue / (scrollableSize - viewportSize) * (trackSize - thumbSize) || 0;
    }
    /**
     * Compute the scroll value depending on thumb offset
     *
     * @param {number} trackSize
     * @param {number} thumbSize
     * @param {number} offset
     * @param {number} scrollableSize
     * @param {number} viewportSize
     * @return {number}
     */

  }, {
    key: "computeScrollForOffset",
    value: function computeScrollForOffset(trackSize, thumbSize, offset, scrollableSize, viewportSize) {
      return (offset - thumbSize / 2) / (trackSize - thumbSize) * (scrollableSize - viewportSize) || 0;
    }
  }]);

  function Scrollbar(props) {
    var _this;

    _classCallCheck(this, Scrollbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Scrollbar).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleScrollEvent", function () {
      _this.scrollDetect();
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "scrollDetect", function () {
      if (!_this.props.onScrollStart && !_this.props.onScrollStop) {
        return;
      }

      !_this.scrollDetect.timeout && _this.props.onScrollStart && _this.props.onScrollStart.call(_assertThisInitialized(_assertThisInitialized(_this)), _this.getScrollValues());
      _this.scrollDetect.timeout && clearTimeout(_this.scrollDetect.timeout);
      _this.scrollDetect.timeout = setTimeout(function () {
        _this.scrollDetect.timeout = null;
        _this.props.onScrollStop && _this.props.onScrollStop.call(_assertThisInitialized(_assertThisInitialized(_this)), _this.getScrollValues());
      }, _this.props.scrollDetectionThreshold);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "update", function () {
      var forced = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      // autodetect direction if not defined
      if (typeof _this.state.isRtl !== "boolean") {
        _this.setState({
          isRtl: getComputedStyle(_this.contentEl).direction === "rtl"
        });

        return _this.getScrollValues();
      }

      var scrollValues = _this.getScrollValues(true),
          prevScrollValues = _this.getScrollValues();

      var bitmask = 0; // calculating bitmask

      prevScrollValues.clientHeight !== scrollValues.clientHeight && (bitmask |= 1 << 0);
      prevScrollValues.clientWidth !== scrollValues.clientWidth && (bitmask |= 1 << 1);
      prevScrollValues.scrollHeight !== scrollValues.scrollHeight && (bitmask |= 1 << 2);
      prevScrollValues.scrollWidth !== scrollValues.scrollWidth && (bitmask |= 1 << 3);
      prevScrollValues.scrollTop !== scrollValues.scrollTop && (bitmask |= 1 << 4);
      prevScrollValues.scrollLeft !== scrollValues.scrollLeft && (bitmask |= 1 << 5);
      prevScrollValues.scrollYBlocked !== scrollValues.scrollYBlocked && (bitmask |= 1 << 6);
      prevScrollValues.scrollXBlocked !== scrollValues.scrollXBlocked && (bitmask |= 1 << 7);
      prevScrollValues.scrollYPossible !== scrollValues.scrollYPossible && (bitmask |= 1 << 8);
      prevScrollValues.scrollXPossible !== scrollValues.scrollXPossible && (bitmask |= 1 << 9);
      prevScrollValues.trackYVisible !== scrollValues.trackYVisible && (bitmask |= 1 << 10);
      prevScrollValues.trackXVisible !== scrollValues.trackXVisible && (bitmask |= 1 << 11);
      prevScrollValues.isRtl !== scrollValues.isRtl && (bitmask |= 1 << 12); // if not forced and nothing has changed - skip this step

      if (bitmask === 0 && !forced) {
        return prevScrollValues;
      } // if updater return true - call callbacks and cache the scroll values


      if ((_this.props.native ? _this.updaterNative : _this.updaterCustom).call(_assertThisInitialized(_assertThisInitialized(_this)), scrollValues, prevScrollValues, bitmask)) {
        _this.scrollValues = scrollValues;
        prevScrollValues.scrollTop !== null && _this.props.onScroll && _this.props.onScroll(scrollValues, prevScrollValues);
      }

      return prevScrollValues;
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTrackClick", function (e, params) {
      params.axis === _Track.TYPE_X && _this.props.trackXProps.onClick && _this.props.trackXProps.onClick(e, params);
      params.axis === _Track.TYPE_Y && _this.props.trackYProps.onClick && _this.props.trackYProps.onClick(e, params);
      var scrollTarget = params.axis === _Track.TYPE_X ? Scrollbar.computeScrollForOffset((0, _getInnerSizes.getInnerWidth)(_this.trackXEl), _this.thumbXEl.clientWidth, params.offset, _this.contentEl.scrollWidth, _this.contentEl.clientWidth) : Scrollbar.computeScrollForOffset((0, _getInnerSizes.getInnerHeight)(_this.trackYEl), _this.thumbYEl.clientHeight, params.offset, _this.contentEl.scrollHeight, _this.contentEl.clientHeight);

      if (_this.props.trackClickBehavior === "jump") {
        params.axis === _Track.TYPE_X && (_this.contentEl.scrollLeft = scrollTarget);
        params.axis === _Track.TYPE_Y && (_this.contentEl.scrollTop = scrollTarget);
      } else if (_this.props.trackClickBehavior === "step") {
        params.axis === _Track.TYPE_X && (_this.contentEl.scrollLeft = _this.contentEl.scrollLeft < scrollTarget ? _this.contentEl.scrollLeft + _this.contentEl.clientWidth : _this.contentEl.scrollLeft - _this.contentEl.clientWidth);
        params.axis === _Track.TYPE_Y && (_this.contentEl.scrollTop = _this.contentEl.scrollTop < scrollTarget ? _this.contentEl.scrollTop + _this.contentEl.clientHeight : _this.contentEl.scrollTop - _this.contentEl.clientHeight);
      }
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleThumbDragStart", function (params) {
      params.axis === _Track.TYPE_X && _this.props.thumbXProps.onDragStart && _this.props.thumbXProps.onDragStart(params);
      params.axis === _Track.TYPE_Y && _this.props.thumbYProps.onDragStart && _this.props.thumbYProps.onDragStart(params);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleThumbDragEnd", function (params) {
      params.axis === _Track.TYPE_X && _this.props.thumbXProps.onDragEnd && _this.props.thumbXProps.onDragEnd(params);
      params.axis === _Track.TYPE_Y && _this.props.thumbYProps.onDragEnd && _this.props.thumbYProps.onDragEnd(params);
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleThumbDrag", function (params) {
      _this.scrollDetect();

      if (params.axis === _Track.TYPE_X) {
        _this.props.thumbXProps.onDrag && _this.props.thumbXProps.onDrag(params);
        var trackWidth = (0, _getInnerSizes.getInnerWidth)(_this.trackXEl);
        var offset = params.offset;

        if (_this.state.isRtl) {
          if (engine === "Trident" || engine === "EdgeHTML") {
            offset = trackWidth - offset;
          } else if (engine !== "Blink") {
            offset -= _this.thumbXEl.clientWidth / 2;
          }
        }

        _this.contentEl.scrollLeft = Scrollbar.computeScrollForOffset(trackWidth, _this.thumbXEl.clientWidth, offset, _this.contentEl.scrollWidth, _this.contentEl.clientWidth);
      }

      if (params.axis === _Track.TYPE_Y) {
        _this.props.thumbYProps.onDrag && _this.props.thumbYProps.onDrag(params);
        _this.contentEl.scrollTop = Scrollbar.computeScrollForOffset((0, _getInnerSizes.getInnerHeight)(_this.trackYEl), _this.thumbYEl.clientHeight, params.offset, _this.contentEl.scrollHeight, _this.contentEl.clientHeight);
      }
    });

    _this.state = {
      trackYVisible: true,
      trackXVisible: true,
      isRtl: _this.props.rtl
    };
    _this.scrollValues = _this.getScrollValues(true);
    return _this;
  }

  _createClass(Scrollbar, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.props.rtl !== prevProps.rtl && this.props.rtl !== this.state.isRtl) {
        this.setState({
          isRtl: this.props.rtl
        });
      }

      if (this.state.isRtl !== prevState.isRtl) {
        this.update();
      }

      if (this.props.scrollTop !== prevProps.scrollTop) {
        if (typeof this.props.scrollTop !== "undefined") {
          this.contentEl.scrollTop = this.props.scrollTop;
        }
      }

      if (this.props.scrollLeft !== prevProps.scrollLeft) {
        if (typeof this.props.scrollLeft !== "undefined") {
          this.contentEl.scrollLeft = this.props.scrollLeft;
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      _LoopController.default.registerScrollbar(this);

      this.contentEl.addEventListener("scroll", this.handleScrollEvent, {
        passive: true
      });

      if (typeof this.props.scrollTop !== "undefined") {
        this.contentEl.scrollTop = this.props.scrollTop;
      }

      if (typeof this.props.scrollLeft !== "undefined") {
        this.contentEl.scrollLeft = this.props.scrollLeft;
      }

      this.update();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _LoopController.default.unregisterScrollbar(this);

      this.contentEl.removeEventListener("scroll", this.handleScrollEvent, {
        passive: true
      });
    }
  }, {
    key: "scrollTo",

    /**
     *  Set scroll at given coordinates
     *
     * @param {number} x
     * @param {number} y
     *
     * @return {Scrollbar}
     */
    value: function scrollTo(y, x) {
      this.contentEl.scrollTop = y;
      this.contentEl.scrollLeft = x;
      return this;
    }
    /**
     *  Set viewport's center at given coordinates
     *
     * @param {number} x
     * @param {number} y
     *
     * @return {Scrollbar}
     */

  }, {
    key: "centerAt",
    value: function centerAt(y, x) {
      this.contentEl.scrollTop = y - this.contentEl.clientHeight / 2;
      this.contentEl.scrollLeft = x - this.contentEl.clientWidth / 2;
      return this;
    }
    /**
     * Return the vertical scroll position
     *
     * @return {number}
     */

  }, {
    key: "scrollToTop",

    /**
     * Scrol to the top border
     *
     * @return {Scrollbar}
     */
    value: function scrollToTop() {
      if (this.contentEl) {
        this.contentEl.scrollTop = 0;
      }

      return this;
    }
    /**
     * Scroll to the bottom border
     *
     * @return {Scrollbar}
     */

  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      if (this.contentEl) {
        this.contentEl.scrollTop = this.contentEl.scrollHeight;
      }

      return this;
    }
    /**
     * Scrolls to the left border
     *
     * @return {Scrollbar}
     */

  }, {
    key: "scrollToLeft",
    value: function scrollToLeft() {
      if (this.contentEl) {
        this.contentEl.scrollLeft = 0;
      }

      return this;
    }
    /**
     * Scroll to the right border
     *
     * @return {Scrollbar}
     */

  }, {
    key: "scrollToRight",
    value: function scrollToRight() {
      if (this.contentEl) {
        this.contentEl.scrollLeft = this.contentEl.scrollWidth;
      }

      return this;
    }
    /**
     * @param {boolean} force
     *
     * @return {ScrollValues}
     */

  }, {
    key: "getScrollValues",
    value: function getScrollValues() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!force) {
        return this.scrollValues;
      }

      var scrollValues = {
        clientHeight: null,
        clientWidth: null,
        scrollHeight: null,
        scrollWidth: null,
        scrollTop: null,
        scrollLeft: null,
        scrollYBlocked: null,
        scrollXBlocked: null,
        scrollYPossible: null,
        scrollXPossible: null,
        trackYVisible: null,
        trackXVisible: null,
        isRtl: null
      };

      if (this.contentEl) {
        scrollValues.clientHeight = this.contentEl.clientHeight;
        scrollValues.clientWidth = this.contentEl.clientWidth;
        scrollValues.scrollHeight = this.contentEl.scrollHeight;
        scrollValues.scrollWidth = this.contentEl.scrollWidth;
        scrollValues.scrollTop = this.contentEl.scrollTop;
        scrollValues.scrollLeft = this.contentEl.scrollLeft;
        scrollValues.scrollYBlocked = this.props.noScroll || this.props.noScrollY;
        scrollValues.scrollXBlocked = this.props.noScroll || this.props.noScrollX;
        scrollValues.scrollYPossible = !scrollValues.scrollYBlocked && scrollValues.scrollHeight > scrollValues.clientHeight;
        scrollValues.scrollXPossible = !scrollValues.scrollXBlocked && scrollValues.scrollWidth > scrollValues.clientWidth;
        scrollValues.trackYVisible = scrollValues.scrollYPossible || this.props.permanentTracks || this.props.permanentTrackY;
        scrollValues.trackXVisible = scrollValues.scrollXPossible || this.props.permanentTracks || this.props.permanentTrackX;
        scrollValues.isRtl = this.state.isRtl;
      }

      return scrollValues;
    }
    /**
     *
     * @param forced
     * @return {ScrollValues}
     */

  }, {
    key: "updaterCustom",

    /**
     * @param {ScrollValues} scrollValues current scroll values
     * @param {ScrollValues} prevScrollValues scroll values that been before the update process
     * @param {number} bitmask bit mask that represents difference between prev scroll values and current ones
     *
     * @return {boolean} whether to save current scroll values or not
     */
    value: function updaterCustom(scrollValues, prevScrollValues, bitmask) {
      // if scrollbars visibility has changed
      if (bitmask & 1 << 10 || bitmask & 1 << 11) {
        this.scrollValues.scrollYBlocked = scrollValues.scrollYBlocked;
        this.scrollValues.scrollXBlocked = scrollValues.scrollXBlocked;
        this.scrollValues.scrollYPossible = scrollValues.scrollYPossible;
        this.scrollValues.scrollXPossible = scrollValues.scrollXPossible;
        this.setState({
          trackYVisible: this.scrollValues.trackYVisible = scrollValues.trackYVisible,
          trackXVisible: this.scrollValues.trackXVisible = scrollValues.trackXVisible
        });
        return false;
      } // if Y track rendered and changed anything related to scrollY


      if (this.trackYEl) {
        bitmask & 1 << 10 && (this.trackYEl.style.display = scrollValues.trackYVisible ? null : "none");

        if (bitmask & 1 << 0 || bitmask & 1 << 2 || bitmask & 1 << 4 || bitmask & 1 << 6 || bitmask & 1 << 8) {
          if (scrollValues.scrollYPossible) {
            var trackSize = (0, _getInnerSizes.getInnerHeight)(this.trackYEl);
            var thumbSize = Scrollbar.computeThumbSize(trackSize, scrollValues.scrollHeight, scrollValues.clientHeight, this.props.minimalThumbsSize);
            var thumbOffset = Scrollbar.computeThumbOffset(trackSize, thumbSize, scrollValues.scrollHeight, scrollValues.clientHeight, scrollValues.scrollTop);
            this.thumbYEl.style.transform = "translateY(".concat(thumbOffset, "px)");
            this.thumbYEl.style.height = thumbSize + "px";
            this.thumbYEl.style.display = null;
          } else {
            this.thumbYEl.style.transform = null;
            this.thumbYEl.style.height = "0px";
            this.thumbYEl.style.display = "none";
          }
        }
      } // if X track rendered and changed anything related to scrollX


      if (this.trackXEl) {
        bitmask & 1 << 11 && (this.trackXEl.style.display = scrollValues.trackXVisible ? null : "none");

        if (bitmask & 1 << 1 || bitmask & 1 << 3 || bitmask & 1 << 5 || bitmask & 1 << 7 || bitmask & 1 << 9) {
          if (scrollValues.scrollXPossible) {
            var _trackSize = (0, _getInnerSizes.getInnerWidth)(this.trackXEl);

            var _thumbSize = Scrollbar.computeThumbSize(_trackSize, scrollValues.scrollWidth, scrollValues.clientWidth, this.props.minimalThumbsSize);

            var _thumbOffset = Scrollbar.computeThumbOffset(_trackSize, _thumbSize, scrollValues.scrollWidth, scrollValues.clientWidth, scrollValues.scrollLeft);

            if (this.state.isRtl) {
              if (engine === "Blink") {
                _thumbOffset = _thumbSize + _thumbOffset - _trackSize;
              } else if (engine === "Trident" || engine === "EdgeHTML") {
                _thumbOffset *= -1;
              }
            }

            this.thumbXEl.style.transform = "translateX(".concat(_thumbOffset, "px)");
            this.thumbXEl.style.width = _thumbSize + "px";
            this.thumbXEl.style.display = null;
          } else {
            this.thumbXEl.style.transform = null;
            this.thumbXEl.style.width = "0px";
            this.thumbXEl.style.display = "none";
          }
        }
      }

      if (this.props.translateContentSizesToHolder && this.holderEl && (bitmask & 1 << 2 || bitmask & 1 << 3)) {
        this.holderEl.style.width = scrollValues.scrollWidth + "px";
        this.holderEl.style.height = scrollValues.scrollHeight + "px";
      }

      return true;
    }
    /**
     * @param {ScrollValues} scrollValues current scroll values
     * @param {ScrollValues} prevScrollValues scroll values that been before the update process
     *
     * @param {number} bitmask bit mask that represents difference between prev scroll values and current ones
     */

  }, {
    key: "updaterNative",
    value: function updaterNative(scrollValues, prevScrollValues, bitmask) {
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          native = _this$props.native,
          minimalThumbsSize = _this$props.minimalThumbsSize,
          fallbackScrollbarWidth = _this$props.fallbackScrollbarWidth,
          scrollDetectionThreshold = _this$props.scrollDetectionThreshold,
          tagName = _this$props.tagName,
          className = _this$props.className,
          style = _this$props.style,
          trackClickBehavior = _this$props.trackClickBehavior,
          rtl = _this$props.rtl,
          momentum = _this$props.momentum,
          noDefaultStyles = _this$props.noDefaultStyles,
          translateContentSizesToHolder = _this$props.translateContentSizesToHolder,
          scrollLeft = _this$props.scrollLeft,
          scrollTop = _this$props.scrollTop,
          noScrollX = _this$props.noScrollX,
          noScrollY = _this$props.noScrollY,
          noScroll = _this$props.noScroll,
          permanentTrackX = _this$props.permanentTrackX,
          permanentTrackY = _this$props.permanentTrackY,
          permanentTracks = _this$props.permanentTracks,
          removeTracksWhenNotUsed = _this$props.removeTracksWhenNotUsed,
          removeTrackYWhenNotUsed = _this$props.removeTrackYWhenNotUsed,
          removeTrackXWhenNotUsed = _this$props.removeTrackXWhenNotUsed,
          propsWrapperProps = _this$props.wrapperProps,
          propsContentProps = _this$props.contentProps,
          propsTrackXProps = _this$props.trackXProps,
          propsTrackYProps = _this$props.trackYProps,
          propsThumbXProps = _this$props.thumbXProps,
          propsThumbYProps = _this$props.thumbYProps,
          wrapperRenderer = _this$props.wrapperRenderer,
          contentRenderer = _this$props.contentRenderer,
          trackXRenderer = _this$props.trackXRenderer,
          trackYRenderer = _this$props.trackYRenderer,
          thumbXRenderer = _this$props.thumbXRenderer,
          thumbYRenderer = _this$props.thumbYRenderer,
          onScroll = _this$props.onScroll,
          onScrollStart = _this$props.onScrollStart,
          onScrollStop = _this$props.onScrollStop,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["native", "minimalThumbsSize", "fallbackScrollbarWidth", "scrollDetectionThreshold", "tagName", "className", "style", "trackClickBehavior", "rtl", "momentum", "noDefaultStyles", "translateContentSizesToHolder", "scrollLeft", "scrollTop", "noScrollX", "noScrollY", "noScroll", "permanentTrackX", "permanentTrackY", "permanentTracks", "removeTracksWhenNotUsed", "removeTrackYWhenNotUsed", "removeTrackXWhenNotUsed", "wrapperProps", "contentProps", "trackXProps", "trackYProps", "thumbXProps", "thumbYProps", "wrapperRenderer", "contentRenderer", "trackXRenderer", "trackYRenderer", "thumbXRenderer", "thumbYRenderer", "onScroll", "onScrollStart", "onScrollStop", "children"]);

      var _this$state = this.state,
          trackXVisible = _this$state.trackXVisible,
          trackYVisible = _this$state.trackYVisible;
      var scrollValues = this.getScrollValues();

      if (native) {
        return _react.default.createElement(_NativeScrollbar.default, _extends({
          rtl: rtl,
          momentum: momentum,
          permanentTrackX: permanentTrackX,
          permanentTrackY: permanentTrackY,
          permanentTracks: permanentTracks,
          noScrollX: noScrollX,
          noScrollY: noScrollY,
          noScroll: noScroll,
          tagName: tagName,
          className: (trackYVisible ? " trackYVisible" : "") + (trackYVisible ? " trackXVisible" : "") + (className ? " " + className : ""),
          style: style,
          elementRef: function elementRef(ref) {
            return _this2.contentEl = ref;
          },
          onScroll: this.handleScrollEvent,
          children: children
        }, props));
      }

      var browserSBW = (0, _getScrollbarWidth.default)();
      var scrollbarWidth = browserSBW || fallbackScrollbarWidth;

      var wrapperProps = _objectSpread({}, propsWrapperProps),
          contentProps = _objectSpread({}, propsContentProps),
          trackXProps = _objectSpread({}, propsTrackXProps),
          trackYProps = _objectSpread({}, propsTrackYProps),
          thumbXProps = _objectSpread({}, propsThumbXProps),
          thumbYProps = _objectSpread({}, propsThumbYProps);

      wrapperProps.key = "wrapper";
      contentProps.key = "content";
      trackXProps.key = "trackX";
      trackYProps.key = "trackY";
      thumbXProps.key = "thumbX";
      thumbYProps.key = "thumbY";

      if (!noDefaultStyles) {
        var _objectSpread2;

        props.style = _objectSpread({}, defaultStyles.holder);
        wrapperProps.style = _objectSpread({}, defaultStyles.wrapper, (_objectSpread2 = {}, _defineProperty(_objectSpread2, this.state.isRtl ? "marginLeft" : "marginRight", trackYVisible ? 8 : null), _defineProperty(_objectSpread2, "marginBottom", trackXVisible ? 8 : null), _objectSpread2));
        trackXProps.style = _objectSpread({}, defaultStyles.track.common, defaultStyles.track.x);
        trackYProps.style = _objectSpread({}, defaultStyles.track.common, defaultStyles.track.y, _defineProperty({}, this.state.isRtl ? "left" : "right", 0));
        thumbXProps.style = _objectSpread({}, defaultStyles.thumb.common, defaultStyles.thumb.x);
        thumbYProps.style = _objectSpread({}, defaultStyles.thumb.common, defaultStyles.thumb.y);
      }

      props.style = _objectSpread({}, props.style, style, typeof rtl !== "undefined" && {
        direction: rtl ? "rtl" : "ltr"
      });
      wrapperProps.style = _objectSpread({}, wrapperProps.style, propsWrapperProps.style, {
        position: "relative",
        overflow: "hidden"
      });
      contentProps.style = _objectSpread({}, defaultStyles.content, propsContentProps.style, momentum && {
        WebkitOverflowScrolling: "touch"
      }, {
        overflowY: scrollValues.scrollYPossible ? "scroll" : "hidden",
        overflowX: scrollValues.scrollXPossible ? "scroll" : "hidden"
      }, this.state.isRtl ? {
        paddingLeft: !browserSBW && scrollValues.scrollYPossible ? scrollbarWidth : null,
        marginLeft: scrollValues.scrollYPossible ? -scrollbarWidth : null
      } : {
        paddingRight: !browserSBW && scrollValues.scrollYPossible ? scrollbarWidth : null,
        marginRight: scrollValues.scrollYPossible ? -scrollbarWidth : null
      }, {
        paddingBottom: !browserSBW && scrollValues.scrollXPossible ? scrollbarWidth : null,
        marginBottom: scrollValues.scrollXPossible ? -scrollbarWidth : null
      });
      trackXProps.style = _objectSpread({}, trackXProps.style, propsTrackXProps.style, !trackXVisible && {
        display: "none"
      });
      trackYProps.style = _objectSpread({}, trackYProps.style, propsTrackYProps.style, !trackYVisible && {
        display: "none"
      });
      thumbXProps.style = _objectSpread({}, thumbXProps.style, propsThumbXProps.style);
      thumbYProps.style = _objectSpread({}, thumbYProps.style, propsThumbYProps.style);
      props.className = "ScrollbarsCustom" + (trackYVisible ? " trackYVisible" : "") + (trackYVisible ? " trackXVisible" : "") + (this.state.isRtl ? " rtl" : "") + (className ? " " + className : "");
      contentProps.className = "content" + (contentProps.className ? " " + contentProps.className : "");
      wrapperProps.className = "wrapper" + (wrapperProps.className ? " " + wrapperProps.className : "");

      props.ref = function (ref) {
        _this2.holderEl = ref;
      };

      wrapperProps[wrapperRenderer ? "elementRef" : "ref"] = function (ref) {
        _this2.wrapperEl = ref;
      };

      contentProps[contentRenderer ? "elementRef" : "ref"] = function (ref) {
        _this2.contentEl = ref;
      };

      trackXProps.elementRef = function (ref) {
        _this2.trackXEl = ref;
      };

      trackYProps.elementRef = function (ref) {
        _this2.trackYEl = ref;
      };

      thumbXProps.elementRef = function (ref) {
        _this2.thumbXEl = ref;
      };

      thumbYProps.elementRef = function (ref) {
        _this2.thumbYEl = ref;
      };

      trackXProps.renderer = trackXRenderer;
      trackYProps.renderer = trackYRenderer;
      thumbXProps.renderer = thumbXRenderer;
      thumbYProps.renderer = thumbYRenderer;
      trackYProps.onClick = trackXProps.onClick = this.handleTrackClick;
      thumbYProps.onDragStart = thumbXProps.onDragStart = this.handleThumbDragStart;
      thumbYProps.onDragEnd = thumbXProps.onDragEnd = this.handleThumbDragEnd;
      thumbYProps.onDrag = thumbXProps.onDrag = this.handleThumbDrag;
      contentProps.children = children;
      wrapperProps.children = contentRenderer ? contentRenderer(contentProps) : _react.default.createElement("div", contentProps);
      return _react.default.createElement(this.props.tagName, props, wrapperRenderer ? wrapperRenderer(wrapperProps) : _react.default.createElement("div", wrapperProps), (trackYVisible || !(removeTracksWhenNotUsed && removeTrackYWhenNotUsed)) && _react.default.createElement(_Track.default, _extends({
        type: _Track.TYPE_Y
      }, trackYProps), _react.default.createElement(_Thumb.default, _extends({
        type: _Track.TYPE_Y
      }, thumbYProps))), (trackXVisible || !(removeTracksWhenNotUsed && removeTrackXWhenNotUsed)) && _react.default.createElement(_Track.default, _extends({
        type: _Track.TYPE_X
      }, trackXProps), _react.default.createElement(_Thumb.default, _extends({
        type: _Track.TYPE_X
      }, thumbXProps))));
    }
  }, {
    key: "scrollTop",
    get: function get() {
      if (this.contentEl) {
        return this.contentEl.scrollTop;
      }

      return 0;
    }
    /**
     *
     * Set the vertical scroll to given amount of pixels
     *
     * @param top {number} Pixels amount
     */
    ,
    set: function set(top) {
      if (this.contentEl) {
        this.contentEl.scrollTop = top;
        this.update();
      }
    }
    /**
     * Return the horizontal scroll position
     *
     * @return {number}
     */

  }, {
    key: "scrollLeft",
    get: function get() {
      if (this.contentEl) {
        return this.contentEl.scrollLeft;
      }

      return 0;
    }
    /**
     * Set the horizontal scroll to given amount of pixels
     *
     * @param left {number} Pixels amount
     */
    ,
    set: function set(left) {
      if (this.contentEl) {
        this.contentEl.scrollLeft = left;
      }
    }
    /**
     * @return {number}
     */

  }, {
    key: "scrollHeight",
    get: function get() {
      if (this.contentEl) {
        return this.contentEl.scrollHeight;
      }

      return 0;
    }
    /**
     * @return {number}
     */

  }, {
    key: "scrollWidth",
    get: function get() {
      if (this.contentEl) {
        return this.contentEl.scrollWidth;
      }

      return 0;
    }
    /**
     * @return {number}
     */

  }, {
    key: "clientHeight",
    get: function get() {
      if (this.contentEl) {
        return this.contentEl.clientHeight;
      }

      return 0;
    }
    /**
     * @return {number}
     */

  }, {
    key: "clientWidth",
    get: function get() {
      if (this.contentEl) {
        return this.contentEl.clientWidth;
      }

      return 0;
    }
  }]);

  return Scrollbar;
}(_react.default.Component);

exports.default = Scrollbar;

_defineProperty(Scrollbar, "propTypes", {
  native: _propTypes.default.bool,
  minimalThumbsSize: _propTypes.default.number,
  fallbackScrollbarWidth: _propTypes.default.number,
  tagName: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  trackClickBehavior: _propTypes.default.oneOf(["jump", "step"]),
  rtl: _propTypes.default.bool,
  momentum: _propTypes.default.bool,
  noDefaultStyles: _propTypes.default.bool,
  scrollDetectionThreshold: _propTypes.default.number,
  translateContentSizesToHolder: _propTypes.default.bool,
  scrollTop: _propTypes.default.number,
  scrollLeft: _propTypes.default.number,
  noScrollX: _propTypes.default.bool,
  noScrollY: _propTypes.default.bool,
  noScroll: _propTypes.default.bool,
  removeTracksWhenNotUsed: _propTypes.default.bool,
  removeTrackYWhenNotUsed: _propTypes.default.bool,
  removeTrackXWhenNotUsed: _propTypes.default.bool,
  permanentTrackX: _propTypes.default.bool,
  permanentTrackY: _propTypes.default.bool,
  permanentTracks: _propTypes.default.bool,
  wrapperProps: _propTypes.default.object,
  contentProps: _propTypes.default.object,
  trackXProps: _propTypes.default.object,
  trackYProps: _propTypes.default.object,
  thumbXProps: _propTypes.default.object,
  thumbYProps: _propTypes.default.object,
  wrapperRenderer: _propTypes.default.func,
  contentRenderer: _propTypes.default.func,
  trackXRenderer: _propTypes.default.func,
  trackYRenderer: _propTypes.default.func,
  thumbXRenderer: _propTypes.default.func,
  thumbYRenderer: _propTypes.default.func,
  onScroll: _propTypes.default.func,
  onScrollStart: _propTypes.default.func,
  onScrollStop: _propTypes.default.func
});

_defineProperty(Scrollbar, "defaultProps", {
  native: false,
  tagName: "div",
  minimalThumbsSize: 30,
  fallbackScrollbarWidth: 20,
  trackClickBehavior: "jump",
  momentum: true,
  noDefaultStyles: false,
  scrollDetectionThreshold: 100,
  translateContentSizesToHolder: false,
  noScrollX: false,
  noScrollY: false,
  noScroll: false,
  permanentTrackX: false,
  permanentTrackY: false,
  permanentTracks: false,
  removeTracksWhenNotUsed: true,
  removeTrackYWhenNotUsed: true,
  removeTrackXWhenNotUsed: true,
  wrapperProps: {},
  contentProps: {},
  trackXProps: {},
  trackYProps: {},
  thumbXProps: {},
  thumbYProps: {}
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(153)('wks');
var uid = __webpack_require__(106);
var Symbol = __webpack_require__(57).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = formatTime;
exports.isVideoChild = isVideoChild;
exports.mergeAndSortChildren = mergeAndSortChildren;
exports.deprecatedWarning = deprecatedWarning;
exports.throttle = throttle;
exports.mediaProperties = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(297));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(172));

var _react = _interopRequireDefault(__webpack_require__(0));

// NaN is the only value in javascript which is not equal to itself.
// eslint-disable-next-line no-self-compare
var isNaN = Number.isNaN || function (value) {
  return value !== value;
};
/**
 * @file format-time.js
 *
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @param  {Number} seconds Number of seconds to be turned into a string
 * @param  {Number} guide   Number (in seconds) to model the string after
 * @return {String}         Time formatted as H:MM:SS or M:SS
 * @private
 * @function formatTime
 */


function formatTime() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600); // handle invalid times

  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = '-';
    m = '-';
    s = '-';
  } // Check if we need to show hours


  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.

  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds

  s = s < 10 ? "0".concat(s) : s;
  return h + m + s;
} // Check if the element belongs to a video element
// only accept <source />, <track />,
// <MyComponent isVideoChild />
// elements


function isVideoChild(c) {
  if (c.props && c.props.isVideoChild) {
    return true;
  }

  return c.type === 'source' || c.type === 'track';
}

var find = function find(elements, func) {
  return elements.filter(func)[0];
}; // check if two components are the same type


var isTypeEqual = function isTypeEqual(component1, component2) {
  var type1 = component1.type;
  var type2 = component2.type;

  if (typeof type1 === 'string' || typeof type2 === 'string') {
    return type1 === type2;
  }

  if (typeof type1 === 'function' && typeof type2 === 'function') {
    return type1.displayName === type2.displayName;
  }

  return false;
}; // merge default children
// sort them by `order` property
// filter them by `disabled` property


function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var children = _react["default"].Children.toArray(_children);

  var order = _parentProps.order,
      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent

  return children.filter(function (e) {
    return !e.props.disabled;
  }) // filter the disabled components
  .concat(defaultChildren.filter(function (c) {
    return !find(children, function (component) {
      return isTypeEqual(component, c);
    });
  })).map(function (element) {
    var defaultComponent = find(defaultChildren, function (c) {
      return isTypeEqual(c, element);
    });
    var defaultProps = defaultComponent ? defaultComponent.props : {};
    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);

    var e = _react["default"].cloneElement(element, props, element.props.children);

    return e;
  }).sort(function (a, b) {
    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
  });
}
/**
 * Temporary utility for generating the warnings
 */


function deprecatedWarning(oldMethodCall, newMethodCall) {
  // eslint-disable-next-line no-console
  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
}

function throttle(callback, limit) {
  var _arguments = arguments;
  var wait = false;
  return function () {
    if (!wait) {
      // eslint-disable-next-line prefer-rest-params
      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
}

var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
exports.mediaProperties = mediaProperties;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/warning.ec1ecb92.svg";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history__ = __webpack_require__(67);
var history=Object(__WEBPACK_IMPORTED_MODULE_0_history__["a" /* createBrowserHistory */])();/* harmony default export */ __webpack_exports__["a"] = (history);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var Loading=function Loading(props){// let timeout = null;
// const [showLoader, setShowLoader] = useState(false);
// timeout = setTimeout(() => {
//   setShowLoader(true);
// }, props.timeout);
// useEffect(() => {
//   return () => {
//     clearTimeout(timeout);
//   };
// });
// if (!showLoader) return null;
return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(ev){ev.preventDefault();ev.stopPropagation();},className:'loading-container',title:'7'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'loading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{version:'1.1',id:'Layer_1',x:'0px',y:'0px',width:'24px',height:'30px',viewBox:'0 0 24 30',style:{enableBackground:"new 0 0 50 50"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'0',y:'10',width:'4',height:'10',fill:'#333',opacity:'0.2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'opacity',attributeType:'XML',values:'0.2; 1; .2',begin:'0s',dur:'0.6s',repeatCount:'indefinite'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'height',attributeType:'XML',values:'10; 20; 10',begin:'0s',dur:'0.6s',repeatCount:'indefinite'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'y',attributeType:'XML',values:'10; 5; 10',begin:'0s',dur:'0.6s',repeatCount:'indefinite'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'8',y:'10',width:'4',height:'10',fill:'#333',opacity:'0.2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'opacity',attributeType:'XML',values:'0.2; 1; .2',begin:'0.15s',dur:'0.6s',repeatCount:'indefinite'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'height',attributeType:'XML',values:'10; 20; 10',begin:'0.15s',dur:'0.6s',repeatCount:'indefinite'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'y',attributeType:'XML',values:'10; 5; 10',begin:'0.15s',dur:'0.6s',repeatCount:'indefinite'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'16',y:'10',width:'4',height:'10',fill:'#333',opacity:'0.2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'opacity',attributeType:'XML',values:'0.2; 1; .2',begin:'0.3s',dur:'0.6s',repeatCount:'indefinite'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'height',attributeType:'XML',values:'10; 20; 10',begin:'0.3s',dur:'0.6s',repeatCount:'indefinite'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('animate',{attributeName:'y',attributeType:'XML',values:'10; 5; 10',begin:'0.3s',dur:'0.6s',repeatCount:'indefinite'}))))),document.body);};Loading.propTypes={timeout:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number};Loading.defaultProps={timeout:500};/* harmony default export */ __webpack_exports__["a"] = (Loading);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getGroupIcons; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getGroupAvatarUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
var LITE_AVATAR_BASE_URL='https://s3.eu-west-1.amazonaws.com/uploads.globalandxl.nl/glxl-lite-avatars';/**
 * Get group icon urls
 * @param {array<string>} themes
 * @param {array<{}>} groups 
 * @return {array<string>}
 */var getGroupIcons=function getGroupIcons(){var themes=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var groups=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];return themes.map(function(theme,i){var g=groups.find(function(g){return g.GroupTheme.color===theme;});if(g)return __WEBPACK_IMPORTED_MODULE_0__config__["apiUrl"]+g.GroupTheme.badge;return null;});};/**
 * Returns the avatar url to display for a group.
 * Falls back to a color-specific placeholder for LITE projects, or the
 * provided fallback otherwise.
 * @param {{ Avatar?: { url: string }, GroupTheme?: { color: string } }} group
 * @param {{ lite?: boolean }} [project]
 * @param {string} [fallback]
 * @returns {string}
 */var getGroupAvatarUrl=function getGroupAvatarUrl(group,project){var fallback=arguments.length>2&&arguments[2]!==undefined?arguments[2]:'';if(group&&group.Avatar&&group.Avatar.url){return group.Avatar.url;}if(project&&project.lite&&group&&group.GroupTheme&&group.GroupTheme.color){return LITE_AVATAR_BASE_URL+'/'+group.GroupTheme.color+'.png';}return fallback;};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, webkitURL, module */

;(function ($) {
  'use strict'

  /**
   * Loads an image for a given File object.
   * Invokes the callback with an img or optional canvas element
   * (if supported by the browser) as parameter:.
   *
   * @param {File|Blob|string} file File or Blob object or image URL
   * @param {Function} [callback] Image load event callback
   * @param {object} [options] Options object
   * @returns {HTMLImageElement|HTMLCanvasElement|FileReader} image object
   */
  function loadImage(file, callback, options) {
    var img = document.createElement('img')
    var url
    img.onerror = function (event) {
      return loadImage.onerror(img, event, file, callback, options)
    }
    img.onload = function (event) {
      return loadImage.onload(img, event, file, callback, options)
    }
    if (typeof file === 'string') {
      loadImage.fetchBlob(
        file,
        function (blob) {
          if (blob && loadImage.isInstanceOf('Blob', blob)) {
            // eslint-disable-next-line no-param-reassign
            file = blob
            url = loadImage.createObjectURL(file)
          } else {
            url = file
            if (options && options.crossOrigin) {
              img.crossOrigin = options.crossOrigin
            }
          }
          img.src = url
        },
        options
      )
      return img
    } else if (
      loadImage.isInstanceOf('Blob', file) ||
      // Files are also Blob instances, but some browsers
      // (Firefox 3.6) support the File API but not Blobs:
      loadImage.isInstanceOf('File', file)
    ) {
      url = img._objectURL = loadImage.createObjectURL(file)
      if (url) {
        img.src = url
        return img
      }
      return loadImage.readFile(file, function (e) {
        var target = e.target
        if (target && target.result) {
          img.src = target.result
        } else if (callback) {
          callback(e)
        }
      })
    }
  }
  // The check for URL.revokeObjectURL fixes an issue with Opera 12,
  // which provides URL.createObjectURL but doesn't properly implement it:
  var urlAPI =
    ($.createObjectURL && $) ||
    ($.URL && URL.revokeObjectURL && URL) ||
    ($.webkitURL && webkitURL)

  /**
   * Helper function to revoke an object URL
   *
   * @param {HTMLImageElement} img Image element
   * @param {object} [options] Options object
   */
  function revokeHelper(img, options) {
    if (img._objectURL && !(options && options.noRevoke)) {
      loadImage.revokeObjectURL(img._objectURL)
      delete img._objectURL
    }
  }

  // If the callback given to this function returns a blob, it is used as image
  // source instead of the original url and overrides the file argument used in
  // the onload and onerror event callbacks:
  loadImage.fetchBlob = function (url, callback) {
    callback()
  }

  loadImage.isInstanceOf = function (type, obj) {
    // Cross-frame instanceof check
    return Object.prototype.toString.call(obj) === '[object ' + type + ']'
  }

  loadImage.transform = function (img, options, callback, file, data) {
    callback(img, data)
  }

  loadImage.onerror = function (img, event, file, callback, options) {
    revokeHelper(img, options)
    if (callback) {
      callback.call(img, event)
    }
  }

  loadImage.onload = function (img, event, file, callback, options) {
    revokeHelper(img, options)
    if (callback) {
      loadImage.transform(img, options, callback, file, {
        originalWidth: img.naturalWidth || img.width,
        originalHeight: img.naturalHeight || img.height
      })
    }
  }

  loadImage.createObjectURL = function (file) {
    return urlAPI ? urlAPI.createObjectURL(file) : false
  }

  loadImage.revokeObjectURL = function (url) {
    return urlAPI ? urlAPI.revokeObjectURL(url) : false
  }

  // Loads a given File object via FileReader interface,
  // invokes the callback with the event object (load or error).
  // The result can be read via event.target.result:
  loadImage.readFile = function (file, callback, method) {
    if ($.FileReader) {
      var fileReader = new FileReader()
      fileReader.onload = fileReader.onerror = callback
      // eslint-disable-next-line no-param-reassign
      method = method || 'readAsDataURL'
      if (fileReader[method]) {
        fileReader[method](file)
        return fileReader
      }
    }
    return false
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return loadImage
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    module.exports = loadImage
  } else {
    $.loadImage = loadImage
  }
})((typeof window !== 'undefined' && window) || this)


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(57);
var core = __webpack_require__(33);
var ctx = __webpack_require__(148);
var hide = __webpack_require__(76);
var has = __webpack_require__(70);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(69);
var IE8_DOM_DEFINE = __webpack_require__(218);
var toPrimitive = __webpack_require__(149);
var dP = Object.defineProperty;

exports.f = __webpack_require__(59) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(78)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(226);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_questionmark_svg__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_questionmark_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_questionmark_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_popupHelper__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var updatePopups=__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */].popup.updatePopups;var QuestionButton=(_temp=_class=function(_Component){_inherits(QuestionButton,_Component);function QuestionButton(props){_classCallCheck(this,QuestionButton);var _this=_possibleConstructorReturn(this,(QuestionButton.__proto__||Object.getPrototypeOf(QuestionButton)).call(this,props));_this.state={showPopUp:false};return _this;}_createClass(QuestionButton,[{key:'render',value:function render(){var props=this.props;var dispatch=props.dispatch;var wrap=props.wrap;if(!wrap)wrap="div";if(Object(__WEBPACK_IMPORTED_MODULE_5__helpers_popupHelper__["d" /* getContent */])(props.popupId,props.gameState.language)===""){return this.props.children;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(e){e.preventDefault();dispatch(updatePopups({popupId:props.popupId,closeable:true,tutorial:false}));}},this.props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question-mark'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'questionMark',src:__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_questionmark_svg___default.a})));}}]);return QuestionButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={elementFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,popupId:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={popupId:'',elementFocus:''},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(state){return state;})(QuestionButton));

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(171);
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? Object(arguments[r]) : {},
      o = Object.keys(t);
    "function" == typeof Object.getOwnPropertySymbols && o.push.apply(o, Object.getOwnPropertySymbols(t).filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), o.forEach(function (r) {
      defineProperty(e, r, t[r]);
    });
  }
  return e;
}
module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/economy.60a2a3d7.svg";

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(226);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ramp_png__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ramp_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ramp_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_disaster_png__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_disaster_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_disaster_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackImage=(_temp=_class=function(_Component){_inherits(FeedbackImage,_Component);function FeedbackImage(props){_classCallCheck(this,FeedbackImage);var _this=_possibleConstructorReturn(this,(FeedbackImage.__proto__||Object.getPrototypeOf(FeedbackImage)).call(this,props));_this.state={showComponent:false};return _this;}_createClass(FeedbackImage,[{key:'render',value:function render(){var img='';var desktop=this.props.desktop;if(this.props.image){if(this.props.image.indexOf('.jpg')!==-1){img=this.props.image.slice(0,this.props.image.length-4);}else if(this.props.image.indexOf('.jpeg')!==-1){img=this.props.image.slice(0,this.props.image.length-5);}else{img=this.props.image;}}var description=this.props.description&&this.props.description!=='<p>-</p>'&&this.props.description!=='<p>- </p>'&&this.props.description!=='<p> -</p>'?this.props.description:false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-image-container '+(this.props.transitionDelay?this.props.transitionDelay:'')+(description===false?' noText':'')},img?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-image',style:desktop?{backgroundImage:'url('+__WEBPACK_IMPORTED_MODULE_3__config___default.a.mediaUrl+img+'.jpeg)'}:{}},!desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'feedback-img',src:''+__WEBPACK_IMPORTED_MODULE_3__config___default.a.mediaUrl+img+'.jpeg',style:{width:'100%'}}):null,this.props.disaster?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'disaster-feedback-image',alt:'disaster',src:this.props.gameState.language==="NL"?__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_ramp_png___default.a:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_disaster_png___default.a}):null):'',description?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'imageText '+(this.props.forceShowText?"forceShow":"")+' '+(this.props.descriptionAbsolute?'imageText--absolute':''),dangerouslySetInnerHTML:{__html:this.props.description}}):null);}}]);return FeedbackImage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,desktop:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,descriptionAbsolute:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool},_class.defaultProps={desktop:false,descriptionAbsolute:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref){var gameState=_ref.gameState;return{gameState:gameState};})(FeedbackImage));

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GameMaterialItem__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AudioGameMaterial__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PasswordGameMaterial__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocumentGameMaterial__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__VideoGameMaterial__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SoftwareGameMaterial__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DownloadAudioButton__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LinkMaterialItem__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_redux__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GameMaterials=(_temp=_class=function(_React$Component){_inherits(GameMaterials,_React$Component);function GameMaterials(props){_classCallCheck(this,GameMaterials);var _this=_possibleConstructorReturn(this,(GameMaterials.__proto__||Object.getPrototypeOf(GameMaterials)).call(this,props));_this.fetchAdditionalFilterData=function(){console.log("Fetch additional filter data");var projectId=_this.props.project&&_this.props.project.id?_this.props.project.id:_this.props.projectId;console.log("project id:",projectId);if(projectId&&!_this.state.fetchingAdditionalFilterData&&!_this.state.fetchedAdditionalFilterData){_this.setState({fetchingAdditionalFilterData:true});Object(__WEBPACK_IMPORTED_MODULE_10__apiCall__["a" /* default */])('/project/'+projectId+'/additionalGameMaterialFilterData').then(function(_ref){var areBonuscardsEnabled=_ref.areBonuscardsEnabled,enabledGames=_ref.enabledGames;_this.setState({areBonuscardsEnabled:areBonuscardsEnabled,enabledGames:enabledGames});}).catch(function(err){console.log(err);}).finally(function(){_this.setState({fetchingAdditionalFilterData:false,fetchedAdditionalFilterData:true});});}};_this.renderMaterialItem=function(item){switch(item.type){case'software':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SoftwareGameMaterial__["a" /* default */],Object.assign({},_this.props,{item:item}));case'video':case'vimeo':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__VideoGameMaterial__["a" /* default */],Object.assign({},_this.props,{item:item}));case'file':if(item.Material&&item.Material.mimeType.includes('pdf')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DocumentGameMaterial__["a" /* default */],Object.assign({},_this.props,{item:item}));}else if(item.Material&&item.Material.mimeType.includes('audio')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__AudioGameMaterial__["a" /* default */],Object.assign({},_this.props,{item:item}));}else if(item.Material&&item.Material.mimeType.includes('video')){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__VideoGameMaterial__["a" /* default */],Object.assign({},_this.props,{item:item}));}else if(!item.Material&&item.alternateUrl){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__VideoGameMaterial__["a" /* default */],Object.assign({},_this.props,{item:item}));}break;case'link':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LinkMaterialItem__["a" /* default */],Object.assign({},_this.props,{item:item}));case'password':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__PasswordGameMaterial__["a" /* default */],Object.assign({},_this.props,{item:item}));default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GameMaterialItem__["a" /* default */],Object.assign({},_this.props,{item:item}));}};console.log("props:",props);_this.state={desktop:window.innerWidth>=1240,areBonuscardsEnabled:null,enabledGames:[],fetchingAdditionalFilterData:false,fetchedAdditionalFilterData:false};return _this;}_createClass(GameMaterials,[{key:'componentDidMount',value:function componentDidMount(){this.fetchAdditionalFilterData();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.fetchAdditionalFilterData();}},{key:'render',value:function render(){var _this2=this;if(this.state.fetchingAdditionalFilterData)return null;console.log(this.state.areBonuscardsEnabled,this.state.enabledGames);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-item-container'},this.props.items.filter(function(item){// areBonuscardsEnabled filter
if(item.bonuscardSettingFilter===0)return true;if(_this2.state.areBonuscardsEnabled===null)return false;if(item.bonuscardSettingFilter===1)return _this2.state.areBonuscardsEnabled;if(item.bonuscardSettingFilter===2)return!_this2.state.areBonuscardsEnabled;return true;})// filter based on lite field on project
.filter(function(item){// basicLiteSettingFilter filter
if(item.basicLiteSettingFilter===0)return true;if(_this2.props.project.lite===null)return false;if(item.basicLiteSettingFilter===1)return _this2.props.project.lite;if(item.basicLiteSettingFilter===2)return!_this2.props.project.lite;return true;}).filter(function(item){// enabledGames filter
console.log(item.showIfGameIsIncluded);// abbreviation
if(!item.showIfGameIsIncluded)return true;if(_this2.state.enabledGames===null||!_this2.state.enabledGames.length)return false;return _this2.state.enabledGames.includes(item.showIfGameIsIncluded.toUpperCase());}).map(function(item){// console.log(item);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:item.id},_this2.renderMaterialItem(item));}),(this.props.gameId===4||this.props.gameId===11)&&!navigator.userAgent.match(/(iPhone|iPod|iPad)/i)?// Only applies for Escape Route and True Comics
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__DownloadAudioButton__["a" /* default */],{audio:this.props.items.filter(function(i){return i.Material&&i.Material.mimeType.includes('audio');}).map(function(i){return i.Material.url;})}):null);}}]);return GameMaterials;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={items:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}))},_class.defaultProps={items:[]},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_redux__["b" /* connect */])(function(state){return{project:state.project};})(GameMaterials));

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(409);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(216);
var defined = __webpack_require__(147);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 70 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = merge;

function merge() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaults = arguments.length > 1 ? arguments[1] : undefined;

  for (var key in defaults) {
    if (typeof obj[key] === 'undefined') {
      obj[key] = defaults[key];
    }
  }

  return obj;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUrlVars;
function getUrlVars(){var vars={};window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,function(m,key,value){vars[key]=value;});return vars;};

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_check_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BudgetCollaboration=(_temp=_class=function(_Component){_inherits(BudgetCollaboration,_Component);function BudgetCollaboration(props){_classCallCheck(this,BudgetCollaboration);var _this=_possibleConstructorReturn(this,(BudgetCollaboration.__proto__||Object.getPrototypeOf(BudgetCollaboration)).call(this,props));_this.selectItem=_this.selectItem.bind(_this);return _this;}_createClass(BudgetCollaboration,[{key:'selectItem',value:function selectItem(groupName){var props=this.props;if(this.props.single){this.props.customOnChange(this.props.onChangeKey,groupName===props.value?"":groupName);return;}if(props.value.includes(groupName)){var newVal=[].concat(props.value);newVal.splice(newVal.indexOf(groupName),1);this.props.customOnChange(this.props.onChangeKey,newVal);}else{this.props.customOnChange(this.props.onChangeKey,[groupName].concat(props.value));}}},{key:'render',value:function render(){var _this2=this;var value=this.props.value||[];var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collaboration-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.title),props.schoolClass.Groups?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.user.role==='groupmember'?'groupmember-disabled':''},props.schoolClass.Groups.map(function(group){return props.group.GroupTheme.color!==group.GroupTheme.color?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:group.GroupTheme.id,className:'collaboration-item'+(value.includes&&value.includes(group.GroupTheme.color)||value===group.GroupTheme.color?' active':''),onClick:_this2.selectItem.bind(_this2,group.GroupTheme.color)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'group-icon',src:__WEBPACK_IMPORTED_MODULE_4__config___default.a.apiUrl+group.GroupTheme.badge}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_check_svg___default.a,alt:'check',className:'collaboration-checkmark'})):'';})):null);}}]);return BudgetCollaboration;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={action:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,customOnChange:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,onChangeKey:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string]),single:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool},_class.defaultProps={value:[]},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schoolClass:state.schoolClass,group:state.group,user:state.user};})(BudgetCollaboration));

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GameMaterialItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Loading__ = __webpack_require__(51);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GameMaterialItem=(_temp=_class=function(_React$Component){_inherits(GameMaterialItem,_React$Component);function GameMaterialItem(props){_classCallCheck(this,GameMaterialItem);var _this=_possibleConstructorReturn(this,(GameMaterialItem.__proto__||Object.getPrototypeOf(GameMaterialItem)).call(this,props));_this.togglePopup=function(){_this.setState({showPopUp:!_this.state.showPopUp});};_this.state={styles:{},icons:[],showPopUp:false};_this.renderTitle=_this.renderTitle.bind(_this);_this.renderIcons=_this.renderIcons.bind(_this);_this.handleClick=_this.handleClick.bind(_this);_this.download=_this.download.bind(_this);return _this;}_createClass(GameMaterialItem,[{key:'componentWillUnmount',value:function componentWillUnmount(){}},{key:'handleClick',value:function handleClick(){return null;}},{key:'renderTitle',value:function renderTitle(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.item.title);}},{key:'renderIcons',value:function renderIcons(){return this.state.icons.map(function(icon,i){if(typeof icon==='string'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:i,style:{marginLeft:'10px'},src:icon,alt:'icon'});}else if((typeof icon==='undefined'?'undefined':_typeof(icon))==='object'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',Object.assign({},icon,{key:i,style:_extends({marginLeft:'10px'},icon.style),src:icon.src,alt:'icon'||icon.alt}));}return null;});}},{key:'download',value:function download(){var ev=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var target=ev.target;var item=this.props.item;if(target&&target.tagName==='IMG'){target.style.opacity=0.5;target.style.pointerEvents='none';}if(!item.Material)return;window.open(item.Material.url,'_blank');}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__ContentContainer__["a" /* default */],{onClick:this.props.disabled?this.togglePopup:this.handleClick,style:this.state.styles,className:''+(this.props.disabled?'disabled':'')},this.renderTitle(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',justifyContent:'space-between',alignItems:'center'}},this.renderIcons()),this.state.showPopUp?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PopUp__["a" /* default */],{popUpFooter:true,id:'m'+(this.props.gameState.difficulty==='BASIC'?'l':'h')+'bmfilmquiz_mobiel',closePopUpClick:this.togglePopup}):null,this.state.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_Loading__["a" /* default */],null):null);}}]);return GameMaterialItem;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={item:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired},_temp);

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(58);
var createDesc = __webpack_require__(88);
module.exports = __webpack_require__(59) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(147);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/check.4e0c0107.svg";

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/caret_down_grey.5a43bde0.svg";

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/team.da6d2a44.svg";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/belasting-5.86dec0be.svg";

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setGiftsRead; });
/* unused harmony export getMaxSpendable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getSavedGlobas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getSavingsInterest; });
/* unused harmony export getRemainingOwnedGlobas */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUnreadGifts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getCountryIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_bank_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_bank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_bank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_gameStateInput__ = __webpack_require__(91);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var updateMyState=__WEBPACK_IMPORTED_MODULE_3__actions_gameStateInput__["a" /* default */].updateMyState;function getCountryIcon(otherCountry){var icon=void 0;switch(Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(otherCountry).toLowerCase()){case Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])("Rood").toLowerCase():case"rood":icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */]['rood'];break;case Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])("Oranje").toLowerCase():case"oranje":icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */]['oranje'];break;case Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])("Geel").toLowerCase():case"geel":icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */]['geel'];break;case Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])("Groen").toLowerCase():case"groen":icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */]['groen'];break;case Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])("Blauw").toLowerCase():case"blauw":icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */]['blauw'];break;case Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])("Paars").toLowerCase():case"paars":icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */]['paars'];break;default:icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */][Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(otherCountry).toLowerCase()];break;}return icon;}function getSavedGlobas(gameState){var debitCredit=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var prevSavings=0;var prevRoundLastGamestate=gameState.prevRound.GameStates[gameState.prevRound.GameStates.length-1];if(prevRoundLastGamestate&&prevRoundLastGamestate.OneTimeEffect&&Array.isArray(prevRoundLastGamestate.OneTimeEffect.debitCredit)){prevSavings=prevRoundLastGamestate.OneTimeEffect.debitCredit.filter(function(dc){return dc.key==='stortenSpaargeld';}).reduce(function(acc,dc){return acc-dc.amount;},0);}var savingsThisround=0;if(debitCredit['stortenSpaargeld']&&debitCredit['stortenSpaargeld'].confirmed){savingsThisround=debitCredit['stortenSpaargeld'].amount;}var withdrawalThisround=0;if(debitCredit['opnemenSpaargeld']&&debitCredit['opnemenSpaargeld'].confirmed){withdrawalThisround=debitCredit['opnemenSpaargeld'].amount;}return prevSavings+savingsThisround-withdrawalThisround;}function getRemainingOwnedGlobas(globas,gameState){var reducingKeys=['lenenAanland','schenkAanLand','stortenSpaargeld'];var globasRemaining=gameState.Rounds.reduce(function(total,current){var debCred=current.debitCredit;if(debCred===undefined){return total;}var collector=total;//remove globa's for all rounds
reducingKeys.forEach(function(key){if(key in debCred){collector-=debCred[key].amount;}});return collector;},globas);return globasRemaining;}function getMaxSpendable(saved,globas,maximum){var maxRemaining=maximum-saved;if(maxRemaining<=0){return 0;}if(maxRemaining>globas){return globas;}return maxRemaining;}function getSavingsInterest(gameState,currentCredit){var prevSaved=arguments.length>2&&arguments[2]!==undefined?arguments[2]:0;var interest=arguments.length>3&&arguments[3]!==undefined?arguments[3]:1;var removeWithdrawn=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var amountSaved=prevSaved;if(currentCredit.stortenSpaargeld!==undefined){if(!currentCredit.stortenSpaargeld.confirmed){amountSaved+=currentCredit.stortenSpaargeld.amount;}if(removeWithdrawn&&currentCredit.opnemenSpaargeld&&currentCredit.opnemenSpaargeld.amount){amountSaved-=currentCredit.opnemenSpaargeld.amount;}}return Math.floor(amountSaved*interest);}function getOverview(gameStateInput){var dispatch=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;var state=arguments.length>2&&arguments[2]!==undefined?arguments[2]:false;var bankNotificationsState=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var isHistory=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var states=gameStateInput.states,myState=gameStateInput.myState;var country=myState.theme;//Geleend, gekregen of opgenomen;
var plusKeys=isHistory?['lenenVanLand','lenenVanBank','opnemenSpaargeld']:['lenenVanLand','lenenVanBank','opnemenSpaargeld','lenenVanLandNotConfirmed'];var plusResult=getKeys(dispatch,gameStateInput,plusKeys,['lenenVanLand','lenenVanLandNotConfirmed']);var plus=plusResult.items;var plusTotal=plusResult.amount;var plusCorrectionIndex=plus.findIndex(function(c){return c.key==='lenenVanLandNotConfirmed'&&c.pending!==true;});if(plusCorrectionIndex>-1){plusTotal-=plus[plusCorrectionIndex].points;plus.splice(plusCorrectionIndex,1);}//Check for gifts
var gift=Object.keys(states).length===0&&states.constructor===Object?undefined:Object.keys(states[gameStateInput.currentRound]).map(function(current){//Escape if it's my state.
if(current===gameStateInput.groupId.toString())return false;//Check only for current round
var extDbCr=states[gameStateInput.currentRound][current].debitCredit;var extCountry=states[gameStateInput.currentRound][current].theme;if(extDbCr===undefined||Object.keys(extDbCr).length===0&&extDbCr.constructor===Object){return false;}//Check for gifts by other countries
if(!('schenkAanLand'in extDbCr))return false;//check if item is confirmed by user
if(extDbCr['schenkAanLand'].confirmed!==true){return false;}//If the country the gift is gifted to is my country...
if(extDbCr['schenkAanLand'].otherCountry===country){//Add cummulative money earned
plusTotal+=extDbCr['schenkAanLand'].amount;return{title:Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])('schenkVanLand')+" "+Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(extCountry).toLowerCase(),pending:false,points:extDbCr['schenkAanLand'].amount,icon:getCountryIcon(extCountry)};}else{return false;}}).filter(Boolean);// Concat gitfts to others when there are any.
if(gift!==undefined&&gift.length>0){plus=plus.concat(gift);}var plusReadMap=plus.map(function(c){return c.pending;});//Uitgeleend, geschonken of gespaard;
var minusKeys=isHistory?['lenenAanLand','schenkAanLand','stortenSpaargeld']:['lenenAanLand','schenkAanLand','stortenSpaargeld','lenenAanLandNotConfirmed'];var minusResult=getKeys(dispatch,gameStateInput,minusKeys,['lenenAanLand','lenenAanLandNotConfirmed']);var minus=minusResult.items;var minusTotal=minusResult.amount;var minusReadMap=minus.map(function(c){return c.pending;});var minusCorrectionIndex=minus.findIndex(function(c){return c.key==='lenenAanLandNotConfirmed'&&c.pending!==true;});if(minusCorrectionIndex>-1){minusTotal-=minus[minusCorrectionIndex].points;minus.splice(minusCorrectionIndex,1);}//Betaalde aflossingen en rentes;
var paidKeys=['lenenVanBank','lenenVanLand'];var paidInterestRes=getInterest(gameStateInput,paidKeys);var paidInterest=paidInterestRes.items;var paidInterestTotal=paidInterestRes.amount;//Ontvangen aflossingen en rentes;
var receivedKeys=['stortenSpaargeld','lenenAanLand'];var receivedKeysNoAmount=[];//['stortenSpaargeld'];
var receivedInterestRes=getInterest(gameStateInput,receivedKeys,receivedKeysNoAmount);var receivedInterest=receivedInterestRes.items;var receivedInterestTotal=receivedInterestRes.amount;var toDisplay=[{title:'mhgvtoverzichtsparenlenen',items:[{title:Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])('sim_geleend_gekregen_of_opgenomen'),extraInfo:'(+)',points:plusTotal,items:plus,pending:plusReadMap.includes(true),readMap:plusReadMap,keys:plusKeys},{title:Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])('sim_uitgeleend_geschonken_of_gespaard'),extraInfo:'(-)',points:minusTotal,items:minus,pending:minusReadMap.includes(true),readMap:minusReadMap,keys:minusKeys},{title:Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])('sim_betaalde_aflossingen_en_rentes'),extraInfo:'(-)',items:paidInterest,points:paidInterestTotal},{title:Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])('sim_ontvangen_aflossingen_en_rentes'),extraInfo:'(+)',points:receivedInterestTotal,items:receivedInterest}]}];return toDisplay;}function getKeys(dispatch,gameStateInput,keys,confirmationKeys){var states=gameStateInput.states,myState=gameStateInput.myState;var debitCredit=myState.debitCredit;if(!debitCredit)debitCredit={};var country=myState.theme;var rainbow={lenenVanLand:'lenenAanLand',lenenAanLand:'lenenVanLand',lenenVanLandNotConfirmed:'lenenAanLandNotConfirmed',lenenAanLandNotConfirmed:'lenenVanLandNotConfirmed'};var accumulative=0;var results=Object.keys(debitCredit).map(function(targetKey,index){//Check if object's key is applicable to this category;
if(keys.includes(targetKey)){var dbCr=debitCredit[targetKey];if(dbCr.amount===undefined||dbCr.amount===0)return false;//Check if confirmed self.
if(dbCr.confirmed!==true){return false;}//Defaultvalue for pending is false: a transaction doesn't require another player's confimation
var isPending=false;//Check if item requires confirmation
if(confirmationKeys.includes(targetKey)){//Check if the user has defined the country to close a deal with
if(dbCr.otherCountry===undefined)return false;//Check if states are set, if yes, find values...
isPending=Object.keys(states).length===0&&states.constructor===Object?undefined:Object.keys(states[gameStateInput.currentRound]).find(function(current){//Escape if it's my round.
if(current===gameStateInput.groupId.toString())return false;//Working object to compare data with.
var extDbCr=states[gameStateInput.currentRound][current].debitCredit;//Find the corresponding key from the enternal entity,
//if it doesn't exist, stop.
if(!(rainbow[targetKey]in extDbCr))return false;//Get data from object to compare.
var rec=extDbCr[rainbow[targetKey]];//Check data and return if they match.
if(rec.otherCountry===country&&rec.amount===dbCr.amount&&rec.interest===dbCr.interest){//Check if other user confirmed input
if(rec.confirmed!==true){return false;}if(targetKey==='lenenVanLandNotConfirmed'){if(extDbCr.globas<rec.amount){return false;}else{if(dispatch!==false&&!('lenenVanLand'in debitCredit)){dispatch(updateMyState({debitCredit:_extends({},debitCredit,{lenenVanLand:debitCredit.lenenVanLandNotConfirmed})}));}}}if(targetKey==='lenenAanLandNotConfirmed'){if(dispatch!==false&&'lenenVanLand'in extDbCr&&!('lenenAanLand'in debitCredit)){dispatch(updateMyState({debitCredit:_extends({},debitCredit,{lenenAanLand:debitCredit.lenenAanLandNotConfirmed})}));}}return true;}return false;});//Make result human readable.
isPending=isPending===undefined?true:false;}//Select icon for transaction
var icon=__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_bank_png___default.a;if(confirmationKeys.includes(targetKey)||targetKey==='schenkAanLand'){icon=getCountryIcon(dbCr.otherCountry);}//Add cummulative money earned
accumulative+=isPending?0:dbCr.amount;var title=void 0;switch(targetKey){case'lenenAanLandNotConfirmed':title='leningAanLand';break;case'lenenVanLandNotConfirmed':title='leningVanLand';break;default:title=targetKey;break;}return{title:Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(title)+" "+(dbCr.otherCountry!==undefined?Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(dbCr.otherCountry).toLowerCase():""),pending:isPending,key:targetKey,points:dbCr.amount,icon:icon};}else{return false;}}).filter(Boolean);return{items:results,amount:accumulative};}function getInterest(gameStateInput,keys){var noAmountKeys=arguments.length>2&&arguments[2]!==undefined?arguments[2]:[];var states=gameStateInput.states;var myGroupId=gameStateInput.groupId;var currentRound=gameStateInput.currentRound;var accumulative=0;var savingsInterest=0;if(gameStateInput.myState.oneTimeEffect.debitCredit){savingsInterest=Object.values(gameStateInput.myState.oneTimeEffect.debitCredit).filter(function(o){return o.key==="stortenSpaargeld";}).reduce(function(accumilator,entry){return accumilator+-entry.interest;},0);}var depositFlag=0;var results=Object.keys(states).reduce(function(array,current,index){//Only check for previous two rounds
if(index<currentRound-2){return array;}if(index>currentRound-1){return array;}var values=Object.keys(states[current]).reduce(function(arr,key){//If the current group isn't mine, stop;
if(key!==myGroupId.toString())return arr;var items=[];//Check if key exists in object
if(states[current].hasOwnProperty(key)){//Store as working object.
var dbCr=states[current][key].debitCredit;for(var _key in dbCr){if(keys.includes(_key)){var curDbCr=dbCr[_key];//check if item is confirmed by user
if(curDbCr.confirmed!==true){continue;}//calculate how many rounds it has been since the deal was made
var passedRounds=currentRound-parseInt(current,10);var interest=0;var amount=0;//Check what calculation has to be made based on amount of rounds passed
if(_key==='stortenSpaargeld'){if(depositFlag===0){amount=savingsInterest;accumulative+=interest+amount;depositFlag=1;}}else if(currentRound===4&&passedRounds===1){amount=curDbCr.interest;if(!noAmountKeys.includes(_key)){amount+=curDbCr.amount;}accumulative+=interest+amount;}else if(passedRounds>1){//Two rounds ago
amount=curDbCr.interest/2;if(!noAmountKeys.includes(_key)){amount+=curDbCr.amount/2;}accumulative+=Math.floor(amount+interest);}else{//Happened in previous round
amount=curDbCr.interest/2;if(!noAmountKeys.includes(_key)){amount+=curDbCr.amount/2;}amount=Math.ceil(amount);accumulative+=Math.ceil(amount+interest);}//Select icon for transaction
var icon=__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_bank_png___default.a;if(curDbCr.otherCountry!==undefined){icon=__WEBPACK_IMPORTED_MODULE_1__assets_assets__["c" /* groupIcons */][Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(curDbCr.otherCountry).toLowerCase()];}var entryTitleRainbow={"lenenVanLand":"leningVanLand","lenenAanLand":"leningAanLand"};var keyForEntryTitle=entryTitleRainbow[_key]||_key;var entryTitle=Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])('sim_aflossing')+" "+Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(keyForEntryTitle).replace(/^\w/,function(c){return c.toLowerCase();})+" "+(curDbCr.otherCountry!==undefined?Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])(curDbCr.otherCountry):"");if(interest>0||amount>0){items.push({title:_key==='stortenSpaargeld'?Object(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["a" /* __ */])('sim_rente_op_spaargeld'):entryTitle,pending:false,points:Math.floor(interest+amount),icon:icon});}}}}return items;},[]);return array.concat.apply(array,_toConsumableArray(values));},[]);return{items:results,amount:accumulative};}function getUnreadGifts(gameStateInput){var unreadGifts=false;if(gameStateInput){var states=gameStateInput.states;var index=Object.keys(states).length-2;var inputs=states[index];if(inputs){var entries=Object.entries(inputs);var groupId=gameStateInput.groupId;unreadGifts=entries.map(function(c){if(c[0]===groupId||c[0]===groupId.toString())return false;var gsInput=c[1];var dbCrArr=gsInput.debitCredit;if(!dbCrArr.hasOwnProperty('schenkAanLand'))return false;if(dbCrArr['schenkAanLand'].otherCountry===gameStateInput.myState.theme&&dbCrArr['schenkAanLand'].confirmed){return _extends({},dbCrArr['schenkAanLand'],{fromCountry:gsInput.theme});}return false;}).filter(Boolean);}}if(unreadGifts!==false){var data=sessionStorage.getItem('debitCreditGifts');data=JSON.parse(data);if(!data||!(gameStateInput.myState.roundId in data)){data={};if(unreadGifts&&unreadGifts.length>0){data[gameStateInput.myState.roundId]=unreadGifts;sessionStorage.setItem('debitCreditGifts',JSON.stringify(data));}return false;}else{var round=data[gameStateInput.myState.roundId];//Compare new and old
var changes=round.map(function(c){var amount=c.amount,fromCountry=c.fromCountry;var match=unreadGifts.find(function(d){return d.amount===amount&&d.fromCountry===fromCountry;});if(match){return false;}return c;}).filter(Boolean);round=[].concat(_toConsumableArray(round),_toConsumableArray(changes));data[gameStateInput.myState.roundId]=round;sessionStorage.setItem('debitCreditGifts',JSON.stringify(data));}return data[gameStateInput.myState.roundId].some(function(c){return c.unread===true;});}return false;}function setGiftsRead(gameStateInput){var data=sessionStorage.getItem('debitCreditGifts');data=JSON.parse(data);if(data&&gameStateInput.myState.roundId in data){var round=data[gameStateInput.myState.roundId];round=round.map(function(r){r.unread=false;return r;});data[gameStateInput.myState.roundId]=round;sessionStorage.setItem('debitCreditGifts',JSON.stringify(data));}}

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var setFavicon=function setFavicon(url){var link=document.querySelector("link[rel*='icon']")||document.createElement('link');link.type='image/png';link.rel='icon';link.href=url;document.getElementsByTagName('head')[0].appendChild(link);};var setWindowTitle=function setWindowTitle(title){window.document.title=title;};/* harmony default export */ __webpack_exports__["a"] = ({setFavicon:setFavicon,setWindowTitle:setWindowTitle});

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(451);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(104);

var callBindBasic = __webpack_require__(142);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(221);
var enumBugKeys = __webpack_require__(154);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/belasting-6.5cdddaa5.svg";

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ws__ = __webpack_require__(170);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var updateInputStates=function updateInputStates(states,updateOwnGroup){return function(dispatch,getState){var ms=undefined;var _getState$gameStateIn=getState().gameStateInput,groupId=_getState$gameStateIn.groupId,myState=_getState$gameStateIn.myState;if(states[myState.roundNumber]){ms=states[myState.roundNumber][groupId];}dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["y" /* UPDATE_INPUT_STATES */],payload:{updateOwnGroup:updateOwnGroup,states:states,myState:ms}});};};var updateMyState=function updateMyState(state){return function(dispatch,getState){var _getState=getState(),gameStateInput=_getState.gameStateInput;if(gameStateInput.myState.joined&&gameStateInput.preventInputChanges)return;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["z" /* UPDATE_MY_STATE */],payload:state});};};var finishedStep=function finishedStep(gameStateInput){return function(dispatch,getState){var _getState2=getState(),group=_getState2.group,gsi=_getState2.gameStateInput;var payload={states:gameStateInput.states,myLatestState:_extends({},gameStateInput.states[gsi.myLatestState.roundNumber][group.id],{showSavedPopup:gameStateInput.step})};dispatch({type:'FINISHED_STEP',payload:payload});};};var submitMyState=function submitMyState(step){return function(dispatch,getState){var _getState3=getState(),group=_getState3.group,schoolClass=_getState3.schoolClass,gameStateInput=_getState3.gameStateInput;if(gameStateInput.myState.joined&&gameStateInput.preventInputChanges)return;var myState=gameStateInput.myState;if(myState[step]==='PROCESSED'||myState.SIMULATION_TAX==='SUBMITTED'||myState.SIMULATION_TAX_2==='SUBMITTED'||myState.SIMULATION_SPENDING==='SUBMITTED')return;var input=_extends({},myState,_defineProperty({},step,'SUBMITTED'));if(window.socket){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["m" /* SUBMIT_MY_STATE */],payload:input});window.socket.emit('updatedInput',{who:group.id,schoolClassId:schoolClass.id,room:'simulationgame-'+schoolClass.id,input:input},__WEBPACK_IMPORTED_MODULE_1__ws__["b" /* handleFailedEmit */]);}};};/* harmony default export */ __webpack_exports__["a"] = ({updateInputStates:updateInputStates,updateMyState:updateMyState,finishedStep:finishedStep,submitMyState:submitMyState});

/***/ }),
/* 92 */
/***/ (function(module, exports) {

function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScoreRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ScoreDiv__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ScoreImgDiv__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_udown_green_svg__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_udown_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_udown_green_svg__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScoreRow=(_temp=_class=function(_Component){_inherits(ScoreRow,_Component);function ScoreRow(props){_classCallCheck(this,ScoreRow);var _this=_possibleConstructorReturn(this,(ScoreRow.__proto__||Object.getPrototypeOf(ScoreRow)).call(this,props));_this.state={text:_this.props.text,score:_this.props.score,showMedal:_this.props.showMedal,showArrow:_this.props.showArrow,to:_this.props.to.length?_this.props.to:false};return _this;}_createClass(ScoreRow,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(state){this.setState(_extends({},this.state,state));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-row '+this.props.className},this.state.to?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{className:'score-row-inner'+(this.state.showArrow?' has-arrow':''),to:this.state.to,href:this.state.to},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.text,this.state.showArrow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'arrow-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'greenArrow',src:__WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_udown_green_svg___default.a})):'')):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-row-inner'+(this.state.showArrow?' has-arrow':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.state.text,this.state.showArrow?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'arrow-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'greenArrow',src:__WEBPACK_IMPORTED_MODULE_5__assets_img_arrow_udown_green_svg___default.a})):'')),!this.props.imgs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ScoreDiv__["a" /* default */],{text:String(this.state.score),imgs:this.props.imgs,showMedal:this.state.showMedal}):null,this.props.imgs?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ScoreImgDiv__["a" /* default */],{imgs:this.props.imgs}):null);}}]);return ScoreRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,score:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number]),to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={showArrow:false,showMedal:false,score:0,to:'',className:''},_temp);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/budget.f82954de.png";

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BudgetSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rc_slider__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_doubleTapHelper__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_slider_assets_index_css__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rc_slider_assets_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rc_slider_assets_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BudgetSlider=(_temp=_class=function(_Component){_inherits(BudgetSlider,_Component);function BudgetSlider(props){_classCallCheck(this,BudgetSlider);var _this=_possibleConstructorReturn(this,(BudgetSlider.__proto__||Object.getPrototypeOf(BudgetSlider)).call(this,props));_this.setValue=_this.setValue.bind(_this);_this.onBlur=_this.onBlur.bind(_this);return _this;}_createClass(BudgetSlider,[{key:'setValue',value:function setValue(val,target){if(this.props.disabled)return false;var value=parseInt(val,10)||0;if(!this.props.ignoreMax&&value>this.props.max)value=this.props.max;if(value<this.props.min)value=this.props.min;if(target)target.value=value;this.props.customOnChange(this.props.onChangeKey,value);}},{key:'onBlur',value:function onBlur(e){if(this.props.disabled)return false;this.focussed=false;if(e.target.value===''||e.target.value===null){e.target.value=this.props.value;}this.setValue(e.target.value.replace(',','.'),e.target);}},{key:'shouldComponentUpdate',value:function shouldComponentUpdate(nextProps,nextState,nextContext){return!this.focussed;}},{key:'render',value:function render(){var _this2=this;var valueMain=void 0;var valueSecond=void 0;var _props=this.props,suffix=_props.suffix,min=_props.min,max=_props.max,value=_props.value,twoValueSlider=_props.twoValueSlider;if(!value&&value!==0)value=Math.floor((max-min)/2+min);if(twoValueSlider){valueSecond=value;valueMain=max-parseInt(valueSecond,10);}else{valueMain=value;}if(this.secondInput)this.secondInput.value=valueSecond;if(this.input)this.input.value=valueMain;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-container'+(this.props.twoValueSlider?' two-value':'')+(suffix?' suffix':'')+(this.props.role==='groupmember'?' groupmember-disabled':'')+(this.props.disabled?' disabled':'')},this.props.titles?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-titles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.titles[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.titles[1])):null,this.props.twoValueSlider?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:this.props.min,max:this.props.ignoreMax?Infinity:this.props.max,onChange:function onChange(ev){if(_this2.props.disabled)return false;if(parseInt(ev.target.value,10)>_this2.props.max&&!_this2.props.ignoreMax){ev.target.value=_this2.props.max;}_this2.setValue(ev.target.value,null);},onFocus:function onFocus(ev){_this2.focussed=true;ev.target.value=null;},onBlur:this.onBlur,onClick:function onClick(ev){return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_doubleTapHelper__["a" /* doubletapSelect */])(ev);},defaultValue:valueSecond,ref:function ref(_ref){return _this2.secondInput=_ref;},pattern:'[0-9]*',className:'value-container'}),suffix?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-input-suffix'},suffix):null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_rc_slider__["a" /* default */],{min:this.props.min?this.props.min:0,max:this.props.max,defaultValue:value,value:value>this.props.max?this.props.max:value,onChange:function onChange(ev){if(_this2.props.disabled)return false;_this2.setValue(parseInt(ev,10),null);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-input-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'number',min:this.props.min,max:this.props.ignoreMax?Infinity:this.props.max,onChange:function onChange(ev){if(_this2.props.disabled)return false;if(parseInt(ev.target.value,10)>_this2.props.max&&!_this2.props.ignoreMax){ev.target.value=_this2.props.max;}_this2.setValue(ev.target.value,null);},onClick:function onClick(ev){return Object(__WEBPACK_IMPORTED_MODULE_2__helpers_doubleTapHelper__["a" /* doubletapSelect */])(ev);},onFocus:function onFocus(ev){_this2.focussed=true;ev.target.value=null;},onBlur:this.onBlur,defaultValue:valueMain,ref:function ref(_ref2){return _this2.input=_ref2;},disabled:this.props.twoValueSlider,pattern:'[0-9]*',className:'value-container'}),this.props.unit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:this.props.unit},this.props.unit):null,suffix?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-input-suffix'},suffix):null));}}]);return BudgetSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={unit:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,max:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,ignoreMax:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,min:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,value:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number,disabled:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool},_class.defaultProps={max:0,min:0,ignoreMax:false,disabled:false},_temp);

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Meta
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Image meta data handling implementation
 * based on the help and contribution of
 * Achim Stöhr.
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, DataView, Uint8Array */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var hasblobSlice =
    typeof Blob !== 'undefined' &&
    (Blob.prototype.slice ||
      Blob.prototype.webkitSlice ||
      Blob.prototype.mozSlice)

  loadImage.blobSlice =
    hasblobSlice &&
    function () {
      var slice = this.slice || this.webkitSlice || this.mozSlice
      return slice.apply(this, arguments)
    }

  loadImage.metaDataParsers = {
    jpeg: {
      0xffe1: [], // APP1 marker
      0xffed: [] // APP13 marker
    }
  }

  // Parses image meta data and calls the callback with an object argument
  // with the following properties:
  // * imageHead: The complete image head as ArrayBuffer (Uint8Array for IE10)
  // The options argument accepts an object and supports the following
  // properties:
  // * maxMetaDataSize: Defines the maximum number of bytes to parse.
  // * disableImageHead: Disables creating the imageHead property.
  loadImage.parseMetaData = function (file, callback, options, data) {
    // eslint-disable-next-line no-param-reassign
    options = options || {}
    // eslint-disable-next-line no-param-reassign
    data = data || {}
    var that = this
    // 256 KiB should contain all EXIF/ICC/IPTC segments:
    var maxMetaDataSize = options.maxMetaDataSize || 262144
    var noMetaData = !(
      typeof DataView !== 'undefined' &&
      file &&
      file.size >= 12 &&
      file.type === 'image/jpeg' &&
      loadImage.blobSlice
    )
    if (
      noMetaData ||
      !loadImage.readFile(
        loadImage.blobSlice.call(file, 0, maxMetaDataSize),
        function (e) {
          if (e.target.error) {
            // FileReader error
            // eslint-disable-next-line no-console
            console.log(e.target.error)
            callback(data)
            return
          }
          // Note on endianness:
          // Since the marker and length bytes in JPEG files are always
          // stored in big endian order, we can leave the endian parameter
          // of the DataView methods undefined, defaulting to big endian.
          var buffer = e.target.result
          var dataView = new DataView(buffer)
          var offset = 2
          var maxOffset = dataView.byteLength - 4
          var headLength = offset
          var markerBytes
          var markerLength
          var parsers
          var i
          // Check for the JPEG marker (0xffd8):
          if (dataView.getUint16(0) === 0xffd8) {
            while (offset < maxOffset) {
              markerBytes = dataView.getUint16(offset)
              // Search for APPn (0xffeN) and COM (0xfffe) markers,
              // which contain application-specific meta-data like
              // Exif, ICC and IPTC data and text comments:
              if (
                (markerBytes >= 0xffe0 && markerBytes <= 0xffef) ||
                markerBytes === 0xfffe
              ) {
                // The marker bytes (2) are always followed by
                // the length bytes (2), indicating the length of the
                // marker segment, which includes the length bytes,
                // but not the marker bytes, so we add 2:
                markerLength = dataView.getUint16(offset + 2) + 2
                if (offset + markerLength > dataView.byteLength) {
                  // eslint-disable-next-line no-console
                  console.log('Invalid meta data: Invalid segment size.')
                  break
                }
                parsers = loadImage.metaDataParsers.jpeg[markerBytes]
                if (parsers && !options.disableMetaDataParsers) {
                  for (i = 0; i < parsers.length; i += 1) {
                    parsers[i].call(
                      that,
                      dataView,
                      offset,
                      markerLength,
                      data,
                      options
                    )
                  }
                }
                offset += markerLength
                headLength = offset
              } else {
                // Not an APPn or COM marker, probably safe to
                // assume that this is the end of the meta data
                break
              }
            }
            // Meta length must be longer than JPEG marker (2)
            // plus APPn marker (2), followed by length bytes (2):
            if (!options.disableImageHead && headLength > 6) {
              if (buffer.slice) {
                data.imageHead = buffer.slice(0, headLength)
              } else {
                // Workaround for IE10, which does not yet
                // support ArrayBuffer.slice:
                data.imageHead = new Uint8Array(buffer).subarray(0, headLength)
              }
            }
          } else {
            // eslint-disable-next-line no-console
            console.log('Invalid JPEG file: Missing JPEG marker.')
          }
          callback(data)
        },
        'readAsArrayBuffer'
      )
    ) {
      callback(data)
    }
  }

  // Replaces the image head of a JPEG blob with the given one.
  // Calls the callback with the new Blob:
  loadImage.replaceHead = function (blob, head, callback) {
    loadImage.parseMetaData(
      blob,
      function (data) {
        callback(
          new Blob(
            [head, loadImage.blobSlice.call(blob, data.imageHead.byteLength)],
            { type: 'image/jpeg' }
          )
        )
      },
      { maxMetaDataSize: 256, disableMetaDataParsers: true }
    )
  }

  // Determines if meta data should be loaded automatically:
  loadImage.hasMetaOption = function (options) {
    return options && options.meta
  }

  var originalTransform = loadImage.transform
  loadImage.transform = function (img, options, callback, file, data) {
    if (loadImage.hasMetaOption(options)) {
      loadImage.parseMetaData(
        file,
        function (data) {
          originalTransform.call(loadImage, img, options, callback, file, data)
        },
        options,
        data
      )
    } else {
      originalTransform.apply(loadImage, arguments)
    }
  }
})


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _extends; });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "legacy_createStore", function() { return legacy_createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(387);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(140);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(202);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(204)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(433);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(141);

var $Error = __webpack_require__(435);
var $EvalError = __webpack_require__(436);
var $RangeError = __webpack_require__(437);
var $ReferenceError = __webpack_require__(438);
var $SyntaxError = __webpack_require__(203);
var $TypeError = __webpack_require__(49);
var $URIError = __webpack_require__(439);

var abs = __webpack_require__(440);
var floor = __webpack_require__(441);
var max = __webpack_require__(442);
var min = __webpack_require__(443);
var pow = __webpack_require__(444);
var round = __webpack_require__(445);
var sign = __webpack_require__(446);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(103);
var $defineProperty = __webpack_require__(102);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(448)();

var getProto = __webpack_require__(449);
var $ObjectGPO = __webpack_require__(208);
var $ReflectGPO = __webpack_require__(207);

var $apply = __webpack_require__(144);
var $call = __webpack_require__(143);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(86);
var hasOwn = __webpack_require__(453);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(471)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(217)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(481);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(483);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(515);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIP;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ipv4Maybe = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
var ipv6Block = /^[0-9A-F]{1,4}$/i;

function isIP(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isIP(str, 4) || isIP(str, 6);
  } else if (version === '4') {
    if (!ipv4Maybe.test(str)) {
      return false;
    }

    var parts = str.split('.').sort(function (a, b) {
      return a - b;
    });
    return parts[3] <= 255;
  } else if (version === '6') {
    var blocks = str.split(':');
    var foundOmissionBlock = false; // marker to indicate ::
    // At least some OS accept the last 32 bits of an IPv6 address
    // (i.e. 2 of the blocks) in IPv4 notation, and RFC 3493 says
    // that '::ffff:a.b.c.d' is valid for IPv4-mapped IPv6 addresses,
    // and '::a.b.c.d' is deprecated, but also valid.

    var foundIPv4TransitionBlock = isIP(blocks[blocks.length - 1], 4);
    var expectedNumberOfBlocks = foundIPv4TransitionBlock ? 7 : 8;

    if (blocks.length > expectedNumberOfBlocks) {
      return false;
    } // initial or final ::


    if (str === '::') {
      return true;
    } else if (str.substr(0, 2) === '::') {
      blocks.shift();
      blocks.shift();
      foundOmissionBlock = true;
    } else if (str.substr(str.length - 2) === '::') {
      blocks.pop();
      blocks.pop();
      foundOmissionBlock = true;
    }

    for (var i = 0; i < blocks.length; ++i) {
      // test for a :: which can not be at the string start/end
      // since those cases have been handled above
      if (blocks[i] === '' && i > 0 && i < blocks.length - 1) {
        if (foundOmissionBlock) {
          return false; // multiple :: in address
        }

        foundOmissionBlock = true;
      } else if (foundIPv4TransitionBlock && i === blocks.length - 1) {// it has been checked before that the last
        // block is a valid IPv4 address
      } else if (!ipv6Block.test(blocks[i])) {
        return false;
      }
    }

    if (foundOmissionBlock) {
      return blocks.length >= 1;
    }

    return blocks.length === expectedNumberOfBlocks;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.commaDecimal = exports.dotDecimal = exports.arabicLocales = exports.englishLocales = exports.decimal = exports.alphanumeric = exports.alpha = void 0;
var alpha = {
  'en-US': /^[A-Z]+$/i,
  'bg-BG': /^[А-Я]+$/i,
  'cs-CZ': /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[A-ZÆØÅ]+$/i,
  'de-DE': /^[A-ZÄÖÜß]+$/i,
  'el-GR': /^[Α-ω]+$/i,
  'es-ES': /^[A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'nb-NO': /^[A-ZÆØÅ]+$/i,
  'nl-NL': /^[A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[A-ZÆØÅ]+$/i,
  'hu-HU': /^[A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'pl-PL': /^[A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[А-ЯЁ]+$/i,
  'sl-SI': /^[A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[A-ZÅÄÖ]+$/i,
  'tr-TR': /^[A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[А-ЩЬЮЯЄIЇҐі]+$/i,
  'ku-IQ': /^[ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};
exports.alpha = alpha;
var alphanumeric = {
  'en-US': /^[0-9A-Z]+$/i,
  'bg-BG': /^[0-9А-Я]+$/i,
  'cs-CZ': /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]+$/i,
  'da-DK': /^[0-9A-ZÆØÅ]+$/i,
  'de-DE': /^[0-9A-ZÄÖÜß]+$/i,
  'el-GR': /^[0-9Α-ω]+$/i,
  'es-ES': /^[0-9A-ZÁÉÍÑÓÚÜ]+$/i,
  'fr-FR': /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]+$/i,
  'it-IT': /^[0-9A-ZÀÉÈÌÎÓÒÙ]+$/i,
  'hu-HU': /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]+$/i,
  'nb-NO': /^[0-9A-ZÆØÅ]+$/i,
  'nl-NL': /^[0-9A-ZÁÉËÏÓÖÜÚ]+$/i,
  'nn-NO': /^[0-9A-ZÆØÅ]+$/i,
  'pl-PL': /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]+$/i,
  'pt-PT': /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]+$/i,
  'ru-RU': /^[0-9А-ЯЁ]+$/i,
  'sl-SI': /^[0-9A-ZČĆĐŠŽ]+$/i,
  'sk-SK': /^[0-9A-ZÁČĎÉÍŇÓŠŤÚÝŽĹŔĽÄÔ]+$/i,
  'sr-RS@latin': /^[0-9A-ZČĆŽŠĐ]+$/i,
  'sr-RS': /^[0-9А-ЯЂЈЉЊЋЏ]+$/i,
  'sv-SE': /^[0-9A-ZÅÄÖ]+$/i,
  'tr-TR': /^[0-9A-ZÇĞİıÖŞÜ]+$/i,
  'uk-UA': /^[0-9А-ЩЬЮЯЄIЇҐі]+$/i,
  'ku-IQ': /^[٠١٢٣٤٥٦٧٨٩0-9ئابپتجچحخدرڕزژسشعغفڤقکگلڵمنوۆھەیێيطؤثآإأكضصةظذ]+$/i,
  ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]+$/
};
exports.alphanumeric = alphanumeric;
var decimal = {
  'en-US': '.',
  ar: '٫'
};
exports.decimal = decimal;
var englishLocales = ['AU', 'GB', 'HK', 'IN', 'NZ', 'ZA', 'ZM'];
exports.englishLocales = englishLocales;

for (var locale, i = 0; i < englishLocales.length; i++) {
  locale = "en-".concat(englishLocales[i]);
  alpha[locale] = alpha['en-US'];
  alphanumeric[locale] = alphanumeric['en-US'];
  decimal[locale] = decimal['en-US'];
} // Source: http://www.localeplanet.com/java/


var arabicLocales = ['AE', 'BH', 'DZ', 'EG', 'IQ', 'JO', 'KW', 'LB', 'LY', 'MA', 'QM', 'QA', 'SA', 'SD', 'SY', 'TN', 'YE'];
exports.arabicLocales = arabicLocales;

for (var _locale, _i = 0; _i < arabicLocales.length; _i++) {
  _locale = "ar-".concat(arabicLocales[_i]);
  alpha[_locale] = alpha.ar;
  alphanumeric[_locale] = alphanumeric.ar;
  decimal[_locale] = decimal.ar;
} // Source: https://en.wikipedia.org/wiki/Decimal_mark


var dotDecimal = [];
exports.dotDecimal = dotDecimal;
var commaDecimal = ['bg-BG', 'cs-CZ', 'da-DK', 'de-DE', 'el-GR', 'es-ES', 'fr-FR', 'it-IT', 'ku-IQ', 'hu-HU', 'nb-NO', 'nn-NO', 'nl-NL', 'pl-PL', 'pt-PT', 'ru-RU', 'sl-SI', 'sr-RS@latin', 'sr-RS', 'sv-SE', 'tr-TR', 'uk-UA'];
exports.commaDecimal = commaDecimal;

for (var _i2 = 0; _i2 < dotDecimal.length; _i2++) {
  decimal[dotDecimal[_i2]] = decimal['en-US'];
}

for (var _i3 = 0; _i3 < commaDecimal.length; _i3++) {
  decimal[commaDecimal[_i3]] = ',';
}

alpha['pt-BR'] = alpha['pt-PT'];
alphanumeric['pt-BR'] = alphanumeric['pt-PT'];
decimal['pt-BR'] = decimal['pt-PT']; // see #862

alpha['pl-Pl'] = alpha['pl-PL'];
alphanumeric['pl-Pl'] = alphanumeric['pl-PL'];
decimal['pl-Pl'] = decimal['pl-PL'];

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/global.dde7f1c2.svg";

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/globas.b5613837.svg";

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/beleidskeuze.04d9d355.svg";

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/belasting-1.f5f6f1c0.svg";

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/belasting-2.1f24c444.svg";

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/belasting-3.0294033c.svg";

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/belasting-4.f24f2402.svg";

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/L-belasting-1.13a5a7a1.svg";

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 122 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFullscreenChange = handleFullscreenChange;
exports.activate = activate;
exports.userActivate = userActivate;
exports.play = play;
exports.pause = pause;
exports.togglePlay = togglePlay;
exports.seek = seek;
exports.forward = forward;
exports.replay = replay;
exports.changeRate = changeRate;
exports.changeVolume = changeVolume;
exports.mute = mute;
exports.toggleFullscreen = toggleFullscreen;
exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;

var _fullscreen = _interopRequireDefault(__webpack_require__(292));

var OPERATE = 'video-react/OPERATE';
exports.OPERATE = OPERATE;
var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
exports.USER_ACTIVATE = USER_ACTIVATE;

function handleFullscreenChange(isFullscreen) {
  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: isFullscreen
  };
}

function activate(activity) {
  return {
    type: PLAYER_ACTIVATE,
    activity: activity
  };
}

function userActivate(activity) {
  return {
    type: USER_ACTIVATE,
    activity: activity
  };
}

function play() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'play',
    source: ''
  };
  this.video.play();
  return {
    type: OPERATE,
    operation: operation
  };
}

function pause() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'pause',
    source: ''
  };
  this.video.pause();
  return {
    type: OPERATE,
    operation: operation
  };
}

function togglePlay() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'toggle-play',
    source: ''
  };
  this.video.togglePlay();
  return {
    type: OPERATE,
    operation: operation
  };
} // seek video by time


function seek(time) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'seek',
    source: ''
  };
  this.video.seek(time);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump forward x seconds


function forward(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "forward-".concat(seconds),
    source: ''
  };
  this.video.forward(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump back x seconds


function replay(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "replay-".concat(seconds),
    source: ''
  };
  this.video.replay(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeRate(rate) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-rate',
    source: ''
  };
  this.video.playbackRate = rate;
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeVolume(volume) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-volume',
    source: ''
  };
  var v = volume;

  if (volume < 0) {
    v = 0;
  }

  if (volume > 1) {
    v = 1;
  }

  this.video.volume = v;
  return {
    type: OPERATE,
    operation: operation
  };
}

function mute(muted) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: muted ? 'muted' : 'unmuted',
    source: ''
  };
  this.video.muted = muted;
  return {
    type: OPERATE,
    operation: operation
  };
}

function toggleFullscreen(player) {
  if (_fullscreen["default"].enabled) {
    if (_fullscreen["default"].isFullscreen) {
      _fullscreen["default"].exit();
    } else {
      _fullscreen["default"].request(this.rootElement);
    }

    return {
      type: OPERATE,
      operation: {
        action: 'toggle-fullscreen',
        source: ''
      }
    };
  }

  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: !player.isFullscreen
  };
}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findElPosition = findElPosition;
exports.getPointerPosition = getPointerPosition;
exports.blurNode = blurNode;
exports.focusNode = focusNode;
exports.hasClass = hasClass;

var _reactDom = __webpack_require__(32);

/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param {Element} el Element from which to get offset
 * @return {Object}
 */
function findElPosition(el) {
  var box;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var _document = document,
      body = _document.body,
      docEl = _document.documentElement;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round

  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}
/**
 * Get pointer position in element
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param {Element} el Element on which to get the pointer position on
 * @param {Event} event Event object
 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
 */


function getPointerPosition(el, event) {
  var position = {};
  var box = findElPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;
  var boxY = box.top;
  var boxX = box.left;
  var evtPageY = event.pageY;
  var evtPageX = event.pageX;

  if (event.changedTouches) {
    evtPageX = event.changedTouches[0].pageX;
    evtPageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
  return position;
} // blur an element


function blurNode(reactNode) {
  var domNode = (0, _reactDom.findDOMNode)(reactNode);

  if (domNode && domNode.blur) {
    domNode.blur();
  }
} // focus an element


function focusNode(reactNode) {
  var domNode = (0, _reactDom.findDOMNode)(reactNode);

  if (domNode && domNode.focus) {
    domNode.focus();
  }
} // check if an element has a class name


function hasClass(elm, cls) {
  var classes = elm.className.split(' ');

  for (var i = 0; i < classes.length; i++) {
    if (classes[i].toLowerCase() === cls.toLowerCase()) {
      return true;
    }
  }

  return false;
}

/***/ }),
/* 125 */
/***/ (function(module, exports) {

var COMPLETE = 'complete',
    CANCELED = 'canceled';

function raf(task){
    if('requestAnimationFrame' in window){
        return window.requestAnimationFrame(task);
    }

    setTimeout(task, 16);
}

function setElementScroll(element, x, y){
    if(element.self === element){
        element.scrollTo(x, y);
    }else{
        element.scrollLeft = x;
        element.scrollTop = y;
    }
}

function getTargetScrollLocation(target, parent, align){
    var targetPosition = target.getBoundingClientRect(),
        parentPosition,
        x,
        y,
        differenceX,
        differenceY,
        targetWidth,
        targetHeight,
        leftAlign = align && align.left != null ? align.left : 0.5,
        topAlign = align && align.top != null ? align.top : 0.5,
        leftOffset = align && align.leftOffset != null ? align.leftOffset : 0,
        topOffset = align && align.topOffset != null ? align.topOffset : 0,
        leftScalar = leftAlign,
        topScalar = topAlign;

    if(parent.self === parent){
        targetWidth = Math.min(targetPosition.width, parent.innerWidth);
        targetHeight = Math.min(targetPosition.height, parent.innerHeight);
        x = targetPosition.left + parent.pageXOffset - parent.innerWidth * leftScalar + targetWidth * leftScalar;
        y = targetPosition.top + parent.pageYOffset - parent.innerHeight * topScalar + targetHeight * topScalar;
        x -= leftOffset;
        y -= topOffset;
        differenceX = x - parent.pageXOffset;
        differenceY = y - parent.pageYOffset;
    }else{
        targetWidth = targetPosition.width;
        targetHeight = targetPosition.height;
        parentPosition = parent.getBoundingClientRect();
        var offsetLeft = targetPosition.left - (parentPosition.left - parent.scrollLeft);
        var offsetTop = targetPosition.top - (parentPosition.top - parent.scrollTop);
        x = offsetLeft + (targetWidth * leftScalar) - parent.clientWidth * leftScalar;
        y = offsetTop + (targetHeight * topScalar) - parent.clientHeight * topScalar;
        x = Math.max(Math.min(x, parent.scrollWidth - parent.clientWidth), 0);
        y = Math.max(Math.min(y, parent.scrollHeight - parent.clientHeight), 0);
        x -= leftOffset;
        y -= topOffset;
        differenceX = x - parent.scrollLeft;
        differenceY = y - parent.scrollTop;
    }

    return {
        x: x,
        y: y,
        differenceX: differenceX,
        differenceY: differenceY
    };
}

function animate(parent){
    var scrollSettings = parent._scrollSettings;
    if(!scrollSettings){
        return;
    }

    var location = getTargetScrollLocation(scrollSettings.target, parent, scrollSettings.align),
        time = Date.now() - scrollSettings.startTime,
        timeValue = Math.min(1 / scrollSettings.time * time, 1);

    if(
        time > scrollSettings.time &&
        scrollSettings.endIterations > 3
    ){
        setElementScroll(parent, location.x, location.y);
        parent._scrollSettings = null;
        return scrollSettings.end(COMPLETE);
    }

    scrollSettings.endIterations++;

    var easeValue = 1 - scrollSettings.ease(timeValue);

    setElementScroll(parent,
        location.x - location.differenceX * easeValue,
        location.y - location.differenceY * easeValue
    );

    // At the end of animation, loop synchronously
    // to try and hit the taget location.
    if(time >= scrollSettings.time){
        return animate(parent);
    }

    raf(animate.bind(null, parent));
}
function transitionScrollTo(target, parent, settings, callback){
    var idle = !parent._scrollSettings,
        lastSettings = parent._scrollSettings,
        now = Date.now(),
        endHandler;

    if(lastSettings){
        lastSettings.end(CANCELED);
    }

    function end(endType){
        parent._scrollSettings = null;
        if(parent.parentElement && parent.parentElement._scrollSettings){
            parent.parentElement._scrollSettings.end(endType);
        }
        callback(endType);
        parent.removeEventListener('touchstart', endHandler, { passive: true });
        parent.removeEventListener('wheel', endHandler, { passive: true });
    }

    parent._scrollSettings = {
        startTime: lastSettings ? lastSettings.startTime : Date.now(),
        endIterations: 0,
        target: target,
        time: settings.time + (lastSettings ? now - lastSettings.startTime : 0),
        ease: settings.ease,
        align: settings.align,
        end: end
    };

    endHandler = end.bind(null, CANCELED);
    parent.addEventListener('touchstart', endHandler, { passive: true });
    parent.addEventListener('wheel', endHandler, { passive: true });

    if(idle){
        animate(parent);
    }
}

function defaultIsScrollable(element){
    return (
        'pageXOffset' in element ||
        (
            element.scrollHeight !== element.clientHeight ||
            element.scrollWidth !== element.clientWidth
        ) &&
        getComputedStyle(element).overflow !== 'hidden'
    );
}

function defaultValidTarget(){
    return true;
}

module.exports = function(target, settings, callback){
    if(!target){
        return;
    }

    if(typeof settings === 'function'){
        callback = settings;
        settings = null;
    }

    if(!settings){
        settings = {};
    }

    settings.time = isNaN(settings.time) ? 1000 : settings.time;
    settings.ease = settings.ease || function(v){return 1 - Math.pow(1 - v, v / 2);};

    var parent = target.parentElement,
        parents = 0;

    function done(endType){
        parents--;
        if(!parents){
            callback && callback(endType);
        }
    }

    var validTarget = settings.validTarget || defaultValidTarget;
    var isScrollable = settings.isScrollable;

    while(parent){
        if(validTarget(parent, parents) && (isScrollable ? isScrollable(parent, defaultIsScrollable) : defaultIsScrollable(parent))){
            parents++;
            transitionScrollTo(target, parent, settings, done);
        }

        parent = parent.parentElement;

        if(!parent){
            if(!parents){
                callback && callback(COMPLETE)
            }
            break;
        }

        if(parent.tagName === 'BODY'){
            parent = parent.ownerDocument;
            parent = parent.defaultView || parent.ownerWindow;
        }
    }
};


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_feedbackHelpers__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EconomyTotal=(_temp=_class=function(_Component){_inherits(EconomyTotal,_Component);function EconomyTotal(props){_classCallCheck(this,EconomyTotal);var _this=_possibleConstructorReturn(this,(EconomyTotal.__proto__||Object.getPrototypeOf(EconomyTotal)).call(this,props));_this.state={};return _this;}_createClass(EconomyTotal,[{key:'getTitle',value:function getTitle(f){if(f.belastingNaam){return f.belastingNaam;}else if(f.ministerie){return f.ministerie;}else if(f.ministerie_OE){return f.ministerie_OE;}else if(f.ministerie_OE_2){return f.ministerie_OE_2;}else if(f.type==="BELASTING"){return"sim_belastingkeuze";}else if(f.type==="BELEIDSKEUZE"){return f["titel_oplossing_"+this.props.gameState.language];}}},{key:'renderList',value:function renderList(title,sign,list){var _this2=this;if(!list)list=[];var total=list.reduce(function(r,f){return r+f.economie.winstverliesglobas;},0);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"table-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"left title"},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"right"},sign,' ',Math.abs(total),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))),list.map(function(f){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:f.id,className:"subitem"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"left title"},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_effect_vanuit')+': '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(_this2.getTitle(f))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"right"},sign,' ',Math.abs(f.economie.winstverliesglobas),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')));}));}},{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,feedback=_props.feedback;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];var winstGlobas=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(feedback.prevRoundFeedbackData,'profit');var verliesGlobas=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(feedback.prevRoundFeedbackData,'loss');if(!gameState.prevRound||!feedback.prevRoundFeedbackData)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__["a" /* default */],{className:'fade-in'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"table-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"left title"},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_earnedglobas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"right"},currentRoundGameState.earnedGlobas,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')))),this.renderList(Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_winstglobas'),'+',winstGlobas),this.renderList(Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),'-',verliesGlobas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"table-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'divider'},'-------------------------------'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"left title"},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_totalglobas')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"right"},gameState.totalEconomy,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')))));}}]);return EconomyTotal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,left:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,feedbackCount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,roundPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,economy:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,schoolClass=_ref.schoolClass;return{gameState:gameState,feedback:feedback,schoolClass:schoolClass};})(EconomyTotal));

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/beleidskeuze_L.796a6127.svg";

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SectionHeading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QuestionButton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PopupTitle__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SectionHeading=(_temp=_class=function(_Component){_inherits(SectionHeading,_Component);function SectionHeading(props){_classCallCheck(this,SectionHeading);var _this=_possibleConstructorReturn(this,(SectionHeading.__proto__||Object.getPrototypeOf(SectionHeading)).call(this,props));_this.state={};return _this;}_createClass(SectionHeading,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-heading-outer",style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-heading "+this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'section-heading-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:'section-heading-icon',src:this.props.icon})),this.props.popupId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PopupTitle__["a" /* default */],{popupId:this.props.popupId,tag:'h4'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,this.props.questionButton?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__QuestionButton__["a" /* default */],{popUpTitle:this.props.popUpTitle,popUpDescription:this.props.popUpDescription},this.props.title):this.props.title)));}}]);return SectionHeading;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={questionButton:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,style:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object},_class.defaultProps={className:'',questionButton:true,style:{}},_temp);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IncomeDetail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IncomeDetail=(_temp=_class=function(_Component){_inherits(IncomeDetail,_Component);function IncomeDetail(props){_classCallCheck(this,IncomeDetail);var _this=_possibleConstructorReturn(this,(IncomeDetail.__proto__||Object.getPrototypeOf(IncomeDetail)).call(this,props));_this.state={};return _this;}_createClass(IncomeDetail,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'income-detail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:this.props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.description)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'point-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:this.props.amount},this.props.amount),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:this.props.unit},this.props.unit))));}}]);return IncomeDetail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={img:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,description:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,amount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,unit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired},_temp);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_gameStateInput__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_VideoButton__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__QuestionButton__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var submitMyState=__WEBPACK_IMPORTED_MODULE_3__actions_gameStateInput__["a" /* default */].submitMyState,updateMyState=__WEBPACK_IMPORTED_MODULE_3__actions_gameStateInput__["a" /* default */].updateMyState;var TaxItemContainer=(_temp=_class=function(_Component){_inherits(TaxItemContainer,_Component);function TaxItemContainer(props){_classCallCheck(this,TaxItemContainer);var _this=_possibleConstructorReturn(this,(TaxItemContainer.__proto__||Object.getPrototypeOf(TaxItemContainer)).call(this,props));_initialiseProps.call(_this);_this.state={};return _this;}_createClass(TaxItemContainer,[{key:'render',value:function render(){var _this2=this;var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'+(props.visible?'':' inactive')},props.saving?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_PopUp__["a" /* default */],{isPortal:true,hideClose:true,showHeader:true,id:props.savingMessage,className:'imgCenter'}):null,props.showSavedPopup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_PopUp__["a" /* default */],{isPortal:true,hideClose:true,showHeader:true,id:props.feedbackMessage,className:'imgCenter',buttonText:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_bekijk_feedback'),closePopUpClick:function closePopUpClick(){props.dispatch(updateMyState({showSavedPopup:false}));_this2.setState({feedbackPopupDone:true});}}):null,props.buitenLandDialog&&this.state.feedbackPopupDone?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_PopUp__["a" /* default */],{isPortal:true,id:'dhgmstap2buitenland',buttonText:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_sluiten'),closePopUpClick:function closePopUpClick(){_this2.setState({feedbackPopupDone:false});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__QuestionButton__["a" /* default */],{popupId:props.popupId},props.title,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.part?' | '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_deel')+' '+props.part:'',' ')),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_VideoButton__["a" /* default */],{src:props.video})),props.children,!props.saved&&this.props.user.role==='groupleader'?props.project.difficulty==='BASIC'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'savebutton-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){ev.preventDefault();_this2.setState({showSavePopup:true});},className:'button'+(props.buttonConditions&&!props.gameStateInput.preventInputChanges?'':' disabled')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_opslaan'))),this.state.showSavePopup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_PopUp__["a" /* default */],{id:'dlgmstap3opslaan_1',closePopUpClick:function closePopUpClick(res){_this2.closeSavePopup(res);}}):null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'savebutton-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){ev.preventDefault();if(props.buttonConditions&&props.user.role==='groupleader'&&!props.gameStateInput.preventInputChanges){props.dispatch(submitMyState(props.step));}},className:'button'+(props.buttonConditions&&!props.gameStateInput.preventInputChanges?'':' disabled')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_opslaan')))):null);}}]);return TaxItemContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,saving:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,visible:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,step:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,savingMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,feedbackMessage:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,notificationCount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,saved:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,part:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,video:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,buitenLandDialog:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any},_class.defaultProps={title:'',saving:false,visible:true,step:'SIMULATION_TAX',savingMessage:'saving...',feedbackMessage:'feedback message',notificationCount:0,saved:false,part:0,video:'',buitenLandDialog:false,showSavePopup:false},_initialiseProps=function _initialiseProps(){var _this3=this;this.closeSavePopup=function(res){if(res){var props=_this3.props;if(props.buttonConditions&&props.user.role==='groupleader'&&!props.gameStateInput.preventInputChanges){props.dispatch(submitMyState(props.step));}}_this3.setState({showSavePopup:false});};},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return state;})(TaxItemContainer));

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/belasting-7.0148f5c5.svg";

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/avatar.c37a0048.svg";

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var translate=function translate(txt,translateItem){if(typeof txt==='string'&&translateItem){return Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(txt);}return txt;};var Table=(_temp=_class=function(_React$Component){_inherits(Table,_React$Component);function Table(){_classCallCheck(this,Table);return _possibleConstructorReturn(this,(Table.__proto__||Object.getPrototypeOf(Table)).apply(this,arguments));}_createClass(Table,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tableWrapper'+(!this.props.foot.length?' no-footer':'')+(!this.props.head.length?' no-header':'')},this.props.head.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thead-border'+(this.props.headColor?' thead-color--'+this.props.headColor:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background'})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tbody-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background'})),this.props.foot.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'tfooter-border'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background'})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('table',{className:this.props.className,cellSpacing:'0',cellPadding:'0'},this.props.head.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('thead',{className:''+(this.props.headTextColor?'thead-TextColor--'+this.props.headTextColor:'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,this.props.head.map(function(headerItem,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('th',{key:i},translate(headerItem,_this2.props.translate));}))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tbody',null,this.props.body.map(function(bodyItem,y){if(!bodyItem)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{key:y},bodyItem.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i},translate(item,_this2.props.translate));}));})),this.props.foot.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tfoot',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,this.props.foot.map(function(footItem,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:i},translate(footItem,_this2.props.translate));}))):null));}}]);return Table;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={headColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,headTextColor:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,head:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,body:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired,foot:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,translate:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={head:[],foot:[],className:'',translate:true},_temp);/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectWithoutPropertiesLoose; });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(138);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(201);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(432);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(86);
var $TypeError = __webpack_require__(49);

var $call = __webpack_require__(143);
var $actualApply = __webpack_require__(209);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(462);
var global = __webpack_require__(57);
var hide = __webpack_require__(76);
var Iterators = __webpack_require__(75);
var TO_STRING_TAG = __webpack_require__(46)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 146 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 147 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(465);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(77);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(69);
var dPs = __webpack_require__(467);
var enumBugKeys = __webpack_require__(154);
var IE_PROTO = __webpack_require__(152)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(219)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(470).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 151 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(153)('keys');
var uid = __webpack_require__(106);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(33);
var global = __webpack_require__(57);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(105) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(58).f;
var has = __webpack_require__(70);
var TAG = __webpack_require__(46)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(56);
var core = __webpack_require__(33);
var fails = __webpack_require__(78);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(46);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(57);
var core = __webpack_require__(33);
var LIBRARY = __webpack_require__(105);
var wksExt = __webpack_require__(157);
var defineProperty = __webpack_require__(58).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 159 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(109);
var createDesc = __webpack_require__(88);
var toIObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(149);
var has = __webpack_require__(70);
var IE8_DOM_DEFINE = __webpack_require__(218);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(59) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 161 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  setCookie: function setCookie(cName, cValue, exDays) {
    var d = new Date();
    d.setTime(d.getTime() + exDays * 24 * 60 * 60 * 1000);
    var expires = 'expires=' + d.toUTCString();
    document.cookie = cName + '=' + cValue + ';' + expires + ';path=/';
  },
  getCookie: function getCookie(cName) {
    var name = cName + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return false;
  }
};

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toDate;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toDate(date) {
  (0, _assertString.default)(date);
  date = Date.parse(date);
  return !isNaN(date) ? new Date(date) : null;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toString;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function toString(input) {
  if (_typeof(input) === 'object' && input !== null) {
    if (typeof input.toString === 'function') {
      input = input.toString();
    } else {
      input = '[object Object]';
    }
  } else if (input === null || typeof input === 'undefined' || isNaN(input) && !input.length) {
    input = '';
  }

  return String(input);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFQDN;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _merge = _interopRequireDefault(__webpack_require__(71));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_fqdn_options = {
  require_tld: true,
  allow_underscores: false,
  allow_trailing_dot: false
};

function isFQDN(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_fqdn_options);
  /* Remove the optional trailing dot before checking validity */

  if (options.allow_trailing_dot && str[str.length - 1] === '.') {
    str = str.substring(0, str.length - 1);
  }

  var parts = str.split('.');

  for (var i = 0; i < parts.length; i++) {
    if (parts[i].length > 63) {
      return false;
    }
  }

  if (options.require_tld) {
    var tld = parts.pop();

    if (!parts.length || !/^([a-z\u00a1-\uffff]{2,}|xn[a-z0-9-]{2,})$/i.test(tld)) {
      return false;
    } // disallow spaces


    if (/[\s\u2002-\u200B\u202F\u205F\u3000\uFEFF\uDB40\uDC20]/.test(tld)) {
      return false;
    }
  }

  for (var part, _i = 0; _i < parts.length; _i++) {
    part = parts[_i];

    if (options.allow_underscores) {
      part = part.replace(/_/g, '');
    }

    if (!/^[a-z\u00a1-\uffff0-9-]+$/i.test(part)) {
      return false;
    } // disallow full-width chars


    if (/[\uff01-\uff5e]/.test(part)) {
      return false;
    }

    if (part[0] === '-' || part[part.length - 1] === '-') {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var includes = function includes(arr, val) {
  return arr.some(function (arrVal) {
    return val === arrVal;
  });
};

var _default = includes;
exports.default = _default;
module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getGameStateSum", function() { return getGameStateSum; });
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var ote={"CO":0,"VV":0,"V":0,"OI":0,"economie":0,"inputGlobas":0,"WG":0,"VG":0,"overfinanced":[],"debitCredit":[],"WI":0,"GZ":0,"OW":0,"VR":0,"IE":0,"FB":0,"LV":0,"WS":0,"MC":0,"OT":0,"KN":0,"OH":0,"HB":0,"EH":0,"R1":0,"R2":0,"R3":0,"R4":0,"R5":0,"R5A":0,"R6":0,"R7":0,"R8":0,"R9":0,"R10":0,"R10A":0,"R11":0,"R12":0,"R13":0,"R14":0,"R15":0,"R16":0};function getGameStateSum(states){return states.reduce(function(r,s){Object.keys(s).forEach(function(key){r[key]=(r[key]||0)+s[key];});r.OneTimeEffect=s.OneTimeEffect;return r;},{OneTimeEffect:_extends({},ote),globas:0,points:0});}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bank.85883f11.png";

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reuse */
/* unused harmony export connect */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleFailedEmit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config__);
var reuse={};function handleFailedEmit(error,success){if(error){console.error(error);if(__WEBPACK_IMPORTED_MODULE_0__config___default.a.development){alert('A websocket emit has failed. Check the console for more details about this error.');}}}function connect(namespace){// if (namespace && reuse[namespace]) {
//   return Promise.resolve(reuse[namespace]);
// }
var endpoint=__WEBPACK_IMPORTED_MODULE_0__config___default.a.socketIoHost+(namespace?'/'+namespace:'');var opts=Object.assign({forceNew:true},__WEBPACK_IMPORTED_MODULE_0__config___default.a.socketIoOptions||{});opts.withCredentials=true;opts.query={sticky:Math.random().toString(16).substr(2)};var socket=window.io(endpoint,opts);reuse[namespace]=socket;if(namespace){return Promise.resolve(socket);}return new Promise(function(resolve,reject){socket.once('connect',function(){resolve(socket);});socket.once('connect_error',function(err){reject(err);});});}/* harmony default export */ __webpack_exports__["a"] = ({reuse:reuse,connect:connect,handleFailedEmit:handleFailedEmit});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(290);
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(810);
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLoadStart = handleLoadStart;
exports.handleCanPlay = handleCanPlay;
exports.handleWaiting = handleWaiting;
exports.handleCanPlayThrough = handleCanPlayThrough;
exports.handlePlaying = handlePlaying;
exports.handlePlay = handlePlay;
exports.handlePause = handlePause;
exports.handleEnd = handleEnd;
exports.handleSeeking = handleSeeking;
exports.handleSeeked = handleSeeked;
exports.handleDurationChange = handleDurationChange;
exports.handleTimeUpdate = handleTimeUpdate;
exports.handleVolumeChange = handleVolumeChange;
exports.handleProgressChange = handleProgressChange;
exports.handleRateChange = handleRateChange;
exports.handleSuspend = handleSuspend;
exports.handleAbort = handleAbort;
exports.handleEmptied = handleEmptied;
exports.handleStalled = handleStalled;
exports.handleLoadedMetaData = handleLoadedMetaData;
exports.handleLoadedData = handleLoadedData;
exports.handleResize = handleResize;
exports.handleError = handleError;
exports.handleSeekingTime = handleSeekingTime;
exports.handleEndSeeking = handleEndSeeking;
exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
var LOAD_START = 'video-react/LOAD_START';
exports.LOAD_START = LOAD_START;
var CAN_PLAY = 'video-react/CAN_PLAY';
exports.CAN_PLAY = CAN_PLAY;
var WAITING = 'video-react/WAITING';
exports.WAITING = WAITING;
var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
var PLAYING = 'video-react/PLAYING';
exports.PLAYING = PLAYING;
var PLAY = 'video-react/PLAY';
exports.PLAY = PLAY;
var PAUSE = 'video-react/PAUSE';
exports.PAUSE = PAUSE;
var END = 'video-react/END';
exports.END = END;
var SEEKING = 'video-react/SEEKING';
exports.SEEKING = SEEKING;
var SEEKED = 'video-react/SEEKED';
exports.SEEKED = SEEKED;
var SEEKING_TIME = 'video-react/SEEKING_TIME';
exports.SEEKING_TIME = SEEKING_TIME;
var END_SEEKING = 'video-react/END_SEEKING';
exports.END_SEEKING = END_SEEKING;
var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
exports.DURATION_CHANGE = DURATION_CHANGE;
var TIME_UPDATE = 'video-react/TIME_UPDATE';
exports.TIME_UPDATE = TIME_UPDATE;
var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
exports.VOLUME_CHANGE = VOLUME_CHANGE;
var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
var RATE_CHANGE = 'video-react/RATE_CHANGE';
exports.RATE_CHANGE = RATE_CHANGE;
var SUSPEND = 'video-react/SUSPEND';
exports.SUSPEND = SUSPEND;
var ABORT = 'video-react/ABORT';
exports.ABORT = ABORT;
var EMPTIED = 'video-react/EMPTIED';
exports.EMPTIED = EMPTIED;
var STALLED = 'video-react/STALLED';
exports.STALLED = STALLED;
var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
exports.LOADED_META_DATA = LOADED_META_DATA;
var LOADED_DATA = 'video-react/LOADED_DATA';
exports.LOADED_DATA = LOADED_DATA;
var RESIZE = 'video-react/RESIZE';
exports.RESIZE = RESIZE;
var ERROR = 'video-react/ERROR';
exports.ERROR = ERROR;

function handleLoadStart(videoProps) {
  return {
    type: LOAD_START,
    videoProps: videoProps
  };
}

function handleCanPlay(videoProps) {
  return {
    type: CAN_PLAY,
    videoProps: videoProps
  };
}

function handleWaiting(videoProps) {
  return {
    type: WAITING,
    videoProps: videoProps
  };
}

function handleCanPlayThrough(videoProps) {
  return {
    type: CAN_PLAY_THROUGH,
    videoProps: videoProps
  };
}

function handlePlaying(videoProps) {
  return {
    type: PLAYING,
    videoProps: videoProps
  };
}

function handlePlay(videoProps) {
  return {
    type: PLAY,
    videoProps: videoProps
  };
}

function handlePause(videoProps) {
  return {
    type: PAUSE,
    videoProps: videoProps
  };
}

function handleEnd(videoProps) {
  return {
    type: END,
    videoProps: videoProps
  };
}

function handleSeeking(videoProps) {
  return {
    type: SEEKING,
    videoProps: videoProps
  };
}

function handleSeeked(videoProps) {
  return {
    type: SEEKED,
    videoProps: videoProps
  };
}

function handleDurationChange(videoProps) {
  return {
    type: DURATION_CHANGE,
    videoProps: videoProps
  };
}

function handleTimeUpdate(videoProps) {
  return {
    type: TIME_UPDATE,
    videoProps: videoProps
  };
}

function handleVolumeChange(videoProps) {
  return {
    type: VOLUME_CHANGE,
    videoProps: videoProps
  };
}

function handleProgressChange(videoProps) {
  return {
    type: PROGRESS_CHANGE,
    videoProps: videoProps
  };
}

function handleRateChange(videoProps) {
  return {
    type: RATE_CHANGE,
    videoProps: videoProps
  };
}

function handleSuspend(videoProps) {
  return {
    type: SUSPEND,
    videoProps: videoProps
  };
}

function handleAbort(videoProps) {
  return {
    type: ABORT,
    videoProps: videoProps
  };
}

function handleEmptied(videoProps) {
  return {
    type: EMPTIED,
    videoProps: videoProps
  };
}

function handleStalled(videoProps) {
  return {
    type: STALLED,
    videoProps: videoProps
  };
}

function handleLoadedMetaData(videoProps) {
  return {
    type: LOADED_META_DATA,
    videoProps: videoProps
  };
}

function handleLoadedData(videoProps) {
  return {
    type: LOADED_DATA,
    videoProps: videoProps
  };
}

function handleResize(videoProps) {
  return {
    type: RESIZE,
    videoProps: videoProps
  };
}

function handleError(videoProps) {
  return {
    type: ERROR,
    videoProps: videoProps
  };
}

function handleSeekingTime(time) {
  return {
    type: SEEKING_TIME,
    time: time
  };
}

function handleEndSeeking(time) {
  return {
    type: END_SEEKING,
    time: time
  };
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(32);

var _classnames = _interopRequireDefault(__webpack_require__(10));

var Dom = _interopRequireWildcard(__webpack_require__(124));

var propTypes = {
  className: _propTypes["default"].string,
  onMouseDown: _propTypes["default"].func,
  onMouseMove: _propTypes["default"].func,
  stepForward: _propTypes["default"].func,
  stepBack: _propTypes["default"].func,
  sliderActive: _propTypes["default"].func,
  sliderInactive: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  getPercent: _propTypes["default"].func,
  vertical: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  label: _propTypes["default"].string,
  valuenow: _propTypes["default"].string,
  valuetext: _propTypes["default"].string
};

var Slider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Slider, _Component);

  function Slider(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Slider);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Slider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      document.removeEventListener('keydown', this.handleKeyPress, true);
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      var getPercent = this.props.getPercent;

      if (!getPercent) {
        return 0;
      }

      var progress = getPercent(); // Protect against no duration and other division issues

      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
        progress = 0;
      }

      return progress;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
      // event.stopPropagation();

      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseMove, true);
      document.addEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: true
      });

      if (this.props.sliderActive) {
        this.props.sliderActive(event);
      }

      this.handleMouseMove(event);

      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var onMouseMove = this.props.onMouseMove;

      if (onMouseMove) {
        onMouseMove(event);
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      var onMouseUp = this.props.onMouseUp;
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: false
      });

      if (this.props.sliderInactive) {
        this.props.sliderInactive(event);
      }

      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();

      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (event.which === 37 || event.which === 40) {
        // Left and Down Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepBack();
      } else if (event.which === 38 || event.which === 39) {
        // Up and Right Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepForward();
      }
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      if (this.props.stepForward) {
        this.props.stepForward();
      }
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      if (this.props.stepBack) {
        this.props.stepBack();
      }
    }
  }, {
    key: "calculateDistance",
    value: function calculateDistance(event) {
      var node = (0, _reactDom.findDOMNode)(this);
      var position = Dom.getPointerPosition(node, event);

      if (this.props.vertical) {
        return position.y;
      }

      return position.x;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var progress = this.getProgress();
      var percentage = "".concat((progress * 100).toFixed(2), "%");
      return _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          progress: progress,
          percentage: percentage
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          vertical = _this$props.vertical,
          label = _this$props.label,
          valuenow = _this$props.valuenow,
          valuetext = _this$props.valuetext;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.className, {
          'video-react-slider-vertical': vertical,
          'video-react-slider-horizontal': !vertical,
          'video-react-sliding': this.state.active
        }, 'video-react-slider'),
        tabIndex: "0",
        role: "slider",
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleMouseDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        "aria-label": label || '',
        "aria-valuenow": valuenow || '',
        "aria-valuetext": valuetext || '',
        "aria-valuemin": 0,
        "aria-valuemax": 100
      }, this.renderChildren());
    }
  }]);
  return Slider;
}(_react.Component);

exports["default"] = Slider;
Slider.propTypes = propTypes;
Slider.displayName = 'Slider';

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _MenuButton = _interopRequireDefault(__webpack_require__(318));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  rates: _propTypes["default"].array,
  className: _propTypes["default"].string
};
var defaultProps = {
  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
};

var PlaybackRateMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);

  function PlaybackRateMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props = this.props,
          rates = _this$props.rates,
          actions = _this$props.actions;

      if (index >= 0 && index < rates.length) {
        actions.changeRate(rates[index]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          rates = _this$props2.rates,
          player = _this$props2.player;
      var items = rates.map(function (rate) {
        return {
          label: "".concat(rate, "x"),
          value: rate
        };
      });
      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Playback Rate"), _react["default"].createElement("div", {
        className: "video-react-playback-rate-value"
      }, "".concat(player.playbackRate.toFixed(2), "x")));
    }
  }]);
  return PlaybackRateMenuButton;
}(_react.Component);

PlaybackRateMenuButton.propTypes = propTypes;
PlaybackRateMenuButton.defaultProps = defaultProps;
PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
var _default = PlaybackRateMenuButton;
exports["default"] = _default;

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HeaderCountdown__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_begeleider_svg__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_begeleider_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_begeleider_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScoreRow__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_tabInfo__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var _logout=__WEBPACK_IMPORTED_MODULE_12__actions__["a" /* default */].user.logout;var TopBar=(_temp=_class=function(_Component){_inherits(TopBar,_Component);function TopBar(props){var _this2=this;_classCallCheck(this,TopBar);var _this=_possibleConstructorReturn(this,(TopBar.__proto__||Object.getPrototypeOf(TopBar)).call(this,props));_this.fetchRankings=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',Object(__WEBPACK_IMPORTED_MODULE_7__apiCall__["a" /* default */])('/group/myRank',null,'GET').then(function(_ref2){var schoolClassRank=_ref2.schoolClassRank,schoolRank=_ref2.schoolRank,totalPoints=_ref2.totalPoints;_this.setState({schoolClassRank:schoolClassRank,schoolRank:schoolRank,totalPoints:totalPoints,fetchedRankings:true});}));case 1:case'end':return _context.stop();}}},_callee,_this2);}));_this.renderBadge=function(){var _this$props=_this.props,group=_this$props.group,user=_this$props.user;var src=__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_begeleider_svg___default.a;if(['groupleader','groupmember'].includes(user.role)){src=''+__WEBPACK_IMPORTED_MODULE_13__config___default.a.apiUrl+group.GroupTheme.badge;if(sessionStorage.getItem('governAsClassleader')==='true'){__WEBPACK_IMPORTED_MODULE_14__helpers_tabInfo__["a" /* default */].setFavicon(window.location.origin+'/logo-small.png');}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'badge',src:src});};_this.renderTitle=function(){var title='';var _this$props2=_this.props,group=_this$props2.group,schoolClass=_this$props2.schoolClass,user=_this$props2.user,project=_this$props2.project;if(user.role==='classleader'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'title'},Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_begeleider'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{position:'relative',top:'-1px'}},'|'),' ',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{position:'relative',top:'-1px',fontSize:'15px',textTransform:'initial',fontWeight:600}},schoolClass.className));}if(user.role==='schoolcontact')title=project.nameSchoolPlace;if(['groupleader','groupmember'].includes(user.role)){title=group.name;if(sessionStorage.getItem('governAsClassleader')==='true'){__WEBPACK_IMPORTED_MODULE_14__helpers_tabInfo__["a" /* default */].setWindowTitle(Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])(group.GroupTheme.name));}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'title'},title);};_this.renderDropDownArrow=function(){// if (!['groupmember', 'groupleader'].includes(this.props.user.role)) return null;
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'arrow-button'});};_this.toggleConfirmLogout=function(ev){if(!ev)return;ev.preventDefault();var parent=ev.target.parentElement;var closeButton=false;while(parent){if(parent.classList.contains('close-button')){closeButton=true;}if(!closeButton){if(parent.classList.contains('popup')){return false;}}parent=parent.parentElement;}_this.setState(function(prevState){return{confirmLogout:!prevState.confirmLogout};});};_this.renderScoreContainerWrapper=function(){var isPortalHome=window.location.pathname==='/portal/group';if(!_this.props.group||!_this.props.group.loaded)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-container-wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ContentContainer__["a" /* default */],null,_this.props.user.role&&!_this.props.user.role.startsWith('group')?'':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-container'},_this.props.project.EducationProject.nameShort==='GLXL'?_this.props.gameState.hideScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'disabled-scores'},Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_tussenstand_uitgeschakeld')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_puntentotaal'),score:_this.state.totalPoints||0}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_ranglijst_school'),score:_this.state.schoolRank}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_ranglijst_klas'),score:_this.state.schoolClassRank})):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'action-buttons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:'/portal',onClick:function onClick(){if(_this.props.gameState.history){window.sessionStorage.removeItem('history');}_this.setState({expanded:!_this.state.expanded});_this.props.dispatch(__WEBPACK_IMPORTED_MODULE_12__actions__["a" /* default */].feedback.setRound(_this.props.feedback.all.length-1));},className:'button button-smallPadding '+(isPortalHome?' disabled':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_ga_naar_startscherm'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'',className:'button',onClick:_this.toggleConfirmLogout},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_uitloggen'))))));};_this.state={expanded:false,schoolRank:'-',schoolClassRank:'-',totalPoints:'-',fetchedRankings:false};_this.logout=_this.logout.bind(_this);_this.socketEventsAdded=false;return _this;}_createClass(TopBar,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps,prevState,snapshot){// Fetch latest ranking state everytime we open the dropdown
if(!prevState.expanded&&this.state.expanded){this.fetchRankings();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref3){var user=_ref3.user;if(!this.state.fetchedRankings&&user.loggedIn){this.fetchRankings();}if(!this.socketEventsAdded&&window.socket&&window.socket.connected){window.socket.on('finishedSimulationStep',this.fetchRankings);window.socket.on('activate',this.fetchRankings);this.socketEventsAdded=true;}}/**
   * Render badge
   */},{key:'logout',value:function logout(){if(sessionStorage.getItem('token')){sessionStorage.removeItem('token');window.close();}else{sessionStorage.clear();localStorage.clear();this.props.dispatch(_logout());}}/**
   * Render title
   *//**
   * Render score container arrow (dropdown)
   *//**
   * Render score container (dropdown)
   */},{key:'render',value:function render(){var _this3=this;var desktop=this.props.desktop;var inGame=!(__WEBPACK_IMPORTED_MODULE_5__history__["a" /* default */].location.pathname.indexOf("portal")>-1);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'topbar-container'+(this.state.expanded?' expanded':'')+(this.props.user.role==='schoolcontact'?' tight':'')+(desktop?' desktop-topbar':'')+(inGame?' topbar--ingame':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'background-overlay',onClick:function onClick(){_this3.setState({expanded:!_this3.state.expanded});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('nav',{className:'topbar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:function onClick(){_this3.setState({expanded:!_this3.state.expanded});}},this.renderBadge(),this.renderTitle(),this.renderDropDownArrow()),this.props.user.role==='schoolcontact'?'':__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HeaderCountdown__["a" /* default */],{role:this.props.user.role})),this.renderScoreContainerWrapper(),this.state.confirmLogout?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_uitloggen'),description:Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_bevestig_uitloggen'),showPopUp:true,closePopUpCross:true,zIndex:9999,customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_11_i18n_for_browser__["a" /* __ */])('sim_uitloggen'),action:function action(){return _this3.logout();}},closePopUpClick:this.toggleConfirmLogout}):null);}}]);return TopBar;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{project:state.project,schoolClass:state.schoolClass,user:state.user,group:state.group,gameState:state.gameState,feedback:state.feedback};})(TopBar));

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* This program is free software. It comes without any warranty, to
     * the extent permitted by applicable law. You can redistribute it
     * and/or modify it under the terms of the Do What The Fuck You Want
     * To Public License, Version 2, as published by Sam Hocevar. See
     * http://www.wtfpl.net/ for more details. */

module.exports = leftPad;

var cache = [
  '',
  ' ',
  '  ',
  '   ',
  '    ',
  '     ',
  '      ',
  '       ',
  '        ',
  '         '
];

function leftPad (str, len, ch) {
  // convert `str` to a `string`
  str = str + '';
  // `len` is the `pad`'s length now
  len = len - str.length;
  // doesn't need to pad
  if (len <= 0) return str;
  // `ch` defaults to `' '`
  if (!ch && ch !== 0) ch = ' ';
  // convert `ch` to a `string` cuz it could be a number
  ch = ch + '';
  // cache common use cases
  if (ch === ' ' && len < 10) return cache[len] + str;
  // `pad` starts with an empty string
  var pad = '';
  // loop
  while (true) {
    // add `ch` to `pad` if `len` is odd
    if (len & 1) pad += ch;
    // divide `len` by 2, ditch the remainder
    len >>= 1;
    // "double" the `ch` so this operation count grows logarithmically on `len`
    // each time `ch` is "doubled", the `len` would need to be "doubled" too
    // similar to finding a value in binary search tree, hence O(log(n))
    if (len) ch += ch;
    // `len` is 0, exit the loop
    else break;
  }
  // pad `str`!
  return pad + str;
}


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(846));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(850));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(326));

var _Transition = _interopRequireDefault(__webpack_require__(324));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sparen_bank.49c070c8.svg";

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__(129);












var Handle = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Handle, _React$Component);

  function Handle() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Handle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clickFocused: false
    }, _this.setHandleRef = function (node) {
      _this.handle = node;
    }, _this.handleMouseUp = function () {
      if (document.activeElement === _this.handle) {
        _this.setClickFocus(true);
      }
    }, _this.handleBlur = function () {
      _this.setClickFocus(false);
    }, _this.handleKeyDown = function () {
      _this.setClickFocus(false);
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Handle, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // mouseup won't trigger if mouse moved out of handle,
      // so we listen on document here.
      this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(document, 'mouseup', this.handleMouseUp);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.onMouseUpListener) {
        this.onMouseUpListener.remove();
      }
    }
  }, {
    key: 'setClickFocus',
    value: function setClickFocus(focused) {
      this.setState({ clickFocused: focused });
    }
  }, {
    key: 'clickFocus',
    value: function clickFocus() {
      this.setClickFocus(true);
      this.focus();
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.handle.focus();
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.handle.blur();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prefixCls = _props.prefixCls,
          vertical = _props.vertical,
          offset = _props.offset,
          style = _props.style,
          disabled = _props.disabled,
          min = _props.min,
          max = _props.max,
          value = _props.value,
          tabIndex = _props.tabIndex,
          restProps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['prefixCls', 'vertical', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);

      var className = __WEBPACK_IMPORTED_MODULE_9_classnames___default()(this.props.className, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, prefixCls + '-handle-click-focused', this.state.clickFocused));

      var postionStyle = vertical ? { bottom: offset + '%' } : { left: offset + '%' };
      var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, postionStyle);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement('div', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        ref: this.setHandleRef,
        tabIndex: disabled ? null : tabIndex || 0
      }, restProps, {
        className: className,
        style: elStyle,
        onBlur: this.handleBlur,
        onKeyDown: this.handleKeyDown

        // aria attribute
        , role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      }));
    }
  }]);

  return Handle;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Handle);


Handle.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  offset: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  min: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number
};

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isEventFromHandle;
/* harmony export (immutable) */ __webpack_exports__["i"] = isValueOutOfRange;
/* harmony export (immutable) */ __webpack_exports__["h"] = isNotTouchEvent;
/* unused harmony export getClosestPoint */
/* unused harmony export getPrecision */
/* harmony export (immutable) */ __webpack_exports__["e"] = getMousePosition;
/* harmony export (immutable) */ __webpack_exports__["f"] = getTouchPosition;
/* harmony export (immutable) */ __webpack_exports__["c"] = getHandleCenterPosition;
/* harmony export (immutable) */ __webpack_exports__["a"] = ensureValueInRange;
/* harmony export (immutable) */ __webpack_exports__["b"] = ensureValuePrecision;
/* harmony export (immutable) */ __webpack_exports__["j"] = pauseEvent;
/* harmony export (immutable) */ __webpack_exports__["d"] = getKeyboardValueMutator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__ = __webpack_require__(906);




function isEventFromHandle(e, handles) {
  return Object.keys(handles).some(function (key) {
    return e.target === Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(handles[key]);
  });
}

function isValueOutOfRange(value, _ref) {
  var min = _ref.min,
      max = _ref.max;

  return value < min || value > max;
}

function isNotTouchEvent(e) {
  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
}

function getClosestPoint(val, _ref2) {
  var marks = _ref2.marks,
      step = _ref2.step,
      min = _ref2.min;

  var points = Object.keys(marks).map(parseFloat);
  if (step !== null) {
    var closestStep = Math.round((val - min) / step) * step + min;
    points.push(closestStep);
  }
  var diffs = points.map(function (point) {
    return Math.abs(val - point);
  });
  return points[diffs.indexOf(Math.min.apply(Math, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(diffs)))];
}

function getPrecision(step) {
  var stepString = step.toString();
  var precision = 0;
  if (stepString.indexOf('.') >= 0) {
    precision = stepString.length - stepString.indexOf('.') - 1;
  }
  return precision;
}

function getMousePosition(vertical, e) {
  return vertical ? e.clientY : e.pageX;
}

function getTouchPosition(vertical, e) {
  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
}

function getHandleCenterPosition(vertical, handle) {
  var coords = handle.getBoundingClientRect();
  return vertical ? coords.top + coords.height * 0.5 : coords.left + coords.width * 0.5;
}

function ensureValueInRange(val, _ref3) {
  var max = _ref3.max,
      min = _ref3.min;

  if (val <= min) {
    return min;
  }
  if (val >= max) {
    return max;
  }
  return val;
}

function ensureValuePrecision(val, props) {
  var step = props.step;

  var closestPoint = getClosestPoint(val, props);
  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
}

function pauseEvent(e) {
  e.stopPropagation();
  e.preventDefault();
}

function getKeyboardValueMutator(e) {
  switch (e.keyCode) {
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].UP:
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].RIGHT:
      return function (value, props) {
        return value + props.step;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].DOWN:
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].LEFT:
      return function (value, props) {
        return value - props.step;
      };

    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].END:
      return function (value, props) {
        return props.max;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].HOME:
      return function (value, props) {
        return props.min;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_UP:
      return function (value, props) {
        return value + props.step * 2;
      };
    case __WEBPACK_IMPORTED_MODULE_2_rc_util_es_KeyCode__["a" /* default */].PAGE_DOWN:
      return function (value, props) {
        return value - props.step * 2;
      };

    default:
      return undefined;
  }
}

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContentContainer__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackEffect=(_temp=_class=function(_Component){_inherits(FeedbackEffect,_Component);function FeedbackEffect(props){_classCallCheck(this,FeedbackEffect);var _this=_possibleConstructorReturn(this,(FeedbackEffect.__proto__||Object.getPrototypeOf(FeedbackEffect)).call(this,props));_this.state={image:_this.props.image,ministry:_this.props.ministry,ministryIcon:_this.props.ministryIcon,description:_this.props.description,disaster:_this.props.disaster,subtitle:_this.props.subtitle};return _this;}_createClass(FeedbackEffect,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var points=this.props.points==="-"?0:this.props.points;if(this.props.points>=0)points='+'+points;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-effect-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-effect-header'},this.props.difficulty!=='BASIC'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-ministry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'ministry',src:this.state.ministryIcon})),this.props.pointsTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.ministry,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thin-subtitle'},'| ',this.props.pointsTitle)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.ministry),this.state.subtitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' |',this.state.subtitle):null):null,!this.props.pointsTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{content:points},points,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{content:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(this.props.unit)},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(this.props.unit)))):null),this.props.minimal?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__FeedbackImage__["a" /* default */],{description:this.state.description,image:this.state.image}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ContentContainer__["a" /* default */],{darkBg:true},this.props.children)));}}]);return FeedbackEffect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,ministry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,ministryIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string},_class.defaultProps={unit:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten')},_temp);

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__config__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updateMyState=__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].gameStateInput.updateMyState;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__["a" /* default */])(function(state){return{policyChoice:state.policyChoice,gameState:state.gameState,gameStateInput:state.gameStateInput,user:state.user};})(function(_React$Component){_inherits(PolicyChoiceLaag,_React$Component);function PolicyChoiceLaag(props){_classCallCheck(this,PolicyChoiceLaag);var _this=_possibleConstructorReturn(this,(PolicyChoiceLaag.__proto__||Object.getPrototypeOf(PolicyChoiceLaag)).call(this,props));_this.toggleShow=function(el){if(_this.props.onClick){_this.props.onClick();return;}if(!_this.props.mainView){_this.setState({show:!_this.state.show});// el.target.scrollIntoView({behavior: 'smooth'});
}};_this.chooseSolution=function(ev){ev.stopPropagation();var target=ev.currentTarget.getElementsByTagName('input')[0];var _this$props=_this.props,dispatch=_this$props.dispatch,gameStateInput=_this$props.gameStateInput;var policyChoices=gameStateInput.myState.policyChoices;var prevMade=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["i" /* getSolutionByCode */])(policyChoices[target.name],_this.props.policyChoice);var prevMadeCosts=prevMade.kosten||0;var newChoice=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["i" /* getSolutionByCode */])(target.value,_this.props.policyChoice);var newCosts=newChoice.kosten||0;if(_this.props.spendableGlobas+prevMadeCosts-newCosts>=0||newCosts===0){dispatch(updateMyState({policyChoices:_extends({},policyChoices,_defineProperty({},target.name,target.value))}));}};_this.state={show:false};return _this;}_createClass(PolicyChoiceLaag,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(this.state.show!==props.show){this.setState({show:props.show});}}},{key:'render',value:function render(){var _this2=this;var props=this.props;var policyChoice=props.policyChoice,gameState=props.gameState,problem=props.problem,gameStateInput=props.gameStateInput;var solutions=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["f" /* getOplossingen */])(policyChoice,problem.Nummer,gameState.language);if(!gameStateInput||!policyChoice||!gameState||!problem)return null;var solution=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["i" /* getSolutionByCode */])(gameStateInput.myState.policyChoices[problem.Nummer],policyChoice,gameState.language)||{kosten:0};var costs='-';var title=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["j" /* getTitle */])(problem,gameState.language);if(gameStateInput.myState.policyChoices[problem.Nummer]){title=solution.titel;costs=solution.kosten;}if(this.props.mainView&&this.props.setShow||!this.props.mainView){if(this.props.mainView){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policy-choice'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'+(this.state.show||this.props.setShow?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["b" /* getIcon */])(problem)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'point-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:costs},costs),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__GoBackButton__["a" /* default */],{history:this.props.history})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'problem-description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_probleem')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'problem-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'problem-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:''+__WEBPACK_IMPORTED_MODULE_8__config___default.a.mediaUrl+Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["c" /* getImage */])(problem,gameState.language)+'.jpeg',alt:'problem'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["g" /* getProbleemTekst */])(problem,gameState.language))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'solutions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_kies_oplossing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flex-solutions'},solutions.map(function(oplossing,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this2.chooseSolution,className:'solution'+(gameStateInput.myState.policyChoices[problem.Nummer]===oplossing.id?' checked':'')+(_this2.props.user.role==='groupmember'?' groupmember-disabled':''),key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:function onChange(){},type:'radio',name:problem.Nummer,value:oplossing.id,checked:gameStateInput.myState.policyChoices[problem.Nummer]===oplossing.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,oplossing.tekst),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-costs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_assets__["d" /* icons */].globas,alt:'globas'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs-price'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:oplossing.kosten},oplossing.kosten),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')))))));}))))));}else{var contentContainerClasses='policy-choice'+(gameStateInput.myState.policyChoices[problem.Nummer]?' checked':'')+(this.state.show&&!this.props.listView||this.props.setShow&&!this.props.listView?' show':'');if(this.props.highlight&&this.props.listView){contentContainerClasses+=' highlight';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],{onClick:this.toggleShow,className:contentContainerClasses},!this.props.mainView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'icon',alt:'ico',src:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["b" /* getIcon */])(problem)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'icon check',alt:'check',src:__WEBPACK_IMPORTED_MODULE_4__assets_assets__["d" /* icons */].check}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'point-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:costs},costs),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))))):null,!this.props.listView?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'+(this.state.show||this.props.setShow?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'problem-description mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:''+__WEBPACK_IMPORTED_MODULE_8__config___default.a.mediaUrl+Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["c" /* getImage */])(problem,gameState.language)+'.jpeg',alt:'problem'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_probleem')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["g" /* getProbleemTekst */])(problem,gameState.language))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'solutions'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_kies_oplossing')),solutions.map(function(oplossing,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:_this2.chooseSolution,className:'solution'+(_this2.props.user.role==='groupmember'?' groupmember-disabled':''),key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'radio-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onChange:function onChange(){},type:'radio',name:problem.Nummer,value:oplossing.id,checked:gameStateInput.myState.policyChoices[problem.Nummer]===oplossing.id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,oplossing.tekst),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'costs'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:oplossing.kosten},oplossing.kosten),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))));}))):'');}}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);}}}]);return PolicyChoiceLaag;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component)));

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fixImageOrientation__ = __webpack_require__(983);
var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var dataURLtoFile=function dataURLtoFile(dataurl,filename){var arr=dataurl.split(','),mime=arr[0].match(/:(.*?);/)[1],bstr=atob(arr[1]),n=bstr.length,u8arr=new Uint8Array(n);while(n--){u8arr[n]=bstr.charCodeAt(n);}var blob=new Blob([u8arr],{type:mime});blob.name=filename;return blob;};/* harmony default export */ __webpack_exports__["a"] = ((function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(file,maxWidth,maxHeight){var quality=arguments.length>3&&arguments[3]!==undefined?arguments[3]:0.8;var fileName=arguments.length>4&&arguments[4]!==undefined?arguments[4]:Date.now()+'.jpeg';return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:return _context2.abrupt('return',new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var reader;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(/image.*/.test(file.type)){_context.next=2;break;}return _context.abrupt('return',reject(new Error('File must be an image with mimetype image/*.')));case 2:_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_1__fixImageOrientation__["a" /* default */])(file);case 4:file=_context.sent;//Load image in FileReader
reader=new FileReader();reader.onload=function(readerLoaded){var image=new Image();image.onload=function(imageLoaded){// Resize the image
var canvas=document.createElement('canvas');var width=image.width;var height=image.height;var ratio=0;if(width>maxWidth){ratio=maxWidth/width;height=height*ratio;width=width*ratio;}if(height>maxHeight){ratio=maxHeight/height;width=width*ratio;height=height*ratio;}canvas.width=width;canvas.height=height;canvas.getContext('2d').drawImage(image,0,0,width,height);var dataUrl=canvas.toDataURL('image/jpeg',quality);var resized=dataURLtoFile(dataUrl,fileName);return resolve(resized);};image.src=readerLoaded.target.result;};reader.readAsDataURL(file);case 8:case'end':return _context.stop();}}},_callee,_this);}));return function(_x6,_x7){return _ref2.apply(this,arguments);};}()));case 1:case'end':return _context2.stop();}}},_callee2,_this);}));return function(_x,_x2,_x3){return _ref.apply(this,arguments);};})());

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(372);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _inheritsLoose; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(378);

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(t, o);
}


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(189);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(383);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _typeof; });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(194);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(135);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPE_Y = exports.TYPE_X = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPE_X = 1;
exports.TYPE_X = TYPE_X;
var TYPE_Y = 2;
exports.TYPE_Y = TYPE_Y;

var Track =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Track, _React$Component);

  function Track(props) {
    var _this;

    _classCallCheck(this, Track);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Track).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "onClickHandler", function (ev) {
      if (ev.target !== _this.element || !_this.props.onClick) {
        return true;
      }

      var rect = _this.element.getBoundingClientRect();

      _this.props.onClick(ev, {
        axis: _this.props.type,
        offset: _this.props.type === TYPE_X ? ev.clientX - rect.left : ev.clientY - rect.top
      });
    });

    return _this;
  }

  _createClass(Track, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          renderer = _this$props.renderer,
          type = _this$props.type,
          elementRef = _this$props.elementRef,
          onClick = _this$props.onClick,
          props = _objectWithoutProperties(_this$props, ["className", "renderer", "type", "elementRef", "onClick"]);

      props.className = "track " + (type === TYPE_X ? "trackX" : "trackY") + (className ? " " + className : "");
      props.onClick = this.onClickHandler;

      var ref = function ref(_ref) {
        typeof elementRef === "function" && elementRef(_ref);
        _this2.element = _ref;
      };

      return renderer ? renderer(_objectSpread({}, props, {
        elementRef: ref
      })) : _react.default.createElement("div", _extends({}, props, {
        ref: ref
      }));
    }
  }]);

  return Track;
}(_react.default.Component);

exports.default = Track;

_defineProperty(Track, "displayName", "Scrollbar Track");

_defineProperty(Track, "propTypes", {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  type: _propTypes.default.oneOf([TYPE_X, TYPE_Y]).isRequired,
  elementRef: _propTypes.default.func,
  renderer: _propTypes.default.func
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(67);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(198);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(139);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(414)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = prefix || defaultDelimiter
    var pattern = capture || group
    var prevText = prefix || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '')

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : restrictBacktrack(delimiter, prevText))
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

function restrictBacktrack(delimiter, prevText) {
  if (!prevText || prevText.indexOf(delimiter) > -1) {
    return '[^' + escapeString(delimiter) + ']+?'
  }

  return escapeString(prevText) + '|(?:(?!' + escapeString(prevText) + ')[^' + escapeString(delimiter) + '])+?'
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(102);

var $SyntaxError = __webpack_require__(203);
var $TypeError = __webpack_require__(49);

var gopd = __webpack_require__(103);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(102);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var setFunctionLength = __webpack_require__(434);

var $defineProperty = __webpack_require__(102);

var callBindBasic = __webpack_require__(142);
var applyBind = __webpack_require__(454);

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		1 + (adjustedLength > 0 ? adjustedLength : 0),
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(141);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(86);

var $apply = __webpack_require__(144);
var $call = __webpack_require__(143);
var $reflectApply = __webpack_require__(452);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(211);
var callBound = __webpack_require__(87);
var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var $push = callBound('Array.prototype.push');

module.exports = function entries(O) {
	var obj = RequireObjectCoercible(O);
	var entrys = [];
	for (var key in obj) {
		if ($isEnumerable(obj, key)) { // checks own-ness as well
			$push(entrys, [key, obj[key]]);
		}
	}
	return entrys;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(49);

/** @type {import('./RequireObjectCoercible')} */
module.exports = function RequireObjectCoercible(value) {
	if (value == null) {
		throw new $TypeError((arguments.length > 0 && arguments[1]) || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(210);

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(211);
var callBound = __webpack_require__(87);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

module.exports = function values(O) {
	var obj = RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if ($isEnumerable(obj, key)) { // checks own-ness as well
			vals[vals.length] = obj[key];
		}
	}
	return vals;
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(213);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_lang_json__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_lang_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_lang_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_getUrlVars__ = __webpack_require__(72);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var c='i18n';var init=Object(__WEBPACK_IMPORTED_MODULE_3__components_apiCall__["a" /* default */])('/language/translations?simulationgame=true').then(function(translations){window.translations=translations;__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["c" /* configure */]({locales:_extends({},__WEBPACK_IMPORTED_MODULE_4__assets_lang_json___default.a,translations),cookie:c});var _getUrlVars=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_getUrlVars__["a" /* default */])(),langFromUri=_getUrlVars.lang;if(langFromUri==='be'){langFromUri='nl';}if(langFromUri&&translations[langFromUri]){setLanguage(langFromUri);__WEBPACK_IMPORTED_MODULE_2_glxl_helpers__["cookie"].setCookie(c,langFromUri);}else{// Default to NL
if(!__WEBPACK_IMPORTED_MODULE_2_glxl_helpers__["cookie"].getCookie(c)){setLanguage('nl');__WEBPACK_IMPORTED_MODULE_2_glxl_helpers__["cookie"].setCookie(c,'nl');}}__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["d" /* getLocale */]());}).catch(function(){throw new Error('Error during fetching of translations');});var setLanguage=function setLanguage(lang){__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["e" /* setLocale */](lang);__WEBPACK_IMPORTED_MODULE_1_moment___default.a.locale(__WEBPACK_IMPORTED_MODULE_0_i18n_for_browser__["d" /* getLocale */]());};/* harmony default export */ __webpack_exports__["a"] = ({init:init,setLanguage:setLanguage});

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(146);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(105);
var $export = __webpack_require__(56);
var redefine = __webpack_require__(220);
var hide = __webpack_require__(76);
var Iterators = __webpack_require__(75);
var $iterCreate = __webpack_require__(466);
var setToStringTag = __webpack_require__(155);
var getPrototypeOf = __webpack_require__(223);
var ITERATOR = __webpack_require__(46)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(59) && !__webpack_require__(78)(function () {
  return Object.defineProperty(__webpack_require__(219)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(77);
var document = __webpack_require__(57).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(76);


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(70);
var toIObject = __webpack_require__(68);
var arrayIndexOf = __webpack_require__(468)(false);
var IE_PROTO = __webpack_require__(152)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(151);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(70);
var toObject = __webpack_require__(79);
var IE_PROTO = __webpack_require__(152)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(146);
var TAG = __webpack_require__(46)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(224);
var ITERATOR = __webpack_require__(46)('iterator');
var Iterators = __webpack_require__(75);
module.exports = __webpack_require__(33).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(479), __esModule: true };

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(221);
var hiddenKeys = __webpack_require__(154).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

var reserved = __webpack_require__(498);
var parse = __webpack_require__(506).parse;


/** Creates a new message compiler. Called internally from {@link MessageFormat#compile}.
 *
 * @class
 * @param {MessageFormat} mf - A MessageFormat instance
 * @property {object} locales - The locale identifiers that are used by the compiled functions
 * @property {object} runtime - Names of the core runtime functions that are used by the compiled functions
 * @property {object} formatters - The formatter functions that are used by the compiled functions
 */
function Compiler(mf) {
    this.mf = mf;
    this.lc = null;
    this.locales = {};
    this.runtime = {};
    this.formatters = {};
}

module.exports = Compiler;


/** Utility function for quoting an Object's key value if required
 *
 *  Quotes the key if it contains invalid characters or is an
 *  ECMAScript 3rd Edition reserved word (for IE8).
 */
Compiler.propname = function(key, obj) {
  if (/^[A-Z_$][0-9A-Z_$]*$/i.test(key) &&
     ['break', 'continue', 'delete', 'else', 'for', 'function', 'if', 'in', 'new',
      'return', 'this', 'typeof', 'var', 'void', 'while', 'with', 'case', 'catch',
      'default', 'do', 'finally', 'instanceof', 'switch', 'throw', 'try'].indexOf(key) < 0) {
    return obj ? obj + '.' + key : key;
  } else {
    var jkey = JSON.stringify(key);
    return obj ? obj + '[' + jkey + ']' : jkey;
  }
}


/** Utility function for escaping a function name if required
 */
Compiler.funcname = function(key) {
  var fn = key.trim().replace(/\W+/g, '_');
  return reserved.check(fn, 'es2015', true) || /^\d/.test(fn) ? '_' + fn : fn;
}


/** Utility formatter function for enforcing Bidi Structured Text by using UCC
 *
 *  List inlined from data extracted from CLDR v27 & v28
 *  To verify/recreate, use the following:
 *
 *     git clone https://github.com/unicode-cldr/cldr-misc-full.git
 *     cd cldr-misc-full/main/
 *     grep characterOrder -r . | tr '"/' '\t' | cut -f2,6 | grep -C4 right-to-left
 */
Compiler.bidiMarkText = function(text, locale) {
  function isLocaleRTL(locale) {
    var rtlLanguages = ['ar', 'ckb', 'fa', 'he', 'ks($|[^bfh])', 'lrc', 'mzn',
                        'pa-Arab', 'ps', 'ug', 'ur', 'uz-Arab', 'yi'];
    return new RegExp('^' + rtlLanguages.join('|^')).test(locale);
  }
  var mark = JSON.stringify(isLocaleRTL(locale) ? '\u200F' : '\u200E');
  return mark + ' + ' + text + ' + ' + mark;
}


/** @private */
Compiler.prototype.cases = function(token, plural) {
  var needOther = token.type === 'select' || !this.mf.hasCustomPluralFuncs;
  var r = token.cases.map(function(c) {
    if (c.key === 'other') needOther = false;
    var s = c.tokens.map(function(tok) { return this.token(tok, plural); }, this);
    return Compiler.propname(c.key) + ': ' + (s.join(' + ') || '""');
  }, this);
  if (needOther) throw new Error("No 'other' form found in " + JSON.stringify(token));
  return '{ ' + r.join(', ') + ' }';
}


/** @private */
Compiler.prototype.token = function(token, plural) {
  if (typeof token == 'string') return JSON.stringify(token);

  var fn, args = [ Compiler.propname(token.arg, 'd') ];
  switch (token.type) {
    case 'argument':
      return this.mf.bidiSupport ? Compiler.bidiMarkText(args[0], this.lc) : args[0];

    case 'select':
      fn = 'select';
      args.push(this.cases(token, this.mf.strictNumberSign ? null : plural));
      this.runtime.select = true;
      break;

    case 'selectordinal':
      fn = 'plural';
      args.push(0, Compiler.funcname(this.lc), this.cases(token, token), 1);
      this.locales[this.lc] = true;
      this.runtime.plural = true;
      break;

    case 'plural':
      fn = 'plural';
      args.push(token.offset || 0, Compiler.funcname(this.lc), this.cases(token, token));
      this.locales[this.lc] = true;
      this.runtime.plural = true;
      break;

    case 'function':
      if (this.mf.intlSupport && !(token.key in this.mf.fmt) && (token.key in this.mf.constructor.formatters)) {
        var fmt = this.mf.constructor.formatters[token.key];
        this.mf.fmt[token.key] = (typeof fmt(this.mf) == 'function') ? fmt(this.mf) : fmt;
      }
      if (!this.mf.fmt[token.key]) throw new Error('Formatting function ' + JSON.stringify(token.key) + ' not found!');
      args.push(JSON.stringify(this.lc));
      if (token.params) switch (token.params.length) {
          case 0:   break;
          case 1:   args.push(JSON.stringify(token.params[0])); break;
          default:  args.push(JSON.stringify(token.params)); break;
      }
      fn = Compiler.propname(token.key, 'fmt');
      this.formatters[token.key] = true;
      break;

    case 'octothorpe':
      if (!plural) return '"#"';
      fn = 'number';
      args = [ Compiler.propname(plural.arg, 'd'), JSON.stringify(plural.arg) ];
      if (plural.offset) args.push(plural.offset);
      this.runtime.number = true;
      break;
  }

  if (!fn) throw new Error('Parser error for token ' + JSON.stringify(token));
  return fn + '(' + args.join(', ') + ')';
};


/** Recursively compile a string or a tree of strings to JavaScript function sources
 *
 *  If `src` is an object with a key that is also present in `plurals`, the key
 *  in question will be used as the locale identifier for its value. To disable
 *  the compile-time checks for plural & selectordinal keys while maintaining
 *  multi-locale support, use falsy values in `plurals`.
 *
 * @param {string|object} src - the source for which the JS code should be generated
 * @param {string} lc - the default locale
 * @param {object} plurals - a map of pluralization keys for all available locales
 */
Compiler.prototype.compile = function(src, lc, plurals) {
  if (typeof src != 'object') {
    this.lc = lc;
    var pc = plurals[lc] || { cardinal: [], ordinal: [] };
    var r = parse(src, pc).map(function(token) { return this.token(token); }, this);
    return 'function(d) { return ' + (r.join(' + ') || '""') + '; }';
  } else {
    var result = {};
    for (var key in src) {
      var lcKey = plurals.hasOwnProperty(key) ? key : lc;
      result[key] = this.compile(src[key], lcKey, plurals);
    }
    return result;
  }
}


/***/ }),
/* 229 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(49);
var inspect = __webpack_require__(110);
var getSideChannelList = __webpack_require__(516);
var getSideChannelMap = __webpack_require__(231);
var getSideChannelWeakMap = __webpack_require__(517);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(104);
var callBound = __webpack_require__(87);
var inspect = __webpack_require__(110);

var $TypeError = __webpack_require__(49);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(162);
var getSideChannel = __webpack_require__(230);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted[compacted.length] = obj[j];
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            var nextIndex = target.length;
            if (options && typeof options.arrayLimit === 'number' && nextIndex > options.arrayLimit) {
                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
            }
            target[nextIndex] = source;
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (options && options.strictMerge) {
                return [target, source];
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        var combined = [target].concat(source);
        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
            return markOverflow(arrayToObject(combined, options), combined.length - 1);
        }
        return combined;
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target[target.length] = item;
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }

        if (isOverflow(source) && !isOverflow(acc)) {
            markOverflow(acc, getMaxIndex(source));
        }
        if (isOverflow(acc)) {
            var keyNum = parseInt(key, 10);
            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
                setMaxIndex(acc, keyNum);
            }
        }

        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue[queue.length] = { obj: obj, prop: key };
                refs[refs.length] = val;
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped[mapped.length] = fn(val[i]);
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    markOverflow: markOverflow,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toFloat;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toFloat(str) {
  (0, _assertString.default)(str);
  return parseFloat(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isByteLength;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isByteLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isByteLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var len = encodeURI(str).split(/%..|./).length - 1;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isInt;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var int = /^(?:[-+]?(?:0|[1-9][0-9]*))$/;
var intLeadingZeroes = /^[-+]?[0-9]+$/;

function isInt(str, options) {
  (0, _assertString.default)(str);
  options = options || {}; // Get the regex to use for testing, based on whether
  // leading zeroes are allowed or not.

  var regex = options.hasOwnProperty('allow_leading_zeroes') && !options.allow_leading_zeroes ? int : intLeadingZeroes; // Check min/max/lt/gt

  var minCheckPassed = !options.hasOwnProperty('min') || str >= options.min;
  var maxCheckPassed = !options.hasOwnProperty('max') || str <= options.max;
  var ltCheckPassed = !options.hasOwnProperty('lt') || str < options.lt;
  var gtCheckPassed = !options.hasOwnProperty('gt') || str > options.gt;
  return regex.test(str) && minCheckPassed && maxCheckPassed && ltCheckPassed && gtCheckPassed;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFullWidth;
exports.fullWidth = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var fullWidth = /[^\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.fullWidth = fullWidth;

function isFullWidth(str) {
  (0, _assertString.default)(str);
  return fullWidth.test(str);
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHalfWidth;
exports.halfWidth = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var halfWidth = /[\u0020-\u007E\uFF61-\uFF9F\uFFA0-\uFFDC\uFFE8-\uFFEE0-9a-zA-Z]/;
exports.halfWidth = halfWidth;

function isHalfWidth(str) {
  (0, _assertString.default)(str);
  return halfWidth.test(str);
}

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexadecimal;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexadecimal = /^[0-9A-F]+$/i;

function isHexadecimal(str) {
  (0, _assertString.default)(str);
  return hexadecimal.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ltrim;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ltrim(str, chars) {
  (0, _assertString.default)(str);
  var pattern = chars ? new RegExp("^[".concat(chars, "]+"), 'g') : /^\s+/g;
  return str.replace(pattern, '');
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rtrim;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function rtrim(str, chars) {
  (0, _assertString.default)(str);
  var pattern = chars ? new RegExp("[".concat(chars, "]")) : /\s/;
  var idx = str.length - 1;

  for (; idx >= 0 && pattern.test(str[idx]); idx--) {
    ;
  }

  return idx < str.length ? str.substr(0, idx + 1) : str;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blacklist;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function blacklist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/FB.25f39d4e.svg";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GZ.78ea658d.svg";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/HB.79afdf21.svg";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/IE.2cd5aaeb.svg";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV.27c0947d.svg";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC.6d794a78.svg";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/KN.64436eea.svg";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OH.ddecf5a9.svg";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OT.636898e1.svg";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW.5f6d10d2.svg";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VR.623d1e1a.svg";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI.d35c8685.svg";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WS.b8a030f8.svg";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/EH.79afdf21.svg";

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALIAAABeCAYAAACHDE6RAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAEaBJREFUeNrsXVlsG8cZHvEWD4mWLNvyUdMu7DSBD8Vu2tQFKhlpgSINGqcFihYFYukxT03QpxZo7aAPfSrsPvWlgO08FAWKws5LgNQNQgNtkiK1TR9xHKfRETumLVkiKVK8j8635NLD3SV3lxqemQ9YSKJ2duf/55t//v+fg4QI9DUCBzZPfBnktIim7nv4BZEFBASRBQQEkQUEBJEFBJEFBASRBQQEkQUEBJEFBJEFBASRBQQEkQXaA7HWQqAvMCmILNAPEIuGBAQEkQUEBJEFBASR+wrPv/LMFL38QhOCyL2Od+k1J8gsiNwPAImPCTUIIvcDAkIFgsgCfQ6bUEHTmCblWbMovV4T6hAWuVdxvELmaaEKQeReRpQJxAQEkXsW10QgJnzkfgOIPD8yMgLrPFGx0qGVlZV5oRpB5K4DQ9SpfD6/s1gsEovFQqxW6/mBgYEaFyMSiYToj6AIBAWRuwFTlZ+SlY1Gowf9fr80MWGz1ahO5Sd7PJ5gIpGYECoURO6ExQ1U3IQAtbiTlIjTsLoy8LtshfVQKBRA4j8KrQoit5KwJyu/TrIWt/J7sGJxQ0yRYOUnPnuV+Xw+nU4TSnri9XrPsfcODg6GUqlUlGO1TT8rcGAz1mlM0Z8n568/PCmI3L8A+RCQRWlgFtL4v8q/pdb4zUogJxMLBJmkf3MnyvOvPHOKIfEFYXcFkWuwHtLRskGzZV765ZFpp9tx3Oj9hVyB5OmVSeZkH33mrT99KDIggsgdVrLdGoivJKdKxVIzxc8yrk1dfP35PVNMcCohvpIKFAslYndaJ+n/5c4b/O9bnwb7TccDgmamhvoJz7DrlNVurSFLLpP3j4z7QnULlkqBQr4YaOadFqslNGAZ0PWP04lsIJvO6b7D4bLPu7wOw9Y9k8yS839476ggcm8Td0rx0YTNYT1FifWl0UExXyS0E2oROUTdnaggcg+QmJL2XeegXSiDJTZ1j7KpHMiNEehot5BZELk+kec2bPEFKJk78v58tkA9En2fOpfO6wePsKqFIpdnKa1yt5BZEFmbxCddHscJ36hbIgH1gaUhVg/ZjD4REPCBpH2ElpGZtgN8fsyk7iTliSos1IJ/f0H5PkFktfL81AeeG9065AeJo4sJ0mS2oaNwuu0EHbFZQHa4EGvRtJHbT1NivcazDegP5NCn69wCEr9O33la/qCafvvZb6dejS2t6a6tlXKc2cLpd964Fu1TLp9y+5z+DG3E+HKypwVxVPz7AjOaYGSRXRZ00GKR+V3pfhjvvwucSYwZyUbrVCSi03sPUjLPSEQ+/vvvSR/S4XPaxPtefO7lg0e7hcyVISjQbHn4hmhEm9Pmt9os0xabpedJLCMZS6sJyh9Bjs/SIzGLadr2C5TMJwcoka+iIPzA6MMESa9lSTqRU5WwOSzEu2FQtsiSeacNP0MbvhkyT9ldtkmLRhpL8kcLpddNPu84rdu02cAMciQiqSqRaZ2Qt+0LAsO1GN0+TBIrzXfIQq5I1mL6rgUl0gAngwRjeqaJortsSvaDxBFKaCVcXodEZNa8+0bc5x2D5icH0WE8wy5id6rLwid1uCxTeJ+Z50lRvklfVh5yLdYBSmQRMnSBNf6FekTJSMa13E4W4h52Un6oeHNsXVPUyViKEt/SRE8vkOV7sbr/R4URaJh53lo01bQcmMbtR7TBpQAucfSNa4xqJpmrkliWB8GnfZOHKCalXlwXkfGi1qBABNaPUnv6Jy+LPKEVu6hkoqMuRlKlGwkih9iHuLx2soF4NX1kjRTIDGlinSwpL25pdJK6aR+ZcNiWn8/mycDAgMYI0XsuR7FgI6V1WmRkNzDaNYLVbg11g7wgMubRz1fIRVweh3TpAJV/6Z03rs13gV9Fnnv5IOpxbt0WrFgKlEjpjJoUPWiNpd0spfXqQ2/yJvT2n69wyVzNXg1Hdz89rorLsgqrDJfCalMbVdu5X11ERY7+9DdTpwymPSRL3E155EqHmufUKSZJnxy6Umq9b8HTGvvTiSxhg3y4D96RQZKKZ6QMCoK8QZ+TaCzaerPqI//1d0Gx2/exW4Np0Z4+eAV+ZNLYrFwDV0t3KLrEscoTkXCcjO8ZrfkQ5NXIUigN6wWxsF7DulOrjE2jJ3pZDlg3XL1kkVO0vvGVFPGNDJoph90zUZE4rYMjP35yrpgvBYQmEDfZT1O/NKbR6U/yesfXnt3+rhynje30GyJzbHHtwr//fuslOdgT0Bqac8XX6PB8XmiCBIN/ud0Ot7Pqyi0tREma+sUbxn1Ea7YWI83y/dX5zFpuphoEtkMTBheCdB2aWJ/bd8C6E40sQccQ/nSZpMou09HbH9wLVgPDdpGY9qyJntttMSzMMS8YWavdCJUtV8Q76gaRT7MkbpdrcQYk9m/ykm7f65bL8LfAyOUWWrCQ3uiuj2YyFd28/hq+s8UycI4SmbSNyNQan3F5HMew2AgkxpLCLAeydLuyBVoLj9+FxUUz7GcDLSbxNHYpgHjxlWS/bfER6ByQO97FbneytJrEsMKRB3FBYgHeGY5XW2qRsXHTM+w6gW02wgoLtMsq2ziTGFb4BCJMWGFdlMpHtQp/V6AZq0x5A6t8kiuRQWK7y3YGCzzqWWEsYsEidnmjoyCwwDpxXCYyF9fiyI+ePEZdCc1ZMOwdw7pYicAlQVwB7sBKzLNcLPKD2Yg0Y+cechL2gD8eyCZzxOHmO5GSXE3Turq41xP4Mte1QzvPA9yDvZ/8+jvVhR/rBaw3FB6ejZDA/s3c6ohJj+vvzpHD39/D7Zlwk2ZDD6R1ATzrChftX3+7SaZ+fpBvXa+GcfQB17pm1rLk/Qsft4u8RxcXYkH2g65cNATfGfPpUHoqzmcpotwxcshpP0rxIxsO5F4rn8jj4DQFz9Z15X6Ca8fAPsu1WIbWtci9rZqpq9VuIXZqALCg3uCWsqCSxF1JZJkYPP1pKDlNn8l7VzFIwXtauxV1ZTsGT2CaHCvR1tNW2PmBCzK7PHYy6HPoLWXQ3M/ZVURuBTFkK8SzY+BZaMBCvtj1nZi1mFz97HTe1JENRgAyZ9MF4htxSZbaqDXuGiI3IsZ6jnWt1zGaOVSGtZhwd5RkQz1bUddBEwfVGO0Y66lro7YyU1eX001cDjcJh++r9Lu6nCLDY24tV6Pu7vqOE7keMWSY3PZSVTaeWc8KjW4fajpQrHeWh290EF9rwN26j+8Z4W4xm62r5PbAutfJ/+vVFcTdvfUJMubfQmzWx+8Ph8Pk8pXLVVJjFMGWJ5DZiDXuOJEbEaOTfpsW2WDZ8rlCT9S1JW4PddHYU3/MwuceJof2HqkhcLUDjI+TF37wArl58wZ5/4P3q76z7DfrWWOgI0v/ZWXzJjGsEGYWeQeKsO68SYxO3Iq64qw0niQud+LsukgMS1yPxCz27dtP9u7d+9hnfnyYZkNr3BEit4IYcsfgHXzACjVyUbqpE6NjJFcz/ANFKv96sx1wJ5Qkzmaz0sV+RTLwrWePEIfDUeVK5YAW3ZOn2upatCKDoOe3idRa5zMo46M7av5eWloiuVy5I+N7vUdHR4ndXiY6SLx1fCuZX5gvEz6VD0YfrgX13tE2iyyfrGhWMT73kL7FLPK1QrBsrUgD8rbu8ujGm8RSW3Hy3Tf4Ntb8nUwmqySWZKAWOR6vXSkJYlctdypv6ESrllvk9eYxy0OSuiz8tm5M8GsSowV1bUnOuUWBYo2OCwXN9zaAv+NE5kGMeDJGnMTHrWM0k64yGtA4HDaunbjdbk+jNGgzFjgSf0RSmdqFRG63W2WBXa7aRVGZrPnAsmVE5jXzM+h0t9wK8UitbaV+INZaJMliy6y7Xn7cKMaGt5CiNVcTKPIIPp87/MPaUaOQI+Hlu9JPOdizWq1k48aNVTLDJ/Z4PDXlFir+cQWhjhCZd851zD8ukYPnlKhvcKilgSLPusoE4NkxkNNFp1srPWxJfpyt+45Nu1Wfg7ysH8wCQZ7CYl9rO5HpUBrSGkoj4cQU+7fX5yU+r8/QMy0FOynFHcSStxEXcdV1P/KFPB3WRo1F0Tt2kOXVWRKLxqVg0mE1NssFyxJPrhKXc5AMOmq/w85KHSBLwapZ10h8mTaqTSKQGZcKMh346jfIQIb+Ti2mkzSeAk5lkySdSUkyNcrZoq4DeQspZZ2019FyyZSmTI3QjEx6WF5eJpcuqRIUF4yUbcuJKTa7FYdnT7M9cnJyigR2BjTvT9MGcSmUiug2n89LQxMuFhi+cCHprrKO1N/CKfRyeod9x39uXSLf3v9dVaPLUbWyDPDvG/8kh584oqofysBa2mw2KaXE4tb8Vcl3VKahEPjg0ioDeeBjPhV42rAeINPlT96TZDKqB3ROyPTNpybryiTndVlcufOeJI8ZmbTatSpvOEz+cfFtqZ4MztLRYqabiAzGXlVGoF/ZM0527d5F7LaychEYLEUfqMiFlE00+jgL4/f7paBBaSFYi4xGQA+XE+64H+Vq8pn0XZj3Z0kSiURIJpOpEhlDINsgIJiy8VA31FErLyq/B3UzIxMIBpnY+hmRSVk/3IsybOdUyqTUgxGZlPqWRhHqEshuAcoMDQ2pZILxwLvkNgdmP5sjs7c/V9IGynmaEnneCMfa8o3h1AeNWqyWh6R8gHYVsZUESeZX6RWTFJNIrRKH3UUCW/bUNMTKykqNb5hOpyUFsY3BBoVyQ8BysSSABWMbw+Oq/a6URCJRbTz53bjYqFo5lKIuq6urtTEC7Qher7fmPRaLtea5jx49Uj2HlQn3K+uHMuxMGGSCPLB+9eoXi8WqHVN+N+rIyqR8D3TA+qnSd4lQK8uSUqlv1AVGgC0D68rqATLdXZwlK6uLUnvj+nzhHvnis0Ut2rxCSRw0yrG2TYjQSp0limOOJGuwEJNWOtVTEMionMasl4+sSeEwjWe0TFYj7aNXhk3uGy3DdjAz5bT+r/V+vTL13t+ojJY+9XLBaDfls9j2Rbuj/TUwU+EL6ToiGyWzMu+o5WvJaZxGcDqdpsto+YJ6ZbT8aK3PlDKZ+bxRXfTepVVGS069Mlr61CuDdlN+LrcvTxK3nchGyIyAAL4Uqwz4WiyZ4RcqFYRhigXKsPdgWFT61fANWSCfyRIDv+M5jcpgiGafi3pq+eJKmZT34G9WRtyvfNfIyEjNPXivcjJBWQb1V8qkzNsqyyh1JbdBozLQ9fDwcMMykAnty5vELckjGyWzrXxswBklmQH4UbvGn1A1GIbEehE+rg2+IzUNtnnzZsldqBfh37l7sybIwXPHxsYaRusog/QWG32DhD6fTxpGtcosRcNSI7JBmJ5MIAqyFmz9INOWLVualqmeBW9GJrSRUiZ0EMhUL2uBMq0gcUcsshHL/NHHH0mNohymoFClcqDM2fufSI2utBLyMKo17N2aD0nvmAt/ojlc12s8lEFZraFVqwxGCnQykIW1ynoy4f5yCm7ZtEyop5ZMWiSG/GZlkjuZlkxyGa3UG9q1FSRuW9aiQTYjZLFaFpTZjEQkKeUVt23bTpwOZ8MJCuQzk+nyNvRlGg0Pe0ZUAaO6wa9WSQ+i4H69xD5Idfvz69VGwYVZR71JjdD/PiDFUlG6VlaXyOaRbTUZjHoyyR0Z9Rwd2kScdpdhmaAHozKBjGZkgr5uzl02JVM8EScXL14kD+89agmJ25ZHNpBnnla6GbLl2b9vv7RzgLUMGFoxlXkl9KHKIgA7tgbIoUOHVbOHKHP9ZoisxtUrA8c3bSMTBw+ppk7RCFeuXCZ376vTmUM+Pzmwb0I1sYMyn965Q27duaGW1WonhyaekcqYkempvfvJnr17TclUTw/IK4euXSHhxS9MyVRPD41kwvalG/TKai8E4kLiriFyIzLLAMEcFeus3HlbD/DxvJVGXF5+VE+ZdcskEnHVSq16GB/farqMLFM2m5HIZVamZvTQapnkMgZk4kbiriJyhcwTFTL31Lc/CZjCfIXEQZ4P7cpvp6GEhs+MI0OnSI9/la6ABPg9IO6bPK0wi/8LMACTCS95oj8djAAAAABJRU5ErkJggg=="

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 262 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 263 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 264 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 265 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 266 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 267 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAACPCAYAAAD9aiWYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABN5JREFUeNrsm89LI2cYgN9osuJGQ2qxLlhoLNnDbmlVCi6C0BQ8rDehrT2aP8B296wHNwc9Ca1t7+2lp/4BLRIwB4XVUxXdPcRCC1uMFVzdJApNdDqfm6SOrYnRzE+fBwadb2b8ZvPke795v3lXBBzJ8PBw7Hybn4/FcZLi+o9pfYvomw9ZzhMU1n881rdH+ha+6Dxk2SspUhpFo9UkIcv++ehRSdKlQZb189G4vsWucj2yrJmP4qWRFLnO3/I74B+zmEwmP/bofBSv9dDgtpEV85ikvpKgeKP/NmGwsQ8N07W+fLdag/LG2+8Y2nbSz5BlQxJbEyVq+ItpQ9uPX36OLLuTWMKgM5LYuB39I8vEJBZZ1s9HSlLfpeaj7oh8+Mm4oS35TQJZTkxib92+LV3R+4wsi+ajcn4UduI9+pFkXhLrCVmTk5OVxHF1ddWwPzs7m7JI0mhJUswtXyy7RtZi+ZeBgQHDvpx7O2rCfDRaTxJbpuvu/Ssns4RBFySxjpelaVrNsDI1NXXhsaWlpZrXDw0NpS4pydYk1g0ja7HWCTMzM5XfNzY25ODgoK7ra4XKyy6qIstFSSyy7JuPxuWKb2I/GPlM3h/51NaHB0/LckMSi6zXor73ykNDPTS59L5vnKgbkWepZLYr+p6hbf3nn5DlSFm6qPMPD26V1SSALCAMGnj3wUf6FjO0NfLNLLIaSFvHW6a+mSUMArKQBc6dszRN+0osXrHu6emRYrFY1zVzc3Ov56w3OyXYETIc6y8dq8xrNc5ZWFiQjEsfMJSomJU3EAwG676mt7f3wmN3qhz7v3PW19cls3tEGARkMWedJ1csyNarrOk3EA21S65QlMyR+aGor6PDm7KUqMerK6bfwNcDD+TXvT35YSttel+phyOEQUAWIAtZgCxAFrIAWVA7Kb7T2irx6F3Tb0D1o1YWrOjL47KiltxEWRgQBr0/srayr+S7589Nv4GJe/dO1yF/+fOF6X2pdUhPylIr4WqB1WzKK+5W9EUYBGQBspAFyAJkIQvszLPaAn5LloBUPyw3XVNWtD1kWcav+nrY3Y0NwuANGFkUebpIFkWehEFAFrIAWYAsZAGyAFle5+K1wVC7JWuDqh8Wcq8pq80fsOwDVH0pYUAY9P7IosjTRbIo8iQMArKQBcgCZCELkAWNzbMo8nSRLIo8CYNgxsiiyNNFsijyJAwCspAFyAJkIQuQBcjyOhR5ekEWRZ6EQTBjZFHk6SJZFHkSBgFZyAJkAbKQBciCxuZZFHm6SBZFnoRBMGNkUeTpIlkUeRIGAVnIAmQBspAFyAJkeR2KPHV+W0nJztZm1XNevvhDkt8mLDmnblk3qcgzv7d7ulXj76O87KSfWXIOYZA5C5AF9c1ZZpDL5SSdNq6ud3Z2yuHhoeTzeUN7f3+/Iz6gk5MTw34gEJBwOCz7+/tSKBSM3/ymJu/IUqImJiYMbWNjY7K5uXm6nWV5edkRspSQ4+Pjyn4oFJLBwUFJpVKSzf77vq+5uVlaWloIg4AsZAGyAFnIAmQBslyEvycSeVLeSSQSEZWdm8X29rbkssbC0ZWnT+Wv3d3/tM/Pz1vyAaytrcnLKv+fuVgsiqZplX21oqHuOZPJyOGZVRefzyd+f2PXGM660fndpzdofGddQeofAQYA9o7FFP7cdPgAAAAASUVORK5CYII="

/***/ }),
/* 268 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAACPCAYAAAD9aiWYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABN5JREFUeNrsm89LI2cYgN9osuJGQ2qxLlhoLNnDbmlVCi6C0BQ8rDehrT2aP8B296wHNwc9Ca1t7+2lp/4BLRIwB4XVUxXdPcRCC1uMFVzdJApNdDqfm6SOrYnRzE+fBwadb2b8ZvPke795v3lXBBzJ8PBw7Hybn4/FcZLi+o9pfYvomw9ZzhMU1n881rdH+ha+6Dxk2SspUhpFo9UkIcv++ehRSdKlQZb189G4vsWucj2yrJmP4qWRFLnO3/I74B+zmEwmP/bofBSv9dDgtpEV85ikvpKgeKP/NmGwsQ8N07W+fLdag/LG2+8Y2nbSz5BlQxJbEyVq+ItpQ9uPX36OLLuTWMKgM5LYuB39I8vEJBZZ1s9HSlLfpeaj7oh8+Mm4oS35TQJZTkxib92+LV3R+4wsi+ajcn4UduI9+pFkXhLrCVmTk5OVxHF1ddWwPzs7m7JI0mhJUswtXyy7RtZi+ZeBgQHDvpx7O2rCfDRaTxJbpuvu/Ssns4RBFySxjpelaVrNsDI1NXXhsaWlpZrXDw0NpS4pydYk1g0ja7HWCTMzM5XfNzY25ODgoK7ra4XKyy6qIstFSSyy7JuPxuWKb2I/GPlM3h/51NaHB0/LckMSi6zXor73ykNDPTS59L5vnKgbkWepZLYr+p6hbf3nn5DlSFm6qPMPD26V1SSALCAMGnj3wUf6FjO0NfLNLLIaSFvHW6a+mSUMArKQBc6dszRN+0osXrHu6emRYrFY1zVzc3Ov56w3OyXYETIc6y8dq8xrNc5ZWFiQjEsfMJSomJU3EAwG676mt7f3wmN3qhz7v3PW19cls3tEGARkMWedJ1csyNarrOk3EA21S65QlMyR+aGor6PDm7KUqMerK6bfwNcDD+TXvT35YSttel+phyOEQUAWIAtZgCxAFrIAWVA7Kb7T2irx6F3Tb0D1o1YWrOjL47KiltxEWRgQBr0/srayr+S7589Nv4GJe/dO1yF/+fOF6X2pdUhPylIr4WqB1WzKK+5W9EUYBGQBspAFyAJkIQvszLPaAn5LloBUPyw3XVNWtD1kWcav+nrY3Y0NwuANGFkUebpIFkWehEFAFrIAWYAsZAGyAFle5+K1wVC7JWuDqh8Wcq8pq80fsOwDVH0pYUAY9P7IosjTRbIo8iQMArKQBcgCZCELkAWNzbMo8nSRLIo8CYNgxsiiyNNFsijyJAwCspAFyAJkIQuQBcjyOhR5ekEWRZ6EQTBjZFHk6SJZFHkSBgFZyAJkAbKQBciCxuZZFHm6SBZFnoRBMGNkUeTpIlkUeRIGAVnIAmQBspAFyAJkeR2KPHV+W0nJztZm1XNevvhDkt8mLDmnblk3qcgzv7d7ulXj76O87KSfWXIOYZA5C5AF9c1ZZpDL5SSdNq6ud3Z2yuHhoeTzeUN7f3+/Iz6gk5MTw34gEJBwOCz7+/tSKBSM3/ymJu/IUqImJiYMbWNjY7K5uXm6nWV5edkRspSQ4+Pjyn4oFJLBwUFJpVKSzf77vq+5uVlaWloIg4AsZAGyAFnIAmQBslyEvycSeVLeSSQSEZWdm8X29rbkssbC0ZWnT+Wv3d3/tM/Pz1vyAaytrcnLKv+fuVgsiqZplX21oqHuOZPJyOGZVRefzyd+f2PXGM660fndpzdofGddQeofAQYA9o7FFP7cdPgAAAAASUVORK5CYII="

/***/ }),
/* 269 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 270 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 271 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/medal.808651ea.svg";

/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/HB1@2x.220d9b09.png";

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/HB2@2x.5ebfaada.png";

/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/HB3@2x.2ff52851.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/HB4.749dbf84.png";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/HB4@2x.5b979066.png";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shadow.33d8726e.png";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/star.8a813fec.svg";

/***/ }),
/* 283 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/globas_trimmed.65de8abe.png";

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lenen_land.0f4e4293.svg";

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/uitlenen_land.7584a0db.svg";

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/schenken_land.d9ffbdd1.svg";

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Auth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ws__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Loading__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__apiCall__ = __webpack_require__(6);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var auth=new __WEBPACK_IMPORTED_MODULE_4_glxl_helpers__["Authorization"]();var _actions$user=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].user,fetchUser=_actions$user.fetchUser,logout=_actions$user.logout;var fetchGhettoRadioGroups=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].ghettoRadio.fetchGhettoRadioGroups;var fetchFeedback=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].feedback.fetchFeedback;var _actions$project=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].project,fetchProject=_actions$project.fetchProject,myProject=_actions$project.myProject,refreshProject=_actions$project.refreshProject,updateProject=_actions$project.updateProject;var _actions$gameStateInp=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].gameStateInput,updateInputStates=_actions$gameStateInp.updateInputStates,updateMyState=_actions$gameStateInp.updateMyState,finishedStep=_actions$gameStateInp.finishedStep;window.timerId=null;window.mainAuth=undefined;var self=undefined;function Auth(ToRender){var allowedRoles=arguments.length>1&&arguments[1]!==undefined?arguments[1]:[];var _class,_temp,_initialiseProps;var allowedSteps=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var props=arguments[3];var Authorization=(_temp=_class=function(_React$Component){_inherits(Authorization,_React$Component);function Authorization(props){_classCallCheck(this,Authorization);var _this=_possibleConstructorReturn(this,(Authorization.__proto__||Object.getPrototypeOf(Authorization)).call(this,props));_initialiseProps.call(_this);var user=_this.props.user;_this.state={user:user,authorized:true,noConnectionPopup:false,removedRoundPopup:false,messageFromAdmin:'',bankDisabledPopup:false};_this.user=props.user||{};_this.mainAuth=!window.mainAuth;if(_this.mainAuth){window.mainAuth=_this.mainAuth;}self=_this;return _this;}_createClass(Authorization,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var currentPathIsBank=this.props.location.pathname.startsWith('/bank');var bankIsDisabled=this.props.project&&this.props.project.bankEnabled===false;var pathWasNotBankBefore=!prevProps.location.pathname.startsWith('/bank');var bankWasJustDisabled=!prevProps.project||prevProps.project.bankEnabled!==false;if(currentPathIsBank&&bankIsDisabled&&(bankWasJustDisabled||pathWasNotBankBefore)){this.setState({bankDisabledPopup:true});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearTimeout(window.timerId);if(this.mainAuth){window.mainAuth=false;}}/**
     * Handle websocket connection
     *//**
     * @name roleAuthorized
     * @return {boolean}
     *//**
     * Method to refresh data and dispatch data changes
     * @return {Promise<void>}
     */},{key:'redirectToLogin',value:function redirectToLogin(){this.props.dispatch(logout());var location=this.props.location;var redirect=location.pathname+location.search;this.props.history.push('/login?redirect='+redirect);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,user=_props.user,gameState=_props.gameState,feedback=_props.feedback,history=_props.history,match=_props.match,location=_props.location,gameStateInput=_props.gameStateInput;if(!this.user.loggedIn&&user.loggedIn){this.refresh(user);}this.setupWebSockets();this.user=_extends({},user);var waitForInputLoad=['groupleader','groupmember'].includes(user.role)&&!gameStateInput.myLatestState.joined;var waitForGameState=user.role!=='schoolcontact'&&!gameState.loaded;if(!auth.getAuthToken()&&!sessionStorage.getItem('token'))this.redirectToLogin();if(!user.loggedIn||!user.userDetails||waitForGameState||waitForInputLoad){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,this.mainAuth||!window.mainAuth?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_Loading__["a" /* default */],null):null,this.renderBankDisabledPopup());}if((user.role==='groupleader'||user.role==='groupmember')&&!feedback.loaded){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,this.mainAuth||!window.mainAuth?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_Loading__["a" /* default */],null):null,this.renderBankDisabledPopup());}if(!this.roleAuthorized()){if(user.role==='classleader'){history.push('/portal/classleader');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}else if(user.role!=='schoolcontact'){history.push('/');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}}if(allowedSteps&&!allowedSteps.includes(gameState.currentStep)){if(props&&props.redirect===false){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}if(gameState.roundData.state==='END'||gameState.currentStep===0){history.push('/portal/group');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}history.push(gameState.simGameEntry);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null);}if(gameStateInput.history){document.getElementsByTagName('body')[0].classList.add('history');}else{document.getElementsByTagName('body')[0].classList.remove('history');}/**
       * If history has been set in sessionStorage, that means that
       * we went back to the portal while in history view.
       *
       * When we go back into the game, we want to go back to the round
       * we were currently watching.
      */var setHistory=parseInt(window.sessionStorage.getItem('history'),10);if(!isNaN(setHistory)&&!this.props.location.pathname.startsWith('/portal')&&gameStateInput.loaded&&this.mainAuth){window.sessionStorage.setItem('history','');this.props.dispatch(__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].feedback.setRound(setHistory));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ToRender,Object.assign({},props,{history:history,match:match,location:location})),this.state.noConnectionPopup?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_geen_verbinding_popup_titel'),description:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_geen_verbinding_popup_beschrijving'),showPopUp:true,customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_herladen'),action:function action(){window.location.reload();}},closePopUpClick:function closePopUpClick(){}}):null,this.state.messageFromAdmin.length?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_bericht_vanuit_admin'),description:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(this.state.messageFromAdmin),showPopUp:true,customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_sluiten'),action:function action(ev){if(ev&&typeof ev.stopPropagation==='function'){ev.stopPropagation();}_this2.setState({messageFromAdmin:''});}},closePopUpClick:function closePopUpClick(ev){if(ev&&typeof ev.stopPropagation==='function'){ev.stopPropagation();}_this2.setState({messageFromAdmin:''});}}):null,this.state.removedRoundPopup?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_huidige_ronde_verwijderd_titel'),description:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_huidige_ronde_verwijderd_beschrijving'),showPopUp:true,customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_herladen'),action:function action(){window.location.href='/portal';}},closePopUpClick:function closePopUpClick(){}}):null,this.renderBankDisabledPopup());}},{key:'renderBankDisabledPopup',value:function renderBankDisabledPopup(){var _this3=this;if(!this.state.bankDisabledPopup)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_bank_uitgeschakeld_melding_titel'),description:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_bank_uitgeschakeld_melding_beschrijving'),showPopUp:true,customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('OK'),action:function action(){_this3.setState({bankDisabledPopup:false});window.location.href='/';}},closePopUpClick:function closePopUpClick(){_this3.setState({bankDisabledPopup:false});window.location.href='/';}});}}]);return Authorization;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component),_class.propTypes={dispatch:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,history:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({go:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,goBack:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,goForward:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,push:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,location:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({})}).isRequired,match:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({isExact:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,params:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({}),path:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,url:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string}).isRequired,location:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({hash:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,key:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,pathname:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string}).isRequired},_initialiseProps=function _initialiseProps(){var _this4=this;this.getTimeDifferenceInSeconds=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_11__apiCall__["a" /* default */])('/define/time');case 2:res=_context.sent;if(!res){_context.next=5;break;}return _context.abrupt('return',new Date(res.time).getTime()-new Date().getTime());case 5:return _context.abrupt('return',0);case 6:case'end':return _context.stop();}}},_callee,_this4);}));this.componentWillMount=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(window.tijdverschil===undefined)){_context2.next=4;break;}_context2.next=3;return _this4.getTimeDifferenceInSeconds();case 3:window.tijdverschil=_context2.sent;case 4:if(!(!_this4.mainAuth&&window.mainAuth)){_context2.next=6;break;}return _context2.abrupt('return');case 6:if(!_this4.props.user.userDetails||!_this4.props.user.loggedIn){_this4.props.dispatch(fetchUser());}_this4.setupWebSockets();if(_this4.props.location.pathname.startsWith('/bank')&&_this4.props.project&&_this4.props.project.bankEnabled===false){_this4.setState({bankDisabledPopup:true});}case 9:case'end':return _context2.stop();}}},_callee2,_this4);}));this.setupWebSockets=function(){var _props2=_this4.props,user=_props2.user,gameState=_props2.gameState,schoolClass=_props2.schoolClass;var userDetails=user.userDetails;window.top.postMessage(''+user.role+(sessionStorage.getItem('redirect')?"-leader":""),'*');// Without the following conditions, we can't set up websockets
if(!userDetails||!gameState.loaded||window.socket||!user.loggedIn||user.role==='schoolcontact')return;// Set window.socket to true so it doesnt get past the conditions the next time
window.socket=true;var schoolClassId=userDetails.group?userDetails.group.SchoolClassId:userDetails.ownedClass?userDetails.ownedClass.id:schoolClass.id;// Attempt to connect to the simulationgame namespace
__WEBPACK_IMPORTED_MODULE_6__ws__["a" /* default */].connect('simulationgame').then(function(s){// Update window.socket
window.socket=s;window.socket.on('connect',function(){console.log('WS connect');// Tell the API we want ot join our schoolclasses room
window.socket.emit('join',{token:user.token,room:'simulationgame-'+schoolClassId,roundNumber:gameState.roundData.roundNumber,schoolClassId:schoolClassId},__WEBPACK_IMPORTED_MODULE_6__ws__["a" /* default */].handleFailedEmit);});// Group specific event handlers
// We joined the room
window.socket.on('joined',function(_ref3){var payload=_ref3.payload,who=_ref3.who;// This is so that the initial join wont refresh data,
// but when we end up triggering another join because of a disconnect,
// we do want to refresh data.
var iJoined=_this4.props.user.userDetails.id===who;if(iJoined&&window.joined){_this4.refresh();}if(iJoined){window.joined=true;}if(user.role==='groupleader'||user.role==='groupmember'){var gameStateInput=_this4.props.gameStateInput;if(!gameStateInput.myLatestState.joined){_this4.props.dispatch(updateMyState(_extends({},payload[gameState.roundData.roundNumber][userDetails.group.id],{joined:true})||{joined:true},true));_this4.props.dispatch(updateInputStates(payload||{}));}}});window.socket.on('scoreVisibilityChanged',function(newValue){_this4.props.dispatch(updateProject(_extends({},_this4.props.project,{showScores:newValue})));});window.socket.on('allFeedbackSetToRead',function(){_this4.props.dispatch(fetchFeedback());});if(_this4.user.role!=='schoolcontact'){window.socket.on('removedCurrentRound',function(){self.setState({removedRoundPopup:true});});}if(user.role==='groupleader'||user.role==='groupmember'){// There has been an update in gameStateInput
window.socket.on('updatedInput',function(_ref4){var payload=_objectWithoutProperties(_ref4,[]);var gameStateInput=_this4.props.gameStateInput;var roundNumber=gameStateInput.myLatestState.roundNumber;var grpId=Object.keys(payload[roundNumber]).length?parseInt(Object.keys(payload[roundNumber])[0],10):-1;var isOwnGroup=grpId!==-1&&grpId===gameStateInput.groupId;var updateOwnGroup=payload[roundNumber][grpId].forceUpdate||isOwnGroup&&payload[roundNumber][grpId].updateOwnGroup&&_this4.props.user.role==='groupmember';if(_this4.props.user.role==='groupmember'){updateOwnGroup=true;}if(updateOwnGroup||gameStateInput.myLatestState.joined&&!isOwnGroup){payload[roundNumber][grpId].updateOwnGroup=undefined;_this4.props.dispatch(updateInputStates(payload,updateOwnGroup));}});}window.socket.on('setTimer',function(payload){_this4.props.dispatch({type:__WEBPACK_IMPORTED_MODULE_7__actions_types__["l" /* SET_TIMER */],payload:payload});});// Simulationstep complete
window.socket.on('finishedSimulationStep',function(payload){if(payload.error){console.error(payload.error);alert(payload.error);return;}console.log('finished simulation step',payload);if(user.role==='groupleader'||user.role==='groupmember'){_this4.props.dispatch(finishedStep(payload));}// If we processed the last step, prevent data reload
if(!['groupleader','groupmember'].includes(user.role)){_this4.refresh();return;}if(payload.step!=='SIMULATION_SPENDING'){_this4.refresh();}else{_this4.preventReload=true;}});// feedback item has been read
window.socket.on('feedbackRead',function(payload){if(_this4.props.user.userDetails.group&&_this4.props.user.userDetails.group.id===payload.groupId){_this4.props.dispatch({type:__WEBPACK_IMPORTED_MODULE_7__actions_types__["p" /* UPDATE_FEEDBACK_READ */],payload:{id:payload.feedbackId,read:payload.read}});}});window.socket.on('schoolClassUpdate',function(cls){if(_this4.props.schoolClass.id==cls.id){_this4.props.dispatch({type:__WEBPACK_IMPORTED_MODULE_7__actions_types__["D" /* UPDATE_SCHOOLCLASS */],payload:cls});}});window.socket.on('groupUpdated',function(groupChanges){if(_this4.props.group.id===groupChanges.id){_this4.props.dispatch({type:__WEBPACK_IMPORTED_MODULE_7__actions_types__["w" /* UPDATE_GROUP */],payload:groupChanges});}// 🤮
if(Array.isArray(_this4.props.schoolClass.Groups)){var indexOfGroup=_this4.props.schoolClass.Groups.findIndex(function(g){return g.id===groupChanges.id;});if(indexOfGroup!==-1){_this4.props.schoolClass.Groups[indexOfGroup]=_extends({},_this4.props.schoolClass.Groups[indexOfGroup],groupChanges);_this4.props.dispatch({type:__WEBPACK_IMPORTED_MODULE_7__actions_types__["D" /* UPDATE_SCHOOLCLASS */],payload:{Groups:_this4.props.schoolClass.Groups}});}}});window.socket.on('messageFromAdmin',function(payload){if(_this4.props.user.role.startsWith('group')){self.setState({messageFromAdmin:payload.message});}});// Classleader activated something
window.socket.on('activate',function(){if(_this4.props.user.role.startsWith('group')){_this4.refresh(_this4.props.user,true);}else if(_this4.props.user.role==='classleader'){_this4.props.dispatch(refreshProject());}});window.socket.on('error',function(err){console.log('WS error',err);self.setState({noConnectionPopup:true});});window.socket.on('disconnect',function(reason){self.setState({noConnectionPopup:true});});window.socket.on('bankDisabled',function(){_this4.refresh();});});};this.roleAuthorized=function(){var role=_this4.props.user.role;if(!allowedRoles.length)return true;if(allowedRoles.includes(role))return true;return false;};this.refresh=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var user=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this4.props.user;var projectId,role,userDetails,ownedClass,group,ownedGroup,schoolClassId;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:if(!(!_this4.mainAuth&&window.mainAuth)){_context3.next=2;break;}return _context3.abrupt('return',false);case 2:if(!_this4.preventReload){_context3.next=4;break;}return _context3.abrupt('return');case 4:projectId=void 0;if(!(!user||!user.userDetails)){_context3.next=7;break;}return _context3.abrupt('return');case 7:role=user.role,userDetails=user.userDetails;if(userDetails){_context3.next=10;break;}return _context3.abrupt('return',null);case 10:ownedClass=userDetails.ownedClass,group=userDetails.group,ownedGroup=userDetails.ownedGroup;if(ownedClass)projectId=ownedClass.ProjectId;if(group)projectId=group.ProjectId;if(ownedGroup)projectId=ownedGroup.ProjectId;if(!(!projectId&&role==='schoolcontact')){_context3.next=17;break;}_this4.props.dispatch(myProject());return _context3.abrupt('return');case 17:schoolClassId=user.userDetails.schoolClass?user.userDetails.schoolClass.id:null;_this4.props.dispatch(fetchProject(projectId,schoolClassId));if(role==='groupmember'||role==='groupleader'){_this4.props.dispatch(fetchFeedback());}if(role==='classleader'){_this4.props.dispatch(fetchGhettoRadioGroups());}case 21:case'end':return _context3.stop();}}},_callee3,_this4);}));return function(){return _ref5.apply(this,arguments);};}();},_temp);return Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return state;})(Authorization);}

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player["default"];
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _Video["default"];
  }
});
Object.defineProperty(exports, "BigPlayButton", {
  enumerable: true,
  get: function get() {
    return _BigPlayButton["default"];
  }
});
Object.defineProperty(exports, "LoadingSpinner", {
  enumerable: true,
  get: function get() {
    return _LoadingSpinner["default"];
  }
});
Object.defineProperty(exports, "PosterImage", {
  enumerable: true,
  get: function get() {
    return _PosterImage["default"];
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider["default"];
  }
});
Object.defineProperty(exports, "Bezel", {
  enumerable: true,
  get: function get() {
    return _Bezel["default"];
  }
});
Object.defineProperty(exports, "Shortcut", {
  enumerable: true,
  get: function get() {
    return _Shortcut["default"];
  }
});
Object.defineProperty(exports, "ControlBar", {
  enumerable: true,
  get: function get() {
    return _ControlBar["default"];
  }
});
Object.defineProperty(exports, "PlayToggle", {
  enumerable: true,
  get: function get() {
    return _PlayToggle["default"];
  }
});
Object.defineProperty(exports, "ForwardControl", {
  enumerable: true,
  get: function get() {
    return _ForwardControl["default"];
  }
});
Object.defineProperty(exports, "ReplayControl", {
  enumerable: true,
  get: function get() {
    return _ReplayControl["default"];
  }
});
Object.defineProperty(exports, "FullscreenToggle", {
  enumerable: true,
  get: function get() {
    return _FullscreenToggle["default"];
  }
});
Object.defineProperty(exports, "ProgressControl", {
  enumerable: true,
  get: function get() {
    return _ProgressControl["default"];
  }
});
Object.defineProperty(exports, "SeekBar", {
  enumerable: true,
  get: function get() {
    return _SeekBar["default"];
  }
});
Object.defineProperty(exports, "PlayProgressBar", {
  enumerable: true,
  get: function get() {
    return _PlayProgressBar["default"];
  }
});
Object.defineProperty(exports, "LoadProgressBar", {
  enumerable: true,
  get: function get() {
    return _LoadProgressBar["default"];
  }
});
Object.defineProperty(exports, "MouseTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _MouseTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "VolumeMenuButton", {
  enumerable: true,
  get: function get() {
    return _VolumeMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRateMenuButton", {
  enumerable: true,
  get: function get() {
    return _PlaybackRateMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRate", {
  enumerable: true,
  get: function get() {
    return _PlaybackRate["default"];
  }
});
Object.defineProperty(exports, "RemainingTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _RemainingTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "CurrentTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _CurrentTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "DurationDisplay", {
  enumerable: true,
  get: function get() {
    return _DurationDisplay["default"];
  }
});
Object.defineProperty(exports, "TimeDivider", {
  enumerable: true,
  get: function get() {
    return _TimeDivider["default"];
  }
});
Object.defineProperty(exports, "MenuButton", {
  enumerable: true,
  get: function get() {
    return _MenuButton["default"];
  }
});
Object.defineProperty(exports, "playerReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.playerReducer;
  }
});
Object.defineProperty(exports, "operationReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.operationReducer;
  }
});
exports.videoActions = exports.playerActions = void 0;

var _Player = _interopRequireDefault(__webpack_require__(808));

var _Video = _interopRequireDefault(__webpack_require__(296));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(293));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(294));

var _PosterImage = _interopRequireDefault(__webpack_require__(295));

var _Slider = _interopRequireDefault(__webpack_require__(174));

var _Bezel = _interopRequireDefault(__webpack_require__(299));

var _Shortcut = _interopRequireDefault(__webpack_require__(300));

var _ControlBar = _interopRequireDefault(__webpack_require__(301));

var _PlayToggle = _interopRequireDefault(__webpack_require__(307));

var _ForwardControl = _interopRequireDefault(__webpack_require__(308));

var _ReplayControl = _interopRequireDefault(__webpack_require__(310));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(311));

var _ProgressControl = _interopRequireDefault(__webpack_require__(302));

var _SeekBar = _interopRequireDefault(__webpack_require__(303));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(304));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(305));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(306));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(316));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(175));

var _PlaybackRate = _interopRequireDefault(__webpack_require__(826));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(312));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(313));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(314));

var _TimeDivider = _interopRequireDefault(__webpack_require__(315));

var _MenuButton = _interopRequireDefault(__webpack_require__(318));

var playerActions = _interopRequireWildcard(__webpack_require__(123));

exports.playerActions = playerActions;

var videoActions = _interopRequireWildcard(__webpack_require__(173));

exports.videoActions = videoActions;

var _reducers = __webpack_require__(291);

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(122)["default"];
var toPrimitive = __webpack_require__(809);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.operationReducer = exports.playerReducer = void 0;

var _player = _interopRequireDefault(__webpack_require__(813));

var _operation = _interopRequireDefault(__webpack_require__(814));

function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    player: (0, _player["default"])(state.player, action),
    operation: (0, _operation["default"])(state.operation, action)
  };
}

var playerReducer = _player["default"];
exports.playerReducer = playerReducer;
var operationReducer = _operation["default"];
exports.operationReducer = operationReducer;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var Fullscreen =
/*#__PURE__*/
function () {
  function Fullscreen() {
    (0, _classCallCheck2["default"])(this, Fullscreen);
  }

  (0, _createClass2["default"])(Fullscreen, [{
    key: "request",
    value: function request(elm) {
      if (elm.requestFullscreen) {
        elm.requestFullscreen();
      } else if (elm.webkitRequestFullscreen) {
        elm.webkitRequestFullscreen();
      } else if (elm.mozRequestFullScreen) {
        elm.mozRequestFullScreen();
      } else if (elm.msRequestFullscreen) {
        elm.msRequestFullscreen();
      }
    }
  }, {
    key: "exit",
    value: function exit() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(handler) {
      document.addEventListener('fullscreenchange', handler);
      document.addEventListener('webkitfullscreenchange', handler);
      document.addEventListener('mozfullscreenchange', handler);
      document.addEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(handler) {
      document.removeEventListener('fullscreenchange', handler);
      document.removeEventListener('webkitfullscreenchange', handler);
      document.removeEventListener('mozfullscreenchange', handler);
      document.removeEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "isFullscreen",
    get: function get() {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    }
  }, {
    key: "enabled",
    get: function get() {
      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    }
  }]);
  return Fullscreen;
}();

var _default = new Fullscreen();

exports["default"] = _default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  position: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  position: 'left'
};

var BigPlayButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(BigPlayButton, _Component);

  function BigPlayButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, BigPlayButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BigPlayButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "handleClick",
    value: function handleClick() {
      var actions = this.props.actions;
      actions.play();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          player = _this$props.player,
          position = _this$props.position;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])('video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
          'big-play-button-hide': player.hasStarted || !player.currentSrc
        }),
        type: "button",
        "aria-live": "polite",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Play Video"));
    }
  }]);
  return BigPlayButton;
}(_react.Component);

exports["default"] = BigPlayButton;
BigPlayButton.propTypes = propTypes;
BigPlayButton.defaultProps = defaultProps;
BigPlayButton.displayName = 'BigPlayButton';

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadingSpinner;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function LoadingSpinner(_ref) {
  var player = _ref.player,
      className = _ref.className;

  if (player.error) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-loading-spinner', className)
  });
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  poster: _propTypes["default"].string,
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function PosterImage(_ref) {
  var poster = _ref.poster,
      player = _ref.player,
      actions = _ref.actions,
      className = _ref.className;

  if (!poster || player.hasStarted) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-poster', className),
    style: {
      backgroundImage: "url(\"".concat(poster, "\")")
    },
    onClick: function onClick() {
      if (player.paused) {
        actions.play();
      }
    }
  });
}

PosterImage.propTypes = propTypes;
PosterImage.displayName = 'PosterImage';
var _default = PosterImage;
exports["default"] = _default;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _utils = __webpack_require__(47);

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  children: _propTypes["default"].any,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  className: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  crossOrigin: _propTypes["default"].string,
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  onResize: _propTypes["default"].func
};

var Video =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Video, _Component);

  function Video(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Video);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
    _this.video = null; // the html5 video

    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate(); // make sure the children can get the video property
    } // get all video properties

  }, {
    key: "getProperties",
    value: function getProperties() {
      var _this2 = this;

      if (!this.video) {
        return null;
      }

      return _utils.mediaProperties.reduce(function (properties, key) {
        properties[key] = _this2.video[key];
        return properties;
      }, {});
    } // get playback rate

  }, {
    key: "play",
    // play the video
    value: function play() {
      var promise = this.video.play();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      var promise = this.video.pause();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // toggle play

  }, {
    key: "togglePlay",
    value: function togglePlay() {
      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      try {
        this.video.currentTime = time;
      } catch (e) {// console.log(e, 'Video is not ready.')
      }
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.seek(this.video.currentTime + seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.forward(-seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.toggleFullscreen(player);
    } // Fired when the user agent
    // begins looking for media data

  }, {
    key: "handleLoadStart",
    value: function handleLoadStart() {
      var _this$props2 = this.props,
          actions = _this$props2.actions,
          onLoadStart = _this$props2.onLoadStart;
      actions.handleLoadStart(this.getProperties());

      if (onLoadStart) {
        onLoadStart.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlay",
    value: function handleCanPlay() {
      var _this$props3 = this.props,
          actions = _this$props3.actions,
          onCanPlay = _this$props3.onCanPlay;
      actions.handleCanPlay(this.getProperties());

      if (onCanPlay) {
        onCanPlay.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlayThrough",
    value: function handleCanPlayThrough() {
      var _this$props4 = this.props,
          actions = _this$props4.actions,
          onCanPlayThrough = _this$props4.onCanPlayThrough;
      actions.handleCanPlayThrough(this.getProperties());

      if (onCanPlayThrough) {
        onCanPlayThrough.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handlePlaying",
    value: function handlePlaying() {
      var _this$props5 = this.props,
          actions = _this$props5.actions,
          onPlaying = _this$props5.onPlaying;
      actions.handlePlaying(this.getProperties());

      if (onPlaying) {
        onPlaying.apply(void 0, arguments);
      }
    } // Fired whenever the media has been started

  }, {
    key: "handlePlay",
    value: function handlePlay() {
      var _this$props6 = this.props,
          actions = _this$props6.actions,
          onPlay = _this$props6.onPlay;
      actions.handlePlay(this.getProperties());

      if (onPlay) {
        onPlay.apply(void 0, arguments);
      }
    } // Fired whenever the media has been paused

  }, {
    key: "handlePause",
    value: function handlePause() {
      var _this$props7 = this.props,
          actions = _this$props7.actions,
          onPause = _this$props7.onPause;
      actions.handlePause(this.getProperties());

      if (onPause) {
        onPause.apply(void 0, arguments);
      }
    } // Fired when the duration of
    // the media resource is first known or changed

  }, {
    key: "handleDurationChange",
    value: function handleDurationChange() {
      var _this$props8 = this.props,
          actions = _this$props8.actions,
          onDurationChange = _this$props8.onDurationChange;
      actions.handleDurationChange(this.getProperties());

      if (onDurationChange) {
        onDurationChange.apply(void 0, arguments);
      }
    } // Fired while the user agent
    // is downloading media data

  }, {
    key: "handleProgress",
    value: function handleProgress() {
      var _this$props9 = this.props,
          actions = _this$props9.actions,
          onProgress = _this$props9.onProgress;

      if (this.video) {
        actions.handleProgressChange(this.getProperties());
      }

      if (onProgress) {
        onProgress.apply(void 0, arguments);
      }
    } // Fired when the end of the media resource
    // is reached (currentTime == duration)

  }, {
    key: "handleEnded",
    value: function handleEnded() {
      var _this$props10 = this.props,
          loop = _this$props10.loop,
          player = _this$props10.player,
          actions = _this$props10.actions,
          onEnded = _this$props10.onEnded;

      if (loop) {
        this.seek(0);
        this.play();
      } else if (!player.paused) {
        this.pause();
      }

      actions.handleEnd(this.getProperties());

      if (onEnded) {
        onEnded.apply(void 0, arguments);
      }
    } // Fired whenever the media begins waiting

  }, {
    key: "handleWaiting",
    value: function handleWaiting() {
      var _this$props11 = this.props,
          actions = _this$props11.actions,
          onWaiting = _this$props11.onWaiting;
      actions.handleWaiting(this.getProperties());

      if (onWaiting) {
        onWaiting.apply(void 0, arguments);
      }
    } // Fired whenever the player
    // is jumping to a new time

  }, {
    key: "handleSeeking",
    value: function handleSeeking() {
      var _this$props12 = this.props,
          actions = _this$props12.actions,
          onSeeking = _this$props12.onSeeking;
      actions.handleSeeking(this.getProperties());

      if (onSeeking) {
        onSeeking.apply(void 0, arguments);
      }
    } // Fired when the player has
    // finished jumping to a new time

  }, {
    key: "handleSeeked",
    value: function handleSeeked() {
      var _this$props13 = this.props,
          actions = _this$props13.actions,
          onSeeked = _this$props13.onSeeked;
      actions.handleSeeked(this.getProperties());

      if (onSeeked) {
        onSeeked.apply(void 0, arguments);
      }
    } // Handle Fullscreen Change

  }, {
    key: "handleFullscreenChange",
    value: function handleFullscreenChange() {} // Fires when the browser is
    // intentionally not getting media data

  }, {
    key: "handleSuspend",
    value: function handleSuspend() {
      var _this$props14 = this.props,
          actions = _this$props14.actions,
          onSuspend = _this$props14.onSuspend;
      actions.handleSuspend(this.getProperties());

      if (onSuspend) {
        onSuspend.apply(void 0, arguments);
      }
    } // Fires when the loading of an audio/video is aborted

  }, {
    key: "handleAbort",
    value: function handleAbort() {
      var _this$props15 = this.props,
          actions = _this$props15.actions,
          onAbort = _this$props15.onAbort;
      actions.handleAbort(this.getProperties());

      if (onAbort) {
        onAbort.apply(void 0, arguments);
      }
    } // Fires when the current playlist is empty

  }, {
    key: "handleEmptied",
    value: function handleEmptied() {
      var _this$props16 = this.props,
          actions = _this$props16.actions,
          onEmptied = _this$props16.onEmptied;
      actions.handleEmptied(this.getProperties());

      if (onEmptied) {
        onEmptied.apply(void 0, arguments);
      }
    } // Fires when the browser is trying to
    // get media data, but data is not available

  }, {
    key: "handleStalled",
    value: function handleStalled() {
      var _this$props17 = this.props,
          actions = _this$props17.actions,
          onStalled = _this$props17.onStalled;
      actions.handleStalled(this.getProperties());

      if (onStalled) {
        onStalled.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // meta data for the audio/video

  }, {
    key: "handleLoadedMetaData",
    value: function handleLoadedMetaData() {
      var _this$props18 = this.props,
          actions = _this$props18.actions,
          onLoadedMetadata = _this$props18.onLoadedMetadata,
          startTime = _this$props18.startTime;

      if (startTime && startTime > 0) {
        this.video.currentTime = startTime;
      }

      actions.handleLoadedMetaData(this.getProperties());

      if (onLoadedMetadata) {
        onLoadedMetadata.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // the current frame of the audio/video

  }, {
    key: "handleLoadedData",
    value: function handleLoadedData() {
      var _this$props19 = this.props,
          actions = _this$props19.actions,
          onLoadedData = _this$props19.onLoadedData;
      actions.handleLoadedData(this.getProperties());

      if (onLoadedData) {
        onLoadedData.apply(void 0, arguments);
      }
    } // Fires when the current
    // playback position has changed

  }, {
    key: "handleTimeUpdate",
    value: function handleTimeUpdate() {
      var _this$props20 = this.props,
          actions = _this$props20.actions,
          onTimeUpdate = _this$props20.onTimeUpdate;
      actions.handleTimeUpdate(this.getProperties());

      if (onTimeUpdate) {
        onTimeUpdate.apply(void 0, arguments);
      }
    }
    /**
     * Fires when the playing speed of the audio/video is changed
     */

  }, {
    key: "handleRateChange",
    value: function handleRateChange() {
      var _this$props21 = this.props,
          actions = _this$props21.actions,
          onRateChange = _this$props21.onRateChange;
      actions.handleRateChange(this.getProperties());

      if (onRateChange) {
        onRateChange.apply(void 0, arguments);
      }
    } // Fires when the volume has been changed

  }, {
    key: "handleVolumeChange",
    value: function handleVolumeChange() {
      var _this$props22 = this.props,
          actions = _this$props22.actions,
          onVolumeChange = _this$props22.onVolumeChange;
      actions.handleVolumeChange(this.getProperties());

      if (onVolumeChange) {
        onVolumeChange.apply(void 0, arguments);
      }
    } // Fires when an error occurred
    // during the loading of an audio/video

  }, {
    key: "handleError",
    value: function handleError() {
      var _this$props23 = this.props,
          actions = _this$props23.actions,
          onError = _this$props23.onError;
      actions.handleError(this.getProperties());

      if (onError) {
        onError.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$props24 = this.props,
          actions = _this$props24.actions,
          onResize = _this$props24.onResize;
      actions.handleResize(this.getProperties());

      if (onResize) {
        onResize.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleKeypress",
    value: function handleKeypress() {}
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;

      var props = (0, _objectSpread2["default"])({}, this.props, {
        video: this.video
      }); // to make sure the children can get video property

      if (!this.video) {
        return null;
      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements


      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
        var cprops;

        if (typeof c.type === 'string') {
          // add onError to <source />
          if (c.type === 'source') {
            cprops = (0, _objectSpread2["default"])({}, c.props);
            var preOnError = cprops.onError;

            cprops.onError = function () {
              if (preOnError) {
                preOnError.apply(void 0, arguments);
              }

              _this3.handleError.apply(_this3, arguments);
            };
          }
        } else {
          cprops = props;
        }

        return _react["default"].cloneElement(c, cprops);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props25 = this.props,
          loop = _this$props25.loop,
          poster = _this$props25.poster,
          preload = _this$props25.preload,
          src = _this$props25.src,
          autoPlay = _this$props25.autoPlay,
          playsInline = _this$props25.playsInline,
          muted = _this$props25.muted,
          crossOrigin = _this$props25.crossOrigin,
          videoId = _this$props25.videoId;
      return _react["default"].createElement("video", {
        className: (0, _classnames["default"])('video-react-video', this.props.className),
        id: videoId,
        crossOrigin: crossOrigin,
        ref: function ref(c) {
          _this4.video = c;
        },
        muted: muted,
        preload: preload,
        loop: loop,
        playsInline: playsInline,
        autoPlay: autoPlay,
        poster: poster,
        src: src,
        onLoadStart: this.handleLoadStart,
        onWaiting: this.handleWaiting,
        onCanPlay: this.handleCanPlay,
        onCanPlayThrough: this.handleCanPlayThrough,
        onPlaying: this.handlePlaying,
        onEnded: this.handleEnded,
        onSeeking: this.handleSeeking,
        onSeeked: this.handleSeeked,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onProgress: this.handleProgress,
        onDurationChange: this.handleDurationChange,
        onError: this.handleError,
        onSuspend: this.handleSuspend,
        onAbort: this.handleAbort,
        onEmptied: this.handleEmptied,
        onStalled: this.handleStalled,
        onLoadedMetadata: this.handleLoadedMetaData,
        onLoadedData: this.handleLoadedData,
        onTimeUpdate: this.handleTimeUpdate,
        onRateChange: this.handleRateChange,
        onVolumeChange: this.handleVolumeChange,
        tabIndex: "-1"
      }, this.renderChildren());
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      if (val > 1) {
        val = 1;
      }

      if (val < 0) {
        val = 0;
      }

      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Video;
}(_react.Component);

exports["default"] = Video;
Video.propTypes = propTypes;
Video.displayName = 'Video';

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(815);
var iterableToArray = __webpack_require__(816);
var unsupportedIterableToArray = __webpack_require__(817);
var nonIterableSpread = __webpack_require__(818);
function _toConsumableArray(r) {
  return arrayWithoutHoles(r) || iterableToArray(r) || unsupportedIterableToArray(r) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 298 */
/***/ (function(module, exports) {

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  manager: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var Bezel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Bezel, _Component);

  function Bezel(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Bezel);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
    _this.timer = null;
    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.state = {
      hidden: true,
      operation: {}
    };
    return _this;
  }

  (0, _createClass2["default"])(Bezel, [{
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      var _this2 = this;

      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
        if (this.timer) {
          // previous animation is not finished
          clearTimeout(this.timer); // cancel it

          this.timer = null;
        } // show it
        // update operation


        this.setState({
          hidden: false,
          count: state.count,
          operation: state.operation
        }); // hide it after 0.5s

        this.timer = setTimeout(function () {
          _this2.setState({
            hidden: true
          });

          _this2.timer = null;
        }, 500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // only displays for shortcut so far
      if (this.state.operation.source !== 'shortcut') {
        return null;
      }

      var style = this.state.hidden ? {
        display: 'none'
      } : null;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-bezel': true,
          'video-react-bezel-animation': this.state.count % 2 === 0,
          'video-react-bezel-animation-alt': this.state.count % 2 === 1
        }, this.props.className),
        style: style,
        role: "status",
        "aria-label": this.state.operation.action
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
      }));
    }
  }]);
  return Bezel;
}(_react.Component);

exports["default"] = Bezel;
Bezel.propTypes = propTypes;
Bezel.displayName = 'Bezel';

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(171));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(297));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _react = __webpack_require__(0);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _dom = __webpack_require__(124);

var propTypes = {
  clickable: _propTypes["default"].bool,
  dblclickable: _propTypes["default"].bool,
  manager: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  shortcuts: _propTypes["default"].array
};
var defaultProps = {
  clickable: true,
  dblclickable: true
};

var Shortcut =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Shortcut, _Component);

  function Shortcut(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Shortcut);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
    _this.defaultShortcuts = [{
      keyCode: 32,
      // spacebar
      handle: _this.togglePlay
    }, {
      keyCode: 75,
      // k
      handle: _this.togglePlay
    }, {
      keyCode: 70,
      // f
      handle: _this.toggleFullscreen
    }, {
      keyCode: 37,
      // Left arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(5, {
          action: 'replay-5',
          source: 'shortcut'
        }); // Go back 5 seconds
      }
    }, {
      keyCode: 74,
      // j
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(10, {
          action: 'replay-10',
          source: 'shortcut'
        }); // Go back 10 seconds
      }
    }, {
      keyCode: 39,
      // Right arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(5, {
          action: 'forward-5',
          source: 'shortcut'
        }); // Go forward 5 seconds
      }
    }, {
      keyCode: 76,
      // l
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(10, {
          action: 'forward-10',
          source: 'shortcut'
        }); // Go forward 10 seconds
      }
    }, {
      keyCode: 36,
      // Home
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.seek(0); // Go to beginning of video
      }
    }, {
      keyCode: 35,
      // End
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        } // Go to end of video


        actions.seek(player.duration);
      }
    }, {
      keyCode: 38,
      // Up arrow
      handle: function handle(player, actions) {
        // Increase volume 5%
        var v = player.volume + 0.05;

        if (v > 1) {
          v = 1;
        }

        actions.changeVolume(v, {
          action: 'volume-up',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 40,
      // Down arrow
      handle: function handle(player, actions) {
        // Decrease volume 5%
        var v = player.volume - 0.05;

        if (v < 0) {
          v = 0;
        }

        var action = v > 0 ? 'volume-down' : 'volume-off';
        actions.changeVolume(v, {
          action: action,
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 190,
      // Shift + >
      shift: true,
      handle: function handle(player, actions) {
        // Increase speed
        var playbackRate = player.playbackRate;

        if (playbackRate >= 1.5) {
          playbackRate = 2;
        } else if (playbackRate >= 1.25) {
          playbackRate = 1.5;
        } else if (playbackRate >= 1.0) {
          playbackRate = 1.25;
        } else if (playbackRate >= 0.5) {
          playbackRate = 1.0;
        } else if (playbackRate >= 0.25) {
          playbackRate = 0.5;
        } else if (playbackRate >= 0) {
          playbackRate = 0.25;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-forward',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 188,
      // Shift + <
      shift: true,
      handle: function handle(player, actions) {
        // Decrease speed
        var playbackRate = player.playbackRate;

        if (playbackRate <= 0.5) {
          playbackRate = 0.25;
        } else if (playbackRate <= 1.0) {
          playbackRate = 0.5;
        } else if (playbackRate <= 1.25) {
          playbackRate = 1.0;
        } else if (playbackRate <= 1.5) {
          playbackRate = 1.25;
        } else if (playbackRate <= 2) {
          playbackRate = 1.5;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-rewind',
          source: 'shortcut'
        });
      }
    }];
    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Shortcut, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mergeShortcuts();
      document.addEventListener('keydown', this.handleKeyPress);
      document.addEventListener('click', this.handleClick);
      document.addEventListener('dblclick', this.handleDoubleClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.shortcuts !== this.props.shortcuts) {
        this.mergeShortcuts();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress);
      document.removeEventListener('click', this.handleClick);
      document.removeEventListener('dblclick', this.handleDoubleClick);
    } // merge the shortcuts from props

  }, {
    key: "mergeShortcuts",
    value: function mergeShortcuts() {
      var getShortcutKey = function getShortcutKey(_ref) {
        var _ref$keyCode = _ref.keyCode,
            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
            _ref$ctrl = _ref.ctrl,
            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
            _ref$shift = _ref.shift,
            shift = _ref$shift === void 0 ? false : _ref$shift,
            _ref$alt = _ref.alt,
            alt = _ref$alt === void 0 ? false : _ref$alt;
        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
      };

      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
      }, {});
      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
        var keyCode = shortcut.keyCode,
            handle = shortcut.handle;

        if (keyCode && typeof handle === 'function') {
          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
        }

        return shortcuts;
      }, defaultShortcuts);

      var gradeShortcut = function gradeShortcut(s) {
        var score = 0;
        var ps = ['ctrl', 'shift', 'alt'];
        ps.forEach(function (key) {
          if (s[key]) {
            score++;
          }
        });
        return score;
      };

      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
        return mergedShortcuts[key];
      }).sort(function (a, b) {
        return gradeShortcut(b) - gradeShortcut(a);
      });
    }
  }, {
    key: "togglePlay",
    value: function togglePlay(player, actions) {
      if (player.paused) {
        actions.play({
          action: 'play',
          source: 'shortcut'
        });
      } else {
        actions.pause({
          action: 'pause',
          source: 'shortcut'
        });
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen(player, actions) {
      actions.toggleFullscreen(player);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (!player.isActive) {
        return;
      }

      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') || // || hasClass(document.activeElement, 'video-react-slider')
      (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
        return;
      }

      var keyCode = e.keyCode || e.which;
      var ctrl = e.ctrlKey || e.metaKey;
      var shift = e.shiftKey;
      var alt = e.altKey;
      var shortcut = this.shortcuts.filter(function (s) {
        if (!s.keyCode || s.keyCode - keyCode !== 0) {
          return false;
        }

        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
          return false;
        }

        return true;
      })[0];

      if (shortcut) {
        shortcut.handle(player, actions);
        e.preventDefault();
      }
    } // only if player is active and player is ready

  }, {
    key: "canBeClicked",
    value: function canBeClicked(player, e) {
      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
        return false;
      }

      return true;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          clickable = _this$props2.clickable;

      if (!this.canBeClicked(player, e) || !clickable) {
        return;
      }

      this.togglePlay(player, actions); // e.preventDefault();
    }
  }, {
    key: "handleDoubleClick",
    value: function handleDoubleClick(e) {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions,
          dblclickable = _this$props3.dblclickable;

      if (!this.canBeClicked(player, e) || !dblclickable) {
        return;
      }

      this.toggleFullscreen(player, actions); // e.preventDefault();
    } // this component dose not render anything
    // it's just for the key down event

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Shortcut;
}(_react.Component);

exports["default"] = Shortcut;
Shortcut.propTypes = propTypes;
Shortcut.defaultProps = defaultProps;
Shortcut.displayName = 'Shortcut';

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(172));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _ProgressControl = _interopRequireDefault(__webpack_require__(302));

var _PlayToggle = _interopRequireDefault(__webpack_require__(307));

var _ForwardControl = _interopRequireDefault(__webpack_require__(308));

var _ReplayControl = _interopRequireDefault(__webpack_require__(310));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(311));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(312));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(313));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(314));

var _TimeDivider = _interopRequireDefault(__webpack_require__(315));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(316));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(175));

var _utils = __webpack_require__(47);

var propTypes = {
  children: _propTypes["default"].any,
  autoHide: _propTypes["default"].bool,
  autoHideTime: _propTypes["default"].number,
  // used in Player
  disableDefaultControls: _propTypes["default"].bool,
  disableCompletely: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  autoHide: true,
  disableCompletely: false
};

var ControlBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ControlBar, _Component);

  function ControlBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ControlBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ControlBar, [{
    key: "getDefaultChildren",
    value: function getDefaultChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5.1
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 5.2
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 5.3
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 6
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 8
      })];
    }
  }, {
    key: "getFullChildren",
    value: function getFullChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_ReplayControl["default"], {
        key: "replay-control",
        order: 2
      }), _react["default"].createElement(_ForwardControl["default"], {
        key: "forward-control",
        order: 3
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 6
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 7
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 8
      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
        key: "remaining-time-display",
        order: 9
      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
        rates: [1, 1.25, 1.5, 2],
        key: "playback-rate",
        order: 10
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 11
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var children = _react["default"].Children.toArray(this.props.children);

      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
      var _this$props = this.props,
          className = _this$props.className,
          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className

      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoHide = _this$props2.autoHide,
          className = _this$props2.className,
          disableCompletely = _this$props2.disableCompletely;
      var children = this.getChildren();
      return disableCompletely ? null : _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-control-bar', {
          'video-react-control-bar-auto-hide': autoHide
        }, className)
      }, children);
    }
  }]);
  return ControlBar;
}(_react.Component);

exports["default"] = ControlBar;
ControlBar.propTypes = propTypes;
ControlBar.defaultProps = defaultProps;
ControlBar.displayName = 'ControlBar';

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(32);

var _classnames = _interopRequireDefault(__webpack_require__(10));

var Dom = _interopRequireWildcard(__webpack_require__(124));

var _SeekBar = _interopRequireDefault(__webpack_require__(303));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var ProgressControl =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ProgressControl, _Component);

  function ProgressControl(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ProgressControl);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
    _this.state = {
      mouseTime: {
        time: null,
        position: 0
      }
    };
    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ProgressControl, [{
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      if (!event.pageX) {
        return;
      }

      var duration = this.props.player.duration;
      var node = (0, _reactDom.findDOMNode)(this.seekBar);
      var newTime = Dom.getPointerPosition(node, event).x * duration;
      var position = event.pageX - Dom.findElPosition(node).left;
      this.setState({
        mouseTime: {
          time: newTime,
          position: position
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      return _react["default"].createElement("div", {
        onMouseMove: this.handleMouseMoveThrottle,
        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
        mouseTime: this.state.mouseTime,
        ref: function ref(c) {
          _this2.seekBar = c;
        }
      }, this.props)));
    }
  }]);
  return ProgressControl;
}(_react.Component);

exports["default"] = ProgressControl;
ProgressControl.propTypes = propTypes;
ProgressControl.displayName = 'ProgressControl';

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _Slider = _interopRequireDefault(__webpack_require__(174));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(304));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(305));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(306));

var _utils = __webpack_require__(47);

var propTypes = {
  player: _propTypes["default"].object,
  mouseTime: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var SeekBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(SeekBar, _Component);

  function SeekBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, SeekBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SeekBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
    /**
     * Get percentage of video played
     *
     * @return {Number} Percentage played
     * @method getPercent
     */

  }, {
    key: "getPercent",
    value: function getPercent() {
      var _this$props$player = this.props.player,
          currentTime = _this$props$player.currentTime,
          seekingTime = _this$props$player.seekingTime,
          duration = _this$props$player.duration;
      var time = seekingTime || currentTime;
      var percent = time / duration;
      return percent >= 1 ? 1 : percent;
    }
  }, {
    key: "getNewTime",
    value: function getNewTime(event) {
      var duration = this.props.player.duration;
      var distance = this.slider.calculateDistance(event);
      var newTime = distance * duration; // Don't let video end while scrubbing.

      return newTime === duration ? newTime - 0.1 : newTime;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {}
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)

      actions.seek(newTime);
      actions.handleEndSeeking(newTime);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event);
      actions.handleSeekingTime(newTime);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var actions = this.props.actions;
      actions.forward(5);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var actions = this.props.actions;
      actions.replay(5);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$player2 = _this$props.player,
          currentTime = _this$props$player2.currentTime,
          seekingTime = _this$props$player2.seekingTime,
          duration = _this$props$player2.duration,
          buffered = _this$props$player2.buffered,
          mouseTime = _this$props.mouseTime;
      var time = seekingTime || currentTime;
      return _react["default"].createElement(_Slider["default"], {
        ref: function ref(input) {
          _this2.slider = input;
        },
        label: "video progress bar",
        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
        valuenow: (this.getPercent() * 100).toFixed(2),
        valuetext: (0, _utils.formatTime)(time, duration),
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        getPercent: this.getPercent,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, _react["default"].createElement(_LoadProgressBar["default"], {
        buffered: buffered,
        currentTime: time,
        duration: duration
      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
        duration: duration,
        mouseTime: mouseTime
      }), _react["default"].createElement(_PlayProgressBar["default"], {
        currentTime: time,
        duration: duration
      }));
    }
  }]);
  return SeekBar;
}(_react.Component);

exports["default"] = SeekBar;
SeekBar.propTypes = propTypes;
SeekBar.displayName = 'SeekBar';

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PlayProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _utils = __webpack_require__(47);

var propTypes = {
  currentTime: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  percentage: _propTypes["default"].string,
  className: _propTypes["default"].string
}; // Shows play progress

function PlayProgressBar(_ref) {
  var currentTime = _ref.currentTime,
      duration = _ref.duration,
      percentage = _ref.percentage,
      className = _ref.className;
  return _react["default"].createElement("div", {
    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
    style: {
      width: percentage
    }
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Progress: ".concat(percentage)));
}

PlayProgressBar.propTypes = propTypes;
PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  duration: _propTypes["default"].number,
  buffered: _propTypes["default"].object,
  className: _propTypes["default"].string
}; // Shows load progress

function LoadProgressBar(_ref) {
  var buffered = _ref.buffered,
      duration = _ref.duration,
      className = _ref.className;

  if (!buffered || !buffered.length) {
    return null;
  }

  var bufferedEnd = buffered.end(buffered.length - 1);
  var style = {};

  if (bufferedEnd > duration) {
    bufferedEnd = duration;
  } // get the percent width of a time compared to the total end


  function percentify(time, end) {
    var percent = time / end || 0; // no NaN

    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
  } // the width of the progress bar


  style.width = percentify(bufferedEnd, duration);
  var parts = []; // add child elements to represent the individual buffered time ranges

  for (var i = 0; i < buffered.length; i++) {
    var start = buffered.start(i);
    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)

    var part = _react["default"].createElement("div", {
      style: {
        left: percentify(start, bufferedEnd),
        width: percentify(end - start, bufferedEnd)
      },
      key: "part-".concat(i)
    });

    parts.push(part);
  }

  if (parts.length === 0) {
    parts = null;
  }

  return _react["default"].createElement("div", {
    style: style,
    className: (0, _classnames["default"])('video-react-load-progress', className)
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Loaded: 0%"), parts);
}

LoadProgressBar.propTypes = propTypes;
LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _utils = __webpack_require__(47);

function MouseTimeDisplay(_ref) {
  var duration = _ref.duration,
      mouseTime = _ref.mouseTime,
      className = _ref.className,
      text = _ref.text;

  if (!mouseTime.time) {
    return null;
  }

  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-mouse-display', className),
    style: {
      left: "".concat(mouseTime.position, "px")
    },
    "data-current-time": time
  });
}

MouseTimeDisplay.propTypes = {
  duration: _propTypes["default"].number,
  mouseTime: _propTypes["default"].object,
  className: _propTypes["default"].string
};
MouseTimeDisplay.displayName = 'MouseTimeDisplay';
var _default = MouseTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var PlayToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlayToggle, _Component);

  function PlayToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlayToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlayToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (player.paused) {
        actions.play();
      } else {
        actions.pause();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      var controlText = player.paused ? 'Play' : 'Pause';
      return _react["default"].createElement("button", {
        ref: function ref(c) {
          _this2.button = c;
        },
        className: (0, _classnames["default"])(className, {
          'video-react-play-control': true,
          'video-react-control': true,
          'video-react-button': true,
          'video-react-paused': player.paused,
          'video-react-playing': !player.paused
        }),
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, controlText));
    }
  }]);
  return PlayToggle;
}(_react.Component);

exports["default"] = PlayToggle;
PlayToggle.propTypes = propTypes;
PlayToggle.displayName = 'PlayToggle';

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(309));

// Pass mode into parent function
var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
ForwardControl.displayName = 'ForwardControl';
var _default = ForwardControl;
exports["default"] = _default;

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  seconds: _propTypes["default"].oneOf([5, 10, 30])
};
var defaultProps = {
  seconds: 10
};

var _default = function _default(mode) {
  var ForwardReplayControl =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2["default"])(ForwardReplayControl, _Component);

    function ForwardReplayControl(props, context) {
      var _this;

      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
      return _this;
    }

    (0, _createClass2["default"])(ForwardReplayControl, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
            actions = _this$props.actions,
            seconds = _this$props.seconds; // Depends mode to implement different actions

        if (mode === 'forward') {
          actions.forward(seconds);
        } else {
          actions.replay(seconds);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            seconds = _this$props2.seconds,
            className = _this$props2.className;
        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));

        if (className) {
          classNames.push(className);
        }

        return _react["default"].createElement("button", {
          ref: function ref(c) {
            _this2.button = c;
          },
          className: classNames.join(' '),
          type: "button",
          onClick: this.handleClick
        }, _react["default"].createElement("span", {
          className: "video-react-control-text"
        }, "".concat(mode, " ").concat(seconds, " seconds")));
      }
    }]);
    return ForwardReplayControl;
  }(_react.Component);

  ForwardReplayControl.propTypes = propTypes;
  ForwardReplayControl.defaultProps = defaultProps;
  return ForwardReplayControl;
};

exports["default"] = _default;

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(309));

// Pass mode into parent function
var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
ReplayControl.displayName = 'ReplayControl';
var _default = ReplayControl;
exports["default"] = _default;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var FullscreenToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FullscreenToggle, _Component);

  function FullscreenToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, FullscreenToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(FullscreenToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.toggleFullscreen(player);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])(className, {
          'video-react-icon-fullscreen-exit': player.isFullscreen,
          'video-react-icon-fullscreen': !player.isFullscreen
        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
        ref: function ref(c) {
          _this2.button = c;
        },
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Non-Fullscreen"));
    }
  }]);
  return FullscreenToggle;
}(_react.Component);

exports["default"] = FullscreenToggle;
FullscreenToggle.propTypes = propTypes;
FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _utils = __webpack_require__(47);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function RemainingTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var remainingTime = duration - currentTime;
  var formattedTime = (0, _utils.formatTime)(remainingTime);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-remaining-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Remaining Time "), "-".concat(formattedTime)));
}

RemainingTimeDisplay.propTypes = propTypes;
RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
var _default = RemainingTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _utils = __webpack_require__(47);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function CurrentTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-current-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Current Time "), formattedTime));
}

CurrentTimeDisplay.propTypes = propTypes;
CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
var _default = CurrentTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _utils = __webpack_require__(47);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function DurationDisplay(_ref) {
  var duration = _ref.player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
  }, _react["default"].createElement("div", {
    className: "video-react-duration-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Duration Time "), formattedTime));
}

DurationDisplay.propTypes = propTypes;
DurationDisplay.displayName = 'DurationDisplay';
var _default = DurationDisplay;
exports["default"] = _default;

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TimeDivider;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  separator: _propTypes["default"].string,
  className: _propTypes["default"].string
};

function TimeDivider(_ref) {
  var separator = _ref.separator,
      className = _ref.className;
  var separatorText = separator || '/';
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
    dir: "ltr"
  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
}

TimeDivider.propTypes = propTypes;
TimeDivider.displayName = 'TimeDivider';

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _PopupButton = _interopRequireDefault(__webpack_require__(819));

var _VolumeBar = _interopRequireDefault(__webpack_require__(821));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  alwaysShowVolume: _propTypes["default"].bool
};
var defaultProps = {
  vertical: false
};

var VolumeMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeMenuButton, _Component);

  function VolumeMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
    _this.state = {
      active: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeMenuButton, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.mute(!player.muted);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        active: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          vertical = _this$props2.vertical,
          player = _this$props2.player,
          className = _this$props2.className;
      var inline = !vertical;
      var level = this.volumeLevel;
      return _react["default"].createElement(_PopupButton["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-volume-menu-button-vertical': vertical,
          'video-react-volume-menu-button-horizontal': !vertical,
          'video-react-vol-muted': player.muted,
          'video-react-vol-0': level === 0 && !player.muted,
          'video-react-vol-1': level === 1,
          'video-react-vol-2': level === 2,
          'video-react-vol-3': level === 3,
          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
        }, 'video-react-volume-menu-button'),
        onClick: this.handleClick,
        inline: inline
      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props)));
    }
  }, {
    key: "volumeLevel",
    get: function get() {
      var _this$props$player = this.props.player,
          volume = _this$props$player.volume,
          muted = _this$props$player.muted;
      var level = 3;

      if (volume === 0 || muted) {
        level = 0;
      } else if (volume < 0.33) {
        level = 1;
      } else if (volume < 0.67) {
        level = 2;
      }

      return level;
    }
  }]);
  return VolumeMenuButton;
}(_react.Component);

VolumeMenuButton.propTypes = propTypes;
VolumeMenuButton.defaultProps = defaultProps;
VolumeMenuButton.displayName = 'VolumeMenuButton';
var _default = VolumeMenuButton;
exports["default"] = _default;

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  tagName: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  tagName: 'div'
};

var ClickableComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClickableComponent, _Component);

  function ClickableComponent(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClickableComponent);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ClickableComponent, [{
    key: "handleKeypress",
    value: function handleKeypress(event) {
      // Support Space (32) or Enter (13) key operation to fire a click event
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var onClick = this.props.onClick;
      onClick(event);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeypress);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeypress);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Tag = this.props.tagName;
      var props = (0, _objectSpread2["default"])({}, this.props);
      delete props.tagName;
      delete props.className;
      return _react["default"].createElement(Tag, (0, _extends2["default"])({
        className: (0, _classnames["default"])(this.props.className),
        role: "button",
        tabIndex: "0",
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, props));
    }
  }]);
  return ClickableComponent;
}(_react.Component);

exports["default"] = ClickableComponent;
ClickableComponent.propTypes = propTypes;
ClickableComponent.defaultProps = defaultProps;
ClickableComponent.displayName = 'ClickableComponent';

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _Menu = _interopRequireDefault(__webpack_require__(823));

var _MenuItem = _interopRequireDefault(__webpack_require__(824));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(317));

var propTypes = {
  inline: _propTypes["default"].bool,
  items: _propTypes["default"].array,
  className: _propTypes["default"].string,
  onSelectItem: _propTypes["default"].func,
  children: _propTypes["default"].any,
  selectedIndex: _propTypes["default"].number
};

var MenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuButton, _Component);

  function MenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
    _this.state = {
      active: false,
      activateIndex: props.selectedIndex || 0
    };
    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedIndex !== this.props.selectedIndex) {
        this.activateMenuItem(this.props.selectedIndex);
      }
    }
  }, {
    key: "commitSelection",
    value: function commitSelection(index) {
      this.setState({
        activateIndex: index,
        active: false
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "activateMenuItem",
    value: function activateMenuItem(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "handleIndexChange",
    value: function handleIndexChange(index) {
      var onSelectItem = this.props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState(function (prevState) {
        return {
          active: !prevState.active
        };
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      document.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
      document.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleUpArrow",
    value: function handleUpArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex - 1;

        if (newIndex < 0) {
          newIndex = items.length ? items.length - 1 : 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleDownArrow",
    value: function handleDownArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex + 1;

        if (newIndex >= items.length) {
          newIndex = 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleTab",
    value: function handleTab(e) {
      if (this.state.active) {
        e.preventDefault();
        this.commitSelection(this.state.activateIndex);
      }
    }
  }, {
    key: "handleReturn",
    value: function handleReturn(e) {
      e.preventDefault();

      if (this.state.active) {
        this.commitSelection(this.state.activateIndex);
      } else {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "handleEscape",
    value: function handleEscape() {
      this.setState({
        active: false,
        activateIndex: 0
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      // Escape (27) key
      if (event.which === 27) {
        this.handleEscape(event);
      } else if (event.which === 9) {
        // Tab (9) key
        this.handleTab(event);
      } else if (event.which === 13) {
        // Enter (13) key
        this.handleReturn(event);
      } else if (event.which === 38) {
        // Up (38) key
        this.handleUpArrow(event);
      } else if (event.which === 40) {
        // Down (40) key press
        this.handleDownArrow(event);
      }
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(i) {
      this.commitSelection(i);
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }

      var items = this.props.items;
      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
        return _react["default"].createElement(_MenuItem["default"], {
          item: item,
          index: i,
          onSelectItem: _this2.handleSelectItem,
          activateIndex: _this2.state.activateIndex,
          key: "item-".concat(i++)
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          inline = _this$props.inline,
          className = _this$props.className;
      return _react["default"].createElement(_ClickableComponent["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-menu-button-inline': !!inline,
          'video-react-menu-button-popup': !inline,
          'video-react-menu-button-active': this.state.active
        }, 'video-react-control video-react-button video-react-menu-button'),
        role: "button",
        tabIndex: "0",
        ref: function ref(c) {
          _this3.menuButton = c;
        },
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props.children, this.renderMenu());
    }
  }]);
  return MenuButton;
}(_react.Component);

exports["default"] = MenuButton;
MenuButton.propTypes = propTypes;
MenuButton.displayName = 'MenuButton';

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrow_udown_green.07139ae6.svg";

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_finish_svg__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_finish_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_finish_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_finish_white_svg__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_finish_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_finish_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_map_svg__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_map_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_map_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_list_svg__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_list_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_list_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var GameTopBar=(_temp=_class=function(_Component){_inherits(GameTopBar,_Component);function GameTopBar(props){_classCallCheck(this,GameTopBar);//Array of viewTypes the roundlist should be hidden on.
var _this=_possibleConstructorReturn(this,(GameTopBar.__proto__||Object.getPrototypeOf(GameTopBar)).call(this,props));_this.goBack=function(){_this.props.history.goBack();};var hideRoundList=['feedback'];_this.state={// To do, replace with function getting current round
currentRound:2,totalRounds:4,// To do, these values should be inherited from parent calling this component
buttonType:_this.props.buttonType,viewType:_this.props.viewType,hideRoundList:hideRoundList.includes(_this.props.viewType)};console.log(_this.props);return _this;}_createClass(GameTopBar,[{key:'changeRound',value:function changeRound(number){this.props.dispatch(__WEBPACK_IMPORTED_MODULE_5__actions__["b" /* feedback */].setRound(number));}},{key:'openRounds',value:function openRounds(){if(this.state.desktopRounds){this.setState({desktopRounds:false});}else{this.setState({desktopRounds:true});}}},{key:'roundList',value:function roundList(){var _this2=this;var roundsArray=[];var maxRounds=5;var _props$feedback=this.props.feedback,currentRound=_props$feedback.currentRound,totalRounds=_props$feedback.totalRounds;for(var i=0;i<=maxRounds;i++){roundsArray.push(i);}var renderedList=roundsArray.map(function(number,i){if(number===0)return null;if(number!==maxRounds){if(number===currentRound){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,className:'current'},number);}else if(number<totalRounds){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,className:'prev',onClick:function onClick(_){return _this2.changeRound(number);}},number);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i,className:'next'},number);}}else{if(number===currentRound){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+1,className:'finish-step current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'finish',src:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_finish_white_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+2,className:'finish-step desktop current'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'finish',src:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_finish_white_svg___default.a})));}else if(number<totalRounds){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+1,className:'finish-step prev',onClick:function onClick(_){return _this2.changeRound(number);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'finish',src:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_finish_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+2,className:'finish-step desktop prev',onClick:function onClick(_){return _this2.changeRound(number);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'finish',src:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_finish_svg___default.a})));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+1,className:'finish-step next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'finish',src:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_finish_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i+2,className:'finish-step desktop next'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'finish',src:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_finish_svg___default.a})));}}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.desktopRounds?'all-rounds active':'all-rounds'},renderedList);}},{key:'changeView',value:function changeView(type){if(type==='list'){this.setState({viewType:'map'});}else{this.setState({viewType:'list'});}}},{key:'generateButton',value:function generateButton(){var _this3=this;var buttonType=this.state.buttonType;var viewType=this.state.viewType;if(buttonType==='view'){var disableButton=this.props.gameState.currentStep===2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:viewType==='list'?'/':'/ministries',className:'switch orange-circle-button'+(disableButton?' disabled':''),onClick:function onClick(ev){if(!disableButton){_this3.changeView(viewType);}else{ev.preventDefault();ev.stopPropagation();}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'viewType',src:viewType==='list'?__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_map_svg___default.a:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_list_svg___default.a}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{onClick:function onClick(ev){var forceLocation=false;if(_this3.props.match){var _props=_this3.props,match=_props.match,gameState=_props.gameState;if(match.path.startsWith('/ministries')){// 🤮🤮🤮🤮
if(gameState.currentStep===3&&gameState.difficulty==='BASIC'&&match.params.id&&match.path.indexOf('budget')===-1){window.location.href='/ministries/budget/'+match.params.id;return false;}// 🤮🤮
if(sessionStorage.getItem('prevLocation')==='/'){forceLocation='/';}else{// 🤮
window.scrollToMinistry=String(match.params.ministryId||match.params.id||'').toLowerCase();forceLocation="/ministries";}// 🤮🤮🤮🤮🤮
if(gameState.difficulty==='BASIC'){if(sessionStorage.getItem('toMin')==='map'){forceLocation='/';}}}}if(__WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].location.pathname.startsWith('/beleidskeuzes')){// 🤮🤮🤮
return;}else{if(forceLocation){if(ev&&typeof ev.preventDefault==='function'){ev.preventDefault();}_this3.props.history.push(forceLocation);return true;}return false;}},history:this.props.history});}}},{key:'render',value:function render(){var _this4=this;var currentRound=this.props.feedback.currentRound;if(!this.state.hideRoundList){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gametopbar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gametopbar-title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_spelronde'))),this.roundList(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gametopbar-button'},this.generateButton()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rounds-desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_ronde').split('').reverse().map(function(char){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:char},char);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'cursor-pointer',onClick:function onClick(){return _this4.openRounds();}},currentRound>=5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'finish-round',alt:'finish',src:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_finish_white_svg___default.a}):isNaN(this.props.feedback.currentRound)?'-':this.props.feedback.currentRound,' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.desktopRounds?'arrow-round active':'arrow-round'})),this.roundList()));}else{return null;}}}]);return GameTopBar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func}).isRequired,buttonType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,viewType:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string},_class.defaultProps={viewType:'map',buttonType:'view',desktopRounds:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(function(_ref){var policyChoice=_ref.policyChoice,gameStateInput=_ref.gameStateInput,project=_ref.project,feedback=_ref.feedback,gameState=_ref.gameState;return{policyChoice:policyChoice,gameStateInput:gameStateInput,project:project,feedback:feedback,gameState:gameState};})(GameTopBar));

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/finish.b444f972.svg";

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/finish_white.216ff429.svg";

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BudgetHeaderDropdown__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_bankHelper__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_budget_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_budget_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_budget_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_bank_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_bank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_bank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_beleidskeuze_svg__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_beleidskeuze_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_beleidskeuze_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_gameStateInput__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_popupHelper__ = __webpack_require__(19);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;};var updateMyState=__WEBPACK_IMPORTED_MODULE_11__actions_gameStateInput__["a" /* default */].updateMyState;var previousGlobas=9999;var BudgetHeader=(_temp=_class=function(_DifficultyAwareCompo){_inherits(BudgetHeader,_DifficultyAwareCompo);function BudgetHeader(props){_classCallCheck(this,BudgetHeader);var _this=_possibleConstructorReturn(this,(BudgetHeader.__proto__||Object.getPrototypeOf(BudgetHeader)).call(this,props));_this.state={previousGlobas:9999,closedNegativeBudgetPopup:false};_this.sendGlobas=null;return _this;}_createClass(BudgetHeader,[{key:'renderLaag',value:function renderLaag(){var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,myState=_props.myState,policyChoice=_props.policyChoice,project=_props.project;var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling;if(gameStateInput===undefined)return;var loanSpare=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,myState.policyChoices,ministerieGlobaVerdeling,loanSpare,policyChoice);var bankActive=window.location.pathname.toLowerCase().substr(1)==='bank';var bankEnabled=project&&project.bankEnabled!==false;// Dit is alleen voor laag! Dus is niet "vergeten" bij pro.
// const showNegativeBudgetPopup = globas < 0 && gameState.roundData.roundNumber <= 4 && !this.state.closedNegativeBudgetPopup;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-header low-budget-header'+(bankEnabled?'':' no-bank')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BudgetHeaderDropdown__["a" /* default */],{history:this.props.history,title:''+globas,doubleTitle:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_budget'),icon:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_budget_png___default.a,dropdownTitle:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_budget')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_overheidsinkomsten'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Math.abs(gameState.totalGameStateSum.globas),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'min'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_overheidsuitgaven'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Math.abs(Object(__WEBPACK_IMPORTED_MODULE_7__helpers_policyChoiceHelper__["k" /* getTotalCosts */])(myState.policyChoices,policyChoice)+Object.values(ministerieGlobaVerdeling).filter(function(i){return parseInt(i,10);}).reduce(function(acc,i){return acc+i;},0)),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'))),bankEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:loanSpare>0?'plus':'min'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_saldo_sparen_lenen'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Math.abs(loanSpare),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'divider'},'-------------------------------'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_resterend_budget'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,globas,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas')))))),bankEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BudgetHeaderDropdown__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bank'),icon:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_bank_png___default.a,bank:true,active:bankActive}):null);}},{key:'renderHoog',value:function renderHoog(){var _props2=this.props,gameState=_props2.gameState,gameStateInput=_props2.gameStateInput,myState=_props2.myState,dispatch=_props2.dispatch,project=_props2.project;var debitCredit=gameStateInput.myState.debitCredit;var policyChoices=myState.policyChoices,ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling;if(gameStateInput===undefined)return;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_calculationsHelper__["b" /* calculateBudgetPRO */])(gameState,gameStateInput,policyChoices,myState.ministerieGlobaVerdeling,savingsAndLoans);if(globas!==previousGlobas){clearTimeout(this.sendGlobas);previousGlobas=globas;this.sendGlobas=setTimeout(function(){dispatch(updateMyState({debitCredit:_extends({},debitCredit,{globas:globas})}));},1000);}var numChoices=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_policyChoiceHelper__["h" /* getSelectedPolicyChoicesCount */])(policyChoices);var showPolicyChoices=project&&project.minPolicyChoices>0;var unreadGifts=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_bankHelper__["e" /* getUnreadGifts */])(gameStateInput);var bankUnread=Object.values(gameStateInput.myState.debitCredit).some(function(dc){return dc.confirmed&&dc.unread;})||unreadGifts;var bankActive=window.location.pathname.toLowerCase().substr(1)==='bank';var bankEnabled=project&&project.bankEnabled!==false;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-header'+(bankEnabled?'':' no-bank')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BudgetHeaderDropdown__["a" /* default */],{history:this.props.history,title:''+globas,icon:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_budget_png___default.a,dropdownTitle:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_budget')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_overheidsinkomsten'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,gameState.totalGameStateSum.globas,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'min'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_overheidsuitgaven'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object.values(policyChoices).reduce(function(acc,o){return acc+o.globas;},0)+Object.values(ministerieGlobaVerdeling).filter(function(i){return parseInt(i,10);}).reduce(function(acc,i){return acc+i;},0),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'))),bankEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:savingsAndLoans>0?'plus':'min'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_saldo_sparen_lenen'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Math.abs(savingsAndLoans),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'divider'},'-------------------------------'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_resterend_budget'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,globas,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas')))))),bankEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BudgetHeaderDropdown__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bank'),icon:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_bank_png___default.a,bank:true,notification:bankUnread,active:bankActive}):null,showPolicyChoices?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__BudgetHeaderDropdown__["a" /* default */],{history:this.props.history,title:numChoices+'/10',icon:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_beleidskeuze_svg___default.a},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_popupHelper__["d" /* getContent */])('dhgmstap3beleidskeuzes',this.props.gameState.language).replace(/h1/g,'h3')}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ol',{className:'policy-list'},Object.values(policyChoices).map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:item.nummer+item.ministry},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'left'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(item.ministry),' - ',item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'right'},item.globas,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'divider'},numChoices?'-------------------------------':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_totale_kosten_beleidskeuzes'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object.values(policyChoices).reduce(function(accumulator,item){return accumulator+item.globas;},0),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_resterende_beleidskeuzes'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,10-numChoices))))):null);}}]);return BudgetHeader;}(__WEBPACK_IMPORTED_MODULE_3__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,gameStateInput=_ref.gameStateInput,project=_ref.project,policyChoice=_ref.policyChoice;return{gameState:gameState,gameStateInput:gameStateInput,myState:gameStateInput.myState,project:project,policyChoice:policyChoice};})(BudgetHeader));

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(32));

var _reactLifecyclesCompat = __webpack_require__(179);

var _PropTypes = __webpack_require__(325);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(179);

var _ChildMapping = __webpack_require__(851);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
    this.mounted = true;
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_map_png__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_map_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_map_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_mapFallout_png__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_mapFallout_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_mapFallout_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_mapCloud_1_png__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_mapCloud_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_mapCloud_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_mapCloud_2_png__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_mapCloud_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_mapCloud_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_mapDecoration_Plane_png__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_mapDecoration_Plane_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_mapDecoration_Plane_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_zoom_out_svg__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_zoom_out_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_zoom_out_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_zoom_in_svg__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_zoom_in_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_zoom_in_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Balloon__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Radiation__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_audio_Bomb_3_mp3__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_audio_Bomb_3_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_audio_Bomb_3_mp3__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var lastPosX=void 0;var lastPosY=void 0;var lastPosZ=void 0;var currentZ=void 0;var minZoom=void 0;var maxZoom=void 0;var maxY=void 0;var minY=void 0;var zoomStep=void 0;var desktop=void 0;var MapImage=void 0;var isDragging=void 0;initDefaultVars();function initDefaultVars(){lastPosX=0;lastPosY=0;lastPosZ=1;currentZ=1;minZoom=.5;maxZoom=4;maxY=50;minY=-50;zoomStep=undefined;desktop=false;MapImage=__WEBPACK_IMPORTED_MODULE_2__assets_img_map_png___default.a;if(document.querySelector('#root').clientWidth>=1240){desktop=true;minZoom=.6;maxZoom=1.4;}isDragging=false;}window.mapElementsAnimationTimePassed=0;var MapView=(_temp=_class=function(_Component){_inherits(MapView,_Component);function MapView(props){_classCallCheck(this,MapView);var _this=_possibleConstructorReturn(this,(MapView.__proto__||Object.getPrototypeOf(MapView)).call(this,props));_initialiseProps.call(_this);_this.state={mapTop:0,mapLeft:0,currentZ:1,maxZoom:maxZoom,minZoom:minZoom,zoomBarPercentage:50,lowBudgetWarning:true,boom:false,nuuk:false,fallout:false};_this.draggable=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.mapElement=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.rafStarted=0;_this.raf=0;_this.animationTimePassedOnConstruct=window.mapElementsAnimationTimePassed;_this.calculateZoomPercentage=_this.calculateZoomPercentage.bind(_this);if(!desktop){initDefaultVars();}return _this;}_createClass(MapView,[{key:'toPercent',value:function toPercent(input,scale){return input/scale*100;}},{key:'toPixel',value:function toPixel(input,scale){if(input===0){return 0;}return input/100*scale;}},{key:'onRouteChange',value:function onRouteChange(){document.querySelector('body').classList.remove('noScroll');document.querySelector('html').classList.remove('noScroll');if(window.location.pathname==='/'){document.querySelector('body').classList.add('noScroll');document.querySelector('html').classList.add('noScroll');}}},{key:'componentDidMount',value:function componentDidMount(){this.calculateZoomPercentage();document.addEventListener('DOMContentLoaded',this.keyMapper());document.querySelector('body').classList.add('noScroll');document.querySelector('html').classList.add('noScroll');document.documentElement.scrollTop=0;//Set the position to last known...
document.querySelector('#draggable').style.transform='translate3d('+lastPosX+'%, '+lastPosY+'%, 0) scale('+currentZ+')';if(!desktop){this.props.history.listen(this.onRouteChange.bind(this));}var area=document.querySelector('#gameMap');var mc=new __WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a(area);mc.add(new __WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a.Pan({direction:__WEBPACK_IMPORTED_MODULE_1_hammerjs___default.a.DIRECTION_ALL,threshold:0}));mc.get('pinch').set({enable:true,threshold:0});mc.on('pinch pan',this.mapMove);mc.on('pinchend',this.saveZoom);var self=this;area.addEventListener('wheel',function(ev){window.setTimeout(self.mapMove(ev),50);self.saveZoom();});// Handle click outside list view somewhere on map
var desktopMap=document.getElementsByClassName('map')[0];if(desktopMap){desktopMap.addEventListener('mousedown',this.handleOutsideClick);}this.animate(850,400,"balloon",[-100,-93.35],[100,93.35],[0,60]);this.animate(550,0,"cloud--1",[-100,-93.35],[100,93.35],[0,15]);this.animate(550,-250,"cloud--2",[-100,-93.35],[100,93.35],[0,15]);this.animate(585,-100,"cloud--3",[-100,-93.35],[100,93.35],[0,60]);this.animate(535,-400,"cloud--4",[-100,-93.35],[100,93.35],[0,60]);this.animate(90,0,"airplane",[100,-93.35],[-100,93.35],[0,50],3);}},{key:'componentWillUnmount',value:function componentWillUnmount(){var desktopMap=document.getElementsByClassName('map')[0];if(desktopMap){desktopMap.removeEventListener('mousedown',this.handleOutsideClick);}document.removeEventListener('DOMContentLoaded',this.keyMapper());cancelAnimationFrame(this.raf);}/**
   * This method handles click events (ignores drags) on the map element.
   * When you click on the map and not on an element on the map, we go back to the map view
   * and close the list view.
   */},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'gameMap',className:this.props.unHighlight?'unHighlight':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'draggable',ref:this.draggable,style:{top:this.state.mapTop,left:this.state.mapLeft}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cloudContainer '+(this.state.boom?'boom':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"balloon",className:'cloudWrap balloon animated-map-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Balloon__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cloud--1',className:'cloudWrap cloud--1 animated-map-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_img_mapCloud_1_png___default.a,alt:"Cloud"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cloud--2',className:'cloudWrap cloud--2 animated-map-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_img_mapCloud_2_png___default.a,alt:"Cloud"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cloud--3',className:'cloudWrap cloud--3 animated-map-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_img_mapCloud_1_png___default.a,alt:"Cloud"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'cloud--4',className:'cloudWrap cloud--4 animated-map-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_img_mapCloud_2_png___default.a,alt:"Cloud"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'airplane',className:'cloudWrap airplane animated-map-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_img_mapDecoration_Plane_png___default.a,alt:"Airplane"})),!this.state.nuuk?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:"nuuk",className:'cloudWrap nuuk animated-map-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Radiation__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'map '+(this.state.boom?'boom':''),ref:this.mapElement,style:this.state.fallout?{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_3__assets_img_mapFallout_png___default.a+")"}:{backgroundImage:"url("+MapImage+")"}},!this.state.boom?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'boom'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{ref:'boomRef',autoPlay:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_11__assets_audio_Bomb_3_mp3___default.a,type:'audio/mp3'})),this.props.children)),desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktop-zoom'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'zoombutton',onClick:this.zoomDesktop.bind(this,1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_zoom_out_svg___default.a,alt:'zoom-out'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{style:{width:this.state.zoomBarPercentage+'%'}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'zoombutton',onClick:this.zoomDesktop.bind(this,-1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_zoom_in_svg___default.a,alt:'zoom-in'}))):null);}}]);return MapView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this2=this;this.panObject=function(ev){var elem=document.querySelector('#draggable');var re=/(-{0,1}[0-9]+(\.[0-9]+)?%)/g;var transform=elem.style.transform;var translate3d=transform.match(re);if(!isDragging){isDragging=true;if(translate3d!==null){lastPosX=parseInt(translate3d[0],10);lastPosY=parseInt(translate3d[1],10);}}var map=document.querySelector('.map');var maxX=(map.offsetWidth/elem.offsetWidth-1/currentZ)/2*100;maxX=maxX+(document.querySelector('body').offsetWidth-elem.offsetWidth)/2*(1/currentZ/2);if(desktop){maxX=maxX*.3;}var posX=ev.deltaX===0?lastPosX:_this2.toPercent(ev.deltaX/currentZ+_this2.toPixel(lastPosX,elem.offsetWidth),elem.offsetWidth);var posY=ev.deltaY===0?lastPosY:_this2.toPercent(ev.deltaY/currentZ+_this2.toPixel(lastPosY,elem.offsetHeight),elem.offsetHeight);if(posX>maxX){posX=maxX+'%';}else if(posX<-maxX){posX=-maxX+'%';}if(posY>maxY){posY=maxY+'%';}else if(posY<minY){posY=-maxY+'%';}var transformString='translate3d('+parseFloat(posX).toFixed(2)+'%, '+parseFloat(posY).toFixed(2)+'%, 0)';if(ev.isFinal){isDragging=false;if(translate3d!==null){lastPosX=parseFloat(translate3d[0]).toFixed(2);lastPosY=parseFloat(translate3d[1]).toFixed(2);}}return transformString;};this.scaleObject=function(ev){var output=1;if(ev.type==='wheel'){if(!ev.fake){ev.preventDefault();zoomStep=.05;}else{zoomStep=.2;}if(ev.deltaY<0){output=currentZ+zoomStep;}if(ev.deltaY>0){output=currentZ-zoomStep;}if(ev.deltaY===0){output=currentZ;}if(currentZ===null){output=1;}}else{output=lastPosZ*ev.scale;}if(output>maxZoom){output=maxZoom;}else if(output<minZoom){output=minZoom;}currentZ=output;_this2.setState({currentZ:currentZ});return'scale('+currentZ+')';};this.saveZoom=function(){lastPosZ=currentZ;_this2.calculateZoomPercentage();};this.calculateZoomPercentage=function(){var zoomBarPercentage=parseInt((lastPosZ-minZoom)*100/(maxZoom-minZoom),10);_this2.setState({zoomBarPercentage:zoomBarPercentage});};this.zoomDesktop=function(inOrOut){var event={fake:true,type:'wheel',deltaY:inOrOut,deltaX:0};_this2.mapMove(event);_this2.saveZoom();_this2.calculateZoomPercentage();};this.mapMove=function(ev){var transform=[];var foo=_this2.scaleObject(ev);transform.push(foo);if(ev.type==='wheel'){transform.push('translate3d('+lastPosX+'%, '+lastPosY+'%, 0)');}else{transform.push(_this2.panObject(ev));}var elem=document.querySelector('#draggable');elem.style.transform=transform.join(" ");};this.keyMapper=function(){var buffer="";var lastKeyTime=Date.now();document.addEventListener('keydown',function(event){var charList='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ@0123456789.';var key=event.key;if(charList.indexOf(key)===-1)return;var currentTime=Date.now();if(currentTime-lastKeyTime>1000){buffer="";}buffer+=key;lastKeyTime=currentTime;if(buffer==="DukeNukemGlobalandXLForever.TM"){if(window.sessionStorage.getItem('fired')!=='true'){_this2.onBlow();window.sessionStorage.setItem('fired','true');}}});};this.getPosition=function(progress,totalDistance,radians,initPos,targPos){var xDelta=totalDistance*progress*Math.cos(radians);var yDelta=totalDistance*progress*Math.sin(radians);var x=initPos[0]>targPos[0]?initPos[0]-xDelta:initPos[0]+xDelta;var y=initPos[1]>targPos[1]?initPos[1]-yDelta:initPos[1]+yDelta;return[x,y];};this.animate=function(duration,delay,element,startPosition,endPosition,offset){var wait=arguments.length>6&&arguments[6]!==undefined?arguments[6]:1;var ignoreTiming=arguments.length>7&&arguments[7]!==undefined?arguments[7]:false;var elem=document.getElementById(element);if(!elem)return;var offsetX=offset[0];var offsetY=offset[1];//Calculate position with percentages from elem's original pos.
var X1=startPosition[0];var Y1=startPosition[1];var X2=endPosition[0];var Y2=endPosition[1];var deltaX=Math.abs(X2-X1);var deltaY=Math.abs(Y2-Y1);var distance=Math.sqrt(Math.pow(deltaX,2)+Math.pow(deltaY,2));var radians=Math.asin(deltaY/distance);//Time form s to ms
duration=duration*1000;delay=-(delay*1000);elem.style.top=offsetY+"%";elem.style.left=offsetX+"%";//set initial pos;
var initialProgress=Date.now()%duration/duration+delay/duration;if(ignoreTiming)initialProgress=Date.now();var start=null;var end=null;var step=function step(ts){if(start===null){start=ts;end=start+duration;}ts=Math.min(ts,end);var progress=(ts-start)/(end-start);// is percentage
if(progress+initialProgress>1)initialProgress=0;var _getPosition=_this2.getPosition(progress+initialProgress,distance,radians,startPosition,endPosition),_getPosition2=_slicedToArray(_getPosition,2),x=_getPosition2[0],y=_getPosition2[1];elem.style.transform='translate3d('+x+'%, '+y+'%, 0)';if(ts>=end){elem.style.transform='translate3d('+X1+'%, '+Y1+'%, 0)';start=null;}requestAnimationFrame(step);};requestAnimationFrame(step);};this.handleOutsideClick=function(ev){if(document.getElementsByClassName('desktop-map')[0]&&!_this2.props.history.location.pathname.startsWith('/taxes')){var props=_this2.props;var desktopMap=document.getElementsByClassName('map')[0];var dragged=false;var handleMouseMove=function handleMouseMove(){dragged=true;document.body.removeEventListener('mousemove',handleMouseMove);};document.body.addEventListener('mousemove',handleMouseMove);var handleMouseUp=function handleMouseUp(){if(!dragged&&ev.target.nodeName==='DIV'&&ev.target.classList.contains('map')&&props.history.location.pathname!=='/'){props.history.push('/');}desktopMap.removeEventListener('mouseup',handleMouseUp);};desktopMap.addEventListener('mouseup',handleMouseUp);}};this.onBlow=function(){if(_this2.state.nuuk===true)return;_this2.setState({nuuk:true},function(){_this2.animate(30,0,"nuuk",[-100,-93.35],[100,93.35],[0,35],1,true);});window.setTimeout(function(){_this2.refs.boomRef.loop=false;_this2.refs.boomRef.play();},13500);window.setTimeout(function(){_this2.initBoom();},15000);window.setTimeout(function(){_this2.setState({nuuk:false});},30000);};this.initBoom=function(){_this2.setState({boom:true,fallout:true,nuke:false});window.setTimeout(function(){_this2.setState({boom:false});},17500);window.setTimeout(function(){_this2.setState({fallout:false});},20000);};},_temp);

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scroll_into_view__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_star_svg__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_star_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_star_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_beleidskeuze_png__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_beleidskeuze_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_beleidskeuze_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_globas_trimmed_png__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_globas_trimmed_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_globas_trimmed_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__config__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var iconSize=false;if(document.querySelector('#root').clientWidth>750){iconSize=2;}var flag=0;var widerMinistries={nl:['mc','hb','fb','lv'],en:['mc','hb','fb','lv']};var semiWideMinistries={nl:['kn'],en:['vr','ws']};var MapElement=(_temp=_class=function(_Component){_inherits(MapElement,_Component);function MapElement(props){_classCallCheck(this,MapElement);var _this=_possibleConstructorReturn(this,(MapElement.__proto__||Object.getPrototypeOf(MapElement)).call(this,props));_this.setImage=function(min,value,difficulty){var type=void 0;if(difficulty==='pro'){if(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["D" /* ministryOverfinanced */])(min,_this.props.gameState))type=5;else type=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["o" /* getMinistryARating */])(difficulty,min,value,_this.props.feedback.prevRoundFeedbackData)+1;if(__WEBPACK_IMPORTED_MODULE_3__Defines__["a" /* default */].i18nMinistries.indexOf(min)!==-1&&type>2)type-=1;}else if(difficulty==='basic'){var color=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["p" /* getMinistryColor */])(difficulty,min,_this.props.gameState,_this.props.gameStateInput,_this.props.feedback.prevRoundFeedbackData);var internationalMinistry=__WEBPACK_IMPORTED_MODULE_3__Defines__["a" /* default */].i18nMinistries.indexOf(min)!==-1;if(internationalMinistry){if(color==='red')type=1;if(color==='orange'||color==='lowOrange')type=2;if(color==='yellow'||color==='lowYellow')type=2;if(color==='green')type=3;if(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["D" /* ministryOverfinanced */])(min,_this.props.gameState))type=4;}else{if(color==='red')type=1;if(color==='orange'||color==='lowOrange')type=2;if(color==='yellow'||color==='lowYellow')type=3;if(color==='green')type=4;if(Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["D" /* ministryOverfinanced */])(min,_this.props.gameState))type=5;}}return __WEBPACK_IMPORTED_MODULE_9__assets_assets__["f" /* mapElements */]['map_'+min+'__'+min+type+(iconSize!==false?iconSize+'x':'')];};_this.setPlateau=function(min,value,difficulty){var color=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["p" /* getMinistryColor */])(difficulty,min,_this.props.gameState,_this.props.gameStateInput,_this.props.feedback.prevRoundFeedbackData);return __WEBPACK_IMPORTED_MODULE_9__assets_assets__["e" /* mapColors */][difficulty+'_'+color];};_this.getFeedBack=function(){var feedbackObject=[];if(!_this.props.policySet&&!_this.props.budgetSet){if(_this.props.feedbackCount>0){feedbackObject.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'notCount',className:'notification-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,_this.props.feedbackCount))));}return feedbackObject;}if(_this.props.budgetSet){feedbackObject.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:1,src:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_globas_trimmed_png___default.a,className:'budget-flag',alt:'Budget'}));}if(_this.props.policySet){feedbackObject.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:2,src:__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_beleidskeuze_png___default.a,className:'policy-flag',alt:'Policy'}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policyWrap'},feedbackObject);};_this.goToClick=function(e,target){e.preventDefault();if(!flag){if(_this.props.unHighlight===false){target='/';}//🤮🤮🤮
sessionStorage.setItem('toMin','map');_this.props.history.push(target);}flag=0;};_this.goToMouse=function(e,target){e.preventDefault();e.target.addEventListener('mousemove',function(){flag=1;});e.target.addEventListener('mouseup',function(){if(!flag){if(_this.props.unHighlight===false){target='/';}//🤮🤮🤮
sessionStorage.setItem('toMin','map');_this.props.history.push(target);if(!(_this.props.unHighlight===false)){if(_this.props.gameState.difficulty==="BASIC"){target=target.split('/').find(function(i){return i.length===2;});}if(window.innerWidth<1024)return;__WEBPACK_IMPORTED_MODULE_4_scroll_into_view___default()(document.getElementById("scrollto-"+target.substr(-2)).closest(".desktop-ministry-list"),{topOffset:200});}}flag=0;});flag=0;};_this.state={};return _this;}_createClass(MapElement,[{key:'isTouchDevice',value:function isTouchDevice(){var isTouch=true;window.addEventListener('mousemove',function mouseMoveDetector(){isTouch=false;window.removeEventListener('mousemove',mouseMoveDetector);});return isTouch;}},{key:'render',value:function render(){var _this2=this;var props=this.props;var schoolClass=props.schoolClass;var lang=schoolClass.Language.code;var stars=[];for(var i=0;i<this.props.stars;i++){stars.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_star_svg___default.a,alt:"Star"})));}var groupBadge=function groupBadge(name,i){var matchedGroup=schoolClass.Groups.find(function(g){return g.GroupTheme.color===name;});if(matchedGroup)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:i,className:'collab-inline-item-badge',src:''+__WEBPACK_IMPORTED_MODULE_11__config___default.a.apiUrl+matchedGroup.GroupTheme.badge,alt:'badge'});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{onClick:function onClick(e){return _this2.goToClick(e,_this2.props.target);},onMouseDown:function onMouseDown(e){return _this2.goToMouse(e,_this2.props.target);},className:this.props.unHighlight?'MapElement hide':this.props.unHighlight===false?'MapElement show':'MapElement',style:{top:this.props.top+"%",left:this.props.left+"%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.setImage(this.props.icon,this.props.value,this.props.difficulty),alt:this.props.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'plateau',src:this.setPlateau(this.props.icon,this.props.value,this.props.difficulty),alt:'plateau'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},this.getFeedBack(),props.feedback.currentRound>1&&this.props.gameState.currentStep===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{text:this.props.roundPoints,className:'score'},this.props.roundPoints,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten'))):'',this.props.gameState.currentStep===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{text:this.props.globas,className:'score'},this.props.globas,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'importance'},stars,this.props.collaboration?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collab-icons'},this.props.collaboration.map(function(group,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:i},groupBadge(group,i));})):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'\n            name\n            '+(semiWideMinistries[lang].includes(this.props.icon.toLowerCase())?"semiwide":'')+'\n            '+(widerMinistries[lang].includes(this.props.icon.toLowerCase())?'wide':'')+'\n            '+(this.props.international?'international':'')+' '+(!this.props.stars?'noStars':''),text:this.props.title},this.props.disaster?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'disasterHolder'+(this.props.gameState.language==="NL"?"":" en")}):null,this.props.title));}}]);return MapElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,left:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,feedbackCount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,roundPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,stars:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),international:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,target:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,budgetSet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,policySet:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,disaster:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var schoolClass=_ref.schoolClass,feedback=_ref.feedback,gameState=_ref.gameState,gameStateInput=_ref.gameStateInput;return{schoolClass:schoolClass,feedback:feedback,gameState:gameState,gameStateInput:gameStateInput};})(MapElement));

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapEconomy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scroll_into_view__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_scroll_into_view__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var flag=0;var MapEconomy=(_temp=_class=function(_Component){_inherits(MapEconomy,_Component);function MapEconomy(props){_classCallCheck(this,MapEconomy);var _this=_possibleConstructorReturn(this,(MapEconomy.__proto__||Object.getPrototypeOf(MapEconomy)).call(this,props));_this.goToClick=function(e,target){e.preventDefault();if(!flag){if(_this.props.unHighlight===false){target='/';}sessionStorage.setItem('toMin','map');_this.props.history.push(target);}flag=0;};_this.goToMouse=function(e,target){e.preventDefault();e.target.addEventListener('mousemove',function(){flag=1;});e.target.addEventListener('mouseup',function(){if(!flag){if(_this.props.unHighlight===false){target='/';}//🤮🤮🤮
sessionStorage.setItem('toMin','map');_this.props.history.push(target);if(!(_this.props.unHighlight===false)){if(_this.props.gameState&&_this.props.gameState.difficulty==="BASIC"){target=target.split('/').find(function(i){return i.length===2;});}if(window.innerWidth<1024)return;__WEBPACK_IMPORTED_MODULE_4_scroll_into_view___default()(document.getElementById("scrollto-economy").closest(".economy-list"),{topOffset:200});}}flag=0;});flag=0;};_this.state={};return _this;}_createClass(MapEconomy,[{key:'isTouchDevice',value:function isTouchDevice(){var isTouch=true;window.addEventListener('mousemove',function mouseMoveDetector(){isTouch=false;window.removeEventListener('mousemove',mouseMoveDetector);});return isTouch;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:this.props.unHighlight?'MapElement MapElement--economy hide':this.props.unHighlight===false?'MapElement MapElement--economy show':'MapElement MapElement--economy',onClick:function onClick(e){return _this2.goToClick(e,_this2.props.target);},onMouseDown:function onMouseDown(e){return _this2.goToMouse(e,_this2.props.target);},style:{top:this.props.top+"%",left:this.props.left+"%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_assets__["f" /* mapElements */]['map_Economy'],alt:this.props.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},this.props.feedbackCount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-count'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.feedbackCount))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'verticalAlignScore'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{text:this.props.economy,className:'score score-economy'},this.props.economy,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{text:this.props.roundPoints,className:'score'},this.props.roundPoints,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name',text:this.props.title},this.props.title));}}]);return MapEconomy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,left:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,feedbackCount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,roundPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,economy:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,to:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string},_class.defaultProps={to:'/economy'},_temp);

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MapPolicy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scroll_into_view__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_scroll_into_view__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var flag=0;var MapPolicy=(_temp=_class=function(_Component){_inherits(MapPolicy,_Component);function MapPolicy(props){_classCallCheck(this,MapPolicy);var _this=_possibleConstructorReturn(this,(MapPolicy.__proto__||Object.getPrototypeOf(MapPolicy)).call(this,props));_this.goToClick=function(e,target){e.preventDefault();if(!flag){if(_this.props.unHighlight===false){target='/';}sessionStorage.setItem('toMin','map');_this.props.history.push(target);}flag=0;};_this.goToMouse=function(e,target){e.preventDefault();e.target.addEventListener('mousemove',function(){flag=1;});e.target.addEventListener('mouseup',function(){if(!flag){if(_this.props.unHighlight===false){target='/';}//🤮🤮🤮
sessionStorage.setItem('toMin','map');_this.props.history.push(target);if(!(_this.props.unHighlight===false)){if(_this.props.gameState&&_this.props.gameState.difficulty==="BASIC"){target=target.split('/').find(function(i){return i.length===2;});}if(window.innerWidth<1024)return;__WEBPACK_IMPORTED_MODULE_3_scroll_into_view___default()(document.getElementById("scrollto-beleidskeuzes").closest(".economy-list"),{topOffset:200});}}flag=0;});flag=0;};_this.state={};return _this;}_createClass(MapPolicy,[{key:'isTouchDevice',value:function isTouchDevice(){var isTouch=true;window.addEventListener('mousemove',function mouseMoveDetector(){isTouch=false;window.removeEventListener('mousemove',mouseMoveDetector);});return isTouch;}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:this.props.unHighlight?'MapElement MapElement--economy beleidskeuze-map hide':this.props.unHighlight===false?'MapElement MapElement--economy beleidskeuze-map show':'MapElement MapElement--economy beleidskeuze-map',onClick:function onClick(e){return _this2.goToClick(e,_this2.props.target);},onMouseDown:function onMouseDown(e){return _this2.goToMouse(e,_this2.props.target);},style:{top:this.props.top+"%",left:this.props.left+"%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_assets__["f" /* mapElements */]['map_Beleidskeuzes'],alt:this.props.title}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overlay'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},this.props.feedbackCount>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification-count '+(this.props.step===3?' red':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.feedbackCount))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{text:this.props.number,className:'score'},this.props.number,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{text:this.props.suffix},this.props.suffix))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'name',text:this.props.title},this.props.title));}}]);return MapPolicy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,top:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,left:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,feedbackCount:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,number:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,suffix:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_temp);

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.3fb4d622.png";

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Defines__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EconomyEarned=(_temp=_class=function(_Component){_inherits(EconomyEarned,_Component);function EconomyEarned(props){_classCallCheck(this,EconomyEarned);var _this=_possibleConstructorReturn(this,(EconomyEarned.__proto__||Object.getPrototypeOf(EconomyEarned)).call(this,props));_this.state={};return _this;}_createClass(EconomyEarned,[{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,feedback=_props.feedback,schoolClass=_props.schoolClass;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];// Retrieve ID of current round game
// Get associated game object from SchoolClass
// Retrieve game icon for display from game object
var GameId=currentRoundGameState.GameId;var gameObject=schoolClass.SchoolClassGames.find(function(game){return game.GameId===GameId;});var gameIcon=__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].gameLogos.find(function(icon){return icon.abbreviation===gameObject.Game.abbreviation;}).logo||"";if(!gameState.prevRound||!feedback.prevRoundFeedbackData)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__["a" /* default */],null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas_punten_verdiend_met_uitleg'),':',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"games-points"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"game-img"},gameIcon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'gameIcon',src:gameIcon}):""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"globas-points"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,currentRound===5?'-':currentRoundGameState.earnedGlobas,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,currentRound===5?'-':currentRoundGameState.earnedPoints,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten'))))));}}]);return EconomyEarned;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,top:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,left:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,feedbackCount:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,roundPoints:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,economy:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,schoolClass=_ref.schoolClass;return{gameState:gameState,feedback:feedback,schoolClass:schoolClass};})(EconomyEarned));

/***/ }),
/* 333 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABcElEQVR4Ae3UJXgWUBSA4XdaZ2necYeC0ysruEWk9wd3+irurj1C3N/wMitz93vmUibfaUeuHLMEWSFfpR22qJRrThS64IE63XqGpFudhy4oNGPK1GrTM4m0qVVmBpzUrGcaaXLSlBR5FUIafHW3T75qCJZXikzCan8S139qjKXGv8T+x5qJM/M7ccuoEKmWSXx+KRfI9z28pgpwwLk+2Q+oCq/6IV/C5ZCBw6DEpxHNJ8XgcPC8bAwbdCXGRlngQaJ9ALI0JtouG43wOdzyFKyNZbcOPA7azwC7YoAb4EzUOwNuRL09wJ5ocA2cjnqnwbWot2uyrz0B62KA9VN/jU06J0z2w0T7EORomjzZXJpB+UvAkeB5aeqG/K8yacgDgEr/p25IykPPZlRPOyL/lItgbRja/2FoD4pDu9YkFHk/wRq51yffxDXyXtHCLbYZrNrWSQ9pnemqBYqdF5d/xkPnFZsT+SrssFWlXCssOXoBRmmlPPWNAdcAAAAASUVORK5CYII="

/***/ }),
/* 334 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAQAAABLCVATAAABy0lEQVR4Ae3UQxhVbRSA0fXbts3sZtm27VFu3DC7cbZt27ZtW/c0Sed7Tm5W7x7u/azr61VP0X++9AL6y3FbXwQ1VyRKoD70q5yy+smbnqjvbQ+oivo7JLo3KTuM0MKnHp0vbIpReV0VJcw1fX3vkX1qVTIVjnPqe2T/SAXUHl211cscZwJsos9ILq3Dd47uUEGVHY1Rh6VNfDbBYyZRv9gZuznke0Ff3/mE4tQ34F1N5AP8HDyrjd4Wa1KAXBSJ7LpDFXbNTJ+DmsFlBwAoLWT+sFVIDQevORu7vSUTANsCaBy+tFFIpQejgutZuHMSBdMNtBEFVG3QVXifG8gtXHQGDUUB9S7oJLwvBjArWIwG6UVCCkYE1/u9BpDZzdjq7J3ViETqVADVAYD2wbIm+MLMBKpk7GGnivW29THomJ8A+TXT1sEYVV7q3sv6XNAPwXd2p19iP459MaqalMhFaSWUzuHgWVUGwF8u3KF+AHWdlZPkPjNNFJsz5uithxkui+7MvjvU5x5ZfedFyRNQj+17fV19MRSfa264HVKxP9ghKvnR/KejgLf9KKcc/vSZ1wDvWxJQz9yHVr4o6hPrRA77zXP3ubn+8jJ0Gwf5qQyAiF8mAAAAAElFTkSuQmCC"

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getOverviewData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_assets__ = __webpack_require__(8);
function getOverviewData(props){var gameStateInput=props.gameStateInput,gameState=props.gameState,project=props.project;var showPolicyChoices=project&&project.minPolicyChoices>0;var bankEnabled=project&&project.bankEnabled!==false;var totalGameStateSum=gameState.totalGameStateSum;//Create a boolean to use for distinguishing Pro and Basic.
var isPro=gameStateInput.myState.niveau==="Pro"?true:false;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_2__calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);//Accumilator for budgetchoices globa's
var budgetChoicesTotal=0;//Map through ministries to get each budget choice
var budgetDistribution=gameStateInput.myState.ministerieGlobaVerdeling;var budgetChoices=__WEBPACK_IMPORTED_MODULE_3__Defines__["a" /* default */][gameState.difficulty.toLowerCase()].ministries.map(function(min){//Add value to accumilator
var value=budgetDistribution[min]?budgetDistribution[min]:0;budgetChoicesTotal+=value;//If choice contains collaboration, map through to generate images required.
var images=budgetDistribution[min+'SW']?budgetDistribution[min+'SW'].map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(c),src:__WEBPACK_IMPORTED_MODULE_4__assets_assets__["c" /* groupIcons */][Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(c).toLowerCase()],alt:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(c)});}):"";//Return an element
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(min),className:'result-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-title'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(min)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right result-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collaboration'},images),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value'},value)));});//Accumilator for globa's spent on policies
var policyTotal=0;//Map through policychoices
var policyKeys=Object.keys(gameStateInput.myState.policyChoices);var policyChoices=policyKeys.map(function(key){var current=gameStateInput.myState.policyChoices[key];/**
     * Custom basic quick fix
     */if(!isPro){var choice=props.policyChoice.find(function(pc){return pc.omschrijving===current||pc.Omschrijving===current;});if(!choice)return false;policyTotal+=choice.kosten_globas;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:current.title,className:'result-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-title'},choice['titel_oplossing_'+props.gameState.language.toUpperCase()]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right result-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value'},choice.kosten_globas)));}//Confirm the policy has been selected
if(current.selected!==true)return false;//Add policy cost to accumilator
policyTotal+=current.globas;//If difficulty is pro, stop.
if(isPro)return false;//Check if policy is a collaboration, then add the images.
var images=current.collaboration.length>0?current.collaboration.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(c),src:__WEBPACK_IMPORTED_MODULE_4__assets_assets__["c" /* groupIcons */][Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(c).toLowerCase()],alt:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(c)});}):"";//Return a row to display in the overview.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:current.title,className:'result-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-title'},current.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right result-value'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collaboration'},images),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'value'},current.globas)));},0);//Create sum of total spent money
var totalSpent=policyTotal+budgetChoicesTotal;//Calculate remaining accordingly
var remaining=totalGameStateSum.globas-totalSpent+savingsAndLoans;//Is put in a separate variable because it's in a different position on different levels.
var sectionBeleidskeuzes=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left title'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},policyTotal)),policyChoices);//Construct final component.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'ovv',className:'popup-overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_overzicht_verdeling')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left title'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_budget")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},totalGameStateSum.globas+(bankEnabled?savingsAndLoans:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-title'},isPro?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_overheidsinkomsten"):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_belastingen")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right result-value'},totalGameStateSum.globas)),bankEnabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-title'},isPro?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_saldo_sparen_lenen"):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_basic_saldo_sparen_lenen")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-value'},savingsAndLoans>=0?"(+)":"(-)",' ',savingsAndLoans>=0?savingsAndLoans:savingsAndLoans*-1)):null),isPro?null:showPolicyChoices?sectionBeleidskeuzes:null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left title'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_budgetkeuze',0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},budgetChoicesTotal)),budgetChoices),isPro?sectionBeleidskeuzes:null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'result-group'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-bar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'left title'},isPro?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_resterend_budget"):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_basic_resterend_budget")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'right'},remaining))));}

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/up-min-globas.f8142e4e.svg";

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);

/* eslint-disable react/prop-types */


var Track = function Track(props) {
  var className = props.className,
      included = props.included,
      vertical = props.vertical,
      offset = props.offset,
      length = props.length,
      style = props.style;


  var positonStyle = vertical ? {
    bottom: offset + '%',
    height: length + '%'
  } : {
    left: offset + '%',
    width: length + '%'
  };

  var elStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, positonStyle);
  return included ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { className: className, style: elStyle }) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (Track);

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSlider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Steps__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Marks__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Handle__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(183);


















function noop() {}

function createSlider(Component) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ComponentEnhancer, _Component);

    function ComponentEnhancer(props) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentEnhancer);

      var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));

      _this.onMouseDown = function (e) {
        if (e.button !== 0) {
          return;
        }

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getMousePosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.removeDocumentEvents();
        _this.onStart(position);
        _this.addDocumentMouseEvents();
      };

      _this.onTouchStart = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["h" /* isNotTouchEvent */](e)) return;

        var isVertical = _this.props.vertical;
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["f" /* getTouchPosition */](isVertical, e);
        if (!__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.dragOffset = 0;
        } else {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](isVertical, e.target);
          _this.dragOffset = position - handlePosition;
          position = handlePosition;
        }
        _this.onStart(position);
        _this.addDocumentTouchEvents();
        __WEBPACK_IMPORTED_MODULE_16__utils__["j" /* pauseEvent */](e);
      };

      _this.onFocus = function (e) {
        var _this$props = _this.props,
            onFocus = _this$props.onFocus,
            vertical = _this$props.vertical;

        if (__WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          var handlePosition = __WEBPACK_IMPORTED_MODULE_16__utils__["c" /* getHandleCenterPosition */](vertical, e.target);
          _this.dragOffset = 0;
          _this.onStart(handlePosition);
          __WEBPACK_IMPORTED_MODULE_16__utils__["j" /* pauseEvent */](e);
          if (onFocus) {
            onFocus(e);
          }
        }
      };

      _this.onBlur = function (e) {
        var onBlur = _this.props.onBlur;

        _this.onEnd(e);
        if (onBlur) {
          onBlur(e);
        }
      };

      _this.onMouseUp = function () {
        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
        }
      };

      _this.onMouseMove = function (e) {
        if (!_this.sliderRef) {
          _this.onEnd();
          return;
        }
        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["e" /* getMousePosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onTouchMove = function (e) {
        if (__WEBPACK_IMPORTED_MODULE_16__utils__["h" /* isNotTouchEvent */](e) || !_this.sliderRef) {
          _this.onEnd();
          return;
        }

        var position = __WEBPACK_IMPORTED_MODULE_16__utils__["f" /* getTouchPosition */](_this.props.vertical, e);
        _this.onMove(e, position - _this.dragOffset);
      };

      _this.onKeyDown = function (e) {
        if (_this.sliderRef && __WEBPACK_IMPORTED_MODULE_16__utils__["g" /* isEventFromHandle */](e, _this.handlesRefs)) {
          _this.onKeyboard(e);
        }
      };

      _this.onClickMarkLabel = function (e, value) {
        e.stopPropagation();
        _this.onChange({ value: value });
      };

      _this.saveSlider = function (slider) {
        _this.sliderRef = slider;
      };

      if (false) {
        var step = props.step,
            max = props.max,
            min = props.min;

        warning(step && Math.floor(step) === step ? (max - min) % step === 0 : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
      }
      _this.handlesRefs = {};
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentEnhancer, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        // Snapshot testing cannot handle refs, so be sure to null-check this.
        this.document = this.sliderRef && this.sliderRef.ownerDocument;
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
        this.removeDocumentEvents();
      }
    }, {
      key: 'getSliderStart',
      value: function getSliderStart() {
        var slider = this.sliderRef;
        var rect = slider.getBoundingClientRect();

        return this.props.vertical ? rect.top : rect.left;
      }
    }, {
      key: 'getSliderLength',
      value: function getSliderLength() {
        var slider = this.sliderRef;
        if (!slider) {
          return 0;
        }

        var coords = slider.getBoundingClientRect();
        return this.props.vertical ? coords.height : coords.width;
      }
    }, {
      key: 'addDocumentTouchEvents',
      value: function addDocumentTouchEvents() {
        // just work for Chrome iOS Safari and Android Browser
        this.onTouchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchmove', this.onTouchMove);
        this.onTouchUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'touchend', this.onEnd);
      }
    }, {
      key: 'addDocumentMouseEvents',
      value: function addDocumentMouseEvents() {
        this.onMouseMoveListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mousemove', this.onMouseMove);
        this.onMouseUpListener = Object(__WEBPACK_IMPORTED_MODULE_10_rc_util_es_Dom_addEventListener__["a" /* default */])(this.document, 'mouseup', this.onEnd);
      }
    }, {
      key: 'removeDocumentEvents',
      value: function removeDocumentEvents() {
        /* eslint-disable no-unused-expressions */
        this.onTouchMoveListener && this.onTouchMoveListener.remove();
        this.onTouchUpListener && this.onTouchUpListener.remove();

        this.onMouseMoveListener && this.onMouseMoveListener.remove();
        this.onMouseUpListener && this.onMouseUpListener.remove();
        /* eslint-enable no-unused-expressions */
      }
    }, {
      key: 'focus',
      value: function focus() {
        if (!this.props.disabled) {
          this.handlesRefs[0].focus();
        }
      }
    }, {
      key: 'blur',
      value: function blur() {
        var _this2 = this;

        if (!this.props.disabled) {
          Object.keys(this.handlesRefs).forEach(function (key) {
            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
              _this2.handlesRefs[key].blur();
            }
          });
        }
      }
    }, {
      key: 'calcValue',
      value: function calcValue(offset) {
        var _props = this.props,
            vertical = _props.vertical,
            min = _props.min,
            max = _props.max;

        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
        return value;
      }
    }, {
      key: 'calcValueByPos',
      value: function calcValueByPos(position) {
        var pixelOffset = position - this.getSliderStart();
        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
        return nextValue;
      }
    }, {
      key: 'calcOffset',
      value: function calcOffset(value) {
        var _props2 = this.props,
            min = _props2.min,
            max = _props2.max;

        var ratio = (value - min) / (max - min);
        return ratio * 100;
      }
    }, {
      key: 'saveHandle',
      value: function saveHandle(index, handle) {
        this.handlesRefs[index] = handle;
      }
    }, {
      key: 'render',
      value: function render() {
        var _classNames;

        var _props3 = this.props,
            prefixCls = _props3.prefixCls,
            className = _props3.className,
            marks = _props3.marks,
            dots = _props3.dots,
            step = _props3.step,
            included = _props3.included,
            disabled = _props3.disabled,
            vertical = _props3.vertical,
            min = _props3.min,
            max = _props3.max,
            children = _props3.children,
            maximumTrackStyle = _props3.maximumTrackStyle,
            style = _props3.style,
            railStyle = _props3.railStyle,
            dotStyle = _props3.dotStyle,
            activeDotStyle = _props3.activeDotStyle;

        var _get$call = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_get___default()(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
            tracks = _get$call.tracks,
            handles = _get$call.handles;

        var sliderClassName = __WEBPACK_IMPORTED_MODULE_11_classnames___default()(prefixCls, (_classNames = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-disabled', disabled), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-vertical', vertical), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_classNames, className, className), _classNames));
        return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          {
            ref: this.saveSlider,
            className: sliderClassName,
            onTouchStart: disabled ? noop : this.onTouchStart,
            onMouseDown: disabled ? noop : this.onMouseDown,
            onMouseUp: disabled ? noop : this.onMouseUp,
            onKeyDown: disabled ? noop : this.onKeyDown,
            onFocus: disabled ? noop : this.onFocus,
            onBlur: disabled ? noop : this.onBlur,
            style: style
          },
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement('div', {
            className: prefixCls + '-rail',
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, maximumTrackStyle, railStyle)
          }),
          tracks,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Steps__["a" /* default */], {
            prefixCls: prefixCls,
            vertical: vertical,
            marks: marks,
            dots: dots,
            step: step,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min,
            dotStyle: dotStyle,
            activeDotStyle: activeDotStyle
          }),
          handles,
          __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Marks__["a" /* default */], {
            className: prefixCls + '-mark',
            onClickLabel: disabled ? noop : this.onClickMarkLabel,
            vertical: vertical,
            marks: marks,
            included: included,
            lowerBound: this.getLowerBound(),
            upperBound: this.getUpperBound(),
            max: max,
            min: min
          }),
          children
        );
      }
    }]);

    return ComponentEnhancer;
  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.propTypes, {
    min: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    max: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    step: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number,
    marks: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    included: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    className: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    prefixCls: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,
    disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    children: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.any,
    onBeforeChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onAfterChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    handle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    dots: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    vertical: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    style: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    minimumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, // just for compatibility, will be deperecate
    maximumTrackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, // just for compatibility, will be deperecate
    handleStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object)]),
    trackStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object)]),
    railStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    dotStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    activeDotStyle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object,
    autoFocus: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
    onFocus: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
  }), _class.defaultProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Component.defaultProps, {
    prefixCls: 'rc-slider',
    className: '',
    min: 0,
    max: 100,
    step: 1,
    marks: {},
    handle: function handle(_ref) {
      var index = _ref.index,
          restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['index']);

      delete restProps.dragging;
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, restProps, { key: index }));
    },

    onBeforeChange: noop,
    onChange: noop,
    onAfterChange: noop,
    included: true,
    disabled: false,
    dots: false,
    vertical: false,
    trackStyle: [{}],
    handleStyle: [{}],
    railStyle: {},
    dotStyle: {},
    activeDotStyle: {}
  }), _temp;
}

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(899);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 342 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_grey_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_grey_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_grey_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_bekijk_svg__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_bekijk_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_bekijk_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MinistryFeedbackStatus=(_temp=_class=function(_Component){_inherits(MinistryFeedbackStatus,_Component);function MinistryFeedbackStatus(props){_classCallCheck(this,MinistryFeedbackStatus);var _this=_possibleConstructorReturn(this,(MinistryFeedbackStatus.__proto__||Object.getPrototypeOf(MinistryFeedbackStatus)).call(this,props));_this.state={showFeedback:props.showFeedback,ministry:_this.props.ministry};_this.showFeedback=_this.showFeedback.bind(_this);return _this;}_createClass(MinistryFeedbackStatus,[{key:'showFeedback',value:function showFeedback(){this.setState(function(prevState){return{showFeedback:!prevState.showFeedback};});}},{key:'render',value:function render(){var _this2=this;var prevRoundFeedbackData=this.props.feedback.prevRoundFeedbackData;var gameState=this.props.gameState;var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;var currentFeedback=[];if(!prevRoundFeedbackData){return null;}else{prevRoundFeedbackData.find(function(item,i){if(item.Ministerie===_this2.props.ministry){currentFeedback[i]=item;return true;// stop searching
}return false;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-status-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-header',onClick:this.showFeedback},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_bekijk_svg___default.a,alt:'view',className:'view-icon'}),' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bekijk_ministerie_status'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_grey_svg___default.a,alt:'close',className:'close-status'+(this.state.showFeedback?' rotate':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-container'+(this.state.showFeedback?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["F" /* renderMinistryFeedbackList */])(this.props.feedback.prevRoundFeedbackData,this.props.ministry,this.props.gameState,this.props.gameStateInput))));}}]);return MinistryFeedbackStatus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={ministry:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired,showFeedback:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool},_class.defaultProps={showFeedback:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,gameStateInput=_ref.gameStateInput;return{gameState:gameState,feedback:feedback,gameStateInput:gameStateInput};})(MinistryFeedbackStatus));

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/single.468fc124.png";

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/group.ac6819ef.png";

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_groupHelper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Defines__ = __webpack_require__(17);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScoreHistory=(_temp=_class=function(_Component){_inherits(ScoreHistory,_Component);function ScoreHistory(){_classCallCheck(this,ScoreHistory);return _possibleConstructorReturn(this,(ScoreHistory.__proto__||Object.getPrototypeOf(ScoreHistory)).apply(this,arguments));}_createClass(ScoreHistory,[{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,round=_props.round,ministerie=_props.ministerie,schoolClass=_props.schoolClass;if(!gameStateInput.states[round]||round===0||gameState.currentRound===round||round>=gameState.currentRound)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null);var sum=gameState.Rounds[round].gameStateSum;var myInput=gameStateInput.states[round][gameStateInput.groupId]||{};var globas=0;if(myInput.ministerieGlobaVerdeling&&myInput.ministerieGlobaVerdeling[ministerie]){globas=myInput.ministerieGlobaVerdeling[ministerie];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-history-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["E" /* reduceMinistryCollabs */])(ministerie,gameStateInput,round).length>0||__WEBPACK_IMPORTED_MODULE_6__Defines__["a" /* default */].i18nMinistries.includes(ministerie)?'round':'round big'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_ronde'),' ',round,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{content:globas+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'),className:'globas white-shadow-text '+(!__WEBPACK_IMPORTED_MODULE_6__Defines__["a" /* default */].i18nMinistries.includes(ministerie)?'big':'')},globas,' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')),Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["E" /* reduceMinistryCollabs */])(ministerie,gameStateInput,round).length>0||__WEBPACK_IMPORTED_MODULE_6__Defines__["a" /* default */].i18nMinistries.includes(ministerie)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collaboration history-collaborations'},Object(__WEBPACK_IMPORTED_MODULE_5__helpers_groupHelper__["b" /* getGroupIcons */])(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["E" /* reduceMinistryCollabs */])(ministerie,gameStateInput,round),schoolClass.Groups).map(function(img,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:index,src:img,alt:'gameState-icon'});})):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{content:sum[ministerie+'_points_raw']+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase(),className:'points white-shadow-text '+(!__WEBPACK_IMPORTED_MODULE_6__Defines__["a" /* default */].i18nMinistries.includes(ministerie)?'big':'')},sum[ministerie+'_points_raw'],' ',Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase()));}}]);return ScoreHistory;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={ministerie:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,round:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,gameStateInput=_ref.gameStateInput,schoolClass=_ref.schoolClass;return{gameState:gameState,gameStateInput:gameStateInput,schoolClass:schoolClass};})(ScoreHistory));

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_globas_svg__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_globas_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackHeader=(_temp=_class=function(_Component){_inherits(FeedbackHeader,_Component);function FeedbackHeader(props){_classCallCheck(this,FeedbackHeader);var _this=_possibleConstructorReturn(this,(FeedbackHeader.__proto__||Object.getPrototypeOf(FeedbackHeader)).call(this,props));_this.getInnerHeader=function(){if(_this.props.oneLine){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subcontainer'},!_this.props.noTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'type'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(_this.props.type)):null,_this.props.popUpTitle?// @todo wanneer dit dynamisch wordt zorg er dan ook voor dat de tekst ook klikbaar is (indien van toepassing)
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_PopupTitle__["a" /* default */],{popupId:_this.props.popUpTitle,tag:'h4'}):null));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'round'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_spelronde'),' ',_this.props.currentRound),!_this.props.noTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'type'},(_this.props.prependEffect===true?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_effect_vanuit")+": ":"")+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(_this.props.type)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'subcontainer'},_this.props.subtitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:"sub"},_this.props.subtitle.indexOf(': ')!==-1?_this.props.subtitle.substr(2):_this.props.subtitle):null,_this.props.popUpTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_PopupTitle__["a" /* default */],{popupId:_this.props.popUpTitle,tag:'h3'}):null));}};_this.state={typeIcon:''};return _this;}_createClass(FeedbackHeader,[{key:'componentDidMount',value:function componentDidMount(){switch(this.props.type){case'budgetkeuze':this.setState({"typeIcon":__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_globas_svg___default.a});break;case'beleidskeuze':this.setState({"typeIcon":__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_globas_svg___default.a});break;default:this.setState({"typeIcon":__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_globas_svg___default.a});}}},{key:'render',value:function render(){var disablePoints=false;if(this.props.type==="Startsituatie"){disablePoints=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbackheader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-feedbackheader'},this.props.icon!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:this.props.icon})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'no-icon-spacing'}),this.getInnerHeader(),!disablePoints&&(this.props.points||this.props.points===0)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'point-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:(this.props.miljard&&this.props.points>0?"+":"")+this.props.points},(this.props.miljard&&this.props.points>0?"+":"")+this.props.points),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:this.props.miljard?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten')},this.props.miljard?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten'))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttons'},this.props.hideClose?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'close-button spacer'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_GoBackButton__["a" /* default */],{history:this.props.history,customHandler:this.props.closeButtonHandler}))));}}]);return FeedbackHeader;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired,currentRound:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,subtitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,disaster:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,hideClose:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,noTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,closeButtonHandler:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func},_class.defaultProps={currentRound:1,type:'budgetkeuze',disaster:false,hideClose:false,noTitle:false,closeButtonHandler:null},_temp);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_finish_svg__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_finish_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_finish_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_close_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_close_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PopupTitle__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackStatusRounds=(_temp=_class=function(_Component){_inherits(FeedbackStatusRounds,_Component);function FeedbackStatusRounds(props){_classCallCheck(this,FeedbackStatusRounds);var _this=_possibleConstructorReturn(this,(FeedbackStatusRounds.__proto__||Object.getPrototypeOf(FeedbackStatusRounds)).call(this,props));_this.state={showWarning:false,showComponent:false};_this.warningPopup=_this.warningPopup.bind(_this);_this.getPill=_this.getPill.bind(_this);return _this;}_createClass(FeedbackStatusRounds,[{key:'componentWillUnmount',value:function componentWillUnmount(){window.removeEventListener("mousedown",this.warningPopup);}},{key:'warningPopup',value:function warningPopup(content){if(!this.state.showWarning){window.addEventListener("mousedown",this.warningPopup);this.setState({showWarning:true});}else{window.removeEventListener("mousedown",this.warningPopup);this.setState({showWarning:false});}}},{key:'getPill',value:function getPill(percentage,currentRound,gameState){var overfinanced=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["D" /* ministryOverfinanced */])(this.props.ministry,gameState,currentRound);var full=percentage>=50||percentage<=-50;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:''+currentRound,className:'round-pill '+(percentage===null?'inactive':'')},percentage!==null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'status-pill '+(percentage>0?'pos':'neg')+' '+(Math.abs(percentage)>30?'almost-full':'')+' '+(Math.abs(percentage)>=50||full?'full':''),style:{height:'calc('+Math.abs(percentage)+'% '+(percentage>0?'+ 1':'- 1')+'px)'}}):null,percentage!==null&&overfinanced?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'disaster-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'disaster',onClick:this.warningPopup,src:__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_warning_svg___default.a})):'');}},{key:'render',value:function render(){var _this2=this;var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,desktop=_props.desktop;var ratings=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["q" /* getMinistryStatusBarRatings */])(this.props.ministry,gameState,gameStateInput);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-rounds '+this.props.transitionDelay},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PopupTitle__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_status'),popupId:''+(desktop?'d':'m')+(gameState.difficulty==='PRO'?'h':'l')+'gvtstatusbalkje',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'pill-container'},[].concat(_toConsumableArray(Array(11))).map(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:Math.random()*Math.floor(100*100),className:'line'});}),ratings.map(function(r,c){return _this2.getPill(r,c,gameState);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'round-names'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:gameState.currentRound>=1?'':'inactive'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_ronde'),' 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:gameState.currentRound>=2?'':'inactive'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_ronde'),' 2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:gameState.currentRound>=3?'':'inactive'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_ronde'),' 3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:gameState.currentRound>=4?'':'inactive'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_ronde'),' 4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:gameState.currentRound>4?'':'inactive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'finish',src:__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_finish_svg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-container '+(this.state.showWarning?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:this.warningPopup.bind(this),className:'close-button'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_img_close_png___default.a,height:'15',alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'disaster',src:__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_warning_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_ministerie_overfinancierd_melding')))));}}]);return FeedbackStatusRounds;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={transitionDelay:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,ministry:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string},_class.defaultProps={transitionDelay:''},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,gameStateInput=_ref.gameStateInput;return{gameState:gameState,gameStateInput:gameStateInput};})(FeedbackStatusRounds));

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__QuestionButton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepThree_BudgetSlider__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepThree_BudgetCollaboration__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__feedback_FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__feedback_FeedbackEffect__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updateMyState=__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].gameStateInput.updateMyState;var updateRead=__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].feedback.updateRead;var TaxItem=(_temp=_class=function(_Component){_inherits(TaxItem,_Component);function TaxItem(props){_classCallCheck(this,TaxItem);var _this=_possibleConstructorReturn(this,(TaxItem.__proto__||Object.getPrototypeOf(TaxItem)).call(this,props));_initialiseProps.call(_this);_this.state={showDropDown:false,capNotification:props.sliderValue>props.cap,saving:_this.props.saving};_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(TaxItem,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(props.sliderValue>props.cap){this.setState({capNotification:true});}if(this.props.feedbackData.show!==props.feedbackData.show){this.setState({showDropDown:false});}if(props.saving!==this.state.saving){if(props.saving){this.setState({saving:props.saving,showDropDrown:false});}else{this.setState({saving:props.saving});}}}},{key:'render',value:function render(){var _this2=this;var props=this.props,state=this.state;var myState=props.gameStateInput.myState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ListButton__["a" /* default */],{onClick:function onClick(){if(props.feedbackData.show){_this2.markAsRead();}if(props.registerShown){props.registerShown();}_this2.setState({showDropDown:!state.showDropDown});},feedbackCount:props.notification.read&&!Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["d" /* checkRead */])(props.notification,false,0,false)?1:0,bgColor:'white',title:props.title,icon:props.icon,reverseGlobasPoints:props.reverseGlobasPoints,arrow:true,bigArrow:true,globas:props.globas,points:props.points}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'+(state.showDropDown&&!props.feedbackData.show?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),props.project.difficulty==='PRO'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PopupTitle__["a" /* default */],{customClass:'popup-heading',popupId:props.popupId,tag:'h4'}):null,props.dataList.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'taxes-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:item.globas},item.globas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard'))));}),props.taxDescription?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'description'},props.taxDescription):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'}),props.sliderTitles!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-titles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.sliderTitles[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.sliderTitles[1])):null,props.type==='taxSlider'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_gekozenbelastingpercentage'),' (',props.minValue,'-',props.cap,'%)')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StepThree_BudgetSlider__["a" /* default */],{role:this.props.user.role,customOnChange:this.onChange,onAfterChange:this.onAfterChange,onChangeKey:props.sliderKey,twoValueSlider:props.twoValueSlider,value:props.sliderValue,min:props.minValue,unit:props.unit,suffix:props.suffix,max:props.maxValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-element content-container taxes-slider-warning '+(this.state.capNotification?'show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_warning_svg___default.a,alt:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:props.capNotification}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'}),this.props.project.difficulty==='PRO'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StepThree_BudgetCollaboration__["a" /* default */],{value:props.collaborationValue,customOnChange:this.onChange,onChangeKey:props.collaborationKey,title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')+':'}):null),state.showDropDown&&props.feedbackData.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-container-taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container show taxes'+(props.feedbackData.effects.length?' hasEffects':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'+(props.feedbackData.effects.length?' hasEffects':'')}),this.props.project.difficulty==='PRO'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'popup-heading'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__QuestionButton__["a" /* default */],null,props.title)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'popup-heading laag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_gekozen_belasting')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:myState.arbeidsBelasting+'%',className:'point-holder'},myState.arbeidsBelasting+'%')),this.renderDetails(props.feedbackData.topData),props.feedbackData.img?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__feedback_FeedbackImage__["a" /* default */],{image:props.feedbackData.img,description:props.feedbackData.imgDescription}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'5px 0'}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:props.feedbackData.description}})),props.feedbackData.effects.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-container feedbackdata-effects taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-header'},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_belastingkeuze_heeft_effect_op')),props.feedbackData.effects.map(function(effect,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__feedback_FeedbackEffect__["a" /* default */],{key:i,minimal:true,ministry:effect.title,ministryIcon:effect.icon,description:'Onderschrift',unit:effect.contentUnit,points:effect.contentTitle});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-message'},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_zie_deze_effecten_volgende_spelronden'))):null):null);}}]);return TaxItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notification:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,globas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,points:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,feedbackData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),dataList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,minValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,maxValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,sliderValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,collaborationValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,sliderKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,collaborationKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notificationReference:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,reverseGlobasPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,saving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={onChange:function onChange(){},reverseGlobasPoints:true,title:'title',icon:'',globas:0,points:0,dataList:[],minValue:0,maxValue:999,sliderKey:'slider',collaborationKey:'collaboration',feedbackData:{},notificationReference:'',notification:{},saving:false},_initialiseProps=function _initialiseProps(){var _this3=this;this.onChange=function(key,value){var cap=_this3.props.cap;var capNotification=void 0;if(cap!==undefined){if(value<=cap&&value>0){capNotification=false;}if(value>cap){capNotification=true;}}_this3.setState({capNotification:capNotification,sliderValue:value});_this3.props.dispatch(updateMyState(_defineProperty({},key,value)));};this.markAsRead=function(){if(_this3.props.notification.reference&&!Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["d" /* checkRead */])(_this3.props.notification,false,0,false)){if(_this3.props.feedback.all[_this3.props.feedback.currentRound].feedback.find(function(c){return c.id===_this3.props.notification.reference;}).economie===null){_this3.props.dispatch(updateRead(_this3.props.notification.reference,{read:true,economie:true}));}else{_this3.props.dispatch(updateRead(_this3.props.notification.reference,{read:true,economie:false}));}}};this.renderDetails=function(data){var props=_this3.props;var dataList=data;var colIndex=dataList.findIndex(function(item){return item.title==='Samenwerking met andere landen'||item.title===Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden');});// Sort all groups to correct order
if(colIndex!==-1&&dataList[colIndex].value.length){var arr=dataList[colIndex].value;if(arr[0]&&arr[0].props&&arr[0].props.src&&arr[0].props.src>arr[arr.length-1].props.src){dataList[colIndex].value=dataList[colIndex].value.sort(function(a,b){var srcA=a.props.src.toLowerCase(),srcB=b.props.src.toLowerCase();if(srcA<srcB)return-1;if(srcA>srcB)return 1;return 0;});}}return dataList.map(function(item,topDataIndex){if(item.hideWhenZero){var val=parseInt(item.value.split(' ')[0],10);if(isNaN(val)||val===0)return'';}if(Array.isArray(item.value)&&!item.value.length){item.value='-';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:topDataIndex},props.feedbackData.topData.length-1===topDataIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topdata-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.value)));});};},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return state;})(TaxItem));

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/buitenland.23b6be95.svg";

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AudioGameMaterial; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameMaterialItem__ = __webpack_require__(74);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AudioGameMaterial=function(_GameMaterialItem){_inherits(AudioGameMaterial,_GameMaterialItem);function AudioGameMaterial(props){var _this2=this;_classCallCheck(this,AudioGameMaterial);var _this=_possibleConstructorReturn(this,(AudioGameMaterial.__proto__||Object.getPrototypeOf(AudioGameMaterial)).call(this,props));_this.handleDownload=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ev){var _this$props$item$Mate,filename,url;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:ev.preventDefault();ev.stopPropagation();if(!_this.state.loading){_context.next=4;break;}return _context.abrupt('return',false);case 4:_this.setState({loading:true});_this$props$item$Mate=_this.props.item.Material,filename=_this$props$item$Mate.filename,url=_this$props$item$Mate.url;_context.next=8;return fetch(url,{method:'GET'}).then(function(resp){return resp.blob();}).then(function(resp){return __WEBPACK_IMPORTED_MODULE_1_downloadjs___default()(resp,filename);}).catch(console.warn);case 8:_this.setState({loading:false});return _context.abrupt('return',false);case 10:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state.loading=false;_this.state.icons=[];if(props.gameId===4&&navigator.userAgent.match(/(iPhone|iPod|iPad)/i)){_this.state.icons.push({src:__WEBPACK_IMPORTED_MODULE_2__assets_assets__["d" /* icons */].download,alt:'icon',style:{margin:'20px 20px 20px 20px'},onClick:_this.handleDownload});}_this.state.icons.push(__WEBPACK_IMPORTED_MODULE_2__assets_assets__["d" /* icons */].play2);_this.handleClick=function(){window.open('/portal/audio/'+(props.item.AudioId||props.item.MaterialId||props.item.FileId)+'?windowTitle='+encodeURIComponent(props.item.windowTitle)+'&faviconUrl='+encodeURIComponent(props.item.faviconUrl),'_blank');};return _this;}return AudioGameMaterial;}(__WEBPACK_IMPORTED_MODULE_3__GameMaterialItem__["a" /* default */]);// import { Howl } from 'howler';
//
// import { icons } from '../../assets/assets';
// import GameMaterialItem from './GameMaterialItem';
// export default class AudioGameMaterial extends GameMaterialItem {
//   constructor(props) {
//     super(props);
//     this.playIcon = {
//       src: icons.play2,
//       alt: 'play-icon',
//       onClick: () => {
//         if (this.howl instanceof Howl === true) {
//           if (!this.state.playing) {
//             this.howl.play();
//           }
//         }
//       },
//     };
//     this.pauzeIcon = {
//       src: icons.pauze,
//       alt: 'pause-icon',
//       onClick: () => {
//         if (this.howl instanceof Howl === true) {
//           if (this.state.playing) {
//             this.howl.pause();
//           }
//         }
//       },
//     };
//     this.downloadIcon = {
//       src: icons.download,
//       alt: 'download-icon',
//       onClick: (ev) => {
//         super.download(ev);
//       },
//     };
//     this.state.playing = false;
//     this.state.paused = false;
//     this.state.stopped = false;
//     this.state.loaded = false;
//     this.state.icons = [
//       this.downloadIcon,
//       {
//         ...this.playIcon,
//         style: {
//           pointerEvents: 'none',
//           opacity: '0.5',
//         },
//         onClick: () => {},
//       }
//     ];
//     this.howl = new Howl({
//       html5: true,
//       src: [props.item.Material.url],
//       onload: this.handleOnLoad,
//       onpause: this.handlePause,
//       onplay: this.handlePlay,
//       onstop: this.handleStop,
//       onloaderror: this.handleLoadError,
//     });
//     this.handleClick = () => {}
//     this.componentWillUnmount = () => {
//       if (this.howl instanceof Howl === true) {
//         this.howl.unload();
//         delete this.howl;
//       }
//       super.componentWillUnmount();
//     }
//   }
//   handlePause = () => {
//     this.setState({
//       playing: false,
//       paused: true,
//       stopped: false,
//       icons: [this.downloadIcon, this.playIcon],
//     });
//   };
//   handlePlay = () => {
//     this.setState({
//       playing: true,
//       paused: false,
//       stopped: false,
//       icons: [this.downloadIcon, this.pauzeIcon],
//     });
//   };
//   handleStop = () => {
//     this.setState({
//       playing: false,
//       paused: false,
//       stopped: true,
//       icons: [this.downloadIcon, this.playIcon],
//     });
//   };
//   handleOnLoad = () => {
//     this.setState({ loaded: true, icons: [this.downloadIcon, this.playIcon] });
//   };
//   handleLoadError = (id, err) => {
//     console.error(err);
//   }
// }


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//download.js v4.2, by dandavis; 2008-2016. [MIT] see http://danml.com/download.html for tests/usage
// v1 landed a FF+Chrome compat way of downloading strings to local un-named files, upgraded to use a hidden frame and optional mime
// v2 added named files via a[download], msSaveBlob, IE (10+) support, and window.URL support for larger+faster saves than dataURLs
// v3 added dataURL and Blob Input, bind-toggle arity, and legacy dataURL fallback was improved with force-download mime and base64 support. 3.1 improved safari handling.
// v4 adds AMD/UMD, commonJS, and plain browser support
// v4.1 adds url download capability via solo URL argument (same domain/CORS only)
// v4.2 adds semantic variable names, long (over 2MB) dataURL support, and hidden by default temp anchors
// https://github.com/rndme/download

(function (root, factory) {
	if (true) {
		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		// Browser globals (root is window)
		root.download = factory();
  }
}(this, function () {

	return function download(data, strFileName, strMimeType) {

		var self = window, // this script is only for browsers anyway...
			defaultMime = "application/octet-stream", // this default mime also triggers iframe downloads
			mimeType = strMimeType || defaultMime,
			payload = data,
			url = !strFileName && !strMimeType && payload,
			anchor = document.createElement("a"),
			toString = function(a){return String(a);},
			myBlob = (self.Blob || self.MozBlob || self.WebKitBlob || toString),
			fileName = strFileName || "download",
			blob,
			reader;
			myBlob= myBlob.call ? myBlob.bind(self) : Blob ;
	  
		if(String(this)==="true"){ //reverse arguments, allowing download.bind(true, "text/xml", "export.xml") to act as a callback
			payload=[payload, mimeType];
			mimeType=payload[0];
			payload=payload[1];
		}


		if(url && url.length< 2048){ // if no filename and no mime, assume a url was passed as the only argument
			fileName = url.split("/").pop().split("?")[0];
			anchor.href = url; // assign href prop to temp anchor
		  	if(anchor.href.indexOf(url) !== -1){ // if the browser determines that it's a potentially valid url path:
        		var ajax=new XMLHttpRequest();
        		ajax.open( "GET", url, true);
        		ajax.responseType = 'blob';
        		ajax.onload= function(e){ 
				  download(e.target.response, fileName, defaultMime);
				};
        		setTimeout(function(){ ajax.send();}, 0); // allows setting custom ajax headers using the return:
			    return ajax;
			} // end if valid url?
		} // end if url?


		//go ahead and download dataURLs right away
		if(/^data:([\w+-]+\/[\w+.-]+)?[,;]/.test(payload)){
		
			if(payload.length > (1024*1024*1.999) && myBlob !== toString ){
				payload=dataUrlToBlob(payload);
				mimeType=payload.type || defaultMime;
			}else{			
				return navigator.msSaveBlob ?  // IE10 can't do a[download], only Blobs:
					navigator.msSaveBlob(dataUrlToBlob(payload), fileName) :
					saver(payload) ; // everyone else can save dataURLs un-processed
			}
			
		}else{//not data url, is it a string with special needs?
			if(/([\x80-\xff])/.test(payload)){			  
				var i=0, tempUiArr= new Uint8Array(payload.length), mx=tempUiArr.length;
				for(i;i<mx;++i) tempUiArr[i]= payload.charCodeAt(i);
			 	payload=new myBlob([tempUiArr], {type: mimeType});
			}		  
		}
		blob = payload instanceof myBlob ?
			payload :
			new myBlob([payload], {type: mimeType}) ;


		function dataUrlToBlob(strUrl) {
			var parts= strUrl.split(/[:;,]/),
			type= parts[1],
			decoder= parts[2] == "base64" ? atob : decodeURIComponent,
			binData= decoder( parts.pop() ),
			mx= binData.length,
			i= 0,
			uiArr= new Uint8Array(mx);

			for(i;i<mx;++i) uiArr[i]= binData.charCodeAt(i);

			return new myBlob([uiArr], {type: type});
		 }

		function saver(url, winMode){

			if ('download' in anchor) { //html5 A[download]
				anchor.href = url;
				anchor.setAttribute("download", fileName);
				anchor.className = "download-js-link";
				anchor.innerHTML = "downloading...";
				anchor.style.display = "none";
				document.body.appendChild(anchor);
				setTimeout(function() {
					anchor.click();
					document.body.removeChild(anchor);
					if(winMode===true){setTimeout(function(){ self.URL.revokeObjectURL(anchor.href);}, 250 );}
				}, 66);
				return true;
			}

			// handle non-a[download] safari as best we can:
			if(/(Version)\/(\d+)\.(\d+)(?:\.(\d+))?.*Safari\//.test(navigator.userAgent)) {
				if(/^data:/.test(url))	url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
				if(!window.open(url)){ // popup blocked, offer direct download:
					if(confirm("Displaying New Document\n\nUse Save As... to download, then click back to return to this page.")){ location.href=url; }
				}
				return true;
			}

			//do iframe dataURL download (old ch+FF):
			var f = document.createElement("iframe");
			document.body.appendChild(f);

			if(!winMode && /^data:/.test(url)){ // force a mime that will download:
				url="data:"+url.replace(/^data:([\w\/\-\+]+)/, defaultMime);
			}
			f.src=url;
			setTimeout(function(){ document.body.removeChild(f); }, 333);

		}//end saver




		if (navigator.msSaveBlob) { // IE10+ : (has Blob, but not a[download] or URL)
			return navigator.msSaveBlob(blob, fileName);
		}

		if(self.URL){ // simple fast and modern way using Blob and URL:
			saver(self.URL.createObjectURL(blob), true);
		}else{
			// handle non-Blob()+non-URL browsers:
			if(typeof blob === "string" || blob.constructor===toString ){
				try{
					return saver( "data:" +  mimeType   + ";base64,"  +  self.btoa(blob)  );
				}catch(y){
					return saver( "data:" +  mimeType   + "," + encodeURIComponent(blob)  );
				}
			}

			// Blob but not URL support:
			reader=new FileReader();
			reader.onload=function(e){
				saver(this.result);
			};
			reader.readAsDataURL(blob);
		}
		return true;
	}; /* end download() */
}));


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, setImmediate, global, process) {var require;var require;/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{("undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this).JSZip=e()}}(function(){return function s(a,o,h){function u(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof require&&require;if(!e&&t)return require(r,!0);if(l)return l(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return u(t||e)},i,i.exports,s,a,o,h)}return o[r].exports}for(var l="function"==typeof require&&require,e=0;e<h.length;e++)u(h[e]);return u}({1:[function(e,t,r){"use strict";var d=e("./utils"),c=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,h=[],u=0,l=e.length,f=l,c="string"!==d.getTypeOf(e);u<e.length;)f=l-u,n=c?(t=e[u++],r=u<l?e[u++]:0,u<l?e[u++]:0):(t=e.charCodeAt(u++),r=u<l?e.charCodeAt(u++):0,u<l?e.charCodeAt(u++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<f?(15&r)<<2|n>>6:64,o=2<f?63&n:64,h.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,h=0,u="data:";if(e.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(e=e.replace(/[^A-Za-z0-9+/=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=c.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),l[h++]=t,64!==s&&(l[h++]=r),64!==a&&(l[h++]=n);return l}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils");var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}(0|t,e,e.length,0):function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t.charCodeAt(a))];return-1^e}(0|t,e,e.length,0):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n=null;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function h(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},h.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new h("Deflate",e)},r.uncompressWorker=function(){return new h("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function A(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function n(e,t,r,n,i,s){var a,o,h=e.file,u=e.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),c=I.transformTo("string",O.utf8encode(h.name)),d=h.comment,p=I.transformTo("string",s(d)),m=I.transformTo("string",O.utf8encode(d)),_=c.length!==h.name.length,g=m.length!==d.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===i?(C=798,z|=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(e){return 63&(e||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+c,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(n,4)+f+b+p}}var I=e("../utils"),i=e("../stream/GenericWorker"),O=e("../utf8"),B=e("../crc32"),R=e("../signature");function s(e,t,r,n){i.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}I.inherits(s,i),s.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,i.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},s.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=n(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},s.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=n(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:function(e){return R.DATA_DESCRIPTOR+A(e.crc32,4)+A(e.compressedSize,4)+A(e.uncompressedSize,4)}(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},s.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,n=function(e,t,r,n,i){var s=I.transformTo("string",i(n));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(e,2)+A(e,2)+A(t,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:n,meta:{percent:100}})},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},s.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(e){var t=this._sources;if(!i.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},s.prototype.lock=function(){i.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=s},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var u=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),h=0;try{e.forEach(function(e,t){h++;var r=function(e,t){var r=e||t,n=u[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=h}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.10.1",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var u=e("./utils"),i=e("./external"),n=e("./utf8"),s=e("./zipEntries"),a=e("./stream/Crc32Probe"),l=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new a);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,o){var h=this;return o=u.extend(o||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:n.utf8decode}),l.isNode&&l.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):u.prepareContent("the loaded zip file",e,!0,o.optimizedBinaryString,o.base64).then(function(e){var t=new s(o);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(o.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n],s=i.fileNameStr,a=u.resolve(i.fileNameStr);h.file(a,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:o.createFolders}),i.dir||(h.file(a).unsafeOriginalName=s)}return t.zipComment.length&&(h.comment=t.zipComment),h})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=u.getTypeOf(t),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=g(e)),s.createFolders&&(n=_(e))&&b.call(this,n,!0);var a="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string");var o=null;o=t instanceof c||t instanceof l?t:p.isNode&&p.isStream(t)?new m(e,t):u.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var h=new d(e,o,s);this.files[e]=h}var i=e("./utf8"),u=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),f=e("./defaults"),c=e("./compressedObject"),d=e("./zipObject"),o=e("./generate"),p=e("./nodejsUtils"),m=e("./nodejs/NodejsStreamInputAdapter"),_=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""},g=function(e){return"/"!==e.slice(-1)&&(e+="/"),e},b=function(e,t){return t=void 0!==t?t:f.createFolders,e=g(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function h(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n)},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(h(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=b.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=u.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){"use strict";t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(){},lastIndexOfSignature:function(){},readAndCheckSignature:function(){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),h=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new h(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo,e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),u=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function l(e,o){return new a.Promise(function(t,r){var n=[],i=e._internalType,s=e._outputType,a=e._mimeType;e.on("data",function(e,t){n.push(e),o&&o(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return u.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()})}function f(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}f.prototype={accumulate:function(e){return l(this,e)},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=f},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),h=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),u=new Array(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;u[254]=u[254]=1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function l(){n.call(this,"utf-8 encode")}s.utf8encode=function(e){return h.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=h.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return h.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=u[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(h.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(h.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}(t),i=t;n!==t.length&&(h.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=l},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,a){"use strict";var o=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),u=e("./external");function n(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}e("setimmediate"),a.newBlob=function(t,r){a.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var i={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function s(e){var t=65536,r=a.getTypeOf(e),n=!0;if("uint8array"===r?n=i.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=i.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return i.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return i.stringifyByChar(e)}function f(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}a.applyFromCharCode=s;var c={};c.string={string:n,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:s,array:n,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return s(new Uint8Array(e))},array:function(e){return f(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:n,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:n,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:n},a.transformTo=function(e,t){if(t=t||"",!e)return t;a.checkSupport(e);var r=a.getTypeOf(t);return c[r][e](t)},a.resolve=function(e){for(var t=e.split("/"),r=[],n=0;n<t.length;n++){var i=t[n];"."===i||""===i&&0!==n&&n!==t.length-1||(".."===i?r.pop():r.push(i))}return r.join("/")},a.getTypeOf=function(e){return"string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":o.nodebuffer&&r.isBuffer(e)?"nodebuffer":o.uint8array&&e instanceof Uint8Array?"uint8array":o.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},a.checkSupport=function(e){if(!o[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},a.delay=function(e,t,r){setImmediate(function(){e.apply(r||null,t||[])})},a.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},a.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},a.prepareContent=function(r,e,n,i,s){return u.Promise.resolve(e).then(function(n){return o.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new u.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):n}).then(function(e){var t=a.getTypeOf(e);return t?("arraybuffer"===t?e=a.transformTo("uint8array",e):"string"===t&&(s?e=h.decode(e):n&&!0!==i&&(e=function(e){return l(e,o.uint8array?new Uint8Array(e.length):new Array(e.length))}(e))),e):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,setimmediate:54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=e("./support");function h(e){this.files=[],this.loadOptions=e}h.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw!this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=h},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),h=e("./compressions"),u=e("./support");function l(e,t){this.options=e,this.loadOptions=t}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in h)if(Object.prototype.hasOwnProperty.call(h,t)&&h[t].magic===e)return h[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=l},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),h=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new h("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new i(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)n.prototype[u[f]]=l;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,l,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(u),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(u,0)};else{var o=new t.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0)}}var h=[];function u(){var e,t;n=!0;for(var r=h.length;r;){for(t=h,h=[],e=-1;++e<r;)t[e]();r=h.length}n=!1}l.exports=function(e){1!==h.push(e)||n||r()}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==u&&d(this,e)}function h(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function f(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return l.reject(t,e)}e===t?l.reject(t,new TypeError("Cannot resolve promise with itself")):l.resolve(t,e)})}function c(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function d(t,e){var r=!1;function n(e){r||(r=!0,l.reject(t,e))}function i(e){r||(r=!0,l.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(u);this.state!==n?f(r,this.state===a?e:t,this.outcome):this.queue.push(new h(r,e,t));return r},h.prototype.callFulfilled=function(e){l.resolve(this.promise,e)},h.prototype.otherCallFulfilled=function(e){f(this.promise,this.onFulfilled,e)},h.prototype.callRejected=function(e){l.reject(this.promise,e)},h.prototype.otherCallRejected=function(e){f(this.promise,this.onRejected,e)},l.resolve=function(e,t){var r=p(c,t);if("error"===r.status)return l.reject(e,r.value);var n=r.value;if(n)d(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},l.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){if(e instanceof this)return e;return l.resolve(new this(u),e)},o.reject=function(e){var t=new this(u);return l.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);var s=new Array(n),a=0,t=-1,o=new this(u);for(;++t<n;)h(e[t],t);return o;function h(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,l.resolve(o,s))},function(e){i||(i=!0,l.reject(o,e))})}},o.race=function(e){var t=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var r=e.length,n=!1;if(!r)return this.resolve([]);var i=-1,s=new this(u);for(;++i<r;)a=e[i],t.resolve(a).then(function(e){n||(n=!0,l.resolve(s,e))},function(e){n||(n=!0,l.reject(s,e))});var a;return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),h=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,c=0,d=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:f,method:d,chunkSize:16384,windowBits:15,memLevel:8,strategy:c,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==l)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?h.string2buf(t.dictionary):"[object ArrayBuffer]"===u.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==l)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=h.string2buf(e):"[object ArrayBuffer]"===u.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==n||(this.onEnd(l),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var c=e("./zlib/inflate"),d=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=d.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=c.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,c.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?h.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new d.Buf8(u),h.next_out=0,h.avail_out=u),(r=c.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=c.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(h.output,h.next_out),s=h.next_out-i,a=p.buf2string(h.output,i),h.next_out=s,h.avail_out=u-s,s&&d.arraySet(h.output,h.output,i,s,0),this.onData(a)):this.onData(d.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0)}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=c.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=d.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var h=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var u=new h.Buf8(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function l(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,h.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}u[254]=u[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new h.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return l(e,e.length)},r.binstring2buf=function(e){for(var t=new h.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=u[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return l(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var h,c=e("../utils/common"),u=e("./trees"),d=e("./adler32"),p=e("./crc32"),n=e("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,i=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(e,t){return e.msg=n[t],t}function T(e){return(e<<1)-(4<e?9:0)}function D(e){for(var t=e.length;0<=--t;)e[t]=0}function F(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(c.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function N(e,t){u._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,F(e.strm)}function U(e,t){e.pending_buf[e.pending++]=t}function P(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function L(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,h=e.strstart>e.w_size-z?e.strstart-(e.w_size-z):0,u=e.window,l=e.w_mask,f=e.prev,c=e.strstart+S,d=u[s+a-1],p=u[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(u[(r=t)+a]===p&&u[r+a-1]===d&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<c);if(n=S-(c-s),s=c-S,a<n){if(e.match_start=t,o<=(a=n))break;d=u[s+a-1],p=u[s+a]}}}while((t=f[t&l])>h&&0!=--i);return a<=e.lookahead?a:e.lookahead}function j(e){var t,r,n,i,s,a,o,h,u,l,f=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=f+(f-z)){for(c.arraySet(e.window,e.window,f,f,0),e.match_start-=f,e.strstart-=f,e.block_start-=f,t=r=e.hash_size;n=e.head[--t],e.head[t]=f<=n?n-f:0,--r;);for(t=r=f;n=e.prev[--t],e.prev[t]=f<=n?n-f:0,--r;);i+=f}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,h=e.strstart+e.lookahead,u=i,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,c.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=d(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),e.lookahead+=r,e.lookahead+e.insert>=x)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+x-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<x)););}while(e.lookahead<z&&0!==e.strm.avail_in)}function Z(e,t){for(var r,n;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r)),e.match_length>=x)if(n=u._tr_tally(e,e.strstart-e.match_start,e.match_length-x),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=x){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function W(e,t){for(var r,n,i;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=x-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===x&&4096<e.strstart-e.match_start)&&(e.match_length=x-1)),e.prev_length>=x&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-x,n=u._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-x),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=x-1,e.strstart++,n&&(N(e,!1),0===e.strm.avail_out))return A}else if(e.match_available){if((n=u._tr_tally(e,0,e.window[e.strstart-1]))&&N(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return A}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=u._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function M(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new c.Buf16(2*w),this.dyn_dtree=new c.Buf16(2*(2*a+1)),this.bl_tree=new c.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new c.Buf16(k+1),this.heap=new c.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new c.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function G(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?C:E,e.adler=2===t.wrap?0:1,t.last_flush=l,u._tr_init(t),m):R(e,_)}function K(e){var t=G(e);return t===m&&function(e){e.window_size=2*e.w_size,D(e.head),e.max_lazy_match=h[e.level].max_lazy,e.good_match=h[e.level].good_length,e.nice_match=h[e.level].nice_length,e.max_chain_length=h[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=x-1,e.match_available=0,e.ins_h=0}(e.state),t}function Y(e,t,r,n,i,s){if(!e)return _;var a=1;if(t===g&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||y<i||r!==v||n<8||15<n||t<0||9<t||s<0||b<s)return R(e,_);8===n&&(n=9);var o=new H;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new c.Buf8(2*o.w_size),o.head=new c.Buf16(o.hash_size),o.prev=new c.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new c.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,K(e)}h=[new M(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(j(e),0===e.lookahead&&t===l)return A;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,N(e,!1),0===e.strm.avail_out))return A;if(e.strstart-e.block_start>=e.w_size-z&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):(e.strstart>e.block_start&&(N(e,!1),e.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(e,t){return Y(e,t,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?_:(e.state.gzhead=t,m):_},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?R(e,_):_;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&t!==f)return R(e,0===e.avail_out?-5:_);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===C)if(2===n.wrap)e.adler=0,U(n,31),U(n,139),U(n,8),n.gzhead?(U(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),U(n,255&n.gzhead.time),U(n,n.gzhead.time>>8&255),U(n,n.gzhead.time>>16&255),U(n,n.gzhead.time>>24&255),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(U(n,255&n.gzhead.extra.length),U(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(U(n,0),U(n,0),U(n,0),U(n,0),U(n,0),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,3),n.status=E);else{var a=v+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=E,P(n,a),0!==n.strstart&&(P(n,e.adler>>>16),P(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending!==n.pending_buf_size));)U(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&F(e),n.pending+2<=n.pending_buf_size&&(U(n,255&e.adler),U(n,e.adler>>8&255),e.adler=0,n.status=E)):n.status=E),0!==n.pending){if(F(e),0===e.avail_out)return n.last_flush=-1,m}else if(0===e.avail_in&&T(t)<=T(r)&&t!==f)return R(e,-5);if(666===n.status&&0!==e.avail_in)return R(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==l&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(j(e),0===e.lookahead)){if(t===l)return A;break}if(e.match_length=0,r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=S){if(j(e),e.lookahead<=S&&t===l)return A;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=x&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+S;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=S-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=x?(r=u._tr_tally(e,1,e.match_length-x),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):h[n.level].func(n,t);if(o!==O&&o!==B||(n.status=666),o===A||o===O)return 0===e.avail_out&&(n.last_flush=-1),m;if(o===I&&(1===t?u._tr_align(n):5!==t&&(u._tr_stored_block(n,0,0,!1),3===t&&(D(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),F(e),0===e.avail_out))return n.last_flush=-1,m}return t!==f?m:n.wrap<=0?1:(2===n.wrap?(U(n,255&e.adler),U(n,e.adler>>8&255),U(n,e.adler>>16&255),U(n,e.adler>>24&255),U(n,255&e.total_in),U(n,e.total_in>>8&255),U(n,e.total_in>>16&255),U(n,e.total_in>>24&255)):(P(n,e.adler>>>16),P(n,65535&e.adler)),F(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?m:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==C&&69!==t&&73!==t&&91!==t&&103!==t&&t!==E&&666!==t?R(e,_):(e.state=null,t===E?R(e,-3):m):_},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,h,u,l=t.length;if(!e||!e.state)return _;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(e.adler=d(e.adler,t,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new c.Buf8(r.w_size),c.arraySet(u,t,l-r.w_size,r.w_size,0),t=u,l=r.w_size),a=e.avail_in,o=e.next_in,h=e.input,e.avail_in=l,e.next_in=0,e.input=t,j(r);r.lookahead>=x;){for(n=r.strstart,i=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+x-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=x-1,j(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,e.next_in=o,e.input=h,e.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,C=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,c=r.window,d=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=m[d&g];t:for(;;){if(d>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else{if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(d&(1<<y)-1)];continue t}if(32&y){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}w=65535&v,(y&=15)&&(p<y&&(d+=z[n++]<<p,p+=8),w+=d&(1<<y)-1,d>>>=y,p-=y),p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=_[d&b];r:for(;;){if(d>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(d&(1<<y)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&v,p<(y&=15)&&(d+=z[n++]<<p,(p+=8)<y&&(d+=z[n++]<<p,p+=8)),h<(k+=d&(1<<y)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=c,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=c[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=c[x++],--y;);x=s-k,S=C}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]))}else{for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]))}break}}break}}while(n<i&&s<o);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=d,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),R=e("./inffast"),T=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function h(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function u(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=h(e,t))!==N&&(e.state=null),r):U}var l,f,c=!0;function j(e){if(c){var t;for(l=new I.Buf32(512),f=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(T(D,e.lens,0,288,l,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;T(F,e.lens,0,32,f,0,e.work,{bits:5}),c=!1}e.lencode=l,e.lenbits=9,e.distcode=f,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(e){return u(e,15)},r.inflateInit2=u,r.inflate=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,f=o,c=h,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){e.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.flags=u,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(d=r.length)&&(d=o),d&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,d,k)),512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,r.length-=d),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}l=u=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}e.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;u>>>=2,l-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if((65535&u)!=(u>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(d=r.length){if(o<d&&(d=o),h<d&&(d=h),0===d)break e;I.arraySet(i,n,s,d,a),o-=d,s+=d,h-=d,a+=d,r.length-=d;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else{if(16===b){for(z=_+2;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u>>>=_,l-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],d=3+(3&u),u>>>=2,l-=2}else if(17===b){for(z=_+3;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=3+(7&(u>>>=_)),u>>>=3,l-=3}else{for(z=_+7;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=11+(127&(u>>>=_)),u>>>=7,l-=7}if(r.have+d>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;d--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=h){e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,R(e,c),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break e;if(d=c-h,r.offset>d){if((d=r.offset-d)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=d>r.wnext?(d-=r.wnext,r.wsize-d):r.wnext-d,d>r.length&&(d=r.length),m=r.window}else m=i,p=a-r.offset,d=r.length;for(h<d&&(d=h),h-=d,r.length-=d;i[a++]=m[p++],--d;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break e;i[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break e;o--,u|=n[s++]<<l,l+=8}if(c-=h,e.total_out+=c,r.total+=c,c&&(e.adler=r.check=r.flags?B(r.check,i,c,a-c):O(r.check,i,c,a-c)),c=h,(r.flags?u:L(u))!==r.check){e.msg="incorrect data check",r.mode=30;break}l=u=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}l=u=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,(r.wsize||c!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,c-e.avail_out)?(r.mode=31,-4):(f-=e.avail_in,c-=e.avail_out,e.total_in+=f,e.total_out+=c,r.total+=c,r.wrap&&c&&(e.adler=r.check=r.flags?B(r.check,i,c,e.next_out-c):O(r.check,i,c,e.next_out-c)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===c||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var h,u,l,f,c,d,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<n;v++)O[t[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return-1;if(0<z&&(0===e||1!==w))return-1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<n;v++)0!==t[r+v]&&(a[B[t[r+v]]++]=v);if(d=0===e?(A=R=a,19):1===e?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,c=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===e&&852<C||2===e&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<d?(m=0,a[v]):a[v]>d?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;i[c+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=t[r+a[v]]}if(k<b&&(E&f)!==l){for(0===S&&(S=k),c+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===e&&852<C||2===e&&592<C)return 1;i[l=E&f]=k<<24|x<<16|c-s|0}}return 0!==E&&(i[c+E]=b-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var i=e("../utils/common"),o=0,h=1;function n(e){for(var t=e.length;0<=--t;)e[t]=0}var s=0,a=29,u=256,l=u+1+a,f=30,c=19,_=2*l+1,g=15,d=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));n(z);var C=new Array(2*f);n(C);var E=new Array(512);n(E);var A=new Array(256);n(A);var I=new Array(a);n(I);var O,B,R,T=new Array(f);function D(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function F(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function N(e){return e<256?E[e]:E[256+(e>>>7)]}function U(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function P(e,t,r){e.bi_valid>d-r?(e.bi_buf|=t<<e.bi_valid&65535,U(e,e.bi_buf),e.bi_buf=t>>d-e.bi_valid,e.bi_valid+=r-d):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function L(e,t,r){P(e,r[2*t],r[2*t+1])}function j(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function Z(e,t,r){var n,i,s=new Array(g+1),a=0;for(n=1;n<=g;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=j(s[o]++,o))}}function W(e){var t;for(t=0;t<l;t++)e.dyn_ltree[2*t]=0;for(t=0;t<f;t++)e.dyn_dtree[2*t]=0;for(t=0;t<c;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*m]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function M(e){8<e.bi_valid?U(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function H(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function G(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&H(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!H(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function K(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?L(e,i,t):(L(e,(s=A[i])+u+1,t),0!==(a=w[s])&&P(e,i-=I[s],a),L(e,s=N(--n),r),0!==(a=k[s])&&P(e,n-=T[s],a)),o<e.last_lit;);L(e,m,t)}function Y(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,h=t.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(e.heap[++e.heap_len]=u=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=u,r=e.heap_len>>1;1<=r;r--)G(e,s,r);for(i=h;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],G(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,G(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,h=t.dyn_tree,u=t.max_code,l=t.stat_desc.static_tree,f=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=g;s++)e.bl_count[s]=0;for(h[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<_;r++)p<(s=h[2*h[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),h[2*n+1]=s,u<n||(e.bl_count[s]++,a=0,d<=n&&(a=c[n-d]),o=h[2*n],e.opt_len+=o*(s+a),f&&(e.static_len+=o*(l[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)u<(i=e.heap[--r])||(h[2*i+1]!==s&&(e.opt_len+=(s-h[2*i+1])*h[2*i],h[2*i+1]=s),n--)}}(e,t),Z(s,u,e.bl_count)}function X(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<h&&i===a||(o<u?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[2*b]++):o<=10?e.bl_tree[2*v]++:e.bl_tree[2*y]++,s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4))}function V(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<h&&i===a)){if(o<u)for(;L(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(L(e,i,e.bl_tree),o--),L(e,b,e.bl_tree),P(e,o-3,2)):o<=10?(L(e,v,e.bl_tree),P(e,o-3,3)):(L(e,y,e.bl_tree),P(e,o-11,7));s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4)}}n(T);var q=!1;function J(e,t,r,n){P(e,(s<<1)+(n?1:0),3),function(e,t,r,n){M(e),n&&(U(e,r),U(e,~r)),i.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r}(e,t,r,!0)}r._tr_init=function(e){q||(function(){var e,t,r,n,i,s=new Array(g+1);for(n=r=0;n<a-1;n++)for(I[n]=r,e=0;e<1<<w[n];e++)A[r++]=n;for(A[r-1]=n,n=i=0;n<16;n++)for(T[n]=i,e=0;e<1<<k[n];e++)E[i++]=n;for(i>>=7;n<f;n++)for(T[n]=i<<7,e=0;e<1<<k[n]-7;e++)E[256+i++]=n;for(t=0;t<=g;t++)s[t]=0;for(e=0;e<=143;)z[2*e+1]=8,e++,s[8]++;for(;e<=255;)z[2*e+1]=9,e++,s[9]++;for(;e<=279;)z[2*e+1]=7,e++,s[7]++;for(;e<=287;)z[2*e+1]=8,e++,s[8]++;for(Z(z,l+1,s),e=0;e<f;e++)C[2*e+1]=5,C[2*e]=j(e,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,c,p)}(),q=!0),e.l_desc=new F(e.dyn_ltree,O),e.d_desc=new F(e.dyn_dtree,B),e.bl_desc=new F(e.bl_tree,R),e.bi_buf=0,e.bi_valid=0,W(e)},r._tr_stored_block=J,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return o;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return h;for(t=32;t<u;t++)if(0!==e.dyn_ltree[2*t])return h;return o}(e)),Y(e,e.l_desc),Y(e,e.d_desc),a=function(e){var t;for(X(e,e.dyn_ltree,e.l_desc.max_code),X(e,e.dyn_dtree,e.d_desc.max_code),Y(e,e.bl_desc),t=c-1;3<=t&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?J(e,t,r,n):4===e.strategy||s===i?(P(e,2+(n?1:0),3),K(e,z,C)):(P(e,4+(n?1:0),3),function(e,t,r,n){var i;for(P(e,t-257,5),P(e,r-1,5),P(e,n-4,4),i=0;i<n;i++)P(e,e.bl_tree[2*S[i]+1],3);V(e,e.dyn_ltree,t-1),V(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),K(e,e.dyn_ltree,e.dyn_dtree)),W(e),n&&M(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(A[r]+u+1)]++,e.dyn_dtree[2*N(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){P(e,2,3),L(e,m,z),function(e){16===e.bi_valid?(U(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):8<=e.bi_valid&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}(e)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){(function(e){!function(r,n){"use strict";if(!r.setImmediate){var i,s,t,a,o=1,h={},u=!1,l=r.document,e=Object.getPrototypeOf&&Object.getPrototypeOf(r);e=e&&e.setTimeout?e:r,i="[object process]"==={}.toString.call(r.process)?function(e){process.nextTick(function(){c(e)})}:function(){if(r.postMessage&&!r.importScripts){var e=!0,t=r.onmessage;return r.onmessage=function(){e=!1},r.postMessage("","*"),r.onmessage=t,e}}()?(a="setImmediate$"+Math.random()+"$",r.addEventListener?r.addEventListener("message",d,!1):r.attachEvent("onmessage",d),function(e){r.postMessage(a+e,"*")}):r.MessageChannel?((t=new MessageChannel).port1.onmessage=function(e){c(e.data)},function(e){t.port2.postMessage(e)}):l&&"onreadystatechange"in l.createElement("script")?(s=l.documentElement,function(e){var t=l.createElement("script");t.onreadystatechange=function(){c(e),t.onreadystatechange=null,s.removeChild(t),t=null},s.appendChild(t)}):function(e){setTimeout(c,0,e)},e.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var n={callback:e,args:t};return h[o]=n,i(o),o++},e.clearImmediate=f}function f(e){delete h[e]}function c(e){if(u)setTimeout(c,0,e);else{var t=h[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}(t)}finally{f(e),u=!1}}}}function d(e){e.source===r&&"string"==typeof e.data&&0===e.data.indexOf(a)&&c(+e.data.slice(a.length))}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[10])(10)});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(956).Buffer, __webpack_require__(356).setImmediate, __webpack_require__(31), __webpack_require__(161)))

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(960);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_switch__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Toggle=(_temp=_class=function(_React$Component){_inherits(Toggle,_React$Component);function Toggle(props){_classCallCheck(this,Toggle);var _this=_possibleConstructorReturn(this,(Toggle.__proto__||Object.getPrototypeOf(Toggle)).call(this,props));_this.handleChange=function(){var preConditionsMet=true;if(_this.props.ignoreDisabled)_this.setState({disabled:false});if(_this.props.preConditions){preConditionsMet=_this.props.preConditions();}if(_this.state.disabled===false&&preConditionsMet){if(!_this.allowAction)return;_this.allowAction=false;var promise=new Promise(function(res){res(_this.props.onChange());});promise.then(function(){_this.allowAction=true;});_this.setState({disabled:true});}};_this.state={checked:_this.props.checked,disabled:false};_this.allowAction=true;return _this;}_createClass(Toggle,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(_ref){var checked=_ref.checked;if(this.state.checked!==checked){this.setState({checked:checked,disabled:false});}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"small-switch"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.props.label),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_switch___default.a,{className:"react-switch "+(this.state.checked?'on':'off'),onChange:this.handleChange,checked:this.state.checked,uncheckedIcon:false,checkedIcon:false,id:"small-switch",height:22,width:40,disabled:this.props.disabled}));}}]);return Toggle;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,checked:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,label:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,ignoreDisabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,disabled:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool},_class.defaultProps={onChange:function onChange(){},checked:false,label:'',ignoreDisabled:false,disabled:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Toggle);

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupGameScoreRow=(_temp=_class=function(_React$Component){_inherits(GroupGameScoreRow,_React$Component);function GroupGameScoreRow(props){_classCallCheck(this,GroupGameScoreRow);var _this=_possibleConstructorReturn(this,(GroupGameScoreRow.__proto__||Object.getPrototypeOf(GroupGameScoreRow)).call(this,props));_this.onGameScoreChange=function(ev){_this.props.onChange(ev.target.value);};_this.state={score:{}};return _this;}_createClass(GroupGameScoreRow,[{key:'render',value:function render(){var _props=this.props,text=_props.text,color=_props.color,gameScores=_props.gameScores,score=_props.score,isPoints=_props.isPoints,bonus=_props.bonus,editable=_props.editable;gameScores.sort(function(a,b){return b.points-a.points;});var points=score.points,globas=score.globas;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'group-row game-score '+color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-row-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,text)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,points!==undefined&&globas!==undefined&&!editable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'score'},bonus?points:globas):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{name:'gameScore',onChange:this.onGameScoreChange,value:points!==undefined&&globas!==undefined?JSON.stringify({points:points,globas:globas}):0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{value:0},'[',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_kies_score'),']'),gameScores.map(function(gs){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:gs.id,value:JSON.stringify({points:gs.points,globas:gs.globas})},isPoints?gs.points:gs.globas);})))));}}]);return GroupGameScoreRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,gameScores:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,isPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,editable:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,bonus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,score:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({globas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,points:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number}),onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func},_class.defaultProps={text:'',color:'red',gameScores:[],bonus:false,editable:false,isPoints:false,onChange:function onChange(){},score:{}},_temp);/* harmony default export */ __webpack_exports__["a"] = (GroupGameScoreRow);

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_assets__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupRow=(_temp=_class=function(_React$Component){_inherits(GroupRow,_React$Component);function GroupRow(){_classCallCheck(this,GroupRow);return _possibleConstructorReturn(this,(GroupRow.__proto__||Object.getPrototypeOf(GroupRow)).apply(this,arguments));}_createClass(GroupRow,[{key:'render',value:function render(){var _props=this.props,text=_props.text,color=_props.color,disabled=_props.disabled,onClick=_props.onClick,saved=_props.saved;var disabledClass=disabled?' disabled':'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:onClick,className:'group-row '+color+disabledClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-row-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,text),saved?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{height:'20px',marginRight:'10px'},src:__WEBPACK_IMPORTED_MODULE_2__assets_assets__["d" /* icons */].check,alt:'checked'}):null));}}]);return GroupRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,disabled:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onClick:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,saved:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={text:'',color:'red',disabled:false,onClick:function onClick(){},saved:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (GroupRow);

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RankingRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_avatar_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_avatar_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var readableNumber=function readableNumber(x){return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g,".");};var RankingRow=(_temp=_class=function(_Component){_inherits(RankingRow,_Component);function RankingRow(){_classCallCheck(this,RankingRow);return _possibleConstructorReturn(this,(RankingRow.__proto__||Object.getPrototypeOf(RankingRow)).apply(this,arguments));}_createClass(RankingRow,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-row '+this.props.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-row-inner '+this.props.color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'badge'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'badge-border border-'+this.props.color}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rank-badge'},this.props.rank)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title'},this.props.to.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{href:this.props.to,to:this.props.to},this.props.title):this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'avatar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.props.avatar.length?this.props.avatar:__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_avatar_svg___default.a,alt:'avatar'})),this.props.showSchoolClassName?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'className'},this.props.className):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'points'},readableNumber(this.props.points))));}}]);return RankingRow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={rank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,avatar:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,points:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,to:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,schoolClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,showSchoolClassName:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={rank:1,title:'-',color:'red',avatar:'',className:'-',points:0,to:'',showSchoolClassName:true},_temp);

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatusBox=(_temp=_class=function(_React$Component){_inherits(StatusBox,_React$Component);function StatusBox(){_classCallCheck(this,StatusBox);return _possibleConstructorReturn(this,(StatusBox.__proto__||Object.getPrototypeOf(StatusBox)).apply(this,arguments));}_createClass(StatusBox,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'status-box status-'+this.props.status},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.text));}}]);return StatusBox;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.propTypes={status:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={status:1,text:''},_temp);/* harmony default export */ __webpack_exports__["a"] = (StatusBox);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Scaling
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var originalTransform = loadImage.transform

  loadImage.transform = function (img, options, callback, file, data) {
    originalTransform.call(
      loadImage,
      loadImage.scale(img, options, data),
      options,
      callback,
      file,
      data
    )
  }

  // Transform image coordinates, allows to override e.g.
  // the canvas orientation based on the orientation option,
  // gets canvas, options passed as arguments:
  loadImage.transformCoordinates = function () {}

  // Returns transformed options, allows to override e.g.
  // maxWidth, maxHeight and crop options based on the aspectRatio.
  // gets img, options passed as arguments:
  loadImage.getTransformedOptions = function (img, options) {
    var aspectRatio = options.aspectRatio
    var newOptions
    var i
    var width
    var height
    if (!aspectRatio) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.crop = true
    width = img.naturalWidth || img.width
    height = img.naturalHeight || img.height
    if (width / height > aspectRatio) {
      newOptions.maxWidth = height * aspectRatio
      newOptions.maxHeight = height
    } else {
      newOptions.maxWidth = width
      newOptions.maxHeight = width / aspectRatio
    }
    return newOptions
  }

  // Canvas render method, allows to implement a different rendering algorithm:
  loadImage.renderImageToCanvas = function (
    canvas,
    img,
    sourceX,
    sourceY,
    sourceWidth,
    sourceHeight,
    destX,
    destY,
    destWidth,
    destHeight,
    options
  ) {
    var ctx = canvas.getContext('2d')
    if (options.imageSmoothingEnabled === false) {
      ctx.imageSmoothingEnabled = false
    } else if (options.imageSmoothingQuality) {
      ctx.imageSmoothingQuality = options.imageSmoothingQuality
    }
    ctx.drawImage(
      img,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight,
      destX,
      destY,
      destWidth,
      destHeight
    )
    return canvas
  }

  // Determines if the target image should be a canvas element:
  loadImage.hasCanvasOption = function (options) {
    return options.canvas || options.crop || !!options.aspectRatio
  }

  // Scales and/or crops the given image (img or canvas HTML element)
  // using the given options.
  // Returns a canvas object if the browser supports canvas
  // and the hasCanvasOption method returns true or a canvas
  // object is passed as image, else the scaled image:
  loadImage.scale = function (img, options, data) {
    // eslint-disable-next-line no-param-reassign
    options = options || {}
    var canvas = document.createElement('canvas')
    var useCanvas =
      img.getContext ||
      (loadImage.hasCanvasOption(options) && canvas.getContext)
    var width = img.naturalWidth || img.width
    var height = img.naturalHeight || img.height
    var destWidth = width
    var destHeight = height
    var maxWidth
    var maxHeight
    var minWidth
    var minHeight
    var sourceWidth
    var sourceHeight
    var sourceX
    var sourceY
    var pixelRatio
    var downsamplingRatio
    var tmp
    /**
     * Scales up image dimensions
     */
    function scaleUp() {
      var scale = Math.max(
        (minWidth || destWidth) / destWidth,
        (minHeight || destHeight) / destHeight
      )
      if (scale > 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    /**
     * Scales down image dimensions
     */
    function scaleDown() {
      var scale = Math.min(
        (maxWidth || destWidth) / destWidth,
        (maxHeight || destHeight) / destHeight
      )
      if (scale < 1) {
        destWidth *= scale
        destHeight *= scale
      }
    }
    if (useCanvas) {
      // eslint-disable-next-line no-param-reassign
      options = loadImage.getTransformedOptions(img, options, data)
      sourceX = options.left || 0
      sourceY = options.top || 0
      if (options.sourceWidth) {
        sourceWidth = options.sourceWidth
        if (options.right !== undefined && options.left === undefined) {
          sourceX = width - sourceWidth - options.right
        }
      } else {
        sourceWidth = width - sourceX - (options.right || 0)
      }
      if (options.sourceHeight) {
        sourceHeight = options.sourceHeight
        if (options.bottom !== undefined && options.top === undefined) {
          sourceY = height - sourceHeight - options.bottom
        }
      } else {
        sourceHeight = height - sourceY - (options.bottom || 0)
      }
      destWidth = sourceWidth
      destHeight = sourceHeight
    }
    maxWidth = options.maxWidth
    maxHeight = options.maxHeight
    minWidth = options.minWidth
    minHeight = options.minHeight
    if (useCanvas && maxWidth && maxHeight && options.crop) {
      destWidth = maxWidth
      destHeight = maxHeight
      tmp = sourceWidth / sourceHeight - maxWidth / maxHeight
      if (tmp < 0) {
        sourceHeight = (maxHeight * sourceWidth) / maxWidth
        if (options.top === undefined && options.bottom === undefined) {
          sourceY = (height - sourceHeight) / 2
        }
      } else if (tmp > 0) {
        sourceWidth = (maxWidth * sourceHeight) / maxHeight
        if (options.left === undefined && options.right === undefined) {
          sourceX = (width - sourceWidth) / 2
        }
      }
    } else {
      if (options.contain || options.cover) {
        minWidth = maxWidth = maxWidth || minWidth
        minHeight = maxHeight = maxHeight || minHeight
      }
      if (options.cover) {
        scaleDown()
        scaleUp()
      } else {
        scaleUp()
        scaleDown()
      }
    }
    if (useCanvas) {
      pixelRatio = options.pixelRatio
      if (pixelRatio > 1) {
        canvas.style.width = destWidth + 'px'
        canvas.style.height = destHeight + 'px'
        destWidth *= pixelRatio
        destHeight *= pixelRatio
        canvas.getContext('2d').scale(pixelRatio, pixelRatio)
      }
      downsamplingRatio = options.downsamplingRatio
      if (
        downsamplingRatio > 0 &&
        downsamplingRatio < 1 &&
        destWidth < sourceWidth &&
        destHeight < sourceHeight
      ) {
        while (sourceWidth * downsamplingRatio > destWidth) {
          canvas.width = sourceWidth * downsamplingRatio
          canvas.height = sourceHeight * downsamplingRatio
          loadImage.renderImageToCanvas(
            canvas,
            img,
            sourceX,
            sourceY,
            sourceWidth,
            sourceHeight,
            0,
            0,
            canvas.width,
            canvas.height,
            options
          )
          sourceX = 0
          sourceY = 0
          sourceWidth = canvas.width
          sourceHeight = canvas.height
          // eslint-disable-next-line no-param-reassign
          img = document.createElement('canvas')
          img.width = sourceWidth
          img.height = sourceHeight
          loadImage.renderImageToCanvas(
            img,
            canvas,
            0,
            0,
            sourceWidth,
            sourceHeight,
            0,
            0,
            sourceWidth,
            sourceHeight,
            options
          )
        }
      }
      canvas.width = destWidth
      canvas.height = destHeight
      loadImage.transformCoordinates(canvas, options)
      return loadImage.renderImageToCanvas(
        canvas,
        img,
        sourceX,
        sourceY,
        sourceWidth,
        sourceHeight,
        0,
        0,
        destWidth,
        destHeight,
        options
      )
    }
    img.width = destWidth
    img.height = destHeight
    return img
  }
})


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, DataView */

/* eslint-disable no-console */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  loadImage.ExifMap = function () {
    return this
  }

  loadImage.ExifMap.prototype.map = {
    Orientation: 0x0112
  }

  loadImage.ExifMap.prototype.get = function (id) {
    return this[id] || this[this.map[id]]
  }

  loadImage.getExifThumbnail = function (dataView, offset, length) {
    if (!length || offset + length > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid thumbnail data.')
      return
    }
    return loadImage.createObjectURL(
      new Blob([dataView.buffer.slice(offset, offset + length)])
    )
  }

  loadImage.exifTagTypes = {
    // byte, 8-bit unsigned int:
    1: {
      getValue: function (dataView, dataOffset) {
        return dataView.getUint8(dataOffset)
      },
      size: 1
    },
    // ascii, 8-bit byte:
    2: {
      getValue: function (dataView, dataOffset) {
        return String.fromCharCode(dataView.getUint8(dataOffset))
      },
      size: 1,
      ascii: true
    },
    // short, 16 bit int:
    3: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint16(dataOffset, littleEndian)
      },
      size: 2
    },
    // long, 32 bit int:
    4: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getUint32(dataOffset, littleEndian)
      },
      size: 4
    },
    // rational = two long values, first is numerator, second is denominator:
    5: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return (
          dataView.getUint32(dataOffset, littleEndian) /
          dataView.getUint32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    },
    // slong, 32 bit signed int:
    9: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return dataView.getInt32(dataOffset, littleEndian)
      },
      size: 4
    },
    // srational, two slongs, first is numerator, second is denominator:
    10: {
      getValue: function (dataView, dataOffset, littleEndian) {
        return (
          dataView.getInt32(dataOffset, littleEndian) /
          dataView.getInt32(dataOffset + 4, littleEndian)
        )
      },
      size: 8
    }
  }
  // undefined, 8-bit byte, value depending on field:
  loadImage.exifTagTypes[7] = loadImage.exifTagTypes[1]

  loadImage.getExifValue = function (
    dataView,
    tiffOffset,
    offset,
    type,
    length,
    littleEndian
  ) {
    var tagType = loadImage.exifTagTypes[type]
    var tagSize
    var dataOffset
    var values
    var i
    var str
    var c
    if (!tagType) {
      console.log('Invalid Exif data: Invalid tag type.')
      return
    }
    tagSize = tagType.size * length
    // Determine if the value is contained in the dataOffset bytes,
    // or if the value at the dataOffset is a pointer to the actual data:
    dataOffset =
      tagSize > 4
        ? tiffOffset + dataView.getUint32(offset + 8, littleEndian)
        : offset + 8
    if (dataOffset + tagSize > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid data offset.')
      return
    }
    if (length === 1) {
      return tagType.getValue(dataView, dataOffset, littleEndian)
    }
    values = []
    for (i = 0; i < length; i += 1) {
      values[i] = tagType.getValue(
        dataView,
        dataOffset + i * tagType.size,
        littleEndian
      )
    }
    if (tagType.ascii) {
      str = ''
      // Concatenate the chars:
      for (i = 0; i < values.length; i += 1) {
        c = values[i]
        // Ignore the terminating NULL byte(s):
        if (c === '\u0000') {
          break
        }
        str += c
      }
      return str
    }
    return values
  }

  loadImage.parseExifTag = function (
    dataView,
    tiffOffset,
    offset,
    littleEndian
  ) {
    return {
      number: dataView.getUint16(offset, littleEndian),
      value: loadImage.getExifValue(
        dataView,
        tiffOffset,
        offset,
        dataView.getUint16(offset + 2, littleEndian), // tag type
        dataView.getUint32(offset + 4, littleEndian), // tag length
        littleEndian
      )
    }
  }

  loadImage.parseExifTags = function (
    dataView,
    tiffOffset,
    dirOffset,
    littleEndian,
    data
  ) {
    var tagsNumber, dirEndOffset, i, tagOffset, tag
    if (dirOffset + 6 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory offset.')
      return
    }
    tagsNumber = dataView.getUint16(dirOffset, littleEndian)
    dirEndOffset = dirOffset + 2 + 12 * tagsNumber
    if (dirEndOffset + 4 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid directory size.')
      return
    }
    for (i = 0; i < tagsNumber; i += 1) {
      tagOffset = dirOffset + 2 + 12 * i
      tag = this.parseExifTag(
        dataView,
        tiffOffset,
        tagOffset,
        littleEndian,
        data
      )
      data.exif[tag.number] = tag.value
      if (data.exifOffsets) {
        data.exifOffsets[tag.number] = tagOffset
      }
    }
    // Return the offset to the next directory:
    return dataView.getUint32(dirEndOffset, littleEndian)
  }

  loadImage.parseExifData = function (dataView, offset, length, data, options) {
    if (options.disableExif) {
      return
    }
    var tiffOffset = offset + 10
    var littleEndian
    var dirOffset
    var thumbnailData
    // Check for the ASCII code for "Exif" (0x45786966):
    if (dataView.getUint32(offset + 4) !== 0x45786966) {
      // No Exif data, might be XMP data instead
      return
    }
    if (tiffOffset + 8 > dataView.byteLength) {
      console.log('Invalid Exif data: Invalid segment size.')
      return
    }
    // Check for the two null bytes:
    if (dataView.getUint16(offset + 8) !== 0x0000) {
      console.log('Invalid Exif data: Missing byte alignment offset.')
      return
    }
    // Check the byte alignment:
    switch (dataView.getUint16(tiffOffset)) {
      case 0x4949:
        littleEndian = true
        break
      case 0x4d4d:
        littleEndian = false
        break
      default:
        console.log('Invalid Exif data: Invalid byte alignment marker.')
        return
    }
    // Check for the TIFF tag marker (0x002A):
    if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002a) {
      console.log('Invalid Exif data: Missing TIFF marker.')
      return
    }
    // Retrieve the directory offset bytes, usually 0x00000008 or 8 decimal:
    dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian)
    // Create the exif object to store the tags:
    data.exif = new loadImage.ExifMap()
    if (!options.disableExifOffsets) {
      data.exifOffsets = new loadImage.ExifMap()
      data.exifTiffOffset = tiffOffset
      data.exifLittleEndian = littleEndian
    }
    // Parse the tags of the main image directory and retrieve the
    // offset to the next directory, usually the thumbnail directory:
    dirOffset = loadImage.parseExifTags(
      dataView,
      tiffOffset,
      tiffOffset + dirOffset,
      littleEndian,
      data
    )
    if (dirOffset && !options.disableExifThumbnail) {
      thumbnailData = { exif: {} }
      dirOffset = loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + dirOffset,
        littleEndian,
        thumbnailData
      )
      // Check for JPEG Thumbnail offset:
      if (thumbnailData.exif[0x0201]) {
        data.exif.Thumbnail = loadImage.getExifThumbnail(
          dataView,
          tiffOffset + thumbnailData.exif[0x0201],
          thumbnailData.exif[0x0202] // Thumbnail data length
        )
      }
    }
    // Check for Exif Sub IFD Pointer:
    if (data.exif[0x8769] && !options.disableExifSub) {
      loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + data.exif[0x8769], // directory offset
        littleEndian,
        data
      )
    }
    // Check for GPS Info IFD Pointer:
    if (data.exif[0x8825] && !options.disableExifGps) {
      loadImage.parseExifTags(
        dataView,
        tiffOffset,
        tiffOffset + data.exif[0x8825], // directory offset
        littleEndian,
        data
      )
    }
  }

  // Registers the Exif parser for the APP1 JPEG meta data segment:
  loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData)

  loadImage.exifWriters = {
    // Orientation writer:
    0x0112: function (buffer, data, value) {
      var view = new DataView(buffer, data.exifOffsets[0x0112] + 8, 2)
      view.setUint16(0, value, data.exifLittleEndian)
      return buffer
    }
  }

  loadImage.writeExifData = function (buffer, data, id, value) {
    loadImage.exifWriters[data.exif.map[id]](buffer, data, value)
  }

  // Adds the following properties to the parseMetaData callback data:
  // * exif: The parsed Exif tags
  // * exifOffsets: The parsed Exif tag offsets
  // * exifTiffOffset: TIFF header offset (used for offset pointers)
  // * exifLittleEndian: little endian order if true, big endian if false

  // Adds the following options to the parseMetaData method:
  // * disableExif: Disables Exif parsing.
  // * disableExifThumbnail: Disables parsing of the Exif Thumbnail.
  // * disableExifSub: Disables parsing of the Exif Sub IFD.
  // * disableExifGps: Disables parsing of the Exif GPS Info IFD.
  // * disableExifOffsets: Disables storing Exif tag offsets
})


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Parser
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require, Buffer */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  loadImage.IptcMap = function () {
    return this
  }

  loadImage.IptcMap.prototype.map = {
    ObjectName: 0x5
  }

  loadImage.IptcMap.prototype.get = function (id) {
    return this[id] || this[this.map[id]]
  }

  loadImage.parseIptcTags = function (
    dataView,
    startOffset,
    sectionLength,
    data
  ) {
    /**
     * Retrieves string for the given Buffer and range
     *
     * @param {Buffer} buffer IPTC buffer
     * @param {number} start Range start
     * @param {number} length Range length
     * @returns {string} String value
     */
    function getStringFromDB(buffer, start, length) {
      var outstr = ''
      for (var n = start; n < start + length; n++) {
        outstr += String.fromCharCode(buffer.getUint8(n))
      }
      return outstr
    }
    var fieldValue, dataSize, segmentType
    var segmentStartPos = startOffset
    while (segmentStartPos < startOffset + sectionLength) {
      // we currently handle the 2: class of iptc tag
      if (
        dataView.getUint8(segmentStartPos) === 0x1c &&
        dataView.getUint8(segmentStartPos + 1) === 0x02
      ) {
        segmentType = dataView.getUint8(segmentStartPos + 2)
        // only store data for known tags
        if (segmentType in data.iptc.tags) {
          dataSize = dataView.getInt16(segmentStartPos + 3)
          fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize)
          // Check if we already stored a value with this name
          if (Object.prototype.hasOwnProperty.call(data.iptc, segmentType)) {
            // Value already stored with this name, create multivalue field
            if (data.iptc[segmentType] instanceof Array) {
              data.iptc[segmentType].push(fieldValue)
            } else {
              data.iptc[segmentType] = [data.iptc[segmentType], fieldValue]
            }
          } else {
            data.iptc[segmentType] = fieldValue
          }
        }
      }
      segmentStartPos++
    }
  }

  loadImage.parseIptcData = function (dataView, offset, length, data, options) {
    if (options.disableIptc) {
      return
    }
    var markerLength = offset + length
    // Found '8BIM<EOT><EOT>' ?
    var isFieldSegmentStart = function (dataView, offset) {
      return (
        dataView.getUint32(offset) === 0x3842494d &&
        dataView.getUint16(offset + 4) === 0x0404
      )
    }
    // Hunt forward, looking for the correct IPTC block signature:
    // Reference: https://metacpan.org/pod/distribution/Image-MetaData-JPEG/lib/Image/MetaData/JPEG/Structures.pod#Structure-of-a-Photoshop-style-APP13-segment
    // From https://github.com/exif-js/exif-js/blob/master/exif.js ~ line 474 on
    while (offset + 8 < markerLength) {
      if (isFieldSegmentStart(dataView, offset)) {
        var nameHeaderLength = dataView.getUint8(offset + 7)
        if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1
        // Check for pre photoshop 6 format
        if (nameHeaderLength === 0) {
          // Always 4
          nameHeaderLength = 4
        }
        var startOffset = offset + 8 + nameHeaderLength
        if (startOffset > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment offset.')
          break
        }
        var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength)
        if (offset + sectionLength > markerLength) {
          // eslint-disable-next-line no-console
          console.log('Invalid IPTC data: Invalid segment size.')
          break
        }
        // Create the iptc object to store the tags:
        data.iptc = new loadImage.IptcMap()
        // Parse the tags
        return loadImage.parseIptcTags(
          dataView,
          startOffset,
          sectionLength,
          data
        )
      }
      // eslint-disable-next-line no-param-reassign
      offset++
    }
    // eslint-disable-next-line no-console
    console.log('No IPTC data at this offset - could be XMP')
  }

  // Registers this IPTC parser for the APP13 JPEG meta data segment:
  loadImage.metaDataParsers.jpeg[0xffed].push(loadImage.parseIptcData)

  // Adds the following properties to the parseMetaData callback data:
  // * iptc: The iptc tags, parsed by the parseIptcData method

  // Adds the following options to the parseMetaData method:
  // * disableIptc: Disables IPTC parsing.
})


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();/**
 *
 * @param obj
 * @param objModified
 * @returns {boolean}
 *//* harmony default export */ __webpack_exports__["a"] = (function(obj,objModified){return!Object.entries(objModified).every(function(_ref){var _ref2=_slicedToArray(_ref,2),key=_ref2[0],value=_ref2[1];return obj[key]===value;});});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updateMyState=__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */].gameStateInput.updateMyState;var updateRead=__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */].feedback.updateRead;var TaxItem=(_temp=_class=function(_Component){_inherits(TaxItem,_Component);function TaxItem(props){_classCallCheck(this,TaxItem);var _this=_possibleConstructorReturn(this,(TaxItem.__proto__||Object.getPrototypeOf(TaxItem)).call(this,props));_this.onChange=function(key,value){var cap=_this.props.cap;var capNotification=void 0;if(cap!==undefined){if(value<=cap&&value>0){capNotification=false;}if(value>cap){capNotification=true;}}_this.setState({capNotification:capNotification,sliderValue:value});_this.props.dispatch(updateMyState(_defineProperty({},key,value)));};_this.markAsRead=function(){if(_this.props.notification.reference&&!Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["d" /* checkRead */])(_this.props.notification,false,0,false)){if(_this.props.feedback.all[_this.props.feedback.currentRound].feedback.find(function(c){return c.id===_this.props.notification.reference;}).economie===null){_this.props.dispatch(updateRead(_this.props.notification.reference,{read:true,economie:true}));}else{_this.props.dispatch(updateRead(_this.props.notification.reference,{read:true,economie:false}));}}};_this.state={showDropDown:_this.props.showDropdown,capNotification:false,saving:_this.props.saving};_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(TaxItem,[{key:'componentDidMount',value:function componentDidMount(){if(this.props.gameState.difficulty==='BASIC'){this.markAsRead();}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(props.sliderValue>props.cap){this.setState({capNotification:true});}if(this.props.feedbackData.show!==props.feedbackData.show){this.setState({showDropDown:false});}if(props.saving!==this.state.saving){if(props.saving){this.setState({saving:props.saving});__WEBPACK_IMPORTED_MODULE_7__history__["a" /* default */].push('/taxes/');}else{this.setState({saving:props.saving});}}}},{key:'render',value:function render(){var _this2=this;var props=this.props,state=this.state;if(this.props.gameState.difficulty==='BASIC'){this.markAsRead();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:this.props.showDropdown?'show':''},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* Link */],{to:this.props.showDropdown?'/taxes':'/taxes/'+props.popupId.substring(5)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{className:' '+(props.selected?'selected':'')+' '+(props.showDropdown?'show':''),onClick:function onClick(){if(props.feedbackData.show){_this2.markAsRead();}if(props.registerShown){props.registerShown();}_this2.setState({showDropDown:!state.showDropDown});},feedbackCount:props.notification.read&&!Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["d" /* checkRead */])(props.notification,false,0,false)?1:0,bgColor:'white',title:props.title,icon:props.icon,reverseGlobasPoints:props.reverseGlobasPoints,arrow:true,bigArrow:true,globas:props.globas,points:props.points})));}}]);return TaxItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notification:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,globas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,points:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,feedbackData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),dataList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,minValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,maxValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,sliderValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,collaborationValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,sliderKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,collaborationKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notificationReference:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,reverseGlobasPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,saving:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,selected:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={onChange:function onChange(){},reverseGlobasPoints:true,title:'title',icon:'',globas:0,points:0,dataList:[],minValue:0,maxValue:999,sliderKey:'slider',collaborationKey:'collaboration',feedbackData:{},notificationReference:'',notification:{},saving:false,selected:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return state;})(TaxItem));

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_StepThree_BudgetSlider__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_StepThree_BudgetCollaboration__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_feedback_FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_feedback_FeedbackEffect__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_arrowTax_png__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_arrowTax_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_img_arrowTax_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _actions$gameStateInp=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].gameStateInput,updateMyState=_actions$gameStateInp.updateMyState,submitMyState=_actions$gameStateInp.submitMyState;var TaxItem=(_temp=_class=function(_Component){_inherits(TaxItem,_Component);function TaxItem(props){_classCallCheck(this,TaxItem);var _this=_possibleConstructorReturn(this,(TaxItem.__proto__||Object.getPrototypeOf(TaxItem)).call(this,props));_initialiseProps.call(_this);_this.state={capNotification:props.sliderValue>props.cap,showSavePopup:false};_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(TaxItem,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(props.sliderValue>props.cap){this.setState({capNotification:true});}if(this.props.feedbackData.show!==props.feedbackData.show){this.setState({showDropDown:false});}}},{key:'render',value:function render(){var _this2=this;var props=this.props;var buttonConditions=props.gameStateInput.myState.arbeidsBelasting>=1&&props.gameStateInput.myState.arbeidsBelasting<=79;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'main-tax-container'+(this.props.showDropdown||props.feedbackData.show?' show':'')},this.props.showDropdown&&!props.feedbackData.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'small-tax'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:this.props.icon}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_PopupTitle__["a" /* default */],{customClass:'popup-heading',popupId:props.popupId,tag:'h4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_GoBackButton__["a" /* default */],{history:this.props.history})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'+(this.props.showDropdown&&!props.feedbackData.show?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),props.dataList.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'taxes-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.title,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:item.globas},item.globas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_miljard'))));}),props.taxDescription?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'description'},props.taxDescription):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'}),props.sliderTitles!==undefined?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-titles'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.sliderTitles[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.sliderTitles[1])):null,props.type==='taxSlider'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_gekozenbelastingpercentage'),' (',props.minValue,'-',props.cap,'%)')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_StepThree_BudgetSlider__["a" /* default */],{role:this.props.user.role,customOnChange:this.onChange,onAfterChange:this.onAfterChange,onChangeKey:props.sliderKey,twoValueSlider:props.twoValueSlider,value:props.sliderValue,min:props.minValue,unit:props.unit,suffix:props.suffix,max:props.maxValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-element content-container taxes-slider-warning '+(this.state.capNotification?'show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_warning_svg___default.a,alt:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:props.capNotification}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'}),props.project.difficulty==='BASIC'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'savebutton-container'},!(props.gameStateInput.myState.SIMULATION_TAX==='PROCESSED'&&props.gameStateInput.myState.SIMULATION_TAX_2==='PROCESSED')&&props.user.role==='groupleader'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){ev.preventDefault();_this2.setState({showSavePopup:true});},className:'button'+(buttonConditions&&!props.gameStateInput.preventInputChanges?'':' disabled')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_opslaan'))):null,this.state.showSavePopup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopUp__["a" /* default */],{id:'dlgmstap3opslaan_1',closePopUpClick:function closePopUpClick(res){_this2.closeSavePopup(res);}}):null):null,this.props.project.difficulty==='PRO'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_StepThree_BudgetCollaboration__["a" /* default */],{value:props.collaborationValue,customOnChange:this.onChange,onChangeKey:props.collaborationKey,title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')+':'}):null)):'',this.props.showDropdown&&props.feedbackData.show?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-container-taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:this.props.icon}),this.props.ignorePopup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,this.props.title):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_PopupTitle__["a" /* default */],{customClass:'popup-heading',popupId:props.popupId,tag:'h4'}),this.props.project.difficulty==='BASIC'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',{className:'percentage'},Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_tarief'),': ',props.sliderValue,'%'):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'point-holder reverse'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:props.points},props.points),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_punten')},Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:props.globas},props.globas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_GoBackButton__["a" /* default */],{history:this.props.history})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-content-row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-content-box'},props.feedbackData.topData.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container show taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),this.renderDetails(props.feedbackData.topData)):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_feedback_FeedbackImage__["a" /* default */],{descriptionAbsolute:true,image:props.feedbackData.img,description:props.feedbackData.imgDescription})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbackText taxes-content-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container show taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:props.feedbackData.description}})))),props.feedbackData.effects.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-container feedbackdata-effects taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-container-half'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-header-wrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-header-inner'},Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belastingkeuze_heeft_effect_op'),':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'edge-element'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_13__assets_img_arrowTax_png___default.a,alt:''}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-message'},Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_zie_deze_effecten_volgende_spelronden'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-container-half'},props.feedbackData.effects.map(function(effect,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_feedback_FeedbackEffect__["a" /* default */],{key:i,minimal:true,ministry:effect.title,ministryIcon:effect.icon,description:'Onderschrift',unit:effect.contentUnit,points:effect.contentTitle});}))):null):null);}}]);return TaxItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notification:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,globas:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,points:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,feedbackData:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}),dataList:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,minValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,maxValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,sliderValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,collaborationValue:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,sliderKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,collaborationKey:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,notificationReference:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,reverseGlobasPoints:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,ignorePopup:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={onChange:function onChange(){},reverseGlobasPoints:true,title:'title',icon:'',globas:0,points:0,dataList:[],minValue:0,maxValue:999,sliderKey:'slider',collaborationKey:'collaboration',feedbackData:{},notificationReference:'',notification:{},ignorePopup:false},_initialiseProps=function _initialiseProps(){var _this3=this;this.onChange=function(key,value){var cap=_this3.props.cap;var capNotification=void 0;if(cap!==undefined){if(value<=cap&&value>0){capNotification=false;}if(value>cap){capNotification=true;}}_this3.setState({capNotification:capNotification,sliderValue:value});_this3.props.dispatch(updateMyState(_defineProperty({},key,value)));};this.renderDetails=function(data){var props=_this3.props;var dataList=data;var colIndex=dataList.findIndex(function(item){return item.title==='Samenwerking met andere landen'||item.title===Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden');});// Sort all groups to correct order
if(colIndex!==-1&&dataList[colIndex].value.length){var arr=dataList[colIndex].value;if(arr[0].props.src>arr[arr.length-1].props.src){dataList[colIndex].value=dataList[colIndex].value.sort(function(a,b){var nameA=a.props.src.toLowerCase(),nameB=b.props.src.toLowerCase();if(nameA<nameB)return-1;if(nameA>nameB)return 1;return 0;});}}return dataList.map(function(item,topDataIndex){if(item.hideWhenZero){var val=parseInt(item.value.split(' ')[0],10);if(isNaN(val)||val===0)return'';}if(Array.isArray(item.value)&&!item.value.length){item.value='-';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:topDataIndex},props.feedbackData.topData.length-1===topDataIndex?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'topdata-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.value)));});};this.closeSavePopup=function(res){if(res){var props=_this3.props;var buttonConditions=props.gameStateInput.myState.arbeidsBelasting>=1&&props.gameStateInput.myState.arbeidsBelasting<=79;if(buttonConditions&&props.user.role==='groupleader'&&!props.gameStateInput.preventInputChanges){props.dispatch(submitMyState('SIMULATION_TAX'));}}_this3.setState({showSavePopup:false});};},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return state;})(TaxItem));

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_left_pad__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_left_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_left_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apiCall__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GameDetails=(_temp=_class=function(_Component){_inherits(GameDetails,_Component);function GameDetails(props){var _this2=this;_classCallCheck(this,GameDetails);var _this=_possibleConstructorReturn(this,(GameDetails.__proto__||Object.getPrototypeOf(GameDetails)).call(this,props));_this.fetchData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(projectId){var _ref2,studentCount,_ref3,schoolClassCount;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return Object(__WEBPACK_IMPORTED_MODULE_6__apiCall__["a" /* default */])('/project/'+projectId+'/countStudents');case 2:_ref2=_context.sent;studentCount=_ref2.count;_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_6__apiCall__["a" /* default */])('/project/'+projectId+'/countSchoolClasses');case 6:_ref3=_context.sent;schoolClassCount=_ref3.count;_this.setState({studentCount:studentCount,schoolClassCount:schoolClassCount});case 9:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state={studentCount:0,schoolClassCount:0};return _this;}_createClass(GameDetails,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextContext){if(this.props.project.id!==nextProps.project.id){this.fetchData(nextProps.project.id);}}},{key:'componentWillMount',value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:this.fetchData(this.props.project.id);case 1:case'end':return _context2.stop();}}},_callee2,this);}));function componentWillMount(){return _ref4.apply(this,arguments);}return componentWillMount;}()},{key:'render',value:function render(){var project=this.props.project;var _state=this.state,schoolClassCount=_state.schoolClassCount,studentCount=_state.studentCount;var inputFromDate=project.dateStart?project.dateStart:0;var inputToDate=project.dateEnd?project.dateEnd:0;var fromDate=new Date(inputFromDate);var fromDatesString=__WEBPACK_IMPORTED_MODULE_4_left_pad___default()(fromDate.getDate(),2,0)+'.'+__WEBPACK_IMPORTED_MODULE_4_left_pad___default()(fromDate.getMonth()+1,2,0)+'.'+fromDate.getFullYear();var toDate=new Date(inputToDate);var toDateString=__WEBPACK_IMPORTED_MODULE_4_left_pad___default()(toDate.getDate(),2,0)+'.'+__WEBPACK_IMPORTED_MODULE_4_left_pad___default()(toDate.getMonth()+1,2,0)+'.'+toDate.getFullYear();return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'gameDetails '+this.props.color},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'dates'},fromDatesString,' - ',toDateString),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'numbers'},schoolClassCount,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["b" /* __n */])('sim_klas',schoolClassCount>1?2:1),' | ',studentCount,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["b" /* __n */])('sim_leerling',studentCount>1?2:1)));}}]);return GameDetails;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={color:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{project:state.project};})(GameDetails));

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(370);
module.exports = __webpack_require__(375);


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(371).enable();
  window.Promise = __webpack_require__(373);
}

// fetch() polyfill for making API calls.
__webpack_require__(374);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(98);


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(187);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(187);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 374 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fastclick__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyfills__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__history_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_disableTouchScroll__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_disableTouchScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__helpers_disableTouchScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lang__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_main_scss__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_css_main_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_css_main_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_auth__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_routes_Home__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_routes_Economy__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_routes_EconomyOverview__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_routes_Login__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_routes_Ministries__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_routes_Ministry__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_routes_MinistryBudget__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_routes_FeedbackOverview__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_routes_Feedback__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_routes_Taxes__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_routes_Bank__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_routes_Verdienen__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_routes_Verdelen__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_routes_Beleidskeuzes__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_routes_Prepare__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_routes_GameInfo__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_routes_GamePage__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_routes_Vimeo__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_routes_Drive__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_routes_Video__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_routes_Audio__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_routes_Password__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_routes_GroupPortalHome__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_routes_ClassLeaderPortalHome__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_portalRedirect__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_routes_TeamInfo__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_routes_Rankings__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_routes_BonusPoints__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_routes_ClassBonusPoints__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_routes_ClassLeaderMedia__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_elements_StepThree_BudgetHeader__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_elements_TopBar__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_elements_PopupContainer__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_elements_ToggleFullscreen__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_elements_HideDesktopMobileContents__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_routes_Desktop__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_desktop_Feedback__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_desktop_Taxes__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_desktop_TaxesMain__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_desktop_MinistryBudget__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_desktop_Beleidskeuzes__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_desktop_GroupPortalHome__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_desktop_TeamInfo__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_desktop_SchoolPortalHome__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_desktop_SchoolPortalClass__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_desktop_SchoolPortalTest__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_desktop_SchoolPortalMedia__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_routes_PreparePublic__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_routes_EscapeRoute__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_elements_Loading__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_glxl_helpers__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var desktop=document.querySelector('#root').clientWidth>=1240;if('addEventListener'in document){document.addEventListener('DOMContentLoaded',function(){__WEBPACK_IMPORTED_MODULE_5_fastclick___default.a.attach(document.body);},false);}var App=function(_React$Component){_inherits(App,_React$Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.state={isLoading:true};return _this;}_createClass(App,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.location.pathname!==prevProps.location.pathname){sessionStorage.setItem('prevLocation',prevProps.location.pathname);}}},{key:'componentWillUnmount',value:function componentWillUnmount(){if(window.socket&&window.socket.close){window.socket.close();window.socket=null;}if(window.timerId){clearTimeout(window.timerId);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(props.location.pathname!==this.prevPath){window.scrollTo(0,0);}this.prevPath=props.location.pathname;}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this;var dontRedirect=window.location.pathname.startsWith('/portal/school/voorbereiding')||window.location.pathname.startsWith('/portal/password');window.onmessage=function(e){if(['schoolcontact','classleader'].includes(e.data)&&!(sessionStorage.getItem('noMobile')==='true')){sessionStorage.setItem('noMobile','true');if(!dontRedirect){if(e.data==='schoolcontact'){__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */].push('/portal/school');}else if(e.data==='classleader'){__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */].push('/portal/classleader');}}_this2.setState({schoolcontact:true});}if(['groupmember'].includes(e.data)&&!(sessionStorage.getItem('noMobile')==='false')){if(__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */].location.pathname.indexOf('teaminfo')===-1){sessionStorage.setItem('noMobile','false');if(!dontRedirect){__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */].push('/');}}}if(['groupmember-leader'].includes(e.data)&&!(sessionStorage.getItem('noMobile')==='false')){var redirect=sessionStorage.getItem('redirect');if(redirect){sessionStorage.setItem('noMobile','true');sessionStorage.removeItem('redirect');if(!dontRedirect){console.log("REDIRECTING TO ",redirect);__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */].push(redirect);}}}};this.setState({isLoading:false});}},{key:'renderDesktop',value:function renderDesktop(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-content desktop'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/login',component:__WEBPACK_IMPORTED_MODULE_18__components_routes_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/blank',component:function component(){return null;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{render:function render(_ref){var location=_ref.location;return location.pathname.match(/(\/login|\/portal|\/escaperoute)/)?'':__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_45__components_elements_Header__["a" /* default */],['groupleader','groupmember'],null,{"desktop":true})});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{render:function render(_ref2){var location=_ref2.location;if(location.pathname.startsWith('/portal/school/voorbereiding'))return null;if(location.pathname.startsWith('/portal/vimeo'))return null;if(location.pathname.startsWith('/portal/drive'))return null;if(location.pathname.startsWith('/portal/video'))return null;if(location.pathname.startsWith('/portal/audio'))return null;if(location.pathname.startsWith('/portal/password'))return null;return location.pathname.indexOf('portal')!==-1||location.pathname.indexOf('escaperoute')!==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_47__components_elements_TopBar__["a" /* default */],['groupleader','groupmember','classleader'],null,{"desktop":true})}):'';}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/escaperoute',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_65__components_routes_EscapeRoute__["a" /* default */],['groupleader','groupmember','classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_39__components_portalRedirect__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_38__components_routes_ClassLeaderPortalHome__["a" /* default */],['classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/verdelen',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_27__components_routes_Verdelen__["a" /* default */],['classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/prepare',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_29__components_routes_Prepare__["a" /* default */],['classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/prepare/:startup',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_29__components_routes_Prepare__["a" /* default */],['classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/teaminfo/:groupId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_59__components_desktop_TeamInfo__["a" /* default */],['classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/verdienen/:gameId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_26__components_routes_Verdienen__["a" /* default */],['classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/classleader/media',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_44__components_routes_ClassLeaderMedia__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/bonuspoints',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_42__components_routes_BonusPoints__["a" /* default */],['classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/vimeo/:vimeoId',component:__WEBPACK_IMPORTED_MODULE_32__components_routes_Vimeo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/drive',component:__WEBPACK_IMPORTED_MODULE_33__components_routes_Drive__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/video/:videoId',component:__WEBPACK_IMPORTED_MODULE_34__components_routes_Video__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/audio/:audioId',component:__WEBPACK_IMPORTED_MODULE_35__components_routes_Audio__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/password/:generalMaterialId',component:function component(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_36__components_routes_Password__["a" /* default */],Object.assign({},props,{desktop:true}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/group',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_58__components_desktop_GroupPortalHome__["a" /* default */],['groupleader','groupmember'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/gameinfo/:gameid',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_30__components_routes_GameInfo__["a" /* default */],['groupleader','groupmember'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/game/:gameid',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_31__components_routes_GamePage__["a" /* default */],['groupleader','groupmember'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/teaminfo',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_59__components_desktop_TeamInfo__["a" /* default */],['groupleader','groupmember'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/bonuspoints',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_43__components_routes_ClassBonusPoints__["a" /* default */],['groupleader','groupmember'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_60__components_desktop_SchoolPortalHome__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/class/:action',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_61__components_desktop_SchoolPortalClass__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/test',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_62__components_desktop_SchoolPortalTest__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/media/:projectId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_63__components_desktop_SchoolPortalMedia__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/prepare',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_29__components_routes_Prepare__["a" /* default */],['schoolcontact'],null,{"desktop":true,"schoolcontact":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/voorbereiding/:projectId/:languageId?/:difficultyId?',component:__WEBPACK_IMPORTED_MODULE_64__components_routes_PreparePublic__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/rankings/:projectId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_41__components_routes_Rankings__["a" /* default */],['groupleader','groupmember','classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/rankings/:projectId/:schoolClassId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_41__components_routes_Rankings__["a" /* default */],['groupleader','groupmember','classleader'],null,{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{render:function render(_ref3){var location=_ref3.location;if(location.pathname.startsWith('/portal')){document.body.classList.add('portalPage');}else{document.body.classList.remove('portalPage');}if(location.pathname.startsWith('/portal'))return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktopcontainer '+(location.pathname.startsWith('/taxes')?'taxes-main-container':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'split-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/(|ministries|bank)/',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_46__components_elements_StepThree_BudgetHeader__["a" /* default */],['groupleader','groupmember'],[3],{"desktop":true,"redirect":false})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/budget/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_46__components_elements_StepThree_BudgetHeader__["a" /* default */],['groupleader','groupmember'],[3],{"desktop":true,"redirect":false})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_46__components_elements_StepThree_BudgetHeader__["a" /* default */],['groupleader','groupmember'],[3],{"desktop":true,"redirect":false})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes/:beleidskeuze?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_46__components_elements_StepThree_BudgetHeader__["a" /* default */],['groupleader','groupmember'],[3],{"desktop":true,"redirect":false})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scrollbars_custom___default.a,{noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/economy/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/(|ministries|bank)/',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/overview/:type',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/budget/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes/:beleidskeuze?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes/:id/:feedbackIdentifier',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_52__components_desktop_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/taxes/:taxid?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_54__components_desktop_Taxes__["a" /* default */],['groupleader','groupmember'],[2],{"desktop":true})}))),!_this3.state.isLoading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fullscreen-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_49__components_elements_ToggleFullscreen__["a" /* default */],null)):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/economy/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_51__components_routes_Desktop__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/(|ministries)/',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_51__components_routes_Desktop__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_51__components_routes_Desktop__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/overview/basic/:type/:identifier?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_53__components_desktop_Feedback__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/overview/:type',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_51__components_routes_Desktop__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/budget/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_56__components_desktop_MinistryBudget__["a" /* default */],['groupleader','groupmember'],[3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_53__components_desktop_Feedback__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_51__components_routes_Desktop__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes/:beleidskeuze',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_57__components_desktop_Beleidskeuzes__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes/:id/:feedbackIdentifier',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_53__components_desktop_Feedback__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/taxes',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_51__components_routes_Desktop__["a" /* default */],['groupleader','groupmember'],[2],{"desktop":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/taxes/:taxid',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_55__components_desktop_TaxesMain__["a" /* default */],['groupleader','groupmember'],[2])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:"/bank",component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_25__components_routes_Bank__["a" /* default */],['groupleader','groupmember'],[3],{"desktop":true})})))));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__components_elements_PopupContainer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__components_elements_HideDesktopMobileContents__["a" /* default */],null));}},{key:'renderMobile',value:function renderMobile(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'page-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{render:function render(_ref4){var location=_ref4.location;if(location.pathname.startsWith('/portal'))document.body.classList.add('portalPage');if(location.pathname.startsWith('/login')){return null;}if(location.pathname.startsWith('/portal/video')){return null;}if(location.pathname.startsWith('/portal/vimeo')){return null;}if(location.pathname.startsWith('/portal/drive')){return null;}if(location.pathname.startsWith('/portal/audio')){return null;}if(location.pathname.startsWith('/portal/password')){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_47__components_elements_TopBar__["a" /* default */],null);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/login',component:__WEBPACK_IMPORTED_MODULE_18__components_routes_Login__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/blank',component:function component(){return null;}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__components_routes_Home__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/escaperoute',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_65__components_routes_EscapeRoute__["a" /* default */],['groupleader','groupmember','classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/economy',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_17__components_routes_EconomyOverview__["a" /* default */],['groupleader','groupmember'],[1,2,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_19__components_routes_Ministries__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_20__components_routes_Ministry__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/overview/:type/:id?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_22__components_routes_FeedbackOverview__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/overview/:type/:id/:feedbackIdentifier',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_23__components_routes_Feedback__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/budget/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_21__components_routes_MinistryBudget__["a" /* default */],['groupleader','groupmember'],[3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/ministries/:id/:feedbackIdentifier/:effect?/:ministryId?',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_23__components_routes_Feedback__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/economy/:id',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__components_routes_Economy__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/taxes',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_24__components_routes_Taxes__["a" /* default */],['groupleader','groupmember'],[2])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/taxes/:taxid',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_24__components_routes_Taxes__["a" /* default */],['groupleader','groupmember'],[2])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/bank',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_25__components_routes_Bank__["a" /* default */],['groupleader','groupmember'],[3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_28__components_routes_Beleidskeuzes__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/beleidskeuzes/:id/:feedbackIdentifier',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_23__components_routes_Feedback__["a" /* default */],['groupleader','groupmember'],[1,3])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_39__components_portalRedirect__["a" /* default */])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/group',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_37__components_routes_GroupPortalHome__["a" /* default */],['groupleader','groupmember'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/gameinfo/:gameid',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_30__components_routes_GameInfo__["a" /* default */],['groupleader','groupmember'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/game/:gameid',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_31__components_routes_GamePage__["a" /* default */],['groupleader','groupmember'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/teaminfo',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_40__components_routes_TeamInfo__["a" /* default */],['groupleader','groupmember'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/bonuspoints',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_43__components_routes_ClassBonusPoints__["a" /* default */],['groupleader','groupmember'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_38__components_routes_ClassLeaderPortalHome__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/teaminfo/:groupId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_40__components_routes_TeamInfo__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/verdienen/:gameId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_26__components_routes_Verdienen__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/verdelen',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_27__components_routes_Verdelen__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/prepare',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_29__components_routes_Prepare__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/classleader/prepare/:startup',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_29__components_routes_Prepare__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_60__components_desktop_SchoolPortalHome__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/class/:action',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_61__components_desktop_SchoolPortalClass__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/test',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_62__components_desktop_SchoolPortalTest__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/media/:projectId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_63__components_desktop_SchoolPortalMedia__["a" /* default */],['schoolcontact'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/prepare',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_29__components_routes_Prepare__["a" /* default */],['schoolcontact'],null,{"schoolcontact":true})}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/school/voorbereiding/:projectId/:languageId?/:difficultyId?',component:__WEBPACK_IMPORTED_MODULE_64__components_routes_PreparePublic__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/vimeo/:vimeoId',component:__WEBPACK_IMPORTED_MODULE_32__components_routes_Vimeo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/drive/',component:__WEBPACK_IMPORTED_MODULE_33__components_routes_Drive__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/video/:videoId',component:__WEBPACK_IMPORTED_MODULE_34__components_routes_Video__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/audio/:audioId',component:__WEBPACK_IMPORTED_MODULE_35__components_routes_Audio__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/password/:generalMaterialId',component:__WEBPACK_IMPORTED_MODULE_36__components_routes_Password__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/classleader/bonuspoints',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_42__components_routes_BonusPoints__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{path:'/portal/classleader/media',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_44__components_routes_ClassLeaderMedia__["a" /* default */],['classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/rankings/:projectId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_41__components_routes_Rankings__["a" /* default */],['groupleader','groupmember','classleader'])}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["c" /* Route */],{exact:true,path:'/portal/rankings/:projectId/:schoolClassId',component:Object(__WEBPACK_IMPORTED_MODULE_14__components_auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_41__components_routes_Rankings__["a" /* default */],['groupleader','groupmember','classleader'])})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_50__components_elements_HideDesktopMobileContents__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_48__components_elements_PopupContainer__["a" /* default */],null));}},{key:'render',value:function render(){var redirect=new URL(window.location);redirect=redirect.searchParams.get('redirect');if(redirect&&redirect.length>0){sessionStorage.setItem('redirect',redirect);}if(this.state.isLoading){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_66__components_elements_Loading__["a" /* default */],null);}if(desktop){if(__WEBPACK_IMPORTED_MODULE_9__config___default.a.disableDesktop==='true'&&!(sessionStorage.getItem('noMobile')==='true')){document.body.classList.add('desktopDisabled');var alternatePath=this.props.location.pathname+this.props.location.search;if(__WEBPACK_IMPORTED_MODULE_67_glxl_helpers__["cookie"].getCookie('token')||alternatePath!=='/'&&alternatePath!=='/login'){var path='/';if(alternatePath.indexOf('token')>-1){path=alternatePath;}else if(__WEBPACK_IMPORTED_MODULE_67_glxl_helpers__["cookie"].getCookie('token')&&__WEBPACK_IMPORTED_MODULE_67_glxl_helpers__["cookie"].getCookie('token')!==false){path='/';}else{path=alternatePath;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'fakePhone'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'phone-frame'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'simulatiespel',id:'foo',className:'desktopDisabled',src:path,height:'700',width:'417'})));}}return this.renderDesktop();}else{if(window.top.document.querySelector('html').offsetWidth>1280){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scrollbars_custom___default.a,{noScrollX:true,style:{width:'100%',height:'100%',minHeight:'100vh'}},this.renderMobile());}return this.renderMobile();}}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var AppRoute=Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* withRouter */])(App);Promise.all([__WEBPACK_IMPORTED_MODULE_10__lang__["a" /* default */].init,__WEBPACK_IMPORTED_MODULE_11__Defines__["a" /* default */].fetch()]).then(function(){__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Router */],{history:__WEBPACK_IMPORTED_MODULE_7__history_js__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AppRoute,null))),document.getElementById('root'));});

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(98),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(135);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _setPrototypeOf; });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(380);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _assertThisInitialized; });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(191);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(193);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _objectSpread2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(388);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _defineProperty; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(389);

function _defineProperty(e, r, t) {
  return (r = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPropertyKey; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(390);


function toPropertyKey(t) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(t, "string");
  return "symbol" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i) ? i : i + "";
}


/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toPrimitive; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(192);

function toPrimitive(t, r) {
  if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(193);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(194);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(395);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(135);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(98),r=__webpack_require__(397);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(398);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(i){if(t[i])return t[i].exports;var n=t[i]={i:i,l:!1,exports:{}};return e[i].call(n.exports,n,n.exports,r),n.l=!0,n.exports}return r.m=e,r.c=t,r.d=function(e,t,i){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:i})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var i=Object.create(null);if(r.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)r.d(i,n,function(t){return e[t]}.bind(null,n));return i},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i=r(18),n=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));t.push(0);var r=t[0],i=t[1];if(10===r)switch(i){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}switch(r){case 11:return"Big Sur";case 12:return"Monterey";case 13:return"Ventura";case 14:return"Sonoma";case 15:return"Sequoia";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,i){void 0===i&&(i=!1);var n=e.getVersionPrecision(t),a=e.getVersionPrecision(r),o=Math.max(n,a),s=0,u=e.map([t,r],(function(t){var r=o-e.getVersionPrecision(t),i=t+new Array(r+1).join(".0");return e.map(i.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(i&&(s=o-Math.min(n,a)),o-=1;o>=s;){if(u[0][o]>u[1][o])return 1;if(u[0][o]===u[1][o]){if(o===s)return 0;o-=1}else if(u[0][o]<u[1][o])return-1}},e.map=function(e,t){var r,i=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)i.push(t(e[r]));return i},e.find=function(e,t){var r,i;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,i=e.length;r<i;r+=1){var n=e[r];if(t(n,r))return n}},e.assign=function(e){for(var t,r,i=e,n=arguments.length,a=new Array(n>1?n-1:0),o=1;o<n;o++)a[o-1]=arguments[o];if(Object.assign)return Object.assign.apply(Object,[e].concat(a));var s=function(){var e=a[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){i[t]=e[t]}))};for(t=0,r=a.length;t<r;t+=1)s();return e},e.getBrowserAlias=function(e){return i.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return i.BROWSER_MAP[e]||""},e}();t.default=n,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={AmazonBot:"amazonbot","Amazon Silk":"amazon_silk","Android Browser":"android",BaiduSpider:"baiduspider",Bada:"bada",BingCrawler:"bingcrawler",Brave:"brave",BlackBerry:"blackberry","ChatGPT-User":"chatgpt_user",Chrome:"chrome",ClaudeBot:"claudebot",Chromium:"chromium",Diffbot:"diffbot",DuckDuckBot:"duckduckbot",DuckDuckGo:"duckduckgo",Electron:"electron",Epiphany:"epiphany",FacebookExternalHit:"facebookexternalhit",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot",GPTBot:"gptbot","Internet Explorer":"ie",InternetArchiveCrawler:"internetarchivecrawler","K-Meleon":"k_meleon",LibreWolf:"librewolf",Linespider:"linespider",Maxthon:"maxthon","Meta-ExternalAds":"meta_externalads","Meta-ExternalAgent":"meta_externalagent","Meta-ExternalFetcher":"meta_externalfetcher","Meta-WebIndexer":"meta_webindexer","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver","OAI-SearchBot":"oai_searchbot",Omgilibot:"omgilibot",Opera:"opera","Opera Coast":"opera_coast","Pale Moon":"pale_moon",PerplexityBot:"perplexitybot","Perplexity-User":"perplexity_user",PhantomJS:"phantomjs",PingdomBot:"pingdombot",Puffin:"puffin",QQ:"qq",QQLite:"qqlite",QupZilla:"qupzilla",Roku:"roku",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SlackBot:"slackbot",SeaMonkey:"seamonkey",Sleipnir:"sleipnir","Sogou Browser":"sogou",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat",YahooSlurp:"yahooslurp","Yandex Browser":"yandex",YandexBot:"yandexbot",YouBot:"youbot"};t.BROWSER_MAP={amazonbot:"AmazonBot",amazon_silk:"Amazon Silk",android:"Android Browser",baiduspider:"BaiduSpider",bada:"Bada",bingcrawler:"BingCrawler",blackberry:"BlackBerry",brave:"Brave",chatgpt_user:"ChatGPT-User",chrome:"Chrome",claudebot:"ClaudeBot",chromium:"Chromium",diffbot:"Diffbot",duckduckbot:"DuckDuckBot",duckduckgo:"DuckDuckGo",edge:"Microsoft Edge",electron:"Electron",epiphany:"Epiphany",facebookexternalhit:"FacebookExternalHit",firefox:"Firefox",focus:"Focus",generic:"Generic",google_search:"Google Search",googlebot:"Googlebot",gptbot:"GPTBot",ie:"Internet Explorer",internetarchivecrawler:"InternetArchiveCrawler",k_meleon:"K-Meleon",librewolf:"LibreWolf",linespider:"Linespider",maxthon:"Maxthon",meta_externalads:"Meta-ExternalAds",meta_externalagent:"Meta-ExternalAgent",meta_externalfetcher:"Meta-ExternalFetcher",meta_webindexer:"Meta-WebIndexer",mz:"MZ Browser",naver:"NAVER Whale Browser",oai_searchbot:"OAI-SearchBot",omgilibot:"Omgilibot",opera:"Opera",opera_coast:"Opera Coast",pale_moon:"Pale Moon",perplexitybot:"PerplexityBot",perplexity_user:"Perplexity-User",phantomjs:"PhantomJS",pingdombot:"PingdomBot",puffin:"Puffin",qq:"QQ Browser",qqlite:"QQ Browser Lite",qupzilla:"QupZilla",roku:"Roku",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",slackbot:"SlackBot",sleipnir:"Sleipnir",sogou:"Sogou Browser",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yahooslurp:"YahooSlurp",yandex:"Yandex Browser",yandexbot:"YandexBot",youbot:"YouBot"};t.PLATFORMS_MAP={bot:"bot",desktop:"desktop",mobile:"mobile",tablet:"tablet",tv:"tv"};t.OS_MAP={Android:"Android",Bada:"Bada",BlackBerry:"BlackBerry",ChromeOS:"Chrome OS",HarmonyOS:"HarmonyOS",iOS:"iOS",Linux:"Linux",MacOS:"macOS",PlayStation4:"PlayStation 4",Roku:"Roku",Tizen:"Tizen",WebOS:"WebOS",Windows:"Windows",WindowsPhone:"Windows Phone"};t.ENGINE_MAP={Blink:"Blink",EdgeHTML:"EdgeHTML",Gecko:"Gecko",Presto:"Presto",Trident:"Trident",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(91))&&i.__esModule?i:{default:i},a=r(18);function o(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||!1,i.configurable=!0,"value"in i&&(i.writable=!0),Object.defineProperty(e,i.key,i)}}var s=function(){function e(){}var t,r,i;return e.getParser=function(e,t,r){if(void 0===t&&(t=!1),void 0===r&&(r=null),"string"!=typeof e)throw new Error("UserAgent should be a string");return new n.default(e,t,r)},e.parse=function(e,t){return void 0===t&&(t=null),new n.default(e,t).getResult()},t=e,i=[{key:"BROWSER_MAP",get:function(){return a.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return a.ENGINE_MAP}},{key:"OS_MAP",get:function(){return a.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return a.PLATFORMS_MAP}}],(r=null)&&o(t.prototype,r),i&&o(t,i),e}();t.default=s,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i=u(r(92)),n=u(r(93)),a=u(r(94)),o=u(r(95)),s=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t,r){if(void 0===t&&(t=!1),void 0===r&&(r=null),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e;var i=!1;"boolean"==typeof t?(i=t,this._hints=r):this._hints=null!=t&&"object"==typeof t?t:null,this.parsedResult={},!0!==i&&this.parse()}var t=e.prototype;return t.getHints=function(){return this._hints},t.hasBrand=function(e){if(!this._hints||!Array.isArray(this._hints.brands))return!1;var t=e.toLowerCase();return this._hints.brands.some((function(e){return e.brand&&e.brand.toLowerCase()===t}))},t.getBrandVersion=function(e){if(this._hints&&Array.isArray(this._hints.brands)){var t=e.toLowerCase(),r=this._hints.brands.find((function(e){return e.brand&&e.brand.toLowerCase()===t}));return r?r.version:void 0}},t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=s.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(Array.isArray(t.test))return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA(),this)),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=s.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(Array.isArray(t.test))return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=s.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(Array.isArray(t.test))return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=s.default.find(o.default,(function(t){if("function"==typeof t.test)return t.test(e);if(Array.isArray(t.test))return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return s.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},i=0,n={},a=0;if(Object.keys(e).forEach((function(t){var o=e[t];"string"==typeof o?(n[t]=o,a+=1):"object"==typeof o&&(r[t]=o,i+=1)})),i>0){var o=Object.keys(r),u=s.default.find(o,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=s.default.find(o,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(a>0){var l=Object.keys(n),b=s.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==b)return this.compareVersion(n[b])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),i=e.toLowerCase(),n=s.default.getBrowserTypeByAlias(i);return t&&n&&(i=n.toLowerCase()),i===r},t.compareVersion=function(e){var t=[0],r=e,i=!1,n=this.getBrowserVersion();if("string"==typeof n)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(i=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(i=!0,r=e.substr(1)),t.indexOf(s.default.compareVersions(n,r,i))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i};var a=/version\/(\d+(\.?_?\d+)+)/i,o=[{test:[/gptbot/i],describe:function(e){var t={name:"GPTBot"},r=n.default.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/chatgpt-user/i],describe:function(e){var t={name:"ChatGPT-User"},r=n.default.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/oai-searchbot/i],describe:function(e){var t={name:"OAI-SearchBot"},r=n.default.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/claudebot/i,/claude-web/i,/claude-user/i,/claude-searchbot/i],describe:function(e){var t={name:"ClaudeBot"},r=n.default.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/omgilibot/i,/webzio-extended/i],describe:function(e){var t={name:"Omgilibot"},r=n.default.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/diffbot/i],describe:function(e){var t={name:"Diffbot"},r=n.default.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/perplexitybot/i],describe:function(e){var t={name:"PerplexityBot"},r=n.default.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/perplexity-user/i],describe:function(e){var t={name:"Perplexity-User"},r=n.default.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/youbot/i],describe:function(e){var t={name:"YouBot"},r=n.default.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/meta-webindexer/i],describe:function(e){var t={name:"Meta-WebIndexer"},r=n.default.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/meta-externalads/i],describe:function(e){var t={name:"Meta-ExternalAds"},r=n.default.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/meta-externalagent/i],describe:function(e){var t={name:"Meta-ExternalAgent"},r=n.default.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/meta-externalfetcher/i],describe:function(e){var t={name:"Meta-ExternalFetcher"},r=n.default.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=n.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/linespider/i],describe:function(e){var t={name:"Linespider"},r=n.default.getFirstMatch(/(?:linespider)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/amazonbot/i],describe:function(e){var t={name:"AmazonBot"},r=n.default.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/bingbot/i],describe:function(e){var t={name:"BingCrawler"},r=n.default.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/baiduspider/i],describe:function(e){var t={name:"BaiduSpider"},r=n.default.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/duckduckbot/i],describe:function(e){var t={name:"DuckDuckBot"},r=n.default.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/ia_archiver/i],describe:function(e){var t={name:"InternetArchiveCrawler"},r=n.default.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/facebookexternalhit/i,/facebookcatalog/i],describe:function(){return{name:"FacebookExternalHit"}}},{test:[/slackbot/i,/slack-imgProxy/i],describe:function(e){var t={name:"SlackBot"},r=n.default.getFirstMatch(/(?:slackbot|slack-imgproxy)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/yahoo!?[\s/]*slurp/i],describe:function(){return{name:"YahooSlurp"}}},{test:[/yandexbot/i,/yandexmobilebot/i],describe:function(){return{name:"YandexBot"}}},{test:[/pingdom/i],describe:function(){return{name:"PingdomBot"}}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=n.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/PaleMoon/i],describe:function(e){var t={name:"Pale Moon"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=n.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=n.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=n.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=n.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=n.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=n.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=n.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=n.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=n.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=n.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=n.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=n.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=n.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=n.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=n.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=n.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=n.default.getFirstMatch(a,e)||n.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=n.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=n.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=n.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/librewolf/i],describe:function(e){var t={name:"LibreWolf"},r=n.default.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=n.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=n.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sogoumobilebrowser/i,/metasr/i,/se 2\.[x]/i],describe:function(e){var t={name:"Sogou Browser"},r=n.default.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i,e),i=n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e),a=n.default.getFirstMatch(/se ([\d.]+)x/i,e),o=r||i||a;return o&&(t.version=o),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=n.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return!!e.hasBrand("DuckDuckGo")||e.test(/\sDdg\/[\d.]+$/i)},describe:function(e,t){var r={name:"DuckDuckGo"};if(t){var i=t.getBrandVersion("DuckDuckGo");if(i)return r.version=i,r}var a=n.default.getFirstMatch(/\sDdg\/([\d.]+)$/i,e);return a&&(r.version=a),r}},{test:function(e){return e.hasBrand("Brave")},describe:function(e,t){var r={name:"Brave"};if(t){var i=t.getBrandVersion("Brave");if(i)return r.version=i,r}return r}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=n.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=n.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=n.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=n.default.getFirstMatch(a,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:n.default.getFirstMatch(t,e),version:n.default.getSecondMatch(t,e)}}}];t.default=o,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i},a=r(18);var o=[{test:[/Roku\/DVP/],describe:function(e){var t=n.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:a.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=n.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:a.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=n.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=n.default.getWindowsVersionName(t);return{name:a.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:a.OS_MAP.iOS},r=n.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=n.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=n.default.getMacOSVersionName(t),i={name:a.OS_MAP.MacOS,version:t};return r&&(i.versionName=r),i}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=n.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:a.OS_MAP.iOS,version:t}}},{test:[/OpenHarmony/i],describe:function(e){var t=n.default.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i,e);return{name:a.OS_MAP.HarmonyOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=n.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=n.default.getAndroidVersionName(t),i={name:a.OS_MAP.Android,version:t};return r&&(i.versionName=r),i}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=n.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:a.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=n.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||n.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||n.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:a.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=n.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:a.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=n.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:a.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:a.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:a.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=n.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:a.OS_MAP.PlayStation4,version:t}}}];t.default=o,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i},a=r(18);var o=[{test:[/googlebot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Google"}}},{test:[/linespider/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Line"}}},{test:[/amazonbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Amazon"}}},{test:[/gptbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"OpenAI"}}},{test:[/chatgpt-user/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"OpenAI"}}},{test:[/oai-searchbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"OpenAI"}}},{test:[/baiduspider/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Baidu"}}},{test:[/bingbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Bing"}}},{test:[/duckduckbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"DuckDuckGo"}}},{test:[/claudebot/i,/claude-web/i,/claude-user/i,/claude-searchbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Anthropic"}}},{test:[/omgilibot/i,/webzio-extended/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Webz.io"}}},{test:[/diffbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Diffbot"}}},{test:[/perplexitybot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Perplexity AI"}}},{test:[/perplexity-user/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Perplexity AI"}}},{test:[/youbot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"You.com"}}},{test:[/ia_archiver/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Internet Archive"}}},{test:[/meta-webindexer/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Meta"}}},{test:[/meta-externalads/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Meta"}}},{test:[/meta-externalagent/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Meta"}}},{test:[/meta-externalfetcher/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Meta"}}},{test:[/facebookexternalhit/i,/facebookcatalog/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Meta"}}},{test:[/slackbot/i,/slack-imgProxy/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Slack"}}},{test:[/yahoo/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Yahoo"}}},{test:[/yandexbot/i,/yandexmobilebot/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Yandex"}}},{test:[/pingdom/i],describe:function(){return{type:a.PLATFORMS_MAP.bot,vendor:"Pingdom"}}},{test:[/huawei/i],describe:function(e){var t=n.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:a.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:a.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:a.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:a.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:a.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:a.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:a.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=n.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:a.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:a.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/Nokia/i],describe:function(e){var t=n.default.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i,e),r={type:a.PLATFORMS_MAP.mobile,vendor:"Nokia"};return t&&(r.model=t),r}},{test:[/[^-]mobi/i],describe:function(){return{type:a.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:a.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:a.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.mobile}}},{test:[/smart-?tv|smarttv/i],describe:function(){return{type:a.PLATFORMS_MAP.tv}}},{test:[/netcast/i],describe:function(){return{type:a.PLATFORMS_MAP.tv}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:a.PLATFORMS_MAP.tv}}}];t.default=o,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var i,n=(i=r(17))&&i.__esModule?i:{default:i},a=r(18);var o=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:a.ENGINE_MAP.Blink};var t=n.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:a.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:a.ENGINE_MAP.Trident},r=n.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:a.ENGINE_MAP.Presto},r=n.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:a.ENGINE_MAP.Gecko},r=n.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:a.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:a.ENGINE_MAP.WebKit},r=n.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=o,e.exports=t.default}})}));

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NativeScrollbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(NativeScrollbar, _React$Component);

  function NativeScrollbar() {
    _classCallCheck(this, NativeScrollbar);

    return _possibleConstructorReturn(this, _getPrototypeOf(NativeScrollbar).apply(this, arguments));
  }

  _createClass(NativeScrollbar, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          rtl = _this$props.rtl,
          momentum = _this$props.momentum,
          permanentTrackX = _this$props.permanentTrackX,
          permanentTrackY = _this$props.permanentTrackY,
          permanentTracks = _this$props.permanentTracks,
          noScrollX = _this$props.noScrollX,
          noScrollY = _this$props.noScrollY,
          noScroll = _this$props.noScroll,
          tagName = _this$props.tagName,
          className = _this$props.className,
          style = _this$props.style,
          elementRef = _this$props.elementRef,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["rtl", "momentum", "permanentTrackX", "permanentTrackY", "permanentTracks", "noScrollX", "noScrollY", "noScroll", "tagName", "className", "style", "elementRef", "children"]);

      var classNames = "ScrollbarsCustom native" + (rtl ? " rtl" : "") + (className ? " " + className : "");

      var styles = _objectSpread({
        position: "relative"
      }, style, rtl && {
        direction: "rtl"
      }, momentum && {
        WebkitOverflowScrolling: "touch"
      }, {
        overflowX: noScroll || noScrollX ? "hidden" : permanentTracks || permanentTrackX ? "scroll" : "auto",
        overflowY: noScroll || noScrollY ? "hidden" : permanentTracks || permanentTrackY ? "scroll" : "auto"
      });

      return _react.default.createElement(this.props.tagName, _extends({
        style: styles,
        className: classNames,
        ref: function ref(_ref) {
          _this.element = _ref;
          typeof elementRef === "function" && elementRef(_ref);
        }
      }, props), children);
    }
  }]);

  return NativeScrollbar;
}(_react.default.Component);

exports.default = NativeScrollbar;

_defineProperty(NativeScrollbar, "propTypes", {
  rtl: _propTypes.default.bool,
  momentum: _propTypes.default.bool,
  permanentTrackX: _propTypes.default.bool,
  permanentTrackY: _propTypes.default.bool,
  permanentTracks: _propTypes.default.bool,
  noScrollX: _propTypes.default.bool,
  noScrollY: _propTypes.default.bool,
  noScroll: _propTypes.default.bool,
  tagName: _propTypes.default.string,
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  elementRef: _propTypes.default.func
});

_defineProperty(NativeScrollbar, "defaultProps", {
  tagName: "div"
});

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TYPE_Y = exports.TYPE_X = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Track = _interopRequireDefault(__webpack_require__(195));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TYPE_X = 1;
exports.TYPE_X = TYPE_X;
var TYPE_Y = 2;
exports.TYPE_Y = TYPE_Y;

var Thumb =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Thumb, _React$Component);

  function Thumb(props) {
    var _this;

    _classCallCheck(this, Thumb);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Thumb).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDragStart", function (ev) {
      if (ev.nativeEvent.which !== 1) {
        return;
      }

      ev.nativeEvent.preventDefault();
      ev.nativeEvent.stopImmediatePropagation();
      _this.isDragging = true;

      _this.element.classList.add("dragging");

      var rect = _this.element.getBoundingClientRect(),
          parentRect = _this.element.offsetParent.getBoundingClientRect(); // drag start offset


      _this.dragStartOffsetX = ev.clientX - rect.left - rect.width / 2;
      _this.dragStartOffsetY = ev.clientY - rect.top - rect.height / 2;

      if (global.document) {
        global.document.addEventListener("mousemove", _this.handleDragEvent);
        global.document.addEventListener("mouseup", _this.handleDragEnd);
        _this.prevUserSelect = global.document.body.style.userSelect;
        global.document.body.style.userSelect = "none";
        _this.prevOnSelectStart = global.document.onselectstart;

        global.document.onselectstart = function () {
          return false;
        };
      }

      _this.props.onDragStart && _this.props.onDragStart({
        axis: _this.props.type,
        offset: _this.props.type === TYPE_X ? ev.clientX - parentRect.left - _this.dragStartOffsetX : ev.clientY - parentRect.top - _this.dragStartOffsetY
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDragEvent", function (ev) {
      if (ev.which !== 1 || !_this.props.onDrag) {
        return;
      } else if (!_this.isDragging) {
        _this.handleDragEnd();

        return;
      }

      var parentRect = _this.element.offsetParent.getBoundingClientRect();

      _this.props.onDrag({
        axis: _this.props.type,
        offset: _this.props.type === TYPE_X ? ev.clientX - parentRect.left - _this.dragStartOffsetX : ev.clientY - parentRect.top - _this.dragStartOffsetY
      });
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleDragEnd", function () {
      _this.dragStartOffsetX = false;
      _this.dragStartOffsetY = false;

      _this.element.classList.remove("dragging");

      if (global.document) {
        global.document.removeEventListener("mousemove", _this.handleDragEvent);
        global.document.removeEventListener("mouseup", _this.handleDragEnd);
        global.document.body.style.userSelect = _this.prevUserSelect;
        _this.prevUserSelect = null;
        global.document.onselectstart = _this.prevOnSelectStart;
        _this.prevOnSelectStart = null;
      }

      if (!_this.isDragging) {
        return;
      }

      _this.isDragging = false;
      _this.props.onDragEnd && _this.props.onDragEnd({
        axis: _this.props.type
      });
    });

    return _this;
  }

  _createClass(Thumb, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleDragEnd();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          renderer = _this$props.renderer,
          type = _this$props.type,
          elementRef = _this$props.elementRef,
          onDrag = _this$props.onDrag,
          onDragStart = _this$props.onDragStart,
          onDragEnd = _this$props.onDragEnd,
          props = _objectWithoutProperties(_this$props, ["className", "renderer", "type", "elementRef", "onDrag", "onDragStart", "onDragEnd"]);

      props.className = "thumb " + (type === TYPE_X ? "thumbX" : "thumbY") + (className ? " " + className : "");
      props.onMouseDown = this.handleDragStart;

      var ref = function ref(_ref) {
        typeof elementRef === "function" && elementRef(_ref);
        _this2.element = _ref;
      };

      return renderer ? renderer(_objectSpread({}, props, {
        elementRef: ref
      })) : _react.default.createElement("div", _extends({}, props, {
        ref: ref
      }));
    }
  }]);

  return Thumb;
}(_react.default.Component);

exports.default = Thumb;

_defineProperty(Thumb, "displayName", "Scrollbar Thumb");

_defineProperty(Thumb, "propTypes", _objectSpread({}, _Track.default.propTypes, {
  onDrag: _propTypes.default.func,
  onDragStart: _propTypes.default.func,
  onDragEnd: _propTypes.default.func
}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInnerHeight = getInnerHeight;
exports.getInnerWidth = getInnerWidth;
exports.getInnerSizes = getInnerSizes;

/**
 * @description Returns element"s height without padding
 * @param {HTMLElement} el
 * @return {number}
 */
function getInnerHeight(el) {
  var styles = getComputedStyle(el);
  return el.clientHeight - styles.paddingTop.slice(0, -2) - styles.paddingBottom.slice(0, -2);
}
/**
 * @description Returns element"s width without padding
 * @param {HTMLElement} el
 * @return {number}
 */


function getInnerWidth(el) {
  var styles = getComputedStyle(el);
  return el.clientWidth - styles.paddingLeft.slice(0, -2) - styles.paddingRight.slice(0, -2);
}
/**
 * @description Returns element"s dimensions without padding
 * @param {HTMLElement} el
 * @return {{width: number, height: number}}
 */


function getInnerSizes(el) {
  var styles = getComputedStyle(el);
  return {
    width: el.clientHeight - styles.paddingLeft.slice(0, -2) - styles.paddingRight.slice(0, -2),
    height: el.clientHeight - styles.paddingTop.slice(0, -2) - styles.paddingBottom.slice(0, -2)
  };
}

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getScrollbarWidth;
exports.dbgSetScrollbarWidth = dbgSetScrollbarWidth;
exports.dbgSetDocument = dbgSetDocument;
exports.dbgGetDocument = dbgGetDocument;
var scrollbarWidth = null;
var doc = global.document || null;
/**
 * @description Returns scrollbar width specific for current environment
 * @return {number}
 */

function getScrollbarWidth() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!force && scrollbarWidth !== null) {
    return scrollbarWidth;
  }

  if (!doc) {
    return scrollbarWidth = 0;
  }

  var el = doc.createElement("div");
  el.setAttribute("style", "display:block;position:absolute;width:100px;height:100px;top:-9999px;overflow:scroll;");
  doc.body.appendChild(el);
  scrollbarWidth = el.offsetWidth - el.clientWidth || 0;
  doc.body.removeChild(el);
  return scrollbarWidth;
}

function dbgSetScrollbarWidth(v) {
  return scrollbarWidth = v;
}

function dbgSetDocument(v) {
  return doc = v;
}

function dbgGetDocument() {
  return doc;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLoopController = createLoopController;
exports.default = exports.LoopController = void 0;

function LoopControllerClass() {
  var _this = this;

  /**
   * @typedef {Object} Scrollbar
   * @property {function} update
   */

  /**
   * @type {Scrollbar[]}
   */
  var scrollbarsRegister = [];
  /**
   * true if loop is active
   * @type {boolean}
   */

  var isActive = false;
  /**
   * ID of requested animation frame
   * @type {null|number}
   */

  var animationFrameId = null;
  /**
   * Function that called in animation frame
   */

  var animationFrameCallback = function animationFrameCallback() {
    if (!isActive) {
      return;
    }

    for (var _i = 0; _i < scrollbarsRegister.length; _i++) {
      var scrollbar = scrollbarsRegister[_i];
      scrollbar.update();
    }

    requestAnimationFrame(animationFrameCallback);
  };
  /**
   * Stop the loop if it wasn't active
   * @return {LoopControllerClass}
   */


  this.start = function () {
    if (!isActive) {
      isActive = true;
      animationFrameId && cancelAnimationFrame(animationFrameId);
      requestAnimationFrame(animationFrameCallback);
    }

    return _this;
  };
  /**
   * Stop the loop if it is active
   * @return {LoopControllerClass}
   */


  this.stop = function () {
    if (isActive) {
      isActive = false;
      animationFrameId && cancelAnimationFrame(animationFrameId);
      animationFrameId = null;
    }

    return _this;
  };
  /**
   * Return the array pf registered scrollbars
   * @return {Scrollbar[]}
   */


  this.getRegisteredScrollbars = function () {
    return scrollbarsRegister.concat();
  };
  /**
   * Add the scrollbar to list to iterate each loop
   * @param {Scrollbar} scrollbar
   * @return {LoopControllerClass}
   */


  this.registerScrollbar = function (scrollbar) {
    if (scrollbarsRegister.indexOf(scrollbar) === -1) {
      scrollbarsRegister.push(scrollbar);

      _this.start();
    }

    return _this;
  };
  /**
   * Remove the scrollbar from list to iterate each loop
   * @param {Scrollbar} scrollbar
   * @return {LoopControllerClass}
   */


  this.unregisterScrollbar = function (scrollbar) {
    var index = scrollbarsRegister.indexOf(scrollbar);

    if (index !== -1) {
      scrollbarsRegister.splice(index, 1);
    }

    return _this;
  };
}

var LoopController = new LoopControllerClass();
exports.LoopController = LoopController;
var _default = LoopController;
/**
 * Return new instance of LoopControllerClass
 * @return {LoopControllerClass}
 */

exports.default = _default;

function createLoopController() {
  return new LoopControllerClass();
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(137);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (BrowserRouter);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(137);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(412);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(138);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(196);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* unused harmony default export */ var _unused_webpack_default_export = (NavLink);

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(416);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(418);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(200);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(420);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(138);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(422);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(139);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(200);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(139);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(426);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(198);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function () {
	'use strict';

	/**
	 * @preserve FastClick: polyfill to remove click delays on browsers with touch UIs.
	 *
	 * @codingstandard ftlabs-jsv2
	 * @copyright The Financial Times Limited [All Rights Reserved]
	 * @license MIT License (see LICENSE.txt)
	 */

	/*jslint browser:true, node:true*/
	/*global define, Event, Node*/


	/**
	 * Instantiate fast-clicking listeners on the specified layer.
	 *
	 * @constructor
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	function FastClick(layer, options) {
		var oldOnClick;

		options = options || {};

		/**
		 * Whether a click is currently being tracked.
		 *
		 * @type boolean
		 */
		this.trackingClick = false;


		/**
		 * Timestamp for when click tracking started.
		 *
		 * @type number
		 */
		this.trackingClickStart = 0;


		/**
		 * The element being tracked for a click.
		 *
		 * @type EventTarget
		 */
		this.targetElement = null;


		/**
		 * X-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartX = 0;


		/**
		 * Y-coordinate of touch start event.
		 *
		 * @type number
		 */
		this.touchStartY = 0;


		/**
		 * ID of the last touch, retrieved from Touch.identifier.
		 *
		 * @type number
		 */
		this.lastTouchIdentifier = 0;


		/**
		 * Touchmove boundary, beyond which a click will be cancelled.
		 *
		 * @type number
		 */
		this.touchBoundary = options.touchBoundary || 10;


		/**
		 * The FastClick layer.
		 *
		 * @type Element
		 */
		this.layer = layer;

		/**
		 * The minimum time between tap(touchstart and touchend) events
		 *
		 * @type number
		 */
		this.tapDelay = options.tapDelay || 200;

		/**
		 * The maximum time for a tap
		 *
		 * @type number
		 */
		this.tapTimeout = options.tapTimeout || 700;

		if (FastClick.notNeeded(layer)) {
			return;
		}

		// Some old versions of Android don't have Function.prototype.bind
		function bind(method, context) {
			return function() { return method.apply(context, arguments); };
		}


		var methods = ['onMouse', 'onClick', 'onTouchStart', 'onTouchMove', 'onTouchEnd', 'onTouchCancel'];
		var context = this;
		for (var i = 0, l = methods.length; i < l; i++) {
			context[methods[i]] = bind(context[methods[i]], context);
		}

		// Set up event handlers as required
		if (deviceIsAndroid) {
			layer.addEventListener('mouseover', this.onMouse, true);
			layer.addEventListener('mousedown', this.onMouse, true);
			layer.addEventListener('mouseup', this.onMouse, true);
		}

		layer.addEventListener('click', this.onClick, true);
		layer.addEventListener('touchstart', this.onTouchStart, false);
		layer.addEventListener('touchmove', this.onTouchMove, false);
		layer.addEventListener('touchend', this.onTouchEnd, false);
		layer.addEventListener('touchcancel', this.onTouchCancel, false);

		// Hack is required for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
		// which is how FastClick normally stops click events bubbling to callbacks registered on the FastClick
		// layer when they are cancelled.
		if (!Event.prototype.stopImmediatePropagation) {
			layer.removeEventListener = function(type, callback, capture) {
				var rmv = Node.prototype.removeEventListener;
				if (type === 'click') {
					rmv.call(layer, type, callback.hijacked || callback, capture);
				} else {
					rmv.call(layer, type, callback, capture);
				}
			};

			layer.addEventListener = function(type, callback, capture) {
				var adv = Node.prototype.addEventListener;
				if (type === 'click') {
					adv.call(layer, type, callback.hijacked || (callback.hijacked = function(event) {
						if (!event.propagationStopped) {
							callback(event);
						}
					}), capture);
				} else {
					adv.call(layer, type, callback, capture);
				}
			};
		}

		// If a handler is already declared in the element's onclick attribute, it will be fired before
		// FastClick's onClick handler. Fix this by pulling out the user-defined handler function and
		// adding it as listener.
		if (typeof layer.onclick === 'function') {

			// Android browser on at least 3.2 requires a new reference to the function in layer.onclick
			// - the old one won't work if passed to addEventListener directly.
			oldOnClick = layer.onclick;
			layer.addEventListener('click', function(event) {
				oldOnClick(event);
			}, false);
			layer.onclick = null;
		}
	}

	/**
	* Windows Phone 8.1 fakes user agent string to look like Android and iPhone.
	*
	* @type boolean
	*/
	var deviceIsWindowsPhone = navigator.userAgent.indexOf("Windows Phone") >= 0;

	/**
	 * Android requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsAndroid = navigator.userAgent.indexOf('Android') > 0 && !deviceIsWindowsPhone;


	/**
	 * iOS requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsIOS = /iP(ad|hone|od)/.test(navigator.userAgent) && !deviceIsWindowsPhone;


	/**
	 * iOS 4 requires an exception for select elements.
	 *
	 * @type boolean
	 */
	var deviceIsIOS4 = deviceIsIOS && (/OS 4_\d(_\d)?/).test(navigator.userAgent);


	/**
	 * iOS 6.0-7.* requires the target element to be manually derived
	 *
	 * @type boolean
	 */
	var deviceIsIOSWithBadTarget = deviceIsIOS && (/OS [6-7]_\d/).test(navigator.userAgent);

	/**
	 * BlackBerry requires exceptions.
	 *
	 * @type boolean
	 */
	var deviceIsBlackBerry10 = navigator.userAgent.indexOf('BB10') > 0;

	/**
	 * Determine whether a given element requires a native click.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element needs a native click
	 */
	FastClick.prototype.needsClick = function(target) {
		switch (target.nodeName.toLowerCase()) {

		// Don't send a synthetic click to disabled inputs (issue #62)
		case 'button':
		case 'select':
		case 'textarea':
			if (target.disabled) {
				return true;
			}

			break;
		case 'input':

			// File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
			if ((deviceIsIOS && target.type === 'file') || target.disabled) {
				return true;
			}

			break;
		case 'label':
		case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
		case 'video':
			return true;
		}

		return (/\bneedsclick\b/).test(target.className);
	};


	/**
	 * Determine whether a given element requires a call to focus to simulate click into element.
	 *
	 * @param {EventTarget|Element} target Target DOM element
	 * @returns {boolean} Returns true if the element requires a call to focus to simulate native click.
	 */
	FastClick.prototype.needsFocus = function(target) {
		switch (target.nodeName.toLowerCase()) {
		case 'textarea':
			return true;
		case 'select':
			return !deviceIsAndroid;
		case 'input':
			switch (target.type) {
			case 'button':
			case 'checkbox':
			case 'file':
			case 'image':
			case 'radio':
			case 'submit':
				return false;
			}

			// No point in attempting to focus disabled inputs
			return !target.disabled && !target.readOnly;
		default:
			return (/\bneedsfocus\b/).test(target.className);
		}
	};


	/**
	 * Send a click event to the specified element.
	 *
	 * @param {EventTarget|Element} targetElement
	 * @param {Event} event
	 */
	FastClick.prototype.sendClick = function(targetElement, event) {
		var clickEvent, touch;

		// On some Android devices activeElement needs to be blurred otherwise the synthetic click will have no effect (#24)
		if (document.activeElement && document.activeElement !== targetElement) {
			document.activeElement.blur();
		}

		touch = event.changedTouches[0];

		// Synthesise a click event, with an extra attribute so it can be tracked
		clickEvent = document.createEvent('MouseEvents');
		clickEvent.initMouseEvent(this.determineEventType(targetElement), true, true, window, 1, touch.screenX, touch.screenY, touch.clientX, touch.clientY, false, false, false, false, 0, null);
		clickEvent.forwardedTouchEvent = true;
		targetElement.dispatchEvent(clickEvent);
	};

	FastClick.prototype.determineEventType = function(targetElement) {

		//Issue #159: Android Chrome Select Box does not open with a synthetic click event
		if (deviceIsAndroid && targetElement.tagName.toLowerCase() === 'select') {
			return 'mousedown';
		}

		return 'click';
	};


	/**
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.focus = function(targetElement) {
		var length;

		// Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
		if (deviceIsIOS && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
			length = targetElement.value.length;
			targetElement.setSelectionRange(length, length);
		} else {
			targetElement.focus();
		}
	};


	/**
	 * Check whether the given target element is a child of a scrollable layer and if so, set a flag on it.
	 *
	 * @param {EventTarget|Element} targetElement
	 */
	FastClick.prototype.updateScrollParent = function(targetElement) {
		var scrollParent, parentElement;

		scrollParent = targetElement.fastClickScrollParent;

		// Attempt to discover whether the target element is contained within a scrollable layer. Re-check if the
		// target element was moved to another parent.
		if (!scrollParent || !scrollParent.contains(targetElement)) {
			parentElement = targetElement;
			do {
				if (parentElement.scrollHeight > parentElement.offsetHeight) {
					scrollParent = parentElement;
					targetElement.fastClickScrollParent = parentElement;
					break;
				}

				parentElement = parentElement.parentElement;
			} while (parentElement);
		}

		// Always update the scroll top tracker if possible.
		if (scrollParent) {
			scrollParent.fastClickLastScrollTop = scrollParent.scrollTop;
		}
	};


	/**
	 * @param {EventTarget} targetElement
	 * @returns {Element|EventTarget}
	 */
	FastClick.prototype.getTargetElementFromEventTarget = function(eventTarget) {

		// On some older browsers (notably Safari on iOS 4.1 - see issue #56) the event target may be a text node.
		if (eventTarget.nodeType === Node.TEXT_NODE) {
			return eventTarget.parentNode;
		}

		return eventTarget;
	};


	/**
	 * On touch start, record the position and scroll offset.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchStart = function(event) {
		var targetElement, touch, selection;

		// Ignore multiple touches, otherwise pinch-to-zoom is prevented if both fingers are on the FastClick element (issue #111).
		if (event.targetTouches.length > 1) {
			return true;
		}

		targetElement = this.getTargetElementFromEventTarget(event.target);
		touch = event.targetTouches[0];

		if (deviceIsIOS) {

			// Only trusted events will deselect text on iOS (issue #49)
			selection = window.getSelection();
			if (selection.rangeCount && !selection.isCollapsed) {
				return true;
			}

			if (!deviceIsIOS4) {

				// Weird things happen on iOS when an alert or confirm dialog is opened from a click event callback (issue #23):
				// when the user next taps anywhere else on the page, new touchstart and touchend events are dispatched
				// with the same identifier as the touch event that previously triggered the click that triggered the alert.
				// Sadly, there is an issue on iOS 4 that causes some normal touch events to have the same identifier as an
				// immediately preceeding touch event (issue #52), so this fix is unavailable on that platform.
				// Issue 120: touch.identifier is 0 when Chrome dev tools 'Emulate touch events' is set with an iOS device UA string,
				// which causes all touch events to be ignored. As this block only applies to iOS, and iOS identifiers are always long,
				// random integers, it's safe to to continue if the identifier is 0 here.
				if (touch.identifier && touch.identifier === this.lastTouchIdentifier) {
					event.preventDefault();
					return false;
				}

				this.lastTouchIdentifier = touch.identifier;

				// If the target element is a child of a scrollable layer (using -webkit-overflow-scrolling: touch) and:
				// 1) the user does a fling scroll on the scrollable layer
				// 2) the user stops the fling scroll with another tap
				// then the event.target of the last 'touchend' event will be the element that was under the user's finger
				// when the fling scroll was started, causing FastClick to send a click event to that layer - unless a check
				// is made to ensure that a parent layer was not scrolled before sending a synthetic click (issue #42).
				this.updateScrollParent(targetElement);
			}
		}

		this.trackingClick = true;
		this.trackingClickStart = event.timeStamp;
		this.targetElement = targetElement;

		this.touchStartX = touch.pageX;
		this.touchStartY = touch.pageY;

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			event.preventDefault();
		}

		return true;
	};


	/**
	 * Based on a touchmove event object, check whether the touch has moved past a boundary since it started.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.touchHasMoved = function(event) {
		var touch = event.changedTouches[0], boundary = this.touchBoundary;

		if (Math.abs(touch.pageX - this.touchStartX) > boundary || Math.abs(touch.pageY - this.touchStartY) > boundary) {
			return true;
		}

		return false;
	};


	/**
	 * Update the last position.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchMove = function(event) {
		if (!this.trackingClick) {
			return true;
		}

		// If the touch has moved, cancel the click tracking
		if (this.targetElement !== this.getTargetElementFromEventTarget(event.target) || this.touchHasMoved(event)) {
			this.trackingClick = false;
			this.targetElement = null;
		}

		return true;
	};


	/**
	 * Attempt to find the labelled control for the given label element.
	 *
	 * @param {EventTarget|HTMLLabelElement} labelElement
	 * @returns {Element|null}
	 */
	FastClick.prototype.findControl = function(labelElement) {

		// Fast path for newer browsers supporting the HTML5 control attribute
		if (labelElement.control !== undefined) {
			return labelElement.control;
		}

		// All browsers under test that support touch events also support the HTML5 htmlFor attribute
		if (labelElement.htmlFor) {
			return document.getElementById(labelElement.htmlFor);
		}

		// If no for attribute exists, attempt to retrieve the first labellable descendant element
		// the list of which is defined here: http://www.w3.org/TR/html5/forms.html#category-label
		return labelElement.querySelector('button, input:not([type=hidden]), keygen, meter, output, progress, select, textarea');
	};


	/**
	 * On touch end, determine whether to send a click event at once.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onTouchEnd = function(event) {
		var forElement, trackingClickStart, targetTagName, scrollParent, touch, targetElement = this.targetElement;

		if (!this.trackingClick) {
			return true;
		}

		// Prevent phantom clicks on fast double-tap (issue #36)
		if ((event.timeStamp - this.lastClickTime) < this.tapDelay) {
			this.cancelNextClick = true;
			return true;
		}

		if ((event.timeStamp - this.trackingClickStart) > this.tapTimeout) {
			return true;
		}

		// Reset to prevent wrong click cancel on input (issue #156).
		this.cancelNextClick = false;

		this.lastClickTime = event.timeStamp;

		trackingClickStart = this.trackingClickStart;
		this.trackingClick = false;
		this.trackingClickStart = 0;

		// On some iOS devices, the targetElement supplied with the event is invalid if the layer
		// is performing a transition or scroll, and has to be re-detected manually. Note that
		// for this to function correctly, it must be called *after* the event target is checked!
		// See issue #57; also filed as rdar://13048589 .
		if (deviceIsIOSWithBadTarget) {
			touch = event.changedTouches[0];

			// In certain cases arguments of elementFromPoint can be negative, so prevent setting targetElement to null
			targetElement = document.elementFromPoint(touch.pageX - window.pageXOffset, touch.pageY - window.pageYOffset) || targetElement;
			targetElement.fastClickScrollParent = this.targetElement.fastClickScrollParent;
		}

		targetTagName = targetElement.tagName.toLowerCase();
		if (targetTagName === 'label') {
			forElement = this.findControl(targetElement);
			if (forElement) {
				this.focus(targetElement);
				if (deviceIsAndroid) {
					return false;
				}

				targetElement = forElement;
			}
		} else if (this.needsFocus(targetElement)) {

			// Case 1: If the touch started a while ago (best guess is 100ms based on tests for issue #36) then focus will be triggered anyway. Return early and unset the target element reference so that the subsequent click will be allowed through.
			// Case 2: Without this exception for input elements tapped when the document is contained in an iframe, then any inputted text won't be visible even though the value attribute is updated as the user types (issue #37).
			if ((event.timeStamp - trackingClickStart) > 100 || (deviceIsIOS && window.top !== window && targetTagName === 'input')) {
				this.targetElement = null;
				return false;
			}

			this.focus(targetElement);
			this.sendClick(targetElement, event);

			// Select elements need the event to go through on iOS 4, otherwise the selector menu won't open.
			// Also this breaks opening selects when VoiceOver is active on iOS6, iOS7 (and possibly others)
			if (!deviceIsIOS || targetTagName !== 'select') {
				this.targetElement = null;
				event.preventDefault();
			}

			return false;
		}

		if (deviceIsIOS && !deviceIsIOS4) {

			// Don't send a synthetic click event if the target element is contained within a parent layer that was scrolled
			// and this tap is being used to stop the scrolling (usually initiated by a fling - issue #42).
			scrollParent = targetElement.fastClickScrollParent;
			if (scrollParent && scrollParent.fastClickLastScrollTop !== scrollParent.scrollTop) {
				return true;
			}
		}

		// Prevent the actual click from going though - unless the target node is marked as requiring
		// real clicks or if it is in the whitelist in which case only non-programmatic clicks are permitted.
		if (!this.needsClick(targetElement)) {
			event.preventDefault();
			this.sendClick(targetElement, event);
		}

		return false;
	};


	/**
	 * On touch cancel, stop tracking the click.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.onTouchCancel = function() {
		this.trackingClick = false;
		this.targetElement = null;
	};


	/**
	 * Determine mouse events which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onMouse = function(event) {

		// If a target element was never set (because a touch event was never fired) allow the event
		if (!this.targetElement) {
			return true;
		}

		if (event.forwardedTouchEvent) {
			return true;
		}

		// Programmatically generated events targeting a specific element should be permitted
		if (!event.cancelable) {
			return true;
		}

		// Derive and check the target element to see whether the mouse event needs to be permitted;
		// unless explicitly enabled, prevent non-touch click events from triggering actions,
		// to prevent ghost/doubleclicks.
		if (!this.needsClick(this.targetElement) || this.cancelNextClick) {

			// Prevent any user-added listeners declared on FastClick element from being fired.
			if (event.stopImmediatePropagation) {
				event.stopImmediatePropagation();
			} else {

				// Part of the hack for browsers that don't support Event#stopImmediatePropagation (e.g. Android 2)
				event.propagationStopped = true;
			}

			// Cancel the event
			event.stopPropagation();
			event.preventDefault();

			return false;
		}

		// If the mouse event is permitted, return true for the action to go through.
		return true;
	};


	/**
	 * On actual clicks, determine whether this is a touch-generated click, a click action occurring
	 * naturally after a delay after a touch (which needs to be cancelled to avoid duplication), or
	 * an actual click which should be permitted.
	 *
	 * @param {Event} event
	 * @returns {boolean}
	 */
	FastClick.prototype.onClick = function(event) {
		var permitted;

		// It's possible for another FastClick-like library delivered with third-party code to fire a click event before FastClick does (issue #44). In that case, set the click-tracking flag back to false and return early. This will cause onTouchEnd to return early.
		if (this.trackingClick) {
			this.targetElement = null;
			this.trackingClick = false;
			return true;
		}

		// Very odd behaviour on iOS (issue #18): if a submit element is present inside a form and the user hits enter in the iOS simulator or clicks the Go button on the pop-up OS keyboard the a kind of 'fake' click event will be triggered with the submit-type input element as the target.
		if (event.target.type === 'submit' && event.detail === 0) {
			return true;
		}

		permitted = this.onMouse(event);

		// Only unset targetElement if the click is not permitted. This will ensure that the check for !targetElement in onMouse fails and the browser's click doesn't go through.
		if (!permitted) {
			this.targetElement = null;
		}

		// If clicks are permitted, return true for the action to go through.
		return permitted;
	};


	/**
	 * Remove all FastClick's event listeners.
	 *
	 * @returns {void}
	 */
	FastClick.prototype.destroy = function() {
		var layer = this.layer;

		if (deviceIsAndroid) {
			layer.removeEventListener('mouseover', this.onMouse, true);
			layer.removeEventListener('mousedown', this.onMouse, true);
			layer.removeEventListener('mouseup', this.onMouse, true);
		}

		layer.removeEventListener('click', this.onClick, true);
		layer.removeEventListener('touchstart', this.onTouchStart, false);
		layer.removeEventListener('touchmove', this.onTouchMove, false);
		layer.removeEventListener('touchend', this.onTouchEnd, false);
		layer.removeEventListener('touchcancel', this.onTouchCancel, false);
	};


	/**
	 * Check whether FastClick is needed.
	 *
	 * @param {Element} layer The layer to listen on
	 */
	FastClick.notNeeded = function(layer) {
		var metaViewport;
		var chromeVersion;
		var blackberryVersion;
		var firefoxVersion;

		// Devices that don't support touch don't need FastClick
		if (typeof window.ontouchstart === 'undefined') {
			return true;
		}

		// Chrome version - zero for other browsers
		chromeVersion = +(/Chrome\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (chromeVersion) {

			if (deviceIsAndroid) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// Chrome on Android with user-scalable="no" doesn't need FastClick (issue #89)
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// Chrome 32 and above with width=device-width or less don't need FastClick
					if (chromeVersion > 31 && document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}

			// Chrome desktop doesn't need FastClick (issue #15)
			} else {
				return true;
			}
		}

		if (deviceIsBlackBerry10) {
			blackberryVersion = navigator.userAgent.match(/Version\/([0-9]*)\.([0-9]*)/);

			// BlackBerry 10.3+ does not require Fastclick library.
			// https://github.com/ftlabs/fastclick/issues/251
			if (blackberryVersion[1] >= 10 && blackberryVersion[2] >= 3) {
				metaViewport = document.querySelector('meta[name=viewport]');

				if (metaViewport) {
					// user-scalable=no eliminates click delay.
					if (metaViewport.content.indexOf('user-scalable=no') !== -1) {
						return true;
					}
					// width=device-width (or less than device-width) eliminates click delay.
					if (document.documentElement.scrollWidth <= window.outerWidth) {
						return true;
					}
				}
			}
		}

		// IE10 with -ms-touch-action: none or manipulation, which disables double-tap-to-zoom (issue #97)
		if (layer.style.msTouchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		// Firefox version - zero for other browsers
		firefoxVersion = +(/Firefox\/([0-9]+)/.exec(navigator.userAgent) || [,0])[1];

		if (firefoxVersion >= 27) {
			// Firefox 27+ does not have tap delay if the content is not zoomable - https://bugzilla.mozilla.org/show_bug.cgi?id=922896

			metaViewport = document.querySelector('meta[name=viewport]');
			if (metaViewport && (metaViewport.content.indexOf('user-scalable=no') !== -1 || document.documentElement.scrollWidth <= window.outerWidth)) {
				return true;
			}
		}

		// IE11: prefixed -ms-touch-action is no longer supported and it's recomended to use non-prefixed version
		// http://msdn.microsoft.com/en-us/library/windows/apps/Hh767313.aspx
		if (layer.style.touchAction === 'none' || layer.style.touchAction === 'manipulation') {
			return true;
		}

		return false;
	};


	/**
	 * Factory method for creating a FastClick object
	 *
	 * @param {Element} layer The layer to listen on
	 * @param {Object} [options={}] The options to override the defaults
	 */
	FastClick.attach = function(layer, options) {
		return new FastClick(layer, options);
	};


	if (true) {

		// AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return FastClick;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = FastClick.attach;
		module.exports.FastClick = FastClick;
	} else {
		window.FastClick = FastClick;
	}
}());


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_toBlob__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_toBlob___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__helpers_toBlob__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_entries__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_values__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_keys__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_object_keys__);
if(typeof Object.entries!=='function'){__WEBPACK_IMPORTED_MODULE_1_object_entries___default.a.shim();}if(typeof Object.values!=='function'){__WEBPACK_IMPORTED_MODULE_2_object_values___default.a.shim();}if(typeof Object.keys!=='function'){__WEBPACK_IMPORTED_MODULE_3_object_keys___default.a.shim();}/**
 * Polyfill for canvas.toBlob method
 */__WEBPACK_IMPORTED_MODULE_0__helpers_toBlob___default.a.init();

/***/ }),
/* 430 */
/***/ (function(module, exports) {

var toBlob=function toBlob(uri){var mime=uri.split(',')[0].split(':')[1].split(';')[0];var bytes=atob(uri.split(',')[1]);var len=bytes.length;var buffer=new window.ArrayBuffer(len);var arr=new window.Uint8Array(buffer);for(var i=0;i<len;i++){arr[i]=bytes.charCodeAt(i);}return new Blob([arr],{type:mime});};var init=function init(){if(!module.exports.supported)return;var CanvasPrototype=window.HTMLCanvasElement.prototype;if(!CanvasPrototype.toBlob&&CanvasPrototype.toDataURL){CanvasPrototype.toBlob=function(callback,type,quality){callback(toBlob(this.toDataURL(type,quality)));};}};// IE >= 10, most modern browsers
// The Blob type can't be polyfilled, which is why there aren't any polyfills for TypedArrays for older IE's
var supported=typeof window.HTMLCanvasElement!=='undefined'&&typeof window.atob!=='undefined'&&typeof window.Blob!=='undefined'&&typeof window.ArrayBuffer!=='undefined'&&typeof window.Uint8Array!=='undefined';module.exports=toBlob;module.exports.init=init;module.exports.supported=supported;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(101);
var callBind = __webpack_require__(205);

var implementation = __webpack_require__(210);
var getPolyfill = __webpack_require__(212);
var shim = __webpack_require__(455);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(201); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(104);
var define = __webpack_require__(202);
var hasDescriptors = __webpack_require__(204)();
var gOPD = __webpack_require__(103);

var $TypeError = __webpack_require__(49);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(447);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(206);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(207);
var originalGetProto = __webpack_require__(208);

var getDunderProto = __webpack_require__(450);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(142);
var gOPD = __webpack_require__(103);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(86);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(86);
var $apply = __webpack_require__(144);
var actualApply = __webpack_require__(209);

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(212);
var define = __webpack_require__(101);

module.exports = function shimEntries() {
	var polyfill = getPolyfill();
	define(Object, { entries: polyfill }, {
		entries: function testEntries() {
			return Object.entries !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(101);
var callBind = __webpack_require__(205);

var implementation = __webpack_require__(213);
var getPolyfill = __webpack_require__(214);
var shim = __webpack_require__(457);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(214);
var define = __webpack_require__(101);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 458 */
/***/ (function(module, exports) {

// Two functions to highly improve usability if the map for iOS devices
var lastTouchEnd=0;var iOS=!!navigator.platform&&/iPad|iPhone|iPod/.test(navigator.platform);// only applies if the device is an iOS device and the page is the homepage.
if(iOS&&window.location.pathname==='/'){document.addEventListener('touchend',function(event){var now=new Date().getTime();if(now-lastTouchEnd<=300){event.preventDefault();}lastTouchEnd=now;},false);document.addEventListener('touchmove',function(event){if(event.scale!==1){event.preventDefault();}},false);}

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(460);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(473);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(461), __esModule: true };

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145);
__webpack_require__(107);
module.exports = __webpack_require__(472);


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(463);
var step = __webpack_require__(464);
var Iterators = __webpack_require__(75);
var toIObject = __webpack_require__(68);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(217)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(150);
var descriptor = __webpack_require__(88);
var setToStringTag = __webpack_require__(155);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(76)(IteratorPrototype, __webpack_require__(46)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(58);
var anObject = __webpack_require__(69);
var getKeys = __webpack_require__(89);

module.exports = __webpack_require__(59) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(68);
var toLength = __webpack_require__(222);
var toAbsoluteIndex = __webpack_require__(469);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(151);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(57).document;
module.exports = document && document.documentElement;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(151);
var defined = __webpack_require__(147);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(224);
var ITERATOR = __webpack_require__(46)('iterator');
var Iterators = __webpack_require__(75);
module.exports = __webpack_require__(33).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(474), __esModule: true };

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(145);
__webpack_require__(107);
module.exports = __webpack_require__(475);


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(69);
var get = __webpack_require__(225);
module.exports = __webpack_require__(33).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(477), __esModule: true };

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(478);
module.exports = __webpack_require__(33).Object.keys;


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(79);
var $keys = __webpack_require__(89);

__webpack_require__(156)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(480);
var $Object = __webpack_require__(33).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(56);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperty: __webpack_require__(58).f });


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(482), __esModule: true };

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
__webpack_require__(145);
module.exports = __webpack_require__(157).f('iterator');


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(484), __esModule: true };

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(485);
__webpack_require__(490);
__webpack_require__(491);
__webpack_require__(492);
module.exports = __webpack_require__(33).Symbol;


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(57);
var has = __webpack_require__(70);
var DESCRIPTORS = __webpack_require__(59);
var $export = __webpack_require__(56);
var redefine = __webpack_require__(220);
var META = __webpack_require__(486).KEY;
var $fails = __webpack_require__(78);
var shared = __webpack_require__(153);
var setToStringTag = __webpack_require__(155);
var uid = __webpack_require__(106);
var wks = __webpack_require__(46);
var wksExt = __webpack_require__(157);
var wksDefine = __webpack_require__(158);
var enumKeys = __webpack_require__(487);
var isArray = __webpack_require__(488);
var anObject = __webpack_require__(69);
var isObject = __webpack_require__(77);
var toObject = __webpack_require__(79);
var toIObject = __webpack_require__(68);
var toPrimitive = __webpack_require__(149);
var createDesc = __webpack_require__(88);
var _create = __webpack_require__(150);
var gOPNExt = __webpack_require__(489);
var $GOPD = __webpack_require__(160);
var $GOPS = __webpack_require__(159);
var $DP = __webpack_require__(58);
var $keys = __webpack_require__(89);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(227).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(109).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(105)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(76)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(106)('meta');
var isObject = __webpack_require__(77);
var has = __webpack_require__(70);
var setDesc = __webpack_require__(58).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(78)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(89);
var gOPS = __webpack_require__(159);
var pIE = __webpack_require__(109);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(146);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(68);
var gOPN = __webpack_require__(227).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 490 */
/***/ (function(module, exports) {



/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158)('asyncIterator');


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(158)('observable');


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* global window, exports, define */

!function() {
    'use strict'

    var re = {
        not_string: /[^s]/,
        not_bool: /[^t]/,
        not_type: /[^T]/,
        not_primitive: /[^v]/,
        number: /[diefg]/,
        numeric_arg: /[bcdiefguxX]/,
        json: /[j]/,
        not_json: /[^j]/,
        text: /^[^\x25]+/,
        modulo: /^\x25{2}/,
        placeholder: /^\x25(?:([1-9]\d*)\$|\(([^)]+)\))?(\+)?(0|'[^$])?(-)?(\d+)?(?:\.(\d+))?([b-gijostTuvxX])/,
        key: /^([a-z_][a-z_\d]*)/i,
        key_access: /^\.([a-z_][a-z_\d]*)/i,
        index_access: /^\[(\d+)\]/,
        sign: /^[+-]/
    }

    function sprintf(key) {
        // `arguments` is not an array, but should be fine for this call
        return sprintf_format(sprintf_parse(key), arguments)
    }

    function vsprintf(fmt, argv) {
        return sprintf.apply(null, [fmt].concat(argv || []))
    }

    function sprintf_format(parse_tree, argv) {
        var cursor = 1, tree_length = parse_tree.length, arg, output = '', i, k, ph, pad, pad_character, pad_length, is_positive, sign
        for (i = 0; i < tree_length; i++) {
            if (typeof parse_tree[i] === 'string') {
                output += parse_tree[i]
            }
            else if (typeof parse_tree[i] === 'object') {
                ph = parse_tree[i] // convenience purposes only
                if (ph.keys) { // keyword argument
                    arg = argv[cursor]
                    for (k = 0; k < ph.keys.length; k++) {
                        if (arg == undefined) {
                            throw new Error(sprintf('[sprintf] Cannot access property "%s" of undefined value "%s"', ph.keys[k], ph.keys[k-1]))
                        }
                        arg = arg[ph.keys[k]]
                    }
                }
                else if (ph.param_no) { // positional argument (explicit)
                    arg = argv[ph.param_no]
                }
                else { // positional argument (implicit)
                    arg = argv[cursor++]
                }

                if (re.not_type.test(ph.type) && re.not_primitive.test(ph.type) && arg instanceof Function) {
                    arg = arg()
                }

                if (re.numeric_arg.test(ph.type) && (typeof arg !== 'number' && isNaN(arg))) {
                    throw new TypeError(sprintf('[sprintf] expecting number but found %T', arg))
                }

                if (re.number.test(ph.type)) {
                    is_positive = arg >= 0
                }

                switch (ph.type) {
                    case 'b':
                        arg = parseInt(arg, 10).toString(2)
                        break
                    case 'c':
                        arg = String.fromCharCode(parseInt(arg, 10))
                        break
                    case 'd':
                    case 'i':
                        arg = parseInt(arg, 10)
                        break
                    case 'j':
                        arg = JSON.stringify(arg, null, ph.width ? parseInt(ph.width) : 0)
                        break
                    case 'e':
                        arg = ph.precision ? parseFloat(arg).toExponential(ph.precision) : parseFloat(arg).toExponential()
                        break
                    case 'f':
                        arg = ph.precision ? parseFloat(arg).toFixed(ph.precision) : parseFloat(arg)
                        break
                    case 'g':
                        arg = ph.precision ? String(Number(arg.toPrecision(ph.precision))) : parseFloat(arg)
                        break
                    case 'o':
                        arg = (parseInt(arg, 10) >>> 0).toString(8)
                        break
                    case 's':
                        arg = String(arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 't':
                        arg = String(!!arg)
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'T':
                        arg = Object.prototype.toString.call(arg).slice(8, -1).toLowerCase()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'u':
                        arg = parseInt(arg, 10) >>> 0
                        break
                    case 'v':
                        arg = arg.valueOf()
                        arg = (ph.precision ? arg.substring(0, ph.precision) : arg)
                        break
                    case 'x':
                        arg = (parseInt(arg, 10) >>> 0).toString(16)
                        break
                    case 'X':
                        arg = (parseInt(arg, 10) >>> 0).toString(16).toUpperCase()
                        break
                }
                if (re.json.test(ph.type)) {
                    output += arg
                }
                else {
                    if (re.number.test(ph.type) && (!is_positive || ph.sign)) {
                        sign = is_positive ? '+' : '-'
                        arg = arg.toString().replace(re.sign, '')
                    }
                    else {
                        sign = ''
                    }
                    pad_character = ph.pad_char ? ph.pad_char === '0' ? '0' : ph.pad_char.charAt(1) : ' '
                    pad_length = ph.width - (sign + arg).length
                    pad = ph.width ? (pad_length > 0 ? pad_character.repeat(pad_length) : '') : ''
                    output += ph.align ? sign + arg + pad : (pad_character === '0' ? sign + pad + arg : pad + sign + arg)
                }
            }
        }
        return output
    }

    var sprintf_cache = Object.create(null)

    function sprintf_parse(fmt) {
        if (sprintf_cache[fmt]) {
            return sprintf_cache[fmt]
        }

        var _fmt = fmt, match, parse_tree = [], arg_names = 0
        while (_fmt) {
            if ((match = re.text.exec(_fmt)) !== null) {
                parse_tree.push(match[0])
            }
            else if ((match = re.modulo.exec(_fmt)) !== null) {
                parse_tree.push('%')
            }
            else if ((match = re.placeholder.exec(_fmt)) !== null) {
                if (match[2]) {
                    arg_names |= 1
                    var field_list = [], replacement_field = match[2], field_match = []
                    if ((field_match = re.key.exec(replacement_field)) !== null) {
                        field_list.push(field_match[1])
                        while ((replacement_field = replacement_field.substring(field_match[0].length)) !== '') {
                            if ((field_match = re.key_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else if ((field_match = re.index_access.exec(replacement_field)) !== null) {
                                field_list.push(field_match[1])
                            }
                            else {
                                throw new SyntaxError('[sprintf] failed to parse named argument key')
                            }
                        }
                    }
                    else {
                        throw new SyntaxError('[sprintf] failed to parse named argument key')
                    }
                    match[2] = field_list
                }
                else {
                    arg_names |= 2
                }
                if (arg_names === 3) {
                    throw new Error('[sprintf] mixing positional and named placeholders is not (yet) supported')
                }

                parse_tree.push(
                    {
                        placeholder: match[0],
                        param_no:    match[1],
                        keys:        match[2],
                        sign:        match[3],
                        pad_char:    match[4],
                        align:       match[5],
                        width:       match[6],
                        precision:   match[7],
                        type:        match[8]
                    }
                )
            }
            else {
                throw new SyntaxError('[sprintf] unexpected placeholder')
            }
            _fmt = _fmt.substring(match[0].length)
        }
        return sprintf_cache[fmt] = parse_tree
    }

    /**
     * export to either browser or node.js
     */
    /* eslint-disable quote-props */
    if (true) {
        exports['sprintf'] = sprintf
        exports['vsprintf'] = vsprintf
    }
    if (typeof window !== 'undefined') {
        window['sprintf'] = sprintf
        window['vsprintf'] = vsprintf

        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
                return {
                    'sprintf': sprintf,
                    'vsprintf': vsprintf
                }
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
        }
    }
    /* eslint-enable quote-props */
}(); // eslint-disable-line


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var patternParts = {
    value: '[-+]?(?:Infinity|[[0-9]*\\.?\\d*(?:[eE][-+]?\\d+)?)',
    leftBrace: '[\\(\\]\\[]',
    delimeter: ',',
    rightBrace: '[\\)\\]\\[]',
};
var PATTERN = new RegExp("(" + patternParts.leftBrace + ")" +
    ("(" + patternParts.value + ")?") +
    ("(" + patternParts.delimeter + ")?") +
    ("(" + patternParts.value + ")?") +
    ("(" + patternParts.rightBrace + ")"));
function execPattern(str) {
    var match = PATTERN.exec(str);
    if (!match) {
        return null;
    }
    var _ = match[0], leftBrace = match[1], fromValue = match[2], delimeter = match[3], toValue = match[4], rightBrace = match[5];
    return {
        leftBrace: leftBrace,
        fromValue: fromValue,
        delimeter: delimeter,
        toValue: toValue,
        rightBrace: rightBrace,
    };
}
function parse(str) {
    var match = execPattern(str);
    if (!match) {
        return null;
    }
    return {
        from: {
            value: match.fromValue !== undefined ?
                +match.fromValue :
                -Infinity,
            included: match.leftBrace === '['
        },
        to: {
            value: match.toValue !== undefined ?
                +match.toValue :
                (match.delimeter ?
                    +Infinity :
                    match.fromValue !== undefined ?
                        +match.fromValue :
                        NaN),
            included: match.rightBrace === ']'
        }
    };
}
function check(interval) {
    if (interval.from.value === interval.to.value) {
        return interval.from.included && interval.to.included;
    }
    return Math.min(interval.from.value, interval.to.value) === interval.from.value;
}
function entry(str) {
    var interval = parse(str);
    if (!interval || !check(interval)) {
        return null;
    }
    return interval;
}
exports.default = entry;


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

var require;var require;(function(f){if(true){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.MakePlural = f()}})(function(){var define,module,exports;return (function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return require(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * make-plural -- https://github.com/eemeli/make-plural
 * Copyright (c) 2014-2016 by Eemeli Aro <eemeli@gmail.com>
 *
 * Permission to use, copy, modify, and/or distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * The software is provided "as is" and the author disclaims all warranties
 * with regard to this software including all implied warranties of
 * merchantability and fitness. In no event shall the author be liable for
 * any special, direct, indirect, or consequential damages or any damages
 * whatsoever resulting from loss of use, data or profits, whether in an
 * action of contract, negligence or other tortious action, arising out of
 * or in connection with the use or performance of this software.
 */
var Parser =
/*#__PURE__*/
function () {
  function Parser() {
    _classCallCheck(this, Parser);
  }

  _createClass(Parser, [{
    key: "parse",
    value: function parse(cond) {
      var _this = this;

      if (cond === 'i = 0 or n = 1') return 'n >= 0 && n <= 1';
      if (cond === 'i = 0,1') return 'n >= 0 && n < 2';

      if (cond === 'i = 1 and v = 0') {
        this.v0 = 1;
        return 'n == 1 && v0';
      }

      return cond.replace(/([tv]) (!?)= 0/g, function (m, sym, noteq) {
        var sn = sym + '0';
        _this[sn] = 1;
        return noteq ? '!' + sn : sn;
      }).replace(/\b[fintv]\b/g, function (m) {
        _this[m] = 1;
        return m;
      }).replace(/([fin]) % (10+)/g, function (m, sym, num) {
        var sn = sym + num;
        _this[sn] = 1;
        return sn;
      }).replace(/n10+ = 0/g, 't0 && $&').replace(/(\w+ (!?)= )([0-9.]+,[0-9.,]+)/g, function (m, se, noteq, x) {
        if (m === 'n = 0,1') return '(n == 0 || n == 1)';
        if (noteq) return se + x.split(',').join(' && ' + se);
        return '(' + se + x.split(',').join(' || ' + se) + ')';
      }).replace(/(\w+) (!?)= ([0-9]+)\.\.([0-9]+)/g, function (m, sym, noteq, x0, x1) {
        if (Number(x0) + 1 === Number(x1)) {
          if (noteq) return "".concat(sym, " != ").concat(x0, " && ").concat(sym, " != ").concat(x1);
          return "(".concat(sym, " == ").concat(x0, " || ").concat(sym, " == ").concat(x1, ")");
        }

        if (noteq) return "(".concat(sym, " < ").concat(x0, " || ").concat(sym, " > ").concat(x1, ")");

        if (sym === 'n') {
          _this.t0 = 1;
          return "(t0 && n >= ".concat(x0, " && n <= ").concat(x1, ")");
        }

        return "(".concat(sym, " >= ").concat(x0, " && ").concat(sym, " <= ").concat(x1, ")");
      }).replace(/ and /g, ' && ').replace(/ or /g, ' || ').replace(/ = /g, ' == ');
    }
  }, {
    key: "vars",
    value: function vars() {
      var vars = [];
      if (this.i) vars.push('i = s[0]');
      if (this.f || this.v) vars.push("f = s[1] || ''");
      if (this.t) vars.push("t = (s[1] || '').replace(/0+$/, '')");
      if (this.v) vars.push('v = f.length');
      if (this.v0) vars.push('v0 = !s[1]');
      if (this.t0 || this.n10 || this.n100) vars.push('t0 = Number(s[0]) == n');

      for (var k in this) {
        if (/^.10+$/.test(k)) {
          var k0 = k[0] === 'n' ? 't0 && s[0]' : k[0];
          vars.push("".concat(k, " = ").concat(k0, ".slice(-").concat(k.substr(2).length, ")"));
        }
      }

      if (!vars.length) return '';
      return 'var ' + ["s = String(n).split('.')"].concat(vars).join(', ');
    }
  }]);

  return Parser;
}();

var Tests =
/*#__PURE__*/
function () {
  function Tests(obj) {
    _classCallCheck(this, Tests);

    this.obj = obj;
    this.ordinal = {};
    this.cardinal = {};
  }

  _createClass(Tests, [{
    key: "add",
    value: function add(type, cat, src) {
      this[type][cat] = {
        src: src,
        values: null
      };
    }
  }, {
    key: "testCond",
    value: function testCond(n, type, expResult, fn) {
      try {
        var r = (fn || this.obj.fn)(n, type === 'ordinal');
      } catch (e) {
        r = e.toString();
      }

      if (r !== expResult) {
        throw new Error('Locale ' + JSON.stringify(this.obj.lc) + type + ' rule self-test failed for v = ' + JSON.stringify(n) + ' (was ' + JSON.stringify(r) + ', expected ' + JSON.stringify(expResult) + ')');
      }

      return true;
    }
  }, {
    key: "testCat",
    value: function testCat(type, cat, fn) {
      var _this2 = this;

      var data = this[type][cat];

      if (!data.values) {
        data.values = data.src.join(' ').replace(/^[ ,]+|[ ,…]+$/g, '').replace(/(0\.[0-9])~(1\.[1-9])/g, '$1 1.0 $2').split(/[ ,~…]+/);
      }

      data.values.forEach(function (n) {
        _this2.testCond(n, type, cat, fn);

        if (!/\.0+$/.test(n)) _this2.testCond(Number(n), type, cat, fn);
      });
      return true;
    }
  }, {
    key: "testAll",
    value: function testAll() {
      for (var cat in this.cardinal) {
        this.testCat('cardinal', cat);
      }

      for (var _cat in this.ordinal) {
        this.testCat('ordinal', _cat);
      }

      return true;
    }
  }]);

  return Tests;
}();

var MakePlural =
/*#__PURE__*/
function () {
  function MakePlural(lc) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : MakePlural,
        cardinals = _ref.cardinals,
        ordinals = _ref.ordinals;

    _classCallCheck(this, MakePlural);

    if (!cardinals && !ordinals) throw new Error('At least one type of plural is required');
    this.lc = lc;
    this.categories = {
      cardinal: [],
      ordinal: []
    };
    this.parser = new Parser();
    this.tests = new Tests(this);
    this.fn = this.buildFunction(cardinals, ordinals);
    this.fn._obj = this;
    this.fn.categories = this.categories;

    this.fn.test = function () {
      return this.tests.testAll() && this.fn;
    }.bind(this);

    this.fn.toString = this.fnToString.bind(this);
    return this.fn;
  }

  _createClass(MakePlural, [{
    key: "compile",
    value: function compile(type, req) {
      var cases = [];
      var rules = MakePlural.getRules(type, this.lc);

      if (!rules) {
        if (req) throw new Error("Locale \"".concat(this.lc, "\" ").concat(type, " rules not found"));
        this.categories[type] = ['other'];
        return "'other'";
      }

      for (var r in rules) {
        var _rules$r$trim$split = rules[r].trim().split(/\s*@\w*/),
            _rules$r$trim$split2 = _toArray(_rules$r$trim$split),
            cond = _rules$r$trim$split2[0],
            examples = _rules$r$trim$split2.slice(1);

        var cat = r.replace('pluralRule-count-', '');
        if (cond) cases.push([this.parser.parse(cond), cat]);
        this.tests.add(type, cat, examples);
      }

      this.categories[type] = cases.map(function (c) {
        return c[1];
      }).concat('other');

      if (cases.length === 1) {
        return "(".concat(cases[0][0], ") ? '").concat(cases[0][1], "' : 'other'");
      } else {
        return _toConsumableArray(cases.map(function (c) {
          return "(".concat(c[0], ") ? '").concat(c[1], "'");
        })).concat(["'other'"]).join('\n      : ');
      }
    }
  }, {
    key: "buildFunction",
    value: function buildFunction(cardinals, ordinals) {
      var _this3 = this;

      var compile = function compile(c) {
        return c ? (c[1] ? 'return ' : 'if (ord) return ') + _this3.compile.apply(_this3, _toConsumableArray(c)) : '';
      };

      var fold = {
        vars: function vars(str) {
          return "  ".concat(str, ";").replace(/(.{1,78})(,|$) ?/g, '$1$2\n      ');
        },
        cond: function cond(str) {
          return "  ".concat(str, ";").replace(/(.{1,78}) (\|\| |$) ?/gm, '$1\n          $2');
        }
      };
      var cond = [ordinals && ['ordinal', !cardinals], cardinals && ['cardinal', true]].map(compile).map(fold.cond);
      var body = [fold.vars(this.parser.vars())].concat(_toConsumableArray(cond)).filter(function (line) {
        return !/^[\s;]*$/.test(line);
      }).map(function (line) {
        return line.replace(/\s+$/gm, '');
      }).join('\n');
      var args = ordinals && cardinals ? 'n, ord' : 'n';
      return new Function(args, body); // eslint-disable-line no-new-func
    }
  }, {
    key: "fnToString",
    value: function fnToString(name) {
      return Function.prototype.toString.call(this.fn).replace(/^function( \w+)?/, name ? 'function ' + name : 'function').replace(/\n\/\*(``)?\*\//, '');
    }
  }], [{
    key: "load",
    value: function load() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      args.forEach(function (cldr) {
        var data = cldr && cldr.supplemental || null;
        if (!data) throw new Error('Data does not appear to be CLDR data');
        MakePlural.rules = {
          cardinal: data['plurals-type-cardinal'] || MakePlural.rules.cardinal,
          ordinal: data['plurals-type-ordinal'] || MakePlural.rules.ordinal
        };
      });
      return MakePlural;
    }
  }, {
    key: "getRules",
    value: function getRules(type, locale) {
      if (locale.length) {
        var cat = MakePlural.rules[type];
        if (locale in cat) return cat[locale];
        var lc0 = locale.toLowerCase();

        for (var lc in cat) {
          if (lc.toLowerCase() === lc0) return cat[lc];
        }
      }

      return null;
    }
  }]);

  return MakePlural;
}();

exports.default = MakePlural;
MakePlural.cardinals = true;
MakePlural.ordinals = false;
MakePlural.rules = {
  cardinal: {},
  ordinal: {}
};
module.exports = exports.default;

},{}]},{},[1])(1)
});


/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = {"supplemental":{"version":{"_number":"$Revision: 14397 $","_unicodeVersion":"11.0.0","_cldrVersion":"34"},"plurals-type-cardinal":{"af":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ak":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"am":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ar":{"pluralRule-count-zero":"n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000","pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-few":"n % 100 = 3..10 @integer 3~10, 103~110, 1003, … @decimal 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 103.0, 1003.0, …","pluralRule-count-many":"n % 100 = 11..99 @integer 11~26, 111, 1011, … @decimal 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 111.0, 1011.0, …","pluralRule-count-other":" @integer 100~102, 200~202, 300~302, 400~402, 500~502, 600, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ars":{"pluralRule-count-zero":"n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000","pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-few":"n % 100 = 3..10 @integer 3~10, 103~110, 1003, … @decimal 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 103.0, 1003.0, …","pluralRule-count-many":"n % 100 = 11..99 @integer 11~26, 111, 1011, … @decimal 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 111.0, 1011.0, …","pluralRule-count-other":" @integer 100~102, 200~202, 300~302, 400~402, 500~502, 600, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"as":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"asa":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ast":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"az":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"be":{"pluralRule-count-one":"n % 10 = 1 and n % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 1.0, 21.0, 31.0, 41.0, 51.0, 61.0, 71.0, 81.0, 101.0, 1001.0, …","pluralRule-count-few":"n % 10 = 2..4 and n % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 2.0, 3.0, 4.0, 22.0, 23.0, 24.0, 32.0, 33.0, 102.0, 1002.0, …","pluralRule-count-many":"n % 10 = 0 or n % 10 = 5..9 or n % 100 = 11..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 11.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":"   @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.1, 1000.1, …"},"bem":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"bez":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"bg":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"bh":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"bm":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"bn":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"bo":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"br":{"pluralRule-count-one":"n % 10 = 1 and n % 100 != 11,71,91 @integer 1, 21, 31, 41, 51, 61, 81, 101, 1001, … @decimal 1.0, 21.0, 31.0, 41.0, 51.0, 61.0, 81.0, 101.0, 1001.0, …","pluralRule-count-two":"n % 10 = 2 and n % 100 != 12,72,92 @integer 2, 22, 32, 42, 52, 62, 82, 102, 1002, … @decimal 2.0, 22.0, 32.0, 42.0, 52.0, 62.0, 82.0, 102.0, 1002.0, …","pluralRule-count-few":"n % 10 = 3..4,9 and n % 100 != 10..19,70..79,90..99 @integer 3, 4, 9, 23, 24, 29, 33, 34, 39, 43, 44, 49, 103, 1003, … @decimal 3.0, 4.0, 9.0, 23.0, 24.0, 29.0, 33.0, 34.0, 103.0, 1003.0, …","pluralRule-count-many":"n != 0 and n % 1000000 = 0 @integer 1000000, … @decimal 1000000.0, 1000000.00, 1000000.000, …","pluralRule-count-other":" @integer 0, 5~8, 10~20, 100, 1000, 10000, 100000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, …"},"brx":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"bs":{"pluralRule-count-one":"v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-few":"v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ca":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ce":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"cgg":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"chr":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ckb":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"cs":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-few":"i = 2..4 and v = 0 @integer 2~4","pluralRule-count-many":"v != 0   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"},"cy":{"pluralRule-count-zero":"n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000","pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-few":"n = 3 @integer 3 @decimal 3.0, 3.00, 3.000, 3.0000","pluralRule-count-many":"n = 6 @integer 6 @decimal 6.0, 6.00, 6.000, 6.0000","pluralRule-count-other":" @integer 4, 5, 7~20, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"da":{"pluralRule-count-one":"n = 1 or t != 0 and i = 0,1 @integer 1 @decimal 0.1~1.6","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 2.0~3.4, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"de":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"dsb":{"pluralRule-count-one":"v = 0 and i % 100 = 1 or f % 100 = 1 @integer 1, 101, 201, 301, 401, 501, 601, 701, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-two":"v = 0 and i % 100 = 2 or f % 100 = 2 @integer 2, 102, 202, 302, 402, 502, 602, 702, 1002, … @decimal 0.2, 1.2, 2.2, 3.2, 4.2, 5.2, 6.2, 7.2, 10.2, 100.2, 1000.2, …","pluralRule-count-few":"v = 0 and i % 100 = 3..4 or f % 100 = 3..4 @integer 3, 4, 103, 104, 203, 204, 303, 304, 403, 404, 503, 504, 603, 604, 703, 704, 1003, … @decimal 0.3, 0.4, 1.3, 1.4, 2.3, 2.4, 3.3, 3.4, 4.3, 4.4, 5.3, 5.4, 6.3, 6.4, 7.3, 7.4, 10.3, 100.3, 1000.3, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"dv":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"dz":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ee":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"el":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"en":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"eo":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"es":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"et":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"eu":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"fa":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ff":{"pluralRule-count-one":"i = 0,1 @integer 0, 1 @decimal 0.0~1.5","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"fi":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"fil":{"pluralRule-count-one":"v = 0 and i = 1,2,3 or v = 0 and i % 10 != 4,6,9 or v != 0 and f % 10 != 4,6,9 @integer 0~3, 5, 7, 8, 10~13, 15, 17, 18, 20, 21, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.3, 0.5, 0.7, 0.8, 1.0~1.3, 1.5, 1.7, 1.8, 2.0, 2.1, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 4, 6, 9, 14, 16, 19, 24, 26, 104, 1004, … @decimal 0.4, 0.6, 0.9, 1.4, 1.6, 1.9, 2.4, 2.6, 10.4, 100.4, 1000.4, …"},"fo":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"fr":{"pluralRule-count-one":"i = 0,1 @integer 0, 1 @decimal 0.0~1.5","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"fur":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"fy":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ga":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-few":"n = 3..6 @integer 3~6 @decimal 3.0, 4.0, 5.0, 6.0, 3.00, 4.00, 5.00, 6.00, 3.000, 4.000, 5.000, 6.000, 3.0000, 4.0000, 5.0000, 6.0000","pluralRule-count-many":"n = 7..10 @integer 7~10 @decimal 7.0, 8.0, 9.0, 10.0, 7.00, 8.00, 9.00, 10.00, 7.000, 8.000, 9.000, 10.000, 7.0000, 8.0000, 9.0000, 10.0000","pluralRule-count-other":" @integer 0, 11~25, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"gd":{"pluralRule-count-one":"n = 1,11 @integer 1, 11 @decimal 1.0, 11.0, 1.00, 11.00, 1.000, 11.000, 1.0000","pluralRule-count-two":"n = 2,12 @integer 2, 12 @decimal 2.0, 12.0, 2.00, 12.00, 2.000, 12.000, 2.0000","pluralRule-count-few":"n = 3..10,13..19 @integer 3~10, 13~19 @decimal 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 3.00","pluralRule-count-other":" @integer 0, 20~34, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"gl":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"gsw":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"gu":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"guw":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"gv":{"pluralRule-count-one":"v = 0 and i % 10 = 1 @integer 1, 11, 21, 31, 41, 51, 61, 71, 101, 1001, …","pluralRule-count-two":"v = 0 and i % 10 = 2 @integer 2, 12, 22, 32, 42, 52, 62, 72, 102, 1002, …","pluralRule-count-few":"v = 0 and i % 100 = 0,20,40,60,80 @integer 0, 20, 40, 60, 80, 100, 120, 140, 1000, 10000, 100000, 1000000, …","pluralRule-count-many":"v != 0   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 3~10, 13~19, 23, 103, 1003, …"},"ha":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"haw":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"he":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-two":"i = 2 and v = 0 @integer 2","pluralRule-count-many":"v = 0 and n != 0..10 and n % 10 = 0 @integer 20, 30, 40, 50, 60, 70, 80, 90, 100, 1000, 10000, 100000, 1000000, …","pluralRule-count-other":" @integer 0, 3~17, 101, 1001, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"hi":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"hr":{"pluralRule-count-one":"v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-few":"v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"hsb":{"pluralRule-count-one":"v = 0 and i % 100 = 1 or f % 100 = 1 @integer 1, 101, 201, 301, 401, 501, 601, 701, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-two":"v = 0 and i % 100 = 2 or f % 100 = 2 @integer 2, 102, 202, 302, 402, 502, 602, 702, 1002, … @decimal 0.2, 1.2, 2.2, 3.2, 4.2, 5.2, 6.2, 7.2, 10.2, 100.2, 1000.2, …","pluralRule-count-few":"v = 0 and i % 100 = 3..4 or f % 100 = 3..4 @integer 3, 4, 103, 104, 203, 204, 303, 304, 403, 404, 503, 504, 603, 604, 703, 704, 1003, … @decimal 0.3, 0.4, 1.3, 1.4, 2.3, 2.4, 3.3, 3.4, 4.3, 4.4, 5.3, 5.4, 6.3, 6.4, 7.3, 7.4, 10.3, 100.3, 1000.3, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"hu":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"hy":{"pluralRule-count-one":"i = 0,1 @integer 0, 1 @decimal 0.0~1.5","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ia":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"id":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ig":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ii":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"in":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"io":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"is":{"pluralRule-count-one":"t = 0 and i % 10 = 1 and i % 100 != 11 or t != 0 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1~1.6, 10.1, 100.1, 1000.1, …","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"it":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"iu":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"iw":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-two":"i = 2 and v = 0 @integer 2","pluralRule-count-many":"v = 0 and n != 0..10 and n % 10 = 0 @integer 20, 30, 40, 50, 60, 70, 80, 90, 100, 1000, 10000, 100000, 1000000, …","pluralRule-count-other":" @integer 0, 3~17, 101, 1001, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ja":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"jbo":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"jgo":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ji":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"jmc":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"jv":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"jw":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ka":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kab":{"pluralRule-count-one":"i = 0,1 @integer 0, 1 @decimal 0.0~1.5","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kaj":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kcg":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kde":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kea":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kk":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kkj":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kl":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"km":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kn":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ko":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ks":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ksb":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ksh":{"pluralRule-count-zero":"n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000","pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ku":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"kw":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ky":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"lag":{"pluralRule-count-zero":"n = 0 @integer 0 @decimal 0.0, 0.00, 0.000, 0.0000","pluralRule-count-one":"i = 0,1 and n != 0 @integer 1 @decimal 0.1~1.6","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"lb":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"lg":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"lkt":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ln":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"lo":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"lt":{"pluralRule-count-one":"n % 10 = 1 and n % 100 != 11..19 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 1.0, 21.0, 31.0, 41.0, 51.0, 61.0, 71.0, 81.0, 101.0, 1001.0, …","pluralRule-count-few":"n % 10 = 2..9 and n % 100 != 11..19 @integer 2~9, 22~29, 102, 1002, … @decimal 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 22.0, 102.0, 1002.0, …","pluralRule-count-many":"f != 0   @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.1, 1000.1, …","pluralRule-count-other":" @integer 0, 10~20, 30, 40, 50, 60, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"lv":{"pluralRule-count-zero":"n % 10 = 0 or n % 100 = 11..19 or v = 2 and f % 100 = 11..19 @integer 0, 10~20, 30, 40, 50, 60, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-one":"n % 10 = 1 and n % 100 != 11 or v = 2 and f % 10 = 1 and f % 100 != 11 or v != 2 and f % 10 = 1 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.0, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-other":" @integer 2~9, 22~29, 102, 1002, … @decimal 0.2~0.9, 1.2~1.9, 10.2, 100.2, 1000.2, …"},"mas":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"mg":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"mgo":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"mk":{"pluralRule-count-one":"v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.2~1.0, 1.2~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ml":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"mn":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"mo":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-few":"v != 0 or n = 0 or n != 1 and n % 100 = 1..19 @integer 0, 2~16, 101, 1001, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 20~35, 100, 1000, 10000, 100000, 1000000, …"},"mr":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ms":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"mt":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-few":"n = 0 or n % 100 = 2..10 @integer 0, 2~10, 102~107, 1002, … @decimal 0.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 10.0, 102.0, 1002.0, …","pluralRule-count-many":"n % 100 = 11..19 @integer 11~19, 111~117, 1011, … @decimal 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 111.0, 1011.0, …","pluralRule-count-other":" @integer 20~35, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"my":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nah":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"naq":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nb":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nd":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ne":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nl":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nn":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nnh":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"no":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nqo":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nr":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nso":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ny":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"nyn":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"om":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"or":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"os":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"pa":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"pap":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"pl":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-few":"v = 0 and i % 10 = 2..4 and i % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, …","pluralRule-count-many":"v = 0 and i != 1 and i % 10 = 0..1 or v = 0 and i % 10 = 5..9 or v = 0 and i % 100 = 12..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …","pluralRule-count-other":"   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"prg":{"pluralRule-count-zero":"n % 10 = 0 or n % 100 = 11..19 or v = 2 and f % 100 = 11..19 @integer 0, 10~20, 30, 40, 50, 60, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 10.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-one":"n % 10 = 1 and n % 100 != 11 or v = 2 and f % 10 = 1 and f % 100 != 11 or v != 2 and f % 10 = 1 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.0, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-other":" @integer 2~9, 22~29, 102, 1002, … @decimal 0.2~0.9, 1.2~1.9, 10.2, 100.2, 1000.2, …"},"ps":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"pt":{"pluralRule-count-one":"i = 0..1 @integer 0, 1 @decimal 0.0~1.5","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 2.0~3.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"pt-PT":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"rm":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ro":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-few":"v != 0 or n = 0 or n != 1 and n % 100 = 1..19 @integer 0, 2~16, 101, 1001, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 20~35, 100, 1000, 10000, 100000, 1000000, …"},"rof":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"root":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ru":{"pluralRule-count-one":"v = 0 and i % 10 = 1 and i % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, …","pluralRule-count-few":"v = 0 and i % 10 = 2..4 and i % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, …","pluralRule-count-many":"v = 0 and i % 10 = 0 or v = 0 and i % 10 = 5..9 or v = 0 and i % 100 = 11..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …","pluralRule-count-other":"   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"rwk":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sah":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"saq":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sc":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"scn":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sd":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sdh":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"se":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"seh":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ses":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sg":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sh":{"pluralRule-count-one":"v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-few":"v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"shi":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-few":"n = 2..10 @integer 2~10 @decimal 2.0, 3.0, 4.0, 5.0, 6.0, 7.0, 8.0, 9.0, 10.0, 2.00, 3.00, 4.00, 5.00, 6.00, 7.00, 8.00","pluralRule-count-other":" @integer 11~26, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~1.9, 2.1~2.7, 10.1, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"si":{"pluralRule-count-one":"n = 0,1 or i = 0 and f = 1 @integer 0, 1 @decimal 0.0, 0.1, 1.0, 0.00, 0.01, 1.00, 0.000, 0.001, 1.000, 0.0000, 0.0001, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.2~0.9, 1.1~1.8, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sk":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-few":"i = 2..4 and v = 0 @integer 2~4","pluralRule-count-many":"v != 0   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"},"sl":{"pluralRule-count-one":"v = 0 and i % 100 = 1 @integer 1, 101, 201, 301, 401, 501, 601, 701, 1001, …","pluralRule-count-two":"v = 0 and i % 100 = 2 @integer 2, 102, 202, 302, 402, 502, 602, 702, 1002, …","pluralRule-count-few":"v = 0 and i % 100 = 3..4 or v != 0 @integer 3, 4, 103, 104, 203, 204, 303, 304, 403, 404, 503, 504, 603, 604, 703, 704, 1003, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …"},"sma":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"smi":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"smj":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"smn":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sms":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-two":"n = 2 @integer 2 @decimal 2.0, 2.00, 2.000, 2.0000","pluralRule-count-other":" @integer 0, 3~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sn":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"so":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sq":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sr":{"pluralRule-count-one":"v = 0 and i % 10 = 1 and i % 100 != 11 or f % 10 = 1 and f % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, … @decimal 0.1, 1.1, 2.1, 3.1, 4.1, 5.1, 6.1, 7.1, 10.1, 100.1, 1000.1, …","pluralRule-count-few":"v = 0 and i % 10 = 2..4 and i % 100 != 12..14 or f % 10 = 2..4 and f % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, … @decimal 0.2~0.4, 1.2~1.4, 2.2~2.4, 3.2~3.4, 4.2~4.4, 5.2, 10.2, 100.2, 1000.2, …","pluralRule-count-other":" @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0, 0.5~1.0, 1.5~2.0, 2.5~2.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ss":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ssy":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"st":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sv":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"sw":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"syr":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ta":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"te":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"teo":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"th":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ti":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"tig":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"tk":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"tl":{"pluralRule-count-one":"v = 0 and i = 1,2,3 or v = 0 and i % 10 != 4,6,9 or v != 0 and f % 10 != 4,6,9 @integer 0~3, 5, 7, 8, 10~13, 15, 17, 18, 20, 21, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.3, 0.5, 0.7, 0.8, 1.0~1.3, 1.5, 1.7, 1.8, 2.0, 2.1, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …","pluralRule-count-other":" @integer 4, 6, 9, 14, 16, 19, 24, 26, 104, 1004, … @decimal 0.4, 0.6, 0.9, 1.4, 1.6, 1.9, 2.4, 2.6, 10.4, 100.4, 1000.4, …"},"tn":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"to":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"tr":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ts":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"tzm":{"pluralRule-count-one":"n = 0..1 or n = 11..99 @integer 0, 1, 11~24 @decimal 0.0, 1.0, 11.0, 12.0, 13.0, 14.0, 15.0, 16.0, 17.0, 18.0, 19.0, 20.0, 21.0, 22.0, 23.0, 24.0","pluralRule-count-other":" @integer 2~10, 100~106, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ug":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"uk":{"pluralRule-count-one":"v = 0 and i % 10 = 1 and i % 100 != 11 @integer 1, 21, 31, 41, 51, 61, 71, 81, 101, 1001, …","pluralRule-count-few":"v = 0 and i % 10 = 2..4 and i % 100 != 12..14 @integer 2~4, 22~24, 32~34, 42~44, 52~54, 62, 102, 1002, …","pluralRule-count-many":"v = 0 and i % 10 = 0 or v = 0 and i % 10 = 5..9 or v = 0 and i % 100 = 11..14 @integer 0, 5~19, 100, 1000, 10000, 100000, 1000000, …","pluralRule-count-other":"   @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ur":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"uz":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"ve":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"vi":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"vo":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"vun":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"wa":{"pluralRule-count-one":"n = 0..1 @integer 0, 1 @decimal 0.0, 1.0, 0.00, 1.00, 0.000, 1.000, 0.0000, 1.0000","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 0.1~0.9, 1.1~1.7, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"wae":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"wo":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"xh":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"xog":{"pluralRule-count-one":"n = 1 @integer 1 @decimal 1.0, 1.00, 1.000, 1.0000","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~0.9, 1.1~1.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"yi":{"pluralRule-count-one":"i = 1 and v = 0 @integer 1","pluralRule-count-other":" @integer 0, 2~16, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"yo":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"yue":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"zh":{"pluralRule-count-other":" @integer 0~15, 100, 1000, 10000, 100000, 1000000, … @decimal 0.0~1.5, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"},"zu":{"pluralRule-count-one":"i = 0 or n = 1 @integer 0, 1 @decimal 0.0~1.0, 0.00~0.04","pluralRule-count-other":" @integer 2~17, 100, 1000, 10000, 100000, 1000000, … @decimal 1.1~2.6, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, …"}}}}

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

/** @file messageformat.js - ICU PluralFormat + SelectFormat for JavaScript
 *
 * @author Alex Sexton - @SlexAxton, Eemeli Aro - @eemeli_aro
 * @copyright 2012-2016 Alex Sexton, Eemeli Aro, and Contributors
 * @license To use or fork, MIT. To contribute back, JS Foundation CLA
 */

var Compiler = __webpack_require__(228);
var Runtime = __webpack_require__(507);


/** Utility getter/wrapper for pluralization functions from
 *  {@link http://github.com/eemeli/make-plural.js make-plural}
 *
 * @private
 */
function getPluralFunc(locale, noPluralKeyChecks) {
  var plurals = __webpack_require__(508);
  var pluralCategories = __webpack_require__(509);
  for (var l = locale; l; l = l.replace(/[-_]?[^-_]*$/, '')) {
    var pf = plurals[l];
    if (pf) {
      var pc = noPluralKeyChecks ? { cardinal: [], ordinal: [] } : (pluralCategories[l] || {});
      var fn = function() { return pf.apply(this, arguments); };
      fn.toString = function() { return pf.toString(); };
      fn.cardinal = pc.cardinal;
      fn.ordinal = pc.ordinal;
      return fn;
    }
  }
  throw new Error('Localisation function not found for locale ' + JSON.stringify(locale));
}


/** Create a new message formatter
 *
 *  If `locale` is not set, calls to `compile()` will fetch the default locale
 *  each time. A string `locale` will create a single-locale MessageFormat
 *  instance, with pluralisation rules fetched from the Unicode CLDR using
 *  {@link http://github.com/eemeli/make-plural.js make-plural}.
 *
 *  Using an array of strings as `locale` will create a MessageFormat object
 *  with multi-language support, with pluralisation rules fetched as above. To
 *  select which to use, use the second parameter of `compile()`, or use message
 *  keys corresponding to your locales.
 *
 *  Using an object `locale` with all properties of type `function` allows for
 *  the use of custom/externally defined pluralisation rules.
 *
 * @class
 * @param {string|string[]|Object.<string,function>} [locale] - The locale(s) to use
 */
function MessageFormat(locale) {
  this.pluralFuncs = {};
  if (locale) {
    if (typeof locale == 'string') {
      this.pluralFuncs[locale] = getPluralFunc(locale);
    } else if (Array.isArray(locale)) {
      locale.forEach(function(lc) { this.pluralFuncs[lc] = getPluralFunc(lc); }, this);
    } else if (typeof locale == 'object') {
      for (var lc in locale) if (locale.hasOwnProperty(lc)) {
        if (typeof locale[lc] != 'function') throw new Error('Expected function value for locale ' + JSON.stringify(lc));
        this.pluralFuncs[lc] = locale[lc];
      }
      this.hasCustomPluralFuncs = true;
    }
  }
  this.fmt = {};
  this.runtime = new Runtime(this);
}


/** The default locale
 *
 *  Read by `compile()` when no locale has been previously set
 *
 * @memberof MessageFormat
 * @default 'en'
 */
MessageFormat.defaultLocale = 'en';


/** Escape special characaters
 *
 *  Prefix the characters `#`, `{`, `}` and `\` in the input string with a `\`.
 *  This will allow those characters to not be considered as MessageFormat
 *  control characters.
 *
 * @param {string} str - The input string
 * @returns {string} The escaped string
 */
MessageFormat.escape = function(str) {
  return str.replace(/[#{}\\]/g, '\\$&');
}


/** Default number formatting functions in the style of ICU's
 *  {@link http://icu-project.org/apiref/icu4j/com/ibm/icu/text/MessageFormat.html simpleArg syntax}
 *  implemented using the
 *  {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl Intl}
 *  object defined by ECMA-402.
 *
 *  **Note**: Intl is not defined in default Node until 0.11.15 / 0.12.0, so
 *  earlier versions require a {@link https://www.npmjs.com/package/intl polyfill}.
 *  Therefore {@link MessageFormat.intlSupport} needs to be true for these default
 *  functions to be available for inclusion in the output.
 *
 * @see MessageFormat#setIntlSupport
 *
 * @namespace
 */
MessageFormat.formatters = {


  /** Represent a number as an integer, percent or currency value
   *
   *  Available in MessageFormat strings as `{VAR, number, integer|percent|currency}`.
   *  Internally, calls Intl.NumberFormat with appropriate parameters. `currency` will
   *  default to USD; to change, set `MessageFormat#currency` to the appropriate
   *  three-letter currency code.
   *
   * @param {number} value - The value to operate on
   * @param {string} type - One of `'integer'`, `'percent'` , or `currency`
   *
   * @example
   * var mf = new MessageFormat('en').setIntlSupport(true);
   * mf.currency = 'EUR';  // needs to be set before first compile() call
   *
   * mf.compile('{N} is almost {N, number, integer}')({ N: 3.14 })
   * // '3.14 is almost 3'
   *
   * mf.compile('{P, number, percent} complete')({ P: 0.99 })
   * // '99% complete'
   *
   * mf.compile('The total is {V, number, currency}.')({ V: 5.5 })
   * // 'The total is €5.50.'
   */
  number: function(self) {
    return new Function("v,lc,p",
      "return new Intl.NumberFormat(lc,\n" +
      "    p=='integer' ? {maximumFractionDigits:0}\n" +
      "  : p=='percent' ? {style:'percent'}\n" +
      "  : p=='currency' ? {style:'currency', currency:'" + (self.currency || 'USD') + "', minimumFractionDigits:2, maximumFractionDigits:2}\n" +
      "  : {}).format(v)"
    );
  },


  /** Represent a date as a short/default/long/full string
   *
   * The input value needs to be in a form that the
   * {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date Date object}
   * can process using its single-argument form, `new Date(value)`.
   *
   * @param {number|string} value - Either a Unix epoch time in milliseconds, or a string value representing a date
   * @param {string} [type='default'] - One of `'short'`, `'default'`, `'long'` , or `full`
   *
   * @example
   * var mf = new MessageFormat(['en', 'fi']).setIntlSupport(true);
   *
   * mf.compile('Today is {T, date}')({ T: Date.now() })
   * // 'Today is Feb 21, 2016'
   *
   * mf.compile('Tänään on {T, date}', 'fi')({ T: Date.now() })
   * // 'Tänään on 21. helmikuuta 2016'
   *
   * mf.compile('Unix time started on {T, date, full}')({ T: 0 })
   * // 'Unix time started on Thursday, January 1, 1970'
   *
   * var cf = mf.compile('{sys} became operational on {d0, date, short}');
   * cf({ sys: 'HAL 9000', d0: '12 January 1999' })
   * // 'HAL 9000 became operational on 1/12/1999'
   */
  date: function(v,lc,p) {
    var o = {day:'numeric', month:'short', year:'numeric'};
    switch (p) {
      case 'full': o.weekday = 'long';
      case 'long': o.month = 'long'; break;
      case 'short': o.month = 'numeric';
    }
    return (new Date(v)).toLocaleDateString(lc, o)
  },


  /** Represent a time as a short/default/long string
   *
   * The input value needs to be in a form that the
   * {@link https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Date Date object}
   * can process using its single-argument form, `new Date(value)`.
   *
   * @param {number|string} value - Either a Unix epoch time in milliseconds, or a string value representing a date
   * @param {string} [type='default'] - One of `'short'`, `'default'`, `'long'` , or `full`
   *
   * @example
   * var mf = new MessageFormat(['en', 'fi']).setIntlSupport(true);
   *
   * mf.compile('The time is now {T, time}')({ T: Date.now() })
   * // 'The time is now 11:26:35 PM'
   *
   * mf.compile('Kello on nyt {T, time}', 'fi')({ T: Date.now() })
   * // 'Kello on nyt 23.26.35'
   *
   * var cf = mf.compile('The Eagle landed at {T, time, full} on {T, date, full}');
   * cf({ T: '1969-07-20 20:17:40 UTC' })
   * // 'The Eagle landed at 10:17:40 PM GMT+2 on Sunday, July 20, 1969'
   */
  time: function(v,lc,p) {
    var o = {second:'numeric', minute:'numeric', hour:'numeric'};
    switch (p) {
      case 'full': case 'long': o.timeZoneName = 'short'; break;
      case 'short': delete o.second;
    }
    return (new Date(v)).toLocaleTimeString(lc, o)
  }
};


/** Add custom formatter functions to this MessageFormat instance
 *
 *  The general syntax for calling a formatting function in MessageFormat is
 *  `{var, fn[, args]*}`, where `var` is the variable that will be set by the
 *  user code, `fn` determines the formatting function, and `args` is an
 *  optional comma-separated list of additional arguments.
 *
 *  In JavaScript, each formatting function is called with three parameters;
 *  the variable value `v`, the current locale `lc`, and (if set) `args` as a
 *  single string, or an array of strings. Formatting functions should not have
 *  side effects.
 *
 * @see MessageFormat.formatters
 *
 * @memberof MessageFormat
 * @param {Object.<string,function>} fmt - A map of formatting functions
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * var mf = new MessageFormat('en-GB');
 * mf.addFormatters({
 *   upcase: function(v) { return v.toUpperCase(); },
 *   locale: function(v, lc) { return lc; },
 *   prop: function(v, lc, p) { return v[p] }
 * });
 *
 * mf.compile('This is {VAR, upcase}.')({ VAR: 'big' })
 * // 'This is BIG.'
 *
 * mf.compile('The current locale is {_, locale}.')({ _: '' })
 * // 'The current locale is en-GB.'
 *
 * mf.compile('Answer: {obj, prop, a}')({ obj: {q: 3, a: 42} })
 * // 'Answer: 42'
 */
MessageFormat.prototype.addFormatters = function(fmt) {
  for (var name in fmt) if (fmt.hasOwnProperty(name)) {
    this.fmt[name] = fmt[name];
  }
  return this;
};


/** Disable the validation of plural & selectordinal keys
 *
 *  Previous versions of messageformat.js allowed the use of plural &
 *  selectordinal statements with any keys; now we throw an error when a
 *  statement uses a non-numerical key that will never be matched as a
 *  pluralization category for the current locale.
 *
 *  Use this method to disable the validation and allow usage as previously.
 *  To re-enable, you'll need to create a new MessageFormat instance.
 *
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * var mf = new MessageFormat('en');
 * var msg = '{X, plural, zero{no answers} one{an answer} other{# answers}}';
 *
 * mf.compile(msg);
 * // Error: Invalid key `zero` for argument `X`. Valid plural keys for this
 * //        locale are `one`, `other`, and explicit keys like `=0`.
 *
 * mf.disablePluralKeyChecks();
 * mf.compile(msg)({ X: 0 });
 * // '0 answers'
 */
MessageFormat.prototype.disablePluralKeyChecks = function() {
  this.noPluralKeyChecks = true;
  for (var lc in this.pluralFuncs) if (this.pluralFuncs.hasOwnProperty(lc)) {
    this.pluralFuncs[lc].cardinal = [];
    this.pluralFuncs[lc].ordinal = [];
  }
  return this;
};


/** Enable or disable the addition of Unicode control characters to all input
 *  to preserve the integrity of the output when mixing LTR and RTL text.
 *
 * @see http://cldr.unicode.org/development/development-process/design-proposals/bidi-handling-of-structured-text
 *
 * @memberof MessageFormat
 * @param {boolean} [enable=true]
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * // upper case stands for RTL characters, output is shown as rendered
 * var mf = new MessageFormat('en');
 *
 * mf.compile('{0} >> {1} >> {2}')(['first', 'SECOND', 'THIRD']);
 * // 'first >> THIRD << SECOND'
 *
 * mf.setBiDiSupport(true);
 * mf.compile('{0} >> {1} >> {2}')(['first', 'SECOND', 'THIRD']);
 * // 'first >> SECOND >> THIRD'
 */
MessageFormat.prototype.setBiDiSupport = function(enable) {
    this.bidiSupport = !!enable || (typeof enable == 'undefined');
    return this;
};


/** Enable or disable support for the default formatters, which require the
 *  `Intl` object. Note that this can't be autodetected, as the environment
 *  in which the formatted text is compiled into Javascript functions is not
 *  necessarily the same environment in which they will get executed.
 *
 * @see MessageFormat.formatters
 *
 * @memberof MessageFormat
 * @param {boolean} [enable=true]
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 */
MessageFormat.prototype.setIntlSupport = function(enable) {
    this.intlSupport = !!enable || (typeof enable == 'undefined');
    return this;
};


/** According to the ICU MessageFormat spec, a `#` character directly inside a
 *  `plural` or `selectordinal` statement should be replaced by the number
 *  matching the surrounding statement. By default, messageformat.js will
 *  replace `#` signs with the value of the nearest surrounding `plural` or
 *  `selectordinal` statement.
 *
 *  Set this to true to follow the stricter ICU MessageFormat spec, and to
 *  throw a runtime error if `#` is used with non-numeric input.
 *
 * @memberof MessageFormat
 * @param {boolean} [enable=true]
 * @returns {MessageFormat} The MessageFormat instance, to allow for chaining
 *
 * @example
 * var mf = new MessageFormat('en');
 *
 * var cookieMsg = '#: {X, plural, =0{no cookies} one{a cookie} other{# cookies}}';
 * mf.compile(cookieMsg)({ X: 3 });
 * // '#: 3 cookies'
 *
 * var pastryMsg = '{X, plural, one{{P, select, cookie{a cookie} other{a pie}}} other{{P, select, cookie{# cookies} other{# pies}}}}';
 * mf.compile(pastryMsg)({ X: 3, P: 'pie' });
 * // '3 pies'
 *
 * mf.setStrictNumberSign(true);
 * mf.compile(pastryMsg)({ X: 3, P: 'pie' });
 * // '# pies'
 */
MessageFormat.prototype.setStrictNumberSign = function(enable) {
    this.strictNumberSign = !!enable || (typeof enable == 'undefined');
    this.runtime.setStrictNumber(this.strictNumberSign);
    return this;
};


/** Compile messages into storable functions
 *
 *  If `messages` is a single string including ICU MessageFormat declarations,
 *  the result of `compile()` is a function taking a single Object parameter
 *  `d` representing each of the input's defined variables.
 *
 *  If `messages` is a hierarchical structure of such strings, the output of
 *  `compile()` will match that structure, with each string replaced by its
 *  corresponding JavaScript function.
 *
 *  If the input `messages` -- and therefore the output -- of `compile()` is an
 *  object, the output object will have a `toString(global)` method that may be
 *  used to store or cache the compiled functions to disk, for later inclusion
 *  in any JS environment, without a local MessageFormat instance required. Its
 *  `global` parameters sets the name (if any) of the resulting global variable,
 *  with special handling for `exports`, `module.exports`, and `export default`.
 *  If `global` does not contain a `.`, the output defaults to an UMD pattern.
 *
 *  If `locale` is not set, the first locale set in the object's constructor
 *  will be used by default; using a key at any depth of `messages` that is a
 *  declared locale will set its child elements to use that locale.
 *
 *  If `locale` is set, it is used for all messages. If the constructor
 *  declared any locales, `locale` needs to be one of them.
 *
 * @memberof MessageFormat
 * @param {string|Object} messages - The input message(s) to be compiled, in ICU MessageFormat
 * @param {string} [locale] - A locale to use for the messages
 * @returns {function|Object} The first match found for the given locale(s)
 *
 * @example
 * var mf = new MessageFormat('en');
 * var cf = mf.compile('A {TYPE} example.');
 *
 * cf({ TYPE: 'simple' })
 * // 'A simple example.'
 *
 * @example
 * var mf = new MessageFormat(['en', 'fi']);
 * var cf = mf.compile({
 *   en: { a: 'A {TYPE} example.',
 *         b: 'This is the {COUNT, selectordinal, one{#st} two{#nd} few{#rd} other{#th}} example.' },
 *   fi: { a: '{TYPE} esimerkki.',
 *         b: 'Tämä on {COUNT, selectordinal, other{#.}} esimerkki.' }
 * });
 *
 * cf.en.b({ COUNT: 2 })
 * // 'This is the 2nd example.'
 *
 * cf.fi.b({ COUNT: 2 })
 * // 'Tämä on 2. esimerkki.'
 *
 * @example
 * var fs = require('fs');
 * var mf = new MessageFormat('en').setIntlSupport();
 * var msgSet = {
 *   a: 'A {TYPE} example.',
 *   b: 'This has {COUNT, plural, one{one member} other{# members}}.',
 *   c: 'We have {P, number, percent} code coverage.'
 * };
 * var cfStr = mf.compile(msgSet).toString('module.exports');
 * fs.writeFileSync('messages.js', cfStr);
 * ...
 * var messages = require('./messages');
 *
 * messages.a({ TYPE: 'more complex' })
 * // 'A more complex example.'
 *
 * messages.b({ COUNT: 3 })
 * // 'This has 3 members.'
 */
MessageFormat.prototype.compile = function(messages, locale) {
  function _stringify(obj, level) {
    if (!level) level = 0;
    if (typeof obj != 'object') return obj;
    var o = [], indent = '';
    for (var i = 0; i < level; ++i) indent += '  ';
    for (var k in obj) o.push('\n' + indent + '  ' + Compiler.propname(k) + ': ' + _stringify(obj[k], level + 1));
    return '{' + o.join(',') + '\n' + indent + '}';
  }

  var pf;
  if (Object.keys(this.pluralFuncs).length == 0) {
    if (!locale) locale = MessageFormat.defaultLocale;
    pf = {};
    pf[locale] = getPluralFunc(locale, this.noPluralKeyChecks);
  } else if (locale) {
    pf = {};
    pf[locale] = this.pluralFuncs[locale];
    if (!pf[locale]) throw new Error('Locale ' + JSON.stringify(locale) + 'not found in ' + JSON.stringify(this.pluralFuncs) + '!');
  } else {
    pf = this.pluralFuncs;
    locale = Object.keys(pf)[0];
  }

  var compiler = new Compiler(this);
  var obj = compiler.compile(messages, locale, pf);

  if (typeof messages != 'object') {
    var fn = new Function(
        'number, plural, select, fmt', Compiler.funcname(locale),
        'return ' + obj);
    var rt = this.runtime;
    return fn(rt.number, rt.plural, rt.select, this.fmt, pf[locale]);
  }

  var rtStr = this.runtime.toString(pf, compiler) + '\n';
  var objStr = _stringify(obj);
  var result = new Function(rtStr + 'return ' + objStr)();
  if (result.hasOwnProperty('toString')) throw new Error('The top-level message key `toString` is reserved');

  result.toString = function(global) {
    switch (global || '') {
      case 'exports':
        var o = [];
        for (var k in obj) o.push(Compiler.propname(k, 'exports') + ' = ' + _stringify(obj[k]));
        return rtStr + o.join(';\n');
      case 'module.exports':
        return rtStr + 'module.exports = ' + objStr;
      case 'export default':
        return rtStr +  'export default ' + objStr;
      case '':
        return rtStr + 'return ' + objStr;
      default:
        if (global.indexOf('.') > -1) return rtStr + global + ' = ' + objStr;
        return rtStr + [
          '(function (root, G) {',
          '  if (typeof define === "function" && define.amd) { define(G); }',
          '  else if (typeof exports === "object") { module.exports = G; }',
          '  else { ' + Compiler.propname(global, 'root') + ' = G; }',
          '})(this, ' + objStr + ');'
        ].join('\n');
    }
  }
  return result;
}


module.exports = MessageFormat;


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(499);


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

var assert = __webpack_require__(500);

/**
 * Structure for storing keywords.
 *
 * @typedef {Object.<String,Boolean>} KeywordsHash
 */

/**
 * ECMAScript dialects.
 *
 * @const
 * @type {Object.<String,Number|String>} - keys as readable names and values as versions
 */
var DIALECTS = {
    es3: 3,
    es5: 5,
    es2015: 6,
    es7: 7,

    // aliases
    es6: 6,
    'default': 5,
    next: 6
};

/**
 * ECMAScript reserved words.
 *
 * @type {Object.<String,KeywordsHash>}
 */
var KEYWORDS = exports.KEYWORDS = {};

/**
 * Check word for being an reserved word.
 *
 * @param {String} word - word to check
 * @param {String|Number} [dialect] - dialect or version
 * @param {Boolean} [strict] - strict mode
 * @returns {?Boolean}
 */
exports.check = function check(word, dialect, strict) {
    dialect = dialect || DIALECTS.default;
    var version = DIALECTS[dialect] || dialect;

    if (strict && version >= 5) {
        version += '-strict';
    }

    assert(KEYWORDS[version], 'Unknown dialect');

    return KEYWORDS[version].hasOwnProperty(word);
};

/**
 * Reserved Words for ES3
 *
 * ECMA-262 3rd: 7.5.1
 * http://www.ecma-international.org/publications/files/ECMA-ST-ARCH/ECMA-262,%203rd%20edition,%20December%201999.pdf
 *
 * @type {KeywordsHash}
 */
KEYWORDS['3'] = _hash(
    // Keyword, ECMA-262 3rd: 7.5.2
    'break    else       new     var',
    'case     finally    return  void',
    'catch    for        switch  while',
    'continue function   this    with',
    'default  if         throw',
    'delete   in         try',
    'do       instanceof typeof',
    // FutureReservedWord, ECMA-262 3rd 7.5.3
    'abstract enum       int        short',
    'boolean  export     interface  static',
    'byte     extends    long       super',
    'char     final      native     synchronized',
    'class    float      package    throws',
    'const    goto       private    transient',
    'debugger implements protected  volatile',
    'double   import     public',
    // NullLiteral & BooleanLiteral
    'null true false'
);

/**
 * Reserved Words for ES5.
 *
 * http://es5.github.io/#x7.6.1
 *
 * @type {KeywordsHash}
 */
KEYWORDS['5'] = _hash(
    // Keyword
    'break    do       instanceof typeof',
    'case     else     new        var',
    'catch    finally  return     void',
    'continue for      switch     while',
    'debugger function this       with',
    'default  if       throw',
    'delete   in       try',
    // FutureReservedWord
    'class enum extends super',
    'const export import',
    // NullLiteral & BooleanLiteral
    'null true false'
);

/**
 * Reserved Words for ES5 in strict mode.
 *
 * @type {KeywordsHash}
 */
KEYWORDS['5-strict'] = _hash(
    KEYWORDS['5'],
    // FutureReservedWord, strict mode. http://es5.github.io/#x7.6.1.2
    'implements let     private   public yield',
    'interface  package protected static'
);

/**
 * Reserved Words for ES6.
 *
 * 11.6.2
 * http://www.ecma-international.org/ecma-262/6.0/index.html#sec-reserved-words
 *
 * @type {KeywordsHash}
 */
KEYWORDS['6'] = _hash(
    // Keywords, ES6 11.6.2.1, http://www.ecma-international.org/ecma-262/6.0/index.html#sec-keywords
    'break    do       in         typeof',
    'case     else     instanceof var',
    'catch    export   new        void',
    'class    extends  return     while',
    'const    finally  super      with',
    'continue for      switch     yield',
    'debugger function this',
    'default  if       throw',
    'delete   import   try',
    // Future Reserved Words, ES6 11.6.2.2
    // http://www.ecma-international.org/ecma-262/6.0/index.html#sec-future-reserved-words
    'enum await',
    // NullLiteral & BooleanLiteral
    'null true false'
);

/**
 * Reserved Words for ES6 in strict mode.
 *
 * @type {KeywordsHash}
 */
KEYWORDS['6-strict'] = _hash(
    KEYWORDS['6'],
    // Keywords, ES6 11.6.2.1
    'let static',
    // Future Reserved Words, ES6 11.6.2.2
    'implements package protected',
    'interface private public'
);

/**
 * Generates hash from strings
 *
 * @private
 * @param {...String|KeywordsHash} keywords - Space-delimited string or previous result of _hash
 * @return {KeywordsHash} - Object with keywords in keys and true in values
 */
function _hash() {
    var set = Array.prototype.map.call(arguments, function(v) {
        return typeof v === 'string' ? v : Object.keys(v).join(' ');
    }).join(' ');

    return set.split(/\s+/)
        .reduce(function(res, keyword) {
            res[keyword] = true;
            return res;
        }, {});
}


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var objectAssign = __webpack_require__(501)();

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:
// NB: The URL to the CommonJS spec is kept just for tradition.
//     node-assert has evolved a lot since then, both in API and behavior.

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(503);
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

// Expose a strict only variant of assert
function strict(value, message) {
  if (!value) fail(value, true, message, '==', strict);
}
assert.strict = objectAssign(strict, assert, {
  equal: assert.strictEqual,
  deepEqual: assert.deepStrictEqual,
  notEqual: assert.notStrictEqual,
  notDeepEqual: assert.notDeepStrictEqual
});
assert.strict.strict = assert.strict;

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(502);

var lacksProperEnumerationOrder = function () {
	if (!Object.assign) {
		return false;
	}
	/*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */
	var str = 'abcdefghijklmnopqrst';
	var letters = str.split('');
	var map = {};
	for (var i = 0; i < letters.length; ++i) {
		map[letters[i]] = letters[i];
	}
	var obj = Object.assign({}, map);
	var actual = '';
	for (var k in obj) {
		actual += k;
	}
	return str !== actual;
};

var assignHasPendingExceptions = function () {
	if (!Object.assign || !Object.preventExtensions) {
		return false;
	}
	/*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */
	var thrower = Object.preventExtensions({ 1: 2 });
	try {
		Object.assign(thrower, 'xy');
	} catch (e) {
		return thrower[1] === 'y';
	}
	return false;
};

module.exports = function getPolyfill() {
	if (!Object.assign) {
		return implementation;
	}
	if (lacksProperEnumerationOrder()) {
		return implementation;
	}
	if (assignHasPendingExceptions()) {
		return implementation;
	}
	return Object.assign;
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// modified from https://github.com/es-shims/es6-shim
var objectKeys = __webpack_require__(140);
var hasSymbols = __webpack_require__(206)();
var callBound = __webpack_require__(87);
var $Object = __webpack_require__(141);
var $push = callBound('Array.prototype.push');
var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
var originalGetSymbols = hasSymbols ? $Object.getOwnPropertySymbols : null;

// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
	if (target == null) { throw new TypeError('target must be an object'); }
	var to = $Object(target); // step 1
	if (arguments.length === 1) {
		return to; // step 2
	}
	for (var s = 1; s < arguments.length; ++s) {
		var from = $Object(arguments[s]); // step 3.a.i

		// step 3.a.ii:
		var keys = objectKeys(from);
		var getSymbols = hasSymbols && ($Object.getOwnPropertySymbols || originalGetSymbols);
		if (getSymbols) {
			var syms = getSymbols(from);
			for (var j = 0; j < syms.length; ++j) {
				var key = syms[j];
				if ($propIsEnumerable(from, key)) {
					$push(keys, key);
				}
			}
		}

		// step 3.a.iii:
		for (var i = 0; i < keys.length; ++i) {
			var nextKey = keys[i];
			if ($propIsEnumerable(from, nextKey)) { // step 3.a.iii.2
				var propValue = from[nextKey]; // step 3.a.iii.2.a
				to[nextKey] = propValue; // step 3.a.iii.2.b
			}
		}
	}

	return to; // step 4
};


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_API_URL":"https://globalandxl.nl/api","REACT_APP_GHETTORADIO_URL":"https://ghettoradio.globalandxl.nl","REACT_APP_DISABLE_TUTORIALS":"false","REACT_APP_DISABLE_DESKTOP":"false","REACT_APP_UPLOADS_URL":"http://uploads.globalandxl.nl","REACT_APP_DECORATORS":"true;","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_SASS":"true;","REACT_APP_LESS":"true;","REACT_APP_STYLUS":"true;","REACT_APP_CSS_MODULES":"true;","REACT_APP_SASS_MODULES":"true;","REACT_APP_STYLUS_MODULES":"true;","REACT_APP_LESS_MODULES":"true;","REACT_APP_WEBPACK_DASHBOARD":"true;","REACT_APP_PROTOCOL":"http:","REACT_APP_HOST":"globalandxl.nl","REACT_APP_PORT":"","REACT_APP_API_PATH":"/api","REACT_APP_ADMIN_PATH":"/admin","REACT_APP_ADMIN_URL":"https://globalandxl.nl/admin","REACT_APP_MEDIA_URL":"http://uploads.globalandxl.nl/assets/pics/","REACT_APP_SOCKET_IO_PATH":"/api/socket.io"}).NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(504);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(505);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(161)))

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Generated by PEG.js 0.10.0.
 *
 * http://pegjs.org/
 */



function peg$subclass(child, parent) {
  function ctor() { this.constructor = child; }
  ctor.prototype = parent.prototype;
  child.prototype = new ctor();
}

function peg$SyntaxError(message, expected, found, location) {
  this.message  = message;
  this.expected = expected;
  this.found    = found;
  this.location = location;
  this.name     = "SyntaxError";

  if (typeof Error.captureStackTrace === "function") {
    Error.captureStackTrace(this, peg$SyntaxError);
  }
}

peg$subclass(peg$SyntaxError, Error);

peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
        literal: function(expectation) {
          return "\"" + literalEscape(expectation.text) + "\"";
        },

        "class": function(expectation) {
          var escapedParts = "",
              i;

          for (i = 0; i < expectation.parts.length; i++) {
            escapedParts += expectation.parts[i] instanceof Array
              ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1])
              : classEscape(expectation.parts[i]);
          }

          return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
        },

        any: function(expectation) {
          return "any character";
        },

        end: function(expectation) {
          return "end of input";
        },

        other: function(expectation) {
          return expectation.description;
        }
      };

  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }

  function literalEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/"/g,  '\\"')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function classEscape(s) {
    return s
      .replace(/\\/g, '\\\\')
      .replace(/\]/g, '\\]')
      .replace(/\^/g, '\\^')
      .replace(/-/g,  '\\-')
      .replace(/\0/g, '\\0')
      .replace(/\t/g, '\\t')
      .replace(/\n/g, '\\n')
      .replace(/\r/g, '\\r')
      .replace(/[\x00-\x0F]/g,          function(ch) { return '\\x0' + hex(ch); })
      .replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) { return '\\x'  + hex(ch); });
  }

  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }

  function describeExpected(expected) {
    var descriptions = new Array(expected.length),
        i, j;

    for (i = 0; i < expected.length; i++) {
      descriptions[i] = describeExpectation(expected[i]);
    }

    descriptions.sort();

    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }

    switch (descriptions.length) {
      case 1:
        return descriptions[0];

      case 2:
        return descriptions[0] + " or " + descriptions[1];

      default:
        return descriptions.slice(0, -1).join(", ")
          + ", or "
          + descriptions[descriptions.length - 1];
    }
  }

  function describeFound(found) {
    return found ? "\"" + literalEscape(found) + "\"" : "end of input";
  }

  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};

function peg$parse(input, options) {
  options = options !== void 0 ? options : {};

  var peg$FAILED = {},

      peg$startRuleFunctions = { start: peg$parsestart },
      peg$startRuleFunction  = peg$parsestart,

      peg$c0 = "#",
      peg$c1 = peg$literalExpectation("#", false),
      peg$c2 = function() { return { type: 'octothorpe' }; },
      peg$c3 = function(str) { return str.join(''); },
      peg$c4 = "{",
      peg$c5 = peg$literalExpectation("{", false),
      peg$c6 = "}",
      peg$c7 = peg$literalExpectation("}", false),
      peg$c8 = function(arg) {
          return {
            type: 'argument',
            arg: arg
          };
        },
      peg$c9 = ",",
      peg$c10 = peg$literalExpectation(",", false),
      peg$c11 = "select",
      peg$c12 = peg$literalExpectation("select", false),
      peg$c13 = function(arg, cases) {
          return {
            type: 'select',
            arg: arg,
            cases: cases
          };
        },
      peg$c14 = "plural",
      peg$c15 = peg$literalExpectation("plural", false),
      peg$c16 = "selectordinal",
      peg$c17 = peg$literalExpectation("selectordinal", false),
      peg$c18 = function(arg, type, offset, cases) {
          var ls = ((type === 'selectordinal') ? options.ordinal : options.cardinal)
                   || ['zero', 'one', 'two', 'few', 'many', 'other'];
          if (ls && ls.length) cases.forEach(function(c) {
            if (isNaN(c.key) && ls.indexOf(c.key) < 0) throw new Error(
              'Invalid key `' + c.key + '` for argument `' + arg + '`.' +
              ' Valid ' + type + ' keys for this locale are `' + ls.join('`, `') +
              '`, and explicit keys like `=0`.');
          });
          return {
            type: type,
            arg: arg,
            offset: offset || 0,
            cases: cases
          };
        },
      peg$c19 = function(arg, key, params) {
          return {
            type: 'function',
            arg: arg,
            key: key,
            params: params
          };
        },
      peg$c20 = /^[0-9a-zA-Z$_]/,
      peg$c21 = peg$classExpectation([["0", "9"], ["a", "z"], ["A", "Z"], "$", "_"], false, false),
      peg$c22 = /^[^ \t\n\r,.+={}]/,
      peg$c23 = peg$classExpectation([" ", "\t", "\n", "\r", ",", ".", "+", "=", "{", "}"], true, false),
      peg$c24 = function(key, tokens) { return { key: key, tokens: tokens }; },
      peg$c25 = function(tokens) { return tokens; },
      peg$c26 = "offset",
      peg$c27 = peg$literalExpectation("offset", false),
      peg$c28 = ":",
      peg$c29 = peg$literalExpectation(":", false),
      peg$c30 = function(d) { return d; },
      peg$c31 = "=",
      peg$c32 = peg$literalExpectation("=", false),
      peg$c33 = function(p) { return options.strictFunctionParams; },
      peg$c34 = function(p) { return p; },
      peg$c35 = function(p) { return p.replace(/^[ \t\n\r]*|[ \t\n\r]*$/g, ''); },
      peg$c36 = "''",
      peg$c37 = peg$literalExpectation("''", false),
      peg$c38 = function() { return "'"; },
      peg$c39 = /^[^']/,
      peg$c40 = peg$classExpectation(["'"], true, false),
      peg$c41 = "'{",
      peg$c42 = peg$literalExpectation("'{", false),
      peg$c43 = "'",
      peg$c44 = peg$literalExpectation("'", false),
      peg$c45 = function(str) { return '\u007B'+str.join(''); },
      peg$c46 = "'}",
      peg$c47 = peg$literalExpectation("'}", false),
      peg$c48 = function(str) { return '\u007D'+str.join(''); },
      peg$c49 = /^[^{}#\\\0-\x08\x0E-\x1F\x7F]/,
      peg$c50 = peg$classExpectation(["{", "}", "#", "\\", ["\0", "\b"], ["\x0E", "\x1F"], "\x7F"], true, false),
      peg$c51 = "\\\\",
      peg$c52 = peg$literalExpectation("\\\\", false),
      peg$c53 = function() { return '\\'; },
      peg$c54 = "\\#",
      peg$c55 = peg$literalExpectation("\\#", false),
      peg$c56 = function() { return '#'; },
      peg$c57 = "\\{",
      peg$c58 = peg$literalExpectation("\\{", false),
      peg$c59 = function() { return '\u007B'; },
      peg$c60 = "\\}",
      peg$c61 = peg$literalExpectation("\\}", false),
      peg$c62 = function() { return '\u007D'; },
      peg$c63 = "\\u",
      peg$c64 = peg$literalExpectation("\\u", false),
      peg$c65 = function(h1, h2, h3, h4) {
            return String.fromCharCode(parseInt('0x' + h1 + h2 + h3 + h4));
          },
      peg$c66 = /^[^',}]/,
      peg$c67 = peg$classExpectation(["'", ",", "}"], true, false),
      peg$c68 = /^[^'}]/,
      peg$c69 = peg$classExpectation(["'", "}"], true, false),
      peg$c70 = /^[0-9]/,
      peg$c71 = peg$classExpectation([["0", "9"]], false, false),
      peg$c72 = /^[0-9a-fA-F]/,
      peg$c73 = peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"]], false, false),
      peg$c74 = /^[ \t\n\r]/,
      peg$c75 = peg$classExpectation([" ", "\t", "\n", "\r"], false, false),

      peg$currPos          = 0,
      peg$savedPos         = 0,
      peg$posDetailsCache  = [{ line: 1, column: 1 }],
      peg$maxFailPos       = 0,
      peg$maxFailExpected  = [],
      peg$silentFails      = 0,

      peg$result;

  if ("startRule" in options) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
    }

    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }

  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }

  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }

  function expected(description, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location
    );
  }

  function error(message, location) {
    location = location !== void 0 ? location : peg$computeLocation(peg$savedPos, peg$currPos)

    throw peg$buildSimpleError(message, location);
  }

  function peg$literalExpectation(text, ignoreCase) {
    return { type: "literal", text: text, ignoreCase: ignoreCase };
  }

  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts: parts, inverted: inverted, ignoreCase: ignoreCase };
  }

  function peg$anyExpectation() {
    return { type: "any" };
  }

  function peg$endExpectation() {
    return { type: "end" };
  }

  function peg$otherExpectation(description) {
    return { type: "other", description: description };
  }

  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos], p;

    if (details) {
      return details;
    } else {
      p = pos - 1;
      while (!peg$posDetailsCache[p]) {
        p--;
      }

      details = peg$posDetailsCache[p];
      details = {
        line:   details.line,
        column: details.column
      };

      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }

        p++;
      }

      peg$posDetailsCache[pos] = details;
      return details;
    }
  }

  function peg$computeLocation(startPos, endPos) {
    var startPosDetails = peg$computePosDetails(startPos),
        endPosDetails   = peg$computePosDetails(endPos);

    return {
      start: {
        offset: startPos,
        line:   startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line:   endPosDetails.line,
        column: endPosDetails.column
      }
    };
  }

  function peg$fail(expected) {
    if (peg$currPos < peg$maxFailPos) { return; }

    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }

    peg$maxFailExpected.push(expected);
  }

  function peg$buildSimpleError(message, location) {
    return new peg$SyntaxError(message, null, null, location);
  }

  function peg$buildStructuredError(expected, found, location) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected, found),
      expected,
      found,
      location
    );
  }

  function peg$parsestart() {
    var s0, s1;

    s0 = [];
    s1 = peg$parsetoken();
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parsetoken();
    }

    return s0;
  }

  function peg$parsetoken() {
    var s0, s1, s2;

    s0 = peg$parseargument();
    if (s0 === peg$FAILED) {
      s0 = peg$parseselect();
      if (s0 === peg$FAILED) {
        s0 = peg$parseplural();
        if (s0 === peg$FAILED) {
          s0 = peg$parsefunction();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 35) {
              s1 = peg$c0;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c1); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c2();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = [];
              s2 = peg$parsechar();
              if (s2 !== peg$FAILED) {
                while (s2 !== peg$FAILED) {
                  s1.push(s2);
                  s2 = peg$parsechar();
                }
              } else {
                s1 = peg$FAILED;
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c3(s1);
              }
              s0 = s1;
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseargument() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c6;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c7); }
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c8(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseselect() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c9;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c10); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                if (input.substr(peg$currPos, 6) === peg$c11) {
                  s7 = peg$c11;
                  peg$currPos += 6;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c12); }
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c9;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();
                      if (s10 !== peg$FAILED) {
                        s11 = [];
                        s12 = peg$parseselectCase();
                        if (s12 !== peg$FAILED) {
                          while (s12 !== peg$FAILED) {
                            s11.push(s12);
                            s12 = peg$parseselectCase();
                          }
                        } else {
                          s11 = peg$FAILED;
                        }
                        if (s11 !== peg$FAILED) {
                          s12 = peg$parse_();
                          if (s12 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 125) {
                              s13 = peg$c6;
                              peg$currPos++;
                            } else {
                              s13 = peg$FAILED;
                              if (peg$silentFails === 0) { peg$fail(peg$c7); }
                            }
                            if (s13 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$c13(s3, s11);
                              s0 = s1;
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseplural() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c9;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c10); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                if (input.substr(peg$currPos, 6) === peg$c14) {
                  s7 = peg$c14;
                  peg$currPos += 6;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) { peg$fail(peg$c15); }
                }
                if (s7 === peg$FAILED) {
                  if (input.substr(peg$currPos, 13) === peg$c16) {
                    s7 = peg$c16;
                    peg$currPos += 13;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) { peg$fail(peg$c17); }
                  }
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 44) {
                      s9 = peg$c9;
                      peg$currPos++;
                    } else {
                      s9 = peg$FAILED;
                      if (peg$silentFails === 0) { peg$fail(peg$c10); }
                    }
                    if (s9 !== peg$FAILED) {
                      s10 = peg$parse_();
                      if (s10 !== peg$FAILED) {
                        s11 = peg$parseoffset();
                        if (s11 === peg$FAILED) {
                          s11 = null;
                        }
                        if (s11 !== peg$FAILED) {
                          s12 = [];
                          s13 = peg$parsepluralCase();
                          if (s13 !== peg$FAILED) {
                            while (s13 !== peg$FAILED) {
                              s12.push(s13);
                              s13 = peg$parsepluralCase();
                            }
                          } else {
                            s12 = peg$FAILED;
                          }
                          if (s12 !== peg$FAILED) {
                            s13 = peg$parse_();
                            if (s13 !== peg$FAILED) {
                              if (input.charCodeAt(peg$currPos) === 125) {
                                s14 = peg$c6;
                                peg$currPos++;
                              } else {
                                s14 = peg$FAILED;
                                if (peg$silentFails === 0) { peg$fail(peg$c7); }
                              }
                              if (s14 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c18(s3, s7, s11, s12);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefunction() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse_();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseid();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 44) {
              s5 = peg$c9;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c10); }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse_();
              if (s6 !== peg$FAILED) {
                s7 = peg$parseid();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse_();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parsefunctionParams();
                    if (s9 !== peg$FAILED) {
                      if (input.charCodeAt(peg$currPos) === 125) {
                        s10 = peg$c6;
                        peg$currPos++;
                      } else {
                        s10 = peg$FAILED;
                        if (peg$silentFails === 0) { peg$fail(peg$c7); }
                      }
                      if (s10 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c19(s3, s7, s9);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseid() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$currPos;
    if (peg$c20.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c21); }
    }
    if (s2 !== peg$FAILED) {
      s3 = [];
      if (peg$c22.test(input.charAt(peg$currPos))) {
        s4 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c23); }
      }
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        if (peg$c22.test(input.charAt(peg$currPos))) {
          s4 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c23); }
        }
      }
      if (s3 !== peg$FAILED) {
        s2 = [s2, s3];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parseparamDefault() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseparamcharsDefault();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseparamcharsDefault();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c3(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseparamStrict() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parseparamcharsStrict();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parseparamcharsStrict();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c3(s1);
    }
    s0 = s1;

    return s0;
  }

  function peg$parseselectCase() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      s2 = peg$parseid();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c24(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepluralCase() {
    var s0, s1, s2, s3, s4;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsepluralKey();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parsecaseTokens();
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c24(s2, s4);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsecaseTokens() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 123) {
      s1 = peg$c4;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c5); }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$currPos;
        peg$silentFails++;
        if (input.charCodeAt(peg$currPos) === 123) {
          s5 = peg$c4;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c5); }
        }
        peg$silentFails--;
        if (s5 !== peg$FAILED) {
          peg$currPos = s4;
          s4 = void 0;
        } else {
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parsetoken();
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parsetoken();
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse_();
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 125) {
              s5 = peg$c6;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c7); }
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c25(s3);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parseoffset() {
    var s0, s1, s2, s3, s4, s5, s6, s7;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.substr(peg$currPos, 6) === peg$c26) {
        s2 = peg$c26;
        peg$currPos += 6;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c27); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 58) {
            s4 = peg$c28;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c29); }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsedigits();
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c30(s6);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsepluralKey() {
    var s0, s1, s2;

    s0 = peg$parseid();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s1 = peg$c31;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c32); }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parsedigits();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c30(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunctionParams() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parsefunctionParamsDefault();
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$parsefunctionParamsDefault();
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s2 = peg$c33(s1);
      if (s2) {
        s2 = peg$FAILED;
      } else {
        s2 = void 0;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c34(s1);
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsefunctionParamsStrict();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsefunctionParamsStrict();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = peg$currPos;
        s2 = peg$c33(s1);
        if (s2) {
          s2 = void 0;
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c34(s1);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsefunctionParamsStrict() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c9;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c10); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseparamStrict();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c34(s3);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsefunctionParamsDefault() {
    var s0, s1, s2, s3, s4, s5;

    s0 = peg$currPos;
    s1 = peg$parse_();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 44) {
        s2 = peg$c9;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c10); }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse_();
        if (s3 !== peg$FAILED) {
          s4 = peg$parseparamDefault();
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c35(s4);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }

    return s0;
  }

  function peg$parsedoubleapos() {
    var s0, s1;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c36) {
      s1 = peg$c36;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c37); }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$c38();
    }
    s0 = s1;

    return s0;
  }

  function peg$parseinapos() {
    var s0, s1, s2;

    s0 = peg$parsedoubleapos();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c39.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c40); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c39.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c40); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parsequotedCurly() {
    var s0, s1, s2, s3;

    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c41) {
      s1 = peg$c41;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c42); }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseinapos();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseinapos();
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s3 = peg$c43;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c44); }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c45(s2);
          s0 = s1;
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c46) {
        s1 = peg$c46;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c47); }
      }
      if (s1 !== peg$FAILED) {
        s2 = [];
        s3 = peg$parseinapos();
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$parseinapos();
        }
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 39) {
            s3 = peg$c43;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c44); }
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c48(s2);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }

    return s0;
  }

  function peg$parsequotedFunctionParams() {
    var s0;

    s0 = peg$parsequotedCurly();
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 39) {
        s0 = peg$c43;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c44); }
      }
    }

    return s0;
  }

  function peg$parsechar() {
    var s0, s1, s2, s3, s4, s5;

    if (peg$c49.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c50); }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c51) {
        s1 = peg$c51;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c52); }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c53();
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c54) {
          s1 = peg$c54;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c55); }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c56();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c57) {
            s1 = peg$c57;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c58); }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c59();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c60) {
              s1 = peg$c60;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) { peg$fail(peg$c61); }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c62();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c63) {
                s1 = peg$c63;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) { peg$fail(peg$c64); }
              }
              if (s1 !== peg$FAILED) {
                s2 = peg$parsehexDigit();
                if (s2 !== peg$FAILED) {
                  s3 = peg$parsehexDigit();
                  if (s3 !== peg$FAILED) {
                    s4 = peg$parsehexDigit();
                    if (s4 !== peg$FAILED) {
                      s5 = peg$parsehexDigit();
                      if (s5 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c65(s2, s3, s4, s5);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            }
          }
        }
      }
    }

    return s0;
  }

  function peg$parseparamcharsCommon() {
    var s0;

    s0 = peg$parsedoubleapos();
    if (s0 === peg$FAILED) {
      s0 = peg$parsequotedFunctionParams();
    }

    return s0;
  }

  function peg$parseparamcharsDefault() {
    var s0, s1, s2;

    s0 = peg$parseparamcharsCommon();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c66.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c67); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c66.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c67); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parseparamcharsStrict() {
    var s0, s1, s2;

    s0 = peg$parseparamcharsCommon();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      if (peg$c68.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c69); }
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          if (peg$c68.test(input.charAt(peg$currPos))) {
            s2 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) { peg$fail(peg$c69); }
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c3(s1);
      }
      s0 = s1;
    }

    return s0;
  }

  function peg$parsedigits() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$c70.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c71); }
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        if (peg$c70.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) { peg$fail(peg$c71); }
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  function peg$parsehexDigit() {
    var s0;

    if (peg$c72.test(input.charAt(peg$currPos))) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c73); }
    }

    return s0;
  }

  function peg$parse_() {
    var s0, s1, s2;

    s0 = peg$currPos;
    s1 = [];
    if (peg$c74.test(input.charAt(peg$currPos))) {
      s2 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s2 = peg$FAILED;
      if (peg$silentFails === 0) { peg$fail(peg$c75); }
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      if (peg$c74.test(input.charAt(peg$currPos))) {
        s2 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) { peg$fail(peg$c75); }
      }
    }
    if (s1 !== peg$FAILED) {
      s0 = input.substring(s0, peg$currPos);
    } else {
      s0 = s1;
    }

    return s0;
  }

  peg$result = peg$startRuleFunction();

  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }

    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length
        ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1)
        : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

module.exports = {
  SyntaxError: peg$SyntaxError,
  parse:       peg$parse
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var Compiler = __webpack_require__(228);


/** A set of utility functions that are called by the compiled Javascript
 *  functions, these are included locally in the output of {@link
 *  MessageFormat#compile compile()}.
 *
 * @class
 * @param {MessageFormat} mf - A MessageFormat instance
 */
function Runtime(mf) {
  this.mf = mf;
  this.setStrictNumber(mf.strictNumberSign);
}

module.exports = Runtime;


/** Utility function for `#` in plural rules
 *
 *  Will throw an Error if `value` has a non-numeric value and `offset` is
 *  non-zero or {@link MessageFormat#setStrictNumberSign} is set.
 *
 * @function Runtime#number
 * @param {number} value - The value to operate on
 * @param {string} name - The name of the argument, used for error reporting
 * @param {number} [offset=0] - An optional offset, set by the surrounding context
 * @returns {number|string} The result of applying the offset to the input value
 */
function defaultNumber(value, name, offset) {
  if (!offset) return value;
  if (isNaN(value)) throw new Error('Can\'t apply offset:' + offset + ' to argument `' + name +
                                    '` with non-numerical value ' + JSON.stringify(value) + '.');
  return value - offset;
}


/** @private */
function strictNumber(value, name, offset) {
  if (isNaN(value)) throw new Error('Argument `' + name + '` has non-numerical value ' + JSON.stringify(value) + '.');
  return value - (offset || 0);
}


/** Set how strictly the {@link number} method parses its input.
 *
 *  According to the ICU MessageFormat spec, `#` can only be used to replace a
 *  number input of a `plural` statement. By default, messageformat.js does not
 *  throw a runtime error if you use non-numeric argument with a `plural` rule,
 *  unless rule also includes a non-zero `offset`.
 *
 *  This is called by {@link MessageFormat#setStrictNumberSign} to follow the
 *  stricter ICU MessageFormat spec.
 *
 * @param {boolean} [enable=false]
 */
Runtime.prototype.setStrictNumber = function(enable) {
  this.number = enable ? strictNumber : defaultNumber;
}


/** Utility function for `{N, plural|selectordinal, ...}`
 *
 * @param {number} value - The key to use to find a pluralization rule
 * @param {number} offset - An offset to apply to `value`
 * @param {function} lcfunc - A locale function from `pluralFuncs`
 * @param {Object.<string,string>} data - The object from which results are looked up
 * @param {?boolean} isOrdinal - If true, use ordinal rather than cardinal rules
 * @returns {string} The result of the pluralization
 */
Runtime.prototype.plural = function(value, offset, lcfunc, data, isOrdinal) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  if (offset) value -= offset;
  var key = lcfunc(value, isOrdinal);
  if (key in data) return data[key];
  return data.other;
}


/** Utility function for `{N, select, ...}`
 *
 * @param {number} value - The key to use to find a selection
 * @param {Object.<string,string>} data - The object from which results are looked up
 * @returns {string} The result of the select statement
 */
Runtime.prototype.select = function(value, data) {
  if ({}.hasOwnProperty.call(data, value)) return data[value];
  return data.other;
}


/** @private */
Runtime.prototype.toString = function(pluralFuncs, compiler) {
  function _stringify(o, level) {
    if (typeof o != 'object') {
      var funcStr = o.toString().replace(/^(function )\w*/, '$1');
      var indent = /([ \t]*)\S.*$/.exec(funcStr);
      return indent ? funcStr.replace(new RegExp('^' + indent[1], 'mg'), '') : funcStr;
    }
    var s = [];
    for (var i in o) {
      if (level == 0) s.push('var ' + i + ' = ' + _stringify(o[i], level + 1) + ';\n');
      else s.push(Compiler.propname(i) + ': ' + _stringify(o[i], level + 1));
    }
    if (level == 0) return s.join('');
    if (s.length == 0) return '{}';
    var indent = '  '; while (--level) indent += '  ';
    return '{\n' + s.join(',\n').replace(/^/gm, indent) + '\n}';
  }

  var obj = {};
  Object.keys(compiler.locales).forEach(function(lc) { obj[Compiler.funcname(lc)] = pluralFuncs[lc]; });
  Object.keys(compiler.runtime).forEach(function(fn) { obj[fn] = this[fn]; }, this);
  var fmtKeys = Object.keys(compiler.formatters);
  var fmt = this.mf.fmt;
  if (fmtKeys.length) obj.fmt = fmtKeys.reduce(function(o, key) { o[key] = fmt[key]; return o; }, {});
  return _stringify(obj, 0);
}


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _cp = [
function(n, ord) {
  if (ord) return 'other';
  return 'other';
},
function(n, ord) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},
function(n, ord) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},
function(n, ord) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
}
];

(function (root, plurals) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (plurals),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = plurals;
  } else {
    root.plurals = plurals;
  }
}(this, {
af: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ak: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

am: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ar: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n100 >= 3 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 99)) ? 'many'
      : 'other';
},

ars: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n100 >= 3 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 99)) ? 'many'
      : 'other';
},

as: function(n, ord
) {
  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
          || n == 10)) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

asa: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ast: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

az: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], i10 = i.slice(-1),
      i100 = i.slice(-2), i1000 = i.slice(-3);
  if (ord) return ((i10 == 1 || i10 == 2 || i10 == 5 || i10 == 7 || i10 == 8)
          || (i100 == 20 || i100 == 50 || i100 == 70
          || i100 == 80)) ? 'one'
      : ((i10 == 3 || i10 == 4) || (i1000 == 100 || i1000 == 200
          || i1000 == 300 || i1000 == 400 || i1000 == 500 || i1000 == 600 || i1000 == 700
          || i1000 == 800
          || i1000 == 900)) ? 'few'
      : (i == 0 || i10 == 6 || (i100 == 40 || i100 == 60
          || i100 == 90)) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

be: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return ((n10 == 2
          || n10 == 3) && n100 != 12 && n100 != 13) ? 'few' : 'other';
  return (n10 == 1 && n100 != 11) ? 'one'
      : ((n10 >= 2 && n10 <= 4) && (n100 < 12
          || n100 > 14)) ? 'few'
      : (t0 && n10 == 0 || (n10 >= 5 && n10 <= 9)
          || (n100 >= 11 && n100 <= 14)) ? 'many'
      : 'other';
},

bem: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bez: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bh: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

bm: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

bn: function(n, ord
) {
  if (ord) return ((n == 1 || n == 5 || n == 7 || n == 8 || n == 9
          || n == 10)) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

bo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

br: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2),
      n1000000 = t0 && s[0].slice(-6);
  if (ord) return 'other';
  return (n10 == 1 && n100 != 11 && n100 != 71 && n100 != 91) ? 'one'
      : (n10 == 2 && n100 != 12 && n100 != 72 && n100 != 92) ? 'two'
      : (((n10 == 3 || n10 == 4) || n10 == 9) && (n100 < 10
          || n100 > 19) && (n100 < 70 || n100 > 79) && (n100 < 90
          || n100 > 99)) ? 'few'
      : (n != 0 && t0 && n1000000 == 0) ? 'many'
      : 'other';
},

brx: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

bs: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

ca: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 1
          || n == 3)) ? 'one'
      : (n == 2) ? 'two'
      : (n == 4) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

ce: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

cgg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

chr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ckb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

cs: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : ((i >= 2 && i <= 4) && v0) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

cy: function(n, ord
) {
  if (ord) return ((n == 0 || n == 7 || n == 8
          || n == 9)) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((n == 3
          || n == 4)) ? 'few'
      : ((n == 5
          || n == 6)) ? 'many'
      : 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : (n == 3) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
},

da: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return (n == 1 || !t0 && (i == 0
          || i == 1)) ? 'one' : 'other';
},

de: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

dsb: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1
          || f100 == 1) ? 'one'
      : (v0 && i100 == 2
          || f100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
          || f100 == 4)) ? 'few'
      : 'other';
},

dv: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

dz: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ee: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

el: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

en: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n10 == 1 && n100 != 11) ? 'one'
      : (n10 == 2 && n100 != 12) ? 'two'
      : (n10 == 3 && n100 != 13) ? 'few'
      : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

eo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

es: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

et: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

eu: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

fa: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ff: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

fi: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

fil: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (v0 && (i == 1 || i == 2 || i == 3)
          || v0 && i10 != 4 && i10 != 6 && i10 != 9
          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
},

fo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

fr: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

fur: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

fy: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

ga: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : ((t0 && n >= 3 && n <= 6)) ? 'few'
      : ((t0 && n >= 7 && n <= 10)) ? 'many'
      : 'other';
},

gd: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((n == 1
          || n == 11)) ? 'one'
      : ((n == 2
          || n == 12)) ? 'two'
      : ((n == 3
          || n == 13)) ? 'few'
      : 'other';
  return ((n == 1
          || n == 11)) ? 'one'
      : ((n == 2
          || n == 12)) ? 'two'
      : (((t0 && n >= 3 && n <= 10)
          || (t0 && n >= 13 && n <= 19))) ? 'few'
      : 'other';
},

gl: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

gsw: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

gu: function(n, ord
) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

guw: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

gv: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1) ? 'one'
      : (v0 && i10 == 2) ? 'two'
      : (v0 && (i100 == 0 || i100 == 20 || i100 == 40 || i100 == 60
          || i100 == 80)) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

ha: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

haw: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

he: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (i == 2 && v0) ? 'two'
      : (v0 && (n < 0
          || n > 10) && t0 && n10 == 0) ? 'many'
      : 'other';
},

hi: function(n, ord
) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

hr: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

hsb: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i100 = i.slice(-2), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1
          || f100 == 1) ? 'one'
      : (v0 && i100 == 2
          || f100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4) || (f100 == 3
          || f100 == 4)) ? 'few'
      : 'other';
},

hu: function(n, ord
) {
  if (ord) return ((n == 1
          || n == 5)) ? 'one' : 'other';
  return (n == 1) ? 'one' : 'other';
},

hy: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

ia: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

id: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ig: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ii: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

"in": function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

io: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

is: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], t0 = Number(s[0]) == n,
      i10 = i.slice(-1), i100 = i.slice(-2);
  if (ord) return 'other';
  return (t0 && i10 == 1 && i100 != 11
          || !t0) ? 'one' : 'other';
},

it: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 11 || n == 8 || n == 80
          || n == 800)) ? 'many' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

iu: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

iw: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (i == 2 && v0) ? 'two'
      : (v0 && (n < 0
          || n > 10) && t0 && n10 == 0) ? 'many'
      : 'other';
},

ja: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

jbo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

jgo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ji: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

jmc: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

jv: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

jw: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ka: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], i100 = i.slice(-2);
  if (ord) return (i == 1) ? 'one'
      : (i == 0 || ((i100 >= 2 && i100 <= 20) || i100 == 40 || i100 == 60
          || i100 == 80)) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

kab: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n < 2) ? 'one' : 'other';
},

kaj: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kcg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kde: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

kea: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

kk: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return (n10 == 6 || n10 == 9
          || t0 && n10 == 0 && n != 0) ? 'many' : 'other';
  return (n == 1) ? 'one' : 'other';
},

kkj: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kl: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

km: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

kn: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ko: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ks: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ksb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ksh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : (n == 1) ? 'one'
      : 'other';
},

ku: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

kw: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

ky: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

lag: function(n, ord
) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return (n == 0) ? 'zero'
      : ((i == 0
          || i == 1) && n != 0) ? 'one'
      : 'other';
},

lb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

lg: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

lkt: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ln: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

lo: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

lt: function(n, ord
) {
  var s = String(n).split('.'), f = s[1] || '', t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n10 == 1 && (n100 < 11
          || n100 > 19)) ? 'one'
      : ((n10 >= 2 && n10 <= 9) && (n100 < 11
          || n100 > 19)) ? 'few'
      : (f != 0) ? 'many'
      : 'other';
},

lv: function(n, ord
) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length,
      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
          || v != 2 && f10 == 1) ? 'one'
      : 'other';
},

mas: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mg: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

mgo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mk: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return (i10 == 1 && i100 != 11) ? 'one'
      : (i10 == 2 && i100 != 12) ? 'two'
      : ((i10 == 7
          || i10 == 8) && i100 != 17 && i100 != 18) ? 'many'
      : 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one' : 'other';
},

ml: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

mo: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one'
      : (!v0 || n == 0
          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
      : 'other';
},

mr: function(n, ord
) {
  if (ord) return (n == 1) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
},

ms: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

mt: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 0
          || (n100 >= 2 && n100 <= 10)) ? 'few'
      : ((n100 >= 11 && n100 <= 19)) ? 'many'
      : 'other';
},

my: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

nah: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

naq: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

nb: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nd: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ne: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((t0 && n >= 1 && n <= 4)) ? 'one' : 'other';
  return (n == 1) ? 'one' : 'other';
},

nl: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

nn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nnh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

no: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nqo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

nr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nso: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

ny: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

nyn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

om: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

or: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return ((n == 1 || n == 5
          || (t0 && n >= 7 && n <= 9))) ? 'one'
      : ((n == 2
          || n == 3)) ? 'two'
      : (n == 4) ? 'few'
      : (n == 6) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

os: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

pa: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

pap: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

pl: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i != 1 && (i10 == 0 || i10 == 1)
          || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 12 && i100 <= 14)) ? 'many'
      : 'other';
},

prg: function(n, ord
) {
  var s = String(n).split('.'), f = s[1] || '', v = f.length,
      t0 = Number(s[0]) == n, n10 = t0 && s[0].slice(-1),
      n100 = t0 && s[0].slice(-2), f100 = f.slice(-2), f10 = f.slice(-1);
  if (ord) return 'other';
  return (t0 && n10 == 0 || (n100 >= 11 && n100 <= 19)
          || v == 2 && (f100 >= 11 && f100 <= 19)) ? 'zero'
      : (n10 == 1 && n100 != 11 || v == 2 && f10 == 1 && f100 != 11
          || v != 2 && f10 == 1) ? 'one'
      : 'other';
},

ps: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

pt: function(n, ord
) {
  var s = String(n).split('.'), i = s[0];
  if (ord) return 'other';
  return ((i == 0
          || i == 1)) ? 'one' : 'other';
},

"pt-PT": function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

rm: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ro: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one'
      : (!v0 || n == 0
          || n != 1 && (n100 >= 1 && n100 <= 19)) ? 'few'
      : 'other';
},

rof: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

root: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ru: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
      : 'other';
},

rwk: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sah: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

saq: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sc: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 11 || n == 8 || n == 80
          || n == 800)) ? 'many' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

scn: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return ((n == 11 || n == 8 || n == 80
          || n == 800)) ? 'many' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

sd: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sdh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

se: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

seh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ses: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

sg: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

sh: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

shi: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one'
      : ((t0 && n >= 2 && n <= 10)) ? 'few'
      : 'other';
},

si: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '';
  if (ord) return 'other';
  return ((n == 0 || n == 1)
          || i == 0 && f == 1) ? 'one' : 'other';
},

sk: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one'
      : ((i >= 2 && i <= 4) && v0) ? 'few'
      : (!v0) ? 'many'
      : 'other';
},

sl: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], i100 = i.slice(-2);
  if (ord) return 'other';
  return (v0 && i100 == 1) ? 'one'
      : (v0 && i100 == 2) ? 'two'
      : (v0 && (i100 == 3 || i100 == 4)
          || !v0) ? 'few'
      : 'other';
},

sma: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smi: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smj: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

smn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

sms: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one'
      : (n == 2) ? 'two'
      : 'other';
},

sn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

so: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sq: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return (n == 1) ? 'one'
      : (n10 == 4 && n100 != 14) ? 'many'
      : 'other';
  return (n == 1) ? 'one' : 'other';
},

sr: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), i100 = i.slice(-2), f10 = f.slice(-1), f100 = f.slice(-2);
  if (ord) return 'other';
  return (v0 && i10 == 1 && i100 != 11
          || f10 == 1 && f100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12 || i100 > 14)
          || (f10 >= 2 && f10 <= 4) && (f100 < 12
          || f100 > 14)) ? 'few'
      : 'other';
},

ss: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ssy: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

st: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

sv: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2);
  if (ord) return ((n10 == 1
          || n10 == 2) && n100 != 11 && n100 != 12) ? 'one' : 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

sw: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

syr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ta: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

te: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

teo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

th: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

ti: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

tig: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

tk: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1);
  if (ord) return ((n10 == 6 || n10 == 9)
          || n == 10) ? 'few' : 'other';
  return (n == 1) ? 'one' : 'other';
},

tl: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], f = s[1] || '', v0 = !s[1],
      i10 = i.slice(-1), f10 = f.slice(-1);
  if (ord) return (n == 1) ? 'one' : 'other';
  return (v0 && (i == 1 || i == 2 || i == 3)
          || v0 && i10 != 4 && i10 != 6 && i10 != 9
          || !v0 && f10 != 4 && f10 != 6 && f10 != 9) ? 'one' : 'other';
},

tn: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

to: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

tr: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ts: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

tzm: function(n, ord
) {
  var s = String(n).split('.'), t0 = Number(s[0]) == n;
  if (ord) return 'other';
  return ((n == 0 || n == 1)
          || (t0 && n >= 11 && n <= 99)) ? 'one' : 'other';
},

ug: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

uk: function(n, ord
) {
  var s = String(n).split('.'), i = s[0], v0 = !s[1], t0 = Number(s[0]) == n,
      n10 = t0 && s[0].slice(-1), n100 = t0 && s[0].slice(-2), i10 = i.slice(-1),
      i100 = i.slice(-2);
  if (ord) return (n10 == 3 && n100 != 13) ? 'few' : 'other';
  return (v0 && i10 == 1 && i100 != 11) ? 'one'
      : (v0 && (i10 >= 2 && i10 <= 4) && (i100 < 12
          || i100 > 14)) ? 'few'
      : (v0 && i10 == 0 || v0 && (i10 >= 5 && i10 <= 9)
          || v0 && (i100 >= 11 && i100 <= 14)) ? 'many'
      : 'other';
},

ur: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

uz: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

ve: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

vi: function(n, ord
) {
  if (ord) return (n == 1) ? 'one' : 'other';
  return 'other';
},

vo: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

vun: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

wa: function(n, ord
) {
  if (ord) return 'other';
  return ((n == 0
          || n == 1)) ? 'one' : 'other';
},

wae: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

wo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

xh: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

xog: function(n, ord
) {
  if (ord) return 'other';
  return (n == 1) ? 'one' : 'other';
},

yi: function(n, ord
) {
  var s = String(n).split('.'), v0 = !s[1];
  if (ord) return 'other';
  return (n == 1 && v0) ? 'one' : 'other';
},

yo: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

yue: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

zh: function(n, ord
) {
  if (ord) return 'other';
  return 'other';
},

zu: function(n, ord
) {
  if (ord) return 'other';
  return (n >= 0 && n <= 1) ? 'one' : 'other';
}
}));


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;var _cc = [
  {cardinal:["other"],ordinal:["other"]},
  {cardinal:["one","other"],ordinal:["other"]},
  {cardinal:["one","other"],ordinal:["one","other"]},
  {cardinal:["one","two","other"],ordinal:["other"]}
];

(function (root, pluralCategories) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (pluralCategories),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports === 'object') {
    module.exports = pluralCategories;
  } else {
    root.pluralCategories = pluralCategories;
  }
}(this, {
af: _cc[1],
ak: _cc[1],
am: _cc[1],
ar: {cardinal:["zero","one","two","few","many","other"],ordinal:["other"]},
ars: {cardinal:["zero","one","two","few","many","other"],ordinal:["other"]},
as: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
asa: _cc[1],
ast: _cc[1],
az: {cardinal:["one","other"],ordinal:["one","few","many","other"]},
be: {cardinal:["one","few","many","other"],ordinal:["few","other"]},
bem: _cc[1],
bez: _cc[1],
bg: _cc[1],
bh: _cc[1],
bm: _cc[0],
bn: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
bo: _cc[0],
br: {cardinal:["one","two","few","many","other"],ordinal:["other"]},
brx: _cc[1],
bs: {cardinal:["one","few","other"],ordinal:["other"]},
ca: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
ce: _cc[1],
cgg: _cc[1],
chr: _cc[1],
ckb: _cc[1],
cs: {cardinal:["one","few","many","other"],ordinal:["other"]},
cy: {cardinal:["zero","one","two","few","many","other"],ordinal:["zero","one","two","few","many","other"]},
da: _cc[1],
de: _cc[1],
dsb: {cardinal:["one","two","few","other"],ordinal:["other"]},
dv: _cc[1],
dz: _cc[0],
ee: _cc[1],
el: _cc[1],
en: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
eo: _cc[1],
es: _cc[1],
et: _cc[1],
eu: _cc[1],
fa: _cc[1],
ff: _cc[1],
fi: _cc[1],
fil: _cc[2],
fo: _cc[1],
fr: _cc[2],
fur: _cc[1],
fy: _cc[1],
ga: {cardinal:["one","two","few","many","other"],ordinal:["one","other"]},
gd: {cardinal:["one","two","few","other"],ordinal:["one","two","few","other"]},
gl: _cc[1],
gsw: _cc[1],
gu: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
guw: _cc[1],
gv: {cardinal:["one","two","few","many","other"],ordinal:["other"]},
ha: _cc[1],
haw: _cc[1],
he: {cardinal:["one","two","many","other"],ordinal:["other"]},
hi: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
hr: {cardinal:["one","few","other"],ordinal:["other"]},
hsb: {cardinal:["one","two","few","other"],ordinal:["other"]},
hu: _cc[2],
hy: _cc[2],
ia: _cc[1],
id: _cc[0],
ig: _cc[0],
ii: _cc[0],
"in": _cc[0],
io: _cc[1],
is: _cc[1],
it: {cardinal:["one","other"],ordinal:["many","other"]},
iu: _cc[3],
iw: {cardinal:["one","two","many","other"],ordinal:["other"]},
ja: _cc[0],
jbo: _cc[0],
jgo: _cc[1],
ji: _cc[1],
jmc: _cc[1],
jv: _cc[0],
jw: _cc[0],
ka: {cardinal:["one","other"],ordinal:["one","many","other"]},
kab: _cc[1],
kaj: _cc[1],
kcg: _cc[1],
kde: _cc[0],
kea: _cc[0],
kk: {cardinal:["one","other"],ordinal:["many","other"]},
kkj: _cc[1],
kl: _cc[1],
km: _cc[0],
kn: _cc[1],
ko: _cc[0],
ks: _cc[1],
ksb: _cc[1],
ksh: {cardinal:["zero","one","other"],ordinal:["other"]},
ku: _cc[1],
kw: _cc[3],
ky: _cc[1],
lag: {cardinal:["zero","one","other"],ordinal:["other"]},
lb: _cc[1],
lg: _cc[1],
lkt: _cc[0],
ln: _cc[1],
lo: {cardinal:["other"],ordinal:["one","other"]},
lt: {cardinal:["one","few","many","other"],ordinal:["other"]},
lv: {cardinal:["zero","one","other"],ordinal:["other"]},
mas: _cc[1],
mg: _cc[1],
mgo: _cc[1],
mk: {cardinal:["one","other"],ordinal:["one","two","many","other"]},
ml: _cc[1],
mn: _cc[1],
mo: {cardinal:["one","few","other"],ordinal:["one","other"]},
mr: {cardinal:["one","other"],ordinal:["one","two","few","other"]},
ms: {cardinal:["other"],ordinal:["one","other"]},
mt: {cardinal:["one","few","many","other"],ordinal:["other"]},
my: _cc[0],
nah: _cc[1],
naq: _cc[3],
nb: _cc[1],
nd: _cc[1],
ne: _cc[2],
nl: _cc[1],
nn: _cc[1],
nnh: _cc[1],
no: _cc[1],
nqo: _cc[0],
nr: _cc[1],
nso: _cc[1],
ny: _cc[1],
nyn: _cc[1],
om: _cc[1],
or: {cardinal:["one","other"],ordinal:["one","two","few","many","other"]},
os: _cc[1],
pa: _cc[1],
pap: _cc[1],
pl: {cardinal:["one","few","many","other"],ordinal:["other"]},
prg: {cardinal:["zero","one","other"],ordinal:["other"]},
ps: _cc[1],
pt: _cc[1],
"pt-PT": _cc[1],
rm: _cc[1],
ro: {cardinal:["one","few","other"],ordinal:["one","other"]},
rof: _cc[1],
root: _cc[0],
ru: {cardinal:["one","few","many","other"],ordinal:["other"]},
rwk: _cc[1],
sah: _cc[0],
saq: _cc[1],
sc: {cardinal:["one","other"],ordinal:["many","other"]},
scn: {cardinal:["one","other"],ordinal:["many","other"]},
sd: _cc[1],
sdh: _cc[1],
se: _cc[3],
seh: _cc[1],
ses: _cc[0],
sg: _cc[0],
sh: {cardinal:["one","few","other"],ordinal:["other"]},
shi: {cardinal:["one","few","other"],ordinal:["other"]},
si: _cc[1],
sk: {cardinal:["one","few","many","other"],ordinal:["other"]},
sl: {cardinal:["one","two","few","other"],ordinal:["other"]},
sma: _cc[3],
smi: _cc[3],
smj: _cc[3],
smn: _cc[3],
sms: _cc[3],
sn: _cc[1],
so: _cc[1],
sq: {cardinal:["one","other"],ordinal:["one","many","other"]},
sr: {cardinal:["one","few","other"],ordinal:["other"]},
ss: _cc[1],
ssy: _cc[1],
st: _cc[1],
sv: _cc[2],
sw: _cc[1],
syr: _cc[1],
ta: _cc[1],
te: _cc[1],
teo: _cc[1],
th: _cc[0],
ti: _cc[1],
tig: _cc[1],
tk: {cardinal:["one","other"],ordinal:["few","other"]},
tl: _cc[2],
tn: _cc[1],
to: _cc[0],
tr: _cc[1],
ts: _cc[1],
tzm: _cc[1],
ug: _cc[1],
uk: {cardinal:["one","few","many","other"],ordinal:["few","other"]},
ur: _cc[1],
uz: _cc[1],
ve: _cc[1],
vi: {cardinal:["other"],ordinal:["one","other"]},
vo: _cc[1],
vun: _cc[1],
wa: _cc[1],
wae: _cc[1],
wo: _cc[0],
xh: _cc[1],
xog: _cc[1],
yi: _cc[1],
yo: _cc[0],
yue: _cc[0],
zh: _cc[0],
zu: _cc[1]
}));


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * mustache.js - Logic-less {{mustache}} templates with JavaScript
 * http://github.com/janl/mustache.js
 */

/*global define: false Mustache: true*/

(function defineMustache (global, factory) {
  if (typeof exports === 'object' && exports && typeof exports.nodeName !== 'string') {
    factory(exports); // CommonJS
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); // AMD
  } else {
    global.Mustache = {};
    factory(global.Mustache); // script, wsh, asp
  }
}(this, function mustacheFactory (mustache) {

  var objectToString = Object.prototype.toString;
  var isArray = Array.isArray || function isArrayPolyfill (object) {
    return objectToString.call(object) === '[object Array]';
  };

  function isFunction (object) {
    return typeof object === 'function';
  }

  /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */
  function typeStr (obj) {
    return isArray(obj) ? 'array' : typeof obj;
  }

  function escapeRegExp (string) {
    return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
  }

  /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */
  function hasProperty (obj, propName) {
    return obj != null && typeof obj === 'object' && (propName in obj);
  }

  // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
  // See https://github.com/janl/mustache.js/issues/189
  var regExpTest = RegExp.prototype.test;
  function testRegExp (re, string) {
    return regExpTest.call(re, string);
  }

  var nonSpaceRe = /\S/;
  function isWhitespace (string) {
    return !testRegExp(nonSpaceRe, string);
  }

  var entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;',
    '`': '&#x60;',
    '=': '&#x3D;'
  };

  function escapeHtml (string) {
    return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap (s) {
      return entityMap[s];
    });
  }

  var whiteRe = /\s*/;
  var spaceRe = /\s+/;
  var equalsRe = /\s*=/;
  var curlyRe = /\s*\}/;
  var tagRe = /#|\^|\/|>|\{|&|=|!/;

  /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   */
  function parseTemplate (template, tags) {
    if (!template)
      return [];

    var sections = [];     // Stack to hold section tokens
    var tokens = [];       // Buffer to hold the tokens
    var spaces = [];       // Indices of whitespace tokens on the current line
    var hasTag = false;    // Is there a {{tag}} on the current line?
    var nonSpace = false;  // Is there a non-space char on the current line?

    // Strips all whitespace tokens array for the current line
    // if there was a {{#tag}} on it and otherwise only space.
    function stripSpace () {
      if (hasTag && !nonSpace) {
        while (spaces.length)
          delete tokens[spaces.pop()];
      } else {
        spaces = [];
      }

      hasTag = false;
      nonSpace = false;
    }

    var openingTagRe, closingTagRe, closingCurlyRe;
    function compileTags (tagsToCompile) {
      if (typeof tagsToCompile === 'string')
        tagsToCompile = tagsToCompile.split(spaceRe, 2);

      if (!isArray(tagsToCompile) || tagsToCompile.length !== 2)
        throw new Error('Invalid tags: ' + tagsToCompile);

      openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
      closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
      closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
    }

    compileTags(tags || mustache.tags);

    var scanner = new Scanner(template);

    var start, type, value, chr, token, openSection;
    while (!scanner.eos()) {
      start = scanner.pos;

      // Match any text between tags.
      value = scanner.scanUntil(openingTagRe);

      if (value) {
        for (var i = 0, valueLength = value.length; i < valueLength; ++i) {
          chr = value.charAt(i);

          if (isWhitespace(chr)) {
            spaces.push(tokens.length);
          } else {
            nonSpace = true;
          }

          tokens.push([ 'text', chr, start, start + 1 ]);
          start += 1;

          // Check for whitespace on the current line.
          if (chr === '\n')
            stripSpace();
        }
      }

      // Match the opening tag.
      if (!scanner.scan(openingTagRe))
        break;

      hasTag = true;

      // Get the tag type.
      type = scanner.scan(tagRe) || 'name';
      scanner.scan(whiteRe);

      // Get the tag value.
      if (type === '=') {
        value = scanner.scanUntil(equalsRe);
        scanner.scan(equalsRe);
        scanner.scanUntil(closingTagRe);
      } else if (type === '{') {
        value = scanner.scanUntil(closingCurlyRe);
        scanner.scan(curlyRe);
        scanner.scanUntil(closingTagRe);
        type = '&';
      } else {
        value = scanner.scanUntil(closingTagRe);
      }

      // Match the closing tag.
      if (!scanner.scan(closingTagRe))
        throw new Error('Unclosed tag at ' + scanner.pos);

      token = [ type, value, start, scanner.pos ];
      tokens.push(token);

      if (type === '#' || type === '^') {
        sections.push(token);
      } else if (type === '/') {
        // Check section nesting.
        openSection = sections.pop();

        if (!openSection)
          throw new Error('Unopened section "' + value + '" at ' + start);

        if (openSection[1] !== value)
          throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
      } else if (type === 'name' || type === '{' || type === '&') {
        nonSpace = true;
      } else if (type === '=') {
        // Set the tags for the next time around.
        compileTags(value);
      }
    }

    // Make sure there are no open sections when we're done.
    openSection = sections.pop();

    if (openSection)
      throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);

    return nestTokens(squashTokens(tokens));
  }

  /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */
  function squashTokens (tokens) {
    var squashedTokens = [];

    var token, lastToken;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      if (token) {
        if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
          lastToken[1] += token[1];
          lastToken[3] = token[3];
        } else {
          squashedTokens.push(token);
          lastToken = token;
        }
      }
    }

    return squashedTokens;
  }

  /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */
  function nestTokens (tokens) {
    var nestedTokens = [];
    var collector = nestedTokens;
    var sections = [];

    var token, section;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      token = tokens[i];

      switch (token[0]) {
        case '#':
        case '^':
          collector.push(token);
          sections.push(token);
          collector = token[4] = [];
          break;
        case '/':
          section = sections.pop();
          section[5] = token[2];
          collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
          break;
        default:
          collector.push(token);
      }
    }

    return nestedTokens;
  }

  /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */
  function Scanner (string) {
    this.string = string;
    this.tail = string;
    this.pos = 0;
  }

  /**
   * Returns `true` if the tail is empty (end of string).
   */
  Scanner.prototype.eos = function eos () {
    return this.tail === '';
  };

  /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */
  Scanner.prototype.scan = function scan (re) {
    var match = this.tail.match(re);

    if (!match || match.index !== 0)
      return '';

    var string = match[0];

    this.tail = this.tail.substring(string.length);
    this.pos += string.length;

    return string;
  };

  /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */
  Scanner.prototype.scanUntil = function scanUntil (re) {
    var index = this.tail.search(re), match;

    switch (index) {
      case -1:
        match = this.tail;
        this.tail = '';
        break;
      case 0:
        match = '';
        break;
      default:
        match = this.tail.substring(0, index);
        this.tail = this.tail.substring(index);
    }

    this.pos += match.length;

    return match;
  };

  /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */
  function Context (view, parentContext) {
    this.view = view;
    this.cache = { '.': this.view };
    this.parent = parentContext;
  }

  /**
   * Creates a new context using the given view with this context
   * as the parent.
   */
  Context.prototype.push = function push (view) {
    return new Context(view, this);
  };

  /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */
  Context.prototype.lookup = function lookup (name) {
    var cache = this.cache;

    var value;
    if (cache.hasOwnProperty(name)) {
      value = cache[name];
    } else {
      var context = this, names, index, lookupHit = false;

      while (context) {
        if (name.indexOf('.') > 0) {
          value = context.view;
          names = name.split('.');
          index = 0;

          /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           **/
          while (value != null && index < names.length) {
            if (index === names.length - 1)
              lookupHit = hasProperty(value, names[index]);

            value = value[names[index++]];
          }
        } else {
          value = context.view[name];
          lookupHit = hasProperty(context.view, name);
        }

        if (lookupHit)
          break;

        context = context.parent;
      }

      cache[name] = value;
    }

    if (isFunction(value))
      value = value.call(this.view);

    return value;
  };

  /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */
  function Writer () {
    this.cache = {};
  }

  /**
   * Clears all cached templates in this writer.
   */
  Writer.prototype.clearCache = function clearCache () {
    this.cache = {};
  };

  /**
   * Parses and caches the given `template` and returns the array of tokens
   * that is generated from the parse.
   */
  Writer.prototype.parse = function parse (template, tags) {
    var cache = this.cache;
    var tokens = cache[template];

    if (tokens == null)
      tokens = cache[template] = parseTemplate(template, tags);

    return tokens;
  };

  /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   */
  Writer.prototype.render = function render (template, view, partials) {
    var tokens = this.parse(template);
    var context = (view instanceof Context) ? view : new Context(view);
    return this.renderTokens(tokens, context, partials, template);
  };

  /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */
  Writer.prototype.renderTokens = function renderTokens (tokens, context, partials, originalTemplate) {
    var buffer = '';

    var token, symbol, value;
    for (var i = 0, numTokens = tokens.length; i < numTokens; ++i) {
      value = undefined;
      token = tokens[i];
      symbol = token[0];

      if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate);
      else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate);
      else if (symbol === '>') value = this.renderPartial(token, context, partials, originalTemplate);
      else if (symbol === '&') value = this.unescapedValue(token, context);
      else if (symbol === 'name') value = this.escapedValue(token, context);
      else if (symbol === 'text') value = this.rawValue(token);

      if (value !== undefined)
        buffer += value;
    }

    return buffer;
  };

  Writer.prototype.renderSection = function renderSection (token, context, partials, originalTemplate) {
    var self = this;
    var buffer = '';
    var value = context.lookup(token[1]);

    // This function is used to render an arbitrary template
    // in the current context by higher-order sections.
    function subRender (template) {
      return self.render(template, context, partials);
    }

    if (!value) return;

    if (isArray(value)) {
      for (var j = 0, valueLength = value.length; j < valueLength; ++j) {
        buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate);
      }
    } else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') {
      buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate);
    } else if (isFunction(value)) {
      if (typeof originalTemplate !== 'string')
        throw new Error('Cannot use higher-order sections without the original template');

      // Extract the portion of the original template that the section contains.
      value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);

      if (value != null)
        buffer += value;
    } else {
      buffer += this.renderTokens(token[4], context, partials, originalTemplate);
    }
    return buffer;
  };

  Writer.prototype.renderInverted = function renderInverted (token, context, partials, originalTemplate) {
    var value = context.lookup(token[1]);

    // Use JavaScript's definition of falsy. Include empty arrays.
    // See https://github.com/janl/mustache.js/issues/186
    if (!value || (isArray(value) && value.length === 0))
      return this.renderTokens(token[4], context, partials, originalTemplate);
  };

  Writer.prototype.renderPartial = function renderPartial (token, context, partials) {
    if (!partials) return;

    var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
    if (value != null)
      return this.renderTokens(this.parse(value), context, partials, value);
  };

  Writer.prototype.unescapedValue = function unescapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return value;
  };

  Writer.prototype.escapedValue = function escapedValue (token, context) {
    var value = context.lookup(token[1]);
    if (value != null)
      return mustache.escape(value);
  };

  Writer.prototype.rawValue = function rawValue (token) {
    return token[1];
  };

  mustache.name = 'mustache.js';
  mustache.version = '2.3.2';
  mustache.tags = [ '{{', '}}' ];

  // All high-level mustache.* functions use this writer.
  var defaultWriter = new Writer();

  /**
   * Clears all cached templates in the default writer.
   */
  mustache.clearCache = function clearCache () {
    return defaultWriter.clearCache();
  };

  /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */
  mustache.parse = function parse (template, tags) {
    return defaultWriter.parse(template, tags);
  };

  /**
   * Renders the `template` with the given `view` and `partials` using the
   * default writer.
   */
  mustache.render = function render (template, view, partials) {
    if (typeof template !== 'string') {
      throw new TypeError('Invalid template! Template should be a "string" ' +
                          'but "' + typeStr(template) + '" was given as the first ' +
                          'argument for mustache#render(template, view, partials)');
    }

    return defaultWriter.render(template, view, partials);
  };

  // This is here for backwards compatibility with 0.4.x.,
  /*eslint-disable */ // eslint wants camel cased function name
  mustache.to_html = function to_html (template, view, partials, send) {
    /*eslint-enable*/

    var result = mustache.render(template, view, partials);

    if (isFunction(send)) {
      send(result);
    } else {
      return result;
    }
  };

  // Export the escaping function so that the user may override it.
  // See https://github.com/janl/mustache.js/issues/244
  mustache.escape = escapeHtml;

  // Export these mainly for testing, but also for advanced usage.
  mustache.Scanner = Scanner;
  mustache.Context = Context;
  mustache.Writer = Writer;

  return mustache;
}));


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var punycode = __webpack_require__(512);

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__(513);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module), __webpack_require__(31)))

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(514);
var parse = __webpack_require__(518);
var formats = __webpack_require__(162);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(230);
var utils = __webpack_require__(232);
var formats = __webpack_require__(162);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(110);

var $TypeError = __webpack_require__(49);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(104);
var callBound = __webpack_require__(87);
var inspect = __webpack_require__(110);
var getSideChannelMap = __webpack_require__(231);

var $TypeError = __webpack_require__(49);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(232);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictMerge: true,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
            if (options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            }
            val = utils.combine([], val, options.arrayLimit, options.plainObjects);
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && (options.duplicates === 'combine' || part.indexOf('[]=') > -1)) {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            var isValidArrayIndex = !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && options.parseArrays;
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (isValidArrayIndex && index < options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
            } else if (isValidArrayIndex) {
                obj[index] = leaf;
                utils.markOverflow(obj, index);
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    var keys = [];

    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = parent;
    }

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;

        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys[keys.length] = segment[1];
    }

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        keys[keys.length] = '[' + key.slice(segment.index) + ']';
    }

    return keys;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(229)(module)))

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  _createClass(HttpRequest, null, [{
    key: 'parseJson',

    /**
     * @name parseJson
     * @description
     * Static class method that parses response to json
     * @param {Object} - Response object from HTTP request
     * @returns {string} - Json string
     */
    value: function parseJson(res) {
      if (!res.ok) {
        throw new Error(res.message);
      }
      return res.json();
    }

    /**
     * @name parseBlob
     * @description
     * Static class method that parses response to blob
     * @param {Object} - Response object from HTTP request
     * @returns {Blob} - Blob
     */

  }, {
    key: 'parseBlob',
    value: function parseBlob(res) {
      if (!res.ok) {
        throw new Error(res.message);
      }
      return res.blob();
    }

    /**
     * @name handleError
     * @description
     * Static class method for error handling
     * @param {Error}
     * @returns undefined
     */

  }, {
    key: 'handleError',
    value: function handleError(err) {
      throw err;
    }
  }, {
    key: 'queryString',
    value: function queryString() {
      var queryParams = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var query = '';

      // Default options
      var params = Object.assign(queryParams, {});
      Object.keys(params).forEach(function (key, i) {
        // First param must be ? instead of &
        query += '' + (i === 0 ? '?' : '&') + key + '=' + params[key];
      });
      return query;
    }
  }]);

  function HttpRequest() {
    var apiUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, HttpRequest);

    this.apiUrl = apiUrl;
  }

  /**
   * @name get
   * @description
   * Method that performs a GET request using the fetch API
   * @param {string} route - Path to route
   * @param {Object=} opts - Options override
   * @returns {Promise}
   */


  _createClass(HttpRequest, [{
    key: 'get',
    value: function get(route) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return fetch('' + (this.apiUrl + route + HttpRequest.queryString(opts.search)), opts).then(opts.blob ? HttpRequest.parseBlob : HttpRequest.parseJson).catch(HttpRequest.handleError);
    }

    /**
     * @name post
     * @description
     * Method that performs a POST request using the fetch API
     * @param {string} route - Path to route
     * @param {Object} body - Body data object to send
     * @param {Object=} opts - Options override
     * @returns {Promise}
     */

  }, {
    key: 'post',
    value: function post(route, body) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return fetch('' + (this.apiUrl + route + HttpRequest.queryString(opts.search)), Object.assign(opts, {
        headers: Object.assign({ 'Content-Type': 'application/json' }, opts.headers),
        method: 'POST',
        body: JSON.stringify(body)
      })).then(opts.blob ? HttpRequest.parseBlob : HttpRequest.parseJson).catch(HttpRequest.handleError);
    }

    /**
     * @name put
     * @description
     * Method that performs a PUT request using the fetch API
     * @param {string} route - Path to route
     * @param {Object} body - Body data object to send
     * @param {Object=} opts - Options override
     * @returns {Promise}
     */

  }, {
    key: 'put',
    value: function put(route, body) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      return fetch('' + (this.apiUrl + route + HttpRequest.queryString(opts.search)), Object.assign(opts, {
        headers: Object.assign({ 'Content-Type': 'application/json' }, opts.headers),
        method: 'PUT',
        body: JSON.stringify(body)
      })).then(opts.blob ? HttpRequest.parseBlob : HttpRequest.parseJson).catch(HttpRequest.handleError);
    }

    /**
     * @name del
     * @description
     * Method that performs a DELETE request using the fetch API
     * @param {string} route - Path to route
     * @param {Object=} opts - Options override
     * @returns {Promise}
     */

  }, {
    key: 'del',
    value: function del(route) {
      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return fetch('' + (this.apiUrl + route + HttpRequest.queryString(opts.search)), Object.assign(opts, { method: 'DELETE' })).then(opts.blob ? HttpRequest.parseBlob : HttpRequest.parseJson).catch(HttpRequest.handleError);
    }

    /**
     * @name upload
     * @description
     * Method that performs a POST request using the fetch API
     * This method will create a new instance of FormData with
     * a single file or an array of files to use as body
     * @param {string} route - Path to route
     * @param {Array || File} - File or array of files
     * @param {Object=} - Options override
     */

  }, {
    key: 'upload',
    value: function upload(route, files) {
      var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var formData = new FormData();
      if (Array.isArray(files)) {
        files.forEach(function (fl, i) {
          if (fl instanceof File) {
            formData.append('file-' + i, fl, fl.name);
          }
        });
      } else {
        formData.append('file', files, files.name);
      }
      return fetch('' + (this.apiUrl + route + HttpRequest.queryString(opts.search)), Object.assign(opts, {
        method: 'POST',
        body: formData
      })).then(opts.blob ? HttpRequest.parseBlob : HttpRequest.parseJson).catch(HttpRequest.handleError);
    }
  }]);

  return HttpRequest;
}();

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cookie = __webpack_require__(163);

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

module.exports = function () {
  function Authorization() {
    var authTokenCookieName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'token';
    var cookieExpire = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 365;

    _classCallCheck(this, Authorization);

    this.authTokenCookieName = authTokenCookieName;
    this.cookieExpire = cookieExpire;
  }

  /**
   * Method to get Authorization string
   * @name getAuthString
   * @returns string
   */


  _createClass(Authorization, [{
    key: 'getAuthString',
    value: function getAuthString() {
      return 'Bearer ' + _cookie2.default.getCookie(this.authTokenCookieName);
    }

    /**
     * Method to get Authorization token
     * @name getAuthToken
     * @returns string
     */

  }, {
    key: 'getAuthToken',
    value: function getAuthToken() {
      return _cookie2.default.getCookie(this.authTokenCookieName);
    }

    /**
     * Method to set authorization token
     * @name setAuthToken
     * @returns boolean
     */

  }, {
    key: 'setAuthToken',
    value: function setAuthToken(token) {
      if (_cookie2.default.setCookie(this.authTokenCookieName, token, this.cookieExpire)) {
        return true;
      }
      return false;
    }
  }]);

  return Authorization;
}();

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(523),
    dateFormat = _require.dateFormat;

var format = dateFormat ? dateFormat : 'yyyy-mm-dd';

module.exports = {
  getTime: function getTime(stamp) {
    var time = new Date(stamp);

    time = time.getHours() + ':' + (time.getMinutes() < 10 ? '0' : '') + time.getMinutes();
    return time;
  },
  humanReadable: function humanReadable(stamp) {
    var date = new Date(stamp);
    var dd = date.getDate();
    var mm = date.getMonth() + 1; // January is 0!

    var yyyy = date.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    date = yyyy + '-' + mm + '-' + dd;
    return date;
  }
};

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  dateFormat: 'yyyy-mm-dd'
};

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var validator = __webpack_require__(525);

// Validate is field is not empty
var notEmpty = function notEmpty(input) {
  return !validator.isEmpty(input);
};

// Validate if input is a number
var isNumber = function isNumber(input) {
  return validator.isNumeric(input);
};

// Validate string length
var len = function len(str, min, max) {
  return validator.isLength(str, { min: min, max: max });
};

// Validate if date is after today
var dateIsFuture = function dateIsFuture(input) {
  return validator.isBefore(new Date().toString(), input);
};

// Validate if date is after another date
var dateIsAfterDate = function dateIsAfterDate(input, inputAfter) {
  return validator.isAfter(input, inputAfter);
};

// Validate group amount
var amountOfGroups = function amountOfGroups(input) {
  return Array.isArray(input) && parseInt(input.length) === 6;
};

// Validate amount of students in group
var amountOfStudents = function amountOfStudents(input) {
  return Array.isArray(input) && parseInt(input.length) > 1 && parseInt(input.length) < 7;
};

module.exports = Object.assign(validator, {
  notEmpty: notEmpty,
  isNumber: isNumber,
  dateIsFuture: dateIsFuture,
  dateIsAfterDate: dateIsAfterDate,
  amountOfGroups: amountOfGroups,
  amountOfStudents: amountOfStudents,
  len: len
});

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toDate = _interopRequireDefault(__webpack_require__(164));

var _toFloat = _interopRequireDefault(__webpack_require__(233));

var _toInt = _interopRequireDefault(__webpack_require__(526));

var _toBoolean = _interopRequireDefault(__webpack_require__(527));

var _equals = _interopRequireDefault(__webpack_require__(528));

var _contains = _interopRequireDefault(__webpack_require__(529));

var _matches = _interopRequireDefault(__webpack_require__(530));

var _isEmail = _interopRequireDefault(__webpack_require__(531));

var _isURL = _interopRequireDefault(__webpack_require__(532));

var _isMACAddress = _interopRequireDefault(__webpack_require__(533));

var _isIP = _interopRequireDefault(__webpack_require__(111));

var _isIPRange = _interopRequireDefault(__webpack_require__(534));

var _isFQDN = _interopRequireDefault(__webpack_require__(166));

var _isBoolean = _interopRequireDefault(__webpack_require__(535));

var _isAlpha = _interopRequireWildcard(__webpack_require__(536));

var _isAlphanumeric = _interopRequireWildcard(__webpack_require__(537));

var _isNumeric = _interopRequireDefault(__webpack_require__(538));

var _isPort = _interopRequireDefault(__webpack_require__(539));

var _isLowercase = _interopRequireDefault(__webpack_require__(540));

var _isUppercase = _interopRequireDefault(__webpack_require__(541));

var _isAscii = _interopRequireDefault(__webpack_require__(542));

var _isFullWidth = _interopRequireDefault(__webpack_require__(236));

var _isHalfWidth = _interopRequireDefault(__webpack_require__(237));

var _isVariableWidth = _interopRequireDefault(__webpack_require__(543));

var _isMultibyte = _interopRequireDefault(__webpack_require__(544));

var _isSurrogatePair = _interopRequireDefault(__webpack_require__(545));

var _isInt = _interopRequireDefault(__webpack_require__(235));

var _isFloat = _interopRequireWildcard(__webpack_require__(546));

var _isDecimal = _interopRequireDefault(__webpack_require__(547));

var _isHexadecimal = _interopRequireDefault(__webpack_require__(238));

var _isDivisibleBy = _interopRequireDefault(__webpack_require__(548));

var _isHexColor = _interopRequireDefault(__webpack_require__(549));

var _isISRC = _interopRequireDefault(__webpack_require__(550));

var _isMD = _interopRequireDefault(__webpack_require__(551));

var _isHash = _interopRequireDefault(__webpack_require__(552));

var _isJWT = _interopRequireDefault(__webpack_require__(553));

var _isJSON = _interopRequireDefault(__webpack_require__(554));

var _isEmpty = _interopRequireDefault(__webpack_require__(555));

var _isLength = _interopRequireDefault(__webpack_require__(556));

var _isByteLength = _interopRequireDefault(__webpack_require__(234));

var _isUUID = _interopRequireDefault(__webpack_require__(557));

var _isMongoId = _interopRequireDefault(__webpack_require__(558));

var _isAfter = _interopRequireDefault(__webpack_require__(559));

var _isBefore = _interopRequireDefault(__webpack_require__(560));

var _isIn = _interopRequireDefault(__webpack_require__(561));

var _isCreditCard = _interopRequireDefault(__webpack_require__(562));

var _isIdentityCard = _interopRequireDefault(__webpack_require__(563));

var _isISIN = _interopRequireDefault(__webpack_require__(564));

var _isISBN = _interopRequireDefault(__webpack_require__(565));

var _isISSN = _interopRequireDefault(__webpack_require__(566));

var _isMobilePhone = _interopRequireWildcard(__webpack_require__(567));

var _isCurrency = _interopRequireDefault(__webpack_require__(568));

var _isISO = _interopRequireDefault(__webpack_require__(569));

var _isRFC = _interopRequireDefault(__webpack_require__(570));

var _isISO31661Alpha = _interopRequireDefault(__webpack_require__(571));

var _isISO31661Alpha2 = _interopRequireDefault(__webpack_require__(572));

var _isBase = _interopRequireDefault(__webpack_require__(573));

var _isDataURI = _interopRequireDefault(__webpack_require__(574));

var _isMagnetURI = _interopRequireDefault(__webpack_require__(575));

var _isMimeType = _interopRequireDefault(__webpack_require__(576));

var _isLatLong = _interopRequireDefault(__webpack_require__(577));

var _isPostalCode = _interopRequireWildcard(__webpack_require__(578));

var _ltrim = _interopRequireDefault(__webpack_require__(239));

var _rtrim = _interopRequireDefault(__webpack_require__(240));

var _trim = _interopRequireDefault(__webpack_require__(579));

var _escape = _interopRequireDefault(__webpack_require__(580));

var _unescape = _interopRequireDefault(__webpack_require__(581));

var _stripLow = _interopRequireDefault(__webpack_require__(582));

var _whitelist = _interopRequireDefault(__webpack_require__(583));

var _blacklist = _interopRequireDefault(__webpack_require__(241));

var _isWhitelisted = _interopRequireDefault(__webpack_require__(584));

var _normalizeEmail = _interopRequireDefault(__webpack_require__(585));

var _toString = _interopRequireDefault(__webpack_require__(165));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = '10.11.0';
var validator = {
  version: version,
  toDate: _toDate.default,
  toFloat: _toFloat.default,
  toInt: _toInt.default,
  toBoolean: _toBoolean.default,
  equals: _equals.default,
  contains: _contains.default,
  matches: _matches.default,
  isEmail: _isEmail.default,
  isURL: _isURL.default,
  isMACAddress: _isMACAddress.default,
  isIP: _isIP.default,
  isIPRange: _isIPRange.default,
  isFQDN: _isFQDN.default,
  isBoolean: _isBoolean.default,
  isAlpha: _isAlpha.default,
  isAlphaLocales: _isAlpha.locales,
  isAlphanumeric: _isAlphanumeric.default,
  isAlphanumericLocales: _isAlphanumeric.locales,
  isNumeric: _isNumeric.default,
  isPort: _isPort.default,
  isLowercase: _isLowercase.default,
  isUppercase: _isUppercase.default,
  isAscii: _isAscii.default,
  isFullWidth: _isFullWidth.default,
  isHalfWidth: _isHalfWidth.default,
  isVariableWidth: _isVariableWidth.default,
  isMultibyte: _isMultibyte.default,
  isSurrogatePair: _isSurrogatePair.default,
  isInt: _isInt.default,
  isFloat: _isFloat.default,
  isFloatLocales: _isFloat.locales,
  isDecimal: _isDecimal.default,
  isHexadecimal: _isHexadecimal.default,
  isDivisibleBy: _isDivisibleBy.default,
  isHexColor: _isHexColor.default,
  isISRC: _isISRC.default,
  isMD5: _isMD.default,
  isHash: _isHash.default,
  isJWT: _isJWT.default,
  isJSON: _isJSON.default,
  isEmpty: _isEmpty.default,
  isLength: _isLength.default,
  isByteLength: _isByteLength.default,
  isUUID: _isUUID.default,
  isMongoId: _isMongoId.default,
  isAfter: _isAfter.default,
  isBefore: _isBefore.default,
  isIn: _isIn.default,
  isCreditCard: _isCreditCard.default,
  isIdentityCard: _isIdentityCard.default,
  isISIN: _isISIN.default,
  isISBN: _isISBN.default,
  isISSN: _isISSN.default,
  isMobilePhone: _isMobilePhone.default,
  isMobilePhoneLocales: _isMobilePhone.locales,
  isPostalCode: _isPostalCode.default,
  isPostalCodeLocales: _isPostalCode.locales,
  isCurrency: _isCurrency.default,
  isISO8601: _isISO.default,
  isRFC3339: _isRFC.default,
  isISO31661Alpha2: _isISO31661Alpha.default,
  isISO31661Alpha3: _isISO31661Alpha2.default,
  isBase64: _isBase.default,
  isDataURI: _isDataURI.default,
  isMagnetURI: _isMagnetURI.default,
  isMimeType: _isMimeType.default,
  isLatLong: _isLatLong.default,
  ltrim: _ltrim.default,
  rtrim: _rtrim.default,
  trim: _trim.default,
  escape: _escape.default,
  unescape: _unescape.default,
  stripLow: _stripLow.default,
  whitelist: _whitelist.default,
  blacklist: _blacklist.default,
  isWhitelisted: _isWhitelisted.default,
  normalizeEmail: _normalizeEmail.default,
  toString: _toString.default
};
var _default = validator;
exports.default = _default;
module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toInt;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toInt(str, radix) {
  (0, _assertString.default)(str);
  return parseInt(str, radix || 10);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toBoolean;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toBoolean(str, strict) {
  (0, _assertString.default)(str);

  if (strict) {
    return str === '1' || str === 'true';
  }

  return str !== '0' && str !== 'false' && str !== '';
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = equals;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function equals(str, comparison) {
  (0, _assertString.default)(str);
  return str === comparison;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contains;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _toString = _interopRequireDefault(__webpack_require__(165));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function contains(str, elem) {
  (0, _assertString.default)(str);
  return str.indexOf((0, _toString.default)(elem)) >= 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = matches;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function matches(str, pattern, modifiers) {
  (0, _assertString.default)(str);

  if (Object.prototype.toString.call(pattern) !== '[object RegExp]') {
    pattern = new RegExp(pattern, modifiers);
  }

  return pattern.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmail;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _merge = _interopRequireDefault(__webpack_require__(71));

var _isByteLength = _interopRequireDefault(__webpack_require__(234));

var _isFQDN = _interopRequireDefault(__webpack_require__(166));

var _isIP = _interopRequireDefault(__webpack_require__(111));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_email_options = {
  allow_display_name: false,
  require_display_name: false,
  allow_utf8_local_part: true,
  require_tld: true
};
/* eslint-disable max-len */

/* eslint-disable no-control-regex */

var displayName = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\,\.\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\s]*<(.+)>$/i;
var emailUserPart = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~]+$/i;
var gmailUserPart = /^[a-z\d]+$/;
var quotedEmailUser = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f]))*$/i;
var emailUserUtf8Part = /^[a-z\d!#\$%&'\*\+\-\/=\?\^_`{\|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+$/i;
var quotedEmailUserUtf8 = /^([\s\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|(\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*$/i;
/* eslint-enable max-len */

/* eslint-enable no-control-regex */

function isEmail(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_email_options);

  if (options.require_display_name || options.allow_display_name) {
    var display_email = str.match(displayName);

    if (display_email) {
      str = display_email[1];
    } else if (options.require_display_name) {
      return false;
    }
  }

  var parts = str.split('@');
  var domain = parts.pop();
  var user = parts.join('@');
  var lower_domain = domain.toLowerCase();

  if (options.domain_specific_validation && (lower_domain === 'gmail.com' || lower_domain === 'googlemail.com')) {
    /*
      Previously we removed dots for gmail addresses before validating.
      This was removed because it allows `multiple..dots@gmail.com`
      to be reported as valid, but it is not.
      Gmail only normalizes single dots, removing them from here is pointless,
      should be done in normalizeEmail
    */
    user = user.toLowerCase(); // Removing sub-address from username before gmail validation

    var username = user.split('+')[0]; // Dots are not included in gmail length restriction

    if (!(0, _isByteLength.default)(username.replace('.', ''), {
      min: 6,
      max: 30
    })) {
      return false;
    }

    var _user_parts = username.split('.');

    for (var i = 0; i < _user_parts.length; i++) {
      if (!gmailUserPart.test(_user_parts[i])) {
        return false;
      }
    }
  }

  if (!(0, _isByteLength.default)(user, {
    max: 64
  }) || !(0, _isByteLength.default)(domain, {
    max: 254
  })) {
    return false;
  }

  if (!(0, _isFQDN.default)(domain, {
    require_tld: options.require_tld
  })) {
    if (!options.allow_ip_domain) {
      return false;
    }

    if (!(0, _isIP.default)(domain)) {
      if (!domain.startsWith('[') || !domain.endsWith(']')) {
        return false;
      }

      var noBracketdomain = domain.substr(1, domain.length - 2);

      if (noBracketdomain.length === 0 || !(0, _isIP.default)(noBracketdomain)) {
        return false;
      }
    }
  }

  if (user[0] === '"') {
    user = user.slice(1, user.length - 1);
    return options.allow_utf8_local_part ? quotedEmailUserUtf8.test(user) : quotedEmailUser.test(user);
  }

  var pattern = options.allow_utf8_local_part ? emailUserUtf8Part : emailUserPart;
  var user_parts = user.split('.');

  for (var _i = 0; _i < user_parts.length; _i++) {
    if (!pattern.test(user_parts[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isURL;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _isFQDN = _interopRequireDefault(__webpack_require__(166));

var _isIP = _interopRequireDefault(__webpack_require__(111));

var _merge = _interopRequireDefault(__webpack_require__(71));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_url_options = {
  protocols: ['http', 'https', 'ftp'],
  require_tld: true,
  require_protocol: false,
  require_host: true,
  require_valid_protocol: true,
  allow_underscores: false,
  allow_trailing_dot: false,
  allow_protocol_relative_urls: false
};
var wrapped_ipv6 = /^\[([^\]]+)\](?::([0-9]+))?$/;

function isRegExp(obj) {
  return Object.prototype.toString.call(obj) === '[object RegExp]';
}

function checkHost(host, matches) {
  for (var i = 0; i < matches.length; i++) {
    var match = matches[i];

    if (host === match || isRegExp(match) && match.test(host)) {
      return true;
    }
  }

  return false;
}

function isURL(url, options) {
  (0, _assertString.default)(url);

  if (!url || url.length >= 2083 || /[\s<>]/.test(url)) {
    return false;
  }

  if (url.indexOf('mailto:') === 0) {
    return false;
  }

  options = (0, _merge.default)(options, default_url_options);
  var protocol, auth, host, hostname, port, port_str, split, ipv6;
  split = url.split('#');
  url = split.shift();
  split = url.split('?');
  url = split.shift();
  split = url.split('://');

  if (split.length > 1) {
    protocol = split.shift().toLowerCase();

    if (options.require_valid_protocol && options.protocols.indexOf(protocol) === -1) {
      return false;
    }
  } else if (options.require_protocol) {
    return false;
  } else if (url.substr(0, 2) === '//') {
    if (!options.allow_protocol_relative_urls) {
      return false;
    }

    split[0] = url.substr(2);
  }

  url = split.join('://');

  if (url === '') {
    return false;
  }

  split = url.split('/');
  url = split.shift();

  if (url === '' && !options.require_host) {
    return true;
  }

  split = url.split('@');

  if (split.length > 1) {
    if (options.disallow_auth) {
      return false;
    }

    auth = split.shift();

    if (auth.indexOf(':') >= 0 && auth.split(':').length > 2) {
      return false;
    }
  }

  hostname = split.join('@');
  port_str = null;
  ipv6 = null;
  var ipv6_match = hostname.match(wrapped_ipv6);

  if (ipv6_match) {
    host = '';
    ipv6 = ipv6_match[1];
    port_str = ipv6_match[2] || null;
  } else {
    split = hostname.split(':');
    host = split.shift();

    if (split.length) {
      port_str = split.join(':');
    }
  }

  if (port_str !== null) {
    port = parseInt(port_str, 10);

    if (!/^[0-9]+$/.test(port_str) || port <= 0 || port > 65535) {
      return false;
    }
  }

  if (!(0, _isIP.default)(host) && !(0, _isFQDN.default)(host, options) && (!ipv6 || !(0, _isIP.default)(ipv6, 6))) {
    return false;
  }

  host = host || ipv6;

  if (options.host_whitelist && !checkHost(host, options.host_whitelist)) {
    return false;
  }

  if (options.host_blacklist && checkHost(host, options.host_blacklist)) {
    return false;
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMACAddress;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var macAddress = /^([0-9a-fA-F][0-9a-fA-F]:){5}([0-9a-fA-F][0-9a-fA-F])$/;
var macAddressNoColons = /^([0-9a-fA-F]){12}$/;

function isMACAddress(str, options) {
  (0, _assertString.default)(str);

  if (options && options.no_colons) {
    return macAddressNoColons.test(str);
  }

  return macAddress.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIPRange;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _isIP = _interopRequireDefault(__webpack_require__(111));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var subnetMaybe = /^\d{1,2}$/;

function isIPRange(str) {
  (0, _assertString.default)(str);
  var parts = str.split('/'); // parts[0] -> ip, parts[1] -> subnet

  if (parts.length !== 2) {
    return false;
  }

  if (!subnetMaybe.test(parts[1])) {
    return false;
  } // Disallow preceding 0 i.e. 01, 02, ...


  if (parts[1].length > 1 && parts[1].startsWith('0')) {
    return false;
  }

  return (0, _isIP.default)(parts[0], 4) && parts[1] <= 32 && parts[1] >= 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBoolean;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBoolean(str) {
  (0, _assertString.default)(str);
  return ['true', 'false', '1', '0'].indexOf(str) >= 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlpha;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _alpha = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlpha(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  (0, _assertString.default)(str);

  if (locale in _alpha.alpha) {
    return _alpha.alpha[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alpha);
exports.locales = locales;

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAlphanumeric;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _alpha = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAlphanumeric(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  (0, _assertString.default)(str);

  if (locale in _alpha.alphanumeric) {
    return _alpha.alphanumeric[locale].test(str);
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(_alpha.alphanumeric);
exports.locales = locales;

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumeric;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var numeric = /^[+-]?([0-9]*[.])?[0-9]+$/;
var numericNoSymbols = /^[0-9]+$/;

function isNumeric(str, options) {
  (0, _assertString.default)(str);

  if (options && options.no_symbols) {
    return numericNoSymbols.test(str);
  }

  return numeric.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPort;

var _isInt = _interopRequireDefault(__webpack_require__(235));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPort(str) {
  return (0, _isInt.default)(str, {
    min: 0,
    max: 65535
  });
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLowercase;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isLowercase(str) {
  (0, _assertString.default)(str);
  return str === str.toLowerCase();
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUppercase;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isUppercase(str) {
  (0, _assertString.default)(str);
  return str === str.toUpperCase();
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAscii;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var ascii = /^[\x00-\x7F]+$/;
/* eslint-enable no-control-regex */

function isAscii(str) {
  (0, _assertString.default)(str);
  return ascii.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isVariableWidth;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _isFullWidth = __webpack_require__(236);

var _isHalfWidth = __webpack_require__(237);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isVariableWidth(str) {
  (0, _assertString.default)(str);
  return _isFullWidth.fullWidth.test(str) && _isHalfWidth.halfWidth.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMultibyte;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-control-regex */
var multibyte = /[^\x00-\x7F]/;
/* eslint-enable no-control-regex */

function isMultibyte(str) {
  (0, _assertString.default)(str);
  return multibyte.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isSurrogatePair;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;

function isSurrogatePair(str) {
  (0, _assertString.default)(str);
  return surrogatePair.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isFloat;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _alpha = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isFloat(str, options) {
  (0, _assertString.default)(str);
  options = options || {};
  var float = new RegExp("^(?:[-+])?(?:[0-9]+)?(?:\\".concat(options.locale ? _alpha.decimal[options.locale] : '.', "[0-9]*)?(?:[eE][\\+\\-]?(?:[0-9]+))?$"));

  if (str === '' || str === '.' || str === '-' || str === '+') {
    return false;
  }

  var value = parseFloat(str.replace(',', '.'));
  return float.test(str) && (!options.hasOwnProperty('min') || value >= options.min) && (!options.hasOwnProperty('max') || value <= options.max) && (!options.hasOwnProperty('lt') || value < options.lt) && (!options.hasOwnProperty('gt') || value > options.gt);
}

var locales = Object.keys(_alpha.decimal);
exports.locales = locales;

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDecimal;

var _merge = _interopRequireDefault(__webpack_require__(71));

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _includes = _interopRequireDefault(__webpack_require__(167));

var _alpha = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function decimalRegExp(options) {
  var regExp = new RegExp("^[-+]?([0-9]+)?(\\".concat(_alpha.decimal[options.locale], "[0-9]{").concat(options.decimal_digits, "})").concat(options.force_decimal ? '' : '?', "$"));
  return regExp;
}

var default_decimal_options = {
  force_decimal: false,
  decimal_digits: '1,',
  locale: 'en-US'
};
var blacklist = ['', '-', '+'];

function isDecimal(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_decimal_options);

  if (options.locale in _alpha.decimal) {
    return !(0, _includes.default)(blacklist, str.replace(/ /g, '')) && decimalRegExp(options).test(str);
  }

  throw new Error("Invalid locale '".concat(options.locale, "'"));
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDivisibleBy;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _toFloat = _interopRequireDefault(__webpack_require__(233));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isDivisibleBy(str, num) {
  (0, _assertString.default)(str);
  return (0, _toFloat.default)(str) % parseInt(num, 10) === 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHexColor;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var hexcolor = /^#?([0-9A-F]{3}|[0-9A-F]{6})$/i;

function isHexColor(str) {
  (0, _assertString.default)(str);
  return hexcolor.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISRC;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// see http://isrc.ifpi.org/en/isrc-standard/code-syntax
var isrc = /^[A-Z]{2}[0-9A-Z]{3}\d{2}\d{5}$/;

function isISRC(str) {
  (0, _assertString.default)(str);
  return isrc.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMD5;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md5 = /^[a-f0-9]{32}$/;

function isMD5(str) {
  (0, _assertString.default)(str);
  return md5.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isHash;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lengths = {
  md5: 32,
  md4: 32,
  sha1: 40,
  sha256: 64,
  sha384: 96,
  sha512: 128,
  ripemd128: 32,
  ripemd160: 40,
  tiger128: 32,
  tiger160: 40,
  tiger192: 48,
  crc32: 8,
  crc32b: 8
};

function isHash(str, algorithm) {
  (0, _assertString.default)(str);
  var hash = new RegExp("^[a-f0-9]{".concat(lengths[algorithm], "}$"));
  return hash.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isJWT;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jwt = /^([A-Za-z0-9\-_~+\/]+[=]{0,2})\.([A-Za-z0-9\-_~+\/]+[=]{0,2})(?:\.([A-Za-z0-9\-_~+\/]+[=]{0,2}))?$/;

function isJWT(str) {
  (0, _assertString.default)(str);
  return jwt.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isJSON;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isJSON(str) {
  (0, _assertString.default)(str);

  try {
    var obj = JSON.parse(str);
    return !!obj && _typeof(obj) === 'object';
  } catch (e) {
    /* ignore */
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isEmpty;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _merge = _interopRequireDefault(__webpack_require__(71));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_is_empty_options = {
  ignore_whitespace: false
};

function isEmpty(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_is_empty_options);
  return (options.ignore_whitespace ? str.trim().length : str.length) === 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isLength;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable prefer-rest-params */
function isLength(str, options) {
  (0, _assertString.default)(str);
  var min;
  var max;

  if (_typeof(options) === 'object') {
    min = options.min || 0;
    max = options.max;
  } else {
    // backwards compatibility: isLength(str, min [, max])
    min = arguments[1];
    max = arguments[2];
  }

  var surrogatePairs = str.match(/[\uD800-\uDBFF][\uDC00-\uDFFF]/g) || [];
  var len = str.length - surrogatePairs.length;
  return len >= min && (typeof max === 'undefined' || len <= max);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isUUID;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var uuid = {
  3: /^[0-9A-F]{8}-[0-9A-F]{4}-3[0-9A-F]{3}-[0-9A-F]{4}-[0-9A-F]{12}$/i,
  4: /^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  5: /^[0-9A-F]{8}-[0-9A-F]{4}-5[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
  all: /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i
};

function isUUID(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'all';
  (0, _assertString.default)(str);
  var pattern = uuid[version];
  return pattern && pattern.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMongoId;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _isHexadecimal = _interopRequireDefault(__webpack_require__(238));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMongoId(str) {
  (0, _assertString.default)(str);
  return (0, _isHexadecimal.default)(str) && str.length === 24;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isAfter;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _toDate = _interopRequireDefault(__webpack_require__(164));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isAfter(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original > comparison);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBefore;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _toDate = _interopRequireDefault(__webpack_require__(164));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBefore(str) {
  var date = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : String(new Date());
  (0, _assertString.default)(str);
  var comparison = (0, _toDate.default)(date);
  var original = (0, _toDate.default)(str);
  return !!(original && comparison && original < comparison);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIn;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _toString = _interopRequireDefault(__webpack_require__(165));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function isIn(str, options) {
  (0, _assertString.default)(str);
  var i;

  if (Object.prototype.toString.call(options) === '[object Array]') {
    var array = [];

    for (i in options) {
      if ({}.hasOwnProperty.call(options, i)) {
        array[i] = (0, _toString.default)(options[i]);
      }
    }

    return array.indexOf(str) >= 0;
  } else if (_typeof(options) === 'object') {
    return options.hasOwnProperty(str);
  } else if (options && typeof options.indexOf === 'function') {
    return options.indexOf(str) >= 0;
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCreditCard;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var creditCard = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|6[27][0-9]{14})$/;
/* eslint-enable max-len */

function isCreditCard(str) {
  (0, _assertString.default)(str);
  var sanitized = str.replace(/[- ]+/g, '');

  if (!creditCard.test(sanitized)) {
    return false;
  }

  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble;

  for (var i = sanitized.length - 1; i >= 0; i--) {
    digit = sanitized.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum % 10 + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return !!(sum % 10 === 0 ? sanitized : false);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isIdentityCard;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validators = {
  ES: function ES(str) {
    (0, _assertString.default)(str);
    var DNI = /^[0-9X-Z][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/;
    var charsValue = {
      X: 0,
      Y: 1,
      Z: 2
    };
    var controlDigits = ['T', 'R', 'W', 'A', 'G', 'M', 'Y', 'F', 'P', 'D', 'X', 'B', 'N', 'J', 'Z', 'S', 'Q', 'V', 'H', 'L', 'C', 'K', 'E']; // sanitize user input

    var sanitized = str.trim().toUpperCase(); // validate the data structure

    if (!DNI.test(sanitized)) {
      return false;
    } // validate the control digit


    var number = sanitized.slice(0, -1).replace(/[X,Y,Z]/g, function (char) {
      return charsValue[char];
    });
    return sanitized.endsWith(controlDigits[number % 23]);
  }
};

function isIdentityCard(str) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'any';
  (0, _assertString.default)(str);

  if (locale in validators) {
    return validators[locale](str);
  } else if (locale === 'any') {
    for (var key in validators) {
      if (validators.hasOwnProperty(key)) {
        var validator = validators[key];

        if (validator(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISIN;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isin = /^[A-Z]{2}[0-9A-Z]{9}[0-9]$/;

function isISIN(str) {
  (0, _assertString.default)(str);

  if (!isin.test(str)) {
    return false;
  }

  var checksumStr = str.replace(/[A-Z]/g, function (character) {
    return parseInt(character, 36);
  });
  var sum = 0;
  var digit;
  var tmpNum;
  var shouldDouble = true;

  for (var i = checksumStr.length - 2; i >= 0; i--) {
    digit = checksumStr.substring(i, i + 1);
    tmpNum = parseInt(digit, 10);

    if (shouldDouble) {
      tmpNum *= 2;

      if (tmpNum >= 10) {
        sum += tmpNum + 1;
      } else {
        sum += tmpNum;
      }
    } else {
      sum += tmpNum;
    }

    shouldDouble = !shouldDouble;
  }

  return parseInt(str.substr(str.length - 1), 10) === (10000 - sum) % 10;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISBN;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isbn10Maybe = /^(?:[0-9]{9}X|[0-9]{10})$/;
var isbn13Maybe = /^(?:[0-9]{13})$/;
var factor = [1, 3];

function isISBN(str) {
  var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  (0, _assertString.default)(str);
  version = String(version);

  if (!version) {
    return isISBN(str, 10) || isISBN(str, 13);
  }

  var sanitized = str.replace(/[\s-]+/g, '');
  var checksum = 0;
  var i;

  if (version === '10') {
    if (!isbn10Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 9; i++) {
      checksum += (i + 1) * sanitized.charAt(i);
    }

    if (sanitized.charAt(9) === 'X') {
      checksum += 10 * 10;
    } else {
      checksum += 10 * sanitized.charAt(9);
    }

    if (checksum % 11 === 0) {
      return !!sanitized;
    }
  } else if (version === '13') {
    if (!isbn13Maybe.test(sanitized)) {
      return false;
    }

    for (i = 0; i < 12; i++) {
      checksum += factor[i % 2] * sanitized.charAt(i);
    }

    if (sanitized.charAt(12) - (10 - checksum % 10) % 10 === 0) {
      return !!sanitized;
    }
  }

  return false;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISSN;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var issn = '^\\d{4}-?\\d{3}[\\dX]$';

function isISSN(str) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _assertString.default)(str);
  var testIssn = issn;
  testIssn = options.require_hyphen ? testIssn.replace('?', '') : testIssn;
  testIssn = options.case_sensitive ? new RegExp(testIssn) : new RegExp(testIssn, 'i');

  if (!testIssn.test(str)) {
    return false;
  }

  var digits = str.replace('-', '').toUpperCase();
  var checksum = 0;

  for (var i = 0; i < digits.length; i++) {
    var digit = digits[i];
    checksum += (digit === 'X' ? 10 : +digit) * (8 - i);
  }

  return checksum % 11 === 0;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMobilePhone;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
var phones = {
  'ar-AE': /^((\+?971)|0)?5[024568]\d{7}$/,
  'ar-DZ': /^(\+?213|0)(5|6|7)\d{8}$/,
  'ar-EG': /^((\+?20)|0)?1[012]\d{8}$/,
  'ar-IQ': /^(\+?964|0)?7[0-9]\d{8}$/,
  'ar-JO': /^(\+?962|0)?7[789]\d{7}$/,
  'ar-KW': /^(\+?965)[569]\d{7}$/,
  'ar-SA': /^(!?(\+?966)|0)?5\d{8}$/,
  'ar-SY': /^(!?(\+?963)|0)?9\d{8}$/,
  'ar-TN': /^(\+?216)?[2459]\d{7}$/,
  'be-BY': /^(\+?375)?(24|25|29|33|44)\d{7}$/,
  'bg-BG': /^(\+?359|0)?8[789]\d{7}$/,
  'bn-BD': /\+?(88)?0?1[356789][0-9]{8}\b/,
  'cs-CZ': /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'da-DK': /^(\+?45)?\s?\d{2}\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'de-DE': /^(\+49)?0?1(5[0-25-9]\d|6([23]|0\d?)|7([0-57-9]|6\d))\d{7}$/,
  'el-GR': /^(\+?30|0)?(69\d{8})$/,
  'en-AU': /^(\+?61|0)4\d{8}$/,
  'en-GB': /^(\+?44|0)7\d{9}$/,
  'en-GH': /^(\+233|0)(20|50|24|54|27|57|26|56|23|28)\d{7}$/,
  'en-HK': /^(\+?852\-?)?[456789]\d{3}\-?\d{4}$/,
  'en-IE': /^(\+?353|0)8[356789]\d{7}$/,
  'en-IN': /^(\+?91|0)?[6789]\d{9}$/,
  'en-KE': /^(\+?254|0)?[7]\d{8}$/,
  'en-MU': /^(\+?230|0)?\d{8}$/,
  'en-NG': /^(\+?234|0)?[789]\d{9}$/,
  'en-NZ': /^(\+?64|0)[28]\d{7,9}$/,
  'en-PK': /^((\+92)|(0092))-{0,1}\d{3}-{0,1}\d{7}$|^\d{11}$|^\d{4}-\d{7}$/,
  'en-RW': /^(\+?250|0)?[7]\d{8}$/,
  'en-SG': /^(\+65)?[89]\d{7}$/,
  'en-TZ': /^(\+?255|0)?[67]\d{8}$/,
  'en-UG': /^(\+?256|0)?[7]\d{8}$/,
  'en-US': /^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/,
  'en-ZA': /^(\+?27|0)\d{9}$/,
  'en-ZM': /^(\+?26)?09[567]\d{7}$/,
  'es-ES': /^(\+?34)?(6\d{1}|7[1234])\d{7}$/,
  'es-MX': /^(\+?52)?(1|01)?\d{10,11}$/,
  'es-UY': /^(\+598|0)9[1-9][\d]{6}$/,
  'et-EE': /^(\+?372)?\s?(5|8[1-4])\s?([0-9]\s?){6,7}$/,
  'fa-IR': /^(\+?98[\-\s]?|0)9[0-39]\d[\-\s]?\d{3}[\-\s]?\d{4}$/,
  'fi-FI': /^(\+?358|0)\s?(4(0|1|2|4|5|6)?|50)\s?(\d\s?){4,8}\d$/,
  'fo-FO': /^(\+?298)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'fr-FR': /^(\+?33|0)[67]\d{8}$/,
  'he-IL': /^(\+972|0)([23489]|5[012345689]|77)[1-9]\d{6}$/,
  'hu-HU': /^(\+?36)(20|30|70)\d{7}$/,
  'id-ID': /^(\+?62|0)8(1[123456789]|2[1238]|3[1238]|5[12356789]|7[78]|9[56789]|8[123456789])([\s?|\d]{5,11})$/,
  'it-IT': /^(\+?39)?\s?3\d{2} ?\d{6,7}$/,
  'ja-JP': /^(\+?81|0)[789]0[ \-]?[1-9]\d{2}[ \-]?\d{5}$/,
  'kk-KZ': /^(\+?7|8)?7\d{9}$/,
  'kl-GL': /^(\+?299)?\s?\d{2}\s?\d{2}\s?\d{2}$/,
  'ko-KR': /^((\+?82)[ \-]?)?0?1([0|1|6|7|8|9]{1})[ \-]?\d{3,4}[ \-]?\d{4}$/,
  'lt-LT': /^(\+370|8)\d{8}$/,
  'ms-MY': /^(\+?6?01){1}(([0145]{1}(\-|\s)?\d{7,8})|([236789]{1}(\s|\-)?\d{7}))$/,
  'nb-NO': /^(\+?47)?[49]\d{7}$/,
  'nl-BE': /^(\+?32|0)4?\d{8}$/,
  'nn-NO': /^(\+?47)?[49]\d{7}$/,
  'pl-PL': /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/,
  'pt-BR': /(?=^(\+?5{2}\-?|0)[1-9]{2}\-?\d{4}\-?\d{4}$)(^(\+?5{2}\-?|0)[1-9]{2}\-?[6-9]{1}\d{3}\-?\d{4}$)|(^(\+?5{2}\-?|0)[1-9]{2}\-?9[6-9]{1}\d{3}\-?\d{4}$)/,
  'pt-PT': /^(\+?351)?9[1236]\d{7}$/,
  'ro-RO': /^(\+?4?0)\s?7\d{2}(\/|\s|\.|\-)?\d{3}(\s|\.|\-)?\d{3}$/,
  'ru-RU': /^(\+?7|8)?9\d{9}$/,
  'sl-SI': /^(\+386\s?|0)(\d{1}\s?\d{3}\s?\d{2}\s?\d{2}|\d{2}\s?\d{3}\s?\d{3})$/,
  'sk-SK': /^(\+?421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
  'sr-RS': /^(\+3816|06)[- \d]{5,9}$/,
  'sv-SE': /^(\+?46|0)[\s\-]?7[\s\-]?[02369]([\s\-]?\d){7}$/,
  'th-TH': /^(\+66|66|0)\d{9}$/,
  'tr-TR': /^(\+?90|0)?5\d{9}$/,
  'uk-UA': /^(\+?38|8)?0\d{9}$/,
  'vi-VN': /^(\+?84|0)((3([2-9]))|(5([689]))|(7([0|6-9]))|(8([1-5]))|(9([0-9])))([0-9]{7})$/,
  'zh-CN': /^((\+|00)86)?1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/,
  'zh-TW': /^(\+?886\-?|0)?9\d{8}$/
};
/* eslint-enable max-len */
// aliases

phones['en-CA'] = phones['en-US'];
phones['fr-BE'] = phones['nl-BE'];
phones['zh-HK'] = phones['en-HK'];

function isMobilePhone(str, locale, options) {
  (0, _assertString.default)(str);

  if (options && options.strictMode && !str.startsWith('+')) {
    return false;
  }

  if (Array.isArray(locale)) {
    return locale.some(function (key) {
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }

      return false;
    });
  } else if (locale in phones) {
    return phones[locale].test(str); // alias falsey locale as 'any'
  } else if (!locale || locale === 'any') {
    for (var key in phones) {
      if (phones.hasOwnProperty(key)) {
        var phone = phones[key];

        if (phone.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

var locales = Object.keys(phones);
exports.locales = locales;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isCurrency;

var _merge = _interopRequireDefault(__webpack_require__(71));

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function currencyRegex(options) {
  var decimal_digits = "\\d{".concat(options.digits_after_decimal[0], "}");
  options.digits_after_decimal.forEach(function (digit, index) {
    if (index !== 0) decimal_digits = "".concat(decimal_digits, "|\\d{").concat(digit, "}");
  });
  var symbol = "(\\".concat(options.symbol.replace(/\./g, '\\.'), ")").concat(options.require_symbol ? '' : '?'),
      negative = '-?',
      whole_dollar_amount_without_sep = '[1-9]\\d*',
      whole_dollar_amount_with_sep = "[1-9]\\d{0,2}(\\".concat(options.thousands_separator, "\\d{3})*"),
      valid_whole_dollar_amounts = ['0', whole_dollar_amount_without_sep, whole_dollar_amount_with_sep],
      whole_dollar_amount = "(".concat(valid_whole_dollar_amounts.join('|'), ")?"),
      decimal_amount = "(\\".concat(options.decimal_separator, "(").concat(decimal_digits, "))").concat(options.require_decimal ? '' : '?');
  var pattern = whole_dollar_amount + (options.allow_decimal || options.require_decimal ? decimal_amount : ''); // default is negative sign before symbol, but there are two other options (besides parens)

  if (options.allow_negatives && !options.parens_for_negatives) {
    if (options.negative_sign_after_digits) {
      pattern += negative;
    } else if (options.negative_sign_before_digits) {
      pattern = negative + pattern;
    }
  } // South African Rand, for example, uses R 123 (space) and R-123 (no space)


  if (options.allow_negative_sign_placeholder) {
    pattern = "( (?!\\-))?".concat(pattern);
  } else if (options.allow_space_after_symbol) {
    pattern = " ?".concat(pattern);
  } else if (options.allow_space_after_digits) {
    pattern += '( (?!$))?';
  }

  if (options.symbol_after_digits) {
    pattern += symbol;
  } else {
    pattern = symbol + pattern;
  }

  if (options.allow_negatives) {
    if (options.parens_for_negatives) {
      pattern = "(\\(".concat(pattern, "\\)|").concat(pattern, ")");
    } else if (!(options.negative_sign_before_digits || options.negative_sign_after_digits)) {
      pattern = negative + pattern;
    }
  } // ensure there's a dollar and/or decimal amount, and that
  // it doesn't start with a space or a negative sign followed by a space


  return new RegExp("^(?!-? )(?=.*\\d)".concat(pattern, "$"));
}

var default_currency_options = {
  symbol: '$',
  require_symbol: false,
  allow_space_after_symbol: false,
  symbol_after_digits: false,
  allow_negatives: true,
  parens_for_negatives: false,
  negative_sign_before_digits: false,
  negative_sign_after_digits: false,
  allow_negative_sign_placeholder: false,
  thousands_separator: ',',
  decimal_separator: '.',
  allow_decimal: true,
  require_decimal: false,
  digits_after_decimal: [2],
  allow_space_after_digits: false
};

function isCurrency(str, options) {
  (0, _assertString.default)(str);
  options = (0, _merge.default)(options, default_currency_options);
  return currencyRegex(options).test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO8601;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
// from http://goo.gl/0ejHHW
var iso8601 = /^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-3])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/;
/* eslint-enable max-len */

var isValidDate = function isValidDate(str) {
  // str must have passed the ISO8601 check
  // this check is meant to catch invalid dates
  // like 2009-02-31
  // first check for ordinal dates
  var ordinalMatch = str.match(/^(\d{4})-?(\d{3})([ T]{1}\.*|$)/);

  if (ordinalMatch) {
    var oYear = Number(ordinalMatch[1]);
    var oDay = Number(ordinalMatch[2]); // if is leap year

    if (oYear % 4 === 0 && oYear % 100 !== 0) return oDay <= 366;
    return oDay <= 365;
  }

  var match = str.match(/(\d{4})-?(\d{0,2})-?(\d*)/).map(Number);
  var year = match[1];
  var month = match[2];
  var day = match[3];
  var monthString = month ? "0".concat(month).slice(-2) : month;
  var dayString = day ? "0".concat(day).slice(-2) : day; // create a date object and compare

  var d = new Date("".concat(year, "-").concat(monthString || '01', "-").concat(dayString || '01'));
  if (isNaN(d.getUTCFullYear())) return false;

  if (month && day) {
    return d.getUTCFullYear() === year && d.getUTCMonth() + 1 === month && d.getUTCDate() === day;
  }

  return true;
};

function isISO8601(str, options) {
  (0, _assertString.default)(str);
  var check = iso8601.test(str);
  if (!options) return check;
  if (check && options.strict) return isValidDate(str);
  return check;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRFC3339;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Based on https://tools.ietf.org/html/rfc3339#section-5.6 */
var dateFullYear = /[0-9]{4}/;
var dateMonth = /(0[1-9]|1[0-2])/;
var dateMDay = /([12]\d|0[1-9]|3[01])/;
var timeHour = /([01][0-9]|2[0-3])/;
var timeMinute = /[0-5][0-9]/;
var timeSecond = /([0-5][0-9]|60)/;
var timeSecFrac = /(\.[0-9]+)?/;
var timeNumOffset = new RegExp("[-+]".concat(timeHour.source, ":").concat(timeMinute.source));
var timeOffset = new RegExp("([zZ]|".concat(timeNumOffset.source, ")"));
var partialTime = new RegExp("".concat(timeHour.source, ":").concat(timeMinute.source, ":").concat(timeSecond.source).concat(timeSecFrac.source));
var fullDate = new RegExp("".concat(dateFullYear.source, "-").concat(dateMonth.source, "-").concat(dateMDay.source));
var fullTime = new RegExp("".concat(partialTime.source).concat(timeOffset.source));
var rfc3339 = new RegExp("".concat(fullDate.source, "[ tT]").concat(fullTime.source));

function isRFC3339(str) {
  (0, _assertString.default)(str);
  return rfc3339.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO31661Alpha2;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _includes = _interopRequireDefault(__webpack_require__(167));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2
var validISO31661Alpha2CountriesCodes = ['AD', 'AE', 'AF', 'AG', 'AI', 'AL', 'AM', 'AO', 'AQ', 'AR', 'AS', 'AT', 'AU', 'AW', 'AX', 'AZ', 'BA', 'BB', 'BD', 'BE', 'BF', 'BG', 'BH', 'BI', 'BJ', 'BL', 'BM', 'BN', 'BO', 'BQ', 'BR', 'BS', 'BT', 'BV', 'BW', 'BY', 'BZ', 'CA', 'CC', 'CD', 'CF', 'CG', 'CH', 'CI', 'CK', 'CL', 'CM', 'CN', 'CO', 'CR', 'CU', 'CV', 'CW', 'CX', 'CY', 'CZ', 'DE', 'DJ', 'DK', 'DM', 'DO', 'DZ', 'EC', 'EE', 'EG', 'EH', 'ER', 'ES', 'ET', 'FI', 'FJ', 'FK', 'FM', 'FO', 'FR', 'GA', 'GB', 'GD', 'GE', 'GF', 'GG', 'GH', 'GI', 'GL', 'GM', 'GN', 'GP', 'GQ', 'GR', 'GS', 'GT', 'GU', 'GW', 'GY', 'HK', 'HM', 'HN', 'HR', 'HT', 'HU', 'ID', 'IE', 'IL', 'IM', 'IN', 'IO', 'IQ', 'IR', 'IS', 'IT', 'JE', 'JM', 'JO', 'JP', 'KE', 'KG', 'KH', 'KI', 'KM', 'KN', 'KP', 'KR', 'KW', 'KY', 'KZ', 'LA', 'LB', 'LC', 'LI', 'LK', 'LR', 'LS', 'LT', 'LU', 'LV', 'LY', 'MA', 'MC', 'MD', 'ME', 'MF', 'MG', 'MH', 'MK', 'ML', 'MM', 'MN', 'MO', 'MP', 'MQ', 'MR', 'MS', 'MT', 'MU', 'MV', 'MW', 'MX', 'MY', 'MZ', 'NA', 'NC', 'NE', 'NF', 'NG', 'NI', 'NL', 'NO', 'NP', 'NR', 'NU', 'NZ', 'OM', 'PA', 'PE', 'PF', 'PG', 'PH', 'PK', 'PL', 'PM', 'PN', 'PR', 'PS', 'PT', 'PW', 'PY', 'QA', 'RE', 'RO', 'RS', 'RU', 'RW', 'SA', 'SB', 'SC', 'SD', 'SE', 'SG', 'SH', 'SI', 'SJ', 'SK', 'SL', 'SM', 'SN', 'SO', 'SR', 'SS', 'ST', 'SV', 'SX', 'SY', 'SZ', 'TC', 'TD', 'TF', 'TG', 'TH', 'TJ', 'TK', 'TL', 'TM', 'TN', 'TO', 'TR', 'TT', 'TV', 'TW', 'TZ', 'UA', 'UG', 'UM', 'US', 'UY', 'UZ', 'VA', 'VC', 'VE', 'VG', 'VI', 'VN', 'VU', 'WF', 'WS', 'YE', 'YT', 'ZA', 'ZM', 'ZW'];

function isISO31661Alpha2(str) {
  (0, _assertString.default)(str);
  return (0, _includes.default)(validISO31661Alpha2CountriesCodes, str.toUpperCase());
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isISO31661Alpha3;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _includes = _interopRequireDefault(__webpack_require__(167));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// from https://en.wikipedia.org/wiki/ISO_3166-1_alpha-3
var validISO31661Alpha3CountriesCodes = ['AFG', 'ALA', 'ALB', 'DZA', 'ASM', 'AND', 'AGO', 'AIA', 'ATA', 'ATG', 'ARG', 'ARM', 'ABW', 'AUS', 'AUT', 'AZE', 'BHS', 'BHR', 'BGD', 'BRB', 'BLR', 'BEL', 'BLZ', 'BEN', 'BMU', 'BTN', 'BOL', 'BES', 'BIH', 'BWA', 'BVT', 'BRA', 'IOT', 'BRN', 'BGR', 'BFA', 'BDI', 'KHM', 'CMR', 'CAN', 'CPV', 'CYM', 'CAF', 'TCD', 'CHL', 'CHN', 'CXR', 'CCK', 'COL', 'COM', 'COG', 'COD', 'COK', 'CRI', 'CIV', 'HRV', 'CUB', 'CUW', 'CYP', 'CZE', 'DNK', 'DJI', 'DMA', 'DOM', 'ECU', 'EGY', 'SLV', 'GNQ', 'ERI', 'EST', 'ETH', 'FLK', 'FRO', 'FJI', 'FIN', 'FRA', 'GUF', 'PYF', 'ATF', 'GAB', 'GMB', 'GEO', 'DEU', 'GHA', 'GIB', 'GRC', 'GRL', 'GRD', 'GLP', 'GUM', 'GTM', 'GGY', 'GIN', 'GNB', 'GUY', 'HTI', 'HMD', 'VAT', 'HND', 'HKG', 'HUN', 'ISL', 'IND', 'IDN', 'IRN', 'IRQ', 'IRL', 'IMN', 'ISR', 'ITA', 'JAM', 'JPN', 'JEY', 'JOR', 'KAZ', 'KEN', 'KIR', 'PRK', 'KOR', 'KWT', 'KGZ', 'LAO', 'LVA', 'LBN', 'LSO', 'LBR', 'LBY', 'LIE', 'LTU', 'LUX', 'MAC', 'MKD', 'MDG', 'MWI', 'MYS', 'MDV', 'MLI', 'MLT', 'MHL', 'MTQ', 'MRT', 'MUS', 'MYT', 'MEX', 'FSM', 'MDA', 'MCO', 'MNG', 'MNE', 'MSR', 'MAR', 'MOZ', 'MMR', 'NAM', 'NRU', 'NPL', 'NLD', 'NCL', 'NZL', 'NIC', 'NER', 'NGA', 'NIU', 'NFK', 'MNP', 'NOR', 'OMN', 'PAK', 'PLW', 'PSE', 'PAN', 'PNG', 'PRY', 'PER', 'PHL', 'PCN', 'POL', 'PRT', 'PRI', 'QAT', 'REU', 'ROU', 'RUS', 'RWA', 'BLM', 'SHN', 'KNA', 'LCA', 'MAF', 'SPM', 'VCT', 'WSM', 'SMR', 'STP', 'SAU', 'SEN', 'SRB', 'SYC', 'SLE', 'SGP', 'SXM', 'SVK', 'SVN', 'SLB', 'SOM', 'ZAF', 'SGS', 'SSD', 'ESP', 'LKA', 'SDN', 'SUR', 'SJM', 'SWZ', 'SWE', 'CHE', 'SYR', 'TWN', 'TJK', 'TZA', 'THA', 'TLS', 'TGO', 'TKL', 'TON', 'TTO', 'TUN', 'TUR', 'TKM', 'TCA', 'TUV', 'UGA', 'UKR', 'ARE', 'GBR', 'USA', 'UMI', 'URY', 'UZB', 'VUT', 'VEN', 'VNM', 'VGB', 'VIR', 'WLF', 'ESH', 'YEM', 'ZMB', 'ZWE'];

function isISO31661Alpha3(str) {
  (0, _assertString.default)(str);
  return (0, _includes.default)(validISO31661Alpha3CountriesCodes, str.toUpperCase());
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isBase64;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var notBase64 = /[^A-Z0-9+\/=]/i;

function isBase64(str) {
  (0, _assertString.default)(str);
  var len = str.length;

  if (!len || len % 4 !== 0 || notBase64.test(str)) {
    return false;
  }

  var firstPaddingChar = str.indexOf('=');
  return firstPaddingChar === -1 || firstPaddingChar === len - 1 || firstPaddingChar === len - 2 && str[len - 1] === '=';
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isDataURI;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validMediaType = /^[a-z]+\/[a-z0-9\-\+]+$/i;
var validAttribute = /^[a-z\-]+=[a-z0-9\-]+$/i;
var validData = /^[a-z0-9!\$&'\(\)\*\+,;=\-\._~:@\/\?%\s]*$/i;

function isDataURI(str) {
  (0, _assertString.default)(str);
  var data = str.split(',');

  if (data.length < 2) {
    return false;
  }

  var attributes = data.shift().trim().split(';');
  var schemeAndMediaType = attributes.shift();

  if (schemeAndMediaType.substr(0, 5) !== 'data:') {
    return false;
  }

  var mediaType = schemeAndMediaType.substr(5);

  if (mediaType !== '' && !validMediaType.test(mediaType)) {
    return false;
  }

  for (var i = 0; i < attributes.length; i++) {
    if (i === attributes.length - 1 && attributes[i].toLowerCase() === 'base64') {// ok
    } else if (!validAttribute.test(attributes[i])) {
      return false;
    }
  }

  for (var _i = 0; _i < data.length; _i++) {
    if (!validData.test(data[_i])) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMagnetURI;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var magnetURI = /^magnet:\?xt=urn:[a-z0-9]+:[a-z0-9]{32,40}&dn=.+&tr=.+$/i;

function isMagnetURI(url) {
  (0, _assertString.default)(url);
  return magnetURI.test(url.trim());
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isMimeType;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Checks if the provided string matches to a correct Media type format (MIME type)

  This function only checks is the string format follows the
  etablished rules by the according RFC specifications.
  This function supports 'charset' in textual media types
  (https://tools.ietf.org/html/rfc6657).

  This function does not check against all the media types listed
  by the IANA (https://www.iana.org/assignments/media-types/media-types.xhtml)
  because of lightness purposes : it would require to include
  all these MIME types in this librairy, which would weigh it
  significantly. This kind of effort maybe is not worth for the use that
  this function has in this entire librairy.

  More informations in the RFC specifications :
  - https://tools.ietf.org/html/rfc2045
  - https://tools.ietf.org/html/rfc2046
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.1
  - https://tools.ietf.org/html/rfc7231#section-3.1.1.5
*/
// Match simple MIME types
// NB :
//   Subtype length must not exceed 100 characters.
//   This rule does not comply to the RFC specs (what is the max length ?).
var mimeTypeSimple = /^(application|audio|font|image|message|model|multipart|text|video)\/[a-zA-Z0-9\.\-\+]{1,100}$/i; // eslint-disable-line max-len
// Handle "charset" in "text/*"

var mimeTypeText = /^text\/[a-zA-Z0-9\.\-\+]{1,100};\s?charset=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?$/i; // eslint-disable-line max-len
// Handle "boundary" in "multipart/*"

var mimeTypeMultipart = /^multipart\/[a-zA-Z0-9\.\-\+]{1,100}(;\s?(boundary|charset)=("[a-zA-Z0-9\.\-\+\s]{0,70}"|[a-zA-Z0-9\.\-\+]{0,70})(\s?\([a-zA-Z0-9\.\-\+\s]{1,20}\))?){0,2}$/i; // eslint-disable-line max-len

function isMimeType(str) {
  (0, _assertString.default)(str);
  return mimeTypeSimple.test(str) || mimeTypeText.test(str) || mimeTypeMultipart.test(str);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var lat = /^\(?[+-]?(90(\.0+)?|[1-8]?\d(\.\d+)?)$/;
var long = /^\s?[+-]?(180(\.0+)?|1[0-7]\d(\.\d+)?|\d{1,2}(\.\d+)?)\)?$/;

function _default(str) {
  (0, _assertString.default)(str);
  if (!str.includes(',')) return false;
  var pair = str.split(',');
  return lat.test(pair[0]) && long.test(pair[1]);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
exports.locales = void 0;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// common patterns
var threeDigit = /^\d{3}$/;
var fourDigit = /^\d{4}$/;
var fiveDigit = /^\d{5}$/;
var sixDigit = /^\d{6}$/;
var patterns = {
  AD: /^AD\d{3}$/,
  AT: fourDigit,
  AU: fourDigit,
  BE: fourDigit,
  BG: fourDigit,
  CA: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][\s\-]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  CH: fourDigit,
  CZ: /^\d{3}\s?\d{2}$/,
  DE: fiveDigit,
  DK: fourDigit,
  DZ: fiveDigit,
  EE: fiveDigit,
  ES: fiveDigit,
  FI: fiveDigit,
  FR: /^\d{2}\s?\d{3}$/,
  GB: /^(gir\s?0aa|[a-z]{1,2}\d[\da-z]?\s?(\d[a-z]{2})?)$/i,
  GR: /^\d{3}\s?\d{2}$/,
  HR: /^([1-5]\d{4}$)/,
  HU: fourDigit,
  IL: fiveDigit,
  IN: sixDigit,
  IS: threeDigit,
  IT: fiveDigit,
  JP: /^\d{3}\-\d{4}$/,
  KE: fiveDigit,
  LI: /^(948[5-9]|949[0-7])$/,
  LT: /^LT\-\d{5}$/,
  LU: fourDigit,
  LV: /^LV\-\d{4}$/,
  MX: fiveDigit,
  NL: /^\d{4}\s?[a-z]{2}$/i,
  NO: fourDigit,
  PL: /^\d{2}\-\d{3}$/,
  PT: /^\d{4}\-\d{3}?$/,
  RO: sixDigit,
  RU: sixDigit,
  SA: fiveDigit,
  SE: /^\d{3}\s?\d{2}$/,
  SI: fourDigit,
  SK: /^\d{3}\s?\d{2}$/,
  TN: fourDigit,
  TW: /^\d{3}(\d{2})?$/,
  UA: fiveDigit,
  US: /^\d{5}(-\d{4})?$/,
  ZA: fourDigit,
  ZM: fiveDigit
};
var locales = Object.keys(patterns);
exports.locales = locales;

function _default(str, locale) {
  (0, _assertString.default)(str);

  if (locale in patterns) {
    return patterns[locale].test(str);
  } else if (locale === 'any') {
    for (var key in patterns) {
      if (patterns.hasOwnProperty(key)) {
        var pattern = patterns[key];

        if (pattern.test(str)) {
          return true;
        }
      }
    }

    return false;
  }

  throw new Error("Invalid locale '".concat(locale, "'"));
}

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = trim;

var _rtrim = _interopRequireDefault(__webpack_require__(240));

var _ltrim = _interopRequireDefault(__webpack_require__(239));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trim(str, chars) {
  return (0, _rtrim.default)((0, _ltrim.default)(str, chars), chars);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = escape;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#x27;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/\//g, '&#x2F;').replace(/\\/g, '&#x5C;').replace(/`/g, '&#96;');
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unescape;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unescape(str) {
  (0, _assertString.default)(str);
  return str.replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&#x27;/g, "'").replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&#x2F;/g, '/').replace(/&#x5C;/g, '\\').replace(/&#96;/g, '`');
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = stripLow;

var _assertString = _interopRequireDefault(__webpack_require__(3));

var _blacklist = _interopRequireDefault(__webpack_require__(241));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function stripLow(str, keep_new_lines) {
  (0, _assertString.default)(str);
  var chars = keep_new_lines ? '\\x00-\\x09\\x0B\\x0C\\x0E-\\x1F\\x7F' : '\\x00-\\x1F\\x7F';
  return (0, _blacklist.default)(str, chars);
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = whitelist;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function whitelist(str, chars) {
  (0, _assertString.default)(str);
  return str.replace(new RegExp("[^".concat(chars, "]+"), 'g'), '');
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isWhitelisted;

var _assertString = _interopRequireDefault(__webpack_require__(3));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isWhitelisted(str, chars) {
  (0, _assertString.default)(str);

  for (var i = str.length - 1; i >= 0; i--) {
    if (chars.indexOf(str[i]) === -1) {
      return false;
    }
  }

  return true;
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeEmail;

var _merge = _interopRequireDefault(__webpack_require__(71));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var default_normalize_email_options = {
  // The following options apply to all email addresses
  // Lowercases the local part of the email address.
  // Please note this may violate RFC 5321 as per http://stackoverflow.com/a/9808332/192024).
  // The domain is always lowercased, as per RFC 1035
  all_lowercase: true,
  // The following conversions are specific to GMail
  // Lowercases the local part of the GMail address (known to be case-insensitive)
  gmail_lowercase: true,
  // Removes dots from the local part of the email address, as that's ignored by GMail
  gmail_remove_dots: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  gmail_remove_subaddress: true,
  // Conversts the googlemail.com domain to gmail.com
  gmail_convert_googlemaildotcom: true,
  // The following conversions are specific to Outlook.com / Windows Live / Hotmail
  // Lowercases the local part of the Outlook.com address (known to be case-insensitive)
  outlookdotcom_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  outlookdotcom_remove_subaddress: true,
  // The following conversions are specific to Yahoo
  // Lowercases the local part of the Yahoo address (known to be case-insensitive)
  yahoo_lowercase: true,
  // Removes the subaddress (e.g. "-foo") from the email address
  yahoo_remove_subaddress: true,
  // The following conversions are specific to Yandex
  // Lowercases the local part of the Yandex address (known to be case-insensitive)
  yandex_lowercase: true,
  // The following conversions are specific to iCloud
  // Lowercases the local part of the iCloud address (known to be case-insensitive)
  icloud_lowercase: true,
  // Removes the subaddress (e.g. "+foo") from the email address
  icloud_remove_subaddress: true
}; // List of domains used by iCloud

var icloud_domains = ['icloud.com', 'me.com']; // List of domains used by Outlook.com and its predecessors
// This list is likely incomplete.
// Partial reference:
// https://blogs.office.com/2013/04/17/outlook-com-gets-two-step-verification-sign-in-by-alias-and-new-international-domains/

var outlookdotcom_domains = ['hotmail.at', 'hotmail.be', 'hotmail.ca', 'hotmail.cl', 'hotmail.co.il', 'hotmail.co.nz', 'hotmail.co.th', 'hotmail.co.uk', 'hotmail.com', 'hotmail.com.ar', 'hotmail.com.au', 'hotmail.com.br', 'hotmail.com.gr', 'hotmail.com.mx', 'hotmail.com.pe', 'hotmail.com.tr', 'hotmail.com.vn', 'hotmail.cz', 'hotmail.de', 'hotmail.dk', 'hotmail.es', 'hotmail.fr', 'hotmail.hu', 'hotmail.id', 'hotmail.ie', 'hotmail.in', 'hotmail.it', 'hotmail.jp', 'hotmail.kr', 'hotmail.lv', 'hotmail.my', 'hotmail.ph', 'hotmail.pt', 'hotmail.sa', 'hotmail.sg', 'hotmail.sk', 'live.be', 'live.co.uk', 'live.com', 'live.com.ar', 'live.com.mx', 'live.de', 'live.es', 'live.eu', 'live.fr', 'live.it', 'live.nl', 'msn.com', 'outlook.at', 'outlook.be', 'outlook.cl', 'outlook.co.il', 'outlook.co.nz', 'outlook.co.th', 'outlook.com', 'outlook.com.ar', 'outlook.com.au', 'outlook.com.br', 'outlook.com.gr', 'outlook.com.pe', 'outlook.com.tr', 'outlook.com.vn', 'outlook.cz', 'outlook.de', 'outlook.dk', 'outlook.es', 'outlook.fr', 'outlook.hu', 'outlook.id', 'outlook.ie', 'outlook.in', 'outlook.it', 'outlook.jp', 'outlook.kr', 'outlook.lv', 'outlook.my', 'outlook.ph', 'outlook.pt', 'outlook.sa', 'outlook.sg', 'outlook.sk', 'passport.com']; // List of domains used by Yahoo Mail
// This list is likely incomplete

var yahoo_domains = ['rocketmail.com', 'yahoo.ca', 'yahoo.co.uk', 'yahoo.com', 'yahoo.de', 'yahoo.fr', 'yahoo.in', 'yahoo.it', 'ymail.com']; // List of domains used by yandex.ru

var yandex_domains = ['yandex.ru', 'yandex.ua', 'yandex.kz', 'yandex.com', 'yandex.by', 'ya.ru']; // replace single dots, but not multiple consecutive dots

function dotsReplacer(match) {
  if (match.length > 1) {
    return match;
  }

  return '';
}

function normalizeEmail(email, options) {
  options = (0, _merge.default)(options, default_normalize_email_options);
  var raw_parts = email.split('@');
  var domain = raw_parts.pop();
  var user = raw_parts.join('@');
  var parts = [user, domain]; // The domain is always lowercased, as it's case-insensitive per RFC 1035

  parts[1] = parts[1].toLowerCase();

  if (parts[1] === 'gmail.com' || parts[1] === 'googlemail.com') {
    // Address is GMail
    if (options.gmail_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (options.gmail_remove_dots) {
      // this does not replace consecutive dots like example..email@gmail.com
      parts[0] = parts[0].replace(/\.+/g, dotsReplacer);
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.gmail_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = options.gmail_convert_googlemaildotcom ? 'gmail.com' : parts[1];
  } else if (icloud_domains.indexOf(parts[1]) >= 0) {
    // Address is iCloud
    if (options.icloud_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.icloud_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (outlookdotcom_domains.indexOf(parts[1]) >= 0) {
    // Address is Outlook.com
    if (options.outlookdotcom_remove_subaddress) {
      parts[0] = parts[0].split('+')[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.outlookdotcom_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yahoo_domains.indexOf(parts[1]) >= 0) {
    // Address is Yahoo
    if (options.yahoo_remove_subaddress) {
      var components = parts[0].split('-');
      parts[0] = components.length > 1 ? components.slice(0, -1).join('-') : components[0];
    }

    if (!parts[0].length) {
      return false;
    }

    if (options.all_lowercase || options.yahoo_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }
  } else if (yandex_domains.indexOf(parts[1]) >= 0) {
    if (options.all_lowercase || options.yandex_lowercase) {
      parts[0] = parts[0].toLowerCase();
    }

    parts[1] = 'yandex.ru'; // all yandex domains are equal, 1st preffered
  } else if (options.all_lowercase) {
    // Any other address
    parts[0] = parts[0].toLowerCase();
  }

  return parts.join('@');
}

module.exports = exports.default;
module.exports.default = exports.default;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"en":{"Project":{"one":"Project","other":"Projects"},"Website":{"one":"Website","other":"Websites"},"Spel":{"one":"Game","other":"Games"},"Gebruiker":{"one":"User","other":"Users"},"Datum":{"one":"Date","other":"Dates"},"Klas":{"one":"Class","other":"Classes"},"Leerling":{"one":"Student","other":"Students"},"Niveau":{"one":"Difficulty","other":"Difficulties"},"Taal":{"one":"Language","other":"Languages"},"Score":{"one":"Score","other":"Scores"},"Onderwijsproject":{"one":"Education project","other":"Education projects"},"Standaardniveau":{"one":"Default difficulty","other":"Default difficulties"},"Standaardtaal":{"one":"Default language","other":"Default languages"},"Duur spel":{"one":"Game duration","other":"Game durations"},"School":{"one":"School","other":"Schools"},"Beschikbaar spel":{"one":"Available game","other":"Available games"},"Nummer":{"one":"Song","other":"Songs"},"Naam":{"one":"Name","other":"Names"},"Lokaal":{"one":"Classroom","other":"Classrooms"},"Groepsindeling":{"one":"Grouplayout","other":"Grouplayouts"},"Groep":{"one":"Group","other":"Groups"},"Login":{"one":"Login","other":"Logins"},"Begeleider":{"one":"Supervisor","other":"Supervisors"},"Groepsleider":{"one":"Groupleader","other":"Groupleaders"},"Wachtwoord":{"one":"Password","other":"Passwords"},"Gebruikersnaam":{"one":"Username","other":"Usernames"},"Globa":{"one":"Globa","other":"Globa's"},"Punt":{"one":"Point","other":"Points"},"Afkorting":"Abbreviation","dutch":"Dutch","english":"English","german":"German","high":"High","low":"Low","red":"Red","blue":"Blue","orange":"Orange","yellow":"Yellow","green":"Green","purple":"Purple","Unauthorized":"<h4>401 - Unauthorized</h4><p>De huidige gebruiker heeft geen toegang tot deze pagina.</p>","Klas gesloten":"Closed class","Klas toevoegen":"Add class","Login groepen":"Group logins","Terug":"Back","Nog geen studenten":"No students have been added yet.","Pas naam student aan":"Edit the students name.","+ Voeg een leerling toe":"+ Add a new student","+ Nieuwe student toevoegen":"+ Add a new student","Vul naam student in":"What's the student's name?","Zeker student verwijderen?":"Are you sure you want to delete this student?","Login begeleiders":"Login supervisors","Opslaan":"Save","Inloggegevens":"Login credentials","Toevoegen":"Add","Inloggen":"Login","Logout":"Sign out","Confirm logout":"Are you sure you want to log out?","Yes":"Yes","No":"No","Gesloten":"Closed","Commandocentrum":"Command center","Projectgegevens":"Project details","Klassen/groepen":"Classes/groups","Fotos/filmpjes":"Photos/videos","Verdienen":"Earning","Verdelen":"Divide","Nieuw project":"New project","Datum van":"Date from","Datum tot":"Date until","Datum tot en met":"Date up to and including","Voeg project toe":"Add a new project","Voeg standaard spel toe":"Add a new game","Naam school en plaats":"Name, school and place","Foutmelding ophalen projecten":"Something went wrong trying to fetch projects.","Foutmelding tellen projecten":"Something went wrong trying to count projects.","Geen projecten gevonden":"No projects have been found.","Project aangemaakt":"The project has been created.","Foutgegaan aanmaken project":"Something went wrong trying to create the project.","Project details":"Project details","Niveau aanpasbaar tot":"The default difficulty is editable until the startdate of the project has been reached.","Projectgegevens bijgewerkt":"The project has been modified.","Foutgegaan bijwerken project":"Something went wrong trying to modify the project.","Zeker spel verwijderen?":"Are you sure you want to remove this game?","Zeker klas verwijderen?":"Are you sure you want to remove this class?","Foutgegaan opslaan klassengegevens":"Something went wrong trying to save class details.","Klassengegevens zijn opgeslagen":"The class details have been saved.","choose song title":"Insert song title","fill in title error":"Please add a song title","fill in all fields error":"Please fill in all available fields","write song line":"Add lyrics...","playing offline":"Play offline","login to sync":"Login to fetch the data needed to play the game offline","press sync button":"Press the button to sync the data","sync":"Sync","pick level":"Pick level","no languages found":"No languages found","version":"Level","pick group":"Choose group","no data for this user":"Something failed when we tried to fetch your data. Try logging in with credentials that are associated with a GhettoRadiogroup","no theme set":"No theme has been set for users in this user group. Ask your teacher for assistance","delete songtexts fail":"Removal of songtexts failed, ask your teacher for assistance","delete songtexts succes":"Songtexts have been deleted","choose island color":"Choose island color","choose level":"Choose level","choose_your_song":"Pick your song","choose language":"Choose language","username":"Username","password":"Password","back":"Go back","loggin":"Sign in","loggout":"Sign out","home":"Home","theme":"Read your magazine","write_your_songtext":"Write a protest song","perform":"Perform","practise":"Practise","remove all songtexts":"Remove all songtexts","go back":"Go back","select this song":"Choose this song","song chosen":"Chosen song","practise song":"Practise song","lvl":"niveau","theme_info":"Lees over jouw thema om de volgende  stappen te kunnen openenen.","theme_inf_start_here":"Intro: start here","theme_inf_intro":"Intro","theme_select":"Selecteer een nummer om een tekst op te schrijven over het thema.","theme_write":"Schrijf een tekst op het  gekozen nummer.","theme_write_fill":"Vul eerst de gegevens in, om met de songtekst te beginnen!","theme_write_name":"naam van de groep.","theme_write_line":"vul hier jouw regel in.","theme_perform":"Klaar? dan is het nu tijd om op te treden. Succes!!","project expired":"The project is expired.","chosen by other":"Already chosen","Geen lied gekozen":"No selected song","Tekst":"Text","Lock group":"Locked","Roodland":"Team Red","Oranjeland":"Team Orange","Geelland":"Team Yellow","Groenland":"Team Green","Blauwland":"Team Blue","Paarsland":"Team Purple","Timer stap 2:":"Timer step 2:","Geef vrij":"Stop timer","+1 minuut":"Extend timer +1 minute","Weet je zeker dat je de timer wilt stoppen?":"Are you sure you want to stop the timer? This action will open step 2 and cannot be undone."},"nl":{"Project":{"one":"Project","other":"Projecten"},"Website":{"one":"Website","other":"Websites"},"Spel":{"one":"Spel","other":"Spellen"},"Gebruiker":{"one":"Gebruiker","other":"Gebruikers"},"Datum":{"one":"Datum","other":"Datums"},"Klas":{"one":"Klas","other":"Klassen"},"Leerling":{"one":"Leerling","other":"Leerlingen"},"Niveau":{"one":"Niveau","other":"Niveaus"},"Taal":{"one":"Taal","other":"Talen"},"Score":{"one":"Score","other":"Scores"},"Onderwijsproject":{"one":"Onderwijsproject","other":"Onderwijsprojecten"},"Standaardniveau":{"one":"Standaardniveau","other":"Standaardniveau's"},"Standaardtaal":{"one":"Standaardtaal","other":"Standaardtalen"},"Duur spel":{"one":"Duur spel","other":"Duur spellen"},"Duur":{"one":"Duur","other":"Duur"},"School":{"one":"School","other":"Scholen"},"Beschikbaar spel":{"one":"Beschikbaar spel","other":"Beschikbare spellen"},"Nummer":{"one":"Nummer","other":"Nummers"},"Naam":{"one":"Naam","other":"Namen"},"Lokaal":{"one":"Lokaal","other":"Lokalen"},"Groepsindeling":{"one":"Groepsindeling","other":"Groepsindelingen"},"Groep":{"one":"Groep","other":"Groepen"},"Login":{"one":"Login","other":"Logins"},"Begeleider":{"one":"Begeleider","other":"Begeleiders"},"Groepsleider":{"one":"Groepsleider","other":"Groepsleiders"},"Wachtwoord":{"one":"Wachtwoord","other":"Wachtwoorden"},"Gebruikersnaam":{"one":"Gebruikersnaam","other":"Gebruikersnamen"},"Thema":{"one":"Thema","other":"Thema's"},"Genre":{"one":"Genre","other":"Genre's"},"Lied":{"one":"Lied","other":"Liedjes"},"Globa":{"one":"Globa","other":"Globa's"},"Punt":{"one":"Punt","other":"Punten"},"Minuut":{"one":"Minuut","other":"Minuten"},"Afkorting":"Afkorting","dutch":"Nederlands","english":"Engels","german":"Duits","high":"Hoog","low":"Laag","red":"Rood","blue":"Blauw","orange":"Oranje","yellow":"Geel","green":"Groen","purple":"Paars","Unauthorized":"<h4>401 - Unauthorized</h4><p>De huidige gebruiker heeft geen toegang tot deze pagina.</p>","Klas gesloten":"Klas gesloten","Klas toevoegen":"Klas toevoegen","Login groepen":"Login groepen","Terug":"Terug","Nog geen studenten":"Er zijn nog geen studenten toegevoegd aan deze groep.","Pas naam student aan":"Pas de naam van de student aan.","+ Voeg een leerling toe":"+ Voeg een leerling toe","+ Nieuwe student toevoegen":"+ Nieuwe student toevoegen","Vul naam student in":"Vul de naam van de student in.","Zeker student verwijderen?":"Weet je zeker dat je deze student wilt verwijderen?","Login begeleiders":"Login begeleiders","Opslaan":"Opslaan","Inloggegevens":"Inloggegevens","Toevoegen":"Toevoegen","Inloggen":"Inloggen","Logout":"Uitloggen","Confirm logout":"Weet je zeker dat je wilt uitloggen?","Yes":"Ja","No":"Nee","Gesloten":"Gesloten","Commandocentrum":"Commandocentrum","Projectgegevens":"Projectgegevens","Klassen/groepen":"Klassen/groepen","Fotos/filmpjes":"Foto's/filmpjes","Verdienen":"Verdienen","Verdelen":"Verdelen","Nieuw project":"Nieuw project","Datum van":"Datum van","Datum tot":"Datum tot","Datum tot en met":"Datum tot en met","Voeg project toe":"Nieuw project","Voeg standaard spel toe":"Voeg standaard spel toe","Naam school en plaats":"School en plaats","Foutmelding ophalen projecten":"Er is iets foutgegaan bij het ophalen van de projecten.","Foutmelding tellen projecten":"Er is iets foutgegaan bij het tellen van de projecten.","Geen projecten gevonden":"Er zijn geen projecten gevonden.","Project aangemaakt":"Het project is aangemaakt.","Foutgegaan aanmaken project":"Er is iets foutgegaan bij het aanmaken van het project.","Project details":"Project details","Niveau aanpasbaar tot":"Het standaard niveau is aanpasbaar tot de startdatum van het project, daarna niet meer.","Projectgegevens bijgewerkt":"De projectgegevens zijn bijgewerkt.","Foutgegaan bijwerken project":"Er is iets foutgegaan bij het bijwerken van dit project.","Zeker spel verwijderen?":"Weet je zeker dat je dit spel wilt verwijderen?","Zeker klas verwijderen?":"Weet je zeker dat je deze klas wilt verwijderen?","Foutgegaan opslaan klassengegevens":"Er is iets foutgegaan bij het opslaan van de klassengegevens.","Klassengegevens zijn opgeslagen":"De klassengegevens zijn opgeslagen.","choose song title":"Vul een titel in","fill in title error":"Vul een titel in","fill in all fields error":"Vul alle velden in","write song line":"Vul songtekst in...","playing offline":"Offline spelen","login to sync":"Log in om de data op te halen die nodig is om het spel offline te kunnen spelen","press sync button":"Druk op de knop om de data te synchroniseren","sync":"Synchroniseren","pick level":"Kies versie","no languages found":"Geen talen gevonden","version":"Niveau","pick group":"Kies groep","no data for this user":"Er ging iets fout met het ophalen van de data. Log opnieuw in met inloggegevens die horen bij een GhettoRadiogroep","no theme set":"Er is geen thema klaargezet voor gebruikers in deze gebruikersgroep. Vraag om hulp bij je leerkracht","choose island color":"Kies land kleur","choose song":"Kies je lied!","choose language":"Kies je taal","choose level":"Kies je niveau","username":"Gebruikersnaam","password":"Wachtwoord","back":"Ga terug","loggin":"Inloggen","loggout":"Uitloggen","home":"Home","theme":"Lees je magazine","choose_your_song":"Kies je lied","write_your_songtext":"Schrijf je protestsong","perform":"Treed op","practise":"Oefenen","remove all songtexts":"Verwijder alle songteksten","go back":"Ga terug","select this song":"Kies dit lied","song chosen":"Gekozen lied","practise song":"Oefen je lied","lvl":"niveau","theme_info":"Lees over jouw thema om de volgende  stappen te kunnen openenen.","theme_inf_start_here":"Intro: begin hier","theme_inf_intro":"Intro","theme_select":"Selecteer een nummer om een tekst op te schrijven over het thema.","theme_write":"Schrijf een tekst op het gekozen nummer.","theme_write_fill":"Vul de gegevens in om met de songtekst te beginnen!","theme_write_name":"Naam van de groep","theme_write_line":"vul hier jouw regel in.","theme_perform":"Klaar? dan is het nu tijd om op te treden. Succes!!","must have one line":"Vul minimaal 1 songtekst in.","chosen by other":"Al gekozen","project expired":"Het project is verlopen.","Lock group":"Op slot","Timer stap 2:":"Timer stap 2:","Geef vrij":"Stop timer","+1 minuut":"Verleng timer +1 minuut","Weet je zeker dat je de timer wilt stoppen?":"Weet je zeker dat je de timer wilt stoppen? Deze actie geeft stap 2 vrij en kan niet worden teruggedraaid.","Instructiemateriaal":"Lesmateriaal","winstgloba":{"one":"Winstgloba","other":"Winstgloba's"},"beleidskeuze":{"one":"beleidskeuze","other":"beleidskeuzes"},"Cloud":"Wolk","Star":"Ster","FB":"Financiën en Bestuur","GZ":"Gezondheidszorg","HB":"Handel en Bedrijven","IE":"Infrastructuur en Energie","LV":"Landbouw en Voedsel","MC":"Media, Cultuur en Sport","KN":"Klimaat, Natuur en Milieu","OH":"Ontwikkelingshulp","OT":"Oorlog en Terrorisme","OW":"Onderwijs","VR":"Veiligheid en Recht","WI":"Werk en Inkomen","WS":"Wonen en Samenleven","EH":"Eerlijke Handel"}}

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(588);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ghettoradio.dad817cf.png";

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/escaperoute.66fe0bdf.png";

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lock.9f3b9ecd.svg";

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/locked.65783cfd.svg";

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(597);
var middleware=[__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]];// Create redux store
var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */],__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined,middleware));/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__feedback__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gameState__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__project__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__group__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__schoolClass__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__gameStateInput__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__popup__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__policyChoice__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__timer__ = __webpack_require__(807);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({feedback:__WEBPACK_IMPORTED_MODULE_2__feedback__["a" /* default */],user:__WEBPACK_IMPORTED_MODULE_1__user__["a" /* default */],gameState:__WEBPACK_IMPORTED_MODULE_3__gameState__["a" /* default */],project:__WEBPACK_IMPORTED_MODULE_4__project__["a" /* default */],group:__WEBPACK_IMPORTED_MODULE_5__group__["a" /* default */],schoolClass:__WEBPACK_IMPORTED_MODULE_6__schoolClass__["a" /* default */],popupState:__WEBPACK_IMPORTED_MODULE_8__popup__["a" /* default */],gameStateInput:__WEBPACK_IMPORTED_MODULE_7__gameStateInput__["a" /* default */],policyChoice:__WEBPACK_IMPORTED_MODULE_9__policyChoice__["a" /* default */],timer:__WEBPACK_IMPORTED_MODULE_10__timer__["a" /* default */]}));

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_types__ = __webpack_require__(15);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var auth=new __WEBPACK_IMPORTED_MODULE_0_glxl_helpers__["Authorization"]();var initialState={projectId:null,userDetails:null,loggedIn:false,token:null,role:null,feedback:[]};var user=function user(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_1__actions_types__["e" /* LOGOUT_USER */]:if(sessionStorage.getItem('token')){sessionStorage.removeItem('token');window.close();}else{auth.setAuthToken('');// cookie.setCookie('i18n', '');
sessionStorage.removeItem('redirect');sessionStorage.removeItem('prevLocation');sessionStorage.removeItem('noMobile');window.location.href='/login';}return initialState;case __WEBPACK_IMPORTED_MODULE_1__actions_types__["F" /* UPDATE_USER */]:if(!payload.userDetails.role){throw new Error('User has no role.');}return _extends({},state,{userDetails:mapUserDetails(payload.userDetails),token:payload.token,loggedIn:true,role:payload.userDetails.role});default:return state;}};var mapUserDetails=function mapUserDetails(data){var mapped=_extends({},data,{group:data.ownedGroup?data.ownedGroup:data.group,schoolClass:null});if(mapped.group){mapped.schoolClass=mapped.group.SchoolClass;}return mapped;};/* harmony default export */ __webpack_exports__["a"] = (user);

/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var emptyFeedback={overigeEffecten:[]};var initialState={feedbackData:[],roundData:{},totalRounds:0,currentRound:1,prevRoundData:{},loaded:false,// Belasting feedback
feedbackAB:emptyFeedback,feedbackBB:emptyFeedback,feedbackCB:emptyFeedback,feedbackVVB:emptyFeedback,feedbackVB:emptyFeedback,belastingFeedback:{},unreadCount:0};var feedbackData=[];var feedbackReducer=function feedbackReducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["q" /* UPDATE_GAMESTATE */]:break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["o" /* UPDATE_FEEDBACK */]:if(!feedbackData.length&&!state.roundOverwritten){state.currentRound=payload.length-1;}feedbackData=payload;state.loaded=true;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["p" /* UPDATE_FEEDBACK_READ */]:state.all.find(function(i){return i.feedback.find(function(fb){if(fb.id===payload.id){return fb.read=payload.read;}return false;});});break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* SET_ROUND */]:state.currentRound=payload;state.roundOverwritten=payload!==state.totalRounds-1;break;default:return state;}state.all=feedbackData;state.prevRoundFeedbackData=!feedbackData.length?[]:feedbackData[state.currentRound-1].feedback;state.feedbackData=!feedbackData.length?[]:feedbackData[state.currentRound].feedback;state.roundData=!feedbackData.length?{}:feedbackData[state.currentRound].round;state.prevRoundData=feedbackData[state.currentRound-1].round;state.totalRounds=feedbackData.length;if(state.roundData.gameStateInput){// Belasting feedback
if(state.roundData.gameStateInput.niveau==="Basic"){state.belastingFeedback=state.feedbackData.find(function(fb){return fb.type==='BELASTING';})||emptyFeedback;// const fbLaag = state.feedbackData.find(fb => fb.fileReference === 'BASIC_BELASTING_VERDIENDE_GLOBAS_0-60');
// const fbMiddel = state.feedbackData.find(fb => fb.fileReference === 'BASIC_BELASTING_VERDIENDE_GLOBAS_61-80');
// const fbHoog = state.feedbackData.find(fb => fb.fileReference === 'BASIC_BELASTING_VERDIENDE_GLOBAS_81');
}else{state.feedbackAB=state.feedbackData.find(function(fb){return fb.fileReference==='PRO_BELASTING_OUTPUT_AB';})||emptyFeedback;state.feedbackBB=state.feedbackData.find(function(fb){return fb.fileReference==='PRO_BELASTING_OUTPUT_BB';})||emptyFeedback;state.feedbackCB=state.feedbackData.find(function(fb){return fb.fileReference==='PRO_BELASTING_OUTPUT_CB';})||emptyFeedback;state.feedbackVVB=state.feedbackData.find(function(fb){return fb.fileReference==='PRO_BELASTING_OUTPUT_VVB';})||emptyFeedback;state.feedbackVB=state.feedbackData.find(function(fb){return fb.fileReference==='PRO_BELASTING_OUTPUT_VB';})||emptyFeedback;}}return _extends({},state);};/* harmony default export */ __webpack_exports__["a"] = (feedbackReducer);

/***/ }),
/* 600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _require=__webpack_require__(168),getGameStateSum=_require.getGameStateSum;var gameStateSum={};var Rounds=[];var activatedStepUpdated=false;/**
 *
 * @type {{gameStateSum: Object, Rounds: Array}}
 */var initialState={prevRoundTaxPoints:0,gameStateSum:gameStateSum,Rounds:Rounds,currentRound:1,roundData:{roundNumber:0},loaded:false,currentStep:0,allowNewGame:true,allowFeedbackActivate:false,simGameEntry:'/',nextStepState:'SIMULATION_TAX',stepPopup:{},difficulty:'PRO',language:'NL',theme:'red',showScores:true,budgetLeft:0,exittedEarly:false,handlingRoundStateChange:false};/**
 * gameState reducer method
 * @param {Object} state
 * @param {Object} action
 * @return {{gameStateSum: Object, Rounds: Array}}
 */var gameState=function gameState(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["C" /* UPDATE_PROJECT */]:if(state.handlingRoundStateChange){state.handlingRoundStateChange=false;}if(payload.gameState){gameStateSum=payload.gameState.gameStateSum;state.showScores=payload.project.showScores;Rounds=payload.gameState.Rounds;state.DefaultDifficultyId=payload.project.DefaultDifficultyId;if(!state.roundOverwritten){state.currentRound=Rounds.length-1;}state.exittedEarly=payload.project.exittedEarly;state.theme=payload.group.GroupTheme.color;state.difficulty=state.DefaultDifficultyId===2?'BASIC':'PRO';if(payload.schoolClass&&_typeof(payload.schoolClass.Language)==='object'){state.language=payload.schoolClass.Language.code.toUpperCase();}}state.loaded=true;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["q" /* UPDATE_GAMESTATE */]:gameStateSum=payload.gameStateSum;Rounds=payload.Rounds;if(!state.roundOverwritten){state.currentRound=Rounds.length-1;}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["z" /* UPDATE_MY_STATE */]:activatedStepUpdated=state.activatedStep!==payload.activatedStep&&payload.activatedStep;if(activatedStepUpdated){state.activatedStep=payload.activatedStep;}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["y" /* UPDATE_INPUT_STATES */]:if(payload.updateOwnGroup){activatedStepUpdated=state.activatedStep!==(payload.myState||{}).activatedStep&&(payload.myState||{}).activatedStep;if(activatedStepUpdated){state.activatedStep=payload.myState.activatedStep;}}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["x" /* UPDATE_HANDLING_ROUND_STATE_CHANGE */]:state.handlingRoundStateChange=true;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["k" /* SET_STEP */]:state.currentStep=payload;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* SET_ROUND */]:state.history=payload<state.Rounds.length-1;state.currentRound=payload;state.roundOverwritten=payload!==state.Rounds.length-1;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["d" /* FORCE_LANGUAGE */]:state.language=payload;break;default:return state;}if(!Rounds.length)return _extends({},initialState);state.gameStateSum=gameStateSum;state.Rounds=Rounds||[];state.roundData=_extends({},state.Rounds[state.currentRound]);// We want to lose the reference here, so we make a clone instead of using the actual object.
state.roundData.GameStates=state.roundData.GameStates.filter(function(gs){return!['TEACHER_INTERVENTION','BONUS_ASSIGNMENT'].includes(gs.type);});state.allowNewGame=state.roundData.state==='END'||state.roundData.state==='PLAYING_GAME';state.prevRound=Rounds.find(function(r){return r.roundNumber===state.currentRound-1;});state.prevRoundSum=getGameStateSum(state.prevRound.GameStates);state.sumUpToPrevRound=getGameStateSum(Rounds.slice(0,state.currentRound).reduce(function(acc,r){return acc.concat(r.GameStates);},[]));state.sumUpToTax1=getGameStateSum([state.sumUpToPrevRound,state.roundData.GameStates[0]||{}]);state.oneTimeEffect=state.prevRoundSum.OneTimeEffect;state.totalEconomy=state.oneTimeEffect.economie+state.roundData.earnedGlobas;state.prevRoundTaxPoints=state.prevRoundSum.AB_points+state.prevRoundSum.BB_points+state.prevRoundSum.V_points+state.prevRoundSum.VV_points+state.prevRoundSum.C_points;state.totalEconomyPoints=state.prevRoundSum.points+state.roundData.earnedPoints-state.prevRoundTaxPoints;state.currentlyPlaying=state.roundData.GameId&&state.roundData.state==='PLAYING_GAME'?state.roundData.GameId:null;state.simGameActive=state.roundData.state.includes('SIMULATION_');state.totalGameStateSum=getGameStateSum(Rounds.slice(0,state.currentRound+1).reduce(function(acc,r){return acc.concat(r.GameStates);},[]));var roundDataStates=state.roundData.GameStates.filter(function(gs){return gs.type!=='TEACHER_INTERVENTION'&&gs.type!=='BONUS_ASSIGNMENT';});state.roundData.lastGameState=roundDataStates[roundDataStates.length-(state.history&&state.currentStep===3?2:1)]||{OneTimeEffect:{}};state.currentDebitCredit=state.roundData.lastGameState.OneTimeEffect.debitCredit||[];state.endOfGame=state.Rounds[4]&&state.Rounds[4].state==='END'||state.Rounds.length>5||state.exittedEarly;state.hideScores=!state.showScores;state.allowFeedbackActivate=state.roundData.state==='SCORE_SUBMITTED'||state.endOfGame&&state.Rounds.length<=5;if(state.exittedEarly&&state.roundData.state==='SIMULATION_START'){state.allowFeedbackActivate=false;}state.budgetLeft=0;for(var i=0;i<state.Rounds.length-1;i+=1){var sum=getGameStateSum(state.Rounds[i].GameStates);state.budgetLeft+=sum.globas;}var tmpState=state.roundData.state;// Set current step
if(!state.currentStep||activatedStepUpdated){switch(state.roundData.state){case'SIMULATION_START':state.currentStep=1;break;case'SIMULATION_TAX':state.currentStep=state.activatedStep===2?2:1;break;case'SIMULATION_TAX_2':tmpState='SIMULATION_TAX';state.currentStep=state.activatedStep===2?2:1;break;case'SIMULATION_SPENDING':state.currentStep=state.activatedStep===3?3:2;break;default:}}// Set entry point for simgame
switch(state.currentStep){case 1:state.simGameEntry='/';state.nextStepState='SIMULATION_TAX';if(state.currentRound===5){state.stepPopup=state.difficulty==='PRO'?'mhgvthoestaatjelandervoor_1':'mlgvthoestaatjelandervoor_1';}else{state.stepPopup=state.difficulty==='PRO'?'mhgvthoestaatjelandervoor':'mlgvthoestaatjelandervoor';}break;case 2:state.simGameEntry='/taxes';state.nextStepState='SIMULATION_SPENDING';state.stepPopup=state.difficulty==='PRO'?'mhgvtbelastingheffen':'mlgvtbelastingheffen';break;case 3:state.simGameEntry='/';state.nextStepState='END';state.stepPopup=state.difficulty==='PRO'?'mhgvtbudgetverdelen':'mlgvtoverzicht_verdelen';break;default:}state.lastGameState={};state.nextStepUnlocked=tmpState===state.nextStepState;for(var c=Rounds.length-1;c>=0;c-=1){var g=Rounds[c].GameStates;if(g.length){var gStates=g.filter(function(gs){return gs.type!=='BONUS_ASSIGNMENT'&&gs.type!=='TEACHER_INTERVENTION';});state.lastGameState=gStates[gStates.length-1];break;}}return _extends({},state);};/* harmony default export */ __webpack_exports__["a"] = (gameState);

/***/ }),
/* 601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={difficulty:'PRO',language:'NL',loaded:false,EducationProject:{nameShort:'GLXL'}};var project=function project(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["C" /* UPDATE_PROJECT */]:state=_extends({},state,payload.project,{loaded:true});if(payload.schoolClass&&_typeof(payload.schoolClass.Language)==='object'){state.language=payload.schoolClass.Language.code.toUpperCase();}break;default:return state;}state.difficulty=state.DefaultDifficultyId===2?'BASIC':'PRO';return _extends({},state);};/* harmony default export */ __webpack_exports__["a"] = (project);

/***/ }),
/* 602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={SchoolClass:{className:'',classRoom:''},loaded:false,GroupTheme:{},grGroups:{loaded:false},ghettoRadioHandlingAction:false};var group=function group(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["C" /* UPDATE_PROJECT */]:if(state.ghettoRadioHandlingAction===__WEBPACK_IMPORTED_MODULE_0__actions_types__["r" /* UPDATE_GHETTORADIO_ACTIVE */]){state.ghettoRadioHandlingAction=false;}return _extends({},state,payload.group);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["w" /* UPDATE_GROUP */]:return _extends({},state,payload);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["t" /* UPDATE_GHETTORADIO_HANDLING_ACTION */]:state.ghettoRadioHandlingAction=payload;return _extends({},state);case __WEBPACK_IMPORTED_MODULE_0__actions_types__["s" /* UPDATE_GHETTORADIO_GROUPS */]:return _extends({},state,{grGroups:_extends({},payload,{loaded:true})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["v" /* UPDATE_GHETTORADIO_TIMER */]:if(state.ghettoRadioHandlingAction===__WEBPACK_IMPORTED_MODULE_0__actions_types__["v" /* UPDATE_GHETTORADIO_TIMER */]){state.ghettoRadioHandlingAction=false;}return _extends({},state,{grGroups:_extends({},state.grGroups,{Groups:state.grGroups.Groups.map(function(grp){grp.GhettoRadioGroup=grp.GhettoRadioGroup||{};grp.GhettoRadioGroup.timerExpiresAt=payload;return grp;})})});case __WEBPACK_IMPORTED_MODULE_0__actions_types__["u" /* UPDATE_GHETTORADIO_LOCKED */]:if(state.ghettoRadioHandlingAction===__WEBPACK_IMPORTED_MODULE_0__actions_types__["u" /* UPDATE_GHETTORADIO_LOCKED */]){state.ghettoRadioHandlingAction=false;}return _extends({},state,{grGroups:_extends({},state.grGroups,{Groups:state.grGroups.Groups.map(function(grp){grp.GhettoRadioGroup=grp.GhettoRadioGroup||{};grp.GhettoRadioGroup.locked=payload;return grp;})})});default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (group);

/***/ }),
/* 603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={className:'',classRoom:'',Groups:[],SchoolClassVideos:[],SchoolClassPhotos:[],loaded:false};var schoolClass=function schoolClass(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["C" /* UPDATE_PROJECT */]:state=_extends({},state,payload.schoolClass);break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["D" /* UPDATE_SCHOOLCLASS */]:state=_extends({},state,payload);break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["b" /* ADD_SCHOOLCLASS_VIDEO */]:if(payload.id){state.SchoolClassVideos.push(payload);}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["g" /* REMOVE_SCHOOLCLASS_VIDEO */]:if(payload.id){var i=state.SchoolClassVideos.findIndex(function(scv){return scv.id===payload.id;});state.SchoolClassVideos.splice(i,1);}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["a" /* ADD_SCHOOLCLASS_PHOTO */]:if(payload.id){state.SchoolClassPhotos.push(payload);}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["f" /* REMOVE_SCHOOLCLASS_PHOTO */]:if(payload.id){var _i=state.SchoolClassPhotos.findIndex(function(scp){return scp.id===payload.id;});state.SchoolClassPhotos.splice(_i,1);}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["l" /* SET_TIMER */]:var timerEndsAt=payload.timerEndsAt,timerPausedAt=payload.timerPausedAt;if(timerEndsAt||timerEndsAt===null)state.timerEndsAt=timerEndsAt;if(timerPausedAt||timerPausedAt===null)state.timerPausedAt=timerPausedAt;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["h" /* SET_GROUP_ID */]:state.groupId=parseInt(payload,10);break;default:return state;}var group=state.Groups.find(function(g){return g.id===state.groupId;});state.group=group?_extends({},group,{loaded:true}):undefined;return _extends({},state);};/* harmony default export */ __webpack_exports__["a"] = (schoolClass);

/***/ }),
/* 604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ws__ = __webpack_require__(170);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var roundId=void 0;var data=[];var beleidskeuzes=[];var initialState={myState:{buitenlandRead:false,SIMULATION_TAX:'UNCOMPLETED',SIMULATION_TAX_2:'UNCOMPLETED',SIMULATION_SPENDING:'UNCOMPLETED',roundNumber:0,globasSpent:0,roundId:0,CBelasting:0,VBelasting:0,VVBelasting:0,CBelastingSW:[],VBelastingSW:[],VVBelastingSW:[],niveau:'Pro',theme:'red',taal:'Nederlands',taxDividence:.57+Math.random()*.06,inputGlobas:0,arbeidsBelasting:0,samenWerkingAB:[],bedrijvenBelasting:0,samenWerkingBB:[],ministryCollaborations:{},ministerieGlobaVerdeling:{// ...ministries
},policyChoices:{},oneTimeEffect:{economie:0,WG:0,VG:0,CO:0,VV:0},debitCredit:{},collaborationMatches:{}},role:'',states:{},ministryCollaborations:{},policyChoiceCollaborations:{},loaded:false,beleidskeuzes:[],removedCurrentRound:false};var timerId=void 0;var latestRound=0;var myLatestState=initialState.myState;var gameStateInput=function gameStateInput(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["C" /* UPDATE_PROJECT */]:if(payload.gameState){if(state.history)return state;var project=payload.project,schoolClass=payload.schoolClass,group=payload.group,gameState=payload.gameState;if(project.DefaultDifficultyId){myLatestState.niveau=project.DefaultDifficultyId===2?'Basic':'Pro';}state.schoolClassId=schoolClass.id;if(state.schoolClassId&&schoolClass.Language){myLatestState.taal=schoolClass.Language.name;}state.groupId=group.id;if(state.groupId&&group.GroupTheme){myLatestState.theme=group.GroupTheme.color;}var currentRound=gameState.Rounds[gameState.Rounds.length-1];if(currentRound){myLatestState.inputGlobas=currentRound.earnedGlobas;if(!roundId){roundId=currentRound.id;myLatestState.roundId=currentRound.id;}myLatestState.roundNumber=currentRound.roundNumber;latestRound=state.currentRound=currentRound.roundNumber;}}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["F" /* UPDATE_USER */]:if(payload.userDetails){state.role=payload.userDetails.role;}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["y" /* UPDATE_INPUT_STATES */]:// -----
// See if we have to mark any local debitcredit items as unread
// -----
var states=state.states[latestRound];if(payload[latestRound]&&state.myState.debitCredit&&states){// check if any other country has confirmed our debitCredit
Object.keys(payload[latestRound]).forEach(function(groupId){var debitCredit=payload[latestRound][groupId].debitCredit;Object.keys(debitCredit).forEach(function(key){var dc=debitCredit[key];// is type lenenAan/van Land, confirmed and targeting us?
if(key.indexOf("Land")!==-1&&dc.confirmed&&dc.otherCountry===state.myState.theme&&(// did this state not exist before or was confirmed false before?
!states[groupId]||!states[groupId].debitCredit[key]||!states[groupId].debitCredit[key].confirmed)){//find local state and mark unread
var local=myLatestState.debitCredit[key==='lenenAanLand'?'lenenVanLand':'lenenAanLand'];if(local&&local.amount===dc.amount&&local.interest===dc.interest)local.unread=true;}});});}// If updateOwnGroup flag is true, set myState too
if(payload.updateOwnGroup&&payload.myState){myLatestState=_extends({},myLatestState,payload.myState);}Object.entries(payload.states).forEach(function(_ref){var _ref2=_slicedToArray(_ref,2),round=_ref2[0],groups=_ref2[1];state.states[round]=_extends({},state.states[round],groups);});break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["z" /* UPDATE_MY_STATE */]:// New round, so reset some state things
myLatestState=_extends({},myLatestState,payload);break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["m" /* SUBMIT_MY_STATE */]:if(timerId){clearTimeout(timerId);}myLatestState=_extends({},myLatestState,payload);break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["A" /* UPDATE_POLICY_CHOICE_OPTIONS */]:data=payload;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["c" /* FINISHED_STEP */]:myLatestState=_extends({},payload.myLatestState);state.states=_extends({},payload.states);break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["i" /* SET_REMOVED_CURRENT_ROUND */]:state.removedCurrentRound=true;console.log(state.removedCurrentRound);break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* SET_ROUND */]:state.history=payload<latestRound;state.currentRound=payload;break;default:return state;}state.myState=state.history?state.states[state.currentRound][state.groupId]:myLatestState;state.loaded=Object.keys(state.states).length&&state.myState.joined;if(!state.loaded||!state.states[state.myState.roundNumber])return _extends({},state,{myLatestState:myLatestState});if(state.myState.niveau==='Basic'){state.processing=state.myState.SIMULATION_TAX==='SUBMITTED'||state.myState.SIMULATION_SPENDING==='SUBMITTED';}else{state.processing=state.myState.SIMULATION_TAX==='SUBMITTED'||state.myState.SIMULATION_TAX_2==='SUBMITTED'||state.myState.SIMULATION_SPENDING==='SUBMITTED';}state.processingStepThree=state.myState.SIMULATION_SPENDING==='SUBMITTED';state.preventInputChanges=state.processing||state.history||!state.loaded||state.removedCurrentRound;// Set collaboration matches
state.myState.collaborationMatches={samenWerkingAB:reduceCollabs('samenWerkingAB','arbeidsBelasting',state),samenWerkingBB:reduceCollabs('samenWerkingBB','bedrijvenBelasting',state),CBelastingSW:reduceCollabs('CBelastingSW','CBelasting',state),VVBelastingSW:reduceCollabs('VVBelastingSW','VVBelasting',state),VBelastingSW:reduceCollabs('VBelastingSW','VBelasting',state)};// Set ministry collaboration matches (previous round)
state.ministryCollaborations=__WEBPACK_IMPORTED_MODULE_1__Defines__["a" /* default */].i18nMinistries.reduce(function(collabs,mKey){collabs[mKey]=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_feedbackHelpers__["E" /* reduceMinistryCollabs */])(mKey,state);return collabs;},_extends({},state.ministryCollaborations));state.myState.ministryCollaborations=state.ministryCollaborations;// Set policy choice collaboration matches (previous round)
if(state.myState.niveau==='Pro'){state.policyChoiceCollaborations=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_feedbackHelpers__["t" /* getPolicyChoiceCollaborations */])(state);}if(Array.isArray(data)){if(data.length){beleidskeuzes=data[state.currentRound===-1?data.length-1:state.currentRound]||[];}}else if((typeof data==='undefined'?'undefined':_typeof(data))==='object'){beleidskeuzes=data[state.currentRound===-1?Object.keys(data).length-1:state.currentRound]||[];}if(type===__WEBPACK_IMPORTED_MODULE_0__actions_types__["z" /* UPDATE_MY_STATE */]&&state.groupId&&state.schoolClassId&&!state.preventInputChanges&&state.role==='groupleader'){state.myState.globasSpent=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_calculationsHelper__["d" /* getGlobasSpent */])(state,beleidskeuzes);emitUpdatedInput(myLatestState,state.groupId,state.schoolClassId);}return _extends({},state,{myLatestState:myLatestState});};function reduceCollabs(swKey,key,s){var roundNumber=s.myState.roundNumber;return s.myState[swKey].reduce(function(arr,val){var group=Object.keys(s.states[roundNumber]).find(function(k){return s.states[roundNumber][k].theme===val;});if(group){if(s.states[roundNumber][group][swKey].includes(s.myState.theme)){if(s.states[roundNumber][group][key]===s.states[roundNumber][s.groupId][key]){arr.push(val);}}}return arr;},[]);}function emitUpdatedInput(myState,groupId,schoolClassId){if(timerId){clearTimeout(timerId);}timerId=setTimeout(function(){if(myState.joined){window.socket.emit('updatedInput',{who:groupId,schoolClassId:schoolClassId,room:'simulationgame-'+schoolClassId,input:_extends({},myState,{roundId:roundId})},__WEBPACK_IMPORTED_MODULE_4__ws__["b" /* handleFailedEmit */]);}timerId=null;},2000);}/* harmony default export */ __webpack_exports__["a"] = (gameStateInput);

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/land_groen.416ec6d3.svg";

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/land_blauw.68b7ff51.svg";

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/land_geel.3f72158f.svg";

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/land_oranje.c4cebd44.svg";

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/land_paars.7055e0f7.svg";

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/land_rood.6f0340b5.svg";

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/camera.f2ef7ebf.svg";

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/checklist.ba253d20.svg";

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bonus.11cdda39.svg";

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/movie.174a80e8.svg";

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Lock_grey.faecd778.svg";

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pen.8d2303c2.svg";

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/add.b72dab36.svg";

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/play2.5a53be22.svg";

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opstart.32b82ca1.svg";

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pdf.0f993a37.svg";

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/delete.018ac6b3.svg";

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/thumbs_up.952ec80d.svg";

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/thumbs_down.ceed10d7.svg";

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/megafoon.faf27f77.svg";

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pauze.25f829c1.svg";

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/download.d48cff11.svg";

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fairaway_logo.c8a732d8.png";

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/link.dad15f3d.svg";

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Economy.cecd1993.png";

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/FB3@2x.36c74b3a.png";

/***/ }),
/* 638 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/FB4@2x.b682a380.png";

/***/ }),
/* 640 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/FB5@2x.87e321c0.png";

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GZ1@2x.35ed2471.png";

/***/ }),
/* 644 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL4AAACLCAMAAADoHdOxAAAC+lBMVEVHcEyoqKijo6PKysry8vLg4OCbm5u8vLysrKyxsbHp6enY2Ni/v79bDQ1bLikDAABKJx9XBwdYCQhjCwt0Cgp8CwuZKSlUFQpXCAhjDAyHCgqLDAwVBQVXBweXDAyfEBA7JydfFBSXb2/GxMTS0tLBsbHHx8dSFAqpmpZxMjKeIiKzOzuMjHSpqaXU1NSKXFx9KCi3RUWXl3eVl3iUlnW5uqacd3evf3/Kvb2GVVWZMjK6S0uUlXTPz8OiPT2OCgrOzs5nISHa29O7j4+zOjqZmZKUlXSSlHOam3zs7OtaIA3DpKSOkHCtr5aoqKjOycmvbGx2HByNjm/DxLOVDQ3Y2NiNj2+QknHg4dpnCAiskJCjpYmqW1sJAADU1NTJyrvm5uJ/SkrMzMzV1ctWBwe3paXV1dW6uroIAABCFAkzHgpKKQ5JKQ3w8PBCKBHq6uoyHgpEJwxNLQ7k5OROLQ/s7Ow9Iwvf398yHgnU1NTf398zHQnc3Nw1Hgri4uLn5+fi4uLa2trX19fu7u7o6Ojs7Ow3IQs2IApLLA7d3d3e3t7j4+PS0tLh4eHY2Njk5OTJycnl5eXi4uJKKg3c3Ny0tLTAwMBOLQ6oqKiVlZXn5+fg4ODg4OCCgoLd3d2cnJzV1dVlZWXp6enS0tI8PDzMzMwsLCyPjYyzsrHQ0NDa2trLy8vb29ve3t6rq6vFxcXQ0NDw8PAtKiednZ1KSkrOzs7AwMCysrKioqJ2dnZDJg16cGjCwsJWVlZfT0Cbm5uqqKaQkJBPOCJxcXHNzc2CfHa/v7/Z2dnq6ure3t7V1dXR0dHm5uYCAQDIyMju7u6ysrIAAADj4+MtLS3Jycm7u7vk5OQAAAAAAADb29vp6env7+/e3t4BAQEAAADm5uYtLS3h4eHj4+PDw8MAAADn5+fc3Nze3t7Jycm2trYAAADR0dHj4+MAAADm5uZ1dXW4uLjo6Oh4eHjk5OTk5OTi4uJxcXHT09Pw8PB9fX2ZmZm4uLjR0dG3t7dOleVQAAAA/nRSTlMAZDXd//UbsHmO/O7JDyIFMdPw9PTPLpH/6PC8AYDw5Az/+vj/9c1Q9//57k+j//70liCG///x/fj6++Sg////+v//+3Y20P///0H+//9O/v3x//+w+v///2L0//8W5P//+fn/q/f/nwT5///A/9H/wPHi////4f+o+vmA++H//Pv6/////UDvgP/3//j///v5//2u/+rwwI7h//z/2vxM+9H//sjvwt7C+v/////l///+buHL//mw6dX////R9v78/cfY/2fc47Hu0PJwE//SPguAnv/7kg8J8GDhQRkO8T0QwG8RIFrlhhUeqVEjz4fxMNyi4mTAuPWSbn/WJx6FTqcAABIpSURBVHgB1NdVd+s6EAVgJVWZeco0ZW5VhtC9J1wI2Ckz9/8/Hymk2Es+eZTzlV6aZC+t7fGYaObxkNrlraP1pFY1NFKuidSm5hYq1JFa5GmlRd6aLH1ZG1Fo7+jodHPppZYGYtfV3dPb19c/4OLSS83EZhCEob7hkVHXll6yz84xKBoan5h0beklj7X2PTA1PYOz01Mif7tbSy/NkUrzAAsozCxC79Kya/qzstpC1bzW7iwirvEvxHXYWN4kbrC1zRjboWqN1vi7KOztIx7A4dGAC8Ifs7wTqtSiin/qQ/QHpk6PtNdnm5UEqVKzLf5+qBAfZ3l9/iNa/f+HhVlRJEpVWokU4/FnfYdxEV/Uf2lC6/Gv8NSJcv4kVTqrGJywiOcXPg65fbgcj+ktTjiRYmXpqrOzG8557FOf74L/xcWp8YzGSZ+NGCn+lTDDrCBHVRrka67gGrkln28pxAcQ9A1rW2/qKc0ljEQqlTJM02TCTbXZ2d6ziJzPd+vz7eEsDA3f6Vlv7qnwwMIpwTASzvWpt8ye63z8+PntHvp5fB2j3ztHi5IskRJ4hUSDIo9Uoany+KfO8/ER+V/o6bvSUHq5IUQjjBkpIRF2nD73lrXnCfGQx+eeAfrmdZReCvLMZuH8w4x7qbb4vMIBYigudp836Ont0FJ6aUfkN/Lnr7p65eyUw/PgHN/F2vYE3b2jekov3TAuJZjqq9f20NjeDYE3Hv59F2BoUFPppRwTDBE/7LQ7fJAK7a8AgcWnAAB0f+oqvfTAuHDp9NmD0+yUvqDgdVRf6aVk8fhNUzF8VA+N398/PTx8TGfppcdIYfyYzreuOnv8X+2lt9VHNN/5sctrj6+/9Lb6KM5ealPE1116y81XSD5SSTk7ZXz9pZdexMjceaTOmhXxdZdeyr0E6T+1/uXNbLrTNqIwfNwQt3X9E7KzT9JF69/Apgu66M7bLrzQgtMJdZUJFXWubSBJFSGZ18FukGViY4ODYhK1TdIkbb763f6qagAJjI/SsREeNgrixI8u7310R5w9vh/6+NbEGeP7oY9zXTxTfD/0LBHremcQ//L4Q59JxLr6m8Yv04tfjT/0arzlnxrEvzL+0HM1Eet6v49/9coZmD4bZ/n7m8YLX/fxx2l6LZeIcfUfuH3j4386ftPnlk6QbHl3+vjXfPyxm57RsjS+1Ccnx4n/7srwn1udl8fPybvzko9/Kfba549lZZ4K0vzF65GnhjeNN9I3r3wbd9Pm9eRwAjjJl/+WIfGh93r46bjxJ0umlTyWHiJ5dxprEu4cF/45PTtTxnAANFqVxl+H9ODj49+OlX66gsrGJob7L3eC8q9RTtKdYmb7Lk76OxVS89Uq7MSwOmlLuvyqEdm9ucFNY+z4E1kdjrZdrWE4/atUky7/1lsuNXfkgdu1WPHvLu0AJdqtLun1Y+qUL/8y0fL/4p+PfeSc1OYI2MN+FTtYLhSOqvMEzWsTIvFD/omYR87Jxk4ecBbQrKJm5GGzo+qUnxxuEa1EnWuED9xixp9e3QOwoG02D5DUlSkH9QQLr0Ejkh7crhuk1iPObQ66U4ycMf0wcc/YIwAt2mzuYkbDCtUrbtFK9dXZnRw4l1B/dKdMhfzTcc5sd1DaAUB7qDZ3jfszgMXZoR0alLWpOzmoEnellbdE7UF4ITHiT2CnBQCtMg786uOhZ5UdB/VBdRIVmJngUuqnqO79vqH1N40/xIR/t2YqBABlDbsCf07x9Hrb8avuh79zEaU20SrnGSn+LSKKGn1+DB+4xTVyTjbUPREdGArhkY9vLpQfK2sFQcpE3lnCJLFSvGhIqp/UKPyp0J0xzWwNtJIAAM0Dms19mDNP5pytoNA8wZiaOiQhH8al5AOK7N5cWP6L8eBPw+pGB8kyys1mE4abh6Eafva5/yLuxyf7pO1SLSOvfjIiunc7PPrIxx/5R8WfQEonOlAVDZsCH7prWNgywcx6Nz0Vq/zYI9qSV3/khzc2gqN76fTi7ZGVqfai0/kSnnbwoSRh2jZ1WzdTJ6XuPXzcc2eCSak/qnunnoXfUTr9fMTw3AVKveig7AHVLn6yZQJJEXRu84rZZqZXVvSOzjlncuqP6t7tcPD5Of38xkj0n9Rg9aIDVSkDu138lgWgKOrMM9wmt+jmn8y2O5NDsS6n/sj4NML0/3JtNPzJBsjrRQeOogEvfPxNAIoOYM2nN22eqlRUF3NzFEwOkuqniI3Li7CpXz4fhf7COSAZRAdlcdTs4bslAJmELx1bV708tzNkEQXpl1M/0frQro2bInhPX73uvfF6cTRlohVEB/A8oBTgaxoA+NWzyTHbZqbA6hpJlj9Uf3dyZuGYl1HF0cqbN6+Ce9evI9B/DKwqSYTZKQObAX4n/FjndGjNeu1KBmTnqE1Emrz6RXzYoKg4F/+aevUmnDsPRlEmDC+MDhZE9B8E+PMi/Hq77ti651rW4ZxpF6iz2AnUT9nVlKg6Z/yI+p8F/0lthDkNSIbR6TVBVeBvAIDSQtY0au2E7nmHsKFnC2LqlN81rhM5etbv3nqgWh6qfz8XtMhnp1cmdvrRASkegN8EfhUAXAUgy2vXTc+bzRYLWYfPC3rpZw5C/RWnbfjYqaNneGL7oDs9/f7H6ZUJU+lHByXlcwC7Ib5mwajct7ZS8GatvGuKx69Eoc3l1O8eOrQW7NFE8DuXbtuN/U7vfnhqb/4JqN5AdPCXcgtAM8QvKfMmTFSMRHHW89zOvYq65T9OyoaHCRao3yH4hylBX/DfzvDu6Uf+4IOXVxdPr0y0BqIDVVEM4Hwff0lZcBy4jn+LmfPxuRjckgLn+EaQD09BjLFA/S45Qc4LjMM/57+4XX2U+Pty+uYXp5YOrMHo4B/lAwD/9vGRVyqA4Swzu5JViLGiynJZQX/8mcN/1JlBjBTHucfr6ZWR9Sy5fdcckKjr6/uRyzvM5d04zmUP9fZSrw+jUgcLdULP+tBpusQXtSOlUya4iBUx0+WpWOoVh/XJm0AMPWbwwDSYGQAvxhmzJARinCSRUj2zjJejARv4abdbq738+/t+X01VD/DdXeAKFsdM0FJrGqWLRV4lwMNO7Q5u67P/cQ6VP/r/N9AT0Hh1Pqq71Wm/Rk/b65l5/I8AIOnSQUEESIA262Sx4iLBiRBzIfjjxc+WxVd8fsWQMMwjO+o60Dn9WZNjlmGlsiziiwXok/NDp+E8+ZLZPmLLvdudufoXPq3jvwuWZN/ooiFUixPAVeQFyueKHQ6iWp8Dj2vP5r7s7gR3c8w6/+UHxSYpTPFjhpuAmZSc87mGl4bjYWNcPVH+PTY9XH5MHfjpXH248sEyfrzfXe/3NwkNOe8KBgpYkq5HNKB6Z+ewuDDM13aJg6Hb9BS27cJs7VhhNvqbIU3wmoTMupR62Or/2dVJY+hMpsg2oNFA35Hz1+Zx/wC7OL3oxdXry/h2dnv9nhUoPe5nHK9F7S7kPjWBhR7EnHWCDAOPmoqz2geVLRbIyDVrKgKcWWH2F6Neb9MUm29am7IMkkhhxs7caEyH0/FwiNDQGX53hW7cDA7auI+7cxosN/Z+Gx/EKCX9AU1DG87ThkY+MSTSQdcq3fGw50ueBTbyTh9qKWKqYqU4TlLOfJoFo6I3IMY2QHDO8JrwML72+bBqoGrLaSEHlQ5yKvSduXTwMXVALtQHhD7dFZ+s0D5JtT1zcw3a93Nj1sNgzgrHKoc1FXjL3UBTYaoSmiXQ1XZYVGwoO2g2R6ZwI7LRbKfNuktnbjmN1QpVQ6dstVbRE/LFK/C4O3P1byI0lx/mrI8upn0qXKsujlnSlEaEx2VQo7sdzjvAOPdsdGaTY5ZprpRKZNcPjBukgSImP1lQtyiKfjE6FoTt5PaXf0TjmeNMGw1na7rqoOrJprcWCHax45KNf30Zn6yYQZDLHqXttzC30WIjiVikD4LjzJafJ91MMNbBZ+cHGxzHKaxZxzMheJO3RR73C1L0grzYEJ7/1f+uNqbVpGwNt4arqDUr0di684T50aXd7izUv4DQ3mV8fcwUYd4XESRKyQ5WockkHIjm+mgbn0HHk9jeOWZHGMZBqpVIMIDyPJFj5q1xfCQXxaaQlJz9vzdms6266uXUGdtnqGzlx+gpuHMNdri9o/45tJAfFoyKo6YfJjlk3O3gyBDI4CiJAmtGvZOMmsszIHuvvgnRXWuCFJm0cw2dTCbBCSrCQp54/3et2fb29sS64tj6V/Yv2wP0dNy6u/zInasPV9FCflgwGAx6adyNE2gzhQMDmnMaUjnX5zCXSTJf7FXK2fpx3LEqUcazvC1TjCPaxG434IMREUf/tOo429tlNW5UM2d7MtmalWW525qnEiigC/XhFlrIfwxq4vV+TwAQP/FtUYGHqerwTi42/aAmzvLFshO1Fffex4yt0W5btHNXxpxzJX0rFe/3ze9ns+m4td1ynJbTmk226i40UAM9PQuBLu+oDwgt5P/5oin7imIlAUikSX4JMgER+DFbsTJQHQTRiuRK2fQqzmPWPMWbMbQF8NA1RuP6H5GGREaXP9+qZpNyUs3GqBrP7MROpk9f+N0Cnd5R/y6q+fRRfIhJf6UrAQKhY8UzHokgUIdELkgRRTqSQEm9NVBtbjejb3OdZ3FOjCWRiuOMplym/3keoao1GY/LYdkYjmfluFWHf3YPcCm2Psc762Yt/zJ+IlxBtYgpzcVbVvMMWAQ+pUWPELpJLiY5iRgwFnXSmL+TuEL51MYXIoe2h5lSin/1+nY5XB1uz6azln0Ou2TWO94KPUPOvbaj/iVUc30ZHygNYzAFgbB3SHlelrV9FYxs/qJX2Ct4UkgZ5JxHvvf2n7VyXUNpKKSA1G8GafuVz2fb5XQ6XC0n5dhmXtT9GbN67+OF+hfQQv5l/P2UHgHa7yV255VoF7KQcX99oyiIH25SchgrYWhsXBGm7k/+QkjXmDxPghTAN8bt3v1VNWu1JpOJU9riOw5q2OwN9My5cR921s2F/O/DggOUriRuv2cM7Z8QhEMqQ2EGRUgjaowMmCdCI/w2JyKlHw1MKBKtVZYmMUkT89XrrXKyZZUpJ2OnssZ8f1ypV6B7aEf+X8DSnjzpEV0QOqCENNMgbmfdUSEJFWSDugdwIIjmOGub0Jz6jRAkB5lHygPOL7/ammxvz6wzw8m0YQvfQN8j9+4CoAXXv43fpRSopHQTjD4Uapkx3pQXjY4EHWz0cgNc+x3mtbkU1HyYCZp6bU97qnP3ynA6G7fKqhqjaev7LPxSoAdowd5v4x+08ieQFj1fW8mZBMWT/GIRBboYCBEUh2IPp6Ay+xOKj04ZKtssj/H98xMHOWWrmo/rD8SOO1b+ZfyT8/gJCQUQAtoFTj0QghaRG4p+Kg/jjgdxlnE/kN1TH0YgUm53xcOyrKaPjuKr6Afmg0fx23Z2hVUoKQQI4lMDLIo77FhEpZCRSykNw5gxlnmaahX9er3jffxXhBpl2SrLR7PaQD8w19+FR4SURqDBFF0KwuggY3E8/4ad0jTd7IqVNOFelCZKBe3kna8f3hqXzrCsynp7hp4Te5fx69ldgTghPTftbp7UDGdSJfupJtFIhFFeUBoGnjBruAOq/d/VeGgrP21Ulc1u3XlOfL3rxS09CCBNv5eIQWFAeb6rU+q6g40BoTqI9sWc8Vw0Gf7mC+RYZ5ytqjW2A/sc+dvu+CJJtOwTHYnBUQFR0BXtfYSEqQ5CrU0v8hlOaNj5ZD75w9Kxv+j58vdl/EOU0kMpaNBkQGnP5C74Qq506xOjjoJcBocZVywRD/dU1fydR6Nhb8+XPf84vZzdkL4WA1BJRY+MRpL7GY3WSI9SGehRvyCbGozPv9yutsYOemG4d+nao9k9bOPHMbh5HFqRAmr8pOhvEN3NzUZBzHHSvXbHGU+delvwAj3BlZuLU7ywtwQglX40iiOTQdJ9b1QUvTA/O9ro65Pybq19/Sn1gnHrwoMHlNIHAOBDHEeQvJmG2hhz1vQ2+t371eR/7lx4+HAPemE5dzOnt6EmAZ9C1sza4FK6WZgDXzbqOXUqZxW9sDTQrUu730V/k3He4VzrB19MG+gloNFA9+5fgx0UtnB8+5//es5z+gRzPC8/rjnTQC8XVqIHYGna8N9cQS8jd84AwG/xZ/fQS8qNcw/4JzfQS8zVW/9uD44JAAAAEAbZP7UddgMDAAAAqgMvThHyJemz3AAAAABJRU5ErkJggg=="

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GZ2@2x.9a5f3d1b.png";

/***/ }),
/* 646 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 647 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 648 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 649 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 650 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/GZ5@2x.c414789b.png";

/***/ }),
/* 652 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAADSCAMAAAAoqzGNAAAC91BMVEVHcEzo5dzw7Ofx7ObMx6fx7ebx7OX268To4Nfw6+Xh29Xv59zEt669r6vo4NbKwLgxDg7v6+PJwrnazsEqKioqKiorKytDNjErKiorKysoJye+xJHIvLMqKSk5NjIqKioyMzErKytEQT94c2vRxbowEBExGBksKis9LC0+Li9gW1kqKirYzMCOhoBHREArKytmT1ItCAotCQpcVE7d1MsrKytwaVwyFRYrBwuHfHiwoJdeRklXPkBTO0ArJiZbUEEdFBRaU0kpKSmkpopMS0OyqKBzbmpMSkihmJOZkYtlYF59eHA6Nzc9OjlpY2NaVlSWpXB4c3BkYVtcV1OJkWeEh29kX1lkWkxFQj9UT0thWUiHf3fn3M26raSvuX+zwoGuvn6puny6xoLD0Ibt5+CbqXSNmmd0eE+xwH+fsHSzwoCaq3F7hluDg1Smt3uernSJgnuZqnGgsXaouXuVpm2Qi26is3eZqnCQn2mDj12nuHuqunyVpm2HlmOis3eMmmWSo2qLnGRlXlDCzISqunyVj4WZqW+crXKLnGWXpmywwICRommxv3+PoGjW2IVcVE5kaU2fsHWltnmHmGGIl2OTpGtOSD+ImGB1dVacrXKWpW+CkF6/zISDkV9/kFpvek+Wp2x+jFpJQjh4iFaMnWV2fl11g1SHiVeGhmttelGVoWjw7ORibkplVDrw7ORqUitbVkK0pGfKvnSYf1t/hVL854Hlz3nErmt+d0ZqYzxsUylOST734X7YyHemjGRmX1Hx2nuWgWpyYjj75oGKkVvUumjZvmqQb0B1ZkZrWTNwU0KceUZFQTFeRkCeeUeDZD3Hpl95XDPty3VeTC3RrWJyW1jnwHCwlm21lld4YmSDbmPbu3LXtGmlgUqhkomqilOShna+nlmkgkrcwWtqZVzexG/854BgUjJsUyj55H7TunW4ooaSjITivnPnx4ZxamASJyiXiYPHtJ2Pg32jp4bu3bvq0aDi1MMyQUAbKCQgMjIOHh7czcA5z/1VAAAA/XRSTlMAI6CAEP/gUj/x0P/+///7gmiL//DAsIJgQCA75jAQkP7//+n/+vnh/9b+0O7/6qD/vf/q/4Ct70D//////3B9pJdQWqD////+/v////7//3CXxfVMf+pR1v8uQP/T4H3rblKBkJOIgZ/n8PHqYcDYwLPP+e8v+N//Pu/U1L7//+T3Z7//nf/57/i59P/cH94////i//6s0B///+z1/3Howv/CwrH//53////A/8Cwkv///////////////v3////8//+M/8H6//////z//9b//v////b//////////7v5///4+u3//8j/27X+/93///////9g/////f///8HAhc/4SwAAEUtJREFUeAHU0gOaw0AUAOBX86WMjUFtu/c/1E6yPMF+k7+N9QT/oFAsQV6VS5VKpVqDXKo3KplmPqNvpeG32pjP6BWl0eggYvfPMPXkHaRyv1Es/I1eGaAwVDXdMC1xyhbdcFyQkecHYRjF3t/oExQIZYxxzkejcZrOUDVBPhO1r0xnc2aYpq4vVJXzZTJAYUXWGUI3yhbR2w13IJvdBPbtNs54yFOHAyVkPUBBXHSP3e6BrMlpe74AWJMFSGZowmp9vRFCQrr+lqAAmfvEA+/46D7TIZv4IBVjIhayTonwV6vV/ZUk2P6J3gpd+OUN3yCTxT0r8Ac1d6LaOAyEAVjAAuFIw6ERGi+2q7JgWFPM0SmEw1C3Obtpuvf1/u+xJG66dqIx5cxMOMIl+BAzv20hqd79pXvpaFfkr3ro13pjM0n6oju1ddlmzuRVj8daIElxGU5so5e4H0exiaTJR+jbQrLP+4M+PbU6kqP37qgNqr1+8qKvTjOmKeToiY4qySY7/U2rz0LCd4pAvcmrjt6XkSG5nMyH4/xOwv1/vatjrVLI0ePJA+DhoI8XjjE2kavH4lXvy+gY5+XqTTE76F0d75VKsP5uftDbeLpgKVh/H25aPVpmUBCsHy2WrZ6tkAIF61frVg+eG+QF6z+EVh8S9hEnWH+xmO31lhtUO8n6x/lezxoRJOvHV3s9Wx+play/+DTZJ6YxwiMzp5h+fb3TG16fydBTVL9aD+sBJesnl5r1F5dLFfraRfXr6aA+J5FrCgf99cdBPcnWzzaa9TdhpkGfhbh+sRrSeylfV4z+aT6kR5Ctn25V6EuM6pcbFXqI68dhplm/WGnQ5xTXP8016InRP25V6PO4fnWlQY8Q14+Dav1mqUCfWka/nSrQm8Do53PN+uuFBn2Jcf1yo0EPjH4cNOidZ/RXqQI9EaNfNJr1c1Kgb4DRT50CPXL6FSjQpwWjnwUFehMY/ThkmvWACvQFMvrKK9ADpyfSoG8YfeMU6IkYPYJmvQkK9N6x+ky+HoHTAyrW85ug6krQdlhOT8S3ipgfq/dOsx5Bgb5ERp9ZBXrg9Cao1pcoX58TpwcFemL1RJr1dS5fX1ecHkG+HoHTp6VmvQmq9UUiX1+yekDxehNYfe616e87eiJt+ueOvnHa9J87egTNehO06b909TbTrAdUpt929c7r0idfu3oiXXrsVY53uvR029EzkdlUUvVVJzG5yESQera8eO7pbSJSz1iyMOrpATXpPfT1VS1Sz2ysg7qvp9iHeVLI0VfUu6uiq+emOchcx8zR9PWplav/9t2YhF1DbqGZ2KPlDz9+mtoN6ksUe+jn1+9bU/hBvavF6tO7PxUYTs+HTkUS8A1BmQ3rESS+piFBKIAOZcPqk1i+eDgnvals+dB0Z53VG5vKupTAFwUl5q8xb9KD51/szlDsZZsyb9MzbWvTM+EtGfNmfWfT4Dtj3p/7UoLEejOsN/+IO8+3NLYtDq+ckNzeIfURb/d5TK9fTuH0aiE9yr2B0YCFhFhgGNoMJHMHCKLOMHOSPWbUMaJieldO773/Q3cPMJbzxJQP4PvJ7uvs315rqbDnT//R7P9bUDXMb9tjL9gdhGHhglSebdvA3tJqX9peUz6++3dOVxvY2x0dhsJDvxxAdHYQhLvDqS/I8mzbEyfbHS7PqXbNfmlWGLoOH4bunl6vw6d1WxII0tvb7vU7W/Vta4ZlgAp43MFQuKdVty+mubUFFmFrtpghcopmyIA2CGn2UdLp9XeThmJ4Ni1L8GOnPV53T/hU+IxuH+oEsLPkYnk4eOTI/yIdHIftq+ptcZszniB7kl63++yxZXyQS+K0J+Xui55Ku4v2/a0eNwDBMu1nYA6fAQa27v/HP/ypdHIQwHgkDkQ8xvfxqSTnSS/jqW+JFz0Jr5AJ6/aOzpC7HwhB9EgL5TW/N/dbz51LnNeOkkpiexEJTIKSg2lYvugMvejp9fKZdMZbtA+6e8gLZwhB8VAL5XUCw1pvPpoCgqOQIIoxiUz59MMdK8/IutF4GkVD0dScfZyNaPZMy4X2+zcC899jYKUFjlZEhiKZABSoeR4qTXUNjCYzXDRMJ+bthQhBqx6R6B29vz2MXQQrQjKvsrxEigF9Wqr0UFyzqQpGU5lkd5gr2g/QUmrOnoy0nGm5n71lE1g5TkIqzQhIHIUipor12w3Vpk1/q9lWWOz0eMqZloZ0e4oTskPYXsH2nl6XfvHP7z0POjbjeisnU9he4SWF7tSag2FjwFipjWve8/x6KJGBmDMSLdnzFCPT2b4LE7J6go94yDn7fU3Pzdvv2RaQJIZTeQUxKsc7+uGsozN4EutXnElIuC5mArq9KNFZlpqg1Ck+K9MjlkXRaX4OM3DYYtxgpRhZRQonqpQQD0FPB9vrqKpZswEqT2A4Az7bQZuhYM9nWTFHTUyhrMxnGxpqDw8M7KrFNMxRW22yxlLTeIE4ZYJCZA+ESSEZx0tq3LSuUm3L8MSvVurFvB0wvgHEKBSfFcQco9vfl9c37R1yUSPUiKSqoiSEYdiNegUtkutMxm1VUAFW/mr+YPt2/1nAjHGiSKGcoOSY3BSXldES9g0HjBYYPxJ7LjYREWPxcwDhZIekVwRj+RvvitWrilz6JQA4U0Fzlw/GZKWPQzlayam57NL2mF01pnVVw82ZERieTBwEGE6nMwtOVTbuKXOA/vSrVSWeMIAr5h48vB/GcAHMosu0ejmXuyxfplD29Z9FphHTpL3xyjNrjDXbLDDHweGFvWSNsXpD2W+JUORXK33nUpa/v67Z81nuMq9epvqySOZppPz9lSbMK3/H1Om80oDB4lXPbFpScsO2v1Wby5ueq7r/6l8eNB9phmvTasF+4jJFSwLbR1Py9ZLxjZu36uZo0pbhCJw/vB+n3LR+Kf9y5+eXq3X/SysAwDKtottFe16keQExvHC9KH8Hc/feTEm/UaubzYMWi1Zmapaa0Nab9PeUP/7HDWChFJbpU9HE7DRSeESzFCez119pqsfyJe7emNIiVKvpz/89a+H1Nyw6LtlU5vgfn4v/CgvFshziUS4/zSk8x7OKTPFvbdly785C3n7n3bp6Tf8A6DxjLLVZwu4Itiy6lYHxGShvfC7ppXPXbY5FnNyH7SUVIV5QJYq//p5+5Rfw/s0PsP7AvOW2oqWzmySPEYvPxV1T5ur5i9WrfvUngCu1eUlAHCWwM9PUbU7gaBUx6MPFV37hTzB1Rf8zhGaphcQ5TnJ+Jyyg37ym7OdV/8kA0Px6bZ6iWY6hhQ+nmRmOp/gJnuWw/JK8/f5H/QBBPSTr4OAkGQ/q9gawn7WHCHimEtPngYbaPIN48WNEf8iIeYZjUI5D79x5CJ9AUA+JcZt5OB7lXVDA7rEHHe3pDoDny6//XAO2RzRSRMR/+LGSvy2L3Oz0Q+U//WxStwezadOG8Yy31HWJbqKjtzvtdwBUlV0fV5GmvCRzqsAizX6G+nz6i4fLf/nUV0mYY5uxyueCkv044aZDab/72AtYv7yVfwC3z6/zFCVPyLT0xcdqfkacZe49XP7pp7/5KgBzrHsrArp9hPDyvYmotyOghecxt67lEDw6R/Do9fev86JIzVKIKtirXzyKPObLr3wwx6Q8DkWsEaeXF4YyXj+2hz2bHq9wjg0MPlZuGuu+zs/cZmYZTvxi5ja2f0R5rP+trn/Qh9NS/GeMzXXRKsTpE9EUti/vHx3exLmpx/ZZlckpjPpFPp//8OYjymO++9YGBVwBwhs0Wmw27fWANZ7iTwTZjoB+F4ny0Ixz80odtv/ienZW/ViTz3//yPKYzyZtPsAcCjhT5Om/ljJujcfik34hUczAHhOUh11aburq8wW+mMljfvjx7UeVxzz1WZvBZvDZJg91J4KwrvS4i4A3lhz085lB/S4SUA4sDXjLNjX9lF/AVz/++P29999+NHmt8JwEnwHarH7BDVC9CQqET6YGo2jo/9SdBXAbRxSGVYbQTBkDqgfKTIJyK2M48cg1FMPMKE+N4QgNYWbmnNkFCyKzz6JYYOYLM+y7aO2zfDdUyfAlZvp29d7vvd2bsRyfM/ks6qXvBumY9qXFxQVGUVkmiUfAKY/1Uekg+9WyObAj/uAoMlm+Uq6avN29Dzfwf613Hl3DHfUhIW+lMeWLiouLi4xCoUgsLCvPxiPglofcTKHtFSvhJBW36LiBqpVyL0zwhBWTZrPqhz5o2RKCiQnZF4g/MJvLPhCKxR9YoIg45DHa/IHIfmniXx5/UGFHihfsZ82aN3vSq5wte47ogLW42FYkLjMD9AhEZcetMAIOeaDgPG/8pu2TkxktOrdiRijPGyyZpYRTM7aeDeR7Tn0emnp7kRjU8QDoIsosRiNglQfyzstHb18pZ9z8OHfsx96xH7dEoYxbyJqXEjz12iCHlgCcyD5PJzJ3gC4iocVmMLLL6132yifmJqcwbwmQe+vCatzyxHWsDRQWEhwM6mcJY1XWEdyzKHKE4NxpBGXOAi756pMna9bgmwh43mXpShVuoKgJjzLXCcElOm1uFgodnY4AXGBfJPrAzIq18+QbjcYCkAf+pr/1y961Z+zWRS1etShyxYT2BEojqgICtEQbtmIcOWzkFOZ5uuOZp0mHrd1BPrth6tdpsri4uMkr2vTlRK20ql2+AOQLIXLYOe3Ss5cNpuZJ3vs+u5oavkWpUCbMXjQNou2HGPS8ziPsceSwY7HliTjkMfW+2wZZM265LE4zb9FMuIVU+saMuYeJDhRaSRQ5BUIzF+V2PYc8pjKU5zNSVJM16nkyuIh78b2xgVW6jvYuEmEvPHXqdA7H5OPG5ZTPjPSZPJwWqJZNXLn90fj4b5MC04ZlIeWf0trrnqSxNpw6ebKhnG0EmYzUFLHJNwp8e9Q2eofq56amwGF82JJEk19by8gcEgMjSD9WbvHUt7mMjKhkkReM5vkYuVTCl/ClyD6L6IDpmHXVMZBvbmkmmxsystHud6alU2qKjEbWsjknQByf1gX2fAlaYrZqme77zsjijsWlnnaSZMsn4eEN9EOQkX4y4yijiE67GxfJZ3vKU61IvuKCj+1DA+lj2EDpu18eIVodOdg+NyEhTrlv497BdvJiZqOBWUQNuIjQckdEy5s6y1OSCiR/iedjwj5G8z4sJDjLSBBHhrW22e/bJ5OpF0QnUEdIG/rnBhWRtSH7ZPaDNig36ZG83elx4VKI5KnaPJD3PV+PkqIVJh/Wx0d0sM7REWcSzqDt41Ubo9cp/amzZBst4eF+VncRoSyFtabe7rnz4OxKeQj8EIkE7QHSaB1VVeuUCQmp6tQFG9XrZH4/USYS03yx8aKdmaXOPLute+WBbWnuqHcEVPElOxM0C9BWcvTWdYpVqy5TtWQ7hbZCkpGlla7q7pYHBh7OBfkSyTCpVJqVqlmnUWvQzCuVMuXeoCtXW0gOirO7Xx5IOQj6/DRkf0STKtu3ccHWf9YpFErFzqBPwvv0gRFw+3ezPBAG/rW1qHO3LlgXvTV61z/qdehScspnEQOefTY8vE//K1fZ/dO7Xx6Qgz8i98Q/J3ad2fvPiWjVOPr9I5p+9Hv2Wnj/PuGsD8Ept7ylG+WBULzMz9389fiBzMaIGVHR79lnP0Ej6FBEznO5he7ycWZevN6d8kBMHXHwcEwYa2vEzPDvSxdRH1xEpTco6oaBLh8kL3gLy/dMoIgEfu42aEH2FHX9OqVF+rbyiwKBo2fLAwNDRwT8+CxqAygi6nq/vhL6F5odVpU9Xh4XUQUqok/8tDf7Pdv3+hCwz+wV8piwmBmCHy3UzX4/3qSsJFmY2YvkcRtso27epCQDrl21GnqbPDDwG4q69c6zz77zGsj3Th565vZrl3g9mPvtwYEAAAAAAJD/ayOoqqqqKngSm4TY7fXpAAAAAElFTkSuQmCC"

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/IE1@2x.ffd6e716.png";

/***/ }),
/* 654 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 656 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/IE3@2x.584d8937.png";

/***/ }),
/* 658 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/IE4@2x.53fd53f1.png";

/***/ }),
/* 660 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 661 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 662 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 663 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/KN2.2cee9cb2.png";

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/KN2@2x.e19fd3a3.png";

/***/ }),
/* 666 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/KN3@2x.da76b946.png";

/***/ }),
/* 668 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/KN4@2x.93362739.png";

/***/ }),
/* 670 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL0AAACXCAMAAAB3PqpSAAAC9FBMVEVHcEwdFQ4kFw8eFQ8dFA5aTTNYQR8dFA4fFQ49KxRHNxVKNhctGQ84IRNAIBFTLBhWLhpPKRdLJhVGJRUnFAtRKxhLJxVPMRY2HA9QOBeghltHXVw6f4o8gIxAeoJVNCI/gYs9gYxQSkRDNCg9gIs9gYtKV1M9gYxFZ2g7S0hQQjU9gYpNRj5LUkxDbXE8gYxJdn5HXlvfspWIbVB9YFOenpTOrpPR0tHy8vL6+vrr7Ozw8PCrxMhunqbDurb///9rWT7j4+OLsLZGg4p7Xzt3c2xlYlyfm5J7bl6pwsZjY2OGd2NoZWG8tbJ0TjRkSC9cNR+xiluzjVuyjFqdgF1tXElhQCiAlZJnTSbYsovYsYuuiFexi1mWiWZUT0aohVS6l2auiVa5k2O+mGmEgW9IQD1MMh+0jl3UrYV1hnNnhXpsUinPqH/DnG9Zg4DFrInXsYrIoXbFn3PIpoFaioy6l2rXr4uqoom2k2eafEihgE2gf03UrYevlnfBnXKujV2afEihgE2ff0vKo3mqiVmggEyvili8lWaYi3OcfUqigU2gf0ybfUmmhFGwi1nRqoKKmYyxkGLWr4ihgU3YsYudfkqqhlOnhVO0kWLYsImyjFmsiFXYsYuxi1mjgk+jgk+xjFnCnnW4nH5jXFRXUk3Vr4iggE3YsYvMpnyokHG9mm6Od1Kae1WefkrAmmy3kWBzf2aklX+Qe19wZViBbU2/mWq/m29YV1GDXTlCPTl2WS9UQRx5ZUteVEdCQDt+VzVsUymUb0WMaEAiEAgbDAZtRClyVy2Mh3qiiWx6WjmbdkujhE+hfE6YeEbBnG/jyp3/6rn03rZrUymFaTm9mHRvViuMbj/XvY6TdEPTtIWAZDZpUidsUilVQhxSPxn67dt7YDRcRyF4XTFnUChUQRt+YzdWQh1TQBprUydbRx9SPxpsUihRPxlOPRZpUCZQPhhsUilPOxdqVSprUilRPhlOPBdPPBdmUCdOPRdsUyhPPBhbRR4/4eD0AAAA/HRSTlMAheL/8yAQxrA/YHD////B////////6Z//fxC+MPD//9T////AgP+h////cP///1tA/xCs5Vcv/v///tjz/5H/Yf///x7//////+D/8/////9w8P//////4Vl2Psj//08fn////////////+D/////k//////+QP///9Muuf////6r5P////////mDw////////871/////9WgsP/egP9k4P//////uPL//////+7//////////////////////////////////////3D//f////+A+P//9//5//rQ8f/A//n//+r/7/b/QPD/sP/AcP+gMDDA//CQ/9mQsFDfpZDmAAAO5klEQVR4AdTUBZIjQQxEUbVlhoaqNWOamX3/q607NAyBQ/lO8Ask+X5BRjUb5IRRvqAmYI6nzC/qs5KQCfSFjHApqeG8/Kwayp9fVub6gr5WESaqzP++SF2fz1RTll4LVbhEcZw45//pXd0V+eqds/xqvSFkmlbvfFVb9baQacd198A3hUyn+1wfstX3+oNh3ZkwjITLCBhbvQ/DcDLNUV09gMEwSS/eJ3U/wUiIzJDmzyfe1eM4rk+ABVd9ahmbFSyfqx7DOLUe4G4jLBYwg+16vdvDHITEFB/o52gW5jtEXx/v7fdAThgc8d5gOPjzg1uS1AEfWJ8wlb+tWbGF+YH5FpC/LHe+XG+frZzTHP+ZracsiaEgAMPD5x5bbdu2bdv2/qeGHS2gvpO8/8m5KPYL4niD0WQGFqvNzrTw4VUhrneYnL/MJiPlA/BfWC63k8Di8bKp+IjrfX6jmVDvtNjR1xO5AkHLf33I5DSH0dcTqSKBoNvs/PYedTpNHjbBG9Tj5ooF/HG32ZhIpi7iThPh50veJR96A+r4dCabCwUC/vwFKASLh437UbgoaTTlShlte7WWBXX2m6JxeXtxAc+7RK5WvEG8sFm4YB2BlgZn+1Mb0jvdbI8NFP3BBRUL96IBw1F2/L9LRQKZhFB/j3zRgFFnQh3s1QK5RCJJTM+P8C6aX7P5gs1oucK7aP6t1142o+AK66Ih2MzYzIoVbOEazdeiGZLqt2xmu30TWf1nO2cB3MaVBmAfU0G9lJmZaXgO42QmM0ln/iTj5O7UnJxUaitdsuo45xew3aziDdjS2X2OmnOrgK1GISmxHWZmhjIzM+P++7Ra/dpdr8+K90rfXZk+PX/73r8vMGQ0RkMI/ZtKG1SyMWO/VfbjiLuD/fiq6pp7S6wYfeP/I/gJcmRiLVAUYX+t2X4Sq6pik6dY2Y9zf5ecWsPkCKurj4KBX479R7yDm+3vZKyqgbEJfysx0Tja7YW/jzHGIw0NrGmaIR+TgsL+akt7VhVnjN1/ZkkBo6a76j7svwDT6hivkpjKxGYQyLIkC/srzfb/mshYE/79Us0/C5/+B9yUf1B7WqP1nCeYRkLLpzwGsmRvD81NLJFgTGY1k2fQ8HnJkOlDb3QnmpmQhceYQM0fu+lX2ndWJ/YA8TqWqJKZyoT83fNGPrTxRtei0eGyupxZmprDs1taW8Zn7a+1tIdogjUkGWM1NeyhvPz5nNHuRSPwK1zSllOQSPVubW2dS+wJoNGc4ExQM8Wwf8DNaBBfQOZhsZwa8xLz5y+Yny3nmsut7RGe+3otvF0vZ7qr0WDlaeCSWM6JuPQVmP80KbvfX9qJPdTXsSw4PNzYOI6P6hHfUUNpNAayBGgvmNaUyC7oPGF/7Q2d2UNtgmVRh4fGoSU9Yj+k8UYajYESBMMed88KplEp7M+1WXtFCSlc/3oJKhpLesR+2JxbLaNBYhliDxBMiLXPTmnY/V8s117mgOBph8SDTRNu7wn76dNJNAoYhENQYC+L5YzwRTlp+o74FxBkkrmvF9oHcXjoiad2zhASjQw5/Cmg9sZyJtl83fou836PJDOQpXYia9CK4/PuPcbNDxnKh2nuY6KANIzss7itpb1jAS69EOAhIOByYkCLztUW+050NtvHlvgh5y8xhC9ldHgo/q1vDtcGYdwHVffFfUaOXLxM5WpV36dPCnIaKLWYT93yC69VddH+LrN9KlQOOiElXifs6fBQPI2q/ZTJDEks7tOnT1KVV1kxQtUX8CDIMhSAw8NKz+kXLVq0COdivDsWHUEWnxIGHUWcdjxYVc0Ym3rmMXxo+aj7maCjtO/w4clSlPeuMPTxrJVDQMHhYaXnuFWMsX6L7lTvBa8Qj/FwyJJBe/r14qmmqioyPBTNOK4kFbEtr/Z618xNrr1QtV+7YsWK1bo9bkOyAoVE13lOXs80Nnh6HfcPBGI+vRYpBQVwCV+8jOGheG6XOPgCGQwB7ce387Vr11594Qhhv3F5MwBHIX/KD4Us92zayDQ2eo7vZXxUQTJosk+rw0NVBB+ZY3LzMOzvoNpDeRBDUO3b+nqTV189QgPtoX7wchDN+zMW9punNWXtT7+jucBeDpjsFTX/JqlJDA8PFfvK/SCAZg9SCJ+rjjVzvd7khRd6L2xH/Q6huAXy8PuJ/cmAsxjaHzeYJWpxo8zZh5M+oKTE7JxggslTiopmJuj2/hha1batUe0H9W5pmXvhiKvngxVyeZ59r+O12RntT97KtJuHtB+ySNy00erDnj67dTt/jAZy9qBI+Bk6vF4vb5vd2jq+Ffd7K2KQb39HdnZW7RmCNw+GPQT11Z/bZ1vLoLzTri6rz6YO6240+fYgZ7OuT3a0b2+d3cEYXkGZSebbnzAYBBs8m5lgYnPev9gfBI1+24ar29ggctoZs3M3o0EUWdj7JX1xEywSTzGkPmprnylH+9N3gGCn5zimk4gay1IeAmSQ90J1G1vTtqaDnHZITc3kXd2JBvEF00kOFJwiIwzB4cHGXsEn8DbD/vfHG8tZF8/Zg+wHldXtF44YceG23q0X0mFPgBdv3YgGfAEfBLntcyVCoPiy9jEAdZvMlYNPQP7NA0A6qG0H5dh5ZGDb6tWrvaVeI568V+X/ZXiYcl+zvvX58ami9vS5QhKW+Wc47LzNg3uORn/VniznxHB5/r84FAKIr2mfHwEDmv+ULgW/UC8zDSDjQoa5ZgMF5IVQDxbwjR6P56TNoLFbHRTocs6rrg8HIMeSJUAw5V9Xt3CGY/BTjTJDoKS1BpLYA/cBhYRQmL8v5eODPSqbN2ryt6m/Rz51pEH9Be0doTcPnXLTHqPMvbkI8CNwP1BECE0R6/yVIO+vyp+C9pq8OvHkf+oEU6nG/Okzs3ff/v0H9mXAIn/n4eHg+kM1LAvdzo1Gaf4NCbIP6qw7jPanbBog5FVOPg9y2D00qVjbgPH79+/fZ97knIcHtF9/5ChDyHZO7Cl7Z5F9UDCtv2enan/SySiP/avgBzEvJ/1mi9j+h+fu26fq7+3G8ID2KisfYQjdzhWwZkmQ7IMCddn78/4nbFpuyB93vPVykocmsP/AyP1tHfv3PwqFhI2v11R7e43H9pi3czuS+g1swqhtd6+T7+ADB/THhDzIKScP7sKZ4Q/guo8cuX//w5AjkwIkpF+81R193N5ecOQQo2Xaw6W0CKF6aV5tG/rzw0FJX/lemwfYnBnkoVH4gf2CMORQOCDh7OO+54knn3KwV9lq5FPfub2sh5AitXHJHyuH5sHHnXzyJkOeUpsgD43C73n66f37cOmJvQF75tknVznaI8/toWXawBU9hCQJgUuQCeA2u2PHDjDhk0xnRnMG58F9j8KjYbC2r3/+ySdXvfCCs73Inznn78sdBNEk2QdVeyhPgQ1yJhMumMWaYikO0WqgGLMtvPgSur/wsq39K3cTfdw9SZlmixQHnWReCPWaPaQUMBNSAII4XRr3mIi8sYJHwZadrz65apXq/vJr1J6u/hOGPM0/DmbSMnCbfVCz98fADA7PyTCEFTIyNUSWL+V1do3GRTQoj/a2/OJ1tLbM35SPP0iOMRICr8C/PZ0GM1y7RAml80emPZXLWQU3/0dINOj+2hsme5rP4+tp/jbDA86gxJ6EwCu12mQwE1CAi6FYJ7pxwU7GKrl5iybRoPsbb7xZ0jlvkXzshgfwhYHYGyHMkyTVHmvzg5lgqNB+y5Z0NMEivDJChwex0xD3t992/IkBfvkO0bceHiAkdswMwPbtRE+qVE1obcQ+TO13D94gHhqO94B0iybRoPub75Y489771P8Zu+GBp1O+ftu2TaLfohKPcFIbQZZxvghLuTLyvhF0Xpz8RzAaw/2Dtz/8bUnX+CPZPW2HBw5wT0vv3n0joKNg635OaiOEgxAA8GUsZqb6uipjizZH89EvS7rKLw+uJ2w9ajU8JAEWbG8pLe2bk5EB4YVTZCZt2MuBULnYMQl+gNp47j+SeFG4o/wbpmic+QXm4zA87FXt29tV+6X0JjODw0NTXm1hnrPnmrmSBgo9M2qeIcF3PRp6+DoOD6svXNtSur0NzKQqjbO6PKBfEQXMr5nmM+PosyR452icD1+av97zmhVrW0tnt1nuLsbw0BDUr4iSHDonmtjzMQ3eORq7fMjuaTU8LFhx9bLS2QMt7Y3hIS5rtcXSEHCyfwR3GiN452icD1/74SEaX902MAbW5xJ5iarFfdLJHnea4qOhh6/T8BAGCzJ+Y3jQqI6Bg33ziwXunxT/E7/88tP1DsMDwfbiTY7HzfY0Ghr8hzgXFI3p8CXDgyMZ0PKJVGBtaO8cDbq/fVqR0ZDD1354cEBJazcPMkNi3L1o7A9f4+LN8eZBCeM+GI8wJMgbfO5FQ19dnIcHMz5FAr8P8xf21VWSORrifiyjsT98n3ukKzcPoVQwLfn1O4QYZ6xyVrN9NG8f42jsD9+uXbwlAynjBnZWkuG36CeiedGQ4I99NPTVxX54oCjZQlLcZ4wBS9FeneSxNstoPvtFj8nTw9fp5iFGvtlUsDellVaBtWE0dA7GaHqYPz7RxZuHpNmeDg+maNz42aXo4WseHmztyQ0sDsLEvYejoYev4/CA9tWTtm0n9sYNrDoIC3cajSt8frdl/mR4KAdoGz68dRYHE817nqHBuxENOXxt8ie7Z3tpe+ths/3u51e5H4358HUYHhaUlra0mMrBncb9aBwP3yOFw0Nf9Y19+z0cCEdfou5vuxeNw6vLSjI8RPuW9tu+YnzSNhp0f9P1aOjhaz88DGwb7x1UESDR0OA/+dx9Z5JP4e6Zl380BACZYCfROA+Tbh++dHig0RB396NxOHzthwcSzdvuR9P1e0Ny8VabjYYG3/Vo3D98yexcH/1WRkM5aJ//i3QsePvDIqJx4fAl+e95jkRT3AWZC68uZHY+9CRx7+6tqvuHLw4PH5Pgi7pVdf/wLSPBFx+Nu68uZd+NaGwO37LvQDT294Zl341obA7fMnT/jkRjfnUpw+B74ILMncO37G16q/rdAb/RrqwHXlvdO3zLMJrvLG9hND9QfuRHfuRHfuRHvgFb8worZ0FoWAAAAABJRU5ErkJggg=="

/***/ }),
/* 671 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV1@3x.fd9139c6.png";

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV1@4x.91dc9fc6.png";

/***/ }),
/* 674 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV2@2x.30e5a0a0.png";

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV2@3x.c06453c1.png";

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV2@4x.1e63798f.png";

/***/ }),
/* 678 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 679 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV3@3x.b7a5a09f.png";

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV3@4x.28c6ba03.png";

/***/ }),
/* 682 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV4@2x.44bff83f.png";

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV4@3x.3617ef02.png";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV4@4x.6a2b7a31.png";

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV5@2x.eaf6f9a6.png";

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV5@3x.b1b6b989.png";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LV5@4x.e73b6897.png";

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC1@2x.297f8e47.png";

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC2@2x.e2a7d362.png";

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC3@2x.27b5e91d.png";

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC4.1db73657.png";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC4@2x.ebf05798.png";

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/MC5@2x.e74ece70.png";

/***/ }),
/* 700 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 701 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 702 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OH2@2x.8905a67a.png";

/***/ }),
/* 704 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OH3@2x.2b672d28.png";

/***/ }),
/* 706 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OH4@2x.79f3898e.png";

/***/ }),
/* 708 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OT1@2x.d9e08f58.png";

/***/ }),
/* 710 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OT2@2x.3e79e214.png";

/***/ }),
/* 712 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OT3@2x.a425add7.png";

/***/ }),
/* 714 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL4AAACKCAMAAAAjQQAUAAADAFBMVEVHcEzewFvKpkr03XLLp0q4ws3QrU/JpEjTq1LGpU7LpkrjxmDs0Wjqzmbau1nZuFbdvlrTsVLSr1DQrU/13XDmyWLMqEvNqU7Sr1DJzM7lyGH022/evlvv1GrMqEtxW13x12z54XLSsFHw1WvWtVQRDgvVs1PqzmbKztDHys/LpknixF7u02nYt1bWtlzNqEzLp0rlyGLc0JP23HbjxWAfHRvLp0r64nTNy8XMzMnjxV/Oq0354XP23XD54XPIpkvauVj75XZ4YmN5Y2bdvVrSyKXev1z33nH643QmJyTozWktKSN4ZWfy2W5sZ23fv1zOr14RDw313G/Ly8vRrk9hTk9jUUnAxszXtlX0229ENDT95XbSsFHfv1v03G8iISD1337MzMx+bGTz2m5+Z2J3aG3BplnpzWXq0GbPw6gbGxkZHB2XkIDrz2cwOUGLfmL44nPMzMfMy8jJyMhyYWKCbm2wrKdJSUbjxV/QrU01NjbOv5QzLBt7Z2nNzMl8ZmnMy8jMzMfvxJ/ay5N7b27ixmCHb2fUvnh4Z1A+REoGBQK5l07uvZSLc2mUn6ozNjYAAAAAAADMzMzIo0hTO0DMqEzPrE54YmTJpEnLp0vy2G3lyGLOq0354XPfwFz022/95XbLpkqBbG/nymMYFRHhwl3v1WvkxmDozGXZuFfs0WjcvVr75Hb23XDRr1Dr0GfqzmbWtVXWtFT433LTsVLSsFHUslPx12z/6Xnz2m4iHyH+6HjXt1XQrU/evlrKpUnixF/643XZuVfYt1bu02kQDgvbu1nMyLzKsHDNy8Xaulj953jQzMDLwqvq6urcyYbLupLMuYray5dtWEPUwYvQvo/QyLDYvWne0ZvWz7LQtm+zlUo9NyrLvpzZwXbe06mniknY0rjruZCZfEfUxZfcxGXNx7XKs3vRslno26AaGRhYSyuJbjnnznPk0YZLQCsAAADq5dXMvZTSunjGsl5xZkL33n7x3ovr3sVcREljSULWvI/AnUbr4bqvlyDEqSJxlyT4AAAAknRSTlMA8vAQQGHuwBAf9urs9/fr6ur3L/f56lXeD/HvPfKS7Pkfzvf2wPDAQiDh8+BfhYKfHy9f+tLN48L23bA/ge9vcPT15b/+sdCgyID9MlShl/7mkoDC+OtSpbsQwnxJbZL6YFbp/nD+orfr3jv8zeT9+qbocNz4+/7F/GbfpLjogJTZ/MjFfM/i/bPt69aCdVRkH5Fupm4AAA/bSURBVHja7dsJVBP3vgfwsIUtrAJSEKpIUVncq3XXumu11mdtrV1O6+2+t6/bbe9979393rcnTjpJJkPSyWRCQvaNhCQkIYkCghcXKOJal1p3a2377mnfe/+ZrERywXOIIefke45wCHLO5//P7/fPzP+f0EaVhb+nxXPy1NWT4pj/JAeSLZ4Tt/wJVoTjFL8St/5qvRWyqtqfjtfqsRgUbAhBklPjkj9J1qTWKRBOm3BdXPrn2zztGp0VUTTG5RI0zY7bOi0GPZvIjUf+FoywozInaAFbZTz6VRKMwFFPk1rNyYzH6nEpJTwCBy3AropD/rNc8XfnJTyyghRx2L0p2sbzm8+qyBZQV9PiL+v58tvm69+RLdD0chxWT2vzebP5MtkCuG1O/FUPVyC4bTafF7tUGL6YFnfJVjZeNZv/dPPnH6QSYkvc8WeiPNdt8+abPT3fuCSquONnqj34ObP57Z6bPd8YlfF38V9isPx423z85u03en4wcqfQQBp2TIwb/iy24ucDZvN18/Wem1ruHhpt6ZsyAzt9QrzcMkLIoZ7DZpADPT/wtcs2aDHAh9oqM0b390szYutP5mzrAdNP1v/PXY4ugY8PJ68YzcK7YVVSQ0z5s2HhGWr6j/f8aOrqEvv5LFZt6oj6ehMjCU+NafXA8LYeJtCbu3sIqVxi8vNBZo/0x+LiYk1BemYs/SwWfKTn7TcOmA//2IljKnsIP32kvy3NFydZs0pmZsSQD/ynenp6Dm8+pbPI7B7e6PmZFVlZOcZsQ01pQwz5ILdugv49y1YY2mWGu5j9jEez02vkxUme/I8nxJAPcuzY5cunIbZeY7GNng8y49VjEnVxHZH9ckos9BksXwavm48LIcSqR9Sj59/3D0zmmVv9djsDy2Esu9f0J8tcMsTvB6vnT0IOOYBR859fxAT5a/+2k5iUYSzfs+We6quchKcd9Qh9/uPmszAMBgDpRsef/i8kft/+vzKZ5/ZfFU+u4C/ffQ/vearYTkLRjhI8DUzxf9p8mAXDbUIOjIyCP+MhJjX1+/eR3w5cOybWVhSZGI/eq0V0nprtdAI+T6m06yn/6ePgCxgAxzoSHxT9Iv/U+3Lm+5MSnEHk5q28R/fpgA+RfKmJK7FRLXAF/CMHAEMj8J//dWDq/enYf+qkq9OebaCXpt4Lfoua7RF6+XytVOJsY/kzEn/6Q8ywqQfp7Wb+cb1RYijOhUrSM7dHsQmmpPj4Mj/fwZNIeRpWIDpPZP597zKDUx/MfiZzJm3eZCPRlKOB6RVYtI495rxSXLGJ4rc3BfiEBRcrCYWfz3FpIvFB0QenPpgTJ5hMUDQpy7hyVJCryKoujE4PL1Nidltn7kradrU4lM/WS10qFPH7NUjbcPwnfh0+9cHJv+B9ardXJhu5uW0lC6LQAluWt2iNSh4ua8p7ZrFpCJ8jxLkuSZPQV/8cXXttxp2L5bBTD+i9TOargXObArp8arWwbKzrZ069lt/c1aIVqwhc1p5tHMqHWTo514X5W4Dd5EKXZIQW/T8zg1Mflq/BI59O8f3vCQsNWUmC5er8uWOqXyfmNsq1DkGrQO6SEKjH2R7GZwm5cqOUYHv9BlyqxUoDl5LvL4o09eCxr8n6YSz218vK7bOSy1uWj+XGXWqpjKc0+gbQ3OjC7KgTCuO3IXhjo1hp41D+donY4SBKGqjF8r2IU0+tmuDLsU76guCzlbFp5q76R8cKn7lDr3bKcJ7KxZVr+WAADm4O6GHDED6CcGAdZjK5VBaY9NuMLkGr0bCgYe5DzMhTTzUuCN2UJMyPyjlBRiXEpvgEBvyNctACgha5C/SwRxbgQxYd4MOQDTOCFtCTfgvf1dpsylZcPOplfhuc+vBVk3lhfUlNUU40NnobalihfLlWIJBrm7sE8zHQwzaVl68hOik+q62TJwEDsCPA3+lAm01SnkfTvxZM/bFvATPS5K+lpWZW5RQtGGv80vWEJpzfwsXsPHGzCeVJCFxJ8nmNPC8foHGJRGk0SmVgEfXY1WIpBhZaz8kjx/YNr+/uJb9+GqVLhPXGYflou87aJJk8f74dx/g8sSDI1zhAXbnEXKMEtIDegEhIvlpmP9gRYfKpx38btUvjukh8iKOTT2WU2ewqbQjfJHDwjWIx1yTn8vQsISJEAV+jUxOSQ4A57KoJsilafNC5EfltMO4oKqogVI4AH2/pAn7tHsDX8uV2CG5jNZF8BbtTeXXgTv7XF6hvz0RxsyEzPSIfRozvCJT5mNHHZ3O1Xn9ROfUSIbeBJ0RH8RE2j/vDmTB9x37qW19+4Uxa9JJaGoEPcGhzEaor4Nkovl3q98vLiwC/2aQywCwNxQfFJtZ+0xG+apJZW5dcENXNnpVr1qz5eNq0abt27d69e9e0NWt27Ej3ZQejPA8RFtgA30BgQb9pjwPwpZjN0+TjC9tk2q5T4asmyNG6usK82TE8qUiGWcmfQDJ0iJ+7xwH4uCzIhzmqxqt9wVXT9zL8x2p6zir6M7HzZ84GS351U7h/akUYH4atOH5yX3DVpDIzk/Zk/cIyWgyTmg4Z1Hf4jRWSMD6LZbVpejuCqybIuDhpLNQP53cx0FA+CEuPGC5+673Qp9I9HvhVbOvwfle2Jchvt8Lk/aQFvdgNVk1vXo09fsZD+5GI/pxcH5+NtbO8gYRt0Anf4v/pvNjaqd1iZve2iH5ltobkGzohmOWPEGZ93eHt4OyFGbHUP7/IO429ioh+VTbbxoFgOISPitkwtXLmIvmVscODjTNvDhw8eCuyX5IEtYXwdSou39FuhbqZHQXK7ML6lBgV/btB/AFQQcci+8sKA3yokyfl8gU8i0HWf66+IH/V/A2xKfpFIXgqJy5G9GP5Vi8fsaA+PpujUc2lpb5ZvycGZ7xPvOfDHwF4fzqORvYTeRwWRyFUhPBhljM27+OY6984O3Jk39CbkFuR/XV1kzvD+Cz4Dy8+cs/r5l3/ZAN8eLr7I/qVOkMtfQh/8Beff/756q0vZN5D/fuLIuKpnOsc3u8Cm+uIgVDVM3z8fwV4Kqsf/qd7tli+58P3Avzw6TgynF8paBHrrWyI4HOdTdn5luS3ffiHyS//+EKUvFvm3Llb3NEbGU+1wMk7/fIWE6HTKaxgT92JgLI/vPN+0g2eAW9+FY0mSNmwMOn3wd1iHx5sm42QtefD/NwWMW7lWDRgAIgC8OHDe/fu/Z/7wdQHsvWpMd/uqecykpJSg1cIFL6bOYqc44X6TXylB+KwLU6LQa9gI5+A2d9LZWeI/+EXx9qvLC7W0RdkBs6TO87dGhEfeDEO8csxCwuyGppQmVNtAC2AsCk+9QyEDGD1GFdQaZ4rqRChr1v+Wwp/6GDfKNwDp74BOXWm76DfL7frYEShcdpwO+ppogbA+tteXx4PqaCHt46lPnNhIb2Om62p7kQvXuj48trA33V3DJz6EuTUQEegBa5Sfj6OCBG9uhO1YxKenfr0C5vDGdzrz07/AFZ/8cWYzn/G09OWlOQYsz0o3n5+IKK7b+25QyADB+74zZekX9nGYessHpTAlC6XhCA//YJAEAc6GxjA/V48yB/G/F52SYGxYj6BYcSdu5Xda48ePXrkXN+ByKV0TcuHybKX4YREajx/9vRpMAC1lboLQ0AH+FvgF1948+LYbyYsyGtkSKQusXgg4D7R29t79Gjfhcil1A3SC3LsIpsseztP4jLKX7p+5Wy/lCDLHyEH8FKgBe738T+IwiXExORiOUPcKOd/PzDw5aFzR4523+E+AwJq/9DBkydP9ueWVs6aNashNTUVYDImLilA7dROo+Pq2a+++l5uJ8tfYaUq6HS4/1fR2G+elWw0VYDjIV6/71C2r6+PLPiD164dvDbZWLRr2bJ5S5cuLZfZWVl5U5Xc6vWbhu42fuwyaZtbxF+RfMyOUgNgkwMQXgnzvxCd/eYC+dQirhS1bivsTELL1q18ZtKkSdTQluRNxpRJy58lT2U6sawVmQvAxbE4pzL8yKBe6+oH/JfkYhXP++k17wB+Ohzq/2D1U9HZTyvJlzMImdOaVZU31YPnZDUE3pdaVVeEm4omkmNZmUkWW2nxO6ilihaWFz46/uNvHt8sbZZTh9zka7C3hwf/Fjr/0boAXZGco83W6K3Ckqpik0pSnBn8TWlOsV39cXCmk2sac4jwI1qR6NKHH30kGkRbHSZyBZU1BXr4bKj/kagduZQYi5IQhD37zRqpTKYOHi5sTy4wTa7YEmz2V3YkNRcPvY/9pQj4j5tF11F7VwufK8UINNjDLKoFHqf4v4vejuaCAm1FLkxnYJ/UiN/Jmxv0blpSsaoidNWblLphDS00z4lEV/7PfEkkOt/cKOa3ao3KIT2MDB72+/89WnzgLElyJGmyagobqsrfYQw5TZ307N89IH9QJLr8vyKQnc0OiQzXCsJ7GFKf9vo/mBjNQ4mSHHluW3JJKi1lJW30AXx/ViyUyAxsZyM1gNAehoWDfwL6lyY3RNE/oZZunJqvKLvLczWR6DWRCNTOA6LPUjYBPqfNIHc0hvWwEN62n4NzVbOjyN/toec1r8rNn3t3/Mc2ikj/6yLzI7Q5SwAfZiEqOddF9jB5CCzjeawKu2lVIeBDpbTopeHZFbVTW1Ytvjv+A4APQvvdh+9Tl1LUWz8hngTr1LA1Vg9mFEigJszU3F7AVSGF86N66AXefLPhzSfviv/gJS//qen+1xEWyHfmy4Msu4Hkd0m9fA59j0Ihm/80bTzljTdEVF4PeR2h+Gbz5UaKL/DzWWWAj01dN574H77qnf3ANc1/b9x82sDqv26+/F1uKT1YPICvIWpkmGnVtJTxw/+33+y8dMntdgceeOzGjRunGxYOnr64DDBn1RkFmJ+vVxmzMVNr0uIp44Z/37yNbrcohP8X9ZUbx2kplet8e2Ezywk/H1GZuopNrSg7exx9Gu85t/sx9wOBHx8YdN4QhR3TV/tmH/CJpuUoGy5pGE/8B92vBX586i/uG5+FXxTmk3wDTvL1SB4bZmVVjhf+L93uje7HaMH81+vDfLQoxwOpvXwOnJVVgJQtyBwf/P90u18DxTNCpkyrKUR9/LZCBsdJXzdOZl8EigfwRxzAhrwCJcXPg9Q17fb87eOCDypnVHzyXfE19Go9R4eDOuKViRnzxgMf2KmVZ1QDeNmQlVyOU21Q3rx8wvjgu93PjXp//mW9oqa2Glc1tubMz8uMNz4YwBpwFIDkM1rtOnptRsxfdl9zfwauz16/m0PYR5ek17I4hbVZWbWxxc94Is3s/vPWt8zmu9+GTU1dUZk+O6ZTn5aWttm9MS3tP7amTafFWyj+W5feSiPzBC3+MiMtbavZTOnvo8VjZsz981vTp8+dQUskkUQSSSSRRBJJJJFEEkkkkUQSSSSRRBIZ0/w/9YaaXglT+TQAAAAASUVORK5CYII="

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OT4@2x.0f907c6e.png";

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW1.06df1870.png";

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW1@2x.e4a4a16b.png";

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW3.55d89b09.png";

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW3@2x.14da0418.png";

/***/ }),
/* 722 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW4@2x.4c768ae4.png";

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW5.0545646c.png";

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/OW5@2x.8f583379.png";

/***/ }),
/* 726 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VR1@2x.75e40bb8.png";

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VR2@2x.e99b6924.png";

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VR3@2x.9ed73ae0.png";

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/VR5@2x.ed547006.png";

/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI1.6db28f05.png";

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI1@2x.e78aedbe.png";

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAL4AAACLCAMAAADoHdOxAAAC8VBMVEVHcExOPz7RP0XPP0TRP0XRP0Xdxrbi1crUWl3i1crj08mgmpI0NTUlKCqxO0DnwJ8eHyAqKSgoKSo/PDp3Z1vSvrLi0MFYTUJ6STTORUrj1csbEAeFbFDvwpvbyLnZf37dvqjk1Mng29svMjNaQzDSq4cQEBADAwMAAAACAgLj4uHl2tHg08sAAAAMDAuMdVfBmn2xlXnTsY3v5d3w6ebZ19ZBOToWFhcfICAvLCl/cWLu0LLl1cbbza5sWELe8fvy7+3py6rg7/QYGRsQEBEHBga1tans4NZMTEsiJScXGRzJ293RPkUpJyYcHR1MLBKOgHDd3t7qxaLwx5zqxp7QP0TVwLHxyJ67lXbw2sR5X0RZMhRyWDmejXxCQkI/Pz9LVWB2lqDEuKjsx5ngu5J+sbuDtL2QyNG33uXl2M3tyJb854DoxZqVzt/ovZZRLhLc1tP754H854G2kmzowprxwaOKv8vN6PDFo3imglj754Ly6qqYuLPTuaPlzLDr7cnc3uDe5+20tLOu1d/V0tCgxcyvnouiflWKi4bm797s6LDUy66tiGDGyb/pxJnz55fGp423ubnqxpulh2TWwrbVv7How5mSb0e0zszerX6hpJ/Frp7Rr4Xlwpmov79+pKuQydqtiW+ff1y5k2vbuI/hs4im5PRhWEuxjmSee1G8m3Sb1ufj5eWbeE/Ipn1qgo2g3e2ce1aohlzcy3hubm5zZla5knXg2dSXdVG7mnB8e3qxsrTCoISTc1BUb3hFRUW+nXKPcFCTd1ljZGVXV1drampnZ2peXl+enp+0tbSvlGcBAQGWyNZRUVE/Pj08PDyClJtWVldLTU66mXHBoHVTUlKXdEpXV1dXV1dTXXCmjHN2b3KKaUG1k25BSlpUVVdTVFdWV1iuvMELCgo9P0H//v75+fm6mW8/Pz8/Pz9QVFqgfFJKS01XV1iwsbQ9P0NVVligfVWjflWxsbSxsbOVdlPd3d1XZXGihWUJCQkKCgrwUd1oAAAA+3RSTlMAEHw4/8EQoPlo8f////+QUb3h4O////7/9v/////////CPKL//zCGwabt/4D////////+/+Ag////////IP//7///YP//////dkD/4PLF/////8A2oP//2f////////////97///////QX8D/////sZv/gb3W//z///Dp/P9P+8Bw5v//////////////4f7//6D/69Ly///////t/////13z/+7///7///n////3//////z///+Q//////////////b////+/+g/8fLd//frufFwvv+Q/8BA/5PK/zzv4WGpntpA/u+Az38v+E+Av8HR3+9cgeuA67jv5+Q4eNAAABLZSURBVHgB1Nh1Y9tGH8DxgBp2WW6rVA6jqqSP7dBjuRc7UK5nBVymgLMssIYZy4zeyszM3Ne2I6nyDf5y6FvGfHT5+XRWWCgLj4gMm8NFcPPmMn8ex81x/tydnqjomDnMj42LTzDNXxA19+QLFy1espQ3xy9bvkKIi51r+kWJqJWixZyULAhCSuqc0qchfHqGKGYItOg5MkGZWdk5mQSPypWoP27V7Kdny6S8xPzV/7Mivs2uX0DBLJ+gwhxNX1RcYjL9H+odNrvdlkv4ipDinM2bjUY3mUzFxWvQ4isA2GGlkkBbNXtfAtkavSivhAy/CwDgRn59gmbrJlpYlmZC9PIKGZWISq8EMDtpLeHPwk0U0hebTIuLMJ1Ugf3rAFl+0lpmEy2MnC30ResXhm+QDaUn4jaS5afZ9AnCn4BNXOHM0zcvWr8B/yrLyC8h/HiA/Xpr0QWYLfwC+PcjOS5iZulb0soKmY2HVOQh/F8w37vWcAGChed5taoa8Wtmjo7mhd15tCpW0+FZ5sb+WotN9ws84vt8C7Zy3LwZodN5YdP1KzPEEsq3k+WvVbcRPL/ds2PHzl2qz6Ekc1xM1HTTF6eVZf7Lm/LN5XTtRdG6OyGhJGHP3n0bAc4ClxtdwH4P1MOWWwQB8pOm7y6wIW3xojR2XoKqq1+j8SsbSI3+Jsx3Ky54gFi7dgfmw/IFQUhKMgvCr6nTxGfnha35t+qqjDUVcsl2saWR6hv9rQDnTc7IaFN3eTzthL/9513g99lwEIo60NHhDGuuq+vs6q4keliP399L+H0Z1oyWnR5t9fuNd4EZPwg5Dwx0DAzm0kEY0vSNPU2AlpGRMSyl63wrvQuQCkZmVA9XHjYKwNg4vIKoCU0/CfRWW82SGerJ9CwXD+rnCHKUrp45fR20Ez/M3Qu/SUh/qBfoeTOGFemwzj+iHq302lHSzL+bHOigDQ4ewx3vONFE7SR3rSJJUr7OP5l89OhRiRyEZvwo3fG3jrtBUGTS03V+H+IfZE6iynS8m2SGNKo6LIrFDxwDwZ0i99x2Dwrz9+t840tA30TDpwg/crqly3gBzfDXI2cY/mgwvrfVf8K3Fio9Ov/swXM6X58gHH4eETk1Z1FnVwvqvFP7TJBfj/4nf6MfdsLnsBn4F4YPHow/aBf+dgEXL4XBargVocdHLWihBerwr8/TX65l+INGvaIO9fhJhI+G/4+zFii211okgj8HZyleQGfpS/SxdMjHpy7Q8rPTI4ZfK8eZ2Xf/HJw/L19WG4m/R+en559NRupanhylr5hw667yfHJ3dZhzRcgfS1efbgnu2vUWLdcxdvk1f5P/xuXLl62NzOrfvNV0EPNra/lkh/2gSesqn+zzpQgxHHc7xEPP4Pvv3L2n/8rNvnjPQL/bPYnM2+7DCxjePzQ01OPRhr+h9cGDXsKvhd6HJj0+2aUIiB/CZ4pRdQz+3qPHj+/09z+pp7/2ujvYzhzvGMKLvrF022VYm88Xr/N7nj548OAZ4qttbaJYYuCb0UFomEsK3UGoORCMDzx5DoP8/pMvyAQpAI0PWwPmvzz1rFS9DPOp6Rrf/wrymyBfFUXxugvzi/B3wy7jQcgZgqFn5+bF6+ca/82bR3iCXACMdrC9hcdl2E05wVtqq4f++4fe7aCr3/oAL38y1Le5hPflUC5DfPmeD46gu8DHqBDz7x35BHv+6fmdI9h/8nMADf8/+W+SDSdPzvviLV0LXwKVt2413Lx5s+HWK8zv3WiBelGR9lfI5eVyeZ5c/KHeEfKDELyz0q4HTkI78d85Qv0nXwRavACA4yz/CuEXy7Jc/PVZqeOy9RbtFfG3+lXRhc5yD2UU1H/zOeyS8RwRineTUXUBOvTfv3+nfsQ/QviPHl0zAxi7/bx/2dOw70cRof3FmhnHtFnmcfzln/2zkjMxg2RhZHESveEDADvadoyMHEhzSy4UL+A1ox2EO/3DLZeYOPijiTcLJbEzcFxS3GS66+la2SuuFlwHW4t9aE+10zJWVq0ypjsdDgH1PP+83/M879unb99eDIVPTLT1n8/z9Pv83u/7EBw2HR7rl/XfOE7SP97f0lLbAvq7dQjQT1XVgP7gGVPWneKhbRmcr1y+yiD2V/9xielT/xDYq+JTiTgVhdqdpgNHJH0YPNSfetYSfz1qfriqqqqH6A8ODmcl6LGtJ+ifI7Ozs+Aur+C9S9Sf6XvsoF+epR/i9lZ/WIc00yauz+IDRQiAH8Bh9oD9TNFBqn+G6m/j2yTEZ+xN8OcrAH3wl7d/F+g/nj16mhGjEPsBCMjgcVkfkkP8n24kVfqi6YgTmKqyFRXZuT5PUP3uLQ1RqMmEnpFZCtMXwV/a/kAPmT2D3Jwhxb4J4znQxwjNvcD1G09T/yNPHyFfeoh9z549pfYDj3P9rQ9R5egsuzTLAP3LohQfTw38nzbTRfxOln4xtdeGI9gY9vujCP1LOruQ+9GeDuoPMSLfDDid7irbnhMnoMrZz5w5UKtaQNHf8wkQq8WcN6/OMt67yvx97MkLWINZ/hoWe9h4YzAa0SN0iuufhh7B/GmgnjozsPPca+d27aVN1H6gvr0881aadun38wpOVmUY+0DSh/ML+m7We4AZq9XqybQfMZKt9zP9YFCLPnzsI6YP0kdeBl58YXR8/DXO8bdPF1Fh0G8v5dfq8HHXrvb3t/iWAvAjUDkL/iNl/OtWK3Chl59cK8Z+RjQWBHSPHpIs3wBaxkiP6Gh8sZ/bw5mwM9+9M0O2djqX+K36S3/YnroMtQd2f3b2Ui/LDeMC0b9unXyHyVdarTjC7CMYBwkffyKfXMB0mFbpno4X+e6T7+lmwxAdGmpv6/ij8o8Cf9uxLS8rMESvVs5WQ244NVaZ4skPSi5YLVZrjCZnLmrUUX0g2vXcq68y/WtnLkpVWql/Eg7rUBVwtr2xg16rc/0OeEvNc/CPZSWouoZ/YNlRYYyS4MTnUTOEXybqh5MLdCHtMKvS/Tz6dPtbwH5qaFfp7vJ6WEBji6Rva+sAnsgzQTcUumM1zl7F54UH1fpBHI7imwUCQsZ4Wt+Imf44TCVMq3S3rA9PMuDpN86BflVpOaGoo81WWkv0h8o6GL/akZd+qJeHpae3ty/h5AuyVTuuq/UtGC/WCQLoWyMZ+s9R/QkENF8x7a/nRXR8nD0HhmaKymUO7rXZiurPVs2c6JCAa4J89EOhsjEmX9YL+qIoSlOzZsAw4LDmIHZLIDysN0Stetkf65PXrh3TIYYGqvSosogeH5WKEGN341nbDJS5DJ44lIc+sFAz9sxY2cLCQu+CTxS9XscCLKbTMDk5MJtL3ygQPp0qa8Uabcwq62cUUY0W+e28iL7Ni1DGArrP1uzJtM/nCN8QRQ8soJfIg36vzws4HNXVrQaDobVT0ldGKCgQPksmk7hYG54rpPqxIGI0NelgNGlQxWBaX/JvgztFoJYtoLTcvruxQ8lL5zet70qJgVCIysM/oO8ARgyw95OtA5Oyslo/QvQNc2DaTBJkjCGGPuaXmuhT/HkwOk78O+BOUXoXKBqa6T571n4wU37PW+7PN6vv9aZcXl+A+oO+00HoG2k1AANp/Y8V/gIhHkl+sTTJTJsLLUZcwfSNOOoH4Mf4SMo+iO85Tf0JJ0+ePGIvrQJmuu1whtP2rwTceegHRDHV5/VJ/n3gTuiEzTcM+C7IxtdV+sLtfQXLOEJVNYXNWqylQyc2h4OkVcBRuJPR5F4fhfxwhmGIuqdm2uFnkAJ0IuR2u29sdno+6RNdIZczlXCw3ff1MTph86t9fcU59QsEiTDGUYgPgFEQhFFhmDY5Yxh+iy95k4Mi+vK5cW7/9vDMVHV3UXv7bnofB/SC/NDm399vhDwJp8vl8zpFrxv8Zf2Byc5q+BdXznx+fSVILEWTsADW3ywW+AXoSmLkKFSgX/Mmd5IUoe7R0eOE1/r7+0/X0hlU2s70y0A+UH/37r83Wz+/tvUG+hwun8ebcHsdXL+6cwReWfjc/OZeLv3FpWO4bmWRlqCwsohampZlfeDi4UZ6JSfDSs9usIcG1xMA+3aQt09vWr9zp+2tQF9CdCU8otO34GH2vhFYx7eiOW18+76VU5fe/dVbmJyCJTgCEUl/DktN7tqfeRE9J1/JKRZQT/b+GRL6mgN375qGpzevP2Bo7a5ZcCcSCU+fxwP6EiAvisU87l+pji6A74M+ULAKRwBHaBHFhaDPSHZNTLAqdE0/DVdyrErLHGyp39vWRkJfVXv37uHT09PT3+3YrP7MrtbWTtulgNuXEDP0Lx1NgL5Frjn7hFz6K3ilblmg1C1HcZgk6OYDiBdROMNM/08IxUxyle6QaWShL4LcEPnhYdj8TeoHQjXdrbbKypGQz5VI65uPHgX7Eh6XTP0HBYn7WODciuMoXiwQ5hFoK4sogBC5E5VvpSVOyKHfT+Tt09N56MMTywb6lQtwBJxM35s6SvS9F/jmCwLXXxMkVteFDNbxIuly55EG+y2yP54g+l0aRNBN2y/Wvi4fgWcWyLCE0O+H0J+6YzLlpx+AzgP6pDSEQqD/rctF9b1eiyy8otC/J0gsQ3I4i3F2cddgiO7UW2V9XYVGh2R0Ebv0NnmC5qaqXAr9nR0P5akPSPrQ2GD3Ey5XwgX6Xq9Bsd3fpPXvp4VXhQyWlgTCxkwnTmr0Uv5jGpRGE9U0awchQQfBH+wDpXRYwokF7a3rE//vXWDP9AeiCt819dzEt4UM4kyfNLnkhYhfp+FFlNUJ8kxoRho7LGAM9G0gT3PzgwBQfWGzPBsgEH1WejbAnuqbH7+iPKprqpNbhyHrHLxIpxHRPwamMdSkIWcXMSrYY6EQLuVMJhiie2ul0P8oMPLQZ7sPEH3q/x9iL7qOmq/4sex7U6m/T5BgM59/qqNrWgsfW1qiRa4ZVeiDuInaN4X9FMhSwV/3kwWwYXnnkLAlfbdSf4PYi1fN4ajfogzLPnkMpU/uKk2LaorW1d2UihzG2mbM/kbhZ8zp0IdwRfauCZBCvyX9Zx2OtH6I6YugPxmNRtN1R6DcU53cZZqWHFN0FSelIhdusmhYcNhHC0KP0qTvN9mnhyH0W9Z3pZyBQAnRB//QBrH3JszhYDo785K+urCxVKmn6HLcH8VxFpeYUZ+Wx/BzoEcEwvMm+7DSFvRPbV4fHlEJpwd2P0D9ib4X9P3GGM8O01cNnvi84qm1KvCBOr++LtyORzKLaCQau4dgjv5WILxr+k3WZu83TX+3eX2fO5VyiQ0lRB/YAHuqb4kps8P1BYmCrMEDoeIDdXVRKnIRPMfuFGO6Rx9AGgv6nUD4SaX/fF76okN0uzzFDeZAgOmDveOy+UowpsyOWv8WLhA4K7AYvi7QZ0UuzIpoGH9DUo/0FlSX1j+1df3zHyQSblfK3NDgcMr6DtA3GI3KrKj157PmppC5rpX70n8v4WgkDNdyDyD0JdUX0vrfbV1f2PGpJyGmSsxm72XRDfrE3iGaDWGsfEip9dkG55ii83FFl8B4CX6YmzA9P9HpLRX/3U594PMbntTDDQ1e0SUG0volhuLMZ1bO7LPfRT1FbyrWtc6qxXnUPDII+tpkwf/V/1HIi/NPNhQ3QOYDTtAH+z7RbDYX8ymvGpwqeH1TDdT1ODtkU1XVEa3eovtCIDyk0v9LvvrAjUqzNyUSfZAn+iWfrmVdiuzLrZ+jvsVzFdHIFbiW0+st11dWzt9eXVHr/5S/PiToSU/K7HQGQN8Blf/nQ1JBvs7GNO88Kn31FM0aqOtSEQXMVqOhq6trIrlO9H/cLn12BPpcHtAH+59Jqq1MX/vIL+8+n6K8u/FaukwbEcgfW3a3TlZPTExcSy5tsz47AgHQ79tgF42SrPb3v5x95bS5nXOg3l9bW/kMnl5JwrGvcur/IGyJHV8HNr7/H/V1oNkwEIBx/AsUQGXv0Cw4gLtCQQor6SNMH6HsBfYqe5bFpsJiZdpB10ig0Ro2uIClPV1zt7SOLd3lByj498Tn7g6Q8t194NF8eW3UQS2t6MPrY7CNX6SozJ/gl3o3FqT8iLchpOpTV7JcHoYnPvK/cF/kjxbTDIUf+a3xZwt/J9q1+i72Tuard7fKFU0Xo+cUBZH/gfqI5XlKpB808qW7m3otpfEMh/wJajS0ows/sQB1+N9xUhZkyqCWbM6WnzDGuIODlV7+OlAHtWQanymfEt7nhJa75AeATH00yiuqqj/fCgkhDgR5enDS9KX6a1Hc1psP6joeKvMt6JvFx/NxLnJ+Cn1vG+PyV51B+4pCSzA3Lt9nhVyrfx5kqNYbT/4n/5rtDKBhHcAUViSu0D7b6nsQ9FbUAEPbtrtdJvAONMQxjMG+9fPQgY6MGnT64tjzkFy6AzSOwxOeE+JRNJJHCqGLpvJcx7Pw1R4ckAAAAAAI+v+6HYEKAAAAAAAnAUqAT4nYxOAkAAAAAElFTkSuQmCC"

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI2@2x.86299f95.png";

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI3.8731292c.png";

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI3@2x.096b4f77.png";

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI4@2x.c579c3b4.png";

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WI5@2x.624ed168.png";

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WS1@2x.c00b9945.png";

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WS2@2x.f3984e63.png";

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 752 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WS4@2x.eaa033d2.png";

/***/ }),
/* 754 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/WS5@2x.c9234997.png";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/cursor.1f24dce1.png";

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 758 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 760 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 767 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 768 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 769 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 770 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 772 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 773 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 774 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 775 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 776 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 777 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 778 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 779 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/groepsbewerk.12175e4f.svg";

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/testen.e718d156.svg";

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plateau_H_1.0f6641d8.svg";

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plateau_H_2.b63c120c.svg";

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plateau_H_3.aff341e5.svg";

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plateau_L_1.0f6641d8.svg";

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plateau_L_2.4bfe82a2.svg";

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plateau_L_3.403d3725.svg";

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plateau_L_4.aff341e5.svg";

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/questionmark.01887690.svg";

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(15);
var auth=new __WEBPACK_IMPORTED_MODULE_0_glxl_helpers__["Authorization"]();/**
 *
 * @param username
 * @param password
 * @return {Function}
 */var login=function login(username,password){var token=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){if(token){sessionStorage.setItem('token','Bearer '+token);return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/user/me').then(function(user){if(!user.role){throw new Error('User has no role.');}if(!['groupmember','groupleader','classleader','schoolcontact'].includes(user.role)){throw new Error('Deze gebruiker heeft geen toegang tot het simulatiespel.');}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["F" /* UPDATE_USER */],payload:{token:token,loggedIn:true,role:user.role,userDetails:user}});return true;}).catch(function(err){console.warn(err.message);auth.setAuthToken('');sessionStorage.removeItem('token');return false;});}if(!username||!password)return false;return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/user/login',{username:username,password:password},'POST').then(function(access){if(!access.auth||!access.token){return false;}auth.setAuthToken(access.token);return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/user/me').then(function(user){if(!['groupmember','groupleader','classleader','schoolcontact'].includes(user.role)){throw new Error('Deze gebruiker heeft geen toegang tot het simulatiespel.');}dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["F" /* UPDATE_USER */],payload:{token:access.token,loggedIn:access.auth,role:user.role,userDetails:user}});return true;}).catch(function(err){console.warn(err.message);return false;});}).catch(function(err){console.warn(err.message);return false;});};};/**
 *
 * @return {Function}
 */var fetchUser=function fetchUser(){return function(dispatch){var token=sessionStorage.getItem('token')||auth.getAuthToken();if(token){Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/user/me').then(function(user){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["F" /* UPDATE_USER */],payload:{token:token.replace('Bearer ',''),userDetails:user}});}).catch(function(err){console.error(err.message);});}};};/**
 *
 * @param user
 * @return {Function}
 */var updateUser=function updateUser(user){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["F" /* UPDATE_USER */],payload:user});};};/**
 *
 * @return {Function}
 */var logout=function logout(){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/user/logout',null,'POST').then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_2__types__["e" /* LOGOUT_USER */]});});};};/* harmony default export */ __webpack_exports__["a"] = ({fetchUser:fetchUser,updateUser:updateUser,login:login,logout:logout});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(9);
var fetchFeedback=function fetchFeedback(){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_0__components_apiCall__["a" /* default */])('/simulatiespel/feedback').then(function(feedback){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["o" /* UPDATE_FEEDBACK */],payload:feedback});}).catch(function(err){console.warn(err.message);});};};/**
 *
 * @param round
 * @return {Function}
 */var setRound=function setRound(round){return function(dispatch,getState){var _getState=getState(),gameState=_getState.gameState;var currentRound=gameState.Rounds[round]||{id:0};// Fetch policy choices for this round
dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].policyChoice.updatePolicyOptions(currentRound.id));dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["j" /* SET_ROUND */],payload:round});};};var updateRead=function updateRead(feedbackId,read){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_0__components_apiCall__["a" /* default */])('/simulatiespel/feedback/'+feedbackId+'/updateRead',read,'PUT');};};/* harmony default export */ __webpack_exports__["a"] = ({fetchFeedback:fetchFeedback,updateRead:updateRead,setRound:setRound});

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_apiCall__ = __webpack_require__(6);
/**
 *
 * @return {Function}
 */var updateGameState=function updateGameState(gameState){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["q" /* UPDATE_GAMESTATE */],payload:gameState});};};var setRoundState=function setRoundState(state,gameId){var gameScores=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["x" /* UPDATE_HANDLING_ROUND_STATE_CHANGE */],payload:true});return Object(__WEBPACK_IMPORTED_MODULE_2__components_apiCall__["a" /* default */])('/gameState/'+state+(gameId?'/'+gameId:'')).then(function(result){if(gameScores){dispatch(submitGameScores(gameScores,gameId));return;}dispatch(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].project.refreshProject());});};};var deactivateGame=function deactivateGame(){return function(dispatch,getState){return Object(__WEBPACK_IMPORTED_MODULE_2__components_apiCall__["a" /* default */])('/gameState/deactivate').then(function(result){dispatch(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].project.refreshProject());});};};var submitGameScores=function submitGameScores(gameScores,gameId,toggleSubmittingScores){return function(dispatch,getState){Object(__WEBPACK_IMPORTED_MODULE_2__components_apiCall__["a" /* default */])('/gameState/submitGameScores/'+gameId,gameScores,'POST').then(function(result){if(toggleSubmittingScores){toggleSubmittingScores(false);}dispatch(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* default */].project.refreshProject());});};};var forceUpdateLanguage=function forceUpdateLanguage(lang){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["d" /* FORCE_LANGUAGE */],payload:lang});};};/* harmony default export */ __webpack_exports__["a"] = ({updateGameState:updateGameState,deactivateGame:deactivateGame,setRoundState:setRoundState,submitGameScores:submitGameScores,forceUpdateLanguage:forceUpdateLanguage});

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/**
 *
 * @return {Function}
 */var updatePopups=function updatePopups(state){return function(dispatch,getState){var _getState=getState(),popupState=_getState.popupState;if(popupState&&popupState.preventInputChanges)return;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["B" /* UPDATE_POPUP */],payload:state});};};/* harmony default export */ __webpack_exports__["a"] = ({updatePopups:updatePopups});

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lang__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Defines__ = __webpack_require__(17);
var _this=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var fetchProject=function fetchProject(projectId){return function(dispatch,getState){var url='/project/'+projectId+'/simulationgame';return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])(url,null,'GET').then(function(project){dispatch(updateProject(project,true));});};};var myProject=function myProject(){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/project/me').then(function(project){dispatch(fetchProject(project.id));});};};var refreshProject=function refreshProject(){return function(dispatch,getState){var state=getState();dispatch(fetchProject(state.project.id));};};var updateProject=function updateProject(project){var fetchPolicyChoices=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch,getState){var _getState,user,schoolClassId,groupId,schoolClass,group,gameState,currentRound;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_getState=getState(),user=_getState.user;schoolClassId=0,groupId=0,schoolClass=undefined,group=undefined,gameState=undefined;// Set schoolClassId
if(user.role==='classleader'){schoolClassId=user.userDetails.ownedClass.id;}else if(['groupleader','groupmember'].includes(user.role)){schoolClassId=user.userDetails.group.SchoolClassId;}if(!schoolClassId){_context.next=13;break;}_context.next=6;return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/'+schoolClassId+'/simulationgame',null,'GET');case 6:schoolClass=_context.sent;// Set groupId
if(['groupleader','groupmember'].includes(user.role)){groupId=user.userDetails.ownedGroup?user.userDetails.ownedGroup.id:user.userDetails.group.id;}else{groupId=schoolClass.Groups[0].id;}_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/group/'+groupId+'/simulationgame',null,'GET');case 10:group=_context.sent;// Find and set gameState
if(group&&Array.isArray(group.Rounds)){gameState={Rounds:group.Rounds||{},gameStateSum:group.gameStateSum||{}};}if(user.role==='groupleader'||user.role==='groupmember'){currentRound=group.Rounds[group.Rounds.length-1]||{id:0};dispatch(__WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */].policyChoice.updatePolicyOptions(currentRound.id));}case 13:if(user.role==='groupleader'||user.role==='groupmember'||user.role==='classleader'){__WEBPACK_IMPORTED_MODULE_4__lang__["a" /* default */].setLanguage(schoolClass.Language.code);}else{__WEBPACK_IMPORTED_MODULE_4__lang__["a" /* default */].setLanguage(project.defaultLanguage.code);}if(project.lite){__WEBPACK_IMPORTED_MODULE_5__Defines__["a" /* default */].applyLiteOverrides();}dispatch({type:__WEBPACK_IMPORTED_MODULE_3__types__["C" /* UPDATE_PROJECT */],payload:{project:project,schoolClass:_extends({},schoolClass,{loaded:true}),group:_extends({},group,{loaded:true}),gameState:gameState}});case 16:case'end':return _context.stop();}}},_callee,_this);}));return function(_x2,_x3){return _ref.apply(this,arguments);};}();};/* harmony default export */ __webpack_exports__["a"] = ({fetchProject:fetchProject,myProject:myProject,updateProject:updateProject,refreshProject:refreshProject});

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_apiCall__ = __webpack_require__(6);
/**
 *
 * @return {Function}
 */var updateSchoolClass=function updateSchoolClass(schoolClass){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["D" /* UPDATE_SCHOOLCLASS */],payload:schoolClass});};};var setGroupId=function setGroupId(groupId){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["h" /* SET_GROUP_ID */],payload:groupId});};};var addVideo=function addVideo(schoolClassId,video){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/'+schoolClassId+'/addVideo',video,'POST').then(function(result){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["b" /* ADD_SCHOOLCLASS_VIDEO */],payload:result});});};};var removeVideo=function removeVideo(videoId){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/removeVideo/'+videoId,{},'DELETE').then(function(result){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["g" /* REMOVE_SCHOOLCLASS_VIDEO */],payload:result});});};};var addPhoto=function addPhoto(schoolClassId,photo){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/'+schoolClassId+'/addPhoto',photo,'POST').then(function(result){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["a" /* ADD_SCHOOLCLASS_PHOTO */],payload:result});});};};var removePhoto=function removePhoto(photoId){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/removePhoto/'+photoId,{},'DELETE').then(function(result){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["f" /* REMOVE_SCHOOLCLASS_PHOTO */],payload:result});});};};var pauseTimer=function pauseTimer(timerPausedAt){return function(dispatch,getState){var _getState=getState(),schoolClass=_getState.schoolClass;Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/'+schoolClass.id+'/setTimer',{timerPausedAt:timerPausedAt},'PUT');};};var emptyTimer=function emptyTimer(){return function(dispatch,getState){var _getState2=getState(),schoolClass=_getState2.schoolClass;Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/'+schoolClass.id+'/setTimer',{timerPausedAt:null,timerEndsAt:null},'PUT');};};var setTimer=function setTimer(timerEndsAt){return function(dispatch,getState){var _getState3=getState(),schoolClass=_getState3.schoolClass;Object(__WEBPACK_IMPORTED_MODULE_1__components_apiCall__["a" /* default */])('/schoolClass/'+schoolClass.id+'/setTimer',{timerEndsAt:timerEndsAt,timerPausedAt:null},'PUT');};};/* harmony default export */ __webpack_exports__["a"] = ({updateSchoolClass:updateSchoolClass,setGroupId:setGroupId,addVideo:addVideo,removeVideo:removeVideo,addPhoto:addPhoto,removePhoto:removePhoto,pauseTimer:pauseTimer,emptyTimer:emptyTimer,setTimer:setTimer});

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/**
 *
 * @return {Function}
 */var updateGroup=function updateGroup(group){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["w" /* UPDATE_GROUP */],payload:group});};};/* harmony default export */ __webpack_exports__["a"] = ({updateGroup:updateGroup});

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(15);
var updatePolicyOptions=function updatePolicyOptions(roundId){return function(dispatch){Object(__WEBPACK_IMPORTED_MODULE_0__components_apiCall__["a" /* default */])(roundId?"/simulatiespel/beleidskeuzes/singleRound/"+roundId:'/simulatiespel/beleidskeuzes').then(function(options){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["A" /* UPDATE_POLICY_CHOICE_OPTIONS */],payload:options});});};};/* harmony default export */ __webpack_exports__["a"] = ({updatePolicyOptions:updatePolicyOptions});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(15);
var lockStepTwo=function lockStepTwo(){return function(dispatch){var d=new Date();var date=new Date(d.setDate(new Date().getDate()+100)).toISOString();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["t" /* UPDATE_GHETTORADIO_HANDLING_ACTION */],payload:__WEBPACK_IMPORTED_MODULE_1__types__["v" /* UPDATE_GHETTORADIO_TIMER */]});Object(__WEBPACK_IMPORTED_MODULE_0__components_apiCall__["a" /* default */])('/ghettoRadioGroup/updateStepOneTimer',date,'POST').then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["v" /* UPDATE_GHETTORADIO_TIMER */],payload:date});});};};var unlockStepTwo=function unlockStepTwo(){return function(dispatch){var d=new Date();var date=new Date(d.setDate(new Date().getDate()-100)).toISOString();dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["t" /* UPDATE_GHETTORADIO_HANDLING_ACTION */],payload:__WEBPACK_IMPORTED_MODULE_1__types__["v" /* UPDATE_GHETTORADIO_TIMER */]});Object(__WEBPACK_IMPORTED_MODULE_0__components_apiCall__["a" /* default */])('/ghettoRadioGroup/updateStepOneTimer',date,'POST').then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["v" /* UPDATE_GHETTORADIO_TIMER */],payload:date});});};};var toggleStepThree=function toggleStepThree(locked){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["t" /* UPDATE_GHETTORADIO_HANDLING_ACTION */],payload:__WEBPACK_IMPORTED_MODULE_1__types__["u" /* UPDATE_GHETTORADIO_LOCKED */]});Object(__WEBPACK_IMPORTED_MODULE_0__components_apiCall__["a" /* default */])('/ghettoRadioGroup/setGhettoRadioLocked',{locked:locked},'POST').then(function(){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["u" /* UPDATE_GHETTORADIO_LOCKED */],payload:locked});});};};var fetchGhettoRadioGroups=function fetchGhettoRadioGroups(){return function(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_0__components_apiCall__["a" /* default */])('/ghettoRadioGroup/myGroups').then(function(groups){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__types__["s" /* UPDATE_GHETTORADIO_GROUPS */],payload:groups});});};};/* harmony default export */ __webpack_exports__["a"] = ({lockStepTwo:lockStepTwo,unlockStepTwo:unlockStepTwo,fetchGhettoRadioGroups:fetchGhettoRadioGroups,toggleStepThree:toggleStepThree});

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/**
 *
 * @return {Function}
 */var updateBankNotifications=function updateBankNotifications(state){return function(dispatch,getState){var _getState=getState(),bankNotificationState=_getState.bankNotificationState;if(bankNotificationState&&bankNotificationState.preventInputChanges)return;dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["n" /* UPDATE_BANKNOTIFICATION */],payload:state});};};/* harmony default export */ __webpack_exports__["a"] = ({updateBankNotifications:updateBankNotifications});

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(15);
/**
 *
 * @param payload
 * @returns {Function}
 */var updateTimer=function updateTimer(payload){return function(dispatch){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__types__["E" /* UPDATE_TIMER */],payload:payload});};};/* harmony default export */ __webpack_exports__["a"] = ({updateTimer:updateTimer});

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/budget.593b2ad9.svg";

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/grondstoffen.15869dde.svg";

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bank.b699f250.svg";

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={popupId:null,closeable:true};var popupState=function popupState(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["B" /* UPDATE_POPUP */]:state=_extends({},state,payload);break;default:return state;}return _extends({},state);};/* harmony default export */ __webpack_exports__["a"] = (popupState);

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var initialState=[];var round=-1;var data=[];var policyChoice=function policyChoice(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["o" /* UPDATE_FEEDBACK */]:if(round===-1){round=payload.length-1;}break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["A" /* UPDATE_POLICY_CHOICE_OPTIONS */]:data=payload;break;case __WEBPACK_IMPORTED_MODULE_0__actions_types__["j" /* SET_ROUND */]:round=payload;break;default:return state;}if(Array.isArray(data)){if(!data.length)return[];return data[round===-1?data.length-1:round]||[];}else if((typeof data==='undefined'?'undefined':_typeof(data))==='object'){return data[round===-1?Object.keys(data).length-1:round]||[];}return[];};/* harmony default export */ __webpack_exports__["a"] = (policyChoice);

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_types__ = __webpack_require__(15);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var initialState={minutesPre:0,minutesLast:0,secondsPre:0,secondsLast:0};var timer=function timer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var payload=action.payload,type=action.type;switch(type){case __WEBPACK_IMPORTED_MODULE_0__actions_types__["E" /* UPDATE_TIMER */]:state=_extends({},state,payload);return state;default:return state;}};/* harmony default export */ __webpack_exports__["a"] = (timer);

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(171));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(172));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _Manager = _interopRequireDefault(__webpack_require__(812));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(293));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(294));

var _PosterImage = _interopRequireDefault(__webpack_require__(295));

var _Video = _interopRequireDefault(__webpack_require__(296));

var _Bezel = _interopRequireDefault(__webpack_require__(299));

var _Shortcut = _interopRequireDefault(__webpack_require__(300));

var _ControlBar = _interopRequireDefault(__webpack_require__(301));

var browser = _interopRequireWildcard(__webpack_require__(825));

var _dom = __webpack_require__(124);

var _utils = __webpack_require__(47);

var _fullscreen = _interopRequireDefault(__webpack_require__(292));

var propTypes = {
  children: _propTypes["default"].any,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  fluid: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  aspectRatio: _propTypes["default"].string,
  className: _propTypes["default"].string,
  videoId: _propTypes["default"].string,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  store: _propTypes["default"].object
};
var defaultProps = {
  fluid: true,
  muted: false,
  playsInline: false,
  preload: 'auto',
  aspectRatio: 'auto'
};

var Player =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Player, _Component);

  function Player(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Player);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
    _this.controlsHideTimer = null;
    _this.video = null; // the Video component

    _this.manager = new _Manager["default"](props.store);
    _this.actions = _this.manager.getActions();

    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));

    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);

      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listener
      window.removeEventListener('resize', this.handleResize);

      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);

      if (this.controlsHideTimer) {
        window.clearTimeout(this.controlsHideTimer);
      }
    }
  }, {
    key: "getDefaultChildren",
    value: function getDefaultChildren(originalChildren) {
      var _this2 = this;

      return [_react["default"].createElement(_Video["default"], {
        ref: function ref(c) {
          _this2.video = c;
          _this2.manager.video = _this2.video;
        },
        key: "video",
        order: 0.0
      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
        key: "poster-image",
        order: 1.0
      }), _react["default"].createElement(_LoadingSpinner["default"], {
        key: "loading-spinner",
        order: 2.0
      }), _react["default"].createElement(_Bezel["default"], {
        key: "bezel",
        order: 3.0
      }), _react["default"].createElement(_BigPlayButton["default"], {
        key: "big-play-button",
        order: 4.0
      }), _react["default"].createElement(_ControlBar["default"], {
        key: "control-bar",
        order: 5.0
      }), _react["default"].createElement(_Shortcut["default"], {
        key: "shortcut",
        order: 99.0
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren(props) {
      var _ = props.className,
          originalChildren = props.children,
          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);

      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
        return !(0, _utils.isVideoChild)(e);
      });

      var defaultChildren = this.getDefaultChildren(originalChildren);
      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
    }
  }, {
    key: "setWidthOrHeight",
    value: function setWidthOrHeight(style, name, value) {
      var styleVal;

      if (typeof value === 'string') {
        if (value === 'auto') {
          styleVal = 'auto';
        } else if (value.match(/\d+%/)) {
          styleVal = value;
        }
      } else if (typeof value === 'number') {
        styleVal = "".concat(value, "px");
      }

      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
          fluid = _this$props.fluid,
          propsAspectRatio = _this$props.aspectRatio,
          propsHeight = _this$props.height,
          propsWidth = _this$props.width;

      var _this$manager$getStat = this.manager.getState(),
          player = _this$manager$getStat.player;

      var style = {};
      var width;
      var height;
      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.

      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
        // Use any aspectRatio that's been specifically set
        aspectRatio = propsAspectRatio;
      } else if (player.videoWidth) {
        // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
      } else {
        // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
      } // Get the ratio as a decimal we can use to calculate dimensions


      var ratioParts = aspectRatio.split(':');
      var ratioMultiplier = ratioParts[1] / ratioParts[0];

      if (propsWidth !== undefined) {
        // Use any width that's been specifically set
        width = propsWidth;
      } else if (propsHeight !== undefined) {
        // Or calulate the width from the aspect ratio if a height has been set
        width = propsHeight / ratioMultiplier;
      } else {
        // Or use the video's metadata, or use the video el's default of 300
        width = player.videoWidth || 400;
      }

      if (propsHeight !== undefined) {
        // Use any height that's been specifically set
        height = propsHeight;
      } else {
        // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
      }

      if (fluid) {
        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
      } else {
        // If Width contains "auto", set "auto" in style
        this.setWidthOrHeight(style, 'width', width);
        this.setWidthOrHeight(style, 'height', height);
      }

      return style;
    } // get redux state
    // { player, operation }

  }, {
    key: "getState",
    value: function getState() {
      return this.manager.getState();
    } // get playback rate

  }, {
    key: "play",
    // play the video
    value: function play() {
      this.video.play();
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      this.video.pause();
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      this.video.seek(time);
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.video.forward(seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.video.replay(seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      this.video.toggleFullscreen();
    } // subscribe to player state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      return this.manager.subscribeToPlayerStateChange(listener);
    } // player resize

  }, {
    key: "handleResize",
    value: function handleResize() {}
  }, {
    key: "handleFullScreenChange",
    value: function handleFullScreenChange(event) {
      if (event.target === this.manager.rootElement) {
        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {
      this.startControlsTimer();
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      this.startControlsTimer();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown() {
      this.startControlsTimer();
    }
  }, {
    key: "startControlsTimer",
    value: function startControlsTimer() {
      var _this3 = this;

      var controlBarActiveTime = 3000;

      _react["default"].Children.forEach(this.props.children, function (element) {
        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
          return;
        }

        var autoHideTime = element.props.autoHideTime;

        if (typeof autoHideTime === 'number') {
          controlBarActiveTime = autoHideTime;
        }
      });

      this.actions.userActivate(true);
      clearTimeout(this.controlsHideTimer);
      this.controlsHideTimer = setTimeout(function () {
        _this3.actions.userActivate(false);
      }, controlBarActiveTime);
    }
  }, {
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      if (state.isFullscreen !== prevState.isFullscreen) {
        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276

        (0, _dom.focusNode)(this.manager.rootElement);
      }

      this.forceUpdate(); // re-render
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.actions.activate(true);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.actions.activate(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var fluid = this.props.fluid;

      var _this$manager$getStat2 = this.manager.getState(),
          player = _this$manager$getStat2.player;

      var paused = player.paused,
          hasStarted = player.hasStarted,
          waiting = player.waiting,
          seeking = player.seeking,
          isFullscreen = player.isFullscreen,
          userActivity = player.userActivity;
      var props = (0, _objectSpread2["default"])({}, this.props, {
        player: player,
        actions: this.actions,
        manager: this.manager,
        store: this.manager.store,
        video: this.video ? this.video.video : null
      });
      var children = this.getChildren(props);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-controls-enabled': true,
          'video-react-has-started': hasStarted,
          'video-react-paused': paused,
          'video-react-playing': !paused,
          'video-react-waiting': waiting,
          'video-react-seeking': seeking,
          'video-react-fluid': fluid,
          'video-react-fullscreen': isFullscreen,
          'video-react-user-inactive': !userActivity,
          'video-react-user-active': userActivity,
          'video-react-workinghover': !browser.IS_IOS
        }, 'video-react', this.props.className),
        style: this.getStyle(),
        ref: function ref(c) {
          _this4.manager.rootElement = c;
        },
        role: "region",
        onTouchStart: this.handleMouseDown,
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: "-1"
      }, children);
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Player;
}(_react.Component);

exports["default"] = Player;
Player.contextTypes = {
  store: _propTypes["default"].object
};
Player.propTypes = propTypes;
Player.defaultProps = defaultProps;
Player.displayName = 'Player';

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(122)["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 810 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 811 */
/***/ (function(module, exports) {

function _setPrototypeOf(t, e) {
  return module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _setPrototypeOf(t, e);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _redux = __webpack_require__(100);

var _reducers = _interopRequireDefault(__webpack_require__(291));

var playerActions = _interopRequireWildcard(__webpack_require__(123));

var videoActions = _interopRequireWildcard(__webpack_require__(173));

var Manager =
/*#__PURE__*/
function () {
  function Manager(store) {
    (0, _classCallCheck2["default"])(this, Manager);
    this.store = store || (0, _redux.createStore)(_reducers["default"]);
    this.video = null;
    this.rootElement = null;
  }

  (0, _createClass2["default"])(Manager, [{
    key: "getActions",
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;
      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);

      function bindActionCreator(actionCreator) {
        return function bindAction() {
          // eslint-disable-next-line prefer-rest-params
          var action = actionCreator.apply(manager, arguments);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      return Object.keys(actions).filter(function (key) {
        return typeof actions[key] === 'function';
      }).reduce(function (boundActions, key) {
        boundActions[key] = bindActionCreator(actions[key]);
        return boundActions;
      }, {});
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.store.getState();
    } // subscribe state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, getState) {
      if (!getState) {
        getState = this.getState.bind(this);
      }

      var prevState = getState();

      var handleChange = function handleChange() {
        var state = getState();

        if (state === prevState) {
          return;
        }

        var prevStateCopy = prevState;
        prevState = state;
        listener(state, prevStateCopy);
      };

      return this.store.subscribe(handleChange);
    } // subscribe to operation state change

  }, {
    key: "subscribeToOperationStateChange",
    value: function subscribeToOperationStateChange(listener) {
      var _this = this;

      return this.subscribeToStateChange(listener, function () {
        return _this.getState().operation;
      });
    } // subscribe to player state change

  }, {
    key: "subscribeToPlayerStateChange",
    value: function subscribeToPlayerStateChange(listener) {
      var _this2 = this;

      return this.subscribeToStateChange(listener, function () {
        return _this2.getState().player;
      });
    }
  }]);
  return Manager;
}();

exports["default"] = Manager;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = player;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _video = __webpack_require__(173);

var _player = __webpack_require__(123);

var initialState = {
  currentSrc: null,
  duration: 0,
  currentTime: 0,
  seekingTime: 0,
  buffered: null,
  waiting: false,
  seeking: false,
  paused: true,
  autoPaused: false,
  ended: false,
  playbackRate: 1,
  muted: false,
  volume: 1,
  readyState: 0,
  networkState: 0,
  videoWidth: 0,
  videoHeight: 0,
  hasStarted: false,
  userActivity: true,
  isActive: false,
  isFullscreen: false
};

function player() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.USER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        userActivity: action.activity
      });

    case _player.PLAYER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        isActive: action.activity
      });

    case _player.FULLSCREEN_CHANGE:
      return (0, _objectSpread2["default"])({}, state, {
        isFullscreen: !!action.isFullscreen
      });

    case _video.SEEKING_TIME:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: action.time
      });

    case _video.END_SEEKING:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: 0
      });

    case _video.LOAD_START:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        hasStarted: false,
        ended: false
      });

    case _video.CAN_PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.WAITING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: true
      });

    case _video.CAN_PLAY_THROUGH:
    case _video.PLAYING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: false,
        paused: false,
        autoPaused: false,
        waiting: false,
        hasStarted: true
      });

    case _video.PAUSE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        paused: true
      });

    case _video.END:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: true
      });

    case _video.SEEKING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: true
      });

    case _video.SEEKED:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: false
      });

    case _video.ERROR:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        error: 'UNKNOWN ERROR',
        ended: true
      });

    case _video.DURATION_CHANGE:
    case _video.TIME_UPDATE:
    case _video.VOLUME_CHANGE:
    case _video.PROGRESS_CHANGE:
    case _video.RATE_CHANGE:
    case _video.SUSPEND:
    case _video.ABORT:
    case _video.EMPTIED:
    case _video.STALLED:
    case _video.LOADED_META_DATA:
    case _video.LOADED_DATA:
    case _video.RESIZE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps);

    default:
      return state;
  }
}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = operation;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _player = __webpack_require__(123);

var initialState = {
  count: 0,
  operation: {
    action: '',
    source: ''
  }
};

function operation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.OPERATE:
      return (0, _objectSpread2["default"])({}, state, {
        count: state.count + 1,
        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
      });

    default:
      return state;
  }
}

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(298);
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return arrayLikeToArray(r);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 816 */
/***/ (function(module, exports) {

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(298);
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? arrayLikeToArray(r, a) : void 0;
  }
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 818 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PopupButton;

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(62));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(317));

var _Popup = _interopRequireDefault(__webpack_require__(820));

var propTypes = {
  inline: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  inline: true
};

function PopupButton(props) {
  var inline = props.inline,
      className = props.className;
  var ps = (0, _objectSpread2["default"])({}, props);
  delete ps.children;
  delete ps.inline;
  delete ps.className;
  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, {
      'video-react-menu-button-inline': !!inline,
      'video-react-menu-button-popup': !inline
    }, 'video-react-control video-react-button video-react-menu-button')
  }, ps), _react["default"].createElement(_Popup["default"], props));
}

PopupButton.propTypes = propTypes;
PopupButton.defaultProps = defaultProps;
PopupButton.displayName = 'PopupButton';

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  player: _propTypes["default"].object,
  children: _propTypes["default"].any
};

var Popup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Popup, _Component);

  function Popup(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Popup, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("div", {
        className: "video-react-menu",
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        className: "video-react-menu-content"
      }, children));
    }
  }]);
  return Popup;
}(_react.Component);

exports["default"] = Popup;
Popup.propTypes = propTypes;
Popup.displayName = 'Popup';

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(92));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var _Slider = _interopRequireDefault(__webpack_require__(174));

var _VolumeLevel = _interopRequireDefault(__webpack_require__(822));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};

var VolumeBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeBar, _Component);

  function VolumeBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
    _this.state = {
      percentage: '0%'
    };
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "getPercent",
    value: function getPercent() {
      var player = this.props.player;

      if (player.muted) {
        return 0;
      }

      return player.volume;
    }
  }, {
    key: "checkMuted",
    value: function checkMuted() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (player.muted) {
        actions.mute(false);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      this.checkMuted();
      var distance = this.slider.calculateDistance(event);
      actions.changeVolume(distance);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      this.checkMuted();
      actions.changeVolume(player.volume + 0.1);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions;
      this.checkMuted();
      actions.changeVolume(player.volume - 0.1);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handlePercentageChange",
    value: function handlePercentageChange(percentage) {
      if (percentage !== this.state.percentage) {
        this.setState({
          percentage: percentage
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          player = _this$props4.player,
          className = _this$props4.className;
      var volume = (player.volume * 100).toFixed(2);
      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
        ref: function ref(c) {
          _this2.slider = c;
        },
        label: "volume level",
        valuenow: volume,
        valuetext: "".concat(volume, "%"),
        onMouseMove: this.handleMouseMove,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        sliderActive: this.handleFocus,
        sliderInactive: this.handleBlur,
        getPercent: this.getPercent,
        onPercentageChange: this.handlePercentageChange,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, this.props, {
        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
    }
  }]);
  return VolumeBar;
}(_react.Component);

VolumeBar.propTypes = propTypes;
VolumeBar.displayName = 'VolumeBar';
var _default = VolumeBar;
exports["default"] = _default;

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  percentage: _propTypes["default"].string,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  percentage: '100%',
  vertical: false
};

function VolumeLevel(_ref) {
  var percentage = _ref.percentage,
      vertical = _ref.vertical,
      className = _ref.className;
  var style = {};

  if (vertical) {
    style.height = percentage;
  } else {
    style.width = percentage;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
    style: style
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }));
}

VolumeLevel.propTypes = propTypes;
VolumeLevel.defaultProps = defaultProps;
VolumeLevel.displayName = 'VolumeLevel';
var _default = VolumeLevel;
exports["default"] = _default;

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  children: _propTypes["default"].any
};

var Menu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Menu, _Component);

  function Menu(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Menu);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Menu, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "video-react-menu video-react-lock-showing",
        role: "presentation",
        onClick: this.handleClick
      }, _react["default"].createElement("ul", {
        className: "video-react-menu-content"
      }, this.props.children));
    }
  }]);
  return Menu;
}(_react.Component);

exports["default"] = Menu;
Menu.propTypes = propTypes;
Menu.displayName = 'Menu';

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(26));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(10));

var propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  activateIndex: _propTypes["default"].number,
  onSelectItem: _propTypes["default"].func
};

var MenuItem =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuItem, _Component);

  function MenuItem(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          index = _this$props.index,
          onSelectItem = _this$props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          item = _this$props2.item,
          index = _this$props2.index,
          activateIndex = _this$props2.activateIndex;
      return _react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          'video-react-menu-item': true,
          'video-react-selected': index === activateIndex
        }),
        role: "menuitem",
        onClick: this.handleClick
      }, item.label, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }));
    }
  }]);
  return MenuItem;
}(_react.Component);

exports["default"] = MenuItem;
MenuItem.propTypes = propTypes;
MenuItem.displayName = 'MenuItem';

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

/*
 * Device is an iPhone
 *
 * @type {Boolean}
 * @constant
 * @private
 */

var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/

exports.IS_IPAD = IS_IPAD;
var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
exports.IS_IPHONE = IS_IPHONE;
var IS_IPOD = /iPod/i.test(USER_AGENT);
exports.IS_IPOD = IS_IPOD;
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
exports.IS_IOS = IS_IOS;

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(23);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(20));

var _createClass2 = _interopRequireDefault(__webpack_require__(21));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(25));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(27));

var _inherits2 = _interopRequireDefault(__webpack_require__(28));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(175));

var _utils = __webpack_require__(47);

var PlaybackRate =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRate, _Component);

  function PlaybackRate(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRate);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRate, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
    }
  }]);
  return PlaybackRate;
}(_react.Component);

exports["default"] = PlaybackRate;
PlaybackRate.displayName = 'PlaybackRate';

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_MapView__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_MapElement__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_MapEconomy__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_MapPolicy__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_logo_png__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__DifficultyAwareComponent__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var Home=(_temp=_class=function(_DifficultyAwareCompo){_inherits(Home,_DifficultyAwareCompo);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.toggleTourPopUp=function(direction){if(direction==="prev"&&_this.state.tourPopUpCount>0){if(_this.state.tourPopups[_this.state.tourPopUpCount-1]){_this.setState({tourPopUpCount:_this.state.tourPopUpCount-1});}}else{if(_this.state.tourPopups[_this.state.tourPopUpCount+1]){_this.setState({tourPopUpCount:_this.state.tourPopUpCount+1});}else{_this.setState({tour:false});}}};_this.state={tour:false,tourPopUpCount:0,lowBudgetWarning:true,tourPopups:[{title:'Welkom in Globaland',nextUpType:'nextPopUp',img:__WEBPACK_IMPORTED_MODULE_17__assets_img_logo_png___default.a,buttonText:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])('sim_volgende_button'),align:'center'},{title:'Om te beginnen',description:'Bedenk een leuke naam voor jullie land en upload je teamfoto. \n\n Let op: alleen de teamleider kan informatie invoeren. De overige teamleden kunnen alleen informatie bekijken. Je kunt per spelronde wisselen van rol.',nextUpType:'nextPopUp',buttonText:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])('sim_volgende_button')},{title:'Land besturen',description:'In deze app kun je je land besturen. Elke spelronde bestaat uit 3 stappen: 1. Hoe staat je land ervoor? 2. Belasting heffen 3. Budget verdelen Op sommige plekken kun je pas verder als alle groepen van de klas klaar zijn of als de begeleider het vervolg heeft geactiveerd.',nextUpType:'close',buttonText:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])('sim_sluiten')}]};_this.toggleTourPopUp=_this.toggleTourPopUp.bind(_this);return _this;}_createClass(Home,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,gameState=_props.gameState,dispatch=_props.dispatch,project=_props.project;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(currentRound===1&&gameState.currentStep===1){Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtlandbesturen1_T1':'mlgvtlandbesturen1_T1',dispatch);}if(currentRound===2&&gameState.currentStep===1){Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtlandbesturen2_T1':'mlgvtlandbesturen2_T1',dispatch,true);}if(currentRound===1&&gameState.currentStep===3){Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtbudgetverdelen_T1':'mlgvtbudgetverdelen_T1',dispatch);}}},{key:'renderLaag',value:function renderLaag(){var _this2=this;var position=__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].position;var tour=this.state.tour;var currentPopUp=this.state.tourPopups[this.state.tourPopUpCount];var _props2=this.props,gameState=_props2.gameState,feedback=_props2.feedback,myState=_props2.myState,policyChoice=_props2.policyChoice;var prevRoundSum=gameState.prevRoundSum,currentRound=gameState.currentRound;if(!prevRoundSum)return null;var niveau=this.props.project.difficulty.toLowerCase();var budget=gameState.totalGameStateSum.globas;var currentRoundGameState=gameState.Rounds[currentRound];var currentMin=this.props.currentMin;if(this.props.history.location.pathname.toLowerCase().indexOf('beleidskeuzes')>-1){currentMin='beleidskeuzes';}if(this.props.history.location.pathname.toLowerCase().indexOf('economy')>-1){currentMin='economy';}console.log(this);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-map step-'+gameState.currentStep},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'view',showBudget:gameState.currentStep===3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["CSSTransition"],{'in':tour,timeout:200,classNames:'animation',unmountOnExit:true},function(state){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_PopUp__["a" /* default */],{title:currentPopUp.title,description:currentPopUp.description,img:currentPopUp.img,align:currentPopUp.align,nextUpType:currentPopUp.nextUpType,buttonText:currentPopUp.buttonText,showPopUp:_this2.state.tour,nthPopup:_this2.state.tourPopUpCount,nPopups:_this2.state.tourPopups.length,closePopUpClick:_this2.toggleTourPopUp,navigation:true});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_MapView__["a" /* default */],{history:this.props.history},gameState.currentStep!==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_MapEconomy__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])("sim_economie"),target:currentMin==='economy'?'/':'/economy',top:position["economy"]['basic']["top"],left:!(gameState.currentStep===1&&gameState.currentRound>1&&this.props.project.minPolicyChoices>0)&&gameState.currentStep!==3?position["economy"]['pro']["left"]:position["economy"]['basic']["left"],history:this.props.history,roundPoints:currentRoundGameState.earnedPoints,economy:gameState.totalEconomy,feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(feedback.prevRoundFeedbackData),true)}):'',!(gameState.currentStep===1&&gameState.currentRound>1)&&gameState.currentStep!==3?null:this.props.project.minPolicyChoices>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_MapPolicy__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),step:gameState.currentStep,target:currentMin==='beleidskeuzes'?'/':'/beleidskeuzes',top:gameState.currentStep===3?position["economy"]['pro']["top"]:position["policy"]["top"],left:gameState.currentStep===3?position["economy"]['pro']["left"]:position["policy"]["left"],history:this.props.history,number:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_15__helpers_policyChoiceHelper__["k" /* getTotalCosts */])(myState.policyChoices,policyChoice):Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["v" /* getPolicyChoiceTotalPoints */])(feedback.prevRoundFeedbackData),suffix:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])('sim_miljard'):Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])('sim_punten'),feedbackCount:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_15__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,myState.policyChoices,this.props.project.minPolicyChoices):Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData),null,true)}):null,__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].basic.ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_MapElement__["a" /* default */],{key:min,target:'/ministries/'+(gameState.currentStep===3?'budget/':'')+min.toLowerCase(),title:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])(min),icon:min,value:gameState.gameStateSum[min+'_value'],stars:false,international:__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].i18nMinistries.includes(min),top:position[min]["basic"]["top"],left:position[min]["basic"]["left"],feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["z" /* getUnreadCount */])(min,_this2.props.feedback.prevRoundFeedbackData),difficulty:niveau,globas:Object(__WEBPACK_IMPORTED_MODULE_16__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(myState.ministerieGlobaVerdeling,min,gameState.currentStep),roundPoints:prevRoundSum[min+'_points'],budgetSet:false,policySet:false,disaster:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["C" /* ministryHasDisaster */])(min,_this2.props.feedback),history:_this2.props.history// collaboration={ministerieGlobaVerdeling[min + 'SW']}
});})),gameState.currentStep===3&&gameState.currentRound<4&&this.state.lowBudgetWarning&&budget<30&&!this.props.gameState.history&&this.props.project.bankEnabled!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])('sim_beperkt_budget_melding'),showIfUnread:gameState.currentRound+'-limitedBudget',closePopUpCross:true,closePopUpClick:function closePopUpClick(){return _this2.setState({lowBudgetWarning:false});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_NextStep__["a" /* default */],null));}},{key:'renderHoog',value:function renderHoog(){var _this3=this;var position=__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].position;var tour=this.state.tour;var currentPopUp=this.state.tourPopups[this.state.tourPopUpCount];var _props3=this.props,gameState=_props3.gameState,myState=_props3.myState,feedback=_props3.feedback;var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;var niveau=this.props.project.difficulty.toLowerCase();var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling;var policyChoices=Object.values(myState.policyChoices);var budget=gameState.totalGameStateSum.globas;var currentMin=this.props.currentMin;if(this.props.history.location.pathname.toLowerCase().indexOf('economy')>-1){currentMin='economy';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-map step-'+gameState.currentStep},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'view',showBudget:gameState.currentStep===3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["CSSTransition"],{'in':tour,timeout:200,classNames:'animation',unmountOnExit:true},function(state){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_PopUp__["a" /* default */],{title:currentPopUp.title,description:currentPopUp.description,img:currentPopUp.img,align:currentPopUp.align,nextUpType:currentPopUp.nextUpType,buttonText:currentPopUp.buttonText,showPopUp:_this3.state.tour,nthPopup:_this3.state.tourPopUpCount,nPopups:_this3.state.tourPopups.length,closePopUpClick:_this3.toggleTourPopUp,navigation:true});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_MapView__["a" /* default */],{history:this.props.history},gameState.currentStep!==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_MapEconomy__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])("sim_economie"),target:currentMin==='economy'?'/':'/economy',top:position["economy"]["pro"]["top"],left:position["economy"]["pro"]["left"],roundPoints:gameState.Rounds[gameState.currentRound].earnedPoints,economy:gameState.totalEconomy,history:this.props.history,feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(feedback.prevRoundFeedbackData),true)}):null,__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].pro.ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_MapElement__["a" /* default */],{key:min,target:'/ministries/'+(gameState.currentStep===3?'budget/':'')+min.toLowerCase(),title:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])(min),icon:min,value:gameState.gameStateSum[min+'_value'],stars:__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].ministeryStars[min],international:__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].i18nMinistries.includes(min),top:position[min]["pro"]["top"],left:position[min]["pro"]["left"],feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["z" /* getUnreadCount */])(min,_this3.props.feedback.prevRoundFeedbackData),difficulty:niveau,globas:Object(__WEBPACK_IMPORTED_MODULE_16__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(ministerieGlobaVerdeling,min,gameState.currentStep,policyChoices),roundPoints:prevRoundSum[min+'_points'],budgetSet:ministerieGlobaVerdeling[min]&&gameState.currentStep>1,policySet:policyChoices.find(function(choice){return choice.ministry===min&&choice.selected;})&&gameState.currentStep>1,history:_this3.props.history,disaster:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_feedbackHelpers__["C" /* ministryHasDisaster */])(min,_this3.props.feedback)});})),gameState.currentStep===3&&gameState.currentRound<4&&this.state.lowBudgetWarning&&budget<250&&!this.props.gameState.history?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_18_i18n_for_browser__["a" /* __ */])('sim_beperkt_budget_melding'),showIfUnread:gameState.currentRound+'-limitedBudget',closePopUpCross:true,closePopUpClick:function closePopUpClick(){return _this3.setState({lowBudgetWarning:false});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_NextStep__["a" /* default */],null));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_19__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref){var gameState=_ref.gameState,gameStateInput=_ref.gameStateInput,feedback=_ref.feedback,project=_ref.project,policyChoice=_ref.policyChoice;return{gameState:gameState,myState:gameStateInput.myState,feedback:feedback,project:project,policyChoice:policyChoice};})(Home));

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_left_pad__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_left_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_left_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_timer_svg__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClassLeaderTimerController__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_audio_timer_ended_wav__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_audio_timer_ended_wav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_audio_timer_ended_wav__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HeaderCountdown=(_temp=_class=function(_Component){_inherits(HeaderCountdown,_Component);function HeaderCountdown(props){var _this2=this;_classCallCheck(this,HeaderCountdown);var _this=_possibleConstructorReturn(this,(HeaderCountdown.__proto__||Object.getPrototypeOf(HeaderCountdown)).call(this,props));_this.componentWillMount=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(_this.timerPausedAt===null){_this.interval=setInterval(_this.updateTimer.bind(_this,true),1000);}else{_this.updateTimer(false,true);}_context.t0=_this;_context.next=4;return _this.getTimeDifferenceInSeconds();case 4:_context.t1=_context.sent;_context.t2={deltaTimeMs:_context.t1};_context.t0.setState.call(_context.t0,_context.t2);case 7:case"end":return _context.stop();}}},_callee,_this2);}));_this.getTimeDifferenceInSeconds=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_5__apiCall__["a" /* default */])('/define/time');case 2:res=_context2.sent;if(!res){_context2.next=5;break;}return _context2.abrupt("return",new Date(res.time).getTime()-new Date().getTime());case 5:return _context2.abrupt("return",0);case 6:case"end":return _context2.stop();}}},_callee2,_this2);}));_this.state={toggleDropdown:false,timer:'00:00',classLeaderTime:'Timer',deltaTimeMs:0};_this.timerEndsAt=props.schoolClass.timerEndsAt||new Date().toISOString();_this.timerPausedAt=props.schoolClass.timerPausedAt||null;_this.toggleFlipCountDownDropdown=_this.toggleFlipCountDownDropdown.bind(_this);_this.updateTimer=_this.updateTimer.bind(_this);_this.timerEndedSoundRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(HeaderCountdown,[{key:"componentWillUpdate",value:function componentWillUpdate(nextProps,nextState,nextContext){if(this.state.timer==='00:01'&&nextState.timer==='00:00'&&this.timerEndedSoundRef.current){// this.timerEndedSoundRef.current.play();
}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.interval);}},{key:"updateTimer",value:function updateTimer(run){var updateOnce=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;if(this.timerPausedAt&&!updateOnce)return null;// Variable 'run' tells if the timer should be running, or should display the time remaining (because the timer is paused by the school leader).
var diff=void 0;if(run&&this.timerPausedAt===null){var now=new Date(Date.now()+this.state.deltaTimeMs);var end=new Date(this.timerEndsAt);diff=end.getTime()-now.getTime();}else{//Timer is paused get remaining time.
var pausedAt=new Date(this.timerPausedAt).getTime();var endsAt=new Date(this.timerEndsAt).getTime();diff=endsAt-pausedAt;}if(diff>0){var min=Math.floor(diff/1000/60<<0);var sec=Math.floor(diff/1000%60);this.setState({timer:__WEBPACK_IMPORTED_MODULE_2_left_pad___default()(min,2,0)+":"+__WEBPACK_IMPORTED_MODULE_2_left_pad___default()(sec,2,0)});}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(_ref3){var schoolClass=_ref3.schoolClass;if(this.timerEndsAt!==schoolClass.timerEndsAt){this.timerEndsAt=schoolClass.timerEndsAt;if(this.timerEndsAt===null){this.setState({timer:"00:00"});this.updateTimer(false);}else{this.interval=setInterval(this.updateTimer.bind(this,true),1000);}}if(this.timerPausedAt!==schoolClass.timerPausedAt){this.timerPausedAt=schoolClass.timerPausedAt;}}},{key:"toggleFlipCountDownDropdown",value:function toggleFlipCountDownDropdown(){var toggleDropdown=this.state.toggleDropdown;this.setState(function(prevState){return{toggleDropdown:!prevState.toggleDropdown};});if(!toggleDropdown){document.body.classList.add('noScroll');}else{document.body.classList.remove('noScroll');}}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:'timer-dropdown'+(this.state.toggleDropdown?' open':'')+' '+this.props.role},this.props.user.role==='classleader'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:'flipcountdown-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{alt:"timer",src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_timer_svg___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",{className:'timertoggle',onClick:this.toggleFlipCountDownDropdown},this.state.timer),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{className:"arrow-button",onClick:this.toggleFlipCountDownDropdown}),this.props.schoolClass.id?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ClassLeaderTimerController__["a" /* default */],{schoolClassId:this.props.schoolClass.id,timerEndsAt:this.props.schoolClass.timerEndsAt,timerPausedAt:this.props.schoolClass.timerPausedAt,toggleFlipCountDownDropdown:this.toggleFlipCountDownDropdown}):null):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{alt:"timer",src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_timer_svg___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,this.state.timer)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("audio",{ref:this.timerEndedSoundRef,autoPlay:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("source",{src:__WEBPACK_IMPORTED_MODULE_7__assets_audio_timer_ended_wav___default.a,type:"audio/wav"})));}}]);return HeaderCountdown;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(_ref4){var user=_ref4.user,gameState=_ref4.gameState,schoolClass=_ref4.schoolClass,timer=_ref4.timer;return{user:user,gameState:gameState,schoolClass:schoolClass,timer:timer};})(HeaderCountdown));

/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/timer.22bc9cc7.svg";

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClassLeaderTimerView__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCall__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClassLeaderTimerController=(_temp=_class=function(_Component){_inherits(ClassLeaderTimerController,_Component);function ClassLeaderTimerController(props){var _this2=this;_classCallCheck(this,ClassLeaderTimerController);var _this=_possibleConstructorReturn(this,(ClassLeaderTimerController.__proto__||Object.getPrototypeOf(ClassLeaderTimerController)).call(this,props));_this.componentWillMount=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.t0=_this;_context.next=3;return _this.getTimeDifferenceInMs();case 3:_context.t1=_context.sent;_context.t2={serverDelayMs:_context.t1};_context.t0.setState.call(_context.t0,_context.t2);case 6:case'end':return _context.stop();}}},_callee,_this2);}));_this.componentDidMount=function(){var _this$props=_this.props,timerEndsAt=_this$props.timerEndsAt,timerPausedAt=_this$props.timerPausedAt;if(timerPausedAt!==null&&timerEndsAt!==null){//Timer is paused but set
_this.setState({isRunning:false,timerEndsAt:new Date(timerEndsAt),timerPausedAt:new Date(timerPausedAt)},function(){_this.setTimerDigits();});}else if(timerPausedAt===null&&timerEndsAt!==null){//Timer is running
_this.setState({isRunning:true,timerEndsAt:new Date(timerEndsAt)},function(){_this.timerFrame=requestAnimationFrame(_this.countdown);});}else if(timerPausedAt!==null&&timerEndsAt===null){//Something has gone wrong at some point, reset the timer.
_this.saveTimerCleared();}};_this.saveTimerPaused=function(){var schoolClassId=_this.props.schoolClassId;var timerPausedAt=_this.state.timerPausedAt;Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/schoolClass/'+schoolClassId+'/setTimer',{timerPausedAt:timerPausedAt},'PUT');};_this.saveTimerEndsAt=function(){var schoolClassId=_this.props.schoolClassId;var timerEndsAt=_this.state.timerEndsAt;Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/schoolClass/'+schoolClassId+'/setTimer',{timerEndsAt:timerEndsAt,timerPausedAt:null},'PUT');};_this.saveTimerCleared=function(){var schoolClassId=_this.props.schoolClassId;Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/schoolClass/'+schoolClassId+'/setTimer',{timerEndsAt:null,timerPausedAt:null},'PUT');};_this.getTimeDifferenceInMs=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/define/time');case 2:res=_context2.sent;if(!res){_context2.next=5;break;}return _context2.abrupt('return',new Date(res.time).getTime()-new Date().getTime());case 5:return _context2.abrupt('return',0);case 6:case'end':return _context2.stop();}}},_callee2,_this2);}));_this.assertValue=function(val,key,confirmed){if(!confirmed&&val<10&&val>=0||val==="")return true;switch(key){case"minDouble":case"minSingle":case"secSingle":return val<10&&val>=0;case"secDouble":return val<6&&val>=0;default:return false;}};_this.handleInputChange=function(e,key,confirmed){var val=e.target.value;if(val===''){_this.setState(_defineProperty({},key,_this.state[key]));return;}val=parseInt(val,10);if(val===_this.state[key])return;if(isNaN(val)){val=_this.state[key];}// Parsed the value or stored empty string when empty.
var parsedValue=parseInt(val,10)||"";// Checks if value is valid
if(!_this.assertValue(parsedValue,key,confirmed))return;if(val===0)return;// If confirmed and value is string it is changed to a 0
if(confirmed&&val.trim()==="")parsedValue=0;// Saves the value
_this.setState(_defineProperty({},key,parsedValue));};_this.handleClearTimer=function(){cancelAnimationFrame(_this.timerFrame);_this.setState({isRunning:false,timerEndsAt:null,timerPausedAt:null,minDouble:0,minSingle:0,secDouble:0,secSingle:0},function(){_this.saveTimerCleared();});};_this.calculateTimeInMs=function(){// Calculates the inserted time in miliseconds
if(_this.state.timerPausedAt&&_this.state.timerEndsAt){var duration=Math.abs(_this.state.timerPausedAt.getTime()-_this.state.timerEndsAt.getTime());return duration;}var miliseconds=0;miliseconds+=(_this.state.secSingle+_this.state.secDouble*10)*1000;miliseconds+=(_this.state.minSingle+_this.state.minDouble*10)*60000;return miliseconds;};_this.setTimerDigits=function(){var timerEndsAt=_this.state.timerEndsAt;if(!timerEndsAt)return;var endsInMs=timerEndsAt.getTime();var remaining=endsInMs-(_this.state.timerPausedAt?_this.state.timerPausedAt:Date.now()+_this.state.serverDelayMs);if(!isNaN(remaining)){if(remaining<=1000){return _this.handleClearTimer();}var remainingTimeStamp=new Date(remaining);var minutes=(remainingTimeStamp.getHours()-1)/60+remainingTimeStamp.getMinutes()+"";var seconds=remainingTimeStamp.getSeconds()+"";_this.setState({minDouble:parseInt(minutes.length>1?minutes[0]:0,10),minSingle:parseInt(minutes.length>1?minutes[1]:minutes,10),secDouble:parseInt(seconds.length>1?seconds[0]:0,10),secSingle:parseInt(seconds.length>1?seconds[1]:seconds,10)});}};_this.countdown=function(timestamp){if(!_this.lastTimerFrame){_this.lastTimerFrame=timestamp;}if(timestamp-_this.lastTimerFrame>=100){// every 100 ms
_this.setTimerDigits();_this.lastTimerFrame=timestamp;}if(_this.state.isRunning){_this.timerFrame=requestAnimationFrame(_this.countdown);}else{cancelAnimationFrame(_this.timerFrame);}};_this.handleRunningToggle=function(){//Timer is not running
if(!_this.state.isRunning){_this.setState({timerPausedAt:false},function(){var timerDuration=_this.calculateTimeInMs();var timerEndsAt=new Date(Date.now()+timerDuration+_this.state.serverDelayMs);_this.setState({isRunning:true,timerEndsAt:timerEndsAt,timerPausedAt:null},function(){_this.saveTimerEndsAt();_this.timerFrame=requestAnimationFrame(_this.countdown);});});}else{cancelAnimationFrame(_this.timerFrame);_this.setState({isRunning:false,timerPausedAt:new Date()},function(){_this.saveTimerPaused();});}};_this.state={minDouble:0,minSingle:0,secDouble:0,secSingle:0,timerEndsAt:null,timerPausedAt:null,isRunning:false,serverDelayMs:0};_this.lastTimerFrame=0;_this.timeDifferenceMs=0;_this.timerFrame=false;return _this;}_createClass(ClassLeaderTimerController,[{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ClassLeaderTimerView__["a" /* default */],{handleInput:function handleInput(e,key,confirmed){return _this3.handleInputChange(e,key,confirmed);},handleRunningToggle:function handleRunningToggle(){return _this3.handleRunningToggle();},handleClearTimer:function handleClearTimer(){return _this3.handleClearTimer();},minDouble:this.state.minDouble,minSingle:this.state.minSingle,secDouble:this.state.secDouble,secSingle:this.state.secSingle,isRunning:this.state.isRunning,toggleFlipCountDownDropdown:this.props.toggleFlipCountDownDropdown});}}]);return ClassLeaderTimerController;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={schoolClassId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,timerPausedAt:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,timerEndsAt:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any},_class.defaultProps={timerPausedAt:null,timerEndsAt:null},_temp);/* harmony default export */ __webpack_exports__["a"] = (ClassLeaderTimerController);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_repeat_arrow_svg__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_repeat_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_repeat_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_arrow_white_svg__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_arrow_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_arrow_white_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_pause_icon_white_svg__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_pause_icon_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_pause_icon_white_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClassLeaderTimerView=(_temp=_class=function(_Component){_inherits(ClassLeaderTimerView,_Component);function ClassLeaderTimerView(props){_classCallCheck(this,ClassLeaderTimerView);var _this=_possibleConstructorReturn(this,(ClassLeaderTimerView.__proto__||Object.getPrototypeOf(ClassLeaderTimerView)).call(this,props));_this.handleInputChange=function(e,key,confirmed){if(_this.props.isRunning)return;_this.props.handleInput(e,key,confirmed);};_this.handleFocus=function(ev){ev.target.value='';};_this.state={editingInput:false};return _this;}_createClass(ClassLeaderTimerView,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ContentContainer__["a" /* default */],{className:'classLeaderCountdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"heading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globatimer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_begleider_timer_omschrijving'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"timer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"digits"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onFocus:this.handleFocus,type:'number',className:"digit",onChange:function onChange(e){return _this2.handleInputChange(e,"minDouble",false);},onBlur:function onBlur(e){return _this2.handleInputChange(e,"minDouble",true);},value:this.props.minDouble}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onFocus:this.handleFocus,type:'number',className:"digit",onChange:function onChange(e){return _this2.handleInputChange(e,"minSingle",false);},onBlur:function onBlur(e){return _this2.handleInputChange(e,"minSingle",true);},value:this.props.minSingle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:"label"},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_minuut',0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"seperator"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"digits"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onFocus:this.handleFocus,type:'number',className:"digit",onChange:function onChange(e){return _this2.handleInputChange(e,"secDouble",false);},onBlur:function onBlur(e){return _this2.handleInputChange(e,"secDouble",true);},value:this.props.secDouble}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{onFocus:this.handleFocus,type:'number',className:"digit",onChange:function onChange(e){return _this2.handleInputChange(e,"secSingle",false);},onBlur:function onBlur(e){return _this2.handleInputChange(e,"secSingle",true);},value:this.props.secSingle}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:"label"},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_seconde',0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"controls"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){return _this2.props.handleClearTimer();},className:"timerControl red"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_repeat_arrow_svg___default.a,alt:'repeat'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{onClick:function onClick(){return _this2.props.handleRunningToggle();},className:"timerControl blue"},this.props.isRunning?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_pause_icon_white_svg___default.a,alt:'repeat'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_arrow_white_svg___default.a,alt:'repeat'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-color',onClick:this.props.toggleFlipCountDownDropdown}));}}]);return ClassLeaderTimerView;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={minDouble:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,minSingle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,secDouble:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,secSingle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number},_class.defaultProps={minDouble:0,minSingle:0,secDouble:0,secSingle:0},_temp);/* harmony default export */ __webpack_exports__["a"] = (ClassLeaderTimerView);

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/repeat_arrow.2a8156f6.svg";

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/play_arrow_white.b02c4fb8.svg";

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pause_icon_white.fc889eda.svg";

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/timer-ended.5e186aec.wav";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/begeleider.0723f6ab.svg";

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScoreDiv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_medal_svg__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_medal_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_medal_svg__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function numberWithCommas(x){return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g,".");}var ScoreDiv=(_temp=_class=function(_Component){_inherits(ScoreDiv,_Component);function ScoreDiv(props){_classCallCheck(this,ScoreDiv);var _this=_possibleConstructorReturn(this,(ScoreDiv.__proto__||Object.getPrototypeOf(ScoreDiv)).call(this,props));_this.state={text:_this.props.text,showMedal:_this.props.showMedal};return _this;}_createClass(ScoreDiv,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(state){this.setState(_extends({},this.state,state));}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-div'},this.state.showMedal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_2__assets_img_medal_svg___default.a,alt:'medal'}):null,this.state.text?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,numberWithCommas(this.state.text)):null);}}]);return ScoreDiv;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={text:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={showMedal:false},_temp);

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScoreImgDiv; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScoreImgDiv=(_temp=_class=function(_Component){_inherits(ScoreImgDiv,_Component);function ScoreImgDiv(props){_classCallCheck(this,ScoreImgDiv);var _this=_possibleConstructorReturn(this,(ScoreImgDiv.__proto__||Object.getPrototypeOf(ScoreImgDiv)).call(this,props));_this.state={text:_this.props.text,showMedal:_this.props.showMedal};return _this;}_createClass(ScoreImgDiv,[{key:'render',value:function render(){// const iconList = this.props.imgs.map((img, index) =>
//   <img
//     key={index}
//     src={img}
//     alt={'gameState-icon'}/>
// );
// const iconList = this.props.imgs.map((img, index) =>
//   <img
//     key={index}
//     src={img}
//     alt={'group-icon'}/>
// );
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'score-div imgs'},this.props.imgs.map(function(img,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:index,src:img,alt:'gameState-icon'});}));}}]);return ScoreImgDiv;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={imgs:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array.isRequired},_temp);

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map.dfb392b4.svg";

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/list.565f17be.svg";

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_finish_white_svg__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_finish_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_finish_white_svg__);
var desktop=document.querySelector('#root').clientWidth>=1240;var TitleBar=function TitleBar(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'titlebar-outer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'titlebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'stepcircle'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'circle-bg'},props.gameState.currentRound===5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'20px'},src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_finish_white_svg___default.a,alt:'finish-flag'}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_stap'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,props.gameState.currentStep)))),props.gameState!==undefined&&!(Object.entries(props.gameState.stepPopup).length===0&&props.gameState.stepPopup.constructor===Object)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_PopupTitle__["a" /* default */],{popupId:!desktop?props.gameState.stepPopup:'d'+props.gameState.stepPopup.substring(1)}):null));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{gameState:state.gameState};})(TitleBar));

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_svg__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_plus_icon_svg__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_plus_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_plus_icon_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])((_temp=_class=function(_Component){_inherits(BudgetHeaderDropdown,_Component);function BudgetHeaderDropdown(props){_classCallCheck(this,BudgetHeaderDropdown);var _this=_possibleConstructorReturn(this,(BudgetHeaderDropdown.__proto__||Object.getPrototypeOf(BudgetHeaderDropdown)).call(this,props));_this.state={showOverlay:false};_this.toggleDropdown=_this.toggleDropdown.bind(_this);_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(BudgetHeaderDropdown,[{key:'toggleDropdown',value:function toggleDropdown(){this.setState({showOverlay:!this.state.showOverlay});}},{key:'handleClick',value:function handleClick(){if(!this.props.bank){this.toggleDropdown();}else{var path=this.props.match.url;if(path.indexOf('bank')!==-1){this.props.history.goBack();}else{window.sessionStorage.setItem('prevLocation',this.props.history.path);this.props.history.push('/bank');}}}},{key:'render',value:function render(){var active=this.props.active;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-header-dropdown'+(this.state.showOverlay?' show':''),onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'budget-header-overlay'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-dropdown '+(active?'active-item':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'icon',alt:'dropdown-img',src:this.props.icon}),this.props.notification?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'!'))):null,this.props.doubleTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'doubleTitle'},this.props.doubleTitle):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'second-title'},'\xA0\xA0',this.props.title,this.props.doubleTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_miljard')):''),this.props.bank?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.match.url.indexOf('bank')!==-1?'dropdown-link bank-active':'dropdown-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'dropdown-plus',src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_plus_icon_svg___default.a}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'caret'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'dropdown-arrow',src:__WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_svg___default.a}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-content'+(this.state.showOverlay?' show':''),onClick:function onClick(ev){ev.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.props.dropdownTitle),this.props.children));}}]);return BudgetHeaderDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,dropdownTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,bank:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool},_class.defaultProps={active:false},_temp)));

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/caret_down.6a95d665.svg";

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/plus_icon.b6beaa25.svg";

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/save.f9c77b03.svg";

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _addClass = _interopRequireDefault(__webpack_require__(847));

var _removeClass = _interopRequireDefault(__webpack_require__(849));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(324));

var _PropTypes = __webpack_require__(325);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var appearClassName = _this.getClassNames('appear').doneClassName;

      var enterClassName = _this.getClassNames('enter').doneClassName;

      var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames3 = _this.getClassNames('exit'),
          className = _this$getClassNames3.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames4.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames5.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + '-' : '';
      var className = isStringClassNames ? prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? className + '-active' : classNames[type + 'Active'];
      var doneClassName = isStringClassNames ? className + '-done' : classNames[type + 'Done'];
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames6 = this.getClassNames(type),
        className = _this$getClassNames6.className,
        activeClassName = _this$getClassNames6.activeClassName,
        doneClassName = _this$getClassNames6.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or
   * has finished the transition. A single name can be provided and it will be
   * suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`,
   * `fade-enter-done`, `fade-exit`, `fade-exit-active`, `fade-exit-done`,
   * `fade-appear`, `fade-appear-active`, and `fade-appear-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(848));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(32);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(326));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */
var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
        return Hammer;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/map.1b0bb49b.png";

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mapFallout.15bd6fee.png";

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mapCloud_1.ace59773.png";

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/mapCloud_2.9be6f9f2.png";

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Plane.581451ca.png";

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zoom_out.d32786a9.svg";

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/zoom_in.7999257c.svg";

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Balloon_png__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Balloon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Balloon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_balloon_explode_gif__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_balloon_explode_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_balloon_explode_gif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_audio_FB5_4_FB6_2_blop_human_pop_wav__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_audio_FB5_4_FB6_2_blop_human_pop_wav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_audio_FB5_4_FB6_2_blop_human_pop_wav__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Import Assets
 */var BalloonEl=function(_React$Component){_inherits(BalloonEl,_React$Component);function BalloonEl(props){_classCallCheck(this,BalloonEl);var _this2=_possibleConstructorReturn(this,(BalloonEl.__proto__||Object.getPrototypeOf(BalloonEl)).call(this,props));_this2.state={explode:false};_this2.audioRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this2;}_createClass(BalloonEl,[{key:'render',value:function render(){var _this3=this;var explode=this.state.explode;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:!explode?__WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Balloon_png___default.a:__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_balloon_explode_gif___default.a,className:'balloon '+(explode?'explode':''),alt:'balloon',onClick:function onClick(){var _this=_this3;_this3.setState({explode:!explode});setTimeout(function(){if(_this.audioRef&&_this.audioRef.current){_this.audioRef.current.play();}},300);}}),explode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{ref:this.audioRef,autoPlay:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:__WEBPACK_IMPORTED_MODULE_3__assets_audio_FB5_4_FB6_2_blop_human_pop_wav___default.a,type:'audio/wav'})):null);}}]);return BalloonEl;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (BalloonEl);

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/balloon-explode.bfab5fbc.gif";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/FB5-4_FB6-2_blop-human-pop.a553ef5c.wav";

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Bomber_png__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Bomber_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Bomber_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Import Assets
 */var Radiator=function(_React$Component){_inherits(Radiator,_React$Component);function Radiator(props){_classCallCheck(this,Radiator);var _this=_possibleConstructorReturn(this,(Radiator.__proto__||Object.getPrototypeOf(Radiator)).call(this,props));_this.state={explode:false};return _this;}_createClass(Radiator,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__assets_img_mapDecoration_Bomber_png___default.a,className:'bomber',alt:'Bomber'}));}}]);return Radiator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Radiator);

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Bomber.14bddf17.png";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/Bomb_3.2ba13b91.mp3";

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_team_svg__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_EconomyTotal__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_EconomyEarned__ = __webpack_require__(332);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Economy=(_temp=_class=function(_Component){_inherits(Economy,_Component);function Economy(props){_classCallCheck(this,Economy);var _this=_possibleConstructorReturn(this,(Economy.__proto__||Object.getPrototypeOf(Economy)).call(this,props));_this.state={viewComponent:true,economyViewType:_this.props.match.params.id};return _this;}_createClass(Economy,[{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,feedback=_props.feedback;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];if(!gameState.prevRound||!feedback.prevRoundFeedbackData)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'close',showTitle:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container single-economy ministries-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"economy-list"},this.state.viewComponent&&this.state.economyViewType==='total'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_ListButton__["a" /* default */],{bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_totalglobas"),className:'total-economy-list-button',icon:__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,points:0}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_EconomyTotal__["a" /* default */],null)),this.state.viewComponent&&this.state.economyViewType==='earned'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_earnedglobas"),icon:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_team_svg___default.a,globas:currentRoundGameState.earnedGlobas,points:currentRoundGameState.earnedPoints}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_EconomyEarned__["a" /* default */],null)))));}}]);return Economy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["b" /* connect */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,schoolClass=_ref.schoolClass;return{gameState:gameState,feedback:feedback,schoolClass:schoolClass};})(Economy));

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_team_svg__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EconomyOverview=function(_React$Component){_inherits(EconomyOverview,_React$Component);function EconomyOverview(){_classCallCheck(this,EconomyOverview);return _possibleConstructorReturn(this,(EconomyOverview.__proto__||Object.getPrototypeOf(EconomyOverview)).apply(this,arguments));}_createClass(EconomyOverview,[{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,feedback=_props.feedback,group=_props.group;var prevRoundSum=gameState.prevRoundSum;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];var prevRoundFeedbackData=feedback.prevRoundFeedbackData;if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var unreadWinstGlobas=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["B" /* getUnreadWinstGlobas */])(prevRoundFeedbackData).length;var unreadVerliesGlobas=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["A" /* getUnreadVerliesGlobas */])(prevRoundFeedbackData).length;var isStartSituation=group.Rounds.length===2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'cross',viewType:'list',showTitle:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministries-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__["a" /* default */],{popupId:'m'+(gameState.difficulty==='PRO'?'h':'l')+'gvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:{pathname:"/economy/total"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ListButton__["a" /* default */],{bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_totalglobas"),icon:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,points:currentRoundGameState.earnedPoints})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:{pathname:"/economy/earned"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_earnedglobas"),icon:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_team_svg___default.a,globas:currentRoundGameState.earnedGlobas,points:currentRoundGameState.earnedPoints})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:{pathname:"/ministries/overview/profit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_winstglobas'),icon:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_economy_up_globas_svg___default.a,feedbackCount:unreadWinstGlobas,globas:isStartSituation?'-':OneTimeEffect.WG===0?0:'+ '+OneTimeEffect.WG})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:{pathname:"/ministries/overview/loss"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),icon:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadVerliesGlobas,globas:isStartSituation?'-':OneTimeEffect.VG===0?0:'- '+Math.abs(OneTimeEffect.VG)})))));}}]);return EconomyOverview;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{gameState:state.gameState,feedback:state.feedback,group:state.group};})(EconomyOverview));

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Loading__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_visible_png__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_visible_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_visible_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_invisible_png__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_invisible_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_invisible_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_login_logo_png__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_login_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_login_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_PopUp__ = __webpack_require__(14);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Import components
 */var login=__WEBPACK_IMPORTED_MODULE_3__actions__["a" /* default */].user.login;var Login=(_temp=_class=function(_Component){_inherits(Login,_Component);function Login(props){_classCallCheck(this,Login);Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["e" /* setLocale */])("en");var _this=_possibleConstructorReturn(this,(Login.__proto__||Object.getPrototypeOf(Login)).call(this,props));_this.handleRedirect=function(){var redirect=new URL(window.location.href).searchParams.get('redirect');if(redirect){return window.location.href=redirect;}window.location.href='/portal';};_this.handleChange=function(ev){var _this$setState;var target=ev.target;var value=target.value,name=target.name;_this.setState((_this$setState={},_defineProperty(_this$setState,name,value),_defineProperty(_this$setState,'loading',false),_defineProperty(_this$setState,'loginFailed',false),_this$setState));};_this.handleSubmit=function(ev){ev.preventDefault();ev.stopPropagation();var _this$state=_this.state,username=_this$state.username,password=_this$state.password;if(!username||!password)return false;Object(__WEBPACK_IMPORTED_MODULE_9__components_apiCall__["a" /* default */])('/user/alreadyLoggedIn',{username:username,password:password},'POST').then(function(_ref){var alreadyLoggedIn=_ref.alreadyLoggedIn,lang=_ref.lang;if(lang){Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["e" /* setLocale */])(lang);}if(!alreadyLoggedIn){_this.handleLogin();}_this.setState({alreadyLoggedIn:alreadyLoggedIn});}).catch(function(err){console.warn(err);});return false;// this.handleLogin();
};_this.handleLogin=function(){sessionStorage.removeItem('redirect');sessionStorage.removeItem('prevLocation');sessionStorage.removeItem('noMobile');_this.setState({loading:true,alreadyLoggedIn:false});var _this$state2=_this.state,username=_this$state2.username,password=_this$state2.password;_this.props.dispatch(login(username,password)).then(function(result){if(!result){_this.setState({loginFailed:true,loading:false});}else{_this.setState({loginFailed:false,loading:false});}});};_this.state={user:_this.props.user,username:'',password:'',loginFailed:false,passwordVisibility:false,alreadyLoggedIn:false,loggedOutBySomeoneElse:sessionStorage.getItem('tweedeinlog')==='true'};_this.handleSubmit=_this.handleSubmit.bind(_this);return _this;}_createClass(Login,[{key:'componentWillMount',value:function componentWillMount(){var token=new URL(window.location.href).searchParams.get('token');/**
     * NOTE: Here we make the assumption that only admin's / classleaders use a token in the URL to log in.
     * This is the case, but keep this in mind when something has to be implemented which would invalidate this.
     */if(token){sessionStorage.setItem('governAsClassleader',true);this.props.dispatch(login(null,null,token));}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(_ref2){var user=_ref2.user;this.setState({user:user});}/**
   * Method to handle on change events for input elements
   *//**
   * Method to handle login form submit
   */},{key:'render',value:function render(){var _this2=this;var state=this.state;if(this.props.user.loggedIn){this.handleRedirect();return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-parent'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'login-logo',src:__WEBPACK_IMPORTED_MODULE_8__assets_img_login_logo_png___default.a,alt:'Globaland XL Logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{action:'/login',method:'post',className:'content-container',onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',placeholder:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_gebruikersnaam"),name:'username',onChange:this.handleChange,value:this.state.username})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{name:'password',placeholder:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_wachtwoord"),type:this.state.passwordVisibility?'text':'password',onChange:this.handleChange,value:this.state.password}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'password-visibility-container',style:{background:'transparent',height:'40px',position:'absolute',right:0,top:0,borderRadius:'16px',display:'flex',padding:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.passwordVisibility?__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_visible_png___default.a:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_invisible_png___default.a,alt:'toggle visibility',onClick:function onClick(){_this2.setState({passwordVisibility:!_this2.state.passwordVisibility});},style:{width:'20px',justifySelf:'center',alignSelf:'center',cursor:'pointer'}})),state.loginFailed?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-failed'},Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_inloggegevens_niet_correct_melding')):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_inloggen'))))),state.alreadyLoggedIn?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_PopUp__["a" /* default */],{id:'dlgmtweedeinlog',closePopUpClick:function closePopUpClick(res){if(res){return _this2.handleLogin();}_this2.setState({alreadyLoggedIn:false});}}):null,state.loading?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_Loading__["a" /* default */],null):null,state.loggedOutBySomeoneElse?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_PopUp__["a" /* default */],{id:'dlgmtweedeinlog_1',showPopUp:true,closePopUpClick:function closePopUpClick(){sessionStorage.setItem('tweedeinlog','');_this2.setState({loggedOutBySomeoneElse:false});}}):null);}}]);return Login;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={dispatch:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(user){return user;})(Login));

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/login-logo.ef902ade.png";

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ministriesHelper__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_up_min_globas_svg__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_up_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_up_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_sparen_bank_svg__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_sparen_bank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_sparen_bank_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var submitMyState=__WEBPACK_IMPORTED_MODULE_22__actions__["a" /* default */].gameStateInput.submitMyState;/**
 * Import assets
 */var Ministries=(_temp=_class=function(_DifficultyAwareCompo){_inherits(Ministries,_DifficultyAwareCompo);function Ministries(props){_classCallCheck(this,Ministries);var _this=_possibleConstructorReturn(this,(Ministries.__proto__||Object.getPrototypeOf(Ministries)).call(this,props));_this.toggleOverviewPopUp=function(){_this.setState({showOverview:!_this.state.showOverview});};_this.allowSave=function(){var _this$props=_this.props,gameState=_this$props.gameState,gameStateInput=_this$props.gameStateInput,policyChoice=_this$props.policyChoice;if(gameState.difficulty==='BASIC'&&Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,gameStateInput.myState.policyChoices,_this.props.project.minPolicyChoices)>0){return false;}return true;};_this.state={showWarning:'',showWarningId:'',showOverview:false};return _this;}_createClass(Ministries,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,gameState=_props.gameState,dispatch=_props.dispatch,project=_props.project;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(currentRound===1&&gameState.currentStep===1){Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtlandbesturen1_T1':'mlgvtlandbesturen1_T1',dispatch);}if(currentRound===2&&gameState.currentStep===1){Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtlandbesturen2_T1':'mlgvtlandbesturen2_T1',dispatch,true);}if(currentRound===1&&gameState.currentStep===3){Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtbudgetverdelen_T1':'mlgvtbudgetverdelen_T1',dispatch);}if(window.scrollToMinistry){var ministryElement=document.getElementById('scrollto-'+window.scrollToMinistry);if(ministryElement){var y=ministryElement.getBoundingClientRect().top+window.pageYOffset;var yOffset=-50;window.scrollTo({top:y+yOffset});}}window.scrollToMinistry=undefined;}},{key:'renderLaag',value:function renderLaag(){var _this2=this;var _props2=this.props,gameState=_props2.gameState,gameStateInput=_props2.gameStateInput,feedback=_props2.feedback,policyChoice=_props2.policyChoice,group=_props2.group;var prevRoundSum=gameState.prevRoundSum;var _gameStateInput$mySta=gameStateInput.myState,ministerieGlobaVerdeling=_gameStateInput$mySta.ministerieGlobaVerdeling,ministryCollaborations=_gameStateInput$mySta.ministryCollaborations,policyChoices=_gameStateInput$mySta.policyChoices;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];var prevRoundFeedbackData=feedback.prevRoundFeedbackData;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,policyChoices,ministerieGlobaVerdeling,savingsAndLoans,policyChoice);if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var unreadWinstGlobas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["B" /* getUnreadWinstGlobas */])(prevRoundFeedbackData).length;var unreadVerliesGlobas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["A" /* getUnreadVerliesGlobas */])(prevRoundFeedbackData).length;var isStartSituation=group.Rounds.length===2;var _gameState$gameStateS=gameState.gameStateSum,remainingSavingsPoints=_gameState$gameStateS.remainingSavingsPoints,remainingProfitLossPoints=_gameState$gameStateS.remainingProfitLossPoints;console.log(gameState.gameStateSum);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_Header__["a" /* default */],{match:this.props.match,history:this.props.history,historic:false,buttonType:'view',viewType:'list',showBudget:gameState.currentStep===3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministries-list'},gameState.currentStep===3?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__["a" /* default */],{popupId:'mlgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:"/economy/total"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{className:'total-economy-list-button',bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])("sim_totalglobas"),icon:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,points:currentRoundGameState.earnedPoints})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:!(currentRound===5)?{pathname:"/economy/earned"}:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])("sim_earnedglobas"),icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg___default.a,globas:currentRound===5?'-':currentRoundGameState.earnedGlobas,points:currentRound===5?'-':currentRoundGameState.earnedPoints})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:"/ministries/overview/profit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_winstglobas'),icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default.a,feedbackCount:unreadWinstGlobas,globas:isStartSituation?'-':OneTimeEffect.WG===0?0:'+ '+OneTimeEffect.WG})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:"/ministries/overview/loss"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadVerliesGlobas,globas:isStartSituation?'-':OneTimeEffect.VG===0?0:'- '+-OneTimeEffect.VG}))),gameState.currentStep===1&&gameState.currentRound<=1?null:this.props.project.minPolicyChoices>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__["a" /* default */],{popupId:'mlgvtstap3beleidskeuzes',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:'/beleidskeuzes',onClick:function onClick(){sessionStorage.setItem('toMin','list');/* 🤮🤮🤮 */}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),className:"beleidskeuze-listbutton-laag",icon:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg___default.a,feedbackCount:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,gameStateInput.myState.policyChoices,this.props.project.minPolicyChoices):Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData),null,true),arrow:true,redNotification:gameState.currentStep===3,points:gameState.currentStep===1?Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["v" /* getPolicyChoiceTotalPoints */])(feedback.prevRoundFeedbackData):false,globas:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["k" /* getTotalCosts */])(gameStateInput.myState.policyChoices,policyChoice):undefined}))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__["a" /* default */],{popupId:'mlgvtministeries',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */]['basic'].ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{key:min,to:'/ministries/'+(gameState.currentStep===3?'budget/':'')+min.toLowerCase(),onClick:function onClick(){sessionStorage.setItem('toMin','list');/* 🤮🤮🤮 */}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{ministry:min,title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])(min),icon:__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].icons[min],arrow:true,points:gameState.currentStep===1?prevRoundSum?prevRoundSum[min+'_points']+'':'...':false,global:__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].i18nMinistries.includes(min),globas:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(ministerieGlobaVerdeling,min,gameState.currentStep),collaboration:gameState.currentStep===1?ministryCollaborations[min]:ministerieGlobaVerdeling[min+'SW']}));})),remainingSavingsPoints>0||remainingProfitLossPoints!==0&&!gameState.history?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overige-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtoverzicht_overige',tag:'h3'}),remainingSavingsPoints>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_overige_spaargeld'),icon:__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_sparen_bank_svg___default.a,arrow:true,points:remainingSavingsPoints}):null,remainingProfitLossPoints!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_overige_wgvg'),icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_up_min_globas_svg___default.a,arrow:true,points:remainingProfitLossPoints}):null):null,this.props.gameState.roundData.state==='SIMULATION_SPENDING'&&this.props.gameStateInput.myState.SIMULATION_SPENDING!=='PROCESSED'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonWrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.toggleOverviewPopUp,className:'button button--blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_overzicht_verdeling'))),this.state.showOverview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopUp__["a" /* default */],{interactive:true,showPopUp:true,closePopUpCross:true,closePopUpClick:this.toggleOverviewPopUp},Object(__WEBPACK_IMPORTED_MODULE_12__helpers_ministriesHelper__["a" /* getOverviewData */])(this.props)):null,this.props.user.role==='groupleader'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){ev.preventDefault();if(globas!==0){_this2.setState({showWarningId:'dlgmstap3verdelingopslaan'});return;}if(globas===0&&!_this2.allowSave()){_this2.setState({showWarningId:'dlgmstap3verdelingopslaan_1'});return;}// @todo conditional
if(globas===0&&_this2.allowSave()&&_this2.props.user.role==='groupleader'&&!_this2.props.gameStateInput.preventInputChanges){_this2.props.dispatch(submitMyState('SIMULATION_SPENDING'));}},className:'button'+(globas===0&&this.allowSave()&&!this.props.gameStateInput.preventInputChanges?'':' disabled pointer-events')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_verdling_opslaan_button'))):null):null),this.state.showWarning.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])(this.state.showWarning),closePopUpClick:function closePopUpClick(){return _this2.setState({showWarning:''});}}):null,this.state.showWarningId.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_warning_svg___default.a,popUpFooter:true,id:this.state.showWarningId,closePopUpClick:function closePopUpClick(){return _this2.setState({showWarningId:''});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_NextStep__["a" /* default */],null));}},{key:'renderHoog',value:function renderHoog(){var _this3=this;var _props3=this.props,gameState=_props3.gameState,gameStateInput=_props3.gameStateInput,feedback=_props3.feedback,group=_props3.group;var prevRoundSum=gameState.prevRoundSum;var _gameStateInput$mySta2=gameStateInput.myState,ministerieGlobaVerdeling=_gameStateInput$mySta2.ministerieGlobaVerdeling,policyChoices=_gameStateInput$mySta2.policyChoices;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];var prevRoundFeedbackData=feedback.prevRoundFeedbackData;if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["b" /* calculateBudgetPRO */])(gameState,gameStateInput,policyChoices,ministerieGlobaVerdeling,savingsAndLoans);var policyChoicesArray=Object.values(gameStateInput.myState.policyChoices);var isStartSituation=group.Rounds.length===2;var unreadWinstGlobas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["B" /* getUnreadWinstGlobas */])(prevRoundFeedbackData).length;var unreadVerliesGlobas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["A" /* getUnreadVerliesGlobas */])(prevRoundFeedbackData).length;var _gameState$gameStateS2=gameState.gameStateSum,remainingSavingsPoints=_gameState$gameStateS2.remainingSavingsPoints,remainingProfitLossPoints=_gameState$gameStateS2.remainingProfitLossPoints;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_Header__["a" /* default */],{match:this.props.match,history:this.props.history,historic:false,buttonType:'view',viewType:'list',showBudget:gameState.currentStep===3}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministries-list'},gameState.currentStep===3?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__["a" /* default */],{popupId:'mhgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:"/economy/total"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{className:'total-economy-list-button',bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])("sim_totalglobas"),icon:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,points:currentRoundGameState.earnedPoints})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:!(currentRound===5)?{pathname:"/economy/earned"}:{}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])("sim_earnedglobas"),icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg___default.a,globas:currentRound===5?'-':currentRoundGameState.earnedGlobas,points:currentRound===5?'-':currentRoundGameState.earnedPoints})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:"/ministries/overview/profit"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_winstglobas'),icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default.a,feedbackCount:unreadWinstGlobas,globas:isStartSituation?'-':OneTimeEffect.WG===0?0:'+ '+OneTimeEffect.WG})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{to:{pathname:"/ministries/overview/loss"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadVerliesGlobas,globas:isStartSituation?'-':OneTimeEffect.VG===0?0:'- '+-OneTimeEffect.VG}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtministeries',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */]['pro'].ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["a" /* Link */],{key:min,to:'/ministries/'+(gameState.currentStep===3?'budget/':'')+min.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{ministry:min,title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])(min),icon:__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].icons[min],arrow:true,stars:__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].ministeryStars[min],globas:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(ministerieGlobaVerdeling,min,gameState.currentStep,policyChoicesArray),points:gameState.currentStep===1?prevRoundSum?prevRoundSum[min+'_points']+'':0:false,global:__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].i18nMinistries.includes(min),budgetSet:ministerieGlobaVerdeling[min]&&gameState.currentStep>1,policySet:policyChoicesArray.find(function(choice){return choice.ministry===min&&choice.selected;})&&gameState.currentStep>1,disaster:false}));})),remainingSavingsPoints>0||remainingProfitLossPoints!==0&&!gameState.history?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overige-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtoverzicht_overige',tag:'h3'}),remainingSavingsPoints>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_overige_spaargeld'),icon:__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_sparen_bank_svg___default.a,arrow:true,points:remainingSavingsPoints}):null,remainingProfitLossPoints!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_overige_wgvg'),icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_up_min_globas_svg___default.a,arrow:true,points:remainingProfitLossPoints}):null):null,this.props.gameState.roundData.state==='SIMULATION_SPENDING'&&this.props.gameStateInput.myState.SIMULATION_SPENDING!=='PROCESSED'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonWrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.toggleOverviewPopUp,className:'button button--blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_overzicht_verdeling'))),this.state.showOverview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopUp__["a" /* default */],{interactive:true,showPopUp:true,closePopUpCross:true,closePopUpClick:this.toggleOverviewPopUp},Object(__WEBPACK_IMPORTED_MODULE_12__helpers_ministriesHelper__["a" /* getOverviewData */])(this.props)):null,this.props.user.role==='groupleader'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:function onClick(ev){ev.preventDefault();if(globas!==0){_this3.setState({showWarningId:'mhgmstap3verdelingopslaan'});return;}// @todo conditional
if(globas===0&&!_this3.props.gameStateInput.preventInputChanges){_this3.props.dispatch(submitMyState('SIMULATION_SPENDING'));}},className:'button'+(globas===0&&!this.props.gameStateInput.preventInputChanges?'':' disabled pointer-events')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])('sim_verdling_opslaan_button'))):null):null),this.state.showWarning.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_6_i18n_for_browser__["a" /* __ */])(this.state.showWarning),closePopUpClick:function closePopUpClick(){return _this3.setState({showWarning:''});}}):null,this.state.showWarningId.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_warning_svg___default.a,popUpFooter:true,id:this.state.showWarningId,closePopUpClick:function closePopUpClick(){return _this3.setState({showWarningId:''});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_NextStep__["a" /* default */],null));}}]);return Ministries;}(__WEBPACK_IMPORTED_MODULE_14__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return state;})(Ministries));

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_assets_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_redux_es_connect_connect__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var Ministry=(_temp=_class=function(_DifficultyAwareCompo){_inherits(Ministry,_DifficultyAwareCompo);function Ministry(props){_classCallCheck(this,Ministry);var _this=_possibleConstructorReturn(this,(Ministry.__proto__||Object.getPrototypeOf(Ministry)).call(this,props));_this.state={ministry:_this.props.match.params.id.toUpperCase()};return _this;}_createClass(Ministry,[{key:'renderLaag',value:function renderLaag(){var _this2=this;var gameState=this.props.gameState;var prevRoundSum=gameState.prevRoundSum;var ministry=this.state.ministry;if(!prevRoundSum)return null;var fb=this.props.feedback.prevRoundFeedbackData.find(function(fb){return fb.ministerie===_this2.state.ministry;});if(fb){this.props.history.replace('/ministries/'+ministry+'/'+fb.omschrijving);}else{this.props.history.goBack();}return null;}},{key:'renderHoog',value:function renderHoog(){var gameState=this.props.gameState;var prevRoundSum=gameState.prevRoundSum;var ministry=this.state.ministry;if(!prevRoundSum)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{match:this.props.match,history:this.props.history,historic:false,buttonType:'close',viewType:'list',showTitle:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{ministry:ministry,title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(this.state.ministry),icon:__WEBPACK_IMPORTED_MODULE_8__assets_assets_js__["g" /* ministryIcons */][this.state.ministry],arrow:true,stars:__WEBPACK_IMPORTED_MODULE_4__Defines__["a" /* default */].ministeryStars[this.state.ministry],points:prevRoundSum?prevRoundSum[this.state.ministry+'_points']+'':'...',popupId:__WEBPACK_IMPORTED_MODULE_4__Defines__["a" /* default */].ministryPopupIds.pro[this.state.ministry],global:__WEBPACK_IMPORTED_MODULE_4__Defines__["a" /* default */].i18nMinistries.includes(this.state.ministry),disaster:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},Object(__WEBPACK_IMPORTED_MODULE_9__helpers_feedbackHelpers__["F" /* renderMinistryFeedbackList */])(this.props.feedback.prevRoundFeedbackData,this.state.ministry,this.props.gameState,this.props.gameStateInput))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}}]);return Ministry;}(__WEBPACK_IMPORTED_MODULE_6__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,gameStateInput=_ref.gameStateInput,project=_ref.project;return{gameState:gameState,feedback:feedback,gameStateInput:gameStateInput,project:project};})(Ministry));

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_SectionHeading__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_StepThree_BudgetSlider__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_StepThree_MinistryFeedbackStatus__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_StepThree_BudgetCollaboration__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_StepThree_PolicyElement__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_globas_svg__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_beleidskeuze_svg__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_beleidskeuze_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_beleidskeuze_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__elements_PopUp__ = __webpack_require__(14);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updateMyState=__WEBPACK_IMPORTED_MODULE_20__actions__["c" /* gameStateInput */].updateMyState;/**
 * Import assets
 */var MinistryBudget=(_temp=_class=function(_DifficultyAwareCompo){_inherits(MinistryBudget,_DifficultyAwareCompo);function MinistryBudget(props){_classCallCheck(this,MinistryBudget);var _this=_possibleConstructorReturn(this,(MinistryBudget.__proto__||Object.getPrototypeOf(MinistryBudget)).call(this,props));_this.state={ministry:_this.props.match.params.id.toUpperCase(),allChoicesMadePopup:false};_this.maxVal=undefined;return _this;}_createClass(MinistryBudget,[{key:'renderLaag',value:function renderLaag(){var _props=this.props,gameState=_props.gameState,myState=_props.myState,dispatch=_props.dispatch,policyChoice=_props.policyChoice,loaded=_props.loaded,gameStateInput=_props.gameStateInput;var ministry=this.state.ministry;var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling,policyChoices=myState.policyChoices;var globas=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,policyChoices,ministerieGlobaVerdeling,Object(__WEBPACK_IMPORTED_MODULE_12__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput),policyChoice);var international=__WEBPACK_IMPORTED_MODULE_19__Defines__["a" /* default */].i18nMinistries.includes(ministry);if(!this.maxVal&&loaded){if(globas+(ministerieGlobaVerdeling[ministry]||0)>20){this.maxVal=20;}else{this.maxVal=globas+(ministerieGlobaVerdeling[ministry]||0);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{match:this.props.match,history:this.props.history,historic:false,buttonType:'close',viewType:'list',showTitle:false,showBudget:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-budget-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ListButton__["a" /* default */],{ministry:ministry,title:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])(ministry),icon:__WEBPACK_IMPORTED_MODULE_18__assets_assets__["g" /* ministryIcons */][ministry],arrow:true,points:false,globas:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(ministerieGlobaVerdeling,ministry,gameState.currentStep),popupId:__WEBPACK_IMPORTED_MODULE_19__Defines__["a" /* default */].ministryPopupIds.pro[ministry],global:__WEBPACK_IMPORTED_MODULE_19__Defines__["a" /* default */].i18nMinistries.includes(ministry),disaster:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_StepThree_MinistryFeedbackStatus__["a" /* default */],{ministry:this.state.ministry}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_SectionHeading__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_globas_svg___default.a,title:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["b" /* __n */])('sim_budgetkeuze',1),popupId:'mhgvtbudgetkeuze'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'popup-heading'},Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])("sim_vraag_hoeveel_globas_aan_ministerie")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_StepThree_BudgetSlider__["a" /* default */],{role:this.props.user.role,key:ministry,unit:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])('sim_miljard'),disabled:globas<0,value:ministerieGlobaVerdeling[ministry]||0,customOnChange:function customOnChange(k,v){var globasLeft=globas+(ministerieGlobaVerdeling[ministry]||0)-v;if(globasLeft>=0||v<(ministerieGlobaVerdeling[ministry]||0)){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,v))}));return;}if(globasLeft<0){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,(ministerieGlobaVerdeling[ministry]||0)+globas))}));}},min:0,max:this.maxVal,ignoreMax:true}),international?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_StepThree_BudgetCollaboration__["a" /* default */],{value:ministerieGlobaVerdeling[ministry+'SW'],customOnChange:function customOnChange(k,v){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry+'SW',v))}));},title:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')+':'}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}},{key:'renderHoog',value:function renderHoog(){var _this2=this;var _props2=this.props,gameStateInput=_props2.gameStateInput,gameState=_props2.gameState,myState=_props2.myState,dispatch=_props2.dispatch,policyChoice=_props2.policyChoice,loaded=_props2.loaded;var ministry=this.state.ministry;var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling,policyChoices=myState.policyChoices;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_calculationsHelper__["b" /* calculateBudgetPRO */])(gameState,gameStateInput,policyChoices,myState.ministerieGlobaVerdeling,savingsAndLoans);var international=__WEBPACK_IMPORTED_MODULE_19__Defines__["a" /* default */].i18nMinistries.includes(ministry);if(!this.maxVal&&loaded){if(globas+(ministerieGlobaVerdeling[ministry]||0)>100){this.maxVal=100;}else{this.maxVal=globas+(ministerieGlobaVerdeling[ministry]||0);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{history:this.props.history,match:this.props.match,historic:false,buttonType:'close',viewType:'list',showTitle:false,showBudget:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-budget-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ListButton__["a" /* default */],{ministry:ministry,title:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])(ministry),icon:__WEBPACK_IMPORTED_MODULE_18__assets_assets__["g" /* ministryIcons */][ministry],arrow:true,stars:__WEBPACK_IMPORTED_MODULE_19__Defines__["a" /* default */].ministeryStars[ministry],points:false,globas:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(ministerieGlobaVerdeling,ministry,gameState.currentStep,Object.values(policyChoices)),popupId:__WEBPACK_IMPORTED_MODULE_19__Defines__["a" /* default */].ministryPopupIds.pro[ministry],global:__WEBPACK_IMPORTED_MODULE_19__Defines__["a" /* default */].i18nMinistries.includes(ministry),disaster:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_StepThree_MinistryFeedbackStatus__["a" /* default */],{ministry:this.state.ministry}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_SectionHeading__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_globas_svg___default.a,title:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["b" /* __n */])('sim_budgetkeuze',1),popupId:'mhgvtbudgetkeuze'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{className:'pro-no-margin-slider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_StepThree_BudgetSlider__["a" /* default */],{role:this.props.user.role,unit:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])('sim_miljard'),disabled:globas<0,value:ministerieGlobaVerdeling[ministry]||0,customOnChange:function customOnChange(k,v){var globasLeft=globas+(ministerieGlobaVerdeling[ministry]||0)-v;if(globasLeft>=0||v<(ministerieGlobaVerdeling[ministry]||0)){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,v))}));return;}if(globasLeft<0){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,(ministerieGlobaVerdeling[ministry]||0)+globas))}));}},min:0,max:this.maxVal,ignoreMax:true}),international?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_StepThree_BudgetCollaboration__["a" /* default */],{value:ministerieGlobaVerdeling[ministry+'SW'],customOnChange:function customOnChange(k,v){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry+'SW',v))}));},title:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')+':'}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_SectionHeading__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_beleidskeuze_svg___default.a,title:Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',1),popupId:'mhgvtbeleidskeuzes'}),Object(__WEBPACK_IMPORTED_MODULE_13__helpers_policyChoiceHelper__["m" /* policiesForMinisterie */])(policyChoice,ministry).map(function(choice,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_StepThree_PolicyElement__["a" /* default */],{key:ministry+choice.Nummer+key,title:choice['titel_beleidskeuze_'+gameState.language],globas:parseInt(choice.kosten_globas[0],10),collaborationGlobas:choice.kosten_globas.length>1?parseInt(choice.kosten_globas[1],10):0,value:policyChoices[choice.omschrijving]||{},onChange:function onChange(v){if(v.selected===false){delete policyChoices[choice.omschrijving];dispatch(updateMyState({policyChoices:policyChoices}));}else{var newPolicyChoices=_extends({},policyChoices,_defineProperty({},choice.omschrijving,_extends({},v,{ministry:ministry,nummer:choice.Nummer})));var numChoices=Object(__WEBPACK_IMPORTED_MODULE_13__helpers_policyChoiceHelper__["h" /* getSelectedPolicyChoicesCount */])(newPolicyChoices);if(numChoices>10){_this2.setState({allChoicesMadePopup:true});return;}if(v.option&&globas-v.globas<0){return;}_this2.maxVal=undefined;dispatch(updateMyState({policyChoices:newPolicyChoices}));}}},choice['tekst_beleidskeuze_'+gameState.language]);})),this.state.allChoicesMadePopup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__elements_PopUp__["a" /* default */],{interactive:true,closePopUpCross:true,closePopUpClick:function closePopUpClick(){_this2.setState({allChoicesMadePopup:false});}},Object(__WEBPACK_IMPORTED_MODULE_17_i18n_for_browser__["a" /* __ */])('sim_maximum_beleidskeuzes_bereikt')):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}}]);return MinistryBudget;}(__WEBPACK_IMPORTED_MODULE_4__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_16_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var user=_ref.user,gameState=_ref.gameState,feedback=_ref.feedback,gameStateInput=_ref.gameStateInput,policyChoice=_ref.policyChoice,project=_ref.project;return{user:user,policyChoice:policyChoice,gameState:gameState,feedback:feedback,project:project,loaded:gameStateInput.loaded,myState:gameStateInput.myState,gameStateInput:gameStateInput};})(MinistryBudget));

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Range__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Handle__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__ = __webpack_require__(909);
/* unused harmony reexport Range */
/* unused harmony reexport Handle */
/* unused harmony reexport createSliderWithTooltip */





__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Range = __WEBPACK_IMPORTED_MODULE_1__Range__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].Handle = __WEBPACK_IMPORTED_MODULE_2__Handle__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */].createSliderWithTooltip = __WEBPACK_IMPORTED_MODULE_3__createSliderWithTooltip__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Slider__["a" /* default */]);


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Track__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_createSlider__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(183);





/* eslint-disable react/prop-types */







var Slider = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Slider, _React$Component);

  function Slider(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Slider);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

    _this.onEnd = function () {
      _this.setState({ dragging: false });
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
    var value = props.value !== undefined ? props.value : defaultValue;

    _this.state = {
      value: _this.trimAlignValue(value),
      dragging: false
    };
    if (false) {
      warning(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecate, please use trackStyle instead.');
      warning(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecate, please use railStyle instead.');
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Slider, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          autoFocus = _props.autoFocus,
          disabled = _props.disabled;

      if (autoFocus && !disabled) {
        this.focus();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;

      var prevValue = this.state.value;
      var value = nextProps.value !== undefined ? nextProps.value : prevValue;
      var nextValue = this.trimAlignValue(value, nextProps);
      if (nextValue === prevValue) return;

      this.setState({ value: nextValue });
      if (__WEBPACK_IMPORTED_MODULE_10__utils__["i" /* isValueOutOfRange */](value, nextProps)) {
        this.props.onChange(nextValue);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      }

      var changedValue = state.value;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      this.setState({ dragging: true });
      var props = this.props;
      var prevValue = this.getValue();
      props.onBeforeChange(prevValue);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      if (value === prevValue) return;

      this.prevMovedHandleIndex = 0;

      this.onChange({ value: value });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
      var oldValue = this.state.value;

      var value = this.calcValueByPos(position);
      if (value === oldValue) return;

      this.onChange({ value: value });
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var valueMutator = __WEBPACK_IMPORTED_MODULE_10__utils__["d" /* getKeyboardValueMutator */](e);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_10__utils__["j" /* pauseEvent */](e);
        var state = this.state;
        var oldValue = state.value;
        var mutatedValue = valueMutator(oldValue, this.props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;

        this.onChange({ value: value });
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.value;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.props.min;
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      return this.state.value;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v) {
      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var mergedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
      var val = __WEBPACK_IMPORTED_MODULE_10__utils__["a" /* ensureValueInRange */](v, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_10__utils__["b" /* ensureValuePrecision */](val, mergedProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          vertical = _props2.vertical,
          included = _props2.included,
          disabled = _props2.disabled,
          minimumTrackStyle = _props2.minimumTrackStyle,
          trackStyle = _props2.trackStyle,
          handleStyle = _props2.handleStyle,
          tabIndex = _props2.tabIndex,
          min = _props2.min,
          max = _props2.max,
          handleGenerator = _props2.handle;
      var _state = this.state,
          value = _state.value,
          dragging = _state.dragging;

      var offset = this.calcOffset(value);
      var handle = handleGenerator({
        className: prefixCls + '-handle',
        prefixCls: prefixCls,
        vertical: vertical,
        offset: offset,
        value: value,
        dragging: dragging,
        disabled: disabled,
        min: min,
        max: max,
        index: 0,
        tabIndex: tabIndex,
        style: handleStyle[0] || handleStyle,
        ref: function ref(h) {
          return _this2.saveHandle(0, h);
        }
      });

      var _trackStyle = trackStyle[0] || trackStyle;
      var track = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Track__["a" /* default */], {
        className: prefixCls + '-track',
        vertical: vertical,
        included: included,
        offset: 0,
        length: offset,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, minimumTrackStyle, _trackStyle)
      });

      return { tracks: track, handles: handle };
    }
  }]);

  return Slider;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Slider.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  value: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  autoFocus: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__common_createSlider__["a" /* default */])(Slider));

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(877), __esModule: true };

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(878);
module.exports = __webpack_require__(33).Object.assign;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(56);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(879) });


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(59);
var getKeys = __webpack_require__(89);
var gOPS = __webpack_require__(159);
var pIE = __webpack_require__(109);
var toObject = __webpack_require__(79);
var IObject = __webpack_require__(216);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(78)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(881), __esModule: true };

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(882);
module.exports = __webpack_require__(33).Object.setPrototypeOf;


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(56);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(883).set });


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(77);
var anObject = __webpack_require__(69);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(148)(Function.call, __webpack_require__(160).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(885), __esModule: true };

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(886);
var $Object = __webpack_require__(33).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(56);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(150) });


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(888);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(891);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(889), __esModule: true };

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(890);
module.exports = __webpack_require__(33).Object.getPrototypeOf;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(79);
var $getPrototypeOf = __webpack_require__(223);

__webpack_require__(156)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(892), __esModule: true };

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(893);
var $Object = __webpack_require__(33).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(68);
var $getOwnPropertyDescriptor = __webpack_require__(160).f;

__webpack_require__(156)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(895);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(896);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(98);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);







var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
  __WEBPACK_IMPORTED_MODULE_5_warning___default()(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
  var points = Object.keys(marks).map(parseFloat);
  if (dots) {
    for (var i = min; i <= max; i += step) {
      if (points.indexOf(i) === -1) {
        points.push(i);
      }
    }
  }
  return points;
};

var Steps = function Steps(_ref) {
  var prefixCls = _ref.prefixCls,
      vertical = _ref.vertical,
      marks = _ref.marks,
      dots = _ref.dots,
      step = _ref.step,
      included = _ref.included,
      lowerBound = _ref.lowerBound,
      upperBound = _ref.upperBound,
      max = _ref.max,
      min = _ref.min,
      dotStyle = _ref.dotStyle,
      activeDotStyle = _ref.activeDotStyle;

  var range = max - min;
  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
    var _classNames;

    var offset = Math.abs(point - min) / range * 100 + '%';

    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var style = vertical ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ bottom: offset }, dotStyle) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ left: offset }, dotStyle);
    if (isActived) {
      style = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, style, activeDotStyle);
    }

    var pointClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, prefixCls + '-dot-active', isActived), _classNames));

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span', { className: pointClassName, style: style, key: point });
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: prefixCls + '-step' },
    elements
  );
};

Steps.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  activeDotStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  dotStyle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  upperBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  lowerBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  included: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  dots: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  step: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  marks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
};

/* harmony default export */ __webpack_exports__["a"] = (Steps);

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);






var Marks = function Marks(_ref) {
  var className = _ref.className,
      vertical = _ref.vertical,
      marks = _ref.marks,
      included = _ref.included,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound,
      max = _ref.max,
      min = _ref.min,
      onClickLabel = _ref.onClickLabel;

  var marksKeys = Object.keys(marks);
  var marksCount = marksKeys.length;
  var unit = marksCount > 1 ? 100 / (marksCount - 1) : 100;
  var markWidth = unit * 0.9;

  var range = max - min;
  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
    return a - b;
  }).map(function (point) {
    var _classNames;

    var markPoint = marks[point];
    var markPointIsObject = typeof markPoint === 'object' && !__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(markPoint);
    var markLabel = markPointIsObject ? markPoint.label : markPoint;
    if (!markLabel && markLabel !== 0) {
      return null;
    }

    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
    var markClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text', true), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_classNames, className + '-text-active', isActive), _classNames));

    var bottomStyle = {
      marginBottom: '-50%',
      bottom: (point - min) / range * 100 + '%'
    };

    var leftStyle = {
      width: markWidth + '%',
      marginLeft: -markWidth / 2 + '%',
      left: (point - min) / range * 100 + '%'
    };

    var style = vertical ? bottomStyle : leftStyle;
    var markStyle = markPointIsObject ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, markPoint.style) : style;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      'span',
      {
        className: markClassName,
        style: markStyle,
        key: point,
        onMouseDown: function onMouseDown(e) {
          return onClickLabel(e, point);
        },
        onTouchStart: function onTouchStart(e) {
          return onClickLabel(e, point);
        }
      },
      markLabel
    );
  });

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
    'div',
    { className: className },
    elements
  );
};

Marks.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  vertical: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  marks: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,
  included: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  upperBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  lowerBound: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  min: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number,
  onClickLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
};

/* harmony default export */ __webpack_exports__["a"] = (Marks);

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(900), __esModule: true };

/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(107);
__webpack_require__(901);
module.exports = __webpack_require__(33).Array.from;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(148);
var $export = __webpack_require__(56);
var toObject = __webpack_require__(79);
var call = __webpack_require__(902);
var isArrayIter = __webpack_require__(903);
var toLength = __webpack_require__(222);
var createProperty = __webpack_require__(904);
var getIterFn = __webpack_require__(225);

$export($export.S + $export.F * !__webpack_require__(905)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(69);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(75);
var ITERATOR = __webpack_require__(46)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(58);
var createDesc = __webpack_require__(88);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(46)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,

  /**
   * BACKSPACE
   */
  BACKSPACE: 8,

  /**
   * TAB
   */
  TAB: 9,

  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,

  /**
   * ENTER
   */
  ENTER: 13,

  /**
   * SHIFT
   */
  SHIFT: 16,

  /**
   * CTRL
   */
  CTRL: 17,

  /**
   * ALT
   */
  ALT: 18,

  /**
   * PAUSE
   */
  PAUSE: 19,

  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,

  /**
   * ESC
   */
  ESC: 27,

  /**
   * SPACE
   */
  SPACE: 32,

  /**
   * PAGE_UP
   */
  PAGE_UP: 33,

  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,

  /**
   * END
   */
  END: 35,

  /**
   * HOME
   */
  HOME: 36,

  /**
   * LEFT
   */
  LEFT: 37,

  /**
   * UP
   */
  UP: 38,

  /**
   * RIGHT
   */
  RIGHT: 39,

  /**
   * DOWN
   */
  DOWN: 40,

  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,

  /**
   * INSERT
   */
  INSERT: 45,

  /**
   * DELETE
   */
  DELETE: 46,

  /**
   * ZERO
   */
  ZERO: 48,

  /**
   * ONE
   */
  ONE: 49,

  /**
   * TWO
   */
  TWO: 50,

  /**
   * THREE
   */
  THREE: 51,

  /**
   * FOUR
   */
  FOUR: 52,

  /**
   * FIVE
   */
  FIVE: 53,

  /**
   * SIX
   */
  SIX: 54,

  /**
   * SEVEN
   */
  SEVEN: 55,

  /**
   * EIGHT
   */
  EIGHT: 56,

  /**
   * NINE
   */
  NINE: 57,

  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,

  /**
   * A
   */
  A: 65,

  /**
   * B
   */
  B: 66,

  /**
   * C
   */
  C: 67,

  /**
   * D
   */
  D: 68,

  /**
   * E
   */
  E: 69,

  /**
   * F
   */
  F: 70,

  /**
   * G
   */
  G: 71,

  /**
   * H
   */
  H: 72,

  /**
   * I
   */
  I: 73,

  /**
   * J
   */
  J: 74,

  /**
   * K
   */
  K: 75,

  /**
   * L
   */
  L: 76,

  /**
   * M
   */
  M: 77,

  /**
   * N
   */
  N: 78,

  /**
   * O
   */
  O: 79,

  /**
   * P
   */
  P: 80,

  /**
   * Q
   */
  Q: 81,

  /**
   * R
   */
  R: 82,

  /**
   * S
   */
  S: 83,

  /**
   * T
   */
  T: 84,

  /**
   * U
   */
  U: 85,

  /**
   * V
   */
  V: 86,

  /**
   * W
   */
  W: 87,

  /**
   * X
   */
  X: 88,

  /**
   * Y
   */
  Y: 89,

  /**
   * Z
   */
  Z: 90,

  /**
   * META
   */
  META: 91,

  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,

  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,

  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,

  /**
   * NUM_ONE
   */
  NUM_ONE: 97,

  /**
   * NUM_TWO
   */
  NUM_TWO: 98,

  /**
   * NUM_THREE
   */
  NUM_THREE: 99,

  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,

  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,

  /**
   * NUM_SIX
   */
  NUM_SIX: 102,

  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,

  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,

  /**
   * NUM_NINE
   */
  NUM_NINE: 105,

  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,

  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,

  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,

  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,

  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,

  /**
   * F1
   */
  F1: 112,

  /**
   * F2
   */
  F2: 113,

  /**
   * F3
   */
  F3: 114,

  /**
   * F4
   */
  F4: 115,

  /**
   * F5
   */
  F5: 116,

  /**
   * F6
   */
  F6: 117,

  /**
   * F7
   */
  F7: 118,

  /**
   * F8
   */
  F8: 119,

  /**
   * F9
   */
  F9: 120,

  /**
   * F10
   */
  F10: 121,

  /**
   * F11
   */
  F11: 122,

  /**
   * F12
   */
  F12: 123,

  /**
   * NUMLOCK
   */
  NUMLOCK: 144,

  /**
   * SEMICOLON
   */
  SEMICOLON: 186,

  /**
   * DASH
   */
  DASH: 189,

  /**
   * EQUALS
   */
  EQUALS: 187,

  /**
   * COMMA
   */
  COMMA: 188,

  /**
   * PERIOD
   */
  PERIOD: 190,

  /**
   * SLASH
   */
  SLASH: 191,

  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,

  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,

  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,

  /**
   * BACKSLASH
   */
  BACKSLASH: 220,

  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,

  /**
   * WIN_KEY
   */
  WIN_KEY: 224,

  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,

  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================

  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;

    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    } // The following keys are quite harmless, even in combination with
    // CTRL, ALT or SHIFT.


    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;

      default:
        return true;
    }
  },

  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }

    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }

    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    } // Safari sends zero key code for non-latin characters.


    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
      return true;
    }

    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;

      default:
        return false;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (KeyCode);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shallowequal__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Track__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_createSlider__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(183);







/* eslint-disable react/prop-types */








var Range = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Range, _React$Component);

  function Range(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Range);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));

    _this.onEnd = function () {
      _this.setState({
        handle: null
      }, _this.blur);
      _this.removeDocumentEvents();
      _this.props.onAfterChange(_this.getValue());
    };

    var count = props.count,
        min = props.min,
        max = props.max;

    var initialValue = Array.apply(undefined, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(Array(count + 1))).map(function () {
      return min;
    });
    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
    var value = props.value !== undefined ? props.value : defaultValue;
    var bounds = value.map(function (v, i) {
      return _this.trimAlignValue(v, i);
    });
    var recent = bounds[0] === max ? 0 : bounds.length - 1;

    _this.state = {
      handle: null,
      recent: recent,
      bounds: bounds
    };
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Range, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (!('value' in nextProps || 'min' in nextProps || 'max' in nextProps)) return;
      if (this.props.min === nextProps.min && this.props.max === nextProps.max && __WEBPACK_IMPORTED_MODULE_10_shallowequal___default()(this.props.value, nextProps.value)) {
        return;
      }

      var bounds = this.state.bounds;

      var value = nextProps.value || bounds;
      var nextBounds = value.map(function (v, i) {
        return _this2.trimAlignValue(v, i, nextProps);
      });
      if (nextBounds.length === bounds.length && nextBounds.every(function (v, i) {
        return v === bounds[i];
      })) return;

      this.setState({ bounds: nextBounds });

      if (bounds.some(function (v) {
        return __WEBPACK_IMPORTED_MODULE_13__utils__["i" /* isValueOutOfRange */](v, nextProps);
      })) {
        var newValues = value.map(function (v) {
          return __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* ensureValueInRange */](v, nextProps);
        });
        this.props.onChange(newValues);
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(state) {
      var props = this.props;
      var isNotControlled = !('value' in props);
      if (isNotControlled) {
        this.setState(state);
      } else if (state.handle !== undefined) {
        this.setState({ handle: state.handle });
      }

      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.state, state);
      var changedValue = data.bounds;
      props.onChange(changedValue);
    }
  }, {
    key: 'onStart',
    value: function onStart(position) {
      var props = this.props;
      var state = this.state;
      var bounds = this.getValue();
      props.onBeforeChange(bounds);

      var value = this.calcValueByPos(position);
      this.startValue = value;
      this.startPosition = position;

      var closestBound = this.getClosestBound(value);
      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);

      this.setState({
        handle: this.prevMovedHandleIndex,
        recent: this.prevMovedHandleIndex
      });

      var prevValue = bounds[this.prevMovedHandleIndex];
      if (value === prevValue) return;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      nextBounds[this.prevMovedHandleIndex] = value;
      this.onChange({ bounds: nextBounds });
    }
  }, {
    key: 'onMove',
    value: function onMove(e, position) {
      __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
      var state = this.state;

      var value = this.calcValueByPos(position);
      var oldValue = state.bounds[state.handle];
      if (value === oldValue) return;

      this.moveTo(value);
    }
  }, {
    key: 'onKeyboard',
    value: function onKeyboard(e) {
      var valueMutator = __WEBPACK_IMPORTED_MODULE_13__utils__["d" /* getKeyboardValueMutator */](e);

      if (valueMutator) {
        __WEBPACK_IMPORTED_MODULE_13__utils__["j" /* pauseEvent */](e);
        var state = this.state,
            props = this.props;
        var bounds = state.bounds,
            handle = state.handle;

        var oldValue = bounds[handle];
        var mutatedValue = valueMutator(oldValue, props);
        var value = this.trimAlignValue(mutatedValue);
        if (value === oldValue) return;
        var isFromKeyboardEvent = true;
        this.moveTo(value, isFromKeyboardEvent);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.state.bounds;
    }
  }, {
    key: 'getClosestBound',
    value: function getClosestBound(value) {
      var bounds = this.state.bounds;

      var closestBound = 0;
      for (var i = 1; i < bounds.length - 1; ++i) {
        if (value > bounds[i]) {
          closestBound = i;
        }
      }
      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
        closestBound += 1;
      }
      return closestBound;
    }
  }, {
    key: 'getBoundNeedMoving',
    value: function getBoundNeedMoving(value, closestBound) {
      var _state = this.state,
          bounds = _state.bounds,
          recent = _state.recent;

      var boundNeedMoving = closestBound;
      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];

      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
        boundNeedMoving = recent;
      }

      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
      }
      return boundNeedMoving;
    }
  }, {
    key: 'getLowerBound',
    value: function getLowerBound() {
      return this.state.bounds[0];
    }
  }, {
    key: 'getUpperBound',
    value: function getUpperBound() {
      var bounds = this.state.bounds;

      return bounds[bounds.length - 1];
    }

    /**
     * Returns an array of possible slider points, taking into account both
     * `marks` and `step`. The result is cached.
     */

  }, {
    key: 'getPoints',
    value: function getPoints() {
      var _props = this.props,
          marks = _props.marks,
          step = _props.step,
          min = _props.min,
          max = _props.max;

      var cache = this._getPointsCache;
      if (!cache || cache.marks !== marks || cache.step !== step) {
        var pointsObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, marks);
        if (step !== null) {
          for (var point = min; point <= max; point += step) {
            pointsObject[point] = point;
          }
        }
        var points = Object.keys(pointsObject).map(parseFloat);
        points.sort(function (a, b) {
          return a - b;
        });
        this._getPointsCache = { marks: marks, step: step, points: points };
      }
      return this._getPointsCache.points;
    }
  }, {
    key: 'moveTo',
    value: function moveTo(value, isFromKeyboardEvent) {
      var _this3 = this;

      var state = this.state,
          props = this.props;

      var nextBounds = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.bounds));
      nextBounds[state.handle] = value;
      var nextHandle = state.handle;
      if (props.pushable !== false) {
        this.pushSurroundingHandles(nextBounds, nextHandle);
      } else if (props.allowCross) {
        nextBounds.sort(function (a, b) {
          return a - b;
        });
        nextHandle = nextBounds.indexOf(value);
      }
      this.onChange({
        handle: nextHandle,
        bounds: nextBounds
      });
      if (isFromKeyboardEvent) {
        // known problem: because setState is async,
        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
        // cause onBeforeChange and onAfterChange receive wrong value.
        // here use setState callback to hack，but not elegant
        this.setState({}, function () {
          _this3.handlesRefs[nextHandle].focus();
        });
      }
    }
  }, {
    key: 'pushSurroundingHandles',
    value: function pushSurroundingHandles(bounds, handle) {
      var value = bounds[handle];
      var threshold = this.props.pushable;

      threshold = Number(threshold);

      var direction = 0;
      if (bounds[handle + 1] - value < threshold) {
        direction = +1; // push to right
      }
      if (value - bounds[handle - 1] < threshold) {
        direction = -1; // push to left
      }

      if (direction === 0) {
        return;
      }

      var nextHandle = handle + direction;
      var diffToNext = direction * (bounds[nextHandle] - value);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // revert to original value if pushing is impossible
        bounds[handle] = bounds[nextHandle] - direction * threshold;
      }
    }
  }, {
    key: 'pushHandle',
    value: function pushHandle(bounds, handle, direction, amount) {
      var originalValue = bounds[handle];
      var currentValue = bounds[handle];
      while (direction * (currentValue - originalValue) < amount) {
        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
          // can't push handle enough to create the needed `amount` gap, so we
          // revert its position to the original value
          bounds[handle] = originalValue;
          return false;
        }
        currentValue = bounds[handle];
      }
      // the handle was pushed enough to create the needed `amount` gap
      return true;
    }
  }, {
    key: 'pushHandleOnePoint',
    value: function pushHandleOnePoint(bounds, handle, direction) {
      var points = this.getPoints();
      var pointIndex = points.indexOf(bounds[handle]);
      var nextPointIndex = pointIndex + direction;
      if (nextPointIndex >= points.length || nextPointIndex < 0) {
        // reached the minimum or maximum available point, can't push anymore
        return false;
      }
      var nextHandle = handle + direction;
      var nextValue = points[nextPointIndex];
      var threshold = this.props.pushable;

      var diffToNext = direction * (bounds[nextHandle] - nextValue);
      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
        // couldn't push next handle, so we won't push this one either
        return false;
      }
      // push the handle
      bounds[handle] = nextValue;
      return true;
    }
  }, {
    key: 'trimAlignValue',
    value: function trimAlignValue(v, handle) {
      var nextProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var mergedProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, nextProps);
      var valInRange = __WEBPACK_IMPORTED_MODULE_13__utils__["a" /* ensureValueInRange */](v, mergedProps);
      var valNotConflict = this.ensureValueNotConflict(handle, valInRange, mergedProps);
      return __WEBPACK_IMPORTED_MODULE_13__utils__["b" /* ensureValuePrecision */](valNotConflict, mergedProps);
    }
  }, {
    key: 'ensureValueNotConflict',
    value: function ensureValueNotConflict(handle, val, _ref) {
      var allowCross = _ref.allowCross,
          thershold = _ref.pushable;

      var state = this.state || {};
      var bounds = state.bounds;

      handle = handle === undefined ? state.handle : handle;
      thershold = Number(thershold);
      /* eslint-disable eqeqeq */
      if (!allowCross && handle != null && bounds !== undefined) {
        if (handle > 0 && val <= bounds[handle - 1] + thershold) {
          return bounds[handle - 1] + thershold;
        }
        if (handle < bounds.length - 1 && val >= bounds[handle + 1] - thershold) {
          return bounds[handle + 1] - thershold;
        }
      }
      /* eslint-enable eqeqeq */
      return val;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state2 = this.state,
          handle = _state2.handle,
          bounds = _state2.bounds;
      var _props2 = this.props,
          prefixCls = _props2.prefixCls,
          vertical = _props2.vertical,
          included = _props2.included,
          disabled = _props2.disabled,
          min = _props2.min,
          max = _props2.max,
          handleGenerator = _props2.handle,
          trackStyle = _props2.trackStyle,
          handleStyle = _props2.handleStyle,
          tabIndex = _props2.tabIndex;


      var offsets = bounds.map(function (v) {
        return _this4.calcOffset(v);
      });

      var handleClassName = prefixCls + '-handle';
      var handles = bounds.map(function (v, i) {
        var _classNames;

        return handleGenerator({
          className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName, true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
          prefixCls: prefixCls,
          vertical: vertical,
          offset: offsets[i],
          value: v,
          dragging: handle === i,
          index: i,
          tabIndex: tabIndex[i] || 0,
          min: min,
          max: max,
          disabled: disabled,
          style: handleStyle[i],
          ref: function ref(h) {
            return _this4.saveHandle(i, h);
          }
        });
      });

      var tracks = bounds.slice(0, -1).map(function (_, index) {
        var _classNames2;

        var i = index + 1;
        var trackClassName = __WEBPACK_IMPORTED_MODULE_9_classnames___default()((_classNames2 = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track', true), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Track__["a" /* default */], {
          className: trackClassName,
          vertical: vertical,
          included: included,
          offset: offsets[i - 1],
          length: offsets[i] - offsets[i - 1],
          style: trackStyle[index],
          key: i
        });
      });

      return { tracks: tracks, handles: handles };
    }
  }]);

  return Range;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

Range.displayName = 'Range';
Range.propTypes = {
  defaultValue: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  value: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number),
  count: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number,
  pushable: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  allowCross: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  tabIndex: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number)
};
Range.defaultProps = {
  count: 1,
  allowCross: true,
  pushable: false,
  tabIndex: []
};


/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__common_createSlider__["a" /* default */])(Range));

/***/ }),
/* 908 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSliderWithTooltip;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Handle__ = __webpack_require__(182);












function createSliderWithTooltip(Component) {
  var _class, _temp;

  return _temp = _class = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ComponentWrapper, _React$Component);

    function ComponentWrapper(props) {
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ComponentWrapper);

      var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ComponentWrapper.__proto__ || Object.getPrototypeOf(ComponentWrapper)).call(this, props));

      _this.handleTooltipVisibleChange = function (index, visible) {
        _this.setState(function (prevState) {
          return {
            visibles: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, prevState.visibles, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, index, visible))
          };
        });
      };

      _this.handleWithTooltip = function (_ref) {
        var value = _ref.value,
            dragging = _ref.dragging,
            index = _ref.index,
            disabled = _ref.disabled,
            restProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['value', 'dragging', 'index', 'disabled']);

        var _this$props = _this.props,
            tipFormatter = _this$props.tipFormatter,
            tipProps = _this$props.tipProps,
            handleStyle = _this$props.handleStyle;

        var _tipProps$prefixCls = tipProps.prefixCls,
            prefixCls = _tipProps$prefixCls === undefined ? 'rc-slider-tooltip' : _tipProps$prefixCls,
            _tipProps$overlay = tipProps.overlay,
            overlay = _tipProps$overlay === undefined ? tipFormatter(value) : _tipProps$overlay,
            _tipProps$placement = tipProps.placement,
            placement = _tipProps$placement === undefined ? 'top' : _tipProps$placement,
            _tipProps$visible = tipProps.visible,
            visible = _tipProps$visible === undefined ? false : _tipProps$visible,
            restTooltipProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(tipProps, ['prefixCls', 'overlay', 'placement', 'visible']);

        var handleStyleWithIndex = void 0;
        if (Array.isArray(handleStyle)) {
          handleStyleWithIndex = handleStyle[index] || handleStyle[0];
        } else {
          handleStyleWithIndex = handleStyle;
        }

        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9_rc_tooltip__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, restTooltipProps, {
            prefixCls: prefixCls,
            overlay: overlay,
            placement: placement,
            visible: !disabled && (_this.state.visibles[index] || dragging) || visible,
            key: index
          }),
          __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Handle__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, restProps, {
            style: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, handleStyleWithIndex),
            value: value,
            onMouseEnter: function onMouseEnter() {
              return _this.handleTooltipVisibleChange(index, true);
            },
            onMouseLeave: function onMouseLeave() {
              return _this.handleTooltipVisibleChange(index, false);
            }
          }))
        );
      };

      _this.state = { visibles: {} };
      return _this;
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ComponentWrapper, [{
      key: 'render',
      value: function render() {
        return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(Component, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, { handle: this.handleWithTooltip }));
      }
    }]);

    return ComponentWrapper;
  }(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component), _class.propTypes = {
    tipFormatter: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
    handleStyle: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object)]),
    tipProps: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.object
  }, _class.defaultProps = {
    tipFormatter: function tipFormatter(value) {
      return value;
    },

    handleStyle: [{}],
    tipProps: {}
  }, _temp;
}

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(911);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tooltip__["a" /* default */]);

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_trigger__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__placements__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Content__ = __webpack_require__(929);











var Tooltip = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Tooltip, _Component);

  function Tooltip() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
      var _this$props = _this.props,
          arrowContent = _this$props.arrowContent,
          overlay = _this$props.overlay,
          prefixCls = _this$props.prefixCls,
          id = _this$props.id;

      return [__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: prefixCls + '-arrow', key: 'arrow' },
        arrowContent
      ), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Content__["a" /* default */], {
        key: 'content',
        trigger: _this.trigger,
        prefixCls: prefixCls,
        id: id,
        overlay: overlay
      })];
    }, _this.saveTrigger = function (node) {
      _this.trigger = node;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
    return this.trigger.getPopupDomNode();
  };

  Tooltip.prototype.render = function render() {
    var _props = this.props,
        overlayClassName = _props.overlayClassName,
        trigger = _props.trigger,
        mouseEnterDelay = _props.mouseEnterDelay,
        mouseLeaveDelay = _props.mouseLeaveDelay,
        overlayStyle = _props.overlayStyle,
        prefixCls = _props.prefixCls,
        children = _props.children,
        onVisibleChange = _props.onVisibleChange,
        afterVisibleChange = _props.afterVisibleChange,
        transitionName = _props.transitionName,
        animation = _props.animation,
        placement = _props.placement,
        align = _props.align,
        destroyTooltipOnHide = _props.destroyTooltipOnHide,
        defaultVisible = _props.defaultVisible,
        getTooltipContainer = _props.getTooltipContainer,
        restProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);

    var extraProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, restProps);
    if ('visible' in this.props) {
      extraProps.popupVisible = this.props.visible;
    }
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_7_rc_trigger__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        popupClassName: overlayClassName,
        ref: this.saveTrigger,
        prefixCls: prefixCls,
        popup: this.getPopupElement,
        action: trigger,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_8__placements__["a" /* placements */],
        popupPlacement: placement,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onPopupVisibleChange: onVisibleChange,
        afterPopupVisibleChange: afterVisibleChange,
        popupTransitionName: transitionName,
        popupAnimation: animation,
        defaultPopupVisible: defaultVisible,
        destroyPopupOnHide: destroyTooltipOnHide,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: overlayStyle,
        mouseEnterDelay: mouseEnterDelay
      }, extraProps),
      children
    );
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Tooltip.propTypes = {
  trigger: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  defaultVisible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  placement: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object]),
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  onVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  afterVisibleChange: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  overlay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func]).isRequired,
  overlayStyle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  overlayClassName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  getTooltipContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  destroyTooltipOnHide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object,
  arrowContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
Tooltip.defaultProps = {
  prefixCls: 'rc-tooltip',
  mouseEnterDelay: 0,
  destroyTooltipOnHide: false,
  mouseLeaveDelay: 0.1,
  align: {},
  placement: 'right',
  trigger: ['hover'],
  arrowContent: null
};


/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(915);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = Object(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return Object(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(Object(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

Object(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var ContainerRender = /*#__PURE__*/function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  var _super = _createSuper(ContainerRender);

  function ContainerRender() {
    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





var Portal = /*#__PURE__*/function (_React$Component) {
  _inherits(Portal, _React$Component);

  var _super = _createSuper(Portal);

  function Portal() {
    _classCallCheck(this, Portal);

    return _super.apply(this, arguments);
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(341);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(917);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(919);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = Object(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        Object(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(lastElement) && Object(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !Object(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.width, sourceRect.width) || !Object(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = Object(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};
function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }
  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';
  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }
  return vendorPrefix;
}
function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}
function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}
function setTransform(node, value) {
  var name = getTransformName();
  if (name) {
    node.style[name] = value;
    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}
function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }
  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);
    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX;

// https://stackoverflow.com/a/3485654/3040605
function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line
  elem.style.display = originalStyle;
}
function css(el, name, v) {
  var value = v;
  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}
function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = Math.floor(box.left);
  y = Math.floor(box.top);

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}
function getScrollLeft(w) {
  return getScroll(w);
}
function getScrollTop(w) {
  return getScroll(w, true);
}
function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}
function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }
  if (node.nodeType === 9) {
    return node;
  }
  return node.ownerDocument;
}
function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }
  return val;
}
var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';
function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}
function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }
  return option.useCssBottom ? 'bottom' : dir;
}
function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
}

// 设置 elem 相对 elem.ownerDocument 的坐标
function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }
  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
  if (horizontalProperty !== 'left') {
    presetH = 999;
  }
  if (verticalProperty !== 'top') {
    presetV = 999;
  }
  var originalTransition = '';
  var originalOffset = getOffset(elem);
  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }
  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }
  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  }
  // force relayout
  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};
  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];
      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }
  css(elem, originalStyle);
  // force relayout
  forceRelayout(elem);
  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }
  var ret = {};
  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);
      var _off = offset[_key] - originalOffset[_key];
      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }
  css(elem, ret);
}
function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };
  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }
  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }
  setTransformXY(elem, resultXY);
}
function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);
    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }
  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}
function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}
function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}
var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;
function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }
  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}
function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;
        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}
var domUtils = {
  getParent: function getParent(element) {
    var parent = element;
    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };
  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, ex) {
  var extra = ex;
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;
  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = Math.floor(parseFloat(cssBoxValue)) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }
    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }
    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}
var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }
  var val;
  var elem = args[0];
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}
each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  domUtils[name] = function (elem, v) {
    var val = v;
    if (val !== undefined) {
      if (elem) {
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});
function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }
  return to;
}
var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};
    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};
    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }
    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */
var getParent = utils.getParent;
function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  }
  // ie 这个也不是完全可行
  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }
  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');
    if (positionStyle !== 'static') {
      return parent;
    }
  }
  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }
  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;
  for (parent = getParent$1(element);
  // 修复元素位于 document.documentElement 下导致崩溃问题
  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');
    if (positionStyle === 'fixed') {
      return true;
    }
  }
  return false;
}

/**
 * 获得元素的显示部分的区域
 */
function getVisibleRectForElement(element, alwaysByViewport) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement;

  // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.
  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) &&
    // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el);
      // add border
      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right,
      // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }
    el = getOffsetParent(el);
  }

  // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601
  var originalPosition = null;
  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');
    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight;

  // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.
  var bodyStyle = window.getComputedStyle(body);
  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }
  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  }

  // Reset element position after calculate the visible area
  if (element.style) {
    element.style.position = originalPosition;
  }
  if (alwaysByViewport || isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }
  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };
  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  }

  // Left edge inside and right edge outside viewport, try to resize it.
  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  }

  // Right edge outside viewport, try to move it.
  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  }

  // Top edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  }

  // Top edge inside and bottom edge outside viewport, try to resize it.
  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  }

  // Bottom edge outside viewport, try to move it.
  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }
  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;
  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }
  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */

function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;
  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }
  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }
  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

// http://yiminghe.iteye.com/blog/1124720

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}
function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}
function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}
function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}
function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}
function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}
function convertOffset(str, offsetLen) {
  var n;
  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }
  return n || 0;
}
function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}

/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */
function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0;
  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport);
  // 当前节点可以被放置的显示区域
  var visibleRect = getVisibleRectForElement(source, alwaysByViewport);
  // 当前节点所占的区域, left/top/width/height
  var elRegion = getRegion(source);
  // 将 offset 转换成数值，支持百分比
  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion);
  // 当前节点将要被放置的位置
  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
  // 当前节点将要所处的区域
  var newElRegion = utils.merge(elRegion, elFuturePos);

  // 如果可视区域不能完全放置当前节点时允许调整
  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
        // 偏移量也反下
        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }
    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
        // 偏移量也反下
        var _newOffset = flipOffset(offset, 1);
        var _newTargetOffset = flipOffset(targetOffset, 1);
        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    }

    // 如果失败，重新计算当前节点将要被放置的位置
    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }
    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect);
    // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数
    if (isStillFailX || isStillFailY) {
      var _newPoints2 = points;

      // 重置对应部分的翻转逻辑
      if (isStillFailX) {
        _newPoints2 = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        });
      }
      if (isStillFailY) {
        _newPoints2 = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        });
      }
      points = _newPoints2;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    }
    // 2. 只有指定了可以调整当前方向才调整
    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY;

    // 确实要调整，甚至可能会调整高度宽度
    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  }

  // need judge to in case set fixed with in css on height auto element
  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }
  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  }

  // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>
  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target, alwaysByViewport) {
  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}
function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}
alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }
  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }
  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight;

  // Provide default target point
  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2(_objectSpread2({}, align), {}, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["b"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["d"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["e"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(340);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && Object(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(343);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(343);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(342);
} catch (err) {
  var index = __webpack_require__(342);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(344);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placements; });
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};

var targetOffset = [0, 0];

var placements = {
  left: {
    points: ['cr', 'cl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  right: {
    points: ['cl', 'cr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  top: {
    points: ['bc', 'tc'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  bottom: {
    points: ['tc', 'bc'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  leftTop: {
    points: ['tr', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -4],
    targetOffset: targetOffset
  },
  rightTop: {
    points: ['tl', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  rightBottom: {
    points: ['bl', 'br'],
    overflow: autoAdjustOverflow,
    offset: [4, 0],
    targetOffset: targetOffset
  },
  bottomLeft: {
    points: ['tl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 4],
    targetOffset: targetOffset
  },
  leftBottom: {
    points: ['br', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [-4, 0],
    targetOffset: targetOffset
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (placements);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);






var Content = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Content, _React$Component);

  function Content() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Content);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  Content.prototype.componentDidUpdate = function componentDidUpdate() {
    var trigger = this.props.trigger;

    if (trigger) {
      trigger.forcePopupAlign();
    }
  };

  Content.prototype.render = function render() {
    var _props = this.props,
        overlay = _props.overlay,
        prefixCls = _props.prefixCls,
        id = _props.id;

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
      typeof overlay === 'function' ? overlay() : overlay
    );
  };

  return Content;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Content.propTypes = {
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  overlay: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func]).isRequired,
  id: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  trigger: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = doubletapSelect;
var mylatesttap;function doubletapSelect(ev){if(mylatesttap===undefined)mylatesttap=new Date().getTime();var now=new Date().getTime();var timesince=now-mylatesttap;if(timesince<600&&timesince>0){if(ev.target){ev.target.select();}}mylatesttap=new Date().getTime();}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bekijk.cebef068.svg";

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BudgetCollaboration__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_grey_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_grey_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_grey_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_group_png__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_group_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_group_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_check_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PolicyElement=(_temp=_class=function(_Component){_inherits(PolicyElement,_Component);function PolicyElement(props){_classCallCheck(this,PolicyElement);var _this=_possibleConstructorReturn(this,(PolicyElement.__proto__||Object.getPrototypeOf(PolicyElement)).call(this,props));_this.collaborationEl=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.policyOptions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.policyHeader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={open:false};_this.onCollabChange=_this.onCollabChange.bind(_this);_this.selectOption=_this.selectOption.bind(_this);//this.openClose = this.openClose.bind(this);
return _this;}_createClass(PolicyElement,[{key:"selectOption",value:function selectOption(selected){if(this.props.value.option!==selected){this.setValues({option:selected,selected:true,collaboration:[]});}else{this.setValues({option:'',selected:false});}}},{key:"componentDidUpdate",value:function componentDidUpdate(oldProps){var props=this.props;if(oldProps&&props.value.option!==oldProps.value.option&&this.collaborationEl&&props.value.option==='collab'){if(this.collaborationEl.current){this.collaborationEl.current.scrollIntoView({behavior:'smooth'});}}}},{key:"openClose",value:function openClose(caret){var _this2=this;if(!this.state.open||caret){this.setState(function(prevState){return{open:!prevState.open};},function(){if(_this2.state.open){if(_this2.policyOptions.current){_this2.policyOptions.current.scrollIntoView({behavior:'smooth'});}}else{if(_this2.policyHeader.current){_this2.policyHeader.current.scrollIntoView({behavior:'smooth'});}}});}}},{key:"onCollabChange",value:function onCollabChange(key,val){this.setValues({'collaboration':val});}},{key:"setValues",value:function setValues(values){var v=_extends({title:this.props.title,option:this.props.value.option,selected:this.props.value.selected,collaboration:this.props.value.collaboration},values);v.globas=0;if(v.option==='collab')v.globas=this.props.collaborationGlobas;if(v.option==='single')v.globas=this.props.globas;this.props.onChange(v);}},{key:"render",value:function render(){var _this3=this;var props=this.props;var value=props.value,schoolClass=props.schoolClass;var title=void 0;var maxGlobas=void 0,rows=void 0;var globas=props.globas;if(props.collaborationGlobas){title=globas+'/'+props.collaborationGlobas;maxGlobas=props.collaborationGlobas;}else{title=props.globas;maxGlobas=props.globas;}if(value.collaboration){rows='three';if(value.collaboration.length<=2){rows='one';}else if(value.collaboration.length<=4){rows='two';}}var groupBadge=function groupBadge(name,i){var matchedGroup=schoolClass.Groups.find(function(g){return g.GroupTheme.color===name;});if(matchedGroup)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{key:i,className:'collab-inline-item-badge',src:""+__WEBPACK_IMPORTED_MODULE_10__config___default.a.apiUrl+matchedGroup.GroupTheme.badge,alt:'badge'});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"policy-element-outer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:function onClick(){return _this3.openClose(false);},className:'policy-element'+(!this.state.open?' closed':'')+(value.selected?' checked':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'policy-header-element',ref:this.policyHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,value.selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_check_svg___default.a,alt:'selected',className:'selected'}):null,props.title,this.state.open&&props.collaborationGlobas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:{height:'14px',alignSelf:'center',marginLeft:'5px'},src:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg___default.a,className:"global-icon",alt:"global-icon"}):null),value.collaboration?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'collab-icons '+rows},value.collaboration.map(function(group,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:i},groupBadge(group,i));})):null,this.state.open?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:'close',onClick:function onClick(){return _this3.openClose(true);},className:'close-policy '+(this.state.open?'show':''),src:__WEBPACK_IMPORTED_MODULE_4__assets_img_caret_down_grey_svg___default.a}):null,!this.state.open?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"point-holder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'point-holder-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:title},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')))):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'hidden-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:'desc'},props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'policy-options',ref:this.policyOptions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PopupTitle__["a" /* default */],{popupId:'mhgvtselecteerbeleidskeuze',tag:'h5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:'options'+(this.props.user.role==='groupmember'?' groupmember-disabled':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:'delay-30 option'+(value.option==='single'?' active':''),onClick:this.selectOption.bind(this,'single')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Avatar",src:__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"point-holder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'point-holder-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:props.globas},props.globas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))))),props.collaborationGlobas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:'delay-45 option'+(value.option==='collab'?' active':''),onClick:this.selectOption.bind(this,'collab')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Group",src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_group_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"point-holder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'point-holder-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:maxGlobas},maxGlobas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))))):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'show-hide-collab '+(value.option==='collab'?' show':''),ref:this.collaborationEl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__BudgetCollaboration__["a" /* default */],{customOnChange:this.onCollabChange,value:props.value.collaboration,title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')})))));}}]);return PolicyElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,globas:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,collaborationGlobas:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,value:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object// value obj is:
// globas: PropTypes.number,
// option: PropTypes.string,
// selected: PropTypes.bool,
},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var schoolClass=_ref.schoolClass,user=_ref.user;return{schoolClass:schoolClass,user:user};})(PolicyElement));

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__config__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updateRead=__WEBPACK_IMPORTED_MODULE_4__actions__["a" /* default */].feedback.updateRead;var FeedbackOverview=(_temp=_class=function(_DifficultyAwareCompo){_inherits(FeedbackOverview,_DifficultyAwareCompo);function FeedbackOverview(props){_classCallCheck(this,FeedbackOverview);var _this=_possibleConstructorReturn(this,(FeedbackOverview.__proto__||Object.getPrototypeOf(FeedbackOverview)).call(this,props));_this.getIcon=function(fb){if(fb.type==='BELASTING'){if(fb.niveau==='Basic'){return __WEBPACK_IMPORTED_MODULE_12__assets_assets__["a" /* belastingIcons */]['LB'];}return __WEBPACK_IMPORTED_MODULE_12__assets_assets__["a" /* belastingIcons */][fb.belastingsoort];}if(fb.type==='BELEIDSKEUZE'){return Object(__WEBPACK_IMPORTED_MODULE_9__helpers_policyChoiceHelper__["b" /* getIcon */])(fb);}return __WEBPACK_IMPORTED_MODULE_12__assets_assets__["g" /* ministryIcons */][fb.ministerie];};_this.getTitle=function(fb){var title=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_effect_vanuit')+': ';if(fb.type==='BELASTING'){if(fb.niveau==='Basic'){return title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belastingkeuze');}return title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.belastingsoort||Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belasting'));}if(fb.type==='BELEIDSKEUZE'){return title+=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_policyChoiceHelper__["e" /* getOplossingTitle */])(fb,_this.props.gameState.language);}return title+=Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(fb.ministerie);};_this.state={type:_this.props.match.params.type,showFeedback:false};return _this;}_createClass(FeedbackOverview,[{key:'setShowFeedback',value:function setShowFeedback(i,id,read,feedback){if(this.state.showFeedback===i){this.setState({showFeedback:false});}else{if(!read){feedback.read.economie=true;var array=feedback.read;array.economie=true;this.props.dispatch(updateRead(id,array));}this.setState({showFeedback:i});}}},{key:'renderLaag',value:function renderLaag(){var _this2=this;var _props=this.props,gameState=_props.gameState,feedback=_props.feedback,group=_props.group;var state=this.state;var prevRoundFeedbackData=feedback.prevRoundFeedbackData;var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var unreadFeedback=0;if(state.type==='profit'){unreadFeedback=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["B" /* getUnreadWinstGlobas */])(prevRoundFeedbackData).length;}else{unreadFeedback=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["A" /* getUnreadVerliesGlobas */])(prevRoundFeedbackData).length;}var allFeedback=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(prevRoundFeedbackData,state.type);var openFeedback=false;if(this.props.match.params.id){allFeedback.find(function(f,i){if(f.omschrijving===_this2.props.match.params.id){openFeedback=i;return f;}return false;},this);}var displayPoints=Math.abs(this.state.type==='profit'?OneTimeEffect.WG:OneTimeEffect.VG);var pointsGlyph=this.state.type==='profit'?"+ ":"- ";var isStartSituation=group.Rounds.length===2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'close',viewType:'list',showTitle:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-container ministry-container--economy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:state.type==='profit'?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),icon:state.type==='profit'?__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadFeedback.length,arrow:true,isGlobas:true,dashForZero:true,points:isStartSituation?'-':displayPoints===0?0:pointsGlyph+displayPoints,popupId:state.type==='profit'?'mlgvtwinstglobas':'mlgvtverliesglobas'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},allFeedback.map(function(feedback,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-container-low',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{read:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["d" /* checkRead */])(feedback,false,0,true),bgColor:'grey',title:_this2.getTitle(feedback),icon:_this2.getIcon(feedback),arrow:true,feedback:true,thumbnail:''+__WEBPACK_IMPORTED_MODULE_15__config___default.a.mediaUrl+Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["l" /* getImage */])(feedback.economie)+'.jpeg',points:(state.type==='profit'?'+ ':null)+feedback.economie.winstverliesglobas,isGlobas:true,onClick:function onClick(){return _this2.setShowFeedback(i,feedback.id,Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["d" /* checkRead */])(feedback,false,0,true),feedback);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:_this2.state.showFeedback===i||openFeedback===i&&!_this2.state.showFeedback?'collapsed-feedback-container show':'collapsed-feedback-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackImage__["a" /* default */]// disaster={false}
,{description:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["m" /* getImageText */])(feedback.economie,gameState.language),image:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["l" /* getImage */])(feedback.economie)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["y" /* getText */])(feedback.economie,gameState.language)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'feedback-list-line'})));}))));}},{key:'renderHoog',value:function renderHoog(){var _props2=this.props,gameState=_props2.gameState,feedback=_props2.feedback,group=_props2.group;var state=this.state;var prevRoundFeedbackData=feedback.prevRoundFeedbackData;var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var unreadFeedback=0;if(state.type==='profit'){unreadFeedback=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["B" /* getUnreadWinstGlobas */])(prevRoundFeedbackData).length;}else{unreadFeedback=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["A" /* getUnreadVerliesGlobas */])(prevRoundFeedbackData).length;}var feedbackFormatted=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_feedbackHelpers__["h" /* getEconomieFeedbackFormatted */])(prevRoundFeedbackData,state.type,gameState);var displayPoints=Math.abs(this.state.type==='profit'?OneTimeEffect.WG:OneTimeEffect.VG);var pointsGlyph=this.state.type==='profit'?"+ ":"- ";var isStartSituation=group.Rounds.length===2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'close',viewType:'list',showTitle:false}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-container ministry-container--economy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'blue',title:state.type==='profit'?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])("sim_winstglobas"):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])("sim_verliesglobas"),icon:state.type==='profit'?__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadFeedback,arrow:true,isGlobas:true,dashForZero:true,points:isStartSituation?'-':displayPoints===0?0:pointsGlyph+displayPoints,popupId:state.type==='profit'?'mhgvtwinstglobas':'mhgvtverliesglobas'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},feedbackFormatted)));}}]);return FeedbackOverview;}(__WEBPACK_IMPORTED_MODULE_5__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,project=_ref.project,group=_ref.group;return{gameState:gameState,feedback:feedback,project:project,group:group};})(FeedbackOverview));

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__history_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_groupHelper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_ScoreHistory__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_feedback_FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackHeader__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_feedback_FeedbackEffect__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_assets_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__elements_feedback_FeedbackStatusRounds__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_beleidskeuze_L_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_beleidskeuze_L_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_beleidskeuze_L_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_caret_down_grey_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_caret_down_grey_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_img_caret_down_grey_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__elements_GameTopBar__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_react_router_dom__ = __webpack_require__(29);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// functions / libraries
// components
// assets
var updateRead=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].feedback.updateRead;var Feedback=function(_DifficultyAwareCompo){_inherits(Feedback,_DifficultyAwareCompo);function Feedback(props){_classCallCheck(this,Feedback);var _this=_possibleConstructorReturn(this,(Feedback.__proto__||Object.getPrototypeOf(Feedback)).call(this,props));_this.flipContainer=function(){_this.setState(function(prevState){return{flip:!prevState.flip};});};_this.toggleProbleemOplossing=function(){_this.setState(function(prevState){return{showProbleemOplossing:!prevState.showProbleemOplossing};});};_this.renderMinistryHeader=function(feedback,overigEffect,economie){var _this$props=_this.props,gameState=_this$props.gameState,feedbacks=_this$props.feedback;if(_this.pageType==='beleidskeuze'&&gameState.difficulty==='BASIC'){return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{key:'cat',bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),icon:__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_beleidskeuze_L_svg___default.a,className:"beleidskeuze-listbutton-laag",feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData),null,true),arrow:true,points:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["v" /* getPolicyChoiceTotalPoints */])(feedbacks.prevRoundFeedbackData),onClick:function onClick(){_this.props.history.goBack();},globas:undefined}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{key:'pol',bgColor:feedback.kleur_balk,title:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["e" /* getOplossingTitle */])(feedback,_this.props.gameState.language),arrow:true,policy:true,feedback:true,icon:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["b" /* getIcon */])(feedback),points:feedback.puntenscore})];}var ministerie=feedback.ministerie;// Check if economie
if(_this.economie){var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var type=parseInt(economie.winstverliesglobas,10)>=0?'profit':'loss';var unreadFeedback=[];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{bgColor:'blue',title:type==='profit'?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),icon:type==='profit'?__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadFeedback.length,arrow:true,isGlobas:true,points:type==='profit'?'+'+OneTimeEffect.WG:'-'+-OneTimeEffect.VG,popupId:type==='profit'?'mhgvtwinstglobas':'mhgvtverliesglobas'});}// Check if OE
if(_this.oe){ministerie=overigEffect.ministerie;}if(feedback&&feedback.type!=='BELASTING'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{key:'minHeader',ministry:ministerie,title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(ministerie),icon:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["g" /* ministryIcons */][ministerie],arrow:true,stars:__WEBPACK_IMPORTED_MODULE_2__Defines__["a" /* default */].ministeryStars[ministerie],points:gameState.prevRoundSum?String(gameState.prevRoundSum[ministerie+'_points']):'0',popupId:gameState.difficulty==='BASIC'?__WEBPACK_IMPORTED_MODULE_2__Defines__["a" /* default */].ministryPopupIds.basic[ministerie]:__WEBPACK_IMPORTED_MODULE_2__Defines__["a" /* default */].ministryPopupIds.pro[ministerie],global:__WEBPACK_IMPORTED_MODULE_2__Defines__["a" /* default */].i18nMinistries.includes(ministerie)});}return null;};_this.renderFeedbackHeader=function(feedback,overigEffect,economie){var _this$props2=_this.props,gameState=_this$props2.gameState,history=_this$props2.history;if(_this.pageType==='beleidskeuze'&&gameState.difficulty==='BASIC'){var title=void 0;if(feedback.oplossing_code){title=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["e" /* getOplossingTitle */])(feedback,gameState.language);}else{title=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["j" /* getTitle */])(feedback,gameState.language);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{className:'policy-choice-laag',read:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["d" /* checkRead */])(feedback),bgColor:Math.sign(feedback.puntenscore)?'green':'red',title:title,arrow:true,feedback:true,thumbnail:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["b" /* getIcon */])(feedback),points:feedback.puntenscore});}if(feedback){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackHeader__["a" /* default */],{key:'header',currentRound:gameState.currentRound,history:history,type:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["j" /* getFeedbackTitle */])(feedback),subtitle:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["x" /* getSubtitle */])(feedback,gameState.language),icon:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["k" /* getIcon */])(feedback),disaster:feedback.type==='RAMP'});}return null;};_this.renderStatistics=function(feedback,overigEffect,economie){var _this$props3=_this.props,gameState=_this$props3.gameState,gameStateInput=_this$props3.gameStateInput,schoolClass=_this$props3.schoolClass;if(_this.pageType==='beleidskeuze'&&gameState.difficulty==='BASIC'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],{className:'problem-solution-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar',onClick:_this.toggleProbleemOplossing},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bekijk_probleem_en_oplossing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_22__assets_img_caret_down_grey_svg___default.a,alt:'close',className:'close-status'+(_this.state.showProbleemOplossing?' rotate':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'+(_this.state.showProbleemOplossing?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_probleem')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["g" /* getProbleemTekst */])(feedback,gameState.language))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_oplossing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_6__helpers_policyChoiceHelper__["d" /* getOplossingTekst */])(feedback,gameState.language))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_kosten'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,(feedback.kosten_globas||0)+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')))));}// check if OE
if(_this.oe){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'card',className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_score',1),score:overigEffect.puntenscore+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase()})));}// check if economie
if(_this.economie){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'card',className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:parseInt(economie.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),score:economie.winstverliesglobas+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')})));}if(feedback){if(feedback.type==='STARTSITUATIE')return null;if(['ALGEMEEN','RAMP'].indexOf(feedback.type)!==-1){var groupIcons=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_groupHelper__["b" /* getGroupIcons */])(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput),schoolClass.Groups);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"flip-container "+(_this.state.flip?'':'flip')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flipper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front round-'+(gameState.Rounds.length-1)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_kosten'),score:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["f" /* getCosts */])(feedback,gameState)+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')}),__WEBPACK_IMPORTED_MODULE_2__Defines__["a" /* default */].i18nMinistries.includes(feedback.ministerie)?groupIcons.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{className:'align-right',text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_samenwerking'),imgs:groupIcons}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{className:'no-collaborations',text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_samenwerking'),score:'-'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_score',1),score:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["s" /* getPoints */])(feedback,gameState,Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput).length)+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase()}),gameState.difficulty==="PRO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_neveneffecten'),score:feedback.nevenEffecten||0}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:_this.flipContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bekijkhistorie')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back round-'+(gameState.Rounds.length-1)},gameState.Rounds.map(function(r,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_ScoreHistory__["a" /* default */],{key:i,round:i,ministerie:feedback.ministerie});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:_this.flipContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_terug'))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'card',className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_kosten'),score:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["f" /* getCosts */])(feedback,gameState)+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')}),feedback.type==='BELEIDSKEUZE'&&Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["c" /* checkIfCollab */])(feedback)&&feedback.omschrijving.match(/SW(\d){1,2}$/i)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{className:'align-right',text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_samenwerking'),imgs:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_groupHelper__["b" /* getGroupIcons */])(Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput),schoolClass.Groups)}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_score',1),score:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["s" /* getPoints */])(feedback,gameState,Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput).length)+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_neveneffecten'),score:feedback.nevenEffecten||0})));}return null;};_this.renderFeedbackImage=function(feedback,overigEffect,economie){var forceEconomy=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var gameState=_this.props.gameState;var text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(feedback,gameState.language);var img=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["l" /* getImage */])(feedback);if(_this.oe){text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(overigEffect,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["l" /* getImage */])(overigEffect,feedback);}if(feedback.niveau.toLowerCase()==='basic'){if(_this.economie||forceEconomy){if(feedback.type==='BELEIDSKEUZE'){text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(feedback.economie,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["l" /* getImage */])(feedback.economie);}else{text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(economie,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["l" /* getImage */])(economie);}}else if(feedback.type==='BELEIDSKEUZE'){img=feedback.img_2;}}else{if(_this.economie&&economie){text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(economie,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["l" /* getImage */])(economie,feedback);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_feedback_FeedbackImage__["a" /* default */],{disaster:feedback.type==='RAMP',description:text,image:img});};_this.renderFeedbackText=function(feedback,overigEffect,economie){var gameState=_this.props.gameState;var text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["y" /* getText */])(feedback,gameState.language);if(_this.oe){text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["y" /* getText */])(overigEffect,gameState.language);}if(_this.economie){text=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["y" /* getText */])(economie,gameState.language);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:text}}));};_this.getFeedbackEffectLaag=function(oi,e,f){var icon=void 0,text=void 0,type=void 0,clickable=void 0;if(e){clickable=true;icon=e.winstverliesglobas>=0?__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].thumbsUp:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].thumbsDown;text=e.winstverliesglobas>=0?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_feedback_door_keuze_meer_globas'):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_feedback_door_keuze_minder_globas');type=e.winstverliesglobas>=0?'profit':'loss';}else if(oi){clickable=false;// OI is altijd positief
icon=__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].thumbsUp;text=Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_feedback_keuze_extra_inkomsten');}var url='/ministries/overview/'+type+'/'+f.omschrijving;if(e||oi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-laag-oi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:icon,alt:'thumbs'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24_react_router_dom__["a" /* Link */],{to:url,style:clickable?{}:{pointerEvents:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:text}})));}return null;};_this.pageType=props.match.params.id;_this.feedbackId=props.match.params.feedbackIdentifier;_this.effectId=props.match.params.effect;_this.oe=_this.pageType==='overigEffect';_this.economie=_this.pageType==='economie';_this.state={flip:true,showProbleemOplossing:false};return _this;}_createClass(Feedback,[{key:'renderHoog',value:function renderHoog(){var _props=this.props,match=_props.match,gameState=_props.gameState,prevRoundFeedbackData=_props.feedback.prevRoundFeedbackData;var feedback=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["i" /* getFeedback */])(prevRoundFeedbackData,this.feedbackId);if(Object.entries(feedback).length===0&&feedback.constructor===Object){var url="/ministries/"+(match.params.ministryId!==undefined?match.params.ministryId:match.params.id);__WEBPACK_IMPORTED_MODULE_5__history_js__["a" /* default */].push(url);return null;}var overigEffect=feedback.overigeEffecten[this.effectId]||{};var economie=feedback.economie||{};if(!economie)this.economie=false;if(!overigEffect)this.oe=false;// Check if OE
if(this.oe||this.economie)feedback.type='OVERIGEFFECT';// override type with OE
if(!Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["d" /* checkRead */])(feedback,this.oe,this.effectId,this.economie)){if(this.oe){feedback.read['readOe_'+this.effectId]=true;var array=feedback.read;array['readOe_'+this.effectId]=true;this.props.dispatch(updateRead(feedback.id,array));}else if(this.economie){feedback.read.economie=true;var _array=feedback.read;_array.economie=true;this.props.dispatch(updateRead(feedback.id,_array));}else{feedback.read.read=true;var _array2=feedback.read;this.props.dispatch(updateRead(feedback.id,_array2));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'fbWrapper',className:'container feedbackcontainer'},this.renderMinistryHeader(feedback,overigEffect,economie),this.renderFeedbackHeader(feedback,overigEffect,economie),this.renderStatistics(feedback,overigEffect,economie),['ALGEMEEN','RAMP','STARTSITUATIE'].indexOf(feedback.type)!==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__elements_feedback_FeedbackStatusRounds__["a" /* default */],{ministry:feedback.ministerie}):null,this.renderFeedbackImage(feedback,overigEffect,economie),this.renderFeedbackText(feedback,overigEffect,economie),feedback.nevenEffecten&&!this.oe&&!this.economie?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'effectsHeader',className:'effects-header'},feedback.type==='BELEIDSKEUZE'?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_beleidskeuze_heeft_effect_op'):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_budgetkeuze_heeft_effect_op'),':'),Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["w" /* getSideEffects */])(feedback).map(function(oe,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_feedback_FeedbackEffect__["a" /* default */],{key:i,image:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["l" /* getImage */])(oe)// minimal={minimal}
,ministry:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(oe.ministerie),ministryIcon:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["g" /* ministryIcons */][oe.ministerie],description:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(oe,gameState.language),s:true,unit:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase(),points:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["s" /* getPoints */])(oe,gameState)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["y" /* getText */])(oe,gameState.language)}}));}),feedback.economie?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_feedback_FeedbackEffect__["a" /* default */],{image:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["l" /* getImage */])(feedback.economie),ministry:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_economie'),pointsTitle:Math.abs(feedback.economie.winstverliesglobas)+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')+' '+(parseInt(feedback.economie.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_verliesglobas')),ministryIcon:parseInt(feedback.economie.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].upGlobas:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].minGlobas,description:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(feedback.economie,gameState.language),unit:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'),points:feedback.economie.winstverliesglobas},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["y" /* getText */])(feedback.economie,gameState.language)}})):null,feedback.overigeInkomsten?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_feedback_FeedbackEffect__["a" /* default */],{ministry:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_overige_inkomsten'),ministryIcon:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].gift,pointsTitle:feedback.overigeInkomsten.winstverliesglobas+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'),description:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["m" /* getImageText */])(feedback.overigeInkomsten,gameState.language),unit:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_globas'),points:feedback.overigeInkomsten.winstverliesglobas},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["y" /* getText */])(feedback.overigeInkomsten,gameState.language)}})):null):null));}},{key:'renderLaag',value:function renderLaag(){var _props2=this.props,match=_props2.match,prevRoundFeedbackData=_props2.feedback.prevRoundFeedbackData;var feedback=Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["i" /* getFeedback */])(prevRoundFeedbackData,this.feedbackId);if(Object.entries(feedback).length===0&&feedback.constructor===Object){var url="/ministries/"+(match.params.ministryId!==undefined?match.params.ministryId:match.params.id);__WEBPACK_IMPORTED_MODULE_5__history_js__["a" /* default */].push(url);return null;}var overigEffect=feedback.overigeEffecten[this.effectId];var economie=feedback.economie;if(!economie)this.economie=false;if(!overigEffect)this.oe=false;// Check if OE
if(this.oe||this.economie)feedback.type='OVERIGEFFECT';// override type with OE
if(!Object(__WEBPACK_IMPORTED_MODULE_4__helpers_feedbackHelpers__["d" /* checkRead */])(feedback,this.oe,this.effectId,this.economie)){if(this.oe){feedback.read['readOe_'+this.effectId]=true;var array=feedback.read;array['readOe_'+this.effectId]=true;this.props.dispatch(updateRead(feedback.id,array));}else if(this.economie){feedback.read.economie=true;var _array3=feedback.read;_array3.economie=true;this.props.dispatch(updateRead(feedback.id,_array3));}else{feedback.read.read=true;var _array4=feedback.read;this.props.dispatch(updateRead(feedback.id,_array4));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'fbWrapper',className:'container feedbackcontainer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_GameTopBar__["a" /* default */],{match:_extends({},match),history:this.props.history,buttonType:'close'}),this.renderMinistryHeader(feedback,overigEffect,economie),this.renderStatistics(feedback,overigEffect,economie),['ALGEMEEN','RAMP','STARTSITUATIE'].indexOf(feedback.type)!==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__elements_feedback_FeedbackStatusRounds__["a" /* default */],{ministry:feedback.ministerie}):null,this.renderFeedbackImage(feedback,overigEffect,economie),this.renderFeedbackText(feedback,overigEffect,economie),feedback.overigeInkomsten||feedback.economie?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-container laag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'effectsHeader',className:'effects-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].megafoon,alt:'megafoon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_let_op'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_feedback_FeedbackEffect__["a" /* default */],{minimal:true,difficulty:'BASIC'},this.getFeedbackEffectLaag(feedback.overigeInkomsten,feedback.economie,feedback))):null));}}]);return Feedback;}(__WEBPACK_IMPORTED_MODULE_15__DifficultyAwareComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,project=_ref.project,gameStateInput=_ref.gameStateInput,schoolClass=_ref.schoolClass,policyChoice=_ref.policyChoice;return{gameState:gameState,feedback:feedback,project:project,gameStateInput:gameStateInput,schoolClass:schoolClass,policyChoice:policyChoice};})(Feedback));

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_QuestionButton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_IncomeDetail__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_TaxItemContainer__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_TaxItem__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_TaxesLow__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_buitenland_svg__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_buitenland_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_buitenland_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_1_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_2_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_3_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_4_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_belasting_5_svg__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_belasting_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_belasting_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_belasting_6_svg__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_belasting_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_belasting_6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_belasting_7_svg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_belasting_7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_img_icons_belasting_7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_img_icons_budget_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__assets_img_icons_budget_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__assets_img_icons_budget_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__config__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var updateMyState=__WEBPACK_IMPORTED_MODULE_30__actions__["a" /* default */].gameStateInput.updateMyState;var Taxes=(_temp=_class=function(_Component){_inherits(Taxes,_Component);function Taxes(props){_classCallCheck(this,Taxes);var _this=_possibleConstructorReturn(this,(Taxes.__proto__||Object.getPrototypeOf(Taxes)).call(this,props));_this.setShown=function(){_this.setState({openedVBelasting:true});};_this.getGroupIcons=function(){var groups=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var schoolClass=_this.props.schoolClass;return groups.map(function(grp,i){var g=schoolClass.Groups.find(function(g){return g.GroupTheme.color===grp;});if(g)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:Math.random()+i+'lolimsorandom',className:'tax-item-badge',src:''+__WEBPACK_IMPORTED_MODULE_31__config___default.a.apiUrl+g.GroupTheme.badge,alt:'badge'});return null;});};_this.validateTaxOne=function(){var state=_this.props.gameStateInput.myState;var ab=state.arbeidsBelasting>=1&&state.arbeidsBelasting<=59;var bb=state.bedrijvenBelasting>=1&&state.bedrijvenBelasting<=34;return ab&&bb;};_this.validateTaxTwo=function(){var vSeen=_this.state.openedVBelasting;var state=_this.props.gameStateInput.myState;var c=state.CBelasting>=1&&state.CBelasting<=34;var vv=state.VVBelasting>=1&&state.VVBelasting<=49;var v=state.VBelasting>=0&&state.VBelasting<=6;return c&&vv&&vSeen&&v;};_this.getWinstVerliesEffect=function(fb){return{icon:parseInt(fb.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_25__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_economy_min_globas_svg___default.a,title:parseInt(fb.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),contentTitle:fb.winstverliesglobas||0,contentUnit:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')};};_this.getTotalBuitenland=function(state){return state.BL_AB_globas+state.BL_BB_globas+state.BL_CB_globas+state.BL_VVB_globas+state.BL_VB_globas;};_this.getTotalBudgetPoints=function(state){return state.AB_points+state.BB_points+state.VV_points+state.C_points+state.V_points;};_this.getTotalBudgetGlobas=function(state,oi,totalDebitCredit){return state.AB_globas+state.BB_globas+state.VV_globas+state.C_globas+state.V_globas+_this.getOISum(oi)+totalDebitCredit;};_this.getEffects=function(fb){var effects=[];if(fb.economie){effects.push(_this.getWinstVerliesEffect(fb.economie));}return effects.concat(fb.overigeEffecten.map(function(oe){return{icon:__WEBPACK_IMPORTED_MODULE_28__assets_assets__["g" /* ministryIcons */][oe.ministerie],title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])(oe.ministerie),contentTitle:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["s" /* getPoints */])(oe),contentUnit:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_punten')};}));};_this.getOISum=function(overigeInkomsten,replacementChar){return overigeInkomsten.reduce(function(sum,oi){sum+=parseInt(oi.winstverliesglobas,10)||0;return sum;},0)||replacementChar||0;};_this.state={showOtherIncomeDropdown:false,showBuitenlandDropdown:false,showInterestDropdown:false,showBudgetDropdown:false,openedVBelasting:false};return _this;}_createClass(Taxes,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,gameState=_props.gameState,dispatch=_props.dispatch,project=_props.project;if(gameState.currentRound===1&&gameState.currentStep===2){Object(__WEBPACK_IMPORTED_MODULE_14__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtbelastingheffen_T1':'mlgvtbelastingheffen1_T1',dispatch);}if(gameState.currentRound===2&&gameState.currentStep===2){if(project.difficulty==="BASIC"){Object(__WEBPACK_IMPORTED_MODULE_14__helpers_popupHelper__["a" /* dispatchUnreadPopup */])('mlgvtbelastingheffen2_T1',dispatch);}}}},{key:'toggleOther',value:function toggleOther(property){var state=_extends({},this.state);state[property]=!state[property];this.setState(state);}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,gameState=_props2.gameState,gameStateInput=_props2.gameStateInput,feedback=_props2.feedback,dispatch=_props2.dispatch,desktop=_props2.desktop;var myState=gameStateInput.myState;var _gameState$roundData=gameState.roundData,gameStateSum=_gameState$roundData.gameStateSum,roundGameStateInput=_gameState$roundData.gameStateInput,currentState=_gameState$roundData.state,roundNumber=_gameState$roundData.roundNumber;var feedbackAB=feedback.feedbackAB,feedbackBB=feedback.feedbackBB,feedbackCB=feedback.feedbackCB,feedbackVVB=feedback.feedbackVVB,feedbackVB=feedback.feedbackVB;var overigeInkomsten=Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["r" /* getOverigeInkomsten */])(feedback.prevRoundFeedbackData,gameState);if(this.props.project.difficulty==='BASIC'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_TaxesLow__["a" /* default */],{desktop:this.props.desktop,history:this.props.history,inheritedState:this.state,getGroupIcons:this.getGroupIcons});}var isBankDisabledForSimulation=false;if(this.props.gameStateInput&&this.props.gameStateInput.myState&&this.props.gameStateInput.myState.SIMULATION_TAX==='PROCESSED'){var currDC=this.props.gameState.roundData&&this.props.gameState.roundData.lastGameState&&this.props.gameState.roundData.lastGameState.OneTimeEffect&&this.props.gameState.roundData.lastGameState.OneTimeEffect.debitCredit;isBankDisabledForSimulation=currDC?currDC.some(function(c){return c.bankDisabledPayout;}):false;}else{isBankDisabledForSimulation=this.props.project.bankEnabled===false;}var debitCredit=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.filter(function(dc){return!dc.key.endsWith('NotConfirmed');}).map(function(dbCr){return Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["a" /* calculateDebitCreditOutcome */])(dbCr,roundNumber,isBankDisabledForSimulation);}).filter(function(entry){return entry&&entry.amount;});//filter out empty
var totalDebitCredit=debitCredit.reduce(function(acc,val){return acc-val.amount;},0);var AB_economie=gameStateSum.AB_economie,BB_economie=gameStateSum.BB_economie;AB_economie=AB_economie||Math.round(gameState.totalEconomy*myState.taxDividence);BB_economie=BB_economie||gameState.totalEconomy-AB_economie;var buitenland1=gameStateSum.BL_AB_globas+gameStateSum.BL_BB_globas;var buitenland2=gameStateSum.BL_VVB_globas+gameStateSum.BL_CB_globas+gameStateSum.BL_VB_globas;var taxAVideo=gameState.language==='NL'?__WEBPACK_IMPORTED_MODULE_31__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGA_NL_720p_1,5Mbps.mp4':__WEBPACK_IMPORTED_MODULE_31__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGA_ENG_720p_1,5Mbps.mp4';var taxBVideo=gameState.language==='NL'?__WEBPACK_IMPORTED_MODULE_31__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGB_NL_720p_1,5Mbps.mp4':__WEBPACK_IMPORTED_MODULE_31__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGB_ENG_720p_1,5Mbps.mp4';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{match:this.props.match,history:this.props.history,historic:false,buttonType:'view',viewType:'list',showTitle:true}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__elements_PopupTitle__["a" /* default */],{popupId:'mhgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{reverseGlobasPoints:true,bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_totalglobas'),icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,hidePoints:true}),gameState.prevRoundSum.FB_value<=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-element content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_26__assets_img_icons_warning_svg___default.a,alt:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_popupHelper__["d" /* getContent */])("dhgmstap2fb0",gameState.language)}}))):null,myState.SIMULATION_TAX==='PROCESSED'&&buitenland1+buitenland2>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_QuestionButton__["a" /* default */],{popupid:'dhgvtbuitenland'},Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_buitenland'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{feedbackCount:myState.buitenlandRead?0:1,onClick:function onClick(){if(!myState.buitenlandRead){dispatch(updateMyState({buitenlandRead:true}));}_this2.toggleOther('showBuitenlandDropdown');},bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_buitenland'),icon:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_buitenland_svg___default.a,globas:this.getTotalBuitenland(gameStateSum),hidePoints:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buitenland interest-income country-budget'+(this.state.showBuitenlandDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verplaats_naar_buitenland')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_lonen_werknemers'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_AB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_BB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumptie'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_CB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_VVB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_spaargeld_en_beleggingen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_VB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_totaal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBuitenland(gameStateSum),' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard'))))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_TaxItemContainer__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_belastingen'),buttonConditions:this.validateTaxOne(),video:taxAVideo,saving:myState.SIMULATION_TAX==='SUBMITTED',saved:myState.SIMULATION_TAX==='PROCESSED',showSavedPopup:myState.showSavedPopup==='SIMULATION_TAX',buitenLandDialog:buitenland1,visible:true,step:'SIMULATION_TAX',savingMessage:'dhgmstap2opslaan1',feedbackMessage:'dhgmstap2opslaan1_2',part:1,popupId:'mhgvtbelastingendeel1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'arbeidsBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_globas,saving:myState.SIMULATION_TAX==='SUBMITTED',maxValue:100,cap:59,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.arbeidsBelasting,collaborationValue:myState.samenWerkingAB,collaborationKey:'samenWerkingAB',notification:{read:feedbackAB.read,reference:feedbackAB.id},icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_1_svg___default.a,dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_lonenwerknemers'),globas:AB_economie}],feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_lonen_werknemers'),value:AB_economie+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).arbeidsBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.samenWerkingAB)},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_geinde_arbeidsbelasting'),value:gameStateSum.AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_besteedbaar_inkomen_werknemers'),value:AB_economie-gameStateSum.BL_AB_globas-gameStateSum.AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["l" /* getImage */])(feedbackAB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackAB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["y" /* getText */])(feedbackAB,gameState.language),effects:this.getEffects(feedbackAB)},popupId:'mhgvtarbeidsbelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting'),sliderKey:'bedrijvenBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.BB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.BB_globas,saving:myState.SIMULATION_TAX==='SUBMITTED',maxValue:100,cap:34,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.bedrijvenBelasting,collaborationValue:myState.samenWerkingBB,collaborationKey:'samenWerkingBB',notification:{read:feedbackBB.read,reference:feedbackBB.id},icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_2_svg___default.a,dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'),globas:BB_economie}],feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'),value:BB_economie+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).bedrijvenBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.samenWerkingBB)},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_geinde_bedrijvenbelasting'),value:gameStateSum.BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_besteedbaar_inkomen_bedrijfseigenaren'),value:BB_economie-gameStateSum.BL_BB_globas-gameStateSum.BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["l" /* getImage */])(feedbackBB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackBB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["y" /* getText */])(feedbackBB,gameState.language),effects:this.getEffects(feedbackBB)},popupId:'mhgvtbedrijvenbelasting'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_TaxItemContainer__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_belastingen'),buttonConditions:this.validateTaxTwo(),video:taxBVideo,saving:myState.SIMULATION_TAX_2==='SUBMITTED',saved:myState.SIMULATION_TAX_2==='PROCESSED',showSavedPopup:myState.showSavedPopup==='SIMULATION_TAX_2',buitenLandDialog:!buitenland1&&buitenland2?buitenland2:false,visible:['SIMULATION_TAX_2','SIMULATION_SPENDING','END'].includes(currentState)&&Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["d" /* checkRead */])(feedbackAB,false,0,false)&&Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["d" /* checkRead */])(feedbackBB,false,0,false),step:'SIMULATION_TAX_2',savingMessage:'dhgmstap2opslaan2',feedbackMessage:'dhgmstap2opslaan2_2',part:2,popupId:'mhgvtbelastingendeel2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'CBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.C_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.C_globas,saving:myState.SIMULATION_TAX_2==='SUBMITTED',maxValue:100,cap:34,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.CBelasting,collaborationValue:myState.CBelastingSW,collaborationKey:'CBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_3_svg___default.a,notification:{read:feedbackCB.read,reference:feedbackCB.id},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumptie'),globas:gameState.roundData.lastGameState.OneTimeEffect.CO}],feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumptie'),value:gameState.roundData.gameStateSum.CO_value+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).CBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.CBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_CB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_geinde_consumentenbelasting'),value:gameStateSum.C_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["l" /* getImage */])(feedbackCB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackCB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["y" /* getText */])(feedbackCB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackCB)},popupId:'mhgvtconsumentenbelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'VVBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.VV_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.VV_globas,saving:myState.SIMULATION_TAX_2==='SUBMITTED',maxValue:100,cap:49,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.VVBelasting,collaborationValue:myState.VVBelastingSW,collaborationKey:'VVBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_4_svg___default.a,notification:{read:feedbackVVB.read,reference:feedbackVVB.id},feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'),value:gameState.roundData.gameStateSum.VV_value+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).VVBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.VVBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_VVB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_geinde_vervuilingsbelasting'),value:gameStateSum.VV_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["l" /* getImage */])(feedbackVVB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackVVB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["y" /* getText */])(feedbackVVB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackVVB)},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'),globas:gameState.roundData.lastGameState.OneTimeEffect.VV}],popupId:'mhgvtmensenmilieubelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_vermogenbelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'VBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.V_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.V_globas,saving:myState.SIMULATION_TAX_2==='SUBMITTED',maxValue:100,cap:6,minValue:0,registerShown:this.setShown,capNotification:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_vermogensbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.VBelasting,collaborationValue:myState.VBelastingSW,collaborationKey:'VBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_belasting_5_svg___default.a,notification:{read:feedbackVB.read,reference:feedbackVB.id},feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_totale_vermogen_van_burgers'),value:gameState.totalGameStateSum.V_value+gameStateSum.V_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).VBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.VBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_VB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_geinde_vermogensbelasting'),value:gameStateSum.V_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["l" /* getImage */])(feedbackVB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackVB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["y" /* getText */])(feedbackVB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackVB)},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_besparingen_deze_periode'),globas:gameState.roundData.gameStateSum.V_value},{title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_totale_vermogen_van_burgers'),globas:gameState.totalGameStateSum.V_value}],popupId:'mhgvtvermogensbelasting'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section overige-inkomsten'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtoverigeinkomsten',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showOtherIncomeDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_overige_inkomsten"),icon:__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_belasting_6_svg___default.a,globas:this.getOISum(overigeInkomsten,'-'),hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'other-income'+(this.state.showOtherIncomeDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__["a" /* default */],null,overigeInkomsten.map(function(oi,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_IncomeDetail__["a" /* default */],{key:i,img:oi.icon,title:oi.title,description:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_feedbackHelpers__["y" /* getText */])(oi,gameState.language),amount:oi.winstverliesglobas,unit:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')});}))),debitCredit.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showInterestDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_aflossingen_en_rentes'),icon:__WEBPACK_IMPORTED_MODULE_23__assets_img_icons_belasting_7_svg___default.a,globas:totalDebitCredit,hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income'+(this.state.showInterestDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__["a" /* default */],null,debitCredit.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.icon,alt:'icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,-item.amount>0?'+'+-item.amount:-item.amount,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard'),' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_totaal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,totalDebitCredit,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))))):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_29__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtoverheidsbudget',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{reverseGlobasPoints:true,onClick:this.toggleOther.bind(this,'showBudgetDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_overheidsbudget'),icon:__WEBPACK_IMPORTED_MODULE_27__assets_img_icons_budget_png___default.a,globas:this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,totalDebitCredit),points:myState.SIMULATION_TAX!=='PROCESSED'?'-':this.getTotalBudgetPoints(gameStateSum),bigArrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income country-budget'+(this.state.showBudgetDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__["a" /* default */],null,gameStateSum.AB_point||gameStateSum.AB_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.AB_points,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.AB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.BB_points||gameStateSum.BB_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BB_points,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.C_points||gameStateSum.C_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.C_points,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.C_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.VV_points||gameStateSum.VV_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.VV_points,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.VV_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.V_points||gameStateSum.V_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_vermogenbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.V_points,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.V_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,this.getOISum(overigeInkomsten)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_overige_inkomsten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getOISum(overigeInkomsten),' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,totalDebitCredit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_aflossingen_en_rentes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,totalDebitCredit,' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_totaal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBudgetPoints(gameStateSum),' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,totalDebitCredit),' ',Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])('sim_miljard')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}}]);return Taxes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux_es_connect_connect__["a" /* default */])(function(state){return state;})(Taxes));

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_svg__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var VideoButton=(_temp=_class=function(_Component){_inherits(VideoButton,_Component);function VideoButton(props){_classCallCheck(this,VideoButton);var _this=_possibleConstructorReturn(this,(VideoButton.__proto__||Object.getPrototypeOf(VideoButton)).call(this,props));_this.state={// To do, replace with function getting current round
currentRound:2,roundTitle:Object(__WEBPACK_IMPORTED_MODULE_4_i18n_for_browser__["a" /* __ */])("sim_hoe_staat_je_land_ervoor"),showPopUp:false};return _this;}_createClass(VideoButton,[{key:'togglePopUp',value:function togglePopUp(){this.setState({showPopUp:!this.state.showPopUp});if(this.state.showPopUp){if(this.props.elementFocus){}}}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'question-mark video',onClick:this.togglePopUp.bind(this)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'videoIcon',src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_play_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_transition_group__["CSSTransition"],{'in':this.state.showPopUp,timeout:200,classNames:'animation',unmountOnExit:true},function(state){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_PopUp__["a" /* default */],{title:_this2.props.popUpTitle,description:_this2.props.popUpDescription,nextUpType:_this2.props.nextUpType,buttonText:_this2.props.buttonText,showPopUp:_this2.state.showPopUp,elementFocus:_this2.props.elementFocus,closePopUpClick:_this2.togglePopUp.bind(_this2),video:_this2.props.src,interactive:true});}));}}]);return VideoButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={elementFocus:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,popUpTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,popUpDescription:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,buttonText:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,nextUpType:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={nextUpType:'close'},_temp);

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/play.43b8bdca.svg";

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TaxItemContainer__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TaxItem__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__IncomeDetail__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__ = __webpack_require__(11);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaxesLow=(_temp=_class=function(_Component){_inherits(TaxesLow,_Component);function TaxesLow(props){_classCallCheck(this,TaxesLow);var _this=_possibleConstructorReturn(this,(TaxesLow.__proto__||Object.getPrototypeOf(TaxesLow)).call(this,props));_this.validateTaxOne=function(){var state=_this.props.gameStateInput.myState;var ab=state.arbeidsBelasting>=1&&state.arbeidsBelasting<=79;return ab;};_this.getWinstVerliesEffect=function(fb){return{icon:parseInt(fb.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg___default.a,title:parseInt(fb.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),contentTitle:fb.winstverliesglobas||0,contentUnit:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')};};_this.getEffects=function(fb){var effects=[];if(fb.economie){effects.push(_this.getWinstVerliesEffect(fb.economie));}return effects.concat((fb.overigeEffecten||[]).map(function(oe){return{icon:__WEBPACK_IMPORTED_MODULE_10__assets_assets__["g" /* ministryIcons */][oe.ministerie],title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])(oe.ministerie),contentTitle:Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["s" /* getPoints */])(oe),contentUnit:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_punten')};}));};_this.getOISum=function(overigeInkomsten,replacementChar){return overigeInkomsten.reduce(function(sum,oi){sum+=parseInt(oi.winstverliesglobas,10)||0;return sum;},0)||replacementChar||0;};_this.getTotalBudgetGlobas=function(state,oi,isBankDisabledForSimulation){var spaar=_this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(i){return i&&i.key;}).reduce(function(acc,i){if(i.key==='stortenSpaargeld'){return acc+-i.amount;}return acc+-i.amount;},0);return state.AB_globas+_this.getOISum(oi)+spaar;};_this.state={showReceivedInterestDropdown:false,showPaidInterestDropdown:false,showOtherIncomeDropdown:false,showBudgetDropdown:false};return _this;}_createClass(TaxesLow,[{key:'toggleOther',value:function toggleOther(property){var state=_extends({},this.state);state[property]=!state[property];this.setState(state);}},{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,feedback=_props.feedback,desktop=_props.desktop,project=_props.project;var myState=gameStateInput.myState;var gameStateSum=gameState.roundData.gameStateSum;var belastingFeedback=feedback.belastingFeedback;var overigeInkomsten=Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["r" /* getOverigeInkomsten */])(feedback.prevRoundFeedbackData,gameState,project.minPolicyChoices);var isBankDisabledForSimulation=false;if(myState&&myState.SIMULATION_TAX==='PROCESSED'){var currDC=gameState.roundData&&gameState.roundData.lastGameState&&gameState.roundData.lastGameState.OneTimeEffect&&gameState.roundData.lastGameState.OneTimeEffect.debitCredit;isBankDisabledForSimulation=currDC?currDC.some(function(c){return c.bankDisabledPayout;}):false;}else{isBankDisabledForSimulation=project.bankEnabled===false;}var schuld=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.filter(function(i){return i.key==='lenenVanBank';}).map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(i){return i&&i.key;}).reduce(function(acc,i){return acc+-i.amount;},0);var spaargeld=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.filter(function(i){return i.key==='stortenSpaargeld';}).map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(i){return i&&i.key;}).reduce(function(acc,i){if(i.key==='stortenSpaargeld'){return acc+-i.amount;}return acc+-i.amount;},0);if(!schuld)schuld=false;if(!spaargeld)spaargeld=false;spaargeld=spaargeld||0;schuld=schuld||0;var taxVideo=gameState.language==='NL'?__WEBPACK_IMPORTED_MODULE_20__config___default.a.uploadsUrl+'/assets/videos/belasting_LAAG_NL_720p_1,5Mbps.mp4':__WEBPACK_IMPORTED_MODULE_20__config___default.a.uploadsUrl+'/assets/videos/belasting_LAAG_ENG_720p_1,5Mbps.mp4';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'view',viewType:'list',showTitle:true}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PopupTitle__["a" /* default */],{popupId:'mlgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ListButton__["a" /* default */],{bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_totalglobas'),icon:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,hidePoints:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TaxItemContainer__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belasting'),video:taxVideo,saving:myState.SIMULATION_TAX==='SUBMITTED'||myState.SIMULATION_TAX_2==='SUBMITTED',saved:myState.SIMULATION_TAX==='PROCESSED'&&myState.SIMULATION_TAX_2==='PROCESSED',showSavedPopup:myState.showSavedPopup==='SIMULATION_TAX_2',visible:true,step:'SIMULATION_TAX',savingMessage:'dlgmstap3opslaan_2',feedbackMessage:'dlgmstap2opslaan_3',buttonConditions:this.validateTaxOne(),popupId:'mlgvtbelasting'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belastinginkomsten'),video:'https://player.vimeo.com/video/265045525',reverseGlobasPoints:true,sliderKey:'arbeidsBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_globas,twoValueSlider:true,suffix:'%',sliderTitles:[Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belasting'),Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_bevolking')],maxValue:100,cap:79,minValue:0,capNotification:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_arbeidsbelasting_te_hoog_percentage_melding'),sliderValue:myState.arbeidsBelasting,notification:{read:belastingFeedback.read,reference:belastingFeedback.id},icon:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg___default.a,taxDescription:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_arbeidsbelasting_beschrijving'),feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[],img:Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["l" /* getImage */])(belastingFeedback),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["m" /* getImageText */])(belastingFeedback,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["y" /* getText */])(belastingFeedback,gameState.language),effects:this.getEffects(belastingFeedback)},popupId:'mlgvtarbeidsbelasting',ignorePopup:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section overige-inkomsten'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__PopupTitle__["a" /* default */],{popupId:'mlgvtoverigeinkomsten',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showOtherIncomeDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('Overige inkomsten'),icon:__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg___default.a,globas:this.getOISum(overigeInkomsten,'-'),hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'other-income'+(this.state.showOtherIncomeDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ContentContainer__["a" /* default */],null,overigeInkomsten.map(function(oi,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__IncomeDetail__["a" /* default */],{key:i,img:oi.icon,title:oi.title,description:Object(__WEBPACK_IMPORTED_MODULE_22__helpers_feedbackHelpers__["y" /* getText */])(oi,gameState.language),amount:oi.winstverliesglobas,unit:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')});}))),spaargeld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showReceivedInterestDropdown'),bgColor:'white',title:isBankDisabledForSimulation?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_spaargeld'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_rente_op_spaargeld'),icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg___default.a,globas:spaargeld,hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income'+(this.state.showReceivedInterestDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,isBankDisabledForSimulation?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_spaargeld_bank_uitgeschakeld_uitleg'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_ontvangen_rente_uitleg'))))):null,schuld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showPaidInterestDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_terug_te_betalen_lening'),icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg___default.a,globas:schuld,hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income'+(this.state.showPaidInterestDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_bedrag_vorige_ronde_geleend_uitleg'))))):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_budget')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showBudgetDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_totale_budget'),icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png___default.a,globas:this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,isBankDisabledForSimulation),hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income country-budget'+(this.state.showBudgetDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ContentContainer__["a" /* default */],null,gameStateSum.AB_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belastinginkomsten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.AB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',this.getOISum(overigeInkomsten)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_overige_inkomsten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getOISum(overigeInkomsten),' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',spaargeld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,isBankDisabledForSimulation?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_spaargeld'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_rente_op_spaargeld'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,spaargeld,' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',schuld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_terug_te_betalen_lening'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,schuld,' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_totaal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,isBankDisabledForSimulation),' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard'))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__NextStep__["a" /* default */],null)));}}]);return TaxesLow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={inheritedState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,gameStateInput=_ref.gameStateInput,project=_ref.project,schoolClass=_ref.schoolClass;return{gameState:gameState,feedback:feedback,gameStateInput:gameStateInput,project:project,schoolClass:schoolClass};})(TaxesLow));

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BankSavingDropdown__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_gameStateInput__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_lenen_bank_svg__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_lenen_bank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_lenen_bank_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_lenen_bank_laag_svg__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_lenen_bank_laag_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_lenen_bank_laag_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_lenen_land_svg__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_lenen_land_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_lenen_land_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_uitlenen_land_svg__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_uitlenen_land_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_uitlenen_land_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_bank_png__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_bank_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_bank_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_opnemen_spaargeld_svg__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_opnemen_spaargeld_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_opnemen_spaargeld_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_sparen_bank_svg__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_sparen_bank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_sparen_bank_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_schenken_land_svg__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_schenken_land_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_schenken_land_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_pending_svg__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_pending_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_pending_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_approved_svg__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_approved_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_approved_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helpers_feedbackHelpers__ = __webpack_require__(11);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */// let cleared = 0;
var updateMyState=__WEBPACK_IMPORTED_MODULE_7__actions_gameStateInput__["a" /* default */].updateMyState;var Bank=(_temp=_class=function(_DifficultyAwareCompo){_inherits(Bank,_DifficultyAwareCompo);function Bank(props){_classCallCheck(this,Bank);var _this=_possibleConstructorReturn(this,(Bank.__proto__||Object.getPrototypeOf(Bank)).call(this,props));_this.printOverview=function(gameStateInput,dispatch){var _this$props$feedback=_this.props.feedback,currentRound=_this$props$feedback.currentRound,totalRounds=_this$props$feedback.totalRounds;var isHistory=currentRound<totalRounds-1?true:false;var overview=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["b" /* getOverview */])(gameStateInput,dispatch,_this.state,_this.props.bankNotificationsState,isHistory);var debitCredit=gameStateInput.myState.debitCredit;var unreadGift=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["e" /* getUnreadGifts */])(gameStateInput);if(overview===null){return"";}else{return overview.map(function(parentItem,partsIndex){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-section overview',key:partsIndex},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:parentItem.title,tag:'h3'}),parentItem.items.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:index,className:'content-container small'+(_this.state.overview[0].items[index].open?' show':''),onClick:_this.toggleOpen.bind(_this,partsIndex,index,dispatch,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'title'},item.title),item.keys&&(item.keys.some(function(key){return debitCredit[key]&&debitCredit[key].confirmed&&debitCredit[key].unread;})||(item.title==='Geleend, gekregen of opgenomen'?unreadGift:false))?//bevat het een unread item?
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'notification'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'!'))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.points!==0?item.extraInfo||'':''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.points===undefined||item.points===0?"-":item.points),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,item.pending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_in_afwachting_status'),src:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_pending_svg___default.a}):'')),item.items?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',{className:'overview-list'},item.items.map(function(listItem,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'image'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:listItem.title,src:listItem.icon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,listItem.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'float-right-small'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,listItem.pending?Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_niet_bevestigd_status'):listItem.points),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,listItem.pending?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_in_afwachting_status'),src:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_pending_svg___default.a}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_geaccepteerd_status'),src:__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_approved_svg___default.a}))));})):'');}));});}};_this.getCreditLand=function(_ref){var states=_ref.states,_ref$myState=_ref.myState,theme=_ref$myState.theme,roundNumber=_ref$myState.roundNumber,debitCredit=_ref$myState.debitCredit;var steps={plus1Rounds:[],plus2Rounds:[]};var credit=Object.values(states).reduce(function(accumilator,round,roundNo){if(roundNumber>=4)return accumilator;if(roundNo>=roundNumber-1&&roundNo>0&&roundNo<=roundNumber){var roundsPassed=roundNumber-roundNo;var myRnds=roundNumber===roundNo?[debitCredit]:Object.values(round).filter(function(current){return current.theme===theme;}).map(function(current){return current.debitCredit;}).filter(Boolean);var count=Object.keys(myRnds[0]).reduce(function(accumilatorInner,current){if(current==='lenenAanLand'&&myRnds[0][current].confirmed===true){var object=myRnds[0][current];if(roundsPassed===2){//math floor
return accumilatorInner+Math.ceil(object.amount/2+object.interest/2);}else if(roundsPassed===1){//math ceil
steps.plus1Rounds.push({name:'lenenAanLand',otherCountry:object.otherCountry,amount:Math.floor(object.amount/2+object.interest/2)});return accumilatorInner+Math.floor(object.amount/2+object.interest/2);}else{//All moneys
steps.plus1Rounds.push({name:'lenenAanLand',otherCountry:object.otherCountry,amount:Math.ceil(object.amount/2+object.interest/2)});steps.plus2Rounds.push({name:'lenenAanLand',otherCountry:object.otherCountry,amount:Math.floor(object.amount/2+object.interest/2)});return accumilatorInner+object.amount+object.interest;}}return accumilatorInner;},0);return accumilator+count;}return accumilator;},0);return{steps:steps,credit:credit};};_this.getCreditBank=function(_ref2){var states=_ref2.states,_ref2$myState=_ref2.myState,theme=_ref2$myState.theme,roundNumber=_ref2$myState.roundNumber,debitCredit=_ref2$myState.debitCredit;var steps={plus1Rounds:[],plus2Rounds:[]};var reduceInterestGain=0;var credit=Object.values(states).reduce(function(accumilator,round,roundNo){if(roundNo>0&&roundNo<=roundNumber){var roundsPassed=roundNumber-roundNo;var myRnds=roundNumber===roundNo?[debitCredit]:Object.values(round).filter(function(current){return current.theme===theme;}).map(function(current){return current.debitCredit;}).filter(Boolean);var count=Object.keys(myRnds[0]).reduce(function(accumilatorInner,current){if(current==='stortenSpaargeld'&&myRnds[0][current].confirmed===true){var object=myRnds[0][current];if(roundsPassed===1){//math ceil
steps.plus1Rounds.push({name:'sim_rente_op_spaargeld',amount:Math.floor(object.interest)});return accumilatorInner+Math.floor(object.amount+(roundNumber>=4?0:object.interest));}else{//All moneys
steps.plus1Rounds.push({name:'sim_rente_op_spaargeld',amount:Math.ceil(object.interest)});return accumilatorInner+object.amount+(roundNumber>=4?0:object.interest);}}else if(current==='opnemenSpaargeld'&&myRnds[0][current].confirmed===true){var _object=myRnds[0][current];reduceInterestGain=-_object.interest;return accumilatorInner-_object.amount-(roundNumber>=4?0:_object.interest);}return accumilatorInner;},0);return accumilator+count;}return accumilator;},0);var changeindex=steps.plus1Rounds.findIndex(function(f){return f.name==='sim_rente_op_spaargeld';});if(changeindex>-1){steps.plus1Rounds[changeindex].amount+=reduceInterestGain;}return{steps:steps,credit:credit};};_this.getCreditBankBasic=function(_ref3){var states=_ref3.states,_ref3$myState=_ref3.myState,roundNumber=_ref3$myState.roundNumber,debitCredit=_ref3$myState.debitCredit;var gameState=_this.props.gameState;var saved=gameState.roundData.lastGameState.OneTimeEffect.debitCredit.filter(function(dc){return dc.key==='stortenSpaargeld';}).reduce(function(acc,dc){return acc-dc.amount;},0);var credit=Object.values(states).reduce(function(accumilator,round,roundNo){if(roundNumber-roundNo===0){var count=Object.keys(debitCredit).reduce(function(accumilatorInner,current){if(current==='stortenSpaargeld'&&debitCredit[current].confirmed===true){var object=debitCredit[current];return accumilatorInner+object.amount/* + object.interest*/;}else if(current==='opnemenSpaargeld'&&debitCredit[current].confirmed===true){var _object2=debitCredit[current];return accumilatorInner-_object2.amount/* - object.interest*/;}return accumilatorInner;},0);return accumilator+count+saved;}return accumilator;},0);return{credit:credit};};_this.getDeptLand=function(_ref4){var states=_ref4.states,_ref4$myState=_ref4.myState,theme=_ref4$myState.theme,roundNumber=_ref4$myState.roundNumber,debitCredit=_ref4$myState.debitCredit;var steps={plus1Rounds:[],plus2Rounds:[]};var debt=Object.values(states).reduce(function(accumilator,round,roundNo){if(roundNumber>=4)return accumilator;if(roundNo>=roundNumber-1&&roundNo>0&&roundNo<=roundNumber){var roundsPassed=roundNumber-roundNo;var myRnds=roundNumber===roundNo?[debitCredit]:Object.values(round).filter(function(current){return current.theme===theme;}).map(function(current){return current.debitCredit;}).filter(Boolean);var count=Object.keys(myRnds[0]).reduce(function(accumilatorInner,current){if(current==='lenenVanLand'&&myRnds[0][current].confirmed===true){var object=myRnds[0][current];if(roundsPassed===2){//math floor
return accumilatorInner+Math.ceil(object.amount/2+object.interest/2);}else if(roundsPassed===1){//math ceil
steps.plus1Rounds.push({name:'lenenVanLand',otherCountry:object.otherCountry,amount:Math.floor(object.amount/2+object.interest/2)});return accumilatorInner+Math.floor(object.amount/2+object.interest/2);}else{//All moneys
steps.plus1Rounds.push({name:'lenenVanLand',otherCountry:object.otherCountry,amount:Math.ceil(object.amount/2+object.interest/2)});steps.plus2Rounds.push({name:'lenenVanLand',otherCountry:object.otherCountry,amount:Math.floor(object.amount/2+object.interest/2)});return accumilatorInner+object.amount+object.interest;}}return accumilatorInner;},0);return accumilator+count;}return accumilator;},0);return{steps:steps,debt:debt};};_this.getDeptBank=function(_ref5){var states=_ref5.states,_ref5$myState=_ref5.myState,theme=_ref5$myState.theme,roundNumber=_ref5$myState.roundNumber,debitCredit=_ref5$myState.debitCredit;var steps={plus1Rounds:[],plus2Rounds:[]};var debt=Object.values(states).reduce(function(accumilator,round,roundNo){if(roundNumber>=4)return accumilator;if(roundNo>=roundNumber-1&&roundNo>0&&roundNo<=roundNumber){var roundsPassed=roundNumber-roundNo;var myRnds=roundNumber===roundNo?[debitCredit]:Object.values(round).filter(function(current){return current.theme===theme;}).map(function(current){return current.debitCredit;}).filter(Boolean);var count=Object.keys(myRnds[0]).reduce(function(accumilatorInner,current){if(current==='lenenVanBank'&&myRnds[0][current].confirmed===true){var object=myRnds[0][current];if(roundsPassed===2){//math floor
return accumilatorInner+Math.ceil(object.amount/2+object.interest/2);}else if(roundsPassed===1){//math ceil
steps.plus1Rounds.push({name:'lenenVanBank',amount:Math.floor(object.amount/2+object.interest/2)});return accumilatorInner+Math.floor(object.amount/2+object.interest/2);}else{//All moneys
steps.plus1Rounds.push({name:'lenenVanBank',amount:Math.ceil(object.amount/2+object.interest/2)});steps.plus2Rounds.push({name:'lenenVanBank',amount:Math.floor(object.amount/2+object.interest/2)});return accumilatorInner+object.amount+object.interest;}}return accumilatorInner;},0);return accumilator+count;}return accumilator;},0);return{steps:steps,debt:debt};};_this.getDeptBankBasic=function(_ref6){var states=_ref6.states,_ref6$myState=_ref6.myState,roundNumber=_ref6$myState.roundNumber,debitCredit=_ref6$myState.debitCredit;var debt=Object.values(states).reduce(function(accumilator,round,roundNo){if(roundNumber-roundNo===0){var count=Object.keys(debitCredit).reduce(function(accumilatorInner,current){if(current==='lenenVanBank'&&debitCredit[current].confirmed===true){var object=debitCredit[current];return accumilatorInner+object.amount+object.interest;}return accumilatorInner;},0);return accumilator+count;}return accumilator;},0);return{debt:debt};};_this.getCreditTotal=function(gameStateInput){return Math.floor(_this.getCreditLand(gameStateInput).credit+_this.getCreditBank(gameStateInput).credit);};_this.getDeptTotal=function(gameStateInput){return Math.floor(_this.getDeptLand(gameStateInput).debt+_this.getDeptBank(gameStateInput).debt);};_this.state={showDropDown:0,lenenVanLand:false,lenenAanLand:false,overview:[{items:[{},{},{},{}]}]};_this.getConfirmedEntries=_this.getConfirmedEntries.bind(_this);_this.renderCurRoundPayback=_this.renderCurRoundPayback.bind(_this);// Reset bank values on page load
Object.keys(_this.props.gameStateInput.myState.debitCredit).forEach(function(k){var debitCredit=_this.props.gameStateInput.myState.debitCredit;console.log(debitCredit);if(_typeof(debitCredit[k])==='object'&&!debitCredit[k].confirmed){debitCredit[k].amount=0;debitCredit[k].interest=0;}_this.props.dispatch(updateMyState({debitCredit:debitCredit}));});return _this;}_createClass(Bank,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){/**
     * This block of code will make sure that whenever we cancel the last pending sparen / lenen item
     * and the overview section is open, the section gets closed again.
     *
     * Client bug description:
     * De bovenste 2 balken onder het ' Overzicht' zijn hoger dan de onderste 2 balken (dit is na het annuleren van leningen,
     * dus er staat nu niks in, maar er heeft wel info in gestaan. )
     */var overview=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["b" /* getOverview */])(props.gameStateInput,props.dispatch,this.state,this.props.bankNotificationsState);var stateOverview=this.state.overview;var change=false;for(var i=0;i<overview[0].items.length;i+=1){if(stateOverview[0].items[i].open&&!overview[0].items[i].items.length){change=true;stateOverview[0].items[i].open=false;}}if(change){this.setState({overview:stateOverview});}return props;}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'toggleDropDown',value:function toggleDropDown(id){if(this.state.showDropDown===id){this.setState({showDropDown:0});}else{this.setState({showDropDown:id});}}},{key:'toggleOpen',value:function toggleOpen(section,index,dispatch,item){if(item.items.length===0)return;var overview=this.state.overview;var gameStateInput=this.props.gameStateInput;if(item.keys){var debitCredit=gameStateInput.myState.debitCredit;item.keys.filter(function(key){return debitCredit[key];}).forEach(function(key){return debitCredit[key].unread=false;});Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["f" /* setGiftsRead */])(gameStateInput);dispatch(updateMyState({debitCredit:debitCredit}));}overview[section].items[index].open=!overview[section].items[index].open;this.setState({overview:overview});}/**
   * Tegoed wat je krijgt van andere landen
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   *//**
   * Tegoed wat je krijgt van de bank
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   *//**
   * Tegoed wat je krijgt van de bank
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   *//**
   * Schuld wat je moet betalen aan andere landen
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   *//**
   * Schuld wat je moet betalen aan de bank
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   *//**
   * Schuld wat je moet betalen aan de bank
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   *//**
   * Totaal tegoed wat je nog krijgt
   * @param {Object} gameStateInput
   * @returns {Number} tegoed
   *//**
   * Totale schuld wat je nog moet betalen
   * @param {Object} gameStateInput
   * @returns {Number} schuld
   */},{key:'getConfirmedEntries',value:function getConfirmedEntries(input,key,otherKey){var _props=this.props,gameStateInput=_props.gameStateInput,gameState=_props.gameState;// Check if debit is confirmed by other group
var loanFromCountry=input.findIndex(function(item){return item.newDebt.key===key;});if(loanFromCountry>-1){if(gameStateInput.states[gameState.currentRound]){var isConfirmed=Object.values(gameStateInput.states[gameState.currentRound]).find(function(state){var groupMatch=state.theme===input[loanFromCountry].newDebt.otherCountry;if(groupMatch&&state.debitCredit[otherKey]){if(state.debitCredit[otherKey].confirmed&&state.debitCredit[otherKey].amount===input[loanFromCountry].newDebt.amount&&state.debitCredit[otherKey].interest===input[loanFromCountry].newDebt.interest){return true;}}return false;});if(!isConfirmed&&key==='lenenVanLand'){return input.filter(function(item){return item.newDebt.key!==key;});}if(isConfirmed){if(!this.state[key]){this.setState(_defineProperty({},key,true));}}}}return input;}},{key:'renderPopupTitle',value:function renderPopupTitle(){var desktop=this.props.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-title-area'},desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'desktop-title-icon',src:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_bank_png___default.a,alt:'Bank Icoon'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:desktop?'dhgvtsparenenlenen':'mhgvtsparenenlenen',tag:'h3'}),desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__elements_GoBackButton__["a" /* default */],{history:this.props.history}):null);}},{key:'renderLowPopupTitle',value:function renderLowPopupTitle(){var desktop=this.props.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-title-area'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:desktop?'dlgvtsparenenlenen':'mlgvtsparenenlenen',tag:'h3'}),desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__elements_GoBackButton__["a" /* default */],{history:this.props.history}):null),desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'desktop-title-icon low-big',src:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_bank_png___default.a,alt:'bank-icon'}):null);}},{key:'renderCurRoundPayback',value:function renderCurRoundPayback(isDebt,gameState){var introText='';var gameStateInput=this.props.gameStateInput;var plus1Rounds=[];var plus2Rounds=[];var debitCredit=gameStateInput.myState.debitCredit;var debitCreditArr=Object.keys(debitCredit).map(function(key){return _extends({},debitCredit[key],{key:key});}).filter(function(_ref7){var confirmed=_ref7.confirmed;return confirmed;});var nextRoundDeb=debitCreditArr.map(function(r){return Object(__WEBPACK_IMPORTED_MODULE_26__helpers_feedbackHelpers__["G" /* simulateDebitCreditOutcome */])(_extends({},r,{round:gameState.currentRound}));}).filter(function(n){return n;}).filter(function(r){return r;});if(isDebt){introText='sim_bank_uitleg_lening_van_andere_landen_aflossen';var debtBank=this.getDeptBank(gameStateInput).steps;var debtLand=this.getDeptLand(gameStateInput).steps;plus1Rounds=[].concat(_toConsumableArray(debtBank.plus1Rounds),_toConsumableArray(debtLand.plus1Rounds));plus2Rounds=[].concat(_toConsumableArray(debtBank.plus2Rounds),_toConsumableArray(debtLand.plus2Rounds));this.getConfirmedEntries(nextRoundDeb.filter(function(item){return item.newDebt.key==='lenenVanBank'||item.newDebt.key==='lenenVanLand';}),'lenenVanLand','lenenAanLand');}else{introText='sim_bank_uitleg_lening_aan_andere_landen_aflossen';var creditBank=this.getCreditBank(gameStateInput).steps;var creditLand=this.getCreditLand(gameStateInput).steps;plus1Rounds=[].concat(_toConsumableArray(creditBank.plus1Rounds),_toConsumableArray(creditLand.plus1Rounds));plus2Rounds=[].concat(_toConsumableArray(creditBank.plus2Rounds),_toConsumableArray(creditLand.plus2Rounds));this.getConfirmedEntries(nextRoundDeb.filter(function(item){return item.newDebt.key==='lenenAanLand';}),'lenenAanLand','lenenVanLand');}if(plus1Rounds.length){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overzicht-schuld-rondes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(introText),':'),plus1Rounds.length>=1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'before'+Math.random(),className:'schuld-rondes overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_ronde').toLowerCase()+' '+(gameState.currentRound+1)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,plus1Rounds.map(function(debt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:debt.name+Math.random()},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(debt.name)+' '+(debt.otherCountry!==undefined?Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(debt.otherCountry):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,debt.amount));}))):null,plus2Rounds.length>=1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'after'+Math.random(),className:'schuld-rondes overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_ronde').toLowerCase()+' '+(gameState.currentRound+2)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,plus2Rounds.map(function(debt){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{key:debt.name+Math.random()},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(debt.name)+' '+(debt.otherCountry!==undefined?Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(debt.otherCountry):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,debt.amount));}))):null);}else{return null;}}},{key:'renderHoog',value:function renderHoog(){var _props2=this.props,gameState=_props2.gameState,gameStateInput=_props2.gameStateInput,dispatch=_props2.dispatch,desktop=_props2.desktop;var debitCredit=gameStateInput.myState.debitCredit;var tegoed=this.getCreditTotal(gameStateInput);var schuld=this.getDeptTotal(gameStateInput);var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["b" /* calculateBudgetPRO */])(gameState,gameStateInput,gameStateInput.myState.policyChoices,gameStateInput.myState.ministerieGlobaVerdeling,savingsAndLoans);// Snippet to clear DebitCredit
// if(cleared === 0) {
//   dispatch(updateMyState(
//     {
//       debitCredit:{}
//     }
//   ))
//   cleared = 1;
// }
// console.log(debitCredit);
var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'close',viewType:'list',showTitle:false,showBudget:true}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes bank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'values'},this.renderPopupTitle(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BankSavingDropdown__["a" /* default */],{'class':'dept',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_schuld'),globas:schuld||'-'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_bank_uitleg_totaal_schuld')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_schulden_aan_landen'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.getDeptLand(gameStateInput).debt,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard_globas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_schulden_aan_bank'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.getDeptBank(gameStateInput).debt,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard_globas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'divider'},'-------------------------------'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_totale_schuld'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,schuld,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard_globas')))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BankSavingDropdown__["a" /* default */],{'class':'left',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_tegoed'),globas:tegoed||'-'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_bank_uitleg_totaal_tegoed')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_tegoed_van_landen'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.getCreditLand(gameStateInput).credit,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard_globas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_tegoed_bij_bank'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.getCreditBank(gameStateInput).credit,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard_globas'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',{className:'divider'},'-------------------------------'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_totale_tegoed'),' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,tegoed,' ',Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard_globas')))))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'collect-spend-globas-overview'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_wij_hebben_globas_nodig")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dhgvtlenenland':'mhgvtlenenland',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_lenen_van_land"),sliderTitle:''+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_lenen_van_land"),sliderTitle_confirmed:''+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_geleend_van_land"),sliderTitleAppend:'(max. '+(20+30*(gameState.currentRound-1))+' '+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard')+')',max:20+30*(gameState.currentRound-1),icon:__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_lenen_land_svg___default.a,value:debitCredit.lenenVanLandNotConfirmed||{},onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{lenenVanLandNotConfirmed:value})}));},fromCountry:true,confirmed:(debitCredit.lenenVanLandNotConfirmed||{}).confirmed,disableInFinalStep:true,disableCancel:(debitCredit.lenenVanLand||{}).confirmed,allowInput:this.props.user.role==='groupleader'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dhgvtlenenbank':'mhgvtlenenbank',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_lenen_van_bank"),max:80-30*(gameState.currentRound-1),sliderTitleAppend:'(max. '+(80-30*(gameState.currentRound-1))+' '+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard')+')',icon:__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_lenen_bank_svg___default.a,value:debitCredit.lenenVanBank||{},onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{lenenVanBank:value})}));},creditRate:.2,renteTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_te_betalen_rente')+' ('+.2*100+'%)',allowInput:this.props.user.role==='groupleader',disableInFinalStep:true,disableCancel:(debitCredit.lenenVanBank||{}).confirmed,roundUp:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dhgvtopnemenspaargeld':'mhgvtopnemenspaargeld',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_opnemen_spaargeld"),max:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_opnemen_spaargeld_svg___default.a,value:debitCredit.opnemenSpaargeld||{},remainingTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_nieuw_spaargeld'),currentValue:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),currentValueTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_huidig_spaargeld'),sliderTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_opname_spaargeld'),allowInput:this.props.user.role==='groupleader',disableCancel:(debitCredit.opnemenSpaargeld||{}).confirmed,onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{opnemenSpaargeld:value})}));},noInterest:true,creditRate:.1,savedThisRound:debitCredit.stortenSpaargeld||{}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_wij_hebben_globas_over')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dhgvtuitlenen':'mhgvtuitlenen',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_lenen_aan_land"),sliderTitle:''+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_lenen_aan_land"),sliderTitle_confirmed:''+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_uitgeleend_aan_land"),sliderTitleAppend:'(max. '+(20+30*(gameState.currentRound-1)<globas?20+30*(gameState.currentRound-1):globas)+' '+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard')+')',icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_uitlenen_land_svg___default.a,max:20+30*(gameState.currentRound-1)<globas?20+30*(gameState.currentRound-1):globas,value:debitCredit.lenenAanLandNotConfirmed||{},allowInput:this.props.user.role==='groupleader'&&!this.state.lenenAanLand,onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{lenenAanLandNotConfirmed:value})}));},toCountry:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_uitgeleend_aan_land'),confirmed:(debitCredit.lenenAanLand||{}).confirmed,disableCancel:(debitCredit.lenenAanLand||{}).confirmed,disableInFinalStep:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dhgvtschenken':'mhgvtschenken',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_schenken_aan_land"),max:20<globas?20:globas,icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_schenken_land_svg___default.a,sliderTitle:''+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_schenking'),sliderTitleAppend:'(max. '+(20<globas?20:globas)+' '+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard')+')',value:debitCredit.schenkAanLand||{},allowInput:this.props.user.role==='groupleader',onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{schenkAanLand:value})}));},toCountry:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_schenk_aan_land'),disableCancel:(debitCredit.schenkAanLand||{}).confirmed,noInterest:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dhgvtsparenbank':'mhgvtsparenbank',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_sparen_bij_bank'),max:30<globas?30:globas<0?0:globas,icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_sparen_bank_svg___default.a,value:debitCredit.stortenSpaargeld||{},renteValue:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["d" /* getSavingsInterest */])(gameState,debitCredit,Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),.1),accumulativeTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_nieuw_spaargeld'),currentValue:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),currentValueTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_huidig_spaargeld'),allowInput:this.props.user.role==='groupleader',disableCancel:(debitCredit.stortenSpaargeld||{}).confirmed,sliderTitle:''+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_spaarbedrag'),sliderTitleAppend:'(max. 30 '+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_miljard')+')',onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{stortenSpaargeld:value})}));},creditRate:.1,renteTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_te_ontvangen_rente')+' ('+.1*100+'%)'}))),this.printOverview(gameStateInput,dispatch)));if(!desktop){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},content),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}}},{key:'renderLaag',value:function renderLaag(){var debitCredit=this.props.gameStateInput.myState.debitCredit;var _props3=this.props,gameState=_props3.gameState,dispatch=_props3.dispatch,gameStateInput=_props3.gameStateInput,policyChoice=_props3.policyChoice,desktop=_props3.desktop;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,gameStateInput.myState.policyChoices,gameStateInput.myState.ministerieGlobaVerdeling,savingsAndLoans,policyChoice);var content=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg',style:{height:"auto"}},!desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'close',viewType:'list',showTitle:false,showBudget:true}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes bank laag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'values'},this.renderLowPopupTitle(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('ul',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BankSavingDropdown__["a" /* default */],{'class':'dept',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_schuld'),onlyThumbTitle:true,globas:this.getDeptBankBasic(gameStateInput).debt},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_popupHelper__["d" /* getContent */])('dlgvtschuld',this.props.gameState.language)}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BankSavingDropdown__["a" /* default */],{'class':'left',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_spaartegoed'),onlyThumbTitle:true,globas:this.getCreditBankBasic(gameStateInput).credit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_popupHelper__["d" /* getContent */])('dlgvtspaartegoed',this.props.gameState.language)}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bank-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dlgvtlenenbank':'mlgvtlenenbank',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('lenenVanBank'),max:15,icon:__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_lenen_bank_laag_svg___default.a,value:debitCredit.lenenVanBank||{},sliderTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_lening'),renteTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_basic_rente_die_je_betaald'),allowInput:this.props.user.role==='groupleader',disableCancel:(debitCredit.lenenVanBank||{}).confirmed,disableInFinalStep:true,onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{lenenVanBank:value})}));},creditRate:.2,roundUp:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dlgvtsparenbank':'mlgvtsparenbank',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('stortenSpaargeld'),max:15<globas?15:globas<0?0:globas,icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_sparen_bank_svg___default.a,value:debitCredit.stortenSpaargeld||{},currentValue:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),currentValueTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_huidig_spaargeld'),renteTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_basic_te_ontvangen_rente'),renteValue:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["d" /* getSavingsInterest */])(gameState,debitCredit,Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),.2),accumulativeTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(!(debitCredit.stortenSpaargeld||{}).confirmed?'sim_basic_nieuw_spaargeld':'sim_basic_nieuw_spaartegoed'),sliderTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(!(debitCredit.stortenSpaargeld||{}).confirmed?'sim_welk_bedrag_sparen':'sim_welk_bedrag_gespaard'),allowInput:this.props.user.role==='groupleader',disableCancel:(debitCredit.stortenSpaargeld||{}).confirmed,onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{stortenSpaargeld:value})}));},creditRate:.2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_DebitCreditDialog__["a" /* default */],{id:desktop?'dlgvtopnemenspaargeld':'mlgvtopnemenspaargeld',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_opnemen_spaargeld'),max:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),currentValue:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_opnemen_spaargeld_svg___default.a,value:debitCredit.opnemenSpaargeld||{},remainingTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(!(debitCredit.opnemenSpaargeld||{}).confirmed?'sim_basic_nieuw_spaargeld':'sim_basic_nieuw_spaartegoed'),sliderTitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(!(debitCredit.opnemenSpaargeld||{}).confirmed?'sim_basic_opname_spaargeld':'sim_basic_opgenomen_spaargeld'),allowInput:this.props.user.role==='groupleader',disableCancel:(debitCredit.opnemenSpaargeld||{}).confirmed,renteValue:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["d" /* getSavingsInterest */])(gameState,debitCredit,Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),.2)-Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["d" /* getSavingsInterest */])(gameState,debitCredit,Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,debitCredit),.2,true),onChange:function onChange(value){return dispatch(updateMyState({debitCredit:_extends({},debitCredit,{opnemenSpaargeld:value})}));},savedThisRound:debitCredit.stortenSpaargeld||{},noInterest:true,creditRate:.2}))));if(!desktop){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},content));}}}]);return Bank;}(__WEBPACK_IMPORTED_MODULE_8__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_es_connect_connect__["a" /* default */])(function(state){return{gameState:state.gameState,gameStateInput:state.gameStateInput,project:state.project,policyChoice:state.policyChoice,user:state.user,feedback:state.feedback};})(Bank));

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BankSavingDropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_white_svg__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_white_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_white_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var BankSavingDropdown=(_temp=_class=function(_Component){_inherits(BankSavingDropdown,_Component);function BankSavingDropdown(props){_classCallCheck(this,BankSavingDropdown);var _this=_possibleConstructorReturn(this,(BankSavingDropdown.__proto__||Object.getPrototypeOf(BankSavingDropdown)).call(this,props));_this.handleOutsideClick=function(ev){if(_this.state.showOverlay&&!_this.node.contains(ev.target)){_this.toggleDropdown();}};_this.state={title:_this.props.title,class:_this.props.class,showOverlay:false};_this.toggleDropdown=_this.toggleDropdown.bind(_this);return _this;}_createClass(BankSavingDropdown,[{key:"toggleDropdown",value:function toggleDropdown(){this.setState({showOverlay:!this.state.showOverlay});}},{key:"componentDidMount",value:function componentDidMount(){document.addEventListener('mousedown',this.handleOutsideClick);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener('mousedown',this.handleOutsideClick);}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:this.state.class+(this.state.showOverlay?' show':''),onClick:this.toggleDropdown,ref:function ref(node){return _this2.node=node;}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'budget-header-overlay'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'inner-dropdown'},this.state.title,":",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'dropdown inner-dropdown'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{title:this.props.globas},this.props.globas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'dropdown-arrow'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:'caret',src:__WEBPACK_IMPORTED_MODULE_2__assets_img_caret_down_white_svg___default.a}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'dropdown-content',onClick:function onClick(ev){ev.stopPropagation();}},this.props.onlyThumbTitle?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,this.state.title),this.props.children));}}]);return BankSavingDropdown;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,class:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_temp);

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/caret_down_white.e8432e43.svg";

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lenen_bank.1ae2d9ae.svg";

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/lenen_bank_laag.3eaecbc7.svg";

/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/opnemen_spaargeld.cfae6389.svg";

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/pending.1854c27a.svg";

/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/approved.692253d6.svg";

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StepThree_BudgetSlider__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StepThree_InputContainer__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepThree_BudgetCollaboration__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__ = __webpack_require__(84);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DebitCreditDialog=(_temp=_class=function(_Component){_inherits(DebitCreditDialog,_Component);function DebitCreditDialog(props){_classCallCheck(this,DebitCreditDialog);var _this=_possibleConstructorReturn(this,(DebitCreditDialog.__proto__||Object.getPrototypeOf(DebitCreditDialog)).call(this,props));_this.state={showPopUp:false,showDropDown:false};_this.onChange=_this.onChange.bind(_this);_this.toggleConfirm=_this.toggleConfirm.bind(_this);return _this;}_createClass(DebitCreditDialog,[{key:'isNumeric',value:function isNumeric(n){return!isNaN(parseFloat(n))&&isFinite(n);}},{key:'onChange',value:function onChange(key,value){if(this.props.value.confirmed!==true){if(Number.isInteger(value)&&this.props.negativeCredit)value=-value;var v=_extends({},this.props.value,_defineProperty({},key,value));if(this.props.creditRate&&!this.props.noInterest){if(this.props.negativeCredit||this.props.roundUp){v.interest=Math.ceil((v.amount||0)*this.props.creditRate);}else{v.interest=Math.floor((v.amount||0)*this.props.creditRate);var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput;var debitCredit=gameStateInput.myState.debitCredit;var savedGlobas=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["c" /* getSavedGlobas */])(gameState,_extends({},debitCredit,{stortenSpaargeld:v}));if(savedGlobas>0){var renteValue=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_bankHelper__["d" /* getSavingsInterest */])(gameState,_extends({},debitCredit,{stortenSpaargeld:v}),savedGlobas,this.props.creditRate);var renteFix=renteValue-Math.floor((this.props.currentValue||0)*this.props.creditRate);// console.log('Initial interest: ', v.interest);
// console.log('savedGlobas', savedGlobas);
// console.log('Rentevalue: ', renteValue);
// console.log('renteFix: ', renteFix);
v.interest=renteFix;}}}else if(this.props.savedThisRound){// const savedThisRound = (this.props.savedThisRound.amount === undefined ? {amount: 0, interest: 0} : this.props.savedThisRound); //5
// const savedEarlier = this.props.currentValue - savedThisRound.amount; //5
var wantToSave=parseInt(value,10);//10
v.interest=0;//Note: old probably faulty code.
// const amountFromCurrentSavings = -(savedEarlier - wantToSave); //5
// if(amountFromCurrentSavings > 0) { // 5 > 0 = true
//   const interestThisRound = savedThisRound.interest;
//   const interestToRemovePercentage = amountFromCurrentSavings / savedThisRound.amount;
//   const interestToRemove = Math.ceil(interestToRemovePercentage * interestThisRound);
//   // console.log("interestToRemove", interestToRemove);
//   v.interest += interestToRemove;
// }
// if(wantToSave > amountFromCurrentSavings) { //10 > 5 = true
//   const amountFromPrevSavings = wantToSave - (amountFromCurrentSavings > 0 ? amountFromCurrentSavings : 0); //5
//   const interestToRemoveFromPrevSavings = Math.ceil(amountFromPrevSavings * this.props.creditRate);
//   // console.log("interestToRemoveFromPrevSavings", interestToRemoveFromPrevSavings, "amountFromPrevSavings", amountFromPrevSavings, "wantToSave", wantToSave);
//   v.interest += interestToRemoveFromPrevSavings;
// }
var totalSaved=this.props.currentValue;var interestOnCurrentSavings=Math.floor((totalSaved||0)*this.props.creditRate);var newTotalSaved=totalSaved-wantToSave;var interestOnNewSavings=Math.floor((newTotalSaved||0)*this.props.creditRate);var interestToRemove=interestOnCurrentSavings-interestOnNewSavings;// console.log(interestToRemove);
v.interest=interestToRemove;}if(v.interest===undefined||v.interest<0&&!this.props.savedThisRound||isNaN(v.interest)){v.interest=0;}if(v.amount===undefined){v.amount=0;}this.props.onChange(v);}}},{key:'getValid',value:function getValid(values){var valid=true;if(Object.keys(values).length===0&&values.constructor===Object){valid=false;}if(values.amount===0||values.amount===undefined){valid=false;}if(this.props.fromCountry||this.props.toCountry){if(values.otherCountry===undefined){valid=false;}}return valid;}},{key:'toggleConfirm',value:function toggleConfirm(){if(Object.keys(this.props.value).length===0&&this.props.value.constructor===Object){return;}var prevVal=this.props.value.confirmed;prevVal=prevVal===undefined?false:prevVal;var v=_extends({},this.props.value,{confirmed:!prevVal,unread:true});this.props.onChange(v);}},{key:'renderDetails',value:function renderDetails(){var v=this.props.value;var s=this.state||{};var props=this.props;var amount=v.amount,interest=v.interest,confirmed=v.confirmed;amount=amount||0;if(!confirmed){amount=amount>this.props.max&&this.props.disableCancel!==true?this.props.max:amount;}interest=interest||0;if(this.props.negativeCredit){amount=-amount;interest=-interest;}var renteTitle=this.props.renteTitle||''+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totale_rente');renteTitle=renteTitle+":";var currentValueTitle=this.props.currentValueTitle?this.props.currentValueTitle+":":false;var currentValue=false;if(!!currentValueTitle||this.props.currentValue){currentValue=this.props.currentValue?this.props.currentValue:0;}var remainingTitle=this.props.remainingTitle?this.props.remainingTitle+":":false;var remaining=false;if(!!remainingTitle&&currentValue!==false){if(this.props.value.confirmed===true){remaining=currentValue;}else{remaining=currentValue-amount;}}var accumulativeTitle=this.props.accumulativeTitle?this.props.accumulativeTitle+":":false;var accumulative=false;if(!!accumulativeTitle&&currentValue!==false){accumulative=currentValue+amount;}var sliderTitle=this.props.sliderTitle?this.props.sliderTitle:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_lening');if(this.props.value.confirmed!==true&&this.props.sliderTitleAppend){sliderTitle=sliderTitle+' '+this.props.sliderTitleAppend;}if(this.props.value.confirmed&&this.props.sliderTitle_confirmed!==undefined){sliderTitle=this.props.sliderTitle_confirmed;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container'+(s.showDropDown?' show':'')+(props.value.confirmed?' disableInput':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PopupTitle__["a" /* default */],{popupId:this.props.id,tag:'h4'}),(currentValue||this.isNumeric(currentValue))&&currentValueTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'currentValue-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(currentValueTitle)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'point-holder'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('li',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{title:currentValue},currentValue),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,sliderTitle,':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__StepThree_BudgetSlider__["a" /* default */],{role:this.props.user.role,customOnChange:this.onChange,onChangeKey:'amount',min:0,max:this.props.max,value:amount,unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')})),remainingTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StepThree_InputContainer__["a" /* default */],{role:this.props.user.role,onChangeKey:'remaining',customOnChange:this.onChange,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(remainingTitle),value:parseInt(remaining,0)||0,disabled:true,unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}):null,accumulativeTitle&&this.props.value.confirmed!==true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StepThree_InputContainer__["a" /* default */],{role:this.props.user.role,onChangeKey:'remaining',customOnChange:this.onChange,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(accumulativeTitle),value:parseInt(accumulative,0)||0,disabled:true,unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}):null,this.props.noInterest?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StepThree_InputContainer__["a" /* default */],{role:this.props.user.role,onChangeKey:'interest',max:100,customOnChange:this.onChange,onFocus:function onFocus(ev){ev.target.setAttribute('type','text');ev.target.setSelectionRange(0,String(ev.target.value).length);ev.target.setAttribute('type','number');},title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(renteTitle),value:this.props.renteValue!==undefined?parseInt(this.props.renteValue,0):parseInt(interest,0),disabled:!!this.props.creditRate,unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}),this.props.fromCountry||this.props.toCountry?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StepThree_BudgetCollaboration__["a" /* default */],{single:true,value:v.otherCountry||"",onChangeKey:'otherCountry',customOnChange:this.onChange,title:(this.props.fromCountry?this.props.disableCancel?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geleend_van_land'):Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('lenenVanLand'):this.props.confirmed?this.props.toCountry:this.props.toCountry)+":"}):null,this.props.allowInput&&!this.props.disableCancel?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'border-line'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.getValid(this.props.value)&&!this.props.gameStateInput.preventInputChanges?"":"disabled",onClick:this.toggleConfirm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.props.value.confirmed!==true?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_opslaan'):Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_annuleren')))):null);}},{key:'renderDropdownOrPopup',value:function renderDropdownOrPopup(){var _this2=this;var s=this.state||{};var desktop=document.querySelector('#root').clientWidth>=1240;if(s.showDropDown){if(desktop){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PopUp__["a" /* default */],{closePopUpClick:function closePopUpClick(){return _this2.setState({showDropDown:false});},interactive:true,closePopUpCross:true},this.renderDetails());}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.renderDetails());}return null;}},{key:'render',value:function render(){var _this3=this;var s=this.state||{};var props=this.props;var bankDisable=false;if(props.disableInFinalStep&&props.gameState.currentRound===4){bankDisable=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(props.value.confirmed!==true?"":'disableInput')+(bankDisable?' bank-disable':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ListButton__["a" /* default */],{onClick:function onClick(){if(!bankDisable){_this3.setState({showDropDown:!s.showDropDown});}},bgColor:'blue',title:this.props.title,icon:this.props.icon}),this.renderDropdownOrPopup());}}]);return DebitCreditDialog;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={renteTitle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={disableCancel:false,disableInFinalStep:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__["a" /* default */])(function(state){return state;})(DebitCreditDialog));

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputContainer=(_temp=_class=function(_Component){_inherits(InputContainer,_Component);function InputContainer(props){_classCallCheck(this,InputContainer);var _this=_possibleConstructorReturn(this,(InputContainer.__proto__||Object.getPrototypeOf(InputContainer)).call(this,props));_this.setValue=_this.setValue.bind(_this);_this.sendToParent=_this.sendToParent.bind(_this);return _this;}_createClass(InputContainer,[{key:'setValue',value:function setValue(event){var val=void 0;if(event.target!==undefined){val=parseInt(event.target.value,10);}else{val=parseInt(event,10);}if(val>this.props.max){event.target.value=this.props.max;val=this.props.max;}if(val>=this.props.min){this.setState({value:val});}else{this.setState({value:this.props.min});}this.sendToParent(val);}},{key:'sendToParent',value:function sendToParent(val){if(this.props.customOnChange){this.props.customOnChange(this.props.onChangeKey,val);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'slider-container input'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{max:this.props.max,onFocus:this.props.onFocus,type:this.props.disabled?this.props.value===0?'text':'number':'number',onChange:this.setValue.bind(this),value:this.props.disabled?this.props.value===0?'-':this.props.value:this.props.value||0,className:(this.props.disabled?'disabled value-container':'value-container')+(this.props.role==='groupmember'?' groupmember-disabled':'')}),this.props.unit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:this.props.role==='groupmember'?' groupmember-disabled':'',title:this.props.unit},this.props.unit):null);}}]);return InputContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={unit:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={onFocus:function onFocus(){},max:Infinity},_temp);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_QuestionButton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_GameMaterials__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Switch__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_GroupGameScoreRow__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_GroupRow__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elements_PopUp__ = __webpack_require__(14);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _actions$gameState=__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].gameState,setRoundState=_actions$gameState.setRoundState,submitGameScores=_actions$gameState.submitGameScores,deactivateGame=_actions$gameState.deactivateGame;var _actions$ghettoRadio=__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].ghettoRadio,lockStepTwo=_actions$ghettoRadio.lockStepTwo,unlockStepTwo=_actions$ghettoRadio.unlockStepTwo,toggleStepThree=_actions$ghettoRadio.toggleStepThree;var Verdienen=(_temp=_class=function(_React$Component){_inherits(Verdienen,_React$Component);function Verdienen(props){var _this2=this;_classCallCheck(this,Verdienen);var _this=_possibleConstructorReturn(this,(Verdienen.__proto__||Object.getPrototypeOf(Verdienen)).call(this,props));_this.gameScoreUpdate=function(groupId,value){var gameScores=_this.state.gameScores;gameScores[groupId]=JSON.parse(value);if(_typeof(gameScores[groupId])!=='object')delete gameScores[groupId];_this.setState({gameScores:gameScores});};_this.toggleSubmittingScores=function(){var value=arguments.length>0&&arguments[0]!==undefined?arguments[0]:!_this.state.submittingScores;_this.setState({submittingScores:value});};_this.submitGameScores=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ev){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:ev.preventDefault();_this.toggleSubmittingScores(true);if(!(_this.allSubmitted&&_this.props.gameState.allowNewGame&&!_this.props.gameState.endOfGame&&!_this.state.submittingScores)){_context.next=7;break;}if(_this.isGameActive){_context.next=6;break;}_this.props.dispatch(setRoundState('PLAYING_GAME',_this.gameId,_this.state.gameScores));return _context.abrupt('return');case 6:_this.props.dispatch(submitGameScores(_this.state.gameScores,_this.gameId,_this.toggleSubmittingScores));case 7:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.loginAsGroup=function(groupId){Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/user/'+groupId+'/loginAsGroup',{},'POST').then(function(access){if(_this.game.softwareLocation&&_this.game.softwareLocation.startsWith('/')&&!_this.game.softwareLocation.startsWith('//')){window.location.href=_this.game.softwareLocation;}else{window.open(_this.game.softwareLocation+'?token='+access.token+'&mentor=true');}});};_this.renderGameMaterials=function(){if(_this.scoresSubmitted||!_this.state.gameMaterials.length)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block content-block--small content-block--gamematerials'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvt'+_this.curGame+'_lesmateriaal',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_GameMaterials__["a" /* default */],Object.assign({},_this.props,{gameId:_this.gameId,showPopup:function showPopup(popupId,popupCb){_this.setState({popupId:popupId,popupCb:popupCb,showPopup:true});},items:_this.state.gameMaterials})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spacing-20'}));};_this.renderGRControls=function(grGroups){var grGroup=grGroups.Groups[0].GhettoRadioGroup||{};var step2unlocked=false;var step3unlocked=true;if(grGroup.timerExpiresAt){step2unlocked=new Date(grGroup.timerExpiresAt).getTime()<=new Date().getTime();}if(grGroup.locked){step3unlocked=false;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{className:_this.isGameActive?'':'disabled'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtghettoradio_lied',tag:'p'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Switch__["a" /* default */],{checked:step2unlocked,disabled:_this.props.group.ghettoRadioHandlingAction===__WEBPACK_IMPORTED_MODULE_10__actions_types__["v" /* UPDATE_GHETTORADIO_TIMER */],onChange:function onChange(){if(!_this.isGameActive)return;if(step2unlocked){_this.props.dispatch(lockStepTwo());return;}_this.props.dispatch(unlockStepTwo());}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{className:_this.isGameActive?'':'disabled'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtghettoradio_songtekst',tag:'p'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Switch__["a" /* default */],{checked:step3unlocked,disabled:_this.props.group.ghettoRadioHandlingAction===__WEBPACK_IMPORTED_MODULE_10__actions_types__["u" /* UPDATE_GHETTORADIO_LOCKED */],onChange:function onChange(){if(!_this.isGameActive)return;if(step3unlocked){_this.props.dispatch(toggleStepThree(1));return;}_this.props.dispatch(toggleStepThree(0));}})));};_this.renderGame=function(){var _this$props=_this.props,gameState=_this$props.gameState,group=_this$props.group,desktop=_this$props.desktop;var grGroups=group.grGroups;var isGR=_this.game.name.trim().replace(/ /g,'').toLowerCase()==='ghettoradio';console.log(_this.deviceAndDifficulty+'bvt'+_this.curGame+'_spelactiveren',' hier');return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvt'+_this.curGame+'_spel',tag:'h3'})),_this.scoresSubmitted?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,!desktop?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'scores-submitted-text'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_scores_voor_spel_zijn_ingevoerd')):null):_this.game.softwareLocation||_this.game.hasContent||_this.game.seriousGamesSoftwareLocation?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{className:!gameState.allowNewGame||_this.props.gameState.endOfGame?'disabled':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvt'+_this.curGame+'_spelactiveren',tag:'p'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Switch__["a" /* default */],{checked:_this.isGameActive,disabled:_this.props.group.ghettoRadioHandlingAction===__WEBPACK_IMPORTED_MODULE_10__actions_types__["r" /* UPDATE_GHETTORADIO_ACTIVE */],onChange:function onChange(){if(!_this.props.gameState.allowNewGame||_this.props.gameState.endOfGame){return;}_this.props.dispatch({type:__WEBPACK_IMPORTED_MODULE_10__actions_types__["t" /* UPDATE_GHETTORADIO_HANDLING_ACTION */],payload:__WEBPACK_IMPORTED_MODULE_10__actions_types__["r" /* UPDATE_GHETTORADIO_ACTIVE */]});if(_this.isGameActive){_this.props.dispatch(deactivateGame());return;}_this.props.dispatch(setRoundState('PLAYING_GAME',_this.game.id));}})),isGR?_this.renderGRControls(grGroups):null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spacing-20'})));};_this.viewGamePerGroup=function(){var schoolClass=_this.props.schoolClass;var isGR=_this.game.name.trim().replace(/ /g,'').toLowerCase()==='ghettoradio';if(isGR&&!_this.scoresSubmitted){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtghettoradio_bekijkspel',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-rows-container'},schoolClass.Groups.map(function(group){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_GroupRow__["a" /* default */],{key:group.id,text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(group.name),color:group.GroupTheme.color,onClick:function onClick(){_this.loginAsGroup(group.id);}});})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spacing-20'}));}else{return null;}};_this.earnedGlobasPerGroup=function(){var _this$props2=_this.props,project=_this$props2.project,desktop=_this$props2.desktop;var projectType=project.EducationProject.nameShort;var assignGameScoreOnce=_this.game.assignGameScoreOnce[project.difficulty.toLowerCase()];if(projectType==='GLXL'){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block'},desktop&&_this.scoresSubmitted?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'desktop-scores-submitted'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvt'+_this.curGame+'_spel',tag:'h3'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'scores-submitted-text'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_scores_voor_spel_zijn_ingevoerd'))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvt'+_this.curGame+'_verdiendeglobas',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-rows-container'},_this.props.schoolClass.Groups.map(function(group){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_GroupGameScoreRow__["a" /* default */],{key:group.id,text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(group.name),color:group.GroupTheme.color,score:_this.scoresSubmitted?group.Rounds[group.Rounds.length-1]?{points:group.Rounds[group.Rounds.length-1].earnedPoints,globas:group.Rounds[group.Rounds.length-1].earnedGlobas}:{}:_this.state.gameScores[group.id]||{},editable:!_this.scoresSubmitted,gameScores:_this.game.GameScores.filter(function(gs){var gameScores=_this.state.gameScores;var difficultyFilter=gs.DifficultyId===_this.props.project.DefaultDifficultyId;if(!assignGameScoreOnce){return difficultyFilter;}var used=Object.keys(gameScores).find(function(key){return gameScores[key].points===gs.points&&gameScores[key].globas===gs.globas&&parseInt(key,10)!==group.id;});return difficultyFilter&&!used;}),onChange:function onChange(value){_this.gameScoreUpdate(group.id,value);}});})),!_this.scoresSubmitted?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:!_this.props.gameState.allowNewGame||!_this.allSubmitted||_this.props.gameState.endOfGame||_this.state.submittingScores?'disabled':'',onClick:_this.submitGameScores},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_opslaan'))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spacing-20'}));}else{return null;}};_this.fetchGeneralMaterials=function(){var _this$props3=_this.props,schoolClass=_this$props3.schoolClass,project=_this$props3.project;Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/generalMaterial/'+schoolClass.LanguageId+'/'+project.DefaultDifficultyId+'/'+_this.gameId).then(function(gameMaterials){_this.setState({gameMaterials:gameMaterials});});};_this.goBack=function(){_this.props.history.goBack();};_this.goBackButtonHandler=function(){var showsGlobasAllocation=_this.props.project.EducationProject.nameShort==='GLXL';if(showsGlobasAllocation&&_this.scoresSubmitted===false&&_this.isGameActive){_this.setState({showPopup:true,popupId:'dhbm'+_this.curGame+'_opslaan'});}else{_this.goBack();}};_this.closePopupHandler=function(answer){if(typeof _this.state.popupCb==='function'){_this.state.popupCb(answer);}_this.setState({showPopup:false,popupCb:undefined,popupId:null});if(answer){_this.goBack();}};_this.state={gameScores:{},gameMaterials:[],submittingScores:false,showPopup:false,popupId:0,popupCb:undefined};_this.gameId=parseInt(_this.props.match.params.gameId,10);_this.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this.props.gameState.DefaultDifficultyId);_this.curGame=Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["g" /* getPopupCurrentGame */])(_this.gameId);return _this;}_createClass(Verdienen,[{key:'componentDidMount',value:function componentDidMount(){var _this3=this;var _props=this.props,schoolClass=_props.schoolClass,dispatch=_props.dispatch,project=_props.project;var game=schoolClass.SchoolClassGames.find(function(game){return game.GameId===_this3.gameId;}).Game;var checkGame=this.gameId;if(game.abbreviation){checkGame=game.abbreviation.toLowerCase();this.curGame=Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["g" /* getPopupCurrentGame */])(checkGame);}switch(checkGame){case 2:case'gr'://Ghettoradio
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'dhbvtghettoradio_T1':'dlbvtghettoradio_T1',dispatch);break;case 3:case'bo'://bonuspoints
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtextraopdrachten_T1':'mlbvtextraopdrachten_T1',dispatch);break;case 4:case'er'://escaperoute
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtescaperoute_T1':'mlbvtescaperoute_T1',dispatch);break;case 5:case'fq'://filmquiz
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtfilmquiz_T1':'mlbvtfilmquiz_T1',dispatch);break;case 6:case'dt'://detectivesspel
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtdetectives_T1':'mlbvtdetectives_T1',dispatch);break;case 7:case'mf'://moviefactory
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtmoviefactory_T1':'mlbvtmoviefactory_T1',dispatch);break;case 8:case'mc'://make a change
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtmakeachange_T1':'mlbvtmakeachange_T1',dispatch);break;case 9:case'ht'://Henna Tattoos
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvthennatattoos_T1':'mlbvthennatattoos_T1',dispatch);break;case'tc'://truecomics
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvttruecomics_T1':'mlbvttruecomics_T1',dispatch);break;case'wq'://wordquest
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtwordquest_T1':'mlbvtwordquest_T1',dispatch);break;case'vm'://votematch
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtvotematch_T1':'mlbvtvotematch_T1',dispatch);break;case'ga'://guessagain
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtguessagain_T1':'mlbvtguessagain_T1',dispatch);break;case'wa'://wanted
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtwanted_T1':'mlbvtwanted_T1',dispatch);break;case'tr'://totalrecall
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvttotalrecall_T1':'mlbvttotalrecall_T1',dispatch);break;case'fc'://factcheck
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtfactcheck_T1':'mlbvtfactcheck_T1',dispatch);break;case'rm'://readtheminds
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtreadtheminds_T1':'mlbvtreadtheminds_T1',dispatch);break;case'fq2'://filmquiz 2
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtfilmquiz2_T1':'mlbvtfilmquiz2_T1',dispatch);break;case'sa'://street art
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtstreetart_T1':'mlbvtstreetart_T1',dispatch);break;case'hl':// hotlist
Object(__WEBPACK_IMPORTED_MODULE_15__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvthotlist_T1':'mlbvthotlist_T1',dispatch);break;default:return;}}},{key:'componentWillMount',value:function componentWillMount(){this.fetchGeneralMaterials();}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,group=_props2.group,desktop=_props2.desktop,project=_props2.project;var renderViewGamePerGroup=this.viewGamePerGroup();var isGLXL=project.EducationProject.nameShort==='GLXL';var nonAppGame=!this.game.hasContent&&!this.game.contentLocation&&!this.game.seriousGamesSoftwareLocation;var mainClassNames='portal-verdienen '+(desktop?'portal-home verdelen-desktop darkBckg':'')+((this.scoresSubmitted||nonAppGame)&&desktop?' desktop-single':'');if(!isGLXL&&!renderViewGamePerGroup){mainClassNames+=' overige-projecten';}if(!group.grGroups.loaded)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:mainClassNames},this.state.showPopup?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_PopUp__["a" /* default */],{id:this.state.popupId,closePopUpClick:function closePopUpClick(res){_this4.closePopupHandler(res);}}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container list-item-container '+(this.scoresSubmitted||nonAppGame?' small-desktop-container':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{customHandler:this.goBackButtonHandler,history:this.props.history}),isGLXL?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_QuestionButton__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvt'+this.curGame+'_1'},this.game.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas_verdienen'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_spel',0)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.game.name))),desktop?nonAppGame?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal',style:{marginRight:0,display:'initial'}},this.renderGameMaterials(),this.earnedGlobasPerGroup()):renderViewGamePerGroup?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal column-portal-row',style:{marginTop:'20px !important'}},this.renderGame(),this.renderGameMaterials()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal column-portal-row'},this.viewGamePerGroup(),this.earnedGlobasPerGroup())):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},this.renderGame(),this.renderGameMaterials()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},this.viewGamePerGroup(),this.earnedGlobasPerGroup())):nonAppGame?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},this.renderGameMaterials(),this.earnedGlobasPerGroup()):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},this.renderGame(),this.renderGameMaterials(),this.viewGamePerGroup(),this.earnedGlobasPerGroup())));}},{key:'game',get:function get(){var _this5=this;var schoolClass=this.props.schoolClass;if(Array.isArray(schoolClass.SchoolClassGames)){var scg=schoolClass.SchoolClassGames.find(function(g){return g.GameId===_this5.gameId;});if(scg)return _extends({},scg.Game,{SchoolClassGame:scg});}return{};}},{key:'currentRound',get:function get(){var gameState=this.props.gameState;return gameState.loaded?gameState.roundData:{};}},{key:'isGameActive',get:function get(){var currentlyPlaying=this.props.gameState.currentlyPlaying;return currentlyPlaying===this.gameId;}},{key:'scoresSubmitted',get:function get(){return this.game.id===this.currentRound.GameId&&this.currentRound.state==='SCORE_SUBMITTED';}},{key:'allSubmitted',get:function get(){var _this6=this;var Groups=this.props.schoolClass.Groups;return Groups.every(function(grp){return Object.keys(_this6.state.gameScores).find(function(k){return grp.id===parseInt(k,10);});});}}]);return Verdienen;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{project:state.project,group:state.group,schoolClass:state.schoolClass,gameState:state.gameState};})(Verdienen));

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PasswordGameMaterial; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__ = __webpack_require__(74);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PasswordGameMaterial=function(_GameMaterialItem){_inherits(PasswordGameMaterial,_GameMaterialItem);function PasswordGameMaterial(props){_classCallCheck(this,PasswordGameMaterial);var _this=_possibleConstructorReturn(this,(PasswordGameMaterial.__proto__||Object.getPrototypeOf(PasswordGameMaterial)).call(this,props));_this.state.loading=false;_this.state.icons=[{src:__WEBPACK_IMPORTED_MODULE_0__assets_assets__["d" /* icons */].greyLock,alt:'icon',onClick:_this.handleClick}];_this.handleClick=function(){window.open('/portal/password/'+props.item.id,'_blank');};return _this;}return PasswordGameMaterial;}(__WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__["a" /* default */]);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentGameMaterial; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__ = __webpack_require__(74);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocumentGameMaterial=function(_GameMaterialItem){_inherits(DocumentGameMaterial,_GameMaterialItem);function DocumentGameMaterial(props){_classCallCheck(this,DocumentGameMaterial);var _this=_possibleConstructorReturn(this,(DocumentGameMaterial.__proto__||Object.getPrototypeOf(DocumentGameMaterial)).call(this,props));_this.state.icons=[__WEBPACK_IMPORTED_MODULE_0__assets_assets__["d" /* icons */].pdf];if(_this.props.item.printable){_this.state.icons.unshift(__WEBPACK_IMPORTED_MODULE_0__assets_assets__["d" /* icons */].print);}_this.handleClick=function(ev){var item=_this.props.item;if(!item.Material)return;window.open(item.Material.url,'_blank');};return _this;}return DocumentGameMaterial;}(__WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__["a" /* default */]);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoGameMaterial=function(_GameMaterialItem){_inherits(VideoGameMaterial,_GameMaterialItem);function VideoGameMaterial(props){_classCallCheck(this,VideoGameMaterial);var _this=_possibleConstructorReturn(this,(VideoGameMaterial.__proto__||Object.getPrototypeOf(VideoGameMaterial)).call(this,props));_this.state.icons=[__WEBPACK_IMPORTED_MODULE_0__assets_assets__["d" /* icons */].play2];_this.handleClick=function(){if(!props.project.offline&&props.item.alternateUrl&&props.item.alternateUrl.match(/drive.google.com/g)){window.open('/portal/drive?url='+encodeURIComponent(props.item.alternateUrl),'_blank');return;}if((props.item.type==='video'||props.item.type==='file')&&(props.project.offline||props.item.alternateId===null)){window.open('/portal/video/'+props.item.MaterialId+'?windowTitle='+encodeURIComponent(props.item.windowTitle)+'&faviconUrl='+encodeURIComponent(props.item.faviconUrl)+'&backgroundUrl='+encodeURIComponent(props.item.Background?props.item.Background.url:"null")+'&publicMaterialId='+(props.item.isPublic?props.item.id:null),'_blank');}else{window.open('/portal/vimeo/'+(props.item.vimeoId||props.item.alternateId)+'?windowTitle='+encodeURIComponent(props.item.windowTitle)+'&faviconUrl='+encodeURIComponent(props.item.faviconUrl)+'&backgroundUrl='+encodeURIComponent(props.item.Background?props.item.Background.url:"null")+'&publicMaterialId='+(props.item.isPublic?props.item.id:null),'_blank');}};return _this;}return VideoGameMaterial;}(__WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{project:state.project};})(VideoGameMaterial));

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SoftwareGameMaterial; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameMaterialItem__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCall__ = __webpack_require__(6);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var auth=new __WEBPACK_IMPORTED_MODULE_1_glxl_helpers__["Authorization"]();var SoftwareGameMaterial=function(_GameMaterialItem){_inherits(SoftwareGameMaterial,_GameMaterialItem);function SoftwareGameMaterial(props){var _this2=this;_classCallCheck(this,SoftwareGameMaterial);var _this=_possibleConstructorReturn(this,(SoftwareGameMaterial.__proto__||Object.getPrototypeOf(SoftwareGameMaterial)).call(this,props));_this.state.icons=[__WEBPACK_IMPORTED_MODULE_2__assets_assets__["d" /* icons */].testen];_this.handleClick=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props$item$Game,softwareLocation,seriousGamesSoftwareLocation,filmquizData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log(props.item);if(!(_typeof(props.item.Game)==='object')){_context.next=25;break;}_props$item$Game=props.item.Game,softwareLocation=_props$item$Game.softwareLocation,seriousGamesSoftwareLocation=_props$item$Game.seriousGamesSoftwareLocation;if(!(props.item.category==="software_testen")){_context.next=6;break;}if(props.item.Game.isSeriousGamesMinigame){window.open(seriousGamesSoftwareLocation+'test/'+props.item.Game.abbreviation,'_blank');}else{window.open(''+softwareLocation,'_blank');}return _context.abrupt('return');case 6:if(!props.item.Game.isSeriousGamesMinigame){_context.next=17;break;}_context.t0=window;_context.t1=props.item.Game.seriousGamesSoftwareLocation+'?token=';_context.t2=encodeURIComponent;_context.next=12;return Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/seriousgames/gamemasterLoginToken',{minigame:props.item.Game.abbreviation},'POST');case 12:_context.t3=_context.sent.token;_context.t4=(0,_context.t2)(_context.t3);_context.t5=_context.t1+_context.t4;_context.t0.open.call(_context.t0,_context.t5);return _context.abrupt('return');case 17:if(!(props.item.Game.id===5)){_context.next=24;break;}_context.next=20;return Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/filmQuiz/'+props.schoolClass.id);case 20:filmquizData=_context.sent;if(!filmquizData.beamerIsOpen){_context.next=24;break;}props.showPopup('dhbmfilmquiz_software',function(result){if(result){window.open(''+softwareLocation+(props.item.dontLogin?'':'?token='+auth.getAuthToken()),'_blank');}});return _context.abrupt('return');case 24:window.open(''+softwareLocation+('?token='+auth.getAuthToken()),'_blank');case 25:case'end':return _context.stop();}}},_callee,_this2);}));return _this;}return SoftwareGameMaterial;}(__WEBPACK_IMPORTED_MODULE_3__GameMaterialItem__["a" /* default */]);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_downloadjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_downloadjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Loading__ = __webpack_require__(51);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// Functional component to render the download audio button
function downloadAudioButton(props){/**
   * Download zip containing all audio files.
   * @param {Array<String>} audio
   * @returns {Promise<void>}
   */var downloadAudio=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var audio=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var zip,files;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',null);case 5:return _context.abrupt('return');case 6:zip=new __WEBPACK_IMPORTED_MODULE_4_jszip___default.a();_context.next=9;return Promise.all(audio.map(function(a){return fetch(a).then(function(r){return r.blob();}).catch(console.error);}));case 9:files=_context.sent;files.forEach(function(file,i){var splitVal=decodeURIComponent(audio[i]).split('/');var fileName=splitVal[splitVal.length-1];zip.file(fileName,file);});_context.next=13;return zip.generateAsync({type:'blob'}).then(function(blob){return __WEBPACK_IMPORTED_MODULE_5_downloadjs___default()(blob,'ER-audio-'+Date.now().toString()+'.zip');}).catch(console.error);case 13:setDisabled(false);case 14:case'end':return _context.stop();}}},_callee,this);}));return function downloadAudio(){return _ref.apply(this,arguments);};}();var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),disabled=_useState2[0],setDisabled=_useState2[1];if(!props.audio.length)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:function onClick(){downloadAudio(props.audio);},style:{opacity:disabled?'0.5':'1',display:'none'}},disabled?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_Loading__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_download_audio_button')));}downloadAudioButton.propTypes={audio:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string)};downloadAudioButton.defaultProps={audio:[]};/* harmony default export */ __webpack_exports__["a"] = (downloadAudioButton);

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(957)
var ieee754 = __webpack_require__(958)
var isArray = __webpack_require__(959)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 958 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 959 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31), __webpack_require__(161)))

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentGameMaterial; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DocumentGameMaterial=function(_GameMaterialItem){_inherits(DocumentGameMaterial,_GameMaterialItem);function DocumentGameMaterial(props){_classCallCheck(this,DocumentGameMaterial);var _this=_possibleConstructorReturn(this,(DocumentGameMaterial.__proto__||Object.getPrototypeOf(DocumentGameMaterial)).call(this,props));_this.state.icons=[__WEBPACK_IMPORTED_MODULE_0__assets_assets__["d" /* icons */].link];_this.renderTitle=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',null,_this.props.item.title);};_this.handleClick=function(ev){window.open(_this.props.item.alternateUrl,'_blank');};return _this;}return DocumentGameMaterial;}(__WEBPACK_IMPORTED_MODULE_1__GameMaterialItem__["a" /* default */]);

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

if (true) {
  module.exports = __webpack_require__(963);
} else {
  module.exports = require("./dist/react-switch.dev.js");
}


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

var React=__webpack_require__(0),uncheckedIcon=React.createElement("svg",{viewBox:"-2 -5 14 20",height:"100%",width:"100%",style:{position:"absolute",top:0}},React.createElement("path",{d:"M9.9 2.12L7.78 0 4.95 2.828 2.12 0 0 2.12l2.83 2.83L0 7.776 2.123 9.9 4.95 7.07 7.78 9.9 9.9 7.776 7.072 4.95 9.9 2.12",fill:"#fff",fillRule:"evenodd"})),checkedIcon=React.createElement("svg",{height:"100%",width:"100%",viewBox:"-2 -5 17 21",style:{position:"absolute",top:0}},React.createElement("path",{d:"M11.264 0L5.26 6.004 2.103 2.847 0 4.95l5.26 5.26 8.108-8.107L11.264 0",fill:"#fff",fillRule:"evenodd"}));function createBackgroundColor(t,i,o,s,n){var h=(t-o)/(i-o);if(0===h)return s;if(1===h)return n;for(var e="#",a=1;a<6;a+=2){var r=parseInt(s.substr(a,2),16),l=parseInt(n.substr(a,2),16),c=Math.round((1-h)*r+h*l).toString(16);1===c.length&&(c="0"+c),e+=c}return e}function convertShorthandColor(t){if(7===t.length)return t;for(var i="#",o=1;o<4;o+=1)i+=t[o]+t[o];return i}function getBackgroundColor(t,i,o,s,n){return createBackgroundColor(t,i,o,convertShorthandColor(s),convertShorthandColor(n))}var ReactSwitch=function(n){function t(t){n.call(this,t);var i=t.height,o=t.width,s=t.checked;this.t=t.handleDiameter||i-2,this.i=Math.max(o-i,o-(i+this.t)/2),this.o=Math.max(0,(i-this.t)/2),this.state={s:s?this.i:this.o},this.n=this.n.bind(this),this.h=this.h.bind(this),this.e=this.e.bind(this),this.a=this.a.bind(this),this.r=this.r.bind(this),this.l=this.l.bind(this),this.c=this.c.bind(this),this.u=this.u.bind(this),this.f=this.f.bind(this)}return n&&(t.__proto__=n),((t.prototype=Object.create(n&&n.prototype)).constructor=t).prototype.componentWillReceiveProps=function(t){this.setState({s:t.checked?this.i:this.o})},t.prototype.g=function(t){this.setState({p:t,b:!0})},t.prototype.v=function(t){var i=Math.min(this.i,Math.max(this.o,(this.props.checked?this.i:this.o)+t-this.state.p));this.setState({s:i,k:!0})},t.prototype.w=function(t){var i=this.state,o=i.s,s=this.props,n=s.checked,h=s.onChange,e=s.id;return i.k?n?(this.i+this.o)/2<o?void this.setState({s:this.i,k:!1,b:!1}):(this.setState({k:!1,b:!1}),void h(!1,t,e)):void(o<(this.i+this.o)/2?this.setState({s:this.o,k:!1,b:!1}):(this.setState({k:!1,b:!1}),h(!0,t,e))):(this.setState({b:!1}),void h(!n,t,e))},t.prototype.n=function(t){"number"==typeof t.button&&0!==t.button||(this.g(t.clientX),window.addEventListener("mousemove",this.h),window.addEventListener("mouseup",this.e))},t.prototype.h=function(t){t.preventDefault(),this.v(t.clientX)},t.prototype.e=function(t){this.w(t),window.removeEventListener("mousemove",this.h),window.removeEventListener("mouseup",this.e)},t.prototype.a=function(t){this.g(t.touches[0].clientX)},t.prototype.r=function(t){this.v(t.touches[0].clientX)},t.prototype.l=function(t){t.preventDefault(),this.w(t)},t.prototype.c=function(){this.setState({b:!1})},t.prototype.u=function(t){var i=this.props;(0,i.onChange)(!i.checked,t,i.id)},t.prototype.f=function(t){var i=this.props,o=i.checked,s=i.onChange,n=i.id;32!==t.keyCode&&13!==t.keyCode||this.state.k||(t.preventDefault(),s(!o,t,n))},t.prototype.render=function(){var t=this,i=this.props,o=i.checked,s=i.disabled,n=i.className,h=i.offColor,e=i.onColor,a=i.offHandleColor,r=i.onHandleColor,l=i.checkedIcon,c=i.uncheckedIcon,u=i.boxShadow,d=i.activeBoxShadow,f=i.height,g=i.width,p=i.id,b=i["aria-labelledby"],v=i["aria-label"],k=this.state,w=k.s,y=k.k,$=k.b,M={position:"relative",display:"inline-block",textAlign:"left",opacity:s?.5:1,borderRadius:f/2,WebkitTransition:"opacity 0.25s",MozTransition:"opacity 0.25s",transition:"opacity 0.25s",touchAction:"none",WebkitTapHighlightColor:"rgba(0, 0, 0, 0)",WebkitUserSelect:"none",MozUserSelect:"none",msUserSelect:"none",userSelect:"none"},R={height:f,width:g,margin:Math.max(0,(this.t-f)/2),position:"relative",background:getBackgroundColor(w,this.i,this.o,h,e),borderRadius:f/2,cursor:s?"default":"pointer",WebkitTransition:y?null:"background 0.25s",MozTransition:y?null:"background 0.25s",transition:y?null:"background 0.25s"},m={height:f,width:Math.min(1.5*f,g-(this.t+f)/2+1),position:"relative",opacity:(w-this.o)/(this.i-this.o),pointerEvents:"none",WebkitTransition:y?null:"opacity 0.25s",MozTransition:y?null:"opacity 0.25s",transition:y?null:"opacity 0.25s"},C={height:f,width:Math.min(1.5*f,g-(this.t+f)/2+1),position:"absolute",opacity:1-(w-this.o)/(this.i-this.o),right:0,top:0,pointerEvents:"none",WebkitTransition:y?null:"opacity 0.25s",MozTransition:y?null:"opacity 0.25s",transition:y?null:"opacity 0.25s"},T={height:this.t,width:this.t,background:getBackgroundColor(w,this.i,this.o,a,r),cursor:s?"default":"pointer",display:"inline-block",borderRadius:"50%",position:"absolute",transform:"translateX("+w+"px)",top:Math.max(0,(f-this.t)/2),outline:0,boxShadow:$?d:u,border:0,WebkitTransition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",MozTransition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s",transition:y?null:"background-color 0.25s, transform 0.25s, box-shadow 0.15s"};return React.createElement("div",{className:n,style:M},React.createElement("div",{className:"react-switch-bg",style:R,onClick:s?null:this.u},l&&React.createElement("div",{style:m},l),c&&React.createElement("div",{style:C},c)),React.createElement("div",{className:"react-switch-handle",role:"checkbox",tabIndex:s?null:0,onMouseDown:s?null:this.n,onTouchStart:s?null:this.a,onTouchMove:s?null:this.r,onTouchEnd:s?null:this.l,onTouchCancel:s?null:this.c,onKeyDown:this.f,onFocus:function(){return t.setState({b:!0})},onBlur:function(){return t.setState({b:!1})},style:T,id:p,"aria-checked":o,"aria-disabled":s,"aria-labelledby":b,"aria-label":v}))},t}(React.Component);ReactSwitch.defaultProps={disabled:!1,offColor:"#888",onColor:"#080",offHandleColor:"#fff",onHandleColor:"#fff",uncheckedIcon:uncheckedIcon,checkedIcon:checkedIcon,boxShadow:null,activeBoxShadow:"0 0 2px 3px #3bf",height:28,width:56},module.exports=ReactSwitch;


/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Switch__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_GameMaterials__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_GroupRow__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_types__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_popupHelper__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* global confirm */var setRoundState=__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].gameState.setRoundState;var updatePopups=__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].popup.updatePopups;var Verdienen=function(_React$Component){_inherits(Verdienen,_React$Component);function Verdienen(props){_classCallCheck(this,Verdienen);var _this=_possibleConstructorReturn(this,(Verdienen.__proto__||Object.getPrototypeOf(Verdienen)).call(this,props));_this.isFeedbackActive=function(){return _this.status==='SIMULATION_START'||_this.isVerdelenActive()||_this.status==='SIMULATION_SPENDING';};_this.isVerdelenActive=function(){return _this.status==='SIMULATION_TAX'||_this.status==='SIMULATION_TAX_2'||_this.status==='SIMULATION_SPENDING';};_this.isSpendingActive=function(){return _this.currentRound.step3Active;};_this.confirmEnd=function(){_this.props.dispatch(setRoundState('END'));_this.setState({confirmEnd:false});};_this.loginAsGroup=function(groupId){Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/user/'+groupId+'/loginAsGroup',{},'POST').then(function(access){window.open('/login?token='+access.token+'&redirect=/');});};_this.fetchGeneralMaterials=function(){var _this$props=_this.props,project=_this$props.project,schoolClass=_this$props.schoolClass;Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/generalMaterial/'+schoolClass.LanguageId+'/'+project.DefaultDifficultyId+'/1').then(function(gameMaterials){_this.setState({gameMaterials:gameMaterials});});};_this.state={gameMaterials:[]};_this.gameId=parseInt(_this.props.match.params.gameId,10);_this.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_14__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this.props.gameState.DefaultDifficultyId);return _this;}_createClass(Verdienen,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,project=_props.project,gameState=_props.gameState;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(currentRound<=1){Object(__WEBPACK_IMPORTED_MODULE_14__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'dhbvtintro_landbesturen_T':'dlbvtintro_landbesturen_T',dispatch);}}},{key:'componentWillMount',value:function componentWillMount(){this.fetchGeneralMaterials();}},{key:'render',value:function render(){var _this2=this;var _props2=this.props,project=_props2.project,schoolClass=_props2.schoolClass,gameState=_props2.gameState;if(!project.loaded||!schoolClass.loaded||!gameState.loaded)return null;var verdelenActiverenIsDisabled=!this.isFeedbackActive()||this.isVerdelenActive()||gameState.endOfGame;var spendingActiverenIsDisabled=!this.isFeedbackActive()||!this.isVerdelenActive()||this.isSpendingActive()||gameState.endOfGame;var finalSituation=this.props.gameState.currentRound===4&&this.status==="END"||this.props.gameState.currentRound===5;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'verdelen-desktop portal-verdelen classleader-portal'+(this.props.desktop?' portal-home darkBckg':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container list-item-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtintro_landbesturen',title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_land_besturen'),tag:'h3'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas_verdelen'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtverdelenspel',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],{className:!this.props.gameState.allowFeedbackActivate?'disabled':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},finalSituation?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtfeedbackactiveren_1',tag:'p'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtfeedbackactiveren',tag:'p'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_Switch__["a" /* default */],{checked:this.isFeedbackActive(),disabled:this.props.gameState.handlingRoundStateChange,onChange:function onChange(){if(!_this2.props.gameState.allowFeedbackActivate)return;_this2.props.dispatch(setRoundState('SIMULATION_START'));},preConditions:function preConditions(){if(!_this2.props.gameState.allowFeedbackActivate){if(_this2.status&&_this2.status.startsWith("SIMULATION_")){_this2.props.dispatch(updatePopups({popupId:_this2.deviceAndDifficulty+'bmfeedbackactiveren',closeable:true,tutorial:false}));}else{_this2.props.dispatch(updatePopups({popupId:'dhbmfeedbackactiveren_0',closeable:true,tutorial:false}));}return false;}return true;}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block'},finalSituation?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],{className:verdelenActiverenIsDisabled?'disabled':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtverdelenactiveren',tag:'p'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_Switch__["a" /* default */],{checked:this.isVerdelenActive(),disabled:this.props.gameState.handlingRoundStateChange,ignoreDisabled:true,onChange:function onChange(){if(verdelenActiverenIsDisabled)return;_this2.setState({confirmPopup:{action:function action(){_this2.props.dispatch(setRoundState('SIMULATION_TAX'));},name:_this2.deviceAndDifficulty+'bmverdelenactiveren_1a'}});return false;},preConditions:function preConditions(){if(verdelenActiverenIsDisabled){if(!_this2.status||_this2.status==='PLAYING_GAME'||"SCORE_SUBMITTED"&&!_this2.isVerdelenActive()){_this2.props.dispatch(updatePopups({popupId:_this2.deviceAndDifficulty+'bmverdelenactiveren_1',closeable:true,tutorial:false}));}else{_this2.props.dispatch(updatePopups({popupId:_this2.deviceAndDifficulty+'bmverdelenactiveren_2',closeable:true,tutorial:false}));}return false;}return true;}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],{className:spendingActiverenIsDisabled?'disabled':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtverdelenactiveren_1',tag:'p'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_Switch__["a" /* default */],{checked:this.isSpendingActive(),disabled:this.props.gameState.handlingRoundStateChange,ignoreDisabled:true,onChange:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!spendingActiverenIsDisabled){_context2.next=2;break;}return _context2.abrupt('return');case 2:_this2.setState({confirmPopup:{name:_this2.deviceAndDifficulty+'bmstap3activeren_1a',action:function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this2.props.dispatch({type:__WEBPACK_IMPORTED_MODULE_10__actions_types__["x" /* UPDATE_HANDLING_ROUND_STATE_CHANGE */],payload:true});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/simulatiespel/activateStepThree/'+_this2.props.schoolClass.id+'/'+_this2.currentRound.roundNumber,null,'POST');case 3:case'end':return _context.stop();}}},_callee,_this2);}));return function action(){return _ref2.apply(this,arguments);};}()}});case 3:case'end':return _context2.stop();}}},_callee2,_this2);})),preConditions:function preConditions(){if(_this2.isSpendingActive()){_this2.props.dispatch(updatePopups({popupId:_this2.deviceAndDifficulty+'bmstap3activeren_2',closeable:true,tutorial:false}));return false;}if(spendingActiverenIsDisabled){_this2.props.dispatch(updatePopups({popupId:_this2.deviceAndDifficulty+'bmstap3activeren_1',closeable:true,tutorial:false}));return false;}return true;}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spacing-20'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block content-block--small'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtverdelenlesmateriaal',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_GameMaterials__["a" /* default */],{items:this.state.gameMaterials}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'spacing-20'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtfeedbackenverdeling',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-rows-container'},schoolClass.Groups.map(function(group){var saved=false;var currentRound=group.Rounds[group.Rounds.length-1];if(currentRound&&currentRound.gameStateInput&&["SUBMITTED","PROCESSED"].includes(currentRound.gameStateInput.SIMULATION_SPENDING)){saved=true;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_GroupRow__["a" /* default */],{key:group.id,text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(group.name),color:group.GroupTheme.color,onClick:function onClick(){_this2.loginAsGroup(group.id);},saved:saved});}))))),this.state.confirmEnd?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_elements_PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen_beeindigen'),description:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bevestig_verdelen_beeindigen_melding'),showPopUp:true,closePopUpCross:true,customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen_beeindigen'),action:function action(){return _this2.confirmEnd();}},closePopUpClick:function closePopUpClick(ev){if(ev&&ev.target&&['span','button'].includes(ev.target.tagName.toLowerCase())){return false;}_this2.setState({confirmEnd:false});}}):'',this.state.confirmPopup&&this.state.confirmPopup.name?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_elements_PopUp__["a" /* default */],{id:this.state.confirmPopup.name,closePopUpClick:function closePopUpClick(res){if(res&&typeof _this2.state.confirmPopup.action==='function'){_this2.state.confirmPopup.action();}_this2.setState({confirmPopup:{action:function action(){},name:''}});}}):null);}},{key:'currentRound',get:function get(){var gameState=this.props.gameState;return gameState.loaded?gameState.roundData:{};}},{key:'status',get:function get(){return this.currentRound.state;}}]);return Verdienen;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(_ref3){var project=_ref3.project,schoolClass=_ref3.schoolClass,gameState=_ref3.gameState;return{project:project,schoolClass:schoolClass,gameState:gameState};})(Verdienen));

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_feedback_FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_PolicyChoiceLaag__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_caret_down_grey_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_caret_down_grey_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_caret_down_grey_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_beleidskeuze_L_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_beleidskeuze_L_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_beleidskeuze_L_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var updateRead=__WEBPACK_IMPORTED_MODULE_15__actions__["a" /* default */].feedback.updateRead;var Beleidskeuzes=(_temp=_class=function(_Component){_inherits(Beleidskeuzes,_Component);function Beleidskeuzes(props){_classCallCheck(this,Beleidskeuzes);var _this=_possibleConstructorReturn(this,(Beleidskeuzes.__proto__||Object.getPrototypeOf(Beleidskeuzes)).call(this,props));_this.toggleProbleemOplossing=function(id){var showProbleemOplossing=undefined;if(_this.state.showProbleemOplossing!==id){showProbleemOplossing=id;}_this.setState({showProbleemOplossing:showProbleemOplossing});};_this.state={showProbleemOplossing:undefined,showBeleidskeuze:undefined,open:undefined};return _this;}_createClass(Beleidskeuzes,[{key:'render',value:function render(){var _this2=this;var _props=this.props,gameState=_props.gameState,feedback=_props.feedback,policyChoice=_props.policyChoice,gameStateInput=_props.gameStateInput;var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;// Filter policy choices to show 1 per number
var filteredPolicyChoices=Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["l" /* groupByProblem */])(policyChoice);var globas=Object(__WEBPACK_IMPORTED_MODULE_13__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,gameStateInput.myState.policyChoices,gameStateInput.myState.ministerieGlobaVerdeling,Object(__WEBPACK_IMPORTED_MODULE_13__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput),policyChoice);var policyChoiceFeedback=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'close',viewType:'list',showTitle:false,showBudget:gameState.currentStep>1}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),icon:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_beleidskeuze_L_svg___default.a,className:"beleidskeuze-listbutton-laag",feedbackCount:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,gameStateInput.myState.policyChoices,this.props.project.minPolicyChoices):Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData),null,true),arrow:true,redNotification:gameState.currentStep===3,points:gameState.currentStep===3?false:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["v" /* getPolicyChoiceTotalPoints */])(feedback.prevRoundFeedbackData),globas:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["k" /* getTotalCosts */])(gameStateInput.myState.policyChoices,policyChoice):undefined}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'low-policy'},gameState.currentStep===3?filteredPolicyChoices.map(function(pc,i){if(i<_this2.props.project.minPolicyChoices){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_PolicyChoiceLaag__["a" /* default */],{key:i,problem:pc,spendableGlobas:globas,show:_this2.state.open===i,onClick:function onClick(){_this2.setState({open:_this2.state.open===i?undefined:i});}});}else{return false;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},policyChoiceFeedback.map(function(feedback,i){var title=void 0;if(feedback.oplossing_code){title=Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["e" /* getOplossingTitle */])(feedback,gameState.language);}else{title=Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["j" /* getTitle */])(feedback,gameState.language);}console.log(_this2.state.open);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-container-low',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["d" /* checkRead */])(feedback)?0:1,bgColor:feedback.kleur_balk,title:title,arrow:true,feedback:true,thumbnail:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["b" /* getIcon */])(feedback),points:feedback.puntenscore,onClick:function onClick(){var showBeleidskeuze=undefined;if(_this2.state.showBeleidskeuze!==feedback.omschrijving){showBeleidskeuze=feedback.omschrijving;}if(!Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["d" /* checkRead */])(feedback)){feedback.read.read=true;_this2.props.dispatch(updateRead(feedback.id,feedback.read));}_this2.setState({showBeleidskeuze:showBeleidskeuze,showProbleemOplossing:false});}}),_this2.state.showBeleidskeuze===feedback.omschrijving?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'low-feedback-policy-choice-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{className:'problem-solution-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar',onClick:function onClick(){_this2.toggleProbleemOplossing(feedback.omschrijving);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bekijk_probleem_en_oplossing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_img_caret_down_grey_svg___default.a,alt:'close',className:'close-status'+(_this2.state.showProbleemOplossing===feedback.omschrijving?' rotate':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'+(_this2.state.showProbleemOplossing===feedback.omschrijving?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_probleem')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["g" /* getProbleemTekst */])(feedback,gameState.language))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_oplossing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_14__helpers_policyChoiceHelper__["d" /* getOplossingTekst */])(feedback,gameState.language))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_kosten'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,(feedback.kosten_globas||0)+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_feedback_FeedbackImage__["a" /* default */],{description:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["m" /* getImageText */])(feedback,gameState.language),image:feedback.img_2}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{style:{marginBottom:'10px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["y" /* getText */])(feedback,gameState.language)}})),policyChoiceFeedback.length>i+1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'feedback-list-line'}):null):null);})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_NextStep__["a" /* default */],null));}}]);return Beleidskeuzes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,policyChoice=_ref.policyChoice,gameStateInput=_ref.gameStateInput,project=_ref.project;return{gameState:gameState,feedback:feedback,policyChoice:policyChoice,gameStateInput:gameStateInput,project:project};})(Beleidskeuzes));

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GameMaterials__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_popupHelper__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Prepare=(_temp=_class=function(_React$Component){_inherits(Prepare,_React$Component);function Prepare(props){_classCallCheck(this,Prepare);var _this=_possibleConstructorReturn(this,(Prepare.__proto__||Object.getPrototypeOf(Prepare)).call(this,props));_this.renderTitle=function(){switch(_this.props.match.params.startup){case'fairaway':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtfairaway',tag:'h3'});case'startup':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtopstart',tag:'h3'});default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtvoorbereiding',tag:'h3'});}};_this.renderParagraph=function(){switch(_this.props.match.params.startup){case'fairaway':return null;case'startup':return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_opstart_project_ondertitel'));default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,_this.props.schoolcontact?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_docent'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_begeleider'));}};_this.state={generalMaterial:[],vimeoId:null};_this.category=_this.props.match.params.startup||'preparation';_this.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this.props.gameState.DefaultDifficultyId);return _this;}_createClass(Prepare,[{key:'componentWillMount',value:function componentWillMount(){this.fetchMaterials();document.body.classList.add('schoolPage');}},{key:'fetchMaterials',value:function fetchMaterials(){var _this2=this;var _props=this.props,schoolClass=_props.schoolClass,project=_props.project;Object(__WEBPACK_IMPORTED_MODULE_5__apiCall__["a" /* default */])('/generalMaterial/'+schoolClass.LanguageId+'/'+project.DefaultDifficultyId+'/'+this.category,null,'GET').then(function(material){_this2.setState({generalMaterial:material});});}},{key:'render',value:function render(){var desktop=this.props.desktop;var generalMaterial=this.state.generalMaterial;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'classleader-prepare '+(desktop?'portal-home darkBckg desktop-single':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container general-materials-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_GoBackButton__["a" /* default */],{history:this.props.history}),this.renderTitle(),this.renderParagraph()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GameMaterials__["a" /* default */],{items:generalMaterial})));}}]);return Prepare;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{schoolClass:state.schoolClass,project:state.project,gameState:state.gameState};})(Prepare));

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_glxl_helpers_lib_util_cookie__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_glxl_helpers_lib_util_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_glxl_helpers_lib_util_cookie__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Import Components
 *//*
* Import helpers
 */var GameInfo=(_temp=_class=function(_Component){_inherits(GameInfo,_Component);function GameInfo(props){_classCallCheck(this,GameInfo);var _this=_possibleConstructorReturn(this,(GameInfo.__proto__||Object.getPrototypeOf(GameInfo)).call(this,props));_initialiseProps.call(_this);_this.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this.props.gameState.DefaultDifficultyId);var gameId=parseInt(props.match.params.gameid,10);var schoolClass=_this.props.schoolClass;_this.state={curGame:schoolClass.SchoolClassGames.find(function(game){return game.GameId===gameId;}).Game,gameId:gameId,popupId:'',showPopUp:false};_this.curGame=schoolClass.SchoolClassGames.find(function(game){return game.GameId===gameId;}).Game;return _this;}_createClass(GameInfo,[{key:"render",value:function render(){var gameState=this.props.gameState;if(!this.state.curGame){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:'error-page container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_standaard_foutmelding')));}if(this.state.curGame.abbreviation){this.curGame=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["g" /* getPopupCurrentGame */])(this.state.curGame.abbreviation);}else{this.curGame=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["g" /* getPopupCurrentGame */])(this.state.gameId);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"gamepage portal-home darkBckg "+(this.props.desktop?' desktop-single':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:'title-block title-portal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,this.state.curGame.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,this.getSubtitle())),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],{className:'content-detail-game'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["d" /* getContent */])(this.deviceAndDifficulty+"gvt"+this.curGame,gameState.language)}})),this.renderButton(this.state.curGame)),this.state.showPopUp?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_PopUp__["a" /* default */],{popUpFooter:true,id:this.state.popupId,closePopUpClick:this.togglePopup}):null));}}]);return GameInfo;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.defaultProps={desktop:false},_initialiseProps=function _initialiseProps(){var _this2=this;this.getSubtitle=function(){var project=_this2.props.project;if(project.EducationProject.nameShort==='GLXL'){return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_globas_verdienen');}else{return Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["b" /* __n */])('sim_spel',0);}};this.renderButton=function(game){var gameId=_this2.state.gameId,_props=_this2.props,user=_props.user,gameState=_props.gameState,schoolClass=_props.schoolClass;console.log(gameState.currentlyPlaying);var playing=gameState.currentlyPlaying===gameId;var curGame=schoolClass.SchoolClassGames.find(function(game){return game.GameId===gameId;});if(!game.isSeriousGamesMinigame){if(curGame&&curGame.Game&&!curGame.Game.hasContent&&!curGame.Game.softwareLocation)return false;}var rounds=_this2.props.gameState.Rounds;var round=rounds[rounds.length-1];var finished=round&&round.GameId===gameId&&round.state==="SCORE_SUBMITTED";if(!game.isSeriousGamesMinigame){if(curGame.Game.abbreviation==="DT")return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:'center-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("button",{onClick:_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var seriousGamesPlayerToken,_ref2,token,maxPlayersReached;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(user.role==="groupmember"&&curGame.Game.abbreviation==="FQ")){_context.next=5;break;}_this2.setState({popupId:'mlgmtussenschermfilmquiz_3'});_this2.togglePopup();_context.next=39;break;case 5:if(!finished){_context.next=10;break;}_this2.setState({popupId:'dlgmtussenschermghettoradio_2'});_this2.togglePopup();_context.next=39;break;case 10:if(!playing){_context.next=37;break;}if(!(game.isSeriousGamesMinigame&&_this2.props.schoolClass.lastOpenedSeriousGamesMinigame!=game.abbreviation)){_context.next=15;break;}_this2.setState({popupId:'dhgmvghettoradio_1_sgspelnognietgeopend'});_this2.togglePopup();return _context.abrupt("return");case 15:if(!(game.softwareLocation||game.isSeriousGamesMinigame)){_context.next=34;break;}if(!(!game.isSeriousGamesMinigame&&game.softwareLocation.startsWith('/')&&!game.softwareLocation.startsWith('//'))){_context.next=20;break;}window.location.href=game.softwareLocation;_context.next=32;break;case 20:if(!game.isSeriousGamesMinigame){_context.next=31;break;}seriousGamesPlayerToken=Object(__WEBPACK_IMPORTED_MODULE_9_glxl_helpers_lib_util_cookie__["getCookie"])("seriousGamesPlayerToken-"+_this2.props.user.userDetails.group.id);_context.next=24;return Object(__WEBPACK_IMPORTED_MODULE_8__apiCall__["a" /* default */])('/seriousgames/playerLoginToken',{token:seriousGamesPlayerToken},'POST');case 24:_ref2=_context.sent;token=_ref2.token;maxPlayersReached=_ref2.maxPlayersReached;seriousGamesPlayerToken=token;if(token){Object(__WEBPACK_IMPORTED_MODULE_9_glxl_helpers_lib_util_cookie__["setCookie"])("seriousGamesPlayerToken-"+_this2.props.user.userDetails.group.id,seriousGamesPlayerToken,30);window.open(game.seriousGamesSoftwareLocation+"?token="+encodeURIComponent(seriousGamesPlayerToken));}else{if(maxPlayersReached){// @TODO: popup toevoegen in sheet?
_this2.setState({popupId:'dlgmtussenschermhotlist_maxteamleden'});_this2.togglePopup();}else{alert("Er is iets misgegaan bij het ophalen van de inlog token voor Serious Games.");// @TODO: popup toevoegen in sheet?
// this.setState({
//   popupId: 'mlgvtussenschermghettoradio_1',
// })
// this.togglePopup();
}}_context.next=32;break;case 31:window.open(game.softwareLocation+"?token="+user.token);case 32:_context.next=35;break;case 34:_this2.props.history.push("/portal/game/"+game.id);case 35:_context.next=39;break;case 37:_this2.setState({popupId:'dhgmvghettoradio_1'});_this2.togglePopup();case 39:case"end":return _context.stop();}}},_callee,_this2);})),className:'button '+(playing&&(game.isSeriousGamesMinigame?_this2.props.schoolClass.lastOpenedSeriousGamesMinigame==game.abbreviation:true)?'':'disabled'),style:{pointerEvents:'all'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_naar_het_spel'))));};this.togglePopup=function(){_this2.setState({showPopUp:!_this2.state.showPopUp});};},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__["a" /* default */])(function(state){return{user:state.user,project:state.project,schoolClass:state.schoolClass,gameState:state.gameState};})(GameInfo));

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GamePageContent__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__helpers_popupHelper__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
* Import Components
 *//*
* Import helpers
 */var GamePage=(_temp=_class=function(_Component){_inherits(GamePage,_Component);function GamePage(props){_classCallCheck(this,GamePage);var _this=_possibleConstructorReturn(this,(GamePage.__proto__||Object.getPrototypeOf(GamePage)).call(this,props));_this.getSubtitle=function(){var project=_this.props.project;if(project.EducationProject.nameShort==='GLXL'){return Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas_verdienen');}else{return Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_spel',0);}};_this.state={gameId:parseInt(props.match.params.gameid,10)};_this.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this.props.gameState.DefaultDifficultyId);_this.curGame=Object(__WEBPACK_IMPORTED_MODULE_5__helpers_popupHelper__["g" /* getPopupCurrentGame */])(_this.state.gameId);return _this;}_createClass(GamePage,[{key:"render",value:function render(){var _props=this.props,schoolClass=_props.schoolClass,desktop=_props.desktop,gameId=this.state.gameId;var curGame=schoolClass.SchoolClassGames.find(function(game){return game.GameId===gameId;});if(!curGame||curGame.Game.softwareLocation!==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'error-page container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_standaard_foutmelding')));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'gamepage portal-home '+(desktop?' darkBckg desktop-single':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container "+(desktop?' general-materials-container':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'title-block title-portal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,curGame.Game.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.getSubtitle())),curGame.Game?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GamePageContent__["a" /* default */],{game:curGame}):null));}}]);return GamePage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__["a" /* default */])(function(state){return{user:state.user,group:state.group,project:state.project,schoolClass:state.schoolClass,gameState:state.gameState};})(GamePage));

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GameMaterials__ = __webpack_require__(66);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var GamePageContent=function GamePageContent(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),items=_useState2[0],setItems=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),fetched=_useState4[0],setFetched=_useState4[1];var gameId=parseInt(props.game.Game.id,10);function fetchItems(){if(fetched){return false;}setFetched(true);var itemName='';switch(gameId){case 4:// Escape Route
itemName='escapeRouteItem';break;case 11:// True Comics
itemName='trueComicsItem';break;default:break;}return Object(__WEBPACK_IMPORTED_MODULE_2__apiCall__["a" /* default */])('/'+itemName+'/'+props.schoolClass.LanguageId+'/'+props.schoolClass.DifficultyId).then(function(result){setItems(result);});}Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){fetchItems();});switch(gameId){case 4:// Escape Route
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GameMaterials__["a" /* default */],{gameId:4,items:items});case 11:// True comics
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__GameMaterials__["a" /* default */],{gameId:11,items:items});default:return null;}};// GamePageContent.propTypes = {
//   Game: PropTypes.shape({
//     id: PropTypes.any.isRequired,
//   }).isRequired,
// };
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref){var schoolClass=_ref.schoolClass,group=_ref.group;return{schoolClass:schoolClass,group:group};})(GamePageContent));

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_VimeoPlayer__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getUrlVars__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__apiCall__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Vimeo=(_temp=_class=function(_React$Component){_inherits(Vimeo,_React$Component);function Vimeo(props){_classCallCheck(this,Vimeo);var _this=_possibleConstructorReturn(this,(Vimeo.__proto__||Object.getPrototypeOf(Vimeo)).call(this,props));_this.state={vimeoId:null};return _this;}_createClass(Vimeo,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;var getParams=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_getUrlVars__["a" /* default */])();if(getParams.publicMaterialId&&getParams.publicMaterialId!=='null'){Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/file/generalMaterial/'+getParams.publicMaterialId,null,'GET').then(function(material){_this2.setState({vimeoId:material.vimeoId||material.alternateId});});}else{Object(__WEBPACK_IMPORTED_MODULE_4__apiCall__["a" /* default */])('/user/me').then(function(){_this2.setState({vimeoId:_this2.props.match.params.vimeoId});});}if(getParams.windowTitle&&getParams.windowTitle!=='null'){__WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__["a" /* default */].setWindowTitle(decodeURIComponent(getParams.windowTitle));}if(getParams.faviconUrl&&getParams.faviconUrl!=='null'){__WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__["a" /* default */].setFavicon(decodeURIComponent(getParams.faviconUrl));}if(getParams.backgroundUrl&&getParams.backgroundUrl!=='null'){this.backgroundUrl=decodeURIComponent(getParams.backgroundUrl);}}},{key:'render',value:function render(){var desktop=this.props.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.backgroundUrl?{backgroundImage:'url('+this.backgroundUrl+')',backgroundSize:'cover',backgroundPosition:'center'}:{},className:desktop?'portal-vimeo portal-home darkBckg'+(this.backgroundUrl?' custom-background':''):'portal-vimeo portal-home darkBckg'+(this.backgroundUrl?' custom-background':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_VimeoPlayer__["a" /* default */],{vimeoId:this.state.vimeoId})));}}]);return Vimeo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Vimeo);

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VimeoPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vimeo_player__ = __webpack_require__(972);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VimeoPlayer=function(_React$Component){_inherits(VimeoPlayer,_React$Component);function VimeoPlayer(props){_classCallCheck(this,VimeoPlayer);var _this=_possibleConstructorReturn(this,(VimeoPlayer.__proto__||Object.getPrototypeOf(VimeoPlayer)).call(this,props));_this.state={};_this.vimeoRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();return _this;}_createClass(VimeoPlayer,[{key:'componentDidMount',value:function componentDidMount(){var ifreume=this.vimeoRef.current;var player=new __WEBPACK_IMPORTED_MODULE_1__vimeo_player__["a" /* default */](ifreume);player.on('ended',function(){if(document.exitFullscreen){document.exitFullscreen();}else if(document.mozCancelFullScreen){document.mozCancelFullScreen();}else if(document.webkitExitFullscreen){document.webkitExitFullscreen();}else if(document.msExitFullscreen){document.msExitFullscreen();}});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vimeo-player'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{ref:this.vimeoRef,title:'Vimeo Video',src:'https://player.vimeo.com/video/'+this.props.vimeoId,frameBorder:0,allowFullScreen:true}));}}]);return VimeoPlayer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*! @vimeo/player v2.29.7 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

/**
 * @module lib/functions
 */

/**
 * Check to see this is a Node environment.
 * @type {boolean}
 */
/* global global */
var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';

/**
 * Check to see if this is a Bun environment.
 * @see https://bun.sh/guides/util/detect-bun
 * @type {boolean}
 */
var isBun = typeof Bun !== 'undefined';

/**
 * Check to see if this is a Deno environment.
 * @see https://docs.deno.com/api/deno/~/Deno
 * @type {boolean}
 */
var isDeno = typeof Deno !== 'undefined';

/**
 * Check if this is a server runtime
 * @type {boolean}
 */
var isServerRuntime = isNode || isBun || isDeno;

/**
 * Get the name of the method for a given getter or setter.
 *
 * @param {string} prop The name of the property.
 * @param {string} type Either “get” or “set”.
 * @return {string}
 */
function getMethodName(prop, type) {
  if (prop.indexOf(type.toLowerCase()) === 0) {
    return prop;
  }
  return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
}

/**
 * Check to see if the object is a DOM Element.
 *
 * @param {*} element The object to check.
 * @return {boolean}
 */
function isDomElement(element) {
  return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
}

/**
 * Check to see whether the value is a number.
 *
 * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
 * @param {*} value The value to check.
 * @param {boolean} integer Check if the value is an integer.
 * @return {boolean}
 */
function isInteger(value) {
  // eslint-disable-next-line eqeqeq
  return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
}

/**
 * Check to see if the URL is a Vimeo url.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */
function isVimeoUrl(url) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(url);
}

/**
 * Check to see if the URL is for a Vimeo embed.
 *
 * @param {string} url The url string.
 * @return {boolean}
 */
function isVimeoEmbed(url) {
  var expr = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return expr.test(url);
}
function getOembedDomain(url) {
  var match = (url || '').match(/^(?:https?:)?(?:\/\/)?([^/?]+)/);
  var domain = (match && match[1] || '').replace('player.', '');
  var customDomains = ['.videoji.hk', '.vimeo.work', '.videoji.cn'];
  for (var _i = 0, _customDomains = customDomains; _i < _customDomains.length; _i++) {
    var customDomain = _customDomains[_i];
    if (domain.endsWith(customDomain)) {
      return domain;
    }
  }
  return 'vimeo.com';
}

/**
 * Get the Vimeo URL from an element.
 * The element must have either a data-vimeo-id or data-vimeo-url attribute.
 *
 * @param {object} oEmbedParameters The oEmbed parameters.
 * @return {string}
 */
function getVimeoUrl() {
  var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = oEmbedParameters.id;
  var url = oEmbedParameters.url;
  var idOrUrl = id || url;
  if (!idOrUrl) {
    throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
  }
  if (isInteger(idOrUrl)) {
    return "https://vimeo.com/".concat(idOrUrl);
  }
  if (isVimeoUrl(idOrUrl)) {
    return idOrUrl.replace('http:', 'https:');
  }
  if (id) {
    throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
  }
  throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
}

/* eslint-disable max-params */
/**
 * A utility method for attaching and detaching event handlers
 *
 * @param {EventTarget} target
 * @param {string | string[]} eventName
 * @param {function} callback
 * @param {'addEventListener' | 'on'} onName
 * @param {'removeEventListener' | 'off'} offName
 * @return {{cancel: (function(): void)}}
 */
var subscribe = function subscribe(target, eventName, callback) {
  var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'addEventListener';
  var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'removeEventListener';
  var eventNames = typeof eventName === 'string' ? [eventName] : eventName;
  eventNames.forEach(function (evName) {
    target[onName](evName, callback);
  });
  return {
    cancel: function cancel() {
      return eventNames.forEach(function (evName) {
        return target[offName](evName, callback);
      });
    }
  };
};

/**
 * Find the iframe element that contains a specific source window
 *
 * @param {Window} sourceWindow The source window to find the iframe for
 * @param {Document} [doc=document] The document to search within
 * @return {HTMLIFrameElement|null} The iframe element if found, otherwise null
 */
function findIframeBySourceWindow(sourceWindow) {
  var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  if (!sourceWindow || !doc || typeof doc.querySelectorAll !== 'function') {
    return null;
  }
  var iframes = doc.querySelectorAll('iframe');
  for (var i = 0; i < iframes.length; i++) {
    if (iframes[i] && iframes[i].contentWindow === sourceWindow) {
      return iframes[i];
    }
  }
  return null;
}

var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
if (!isServerRuntime && (!arrayIndexOfSupport || !postMessageSupport)) {
  throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */

(function (self) {

  if (self.WeakMap) {
    return;
  }
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var hasDefine = Object.defineProperty && function () {
    try {
      // Avoid IE8's broken Object.defineProperty
      return Object.defineProperty({}, 'x', {
        value: 1
      }).x === 1;
    } catch (e) {}
  }();
  var defineProperty = function (object, name, value) {
    if (hasDefine) {
      Object.defineProperty(object, name, {
        configurable: true,
        writable: true,
        value: value
      });
    } else {
      object[name] = value;
    }
  };
  self.WeakMap = function () {
    // ECMA-262 23.3 WeakMap Objects
    function WeakMap() {
      if (this === void 0) {
        throw new TypeError("Constructor WeakMap requires 'new'");
      }
      defineProperty(this, '_id', genId('_WeakMap'));

      // ECMA-262 23.3.1.1 WeakMap([iterable])
      if (arguments.length > 0) {
        // Currently, WeakMap `iterable` argument is not supported
        throw new TypeError('WeakMap iterable is not supported');
      }
    }

    // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
    defineProperty(WeakMap.prototype, 'delete', function (key) {
      checkInstance(this, 'delete');
      if (!isObject(key)) {
        return false;
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        delete key[this._id];
        return true;
      }
      return false;
    });

    // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
    defineProperty(WeakMap.prototype, 'get', function (key) {
      checkInstance(this, 'get');
      if (!isObject(key)) {
        return void 0;
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        return entry[1];
      }
      return void 0;
    });

    // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
    defineProperty(WeakMap.prototype, 'has', function (key) {
      checkInstance(this, 'has');
      if (!isObject(key)) {
        return false;
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        return true;
      }
      return false;
    });

    // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
    defineProperty(WeakMap.prototype, 'set', function (key, value) {
      checkInstance(this, 'set');
      if (!isObject(key)) {
        throw new TypeError('Invalid value used as weak map key');
      }
      var entry = key[this._id];
      if (entry && entry[0] === key) {
        entry[1] = value;
        return this;
      }
      defineProperty(key, this._id, [key, value]);
      return this;
    });
    function checkInstance(x, methodName) {
      if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
        throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
      }
    }
    function genId(prefix) {
      return prefix + '_' + rand() + '.' + rand();
    }
    function rand() {
      return Math.random().toString().substring(2);
    }
    defineProperty(WeakMap, '_polyfill', true);
    return WeakMap;
  }();
  function isObject(x) {
    return Object(x) === x;
  }
})(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

var npo_src = createCommonjsModule(function (module) {
/*! Native Promise Only
    v0.8.1 (c) Kyle Simpson
    MIT License: http://getify.mit-license.org
*/

(function UMD(name, context, definition) {
  // special form of UMD for polyfilling across evironments
  context[name] = context[name] || definition();
  if (module.exports) {
    module.exports = context[name];
  }
})("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

  var builtInProp,
    cycle,
    scheduling_queue,
    ToString = Object.prototype.toString,
    timer = typeof setImmediate != "undefined" ? function timer(fn) {
      return setImmediate(fn);
    } : setTimeout;

  // dammit, IE8.
  try {
    Object.defineProperty({}, "x", {});
    builtInProp = function builtInProp(obj, name, val, config) {
      return Object.defineProperty(obj, name, {
        value: val,
        writable: true,
        configurable: config !== false
      });
    };
  } catch (err) {
    builtInProp = function builtInProp(obj, name, val) {
      obj[name] = val;
      return obj;
    };
  }

  // Note: using a queue instead of array for efficiency
  scheduling_queue = function Queue() {
    var first, last, item;
    function Item(fn, self) {
      this.fn = fn;
      this.self = self;
      this.next = void 0;
    }
    return {
      add: function add(fn, self) {
        item = new Item(fn, self);
        if (last) {
          last.next = item;
        } else {
          first = item;
        }
        last = item;
        item = void 0;
      },
      drain: function drain() {
        var f = first;
        first = last = cycle = void 0;
        while (f) {
          f.fn.call(f.self);
          f = f.next;
        }
      }
    };
  }();
  function schedule(fn, self) {
    scheduling_queue.add(fn, self);
    if (!cycle) {
      cycle = timer(scheduling_queue.drain);
    }
  }

  // promise duck typing
  function isThenable(o) {
    var _then,
      o_type = typeof o;
    if (o != null && (o_type == "object" || o_type == "function")) {
      _then = o.then;
    }
    return typeof _then == "function" ? _then : false;
  }
  function notify() {
    for (var i = 0; i < this.chain.length; i++) {
      notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
    }
    this.chain.length = 0;
  }

  // NOTE: This is a separate function to isolate
  // the `try..catch` so that other code can be
  // optimized better
  function notifyIsolated(self, cb, chain) {
    var ret, _then;
    try {
      if (cb === false) {
        chain.reject(self.msg);
      } else {
        if (cb === true) {
          ret = self.msg;
        } else {
          ret = cb.call(void 0, self.msg);
        }
        if (ret === chain.promise) {
          chain.reject(TypeError("Promise-chain cycle"));
        } else if (_then = isThenable(ret)) {
          _then.call(ret, chain.resolve, chain.reject);
        } else {
          chain.resolve(ret);
        }
      }
    } catch (err) {
      chain.reject(err);
    }
  }
  function resolve(msg) {
    var _then,
      self = this;

    // already triggered?
    if (self.triggered) {
      return;
    }
    self.triggered = true;

    // unwrap
    if (self.def) {
      self = self.def;
    }
    try {
      if (_then = isThenable(msg)) {
        schedule(function () {
          var def_wrapper = new MakeDefWrapper(self);
          try {
            _then.call(msg, function $resolve$() {
              resolve.apply(def_wrapper, arguments);
            }, function $reject$() {
              reject.apply(def_wrapper, arguments);
            });
          } catch (err) {
            reject.call(def_wrapper, err);
          }
        });
      } else {
        self.msg = msg;
        self.state = 1;
        if (self.chain.length > 0) {
          schedule(notify, self);
        }
      }
    } catch (err) {
      reject.call(new MakeDefWrapper(self), err);
    }
  }
  function reject(msg) {
    var self = this;

    // already triggered?
    if (self.triggered) {
      return;
    }
    self.triggered = true;

    // unwrap
    if (self.def) {
      self = self.def;
    }
    self.msg = msg;
    self.state = 2;
    if (self.chain.length > 0) {
      schedule(notify, self);
    }
  }
  function iteratePromises(Constructor, arr, resolver, rejecter) {
    for (var idx = 0; idx < arr.length; idx++) {
      (function IIFE(idx) {
        Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
          resolver(idx, msg);
        }, rejecter);
      })(idx);
    }
  }
  function MakeDefWrapper(self) {
    this.def = self;
    this.triggered = false;
  }
  function MakeDef(self) {
    this.promise = self;
    this.state = 0;
    this.triggered = false;
    this.chain = [];
    this.msg = void 0;
  }
  function Promise(executor) {
    if (typeof executor != "function") {
      throw TypeError("Not a function");
    }
    if (this.__NPO__ !== 0) {
      throw TypeError("Not a promise");
    }

    // instance shadowing the inherited "brand"
    // to signal an already "initialized" promise
    this.__NPO__ = 1;
    var def = new MakeDef(this);
    this["then"] = function then(success, failure) {
      var o = {
        success: typeof success == "function" ? success : true,
        failure: typeof failure == "function" ? failure : false
      };
      // Note: `then(..)` itself can be borrowed to be used against
      // a different promise constructor for making the chained promise,
      // by substituting a different `this` binding.
      o.promise = new this.constructor(function extractChain(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        o.resolve = resolve;
        o.reject = reject;
      });
      def.chain.push(o);
      if (def.state !== 0) {
        schedule(notify, def);
      }
      return o.promise;
    };
    this["catch"] = function $catch$(failure) {
      return this.then(void 0, failure);
    };
    try {
      executor.call(void 0, function publicResolve(msg) {
        resolve.call(def, msg);
      }, function publicReject(msg) {
        reject.call(def, msg);
      });
    } catch (err) {
      reject.call(def, err);
    }
  }
  var PromisePrototype = builtInProp({}, "constructor", Promise, /*configurable=*/false);

  // Note: Android 4 cannot use `Object.defineProperty(..)` here
  Promise.prototype = PromisePrototype;

  // built-in "brand" to signal an "uninitialized" promise
  builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/false);
  builtInProp(Promise, "resolve", function Promise$resolve(msg) {
    var Constructor = this;

    // spec mandated checks
    // note: best "isPromise" check that's practical for now
    if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
      return msg;
    }
    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      resolve(msg);
    });
  });
  builtInProp(Promise, "reject", function Promise$reject(msg) {
    return new this(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      reject(msg);
    });
  });
  builtInProp(Promise, "all", function Promise$all(arr) {
    var Constructor = this;

    // spec mandated checks
    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }
    if (arr.length === 0) {
      return Constructor.resolve([]);
    }
    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      var len = arr.length,
        msgs = Array(len),
        count = 0;
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        msgs[idx] = msg;
        if (++count === len) {
          resolve(msgs);
        }
      }, reject);
    });
  });
  builtInProp(Promise, "race", function Promise$race(arr) {
    var Constructor = this;

    // spec mandated checks
    if (ToString.call(arr) != "[object Array]") {
      return Constructor.reject(TypeError("Not an array"));
    }
    return new Constructor(function executor(resolve, reject) {
      if (typeof resolve != "function" || typeof reject != "function") {
        throw TypeError("Not a function");
      }
      iteratePromises(Constructor, arr, function resolver(idx, msg) {
        resolve(msg);
      }, reject);
    });
  });
  return Promise;
});
});

/**
 * @module lib/callbacks
 */

var callbackMap = new WeakMap();

/**
 * Store a callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
 *        The callback to call or an object with resolve and reject functions for a promise.
 * @return {void}
 */
function storeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  if (!(name in playerCallbacks)) {
    playerCallbacks[name] = [];
  }
  playerCallbacks[name].push(callback);
  callbackMap.set(player.element, playerCallbacks);
}

/**
 * Get the callbacks for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @return {function[]}
 */
function getCallbacks(player, name) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  return playerCallbacks[name] || [];
}

/**
 * Remove a stored callback for a method or event for a player.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name
 * @param {function} [callback] The specific callback to remove.
 * @return {boolean} Was this the last callback?
 */
function removeCallback(player, name, callback) {
  var playerCallbacks = callbackMap.get(player.element) || {};
  if (!playerCallbacks[name]) {
    return true;
  }

  // If no callback is passed, remove all callbacks for the event
  if (!callback) {
    playerCallbacks[name] = [];
    callbackMap.set(player.element, playerCallbacks);
    return true;
  }
  var index = playerCallbacks[name].indexOf(callback);
  if (index !== -1) {
    playerCallbacks[name].splice(index, 1);
  }
  callbackMap.set(player.element, playerCallbacks);
  return playerCallbacks[name] && playerCallbacks[name].length === 0;
}

/**
 * Return the first stored callback for a player and event or method.
 *
 * @param {Player} player The player object.
 * @param {string} name The method or event name.
 * @return {function} The callback, or false if there were none
 */
function shiftCallbacks(player, name) {
  var playerCallbacks = getCallbacks(player, name);
  if (playerCallbacks.length < 1) {
    return false;
  }
  var callback = playerCallbacks.shift();
  removeCallback(player, name, callback);
  return callback;
}

/**
 * Move callbacks associated with an element to another element.
 *
 * @param {HTMLElement} oldElement The old element.
 * @param {HTMLElement} newElement The new element.
 * @return {void}
 */
function swapCallbacks(oldElement, newElement) {
  var playerCallbacks = callbackMap.get(oldElement);
  callbackMap.set(newElement, playerCallbacks);
  callbackMap.delete(oldElement);
}

/**
 * @module lib/postmessage
 */

/**
 * Parse a message received from postMessage.
 *
 * @param {*} data The data received from postMessage.
 * @return {object}
 */
function parseMessageData(data) {
  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (error) {
      // If the message cannot be parsed, throw the error as a warning
      console.warn(error);
      return {};
    }
  }
  return data;
}

/**
 * Post a message to the specified target.
 *
 * @param {Player} player The player object to use.
 * @param {string} method The API method to call.
 * @param {string|number|object|Array|undefined} params The parameters to send to the player.
 * @return {void}
 */
function postMessage(player, method, params) {
  if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
    return;
  }
  var message = {
    method: method
  };
  if (params !== undefined) {
    message.value = params;
  }

  // IE 8 and 9 do not support passing messages, so stringify them
  var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
  if (ieVersion >= 8 && ieVersion < 10) {
    message = JSON.stringify(message);
  }
  player.element.contentWindow.postMessage(message, player.origin);
}

/**
 * Parse the data received from a message event.
 *
 * @param {Player} player The player that received the message.
 * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
 * @return {void}
 */
function processData(player, data) {
  data = parseMessageData(data);
  var callbacks = [];
  var param;
  if (data.event) {
    if (data.event === 'error') {
      var promises = getCallbacks(player, data.data.method);
      promises.forEach(function (promise) {
        var error = new Error(data.data.message);
        error.name = data.data.name;
        promise.reject(error);
        removeCallback(player, data.data.method, promise);
      });
    }
    callbacks = getCallbacks(player, "event:".concat(data.event));
    param = data.data;
  } else if (data.method) {
    var callback = shiftCallbacks(player, data.method);
    if (callback) {
      callbacks.push(callback);
      param = data.value;
    }
  }
  callbacks.forEach(function (callback) {
    try {
      if (typeof callback === 'function') {
        callback.call(player, param);
        return;
      }
      callback.resolve(param);
    } catch (e) {
      // empty
    }
  });
}

/**
 * @module lib/embed
 */
var oEmbedParameters = ['airplay', 'audio_tracks', 'audiotrack', 'autopause', 'autoplay', 'background', 'byline', 'cc', 'chapter_id', 'chapters', 'chromecast', 'color', 'colors', 'controls', 'dnt', 'end_time', 'fullscreen', 'height', 'id', 'initial_quality', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'max_quality', 'maxwidth', 'min_quality', 'muted', 'play_button_position', 'playsinline', 'portrait', 'preload', 'progress_bar', 'quality', 'quality_selector', 'responsive', 'skipping_forward', 'speed', 'start_time', 'texttrack', 'thumbnail_id', 'title', 'transcript', 'transparent', 'unmute_button', 'url', 'vimeo_logo', 'volume', 'watch_full_video', 'width'];

/**
 * Get the 'data-vimeo'-prefixed attributes from an element as an object.
 *
 * @param {HTMLElement} element The element.
 * @param {Object} [defaults={}] The default values to use.
 * @return {Object<string, string>}
 */
function getOEmbedParameters(element) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return oEmbedParameters.reduce(function (params, param) {
    var value = element.getAttribute("data-vimeo-".concat(param));
    if (value || value === '') {
      params[param] = value === '' ? 1 : value;
    }
    return params;
  }, defaults);
}

/**
 * Create an embed from oEmbed data inside an element.
 *
 * @param {object} data The oEmbed data.
 * @param {HTMLElement} element The element to put the iframe in.
 * @return {HTMLIFrameElement} The iframe embed.
 */
function createEmbed(_ref, element) {
  var html = _ref.html;
  if (!element) {
    throw new TypeError('An element must be provided');
  }
  if (element.getAttribute('data-vimeo-initialized') !== null) {
    return element.querySelector('iframe');
  }
  var div = document.createElement('div');
  div.innerHTML = html;
  element.appendChild(div.firstChild);
  element.setAttribute('data-vimeo-initialized', 'true');
  return element.querySelector('iframe');
}

/**
 * Make an oEmbed call for the specified URL.
 *
 * @param {string} videoUrl The vimeo.com url for the video.
 * @param {Object} [params] Parameters to pass to oEmbed.
 * @param {HTMLElement} element The element.
 * @return {Promise}
 */
function getOEmbedData(videoUrl) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var element = arguments.length > 2 ? arguments[2] : undefined;
  return new Promise(function (resolve, reject) {
    if (!isVimeoUrl(videoUrl)) {
      throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
    }
    var domain = getOembedDomain(videoUrl);
    var url = "https://".concat(domain, "/api/oembed.json?url=").concat(encodeURIComponent(videoUrl));
    for (var param in params) {
      if (params.hasOwnProperty(param)) {
        url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
      }
    }
    var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.onload = function () {
      if (xhr.status === 404) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
        return;
      }
      if (xhr.status === 403) {
        reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
        return;
      }
      try {
        var json = JSON.parse(xhr.responseText);
        // Check api response for 403 on oembed
        if (json.domain_status_code === 403) {
          // We still want to create the embed to give users visual feedback
          createEmbed(json, element);
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }
        resolve(json);
      } catch (error) {
        reject(error);
      }
    };
    xhr.onerror = function () {
      var status = xhr.status ? " (".concat(xhr.status, ")") : '';
      reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
    };
    xhr.send();
  });
}

/**
 * Initialize all embeds within a specific element
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function initializeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error creating an embed: ".concat(error));
    }
  };
  elements.forEach(function (element) {
    try {
      // Skip any that have data-vimeo-defer
      if (element.getAttribute('data-vimeo-defer') !== null) {
        return;
      }
      var params = getOEmbedParameters(element);
      var url = getVimeoUrl(params);
      getOEmbedData(url, params, element).then(function (data) {
        return createEmbed(data, element);
      }).catch(handleError);
    } catch (error) {
      handleError(error);
    }
  });
}

/**
 * Resize embeds when messaged by the player.
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function resizeEmbeds() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  // Prevent execution if users include the player.js script multiple times.
  if (window.VimeoPlayerResizeEmbeds_) {
    return;
  }
  window.VimeoPlayerResizeEmbeds_ = true;
  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }

    // 'spacechange' is fired only on embeds with cards
    if (!event.data || event.data.event !== 'spacechange') {
      return;
    }
    var senderIFrame = event.source ? findIframeBySourceWindow(event.source, parent) : null;
    if (senderIFrame) {
      // Change padding-bottom of the enclosing div to accommodate
      // card carousel without distorting aspect ratio
      var space = senderIFrame.parentElement;
      space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
    }
  };
  window.addEventListener('message', onMessage);
}

/**
 * Add chapters to existing metadata for Google SEO
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function initAppendVideoMetadata() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  //  Prevent execution if users include the player.js script multiple times.
  if (window.VimeoSeoMetadataAppended) {
    return;
  }
  window.VimeoSeoMetadataAppended = true;
  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }
    var data = parseMessageData(event.data);
    if (!data || data.event !== 'ready') {
      return;
    }
    var senderIFrame = event.source ? findIframeBySourceWindow(event.source, parent) : null;

    // Initiate appendVideoMetadata if iframe is a Vimeo embed
    if (senderIFrame && isVimeoEmbed(senderIFrame.src)) {
      var player = new Player(senderIFrame);
      player.callMethod('appendVideoMetadata', window.location.href);
    }
  };
  window.addEventListener('message', onMessage);
}

/**
 * Seek to time indicated by vimeo_t query parameter if present in URL
 *
 * @param {HTMLElement} [parent=document] The parent element.
 * @return {void}
 */
function checkUrlTimeParam() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  //  Prevent execution if users include the player.js script multiple times.
  if (window.VimeoCheckedUrlTimeParam) {
    return;
  }
  window.VimeoCheckedUrlTimeParam = true;
  var handleError = function handleError(error) {
    if ('console' in window && console.error) {
      console.error("There was an error getting video Id: ".concat(error));
    }
  };
  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }
    var data = parseMessageData(event.data);
    if (!data || data.event !== 'ready') {
      return;
    }
    var senderIFrame = event.source ? findIframeBySourceWindow(event.source, parent) : null;
    if (senderIFrame && isVimeoEmbed(senderIFrame.src)) {
      var player = new Player(senderIFrame);
      player.getVideoId().then(function (videoId) {
        var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
        if (matches && matches[1]) {
          var sec = decodeURI(matches[1]);
          player.setCurrentTime(sec);
        }
        return;
      }).catch(handleError);
    }
  };
  window.addEventListener('message', onMessage);
}

/**
 * Updates iframe embeds to support DRM content playback by adding the 'encrypted-media' permission
 * to the iframe's allow attribute when DRM initialization fails. This function acts as a fallback
 * mechanism to enable playback of DRM-protected content in embeds that weren't properly configured.
 *
 * @return {void}
 */
function updateDRMEmbeds() {
  if (window.VimeoDRMEmbedsUpdated) {
    return;
  }
  window.VimeoDRMEmbedsUpdated = true;

  /**
   * Handle message events for DRM initialization failures
   * @param {MessageEvent} event - The message event from the iframe
   */
  var onMessage = function onMessage(event) {
    if (!isVimeoUrl(event.origin)) {
      return;
    }
    var data = parseMessageData(event.data);
    if (!data || data.event !== 'drminitfailed') {
      return;
    }
    var senderIFrame = event.source ? findIframeBySourceWindow(event.source) : null;
    if (!senderIFrame) {
      return;
    }
    var currentAllow = senderIFrame.getAttribute('allow') || '';
    var allowSupportsDRM = currentAllow.includes('encrypted-media');
    if (!allowSupportsDRM) {
      // For DRM playback to successfully occur, the iframe `allow` attribute must include 'encrypted-media'.
      // If the video requires DRM but doesn't have the attribute, we try to add on behalf of the embed owner
      // as a temporary measure to enable playback until they're able to update their embeds.
      senderIFrame.setAttribute('allow', "".concat(currentAllow, "; encrypted-media"));
      var currentUrl = new URL(senderIFrame.getAttribute('src'));

      // Adding this forces the embed to reload once `allow` has been updated with `encrypted-media`.
      currentUrl.searchParams.set('forcereload', 'drm');
      senderIFrame.setAttribute('src', currentUrl.toString());
      return;
    }
  };
  window.addEventListener('message', onMessage);
}

/* MIT License

Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
Terms */

function initializeScreenfull() {
  var fn = function () {
    var val;
    var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
    // New WebKit
    ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
    // Old WebKit
    ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
    var i = 0;
    var l = fnMap.length;
    var ret = {};
    for (; i < l; i++) {
      val = fnMap[i];
      if (val && val[1] in document) {
        for (i = 0; i < val.length; i++) {
          ret[fnMap[0][i]] = val[i];
        }
        return ret;
      }
    }
    return false;
  }();
  var eventNameMap = {
    fullscreenchange: fn.fullscreenchange,
    fullscreenerror: fn.fullscreenerror
  };
  var screenfull = {
    request: function request(element) {
      return new Promise(function (resolve, reject) {
        var onFullScreenEntered = function onFullScreenEntered() {
          screenfull.off('fullscreenchange', onFullScreenEntered);
          resolve();
        };
        screenfull.on('fullscreenchange', onFullScreenEntered);
        element = element || document.documentElement;
        var returnPromise = element[fn.requestFullscreen]();
        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenEntered).catch(reject);
        }
      });
    },
    exit: function exit() {
      return new Promise(function (resolve, reject) {
        if (!screenfull.isFullscreen) {
          resolve();
          return;
        }
        var onFullScreenExit = function onFullScreenExit() {
          screenfull.off('fullscreenchange', onFullScreenExit);
          resolve();
        };
        screenfull.on('fullscreenchange', onFullScreenExit);
        var returnPromise = document[fn.exitFullscreen]();
        if (returnPromise instanceof Promise) {
          returnPromise.then(onFullScreenExit).catch(reject);
        }
      });
    },
    on: function on(event, callback) {
      var eventName = eventNameMap[event];
      if (eventName) {
        document.addEventListener(eventName, callback);
      }
    },
    off: function off(event, callback) {
      var eventName = eventNameMap[event];
      if (eventName) {
        document.removeEventListener(eventName, callback);
      }
    }
  };
  Object.defineProperties(screenfull, {
    isFullscreen: {
      get: function get() {
        return Boolean(document[fn.fullscreenElement]);
      }
    },
    element: {
      enumerable: true,
      get: function get() {
        return document[fn.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: true,
      get: function get() {
        // Coerce to boolean in case of old WebKit
        return Boolean(document[fn.fullscreenEnabled]);
      }
    }
  });
  return screenfull;
}

/** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */
/** @typedef {import('timing-object').ITimingObject} TimingObject */
/** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
/** @typedef {(msg: string) => any} Logger */
/** @typedef {import('timing-object').TConnectionState} TConnectionState */

/**
 * @type {TimingSrcConnectorOptions}
 *
 * For details on these properties and their effects, see the typescript definition referenced above.
 */
var defaultOptions = {
  role: 'viewer',
  autoPlayMuted: true,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
};

/**
 * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
 *
 * Proposed spec: https://webtiming.github.io/timingobject/
 * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
 * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
 *
 * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
 *
 * There are 5 general responsibilities in TimingSrcConnector:
 *
 * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
 * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
 * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
 * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
 * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
 */
var TimingSrcConnector = /*#__PURE__*/function (_EventTarget) {
  _inherits(TimingSrcConnector, _EventTarget);
  var _super = _createSuper(TimingSrcConnector);
  /**
   * @param {PlayerControls} player
   * @param {TimingObject} timingObject
   * @param {TimingSrcConnectorOptions} options
   * @param {Logger} logger
   */
  function TimingSrcConnector(_player, timingObject) {
    var _this;
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var logger = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, TimingSrcConnector);
    _this = _super.call(this);
    _defineProperty(_assertThisInitialized(_this), "logger", void 0);
    _defineProperty(_assertThisInitialized(_this), "speedAdjustment", 0);
    /**
     * @param {PlayerControls} player
     * @param {number} newAdjustment
     * @return {Promise<void>}
     */
    _defineProperty(_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
        var newPlaybackRate;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.speedAdjustment === newAdjustment)) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return player.getPlaybackRate();
            case 4:
              _context.t0 = _context.sent;
              _context.t1 = _this.speedAdjustment;
              _context.t2 = _context.t0 - _context.t1;
              _context.t3 = newAdjustment;
              newPlaybackRate = _context.t2 + _context.t3;
              _this.log("New playbackRate:  ".concat(newPlaybackRate));
              _context.next = 12;
              return player.setPlaybackRate(newPlaybackRate);
            case 12:
              _this.speedAdjustment = newAdjustment;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.logger = logger;
    _this.init(timingObject, _player, _objectSpread2(_objectSpread2({}, defaultOptions), options));
    return _this;
  }
  _createClass(TimingSrcConnector, [{
    key: "disconnect",
    value: function disconnect() {
      this.dispatchEvent(new Event('disconnect'));
    }

    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
        var _this2 = this;
        var playerUpdater, positionSync, timingObjectUpdater;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.waitForTOReadyState(timingObject, 'open');
            case 2:
              if (!(options.role === 'viewer')) {
                _context2.next = 10;
                break;
              }
              _context2.next = 5;
              return this.updatePlayer(timingObject, player, options);
            case 5:
              playerUpdater = subscribe(timingObject, 'change', function () {
                return _this2.updatePlayer(timingObject, player, options);
              });
              positionSync = this.maintainPlaybackPosition(timingObject, player, options);
              this.addEventListener('disconnect', function () {
                positionSync.cancel();
                playerUpdater.cancel();
              });
              _context2.next = 14;
              break;
            case 10:
              _context2.next = 12;
              return this.updateTimingObject(timingObject, player);
            case 12:
              timingObjectUpdater = subscribe(player, ['seeked', 'play', 'pause', 'ratechange'], function () {
                return _this2.updateTimingObject(timingObject, player);
              }, 'on', 'off');
              this.addEventListener('disconnect', function () {
                return timingObjectUpdater.cancel();
              });
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function init(_x3, _x4, _x5) {
        return _init.apply(this, arguments);
      }
      return init;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function () {
      var _updateTimingObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(timingObject, player) {
        var _yield$Promise$all, _yield$Promise$all2, position, isPaused, playbackRate;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return Promise.all([player.getCurrentTime(), player.getPaused(), player.getPlaybackRate()]);
            case 2:
              _yield$Promise$all = _context3.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
              position = _yield$Promise$all2[0];
              isPaused = _yield$Promise$all2[1];
              playbackRate = _yield$Promise$all2[2];
              timingObject.update({
                position: position,
                velocity: isPaused ? 0 : playbackRate
              });
            case 8:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function updateTimingObject(_x6, _x7) {
        return _updateTimingObject.apply(this, arguments);
      }
      return updateTimingObject;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function () {
      var _updatePlayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
        var _timingObject$query, position, velocity;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
              if (typeof position === 'number') {
                player.setCurrentTime(position);
              }
              if (!(typeof velocity === 'number')) {
                _context5.next = 25;
                break;
              }
              if (!(velocity === 0)) {
                _context5.next = 11;
                break;
              }
              _context5.next = 6;
              return player.getPaused();
            case 6:
              _context5.t0 = _context5.sent;
              if (!(_context5.t0 === false)) {
                _context5.next = 9;
                break;
              }
              player.pause();
            case 9:
              _context5.next = 25;
              break;
            case 11:
              if (!(velocity > 0)) {
                _context5.next = 25;
                break;
              }
              _context5.next = 14;
              return player.getPaused();
            case 14:
              _context5.t1 = _context5.sent;
              if (!(_context5.t1 === true)) {
                _context5.next = 19;
                break;
              }
              _context5.next = 18;
              return player.play().catch( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(err) {
                  return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        if (!(err.name === 'NotAllowedError' && options.autoPlayMuted)) {
                          _context4.next = 5;
                          break;
                        }
                        _context4.next = 3;
                        return player.setMuted(true);
                      case 3:
                        _context4.next = 5;
                        return player.play().catch(function (err2) {
                          return console.error('Couldn\'t play the video from TimingSrcConnector. Error:', err2);
                        });
                      case 5:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                }));
                return function (_x11) {
                  return _ref2.apply(this, arguments);
                };
              }());
            case 18:
              this.updatePlayer(timingObject, player, options);
            case 19:
              _context5.next = 21;
              return player.getPlaybackRate();
            case 21:
              _context5.t2 = _context5.sent;
              _context5.t3 = velocity;
              if (!(_context5.t2 !== _context5.t3)) {
                _context5.next = 25;
                break;
              }
              player.setPlaybackRate(velocity);
            case 25:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updatePlayer(_x8, _x9, _x10) {
        return _updatePlayer.apply(this, arguments);
      }
      return updatePlayer;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function maintainPlaybackPosition(timingObject, player, options) {
      var _this3 = this;
      var allowedDrift = options.allowedDrift,
        maxAllowedDrift = options.maxAllowedDrift,
        minCheckInterval = options.minCheckInterval,
        maxRateAdjustment = options.maxRateAdjustment,
        maxTimeToCatchUp = options.maxTimeToCatchUp;
      var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
      var check = /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          var diff, diffAbs, min, max, adjustment;
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.t0 = timingObject.query().velocity === 0;
                if (_context6.t0) {
                  _context6.next = 6;
                  break;
                }
                _context6.next = 4;
                return player.getPaused();
              case 4:
                _context6.t1 = _context6.sent;
                _context6.t0 = _context6.t1 === true;
              case 6:
                if (!_context6.t0) {
                  _context6.next = 8;
                  break;
                }
                return _context6.abrupt("return");
              case 8:
                _context6.t2 = timingObject.query().position;
                _context6.next = 11;
                return player.getCurrentTime();
              case 11:
                _context6.t3 = _context6.sent;
                diff = _context6.t2 - _context6.t3;
                diffAbs = Math.abs(diff);
                _this3.log("Drift: ".concat(diff));
                if (!(diffAbs > maxAllowedDrift)) {
                  _context6.next = 22;
                  break;
                }
                _context6.next = 18;
                return _this3.adjustSpeed(player, 0);
              case 18:
                player.setCurrentTime(timingObject.query().position);
                _this3.log('Resync by currentTime');
                _context6.next = 29;
                break;
              case 22:
                if (!(diffAbs > allowedDrift)) {
                  _context6.next = 29;
                  break;
                }
                min = diffAbs / maxTimeToCatchUp;
                max = maxRateAdjustment;
                adjustment = min < max ? (max - min) / 2 : max;
                _context6.next = 28;
                return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
              case 28:
                _this3.log('Resync by playbackRate');
              case 29:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function check() {
          return _ref3.apply(this, arguments);
        };
      }();
      var interval = setInterval(function () {
        return check();
      }, syncInterval);
      return {
        cancel: function cancel() {
          return clearInterval(interval);
        }
      };
    }

    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function log(msg) {
      var _this$logger;
      (_this$logger = this.logger) === null || _this$logger === void 0 ? void 0 : _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
    }
  }, {
    key: "waitForTOReadyState",
    value:
    /**
     * @param {TimingObject} timingObject
     * @param {TConnectionState} state
     * @return {Promise<void>}
     */
    function waitForTOReadyState(timingObject, state) {
      return new Promise(function (resolve) {
        var check = function check() {
          if (timingObject.readyState === state) {
            resolve();
          } else {
            timingObject.addEventListener('readystatechange', check, {
              once: true
            });
          }
        };
        check();
      });
    }
  }]);
  return TimingSrcConnector;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

var playerMap = new WeakMap();
var readyMap = new WeakMap();
var screenfull = {};
var Player = /*#__PURE__*/function () {
  /**
   * Create a Player.
   *
   * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
   *        player iframe, and id, or a jQuery object.
   * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
   * @return {Player}
   */
  function Player(element) {
    var _this = this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Player);
    /* global jQuery */
    if (window.jQuery && element instanceof jQuery) {
      if (element.length > 1 && window.console && console.warn) {
        console.warn('A jQuery object with multiple elements was passed, using the first element.');
      }
      element = element[0];
    }

    // Find an element by ID
    if (typeof document !== 'undefined' && typeof element === 'string') {
      element = document.getElementById(element);
    }

    // Not an element!
    if (!isDomElement(element)) {
      throw new TypeError('You must pass either a valid element or a valid id.');
    }

    // Already initialized an embed in this div, so grab the iframe
    if (element.nodeName !== 'IFRAME') {
      var iframe = element.querySelector('iframe');
      if (iframe) {
        element = iframe;
      }
    }

    // iframe url is not a Vimeo url
    if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
      throw new Error('The player element passed isn’t a Vimeo embed.');
    }

    // If there is already a player object in the map, return that
    if (playerMap.has(element)) {
      return playerMap.get(element);
    }
    this._window = element.ownerDocument.defaultView;
    this.element = element;
    this.origin = '*';
    var readyPromise = new npo_src(function (resolve, reject) {
      _this._onMessage = function (event) {
        if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
          return;
        }
        if (_this.origin === '*') {
          _this.origin = event.origin;
        }
        var data = parseMessageData(event.data);
        var isError = data && data.event === 'error';
        var isReadyError = isError && data.data && data.data.method === 'ready';
        if (isReadyError) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          reject(error);
          return;
        }
        var isReadyEvent = data && data.event === 'ready';
        var isPingResponse = data && data.method === 'ping';
        if (isReadyEvent || isPingResponse) {
          _this.element.setAttribute('data-ready', 'true');
          resolve();
          return;
        }
        processData(_this, data);
      };
      _this._window.addEventListener('message', _this._onMessage);
      if (_this.element.nodeName !== 'IFRAME') {
        var params = getOEmbedParameters(element, options);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          var iframe = createEmbed(data, element);
          // Overwrite element with the new iframe,
          // but store reference to the original element
          _this.element = iframe;
          _this._originalElement = element;
          swapCallbacks(element, iframe);
          playerMap.set(_this.element, _this);
          return data;
        }).catch(reject);
      }
    });

    // Store a copy of this Player in the map
    readyMap.set(this, readyPromise);
    playerMap.set(this.element, this);

    // Send a ping to the iframe so the ready promise will be resolved if
    // the player is already ready.
    if (this.element.nodeName === 'IFRAME') {
      postMessage(this, 'ping');
    }
    if (screenfull.isEnabled) {
      var exitFullscreen = function exitFullscreen() {
        return screenfull.exit();
      };
      this.fullscreenchangeHandler = function () {
        if (screenfull.isFullscreen) {
          storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        } else {
          removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
        }
        // eslint-disable-next-line
        _this.ready().then(function () {
          postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
        });
      };
      screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
    }
    return this;
  }

  /**
   * Check to see if the URL is a Vimeo URL.
   *
   * @param {string} url The URL string.
   * @return {boolean}
   */
  _createClass(Player, [{
    key: "callMethod",
    value:
    /**
     * Get a promise for a method.
     *
     * @param {string} name The API method to call.
     * @param {...(string|number|object|Array)} args Arguments to send via postMessage.
     * @return {Promise}
     */
    function callMethod(name) {
      var _this2 = this;
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (name === undefined || name === null) {
        throw new TypeError('You must pass a method name.');
      }
      return new npo_src(function (resolve, reject) {
        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        return _this2.ready().then(function () {
          storeCallback(_this2, name, {
            resolve: resolve,
            reject: reject
          });
          if (args.length === 0) {
            args = {};
          } else if (args.length === 1) {
            args = args[0];
          }
          postMessage(_this2, name, args);
        }).catch(reject);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function get(name) {
      var _this3 = this;
      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'get');

        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        return _this3.ready().then(function () {
          storeCallback(_this3, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this3, name);
        }).catch(reject);
      });
    }

    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function set(name, value) {
      var _this4 = this;
      return new npo_src(function (resolve, reject) {
        name = getMethodName(name, 'set');
        if (value === undefined || value === null) {
          throw new TypeError('There must be a value to set.');
        }

        // We are storing the resolve/reject handlers to call later, so we
        // can’t return here.
        return _this4.ready().then(function () {
          storeCallback(_this4, name, {
            resolve: resolve,
            reject: reject
          });
          postMessage(_this4, name, value);
        }).catch(reject);
      });
    }

    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function on(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }
      if (!callback) {
        throw new TypeError('You must pass a callback function.');
      }
      if (typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }
      var callbacks = getCallbacks(this, "event:".concat(eventName));
      if (callbacks.length === 0) {
        this.callMethod('addEventListener', eventName).catch(function () {
          // Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
      storeCallback(this, "event:".concat(eventName), callback);
    }

    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function off(eventName, callback) {
      if (!eventName) {
        throw new TypeError('You must pass an event name.');
      }
      if (callback && typeof callback !== 'function') {
        throw new TypeError('The callback must be a function.');
      }
      var lastCallback = removeCallback(this, "event:".concat(eventName), callback);

      // If there are no callbacks left, remove the listener
      if (lastCallback) {
        this.callMethod('removeEventListener', eventName).catch(function (e) {
          // Ignore the error. There will be an error event fired that
          // will trigger the error callback if they are listening.
        });
      }
    }

    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function loadVideo(options) {
      return this.callMethod('loadVideo', options);
    }

    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function ready() {
      var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
        reject(new Error('Unknown player. Probably unloaded.'));
      });
      return npo_src.resolve(readyPromise);
    }

    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function addCuePoint(time) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.callMethod('addCuePoint', {
        time: time,
        data: data
      });
    }

    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function removeCuePoint(id) {
      return this.callMethod('removeCuePoint', id);
    }

    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function enableTextTrack(language, kind) {
      if (!language) {
        throw new TypeError('You must pass a language.');
      }
      return this.callMethod('enableTextTrack', {
        language: language,
        kind: kind
      });
    }

    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function disableTextTrack() {
      return this.callMethod('disableTextTrack');
    }

    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function pause() {
      return this.callMethod('pause');
    }

    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function play() {
      return this.callMethod('play');
    }

    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function requestFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.request(this.element);
      }
      return this.callMethod('requestFullscreen');
    }

    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (screenfull.isEnabled) {
        return screenfull.exit();
      }
      return this.callMethod('exitFullscreen');
    }

    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function getFullscreen() {
      if (screenfull.isEnabled) {
        return npo_src.resolve(screenfull.isFullscreen);
      }
      return this.get('fullscreen');
    }

    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function requestPictureInPicture() {
      return this.callMethod('requestPictureInPicture');
    }

    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function exitPictureInPicture() {
      return this.callMethod('exitPictureInPicture');
    }

    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function getPictureInPicture() {
      return this.get('pictureInPicture');
    }

    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function remotePlaybackPrompt() {
      return this.callMethod('remotePlaybackPrompt');
    }

    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function unload() {
      return this.callMethod('unload');
    }

    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function destroy() {
      var _this5 = this;
      return new npo_src(function (resolve) {
        readyMap.delete(_this5);
        playerMap.delete(_this5.element);
        if (_this5._originalElement) {
          playerMap.delete(_this5._originalElement);
          _this5._originalElement.removeAttribute('data-vimeo-initialized');
        }
        if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
          // If we've added an additional wrapper div, remove that from the DOM.
          // If not, just remove the iframe element.
          if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
            _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
          } else {
            _this5.element.parentNode.removeChild(_this5.element);
          }
        }

        // If the clip is private there is a case where the element stays the
        // div element. Destroy should reset the div and remove the iframe child.
        if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
          _this5.element.removeAttribute('data-vimeo-initialized');
          var iframe = _this5.element.querySelector('iframe');
          if (iframe && iframe.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
              iframe.parentNode.parentNode.removeChild(iframe.parentNode);
            } else {
              iframe.parentNode.removeChild(iframe);
            }
          }
        }
        _this5._window.removeEventListener('message', _this5._onMessage);
        if (screenfull.isEnabled) {
          screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
        }
        resolve();
      });
    }

    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function getAutopause() {
      return this.get('autopause');
    }

    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function setAutopause(autopause) {
      return this.set('autopause', autopause);
    }

    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function getBuffered() {
      return this.get('buffered');
    }

    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function getCameraProps() {
      return this.get('cameraProps');
    }

    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function setCameraProps(camera) {
      return this.set('cameraProps', camera);
    }

    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function getChapters() {
      return this.get('chapters');
    }

    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function getCurrentChapter() {
      return this.get('currentChapter');
    }

    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function getColor() {
      return this.get('color');
    }

    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function getColors() {
      return npo_src.all([this.get('colorOne'), this.get('colorTwo'), this.get('colorThree'), this.get('colorFour')]);
    }

    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function setColor(color) {
      return this.set('color', color);
    }

    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function setColors(colors) {
      if (!Array.isArray(colors)) {
        return new npo_src(function (resolve, reject) {
          return reject(new TypeError('Argument must be an array.'));
        });
      }
      var nullPromise = new npo_src(function (resolve) {
        return resolve(null);
      });
      var colorPromises = [colors[0] ? this.set('colorOne', colors[0]) : nullPromise, colors[1] ? this.set('colorTwo', colors[1]) : nullPromise, colors[2] ? this.set('colorThree', colors[2]) : nullPromise, colors[3] ? this.set('colorFour', colors[3]) : nullPromise];
      return npo_src.all(colorPromises);
    }

    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function getCuePoints() {
      return this.get('cuePoints');
    }

    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function getCurrentTime() {
      return this.get('currentTime');
    }

    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function setCurrentTime(currentTime) {
      return this.set('currentTime', currentTime);
    }

    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function getDuration() {
      return this.get('duration');
    }

    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function getEnded() {
      return this.get('ended');
    }

    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function getLoop() {
      return this.get('loop');
    }

    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function setLoop(loop) {
      return this.set('loop', loop);
    }

    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function setMuted(muted) {
      return this.set('muted', muted);
    }

    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function getMuted() {
      return this.get('muted');
    }

    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function getPaused() {
      return this.get('paused');
    }

    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function getPlaybackRate() {
      return this.get('playbackRate');
    }

    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function setPlaybackRate(playbackRate) {
      return this.set('playbackRate', playbackRate);
    }

    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function getPlayed() {
      return this.get('played');
    }

    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function getQualities() {
      return this.get('qualities');
    }

    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function getQuality() {
      return this.get('quality');
    }

    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function setQuality(quality) {
      return this.set('quality', quality);
    }

    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function getRemotePlaybackAvailability() {
      return this.get('remotePlaybackAvailability');
    }

    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function getRemotePlaybackState() {
      return this.get('remotePlaybackState');
    }

    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function getSeekable() {
      return this.get('seekable');
    }

    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function getSeeking() {
      return this.get('seeking');
    }

    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function getTextTracks() {
      return this.get('textTracks');
    }

    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function getVideoEmbedCode() {
      return this.get('videoEmbedCode');
    }

    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function getVideoId() {
      return this.get('videoId');
    }

    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function getVideoTitle() {
      return this.get('videoTitle');
    }

    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function getVideoWidth() {
      return this.get('videoWidth');
    }

    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function getVideoHeight() {
      return this.get('videoHeight');
    }

    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function getVideoUrl() {
      return this.get('videoUrl');
    }

    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function getVolume() {
      return this.get('volume');
    }

    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function setVolume(volume) {
      return this.set('volume', volume);
    }

    /** @typedef {import('timing-object').ITimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */

    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function () {
      var _setTimingSrc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(timingObject, options) {
        var _this6 = this;
        var connector;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (timingObject) {
                _context.next = 2;
                break;
              }
              throw new TypeError('A Timing Object must be provided.');
            case 2:
              _context.next = 4;
              return this.ready();
            case 4:
              connector = new TimingSrcConnector(this, timingObject, options);
              postMessage(this, 'notifyTimingObjectConnect');
              connector.addEventListener('disconnect', function () {
                return postMessage(_this6, 'notifyTimingObjectDisconnect');
              });
              return _context.abrupt("return", connector);
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function setTimingSrc(_x, _x2) {
        return _setTimingSrc.apply(this, arguments);
      }
      return setTimingSrc;
    }()
  }], [{
    key: "isVimeoUrl",
    value: function isVimeoUrl$1(url) {
      return isVimeoUrl(url);
    }
  }]);
  return Player;
}(); // Setup embed only if this is not a server runtime
if (!isServerRuntime) {
  screenfull = initializeScreenfull();
  initializeEmbeds();
  resizeEmbeds();
  initAppendVideoMetadata();
  checkUrlTimeParam();
  updateDRMEmbeds();
}

/* harmony default export */ __webpack_exports__["a"] = (Player);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(31), __webpack_require__(356).setImmediate))

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers_getUrlVars__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_tabInfo__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Vimeo=(_temp=_class=function(_React$Component){_inherits(Vimeo,_React$Component);function Vimeo(){_classCallCheck(this,Vimeo);return _possibleConstructorReturn(this,(Vimeo.__proto__||Object.getPrototypeOf(Vimeo)).apply(this,arguments));}_createClass(Vimeo,[{key:'componentWillMount',value:function componentWillMount(){var getParams=Object(__WEBPACK_IMPORTED_MODULE_1__helpers_getUrlVars__["a" /* default */])();if(getParams.windowTitle&&getParams.windowTitle!=='null'){__WEBPACK_IMPORTED_MODULE_2__helpers_tabInfo__["a" /* default */].setWindowTitle(decodeURIComponent(getParams.windowTitle));}if(getParams.faviconUrl&&getParams.faviconUrl!=='null'){__WEBPACK_IMPORTED_MODULE_2__helpers_tabInfo__["a" /* default */].setFavicon(decodeURIComponent(getParams.faviconUrl));}}},{key:'render',value:function render(){var desktop=this.props.desktop;var url=decodeURIComponent(Object(__WEBPACK_IMPORTED_MODULE_1__helpers_getUrlVars__["a" /* default */])()['url']);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:desktop?'portal-vimeo portal-home darkBckg':'portal-vimeo portal-home darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'vimeo-player'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('iframe',{title:'drive-player',src:url,style:{border:'none'},allowfullscreen:'allowfullscreen'}))));}}]);return Vimeo;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Vimeo);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_react__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_video_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_getUrlVars__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers_tabInfo__ = __webpack_require__(85);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Video=(_temp=_class=function(_React$Component){_inherits(Video,_React$Component);function Video(props){_classCallCheck(this,Video);var _this=_possibleConstructorReturn(this,(Video.__proto__||Object.getPrototypeOf(Video)).call(this,props));_this.minimizeVid=function(e){if(document.exitFullscreen){document.exitFullscreen();}else if(document.mozCancelFullScreen){document.mozCancelFullScreen();}else if(document.webkitExitFullscreen){document.webkitExitFullscreen();}else if(document.msExitFullscreen){document.msExitFullscreen();}};_this.state={gameMaterial:null,isFullscreen:false};return _this;}_createClass(Video,[{key:'componentWillMount',value:function componentWillMount(){this.fetchMaterials();var getParams=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getUrlVars__["a" /* default */])();if(getParams.windowTitle&&getParams.windowTitle!=='null'){__WEBPACK_IMPORTED_MODULE_4__helpers_tabInfo__["a" /* default */].setWindowTitle(decodeURIComponent(getParams.windowTitle));}if(getParams.faviconUrl&&getParams.faviconUrl!=='null'){__WEBPACK_IMPORTED_MODULE_4__helpers_tabInfo__["a" /* default */].setFavicon(decodeURIComponent(getParams.faviconUrl));}if(getParams.backgroundUrl&&getParams.backgroundUrl!=='null'){this.backgroundUrl=decodeURIComponent(getParams.backgroundUrl);}}},{key:'componentDidMount',value:function componentDidMount(){this.refs.player.subscribeToStateChange(this.handleStateChange.bind(this));}},{key:'handleStateChange',value:function handleStateChange(state){var isFullscreen=this.state.isFullscreen;if(state.isFullscreen!==isFullscreen){this.setState({isFullscreen:state.isFullscreen});}}},{key:'fetchMaterials',value:function fetchMaterials(){var _this2=this;var videoId=this.props.match.params.videoId;var getParams=Object(__WEBPACK_IMPORTED_MODULE_3__helpers_getUrlVars__["a" /* default */])();if(getParams.publicMaterialId&&getParams.publicMaterialId!=='null'){Object(__WEBPACK_IMPORTED_MODULE_2__apiCall__["a" /* default */])('/file/generalMaterial/'+getParams.publicMaterialId,null,'GET').then(function(material){_this2.setState({gameMaterial:material.Material});});}else{Object(__WEBPACK_IMPORTED_MODULE_2__apiCall__["a" /* default */])('/file/'+videoId,null,'GET').then(function(material){_this2.setState({gameMaterial:material});});}}},{key:'render',value:function render(){var _this3=this;var _state=this.state,gameMaterial=_state.gameMaterial,isFullscreen=_state.isFullscreen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:this.backgroundUrl?{backgroundImage:'url('+this.backgroundUrl+')',backgroundSize:'cover',backgroundPosition:'center'}:{},className:this.props.desktop?'portal-vimeo portal-home darkBckg'+(this.backgroundUrl?' custom-background':''):'portal-vimeo portal-home darkBckg'+(this.backgroundUrl?' custom-background':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container video-container-begeleider'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_video_react__["Player"],{autoPlay:false,muted:false,onEnded:function onEnded(e){return _this3.minimizeVid(e);},className:'videoframe '+(isFullscreen?' fullscreen':''),ref:'player',src:gameMaterial?gameMaterial.url:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_video_react__["ControlBar"],{autoHide:isFullscreen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_video_react__["VolumeMenuButton"],{vertical:true})))));}}]);return Video;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Video);

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_getUrlVars__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_forward_10_svg__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_forward_10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_forward_10_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_replay_10_svg__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_replay_10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_replay_10_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Audio=(_temp=_class=function(_React$Component){_inherits(Audio,_React$Component);function Audio(props){_classCallCheck(this,Audio);var _this=_possibleConstructorReturn(this,(Audio.__proto__||Object.getPrototypeOf(Audio)).call(this,props));_this.scrubAudio=function(time){_this.refs.audio.currentTime+=time;};_this.state={gameMaterial:null};return _this;}_createClass(Audio,[{key:'componentWillMount',value:function componentWillMount(){this.fetchMaterials();var getParams=Object(__WEBPACK_IMPORTED_MODULE_2__helpers_getUrlVars__["a" /* default */])();if(getParams.windowTitle&&getParams.windowTitle!=='null'){__WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__["a" /* default */].setWindowTitle(decodeURIComponent(getParams.windowTitle));}if(getParams.faviconUrl&&getParams.faviconUrl!=='null'){__WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__["a" /* default */].setFavicon(decodeURIComponent(getParams.faviconUrl));}}},{key:'fetchMaterials',value:function fetchMaterials(){var _this2=this;var audioId=this.props.match.params.audioId;Object(__WEBPACK_IMPORTED_MODULE_1__apiCall__["a" /* default */])('/file/'+audioId,null,'GET').then(function(material){_this2.setState({gameMaterial:material});});}},{key:'render',value:function render(){var _this3=this;var gameMaterial=this.state.gameMaterial;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.desktop?'portal-vimeo portal-home darkBckg':'portal-vimeo portal-home darkBckg'},gameMaterial&&gameMaterial.url?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"portal-audio-container",style:{display:'flex',justifyContent:'center',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{style:{margin:"0 auto"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{textAlign:'center',marginBottom:"20px"}},gameMaterial.filename),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('audio',{ref:'audio',controls:true,autoPlay:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:gameMaterial.url})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'countdown-controls'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{cursor:"pointer"},className:'icon',onClick:function onClick(){return _this3.scrubAudio(-10);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_replay_10_svg___default.a,alt:"rewind"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{cursor:"pointer"},className:'icon',onClick:function onClick(){return _this3.scrubAudio(10);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_forward_10_svg___default.a,alt:"fast forward"}))))):null);}}]);return Audio;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Audio);

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/forward-10.b43a7473.svg";

/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/replay-10.2df076ff.svg";

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_assets_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_visible_png__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_visible_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_visible_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_invisible_png__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_invisible_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_invisible_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_TopBar__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__auth__ = __webpack_require__(288);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var auth=new __WEBPACK_IMPORTED_MODULE_1_glxl_helpers__["Authorization"]();var Password=(_temp=_class=function(_React$Component){_inherits(Password,_React$Component);function Password(props){_classCallCheck(this,Password);var _this=_possibleConstructorReturn(this,(Password.__proto__||Object.getPrototypeOf(Password)).call(this,props));_this.handleChange=function(ev){_this.setState(_defineProperty({},ev.target.name,ev.target.value));};_this.handleCompleted=function(){window.open(_this.state.generalMaterial.alternateUrl,"_blank");};_this.handleSubmit=function(ev,fieldName){ev.preventDefault();ev.stopPropagation();if(fieldName==='password'){var correct=_this.state.generalMaterial.password===_this.state.password;_this.setState({passwordCorrect:correct,wrongPassword:!correct});if(correct&&!_this.state.generalMaterial.secondPassword){_this.handleCompleted();}}else if(fieldName==='secondPassword'){var _correct=_this.state.generalMaterial.secondPassword===_this.state.secondPassword;_this.setState({secondPasswordCorrect:_correct,wrongSecondPassword:!_correct});if(_correct){_this.handleCompleted();}}return false;};_this.state={secondPasswordCorrect:false,passwordCorrect:false,wrongSecondPassword:false,wrongPassword:false,password:'',secondPassword:'',generalMaterial:null,passwordVisibility:false,secondPasswordVisibility:false,showTopbar:false};return _this;}_createClass(Password,[{key:'componentWillMount',value:function componentWillMount(){this.fetchGeneralMaterial();}},{key:'fetchGeneralMaterial',value:function fetchGeneralMaterial(){var _this2=this;var generalMaterialId=this.props.match.params.generalMaterialId;Object(__WEBPACK_IMPORTED_MODULE_2__apiCall__["a" /* default */])('/generalMaterial/'+generalMaterialId,null,'GET').then(function(generalMaterial){if(generalMaterial.windowTitle){__WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__["a" /* default */].setWindowTitle(generalMaterial.windowTitle);}if(generalMaterial.faviconUrl){__WEBPACK_IMPORTED_MODULE_3__helpers_tabInfo__["a" /* default */].setFavicon(generalMaterial.faviconUrl);}Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["e" /* setLocale */])(generalMaterial.Language.code);_this2.setState({generalMaterial:generalMaterial});var token=sessionStorage.getItem('token')||auth.getAuthToken();if(token){Object(__WEBPACK_IMPORTED_MODULE_2__apiCall__["a" /* default */])('/user/me',null,'GET',{},false).then(function(user){if(user&&user.id){_this2.setState({showTopbar:true});}else{if(!generalMaterial.isPublic){window.location.href='/login';}}}).catch(function(err){console.error(err.message);});}else{if(!generalMaterial.isPublic){window.location.href='/login';}}});}},{key:'render',value:function render(){var _this3=this;var generalMaterial=this.state.generalMaterial;var backgroundUrl=null;if(generalMaterial&&generalMaterial.Background&&generalMaterial.Background.url){backgroundUrl=generalMaterial.Background.url;}var AuthTopHeader=Object(__WEBPACK_IMPORTED_MODULE_10__auth__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__elements_TopBar__["a" /* default */],['groupleader','groupmember','classleader'],null,{"desktop":!!this.props.desktop});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:backgroundUrl?{backgroundImage:'url('+backgroundUrl+')',backgroundSize:'cover',backgroundPosition:'center'}:{},className:this.props.desktop?'portal-vimeo portal-home darkBckg'+(backgroundUrl?' custom-background':''):'portal-vimeo portal-home darkBckg'+(backgroundUrl?' custom-background':'')},generalMaterial&&generalMaterial.id?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{margin:'0 auto',paddingLeft:'15px',paddingRight:'15px',position:'absolute',left:0,right:0,top:'50%',transform:'translateY(-50%)'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(ev){return _this3.handleSubmit(ev,"password");},action:'#',method:'GET',style:{display:'flex',justifyContent:'center',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__["a" /* default */],{style:{margin:'0 auto',width:'100%',maxWidth:'450px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{textAlign:'center',marginBottom:"20px",fontWeight:'bold'}},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_wachtwoord").toUpperCase()+(this.state.generalMaterial.secondPassword?' 1:':':')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-container',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:this.state.passwordCorrect,type:this.state.passwordVisibility?'text':'password',placeholder:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_wachtwoord"),name:'password',onChange:this.handleChange,value:this.state.password}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'password-visibility-container',style:{background:'transparent',height:'40px',position:'absolute',right:0,top:0,borderRadius:'16px',display:'flex',padding:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.passwordVisibility?__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_visible_png___default.a:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_invisible_png___default.a,alt:'toggle visibility',onClick:function onClick(){_this3.setState({passwordVisibility:!_this3.state.passwordVisibility});},style:{width:'20px',justifySelf:'center',alignSelf:'center',cursor:'pointer'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:'center',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{margin:0},type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_versturen'))),this.state.passwordCorrect?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'20px',position:'absolute',left:'calc((100% / 2) + 85px)'},src:__WEBPACK_IMPORTED_MODULE_6__assets_assets_js__["d" /* icons */].check,alt:'check'}):null),this.state.wrongPassword?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-failed',style:{color:'red',marginTop:'10px',textAlign:'center'}},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_password_wrong_password')):null)),this.state.generalMaterial.secondPassword?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form',{onSubmit:function onSubmit(ev){return _this3.handleSubmit(ev,"secondPassword");},action:'#',method:'GET',style:{display:'flex',justifyContent:'center',alignItems:'center',marginTop:'20px',opacity:this.state.passwordCorrect?1:0,pointerEvents:this.state.passwordCorrect?'initial':'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__["a" /* default */],{style:{margin:'0 auto',width:'100%',maxWidth:'450px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{style:{textAlign:'center',marginBottom:"20px",fontWeight:'bold'}},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_wachtwoord").toUpperCase()+' 2:'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'input-container',style:{position:'relative'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{disabled:this.state.secondPasswordCorrect,type:this.state.secondPasswordVisibility?'text':'password',placeholder:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_wachtwoord"),name:'secondPassword',onChange:this.handleChange,value:this.state.secondPassword}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'password-visibility-container',style:{background:'transparent',height:'40px',position:'absolute',right:0,top:0,borderRadius:'16px',display:'flex',padding:8}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.state.secondPasswordVisibility?__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_visible_png___default.a:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_invisible_png___default.a,alt:'toggle visibility',onClick:function onClick(){_this3.setState({secondPasswordVisibility:!_this3.state.secondPasswordVisibility});},style:{width:'20px',justifySelf:'center',alignSelf:'center',cursor:'pointer'}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'flex',alignItems:'center',justifyContent:'center',marginTop:'20px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{margin:0},type:'submit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_versturen'))),this.state.secondPasswordCorrect?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{style:{width:'20px',position:'absolute',left:'calc((100% / 2) + 85px)'},src:__WEBPACK_IMPORTED_MODULE_6__assets_assets_js__["d" /* icons */].check,alt:'check'}):null),this.state.wrongSecondPassword?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'login-failed',style:{color:'red',marginTop:'10px',textAlign:'center'}},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_password_wrong_password')):null)):null):null));}}]);return Password;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Password);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ScoreRow__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_team_svg__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_groupHelper__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupPortalHome=(_temp=_class=function(_Component){_inherits(GroupPortalHome,_Component);function GroupPortalHome(props){var _this2=this;_classCallCheck(this,GroupPortalHome);var _this=_possibleConstructorReturn(this,(GroupPortalHome.__proto__||Object.getPrototypeOf(GroupPortalHome)).call(this,props));_this.fetchMyRank=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/group/myRank',null,'GET').then(function(_ref2){var schoolClassRank=_ref2.schoolClassRank,schoolRank=_ref2.schoolRank,totalPoints=_ref2.totalPoints;_this.setState({schoolClassRank:schoolClassRank,schoolRank:schoolRank,totalPoints:totalPoints});});case 1:case'end':return _context.stop();}}},_callee,_this2);}));_this.togglePopup=function(){_this.setState({showPopUp:!_this.state.showPopUp});};_this.renderGameButtons=function(){var schoolClass=_this.props.schoolClass;// Get games from my schoolClass
if(!Array.isArray(schoolClass.SchoolClassGames))return null;var games=schoolClass.SchoolClassGames.reduce(function(arr,val){// Ignore Simulationgame as it has a custom button
if(val.Game.abbreviation!=='SS'&&val.Game.abbreviation!=='BO')arr.push(val.Game);return arr;},[]);// Render game buttons
return games.map(function(g){var curGame=__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].gameLogos.find(function(game){return game.id===g.id;});var hasGamePage=__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].gamePageGames.findIndex(function(game){return game.id===g.id;});var hasGamePageContent=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_popupHelper__["g" /* getPopupCurrentGame */])(g.abbreviation)!==false;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{key:g.id,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(g.name),subtitle:''+(_this.props.project.EducationProject.nameShort==='GLXL'?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas_verdienen'):''),icon:curGame.logo,className:'gameButton opacity',onClick:function onClick(){if(hasGamePage>-1&&hasGamePageContent){return _this.props.history.push('/portal/gameinfo/'+g.id);}}});});};_this.state={schoolRank:'-',schoolClassRank:'-',totalPoints:'-',showPopUp:false};_this.togglePopup=_this.togglePopup.bind(_this);return _this;}_createClass(GroupPortalHome,[{key:'componentWillMount',value:function componentWillMount(){this.fetchMyRank();window.socket.on('finishedSimulationStep',this.fetchMyRank);window.socket.on('activate',this.fetchMyRank);}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,project=_props.project,gameState=_props.gameState;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(project.EducationProject.nameShort==='GLXL'&&currentRound<=1){Object(__WEBPACK_IMPORTED_MODULE_9__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtintro_welkom':'mlgvtintro_welkom',dispatch);}}/**
   * Render game buttons using redux state data
   */},{key:'render',value:function render(){var _this3=this;var bonus=this.props.schoolClass.SchoolClassGames.find(function(g){return g.Game.abbreviation==='BO';});var simGame=__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].gameLogos.find(function(game){return game.abbreviation.toLowerCase()==='ss';});var boGame=__WEBPACK_IMPORTED_MODULE_8__Defines__["a" /* default */].gameLogos.find(function(game){return game.abbreviation.toLowerCase()==='bo';});var showPopUp=this.state.showPopUp;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-home class-portal '+(this.props.project.EducationProject.nameShort==='GLXL'?'':'non-glxl')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},this.props.project.EducationProject.nameShort==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-container'},this.props.gameState.hideScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{className:'disabled-scores-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'disabled-scores'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_tussenstand_uitgeschakeld'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_puntentotaal'),score:this.state.totalPoints||0,showArrow:true,to:'/portal/teaminfo'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_ranglijst_school'),score:this.state.schoolRank||0,showMedal:true,showArrow:true,to:'/portal/rankings/'+this.props.group.ProjectId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_ranglijst_klas'),score:this.state.schoolClassRank||0,showMedal:true,showArrow:true,to:'/portal/rankings/'+this.props.group.ProjectId+'/'+this.props.group.SchoolClassId}))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'list-button-container'},this.props.project.EducationProject.nameShort==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_team_info'),subtitle:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gegevens_en_scores'),icon:Object(__WEBPACK_IMPORTED_MODULE_13__helpers_groupHelper__["a" /* getGroupAvatarUrl */])(this.props.group,this.props.project,__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_economy_team_svg___default.a),className: true?' with-avatar-icon':'',onClick:function onClick(){_this3.props.history.push('/portal/teaminfo');}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_land_besturen'),subtitle:''+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas_verdelen'),icon:simGame.logo,className:'gameButton opacity',onClick:function onClick(){if(!_this3.props.gameState.simGameActive&&_this3.props.gameState.currentRound<=4||_this3.props.gameStateInput.processingStepThree!==false){_this3.togglePopup();}else{window.location.href=_this3.props.gameState.simGameEntry;}}})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_spel',0))),this.renderGameButtons(),bonus?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_extra_opdrachten'),subtitle:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bonuspunten'),icon:boGame.logo,className:'gameButton opacity',onClick:function onClick(){_this3.props.history.push('/portal/bonuspoints');}}):'',showPopUp?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopUp__["a" /* default */],{popUpFooter:true,id:['SIMULATION_SPENDING','END'].includes(this.props.gameState.roundData.state)?'dlgmlandbesturen_1':'mlgmlandbesturen',closePopUpClick:this.togglePopup}):null))));}}]);return GroupPortalHome;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{user:state.user,project:state.project,group:state.group,schoolClass:state.schoolClass,gameState:state.gameState,feedBack:state.feedBack,gameStateInput:state.gameStateInput};})(GroupPortalHome));

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_RankingRow__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Loading__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_groupHelper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__config__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClassLeaderPortalHome=(_temp=_class=function(_Component){_inherits(ClassLeaderPortalHome,_Component);function ClassLeaderPortalHome(props){var _this2=this;_classCallCheck(this,ClassLeaderPortalHome);var _this=_possibleConstructorReturn(this,(ClassLeaderPortalHome.__proto__||Object.getPrototypeOf(ClassLeaderPortalHome)).call(this,props));_this.updateSchoolClassFilter=function(f){_this.setState({schoolClassFilter:f});};_this.renderTitle=function(){return _this.state.schoolClassFilter?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtteams',tag:'h3'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_tussenstand'));};_this.renderGameButtons=function(){var schoolClass=_this.props.schoolClass;if(!Array.isArray(schoolClass.SchoolClassGames))return null;var games=schoolClass.SchoolClassGames.reduce(function(arr,val){if(val.Game.abbreviation!=='SS'&&val.Game.abbreviation!=='BO')arr.push(val.Game);return arr;},[]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},_this.props.project.EducationProject.nameShort==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtverdienen',tag:'h3'}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_spel',0)))),games.map(function(g){var curGame=__WEBPACK_IMPORTED_MODULE_15__Defines__["a" /* default */].gameLogos.find(function(game){return game.id===g.id;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{key:g.id,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(g.name),icon:curGame.logo,className:'opacity gameButton',onClick:function onClick(){_this.props.history.push('/portal/classleader/verdienen/'+g.id);}});}));};_this.renderPrepareButton=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtvoorbereiding',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_voorbereiding_begeleider'),icon:__WEBPACK_IMPORTED_MODULE_11__assets_assets__["d" /* icons */].checklist,className:'opacity',onClick:function onClick(){_this.props.history.push('/portal/classleader/prepare');}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtopstart',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_opstart_project'),icon:__WEBPACK_IMPORTED_MODULE_11__assets_assets__["d" /* icons */].startup,className:'opacity',onClick:function onClick(){_this.props.history.push('/portal/classleader/prepare/startup');}})));};_this.renderGlobasVerdelenButton=function(){var curGame=__WEBPACK_IMPORTED_MODULE_15__Defines__["a" /* default */].gameLogos.find(function(game){return game.id===1;});console.log(curGame);if(curGame===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtverdelen',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_land_besturen'),icon:curGame.logo,className:'opacity gameButton',onClick:function onClick(){_this.props.history.push('/portal/classleader/verdelen');}}));};_this.renderBonusSection=function(){var schoolClass=_this.props.schoolClass;if(Array.isArray(schoolClass.SchoolClassGames)){if(schoolClass.SchoolClassGames.findIndex(function(g){return g.Game.abbreviation==='BO';})===-1){return null;}}var curGame=__WEBPACK_IMPORTED_MODULE_15__Defines__["a" /* default */].gameLogos.find(function(game){return game.abbreviation.toLowerCase()==='bo';});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtbonuspunten',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_extra_opdrachten'),icon:curGame.logo,className:'opacity',onClick:function onClick(){_this.props.history.push('/portal/classleader/bonuspoints');}}));};_this.renderFairawayButton=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtreizen',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_fairaway'),icon:__WEBPACK_IMPORTED_MODULE_11__assets_assets__["d" /* icons */].fairaway,className:'opacity',onClick:function onClick(){_this.props.history.push('/portal/classleader/prepare/fairaway');}}));};_this.renderOverigeButtons=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_PopupTitle__["a" /* default */],{popupId:_this.deviceAndDifficulty+'bvtfotosfilmpjes',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_fotos_uploaden',0),icon:__WEBPACK_IMPORTED_MODULE_11__assets_assets__["d" /* icons */].camera,className:'opacity',onClick:function onClick(){_this.props.history.push('/portal/classleader/media');}}),_this.props.project.festiveEndingInClass?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'festive-ending-btn',onClick:function onClick(){var token=(sessionStorage.getItem('token')||__WEBPACK_IMPORTED_MODULE_5_glxl_helpers__["cookie"].getCookie('token')||'').replace(/^Bearer\s+/i,'');var url=__WEBPACK_IMPORTED_MODULE_16__config___default.a.adminUrl+'/FestiveEnding/'+_this.props.project.id+'?standalone=1'+(token?'&token='+encodeURIComponent(token):'');window.open(url,'React','resizable=yes, scrollbars=yes, width=1451, height=920, left=300, top=200');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_prijsuitreiking'))):null);};_this.renderPDFButtons=function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pdf-button-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:_this.state.downloading.includes('groupStudentLogins')?'disabled':'',onClick:function onClick(){_this.downloadPdf('groupStudentLogins');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_pdf_logins_groepen'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:_this.state.downloading.includes('groupLayout')?'disabled':'',onClick:function onClick(){_this.downloadPdf('groupLayout');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_pdf_groepsindeling'))));};_this.renderTeams=function(){var schoolClassFilter=_this.state.schoolClassFilter;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button-section'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,_this.renderTitle()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:schoolClassFilter?'':'inactive',onClick:function onClick(){_this.updateSchoolClassFilter(true);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_klas',1))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:schoolClassFilter?'inactive':'',onClick:function onClick(){_this.updateSchoolClassFilter(false);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_school',1))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'ranking-rows-container'},_this.renderGroupRows()));};_this.downloadPdf=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(pdfType){var token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!_this.state.downloading.includes(pdfType)){_context.next=2;break;}return _context.abrupt('return',false);case 2:token=__WEBPACK_IMPORTED_MODULE_5_glxl_helpers__["cookie"].getCookie('token');window.open(__WEBPACK_IMPORTED_MODULE_16__config___default.a.apiUrl+'/pdf/'+pdfType+'/'+_this.props.schoolClass.id+'?authorization='+token,'_blank');case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.state={downloading:[],schoolClassFilter:true,schoolClasses:[]};_this.gameId=parseInt(_this.props.match.params.gameId,10);_this.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this.props.gameState.DefaultDifficultyId);return _this;}_createClass(ClassLeaderPortalHome,[{key:'componentWillMount',value:function componentWillMount(){var _this3=this;Object(__WEBPACK_IMPORTED_MODULE_6__apiCall__["a" /* default */])('/schoolClass/simGameSchoolClasses/'+this.props.project.id).then(function(schoolClasses){_this3.setState({schoolClasses:schoolClasses});});}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,project=_props.project,gameState=_props.gameState;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(currentRound<=1&&project.EducationProjectId===2){Object(__WEBPACK_IMPORTED_MODULE_13__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtintro_inleiding_T1':'mlbvtintro_inleiding_T1',dispatch);}}},{key:'renderGroupRows',value:function renderGroupRows(){var _this4=this;var schoolClasses=this.state.schoolClasses;var schoolClass=this.props.schoolClass;if(!schoolClasses.length)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_Loading__["a" /* default */],null);var groups=schoolClasses.reduce(function(acc,sc){return acc.concat(sc.Groups.map(function(g){return _extends({},g,{SchoolClass:sc});}));},[]).filter(function(g){return!_this4.state.schoolClassFilter||g.SchoolClassId===schoolClass.id;}).sort(function(a,b){return b.totalPoints-a.totalPoints;});return groups.map(function(grp,i){var to=grp.SchoolClassId===schoolClass.id;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_RankingRow__["a" /* default */],{key:grp.id,rank:i+1,title:grp.name,color:grp.GroupTheme.color,showSchoolClassName:!_this4.state.schoolClassFilter,className:grp.SchoolClass.className,points:grp.totalPoints||0,avatar:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_groupHelper__["a" /* getGroupAvatarUrl */])(grp,_this4.props.project,''),to:to?'/portal/classleader/teaminfo/'+grp.id:''});});}},{key:'render',value:function render(){if(!this.props.project.loaded||!this.props.gameState.loaded){return null;}var desktop=this.props.desktop;var projectType=this.props.project.EducationProject.nameShort;var hideScores=this.props.gameState.hideScores;if(desktop){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-home classleader-portal classleader-portal-home'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container '+(projectType!=='GLXL'?'overige-projecten':''),style:{maxWidth:'1252px'}},projectType==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},this.renderGlobasVerdelenButton(),this.renderGameButtons()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},this.renderPrepareButton(),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.renderFairawayButton(),this.renderBonusSection(),this.renderPDFButtons()))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},this.renderGameButtons()),projectType==='GLXL'?hideScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'column-portal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__["a" /* default */],{className:'button-section disabled-scores-container',style:{marginTop:'40px',marginBottom:'5px'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'disabled-scores'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_tussenstand_uitgeschakeld'))),this.renderOverigeButtons()):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"column-portal"},this.renderTeams(),this.renderOverigeButtons()):null));}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'classleader-portal-home'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,projectType==='GLXL'&&!hideScores?this.renderTeams():null,this.state.schoolClassFilter?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,projectType==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,hideScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__["a" /* default */],{className:'button-section disabled-scores-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'disabled-scores'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_tussenstand_uitgeschakeld'))):null,this.renderPrepareButton()):null,projectType==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.renderGlobasVerdelenButton(),this.renderGameButtons(),this.renderBonusSection(),this.renderFairawayButton(),this.renderOverigeButtons(),this.renderPDFButtons()):this.renderGameButtons()):null)));}}}]);return ClassLeaderPortalHome;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{project:state.project,schoolClass:state.schoolClass,gameState:state.gameState};})(ClassLeaderPortalHome));

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
var portalRedirect=function portalRedirect(props){var to=void 0;switch(props.user.role){case'groupleader':to='group';break;case'groupmember':to='group';break;case'schoolcontact':to='school';break;default:to=props.user.role;break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Redirect */],{to:'/portal/'+to});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{user:state.user};})(portalRedirect));

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_avatar_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Table__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_SectionHeading__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_StatusBox__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_gameStateHelpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_groupHelper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_imageResizer__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_objectChanged__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_getUrlVars__ = __webpack_require__(72);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setGroupId=__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* default */].schoolClass.setGroupId;var TeamInfo=(_temp=_class=function(_Component){_inherits(TeamInfo,_Component);function TeamInfo(props){var _this2=this;_classCallCheck(this,TeamInfo);var _this=_possibleConstructorReturn(this,(TeamInfo.__proto__||Object.getPrototypeOf(TeamInfo)).call(this,props));_this.handleChange=function(_ref){var _ref$target=_ref.target,value=_ref$target.value,name=_ref$target.name,blur=_ref$target.blur;if(_this.props.user.role.indexOf('leader')===-1||!_this.allowUpdateName())return false;if(name==='name')value=value.toUpperCase();var state=_this.state;if(value.length<17){state.group[name]=value;state.nameChanged=true;state.submittedName=false;_this.setState(state);}};_this.getValueFromRound=function(roundNumber,keyName,gameStateFilter){var round=_this.state.group.Rounds.find(function(r){return r.roundNumber===roundNumber;});if(round){if(['AB_points','BB_points'].includes(keyName)&&!['SIMULATION_TAX_2','SIMULATION_SPENDING','END'].includes(round.state))return'';if(['C_points','V_points','VV_points'].includes(keyName)&&!['SIMULATION_SPENDING','END'].includes(round.state))return'';if(['pc_points'].includes(keyName)&&!['END'].includes(round.state))return'';if(gameStateFilter){var sum=Object(__WEBPACK_IMPORTED_MODULE_15__helpers_gameStateHelpers__["getGameStateSum"])(round.GameStates.filter(function(gs){return gs.state===gameStateFilter;}));console.log(sum,roundNumber,_this.props);return sum[keyName]||0;}return round.gameStateSum[keyName]||0;}return'';};_this.getValueFromRoundForMinistry=function(roundNumber,keyName,gameStateFilter){var nextRound=_this.state.group.Rounds.find(function(r){return r.roundNumber===roundNumber+1;});if(nextRound&&(nextRound.state.startsWith('SIMULATION_')||nextRound.state==='END')){return _this.getValueFromRound(roundNumber,keyName,gameStateFilter);}return'';};_this.renderTaxScores=function(){if(_this.props.project.difficulty==='PRO'){return[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting'),'',_this.getValueFromRound(1,'AB_points'),_this.getValueFromRound(2,'AB_points'),_this.getValueFromRound(3,'AB_points'),_this.getValueFromRound(4,'AB_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting'),'',_this.getValueFromRound(1,'BB_points'),_this.getValueFromRound(2,'BB_points'),_this.getValueFromRound(3,'BB_points'),_this.getValueFromRound(4,'BB_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting'),'',_this.getValueFromRound(1,'C_points'),_this.getValueFromRound(2,'C_points'),_this.getValueFromRound(3,'C_points'),_this.getValueFromRound(4,'C_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting'),'',_this.getValueFromRound(1,'VV_points'),_this.getValueFromRound(2,'VV_points'),_this.getValueFromRound(3,'VV_points'),_this.getValueFromRound(4,'VV_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vermogenbelasting'),'',_this.getValueFromRound(1,'V_points'),_this.getValueFromRound(2,'V_points'),_this.getValueFromRound(3,'V_points'),_this.getValueFromRound(4,'V_points')]];}var rows=[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_belasting'),'',_this.getValueFromRound(1,'AB_points'),_this.getValueFromRound(2,'AB_points'),_this.getValueFromRound(3,'AB_points'),_this.getValueFromRound(4,'AB_points')]];if(_this.props.project.minPolicyChoices>0){rows.push([Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),'',_this.getValueFromRound(1,'pc_points'),_this.getValueFromRound(2,'pc_points'),_this.getValueFromRound(3,'pc_points'),_this.getValueFromRound(4,'pc_points')]);}return rows;};_this.getColor=function(ministry){var roundNumber=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var _this$props=_this.props,project=_this$props.project,gameStateInput=_this$props.gameStateInput,feedback=_this$props.feedback,gameState=_this$props.gameState;var group=_this.state.group;if(gameState.Rounds.length<=roundNumber)return'';var currentRound=gameState.Rounds.find(function(r){return r.roundNumber===roundNumber;});var nextRound=gameState.Rounds.find(function(r){return r.roundNumber===roundNumber+1;});if(!currentRound)return'';if(roundNumber>0&&(!nextRound||nextRound.state==='PLAYING_GAME'||nextRound.state==='SCORE_SUBMITTED'))return'';var fb=(!feedback.all.length?[]:feedback.all[roundNumber]||{}).feedback||[];var gs={sumUpToPrevRound:Object(__WEBPACK_IMPORTED_MODULE_15__helpers_gameStateHelpers__["getGameStateSum"])(gameState.Rounds.slice(0,roundNumber+1).reduce(function(acc,r){return acc.concat(r.GameStates);},[])),currentRound:roundNumber};var ministryCollaborations={};if(gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling){var selectedCollabs=gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling[ministry+'SW']||[];var myTheme=gameStateInput.states[roundNumber][group.id].theme;var myValue=gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling[ministry];ministryCollaborations=_defineProperty({},ministry,selectedCollabs.filter(function(theme){var otherGroup=Object.values(gameStateInput.states[roundNumber]).find(function(g){return g.theme===theme;});return otherGroup&&otherGroup.ministerieGlobaVerdeling&&myValue===otherGroup.ministerieGlobaVerdeling[ministry]&&(otherGroup.ministerieGlobaVerdeling[ministry+'SW']||[]).includes(myTheme);}));}return Object(__WEBPACK_IMPORTED_MODULE_16__helpers_feedbackHelpers__["p" /* getMinistryColor */])(project.difficulty.toLowerCase(),ministry,gs,{ministryCollaborations:ministryCollaborations},fb,true);};_this.renderMinistryScores=function(){return _this.ministries.map(function(m){return[m,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,0)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,1),text:_this.getValueFromRoundForMinistry(1,m+'_points')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,2),text:_this.getValueFromRoundForMinistry(2,m+'_points')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,3),text:_this.getValueFromRoundForMinistry(3,m+'_points')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,4),text:_this.getValueFromRoundForMinistry(4,m+'_points')})];});};_this.uploadAvatar=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file){var _this$state,group,uploadingAvatar,formData,fileName,resized;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state=_this.state,group=_this$state.group,uploadingAvatar=_this$state.uploadingAvatar;if(!uploadingAvatar){_context.next=3;break;}return _context.abrupt('return',null);case 3:_this.setState({uploadingAvatar:true,avatarChanged:true,submittedAvatar:false});formData=new FormData();fileName=(_this.props.schoolClass.className+'-'+_this.props.schoolClass.classRoom+'-'+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(_this.props.group.GroupTheme.color).toUpperCase()).replace(/[^a-z0-9]/gi,'_')+".jpeg";_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_18__helpers_imageResizer__["a" /* default */])(file,500,500,0.8,fileName);case 8:resized=_context.sent;formData.append('file',resized,resized.name);Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/file/upload',formData,'POST').then(function(f){if(f[0]){group.Avatar=f[0];group.AvatarId=f[0].id;_this.setState({group:group,uploadingAvatar:false});}}).catch(function(){_this.setState({uploadingAvatar:false,avatarChanged:false,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_fout_uploaden_groeps_foto')},function(){if(_this.timeout)clearTimeout(_this.timeout);_this.timeout=setTimeout(function(){_this.setState({errorMessage:undefined});},7000);});});case 11:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();_this.openPopup=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;_this.setState({popupId:id,showPopup:true,popupCallBack:callback});};_this.closePopup=function(){var executeCallBack=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this.setState({popupId:null,showPopup:false});if(_this.state.popupCallBack!==null&&executeCallBack){_this.state.popupCallBack();}};_this.popupBeforeSubmitGroup=function(){var group=_this.state.group;if(_this.props.user.role==='classleader')return _this.submitGroup();var nameChangedOnce=group.name!==Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(group.GroupTheme.name);var avatarChangedOnce=group.AvatarId!==null;if(!avatarChangedOnce&&!nameChangedOnce){_this.openPopup('dlgmopslaan');}else if(!avatarChangedOnce&&nameChangedOnce){_this.openPopup('dlgmopslaanfoto',_this.submitGroup);}else if(avatarChangedOnce&&!nameChangedOnce){_this.openPopup('dlgmopslaannaam');}else{_this.submitGroup();}};_this.submitGroup=function(){if(_this.state.submittingGroup)return;var user=_this.props.user;_this.setState({submittingGroup:true});if(user.role.indexOf('leader')!==-1){var group=_this.state.group;if(_this.state.nameChanged){group.countrynameLocked=true;}if(_this.state.avatarChanged){group.avatarLocked=true;}Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/group/'+group.id+'/update',group,'PUT').then(function(group){_this.setState({submittedName:_this.state.nameChanged,submittedAvatar:_this.state.avatarChanged,submittingGroup:false,group:_extends({},_this.state.group,group)});});// this.props.dispatch(updateGroup({name: __(this.state.group.name)}));
}};_this.allowUpdateName=function(){if(_this.props.user.role==='classleader')return true;return _this.props.user.role==='groupleader'&&!_this.state.group.countrynameLocked;};_this.toggleAvatarLocked=function(ev){if(_this.props.user.role!=='classleader')return;var group=_this.state.group;ev.preventDefault();Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/group/'+group.id+'/setAvatarLocked',!group.avatarLocked,'PUT').then(function(result){group.avatarLocked=result.avatarLocked;_this.setState({group:group});});};_this.toggleCountrynameLocked=function(ev){var group=_this.state.group;if(ev!==false)ev.preventDefault();Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/group/'+group.id+'/setCountryNameLocked',!group.countrynameLocked,'PUT').then(function(result){group.countrynameLocked=!group.countrynameLocked;_this.setState({group:group});});};_this.studentNameUpdate=function(ev,index){var group=_this.state.group;if(!group.Students[index]){group.Students[index]={name:''};}group.Students[index].name=ev.target.value;_this.setState({group:group});};_this.studentNameBlur=function(ev,index){if(_this.props.user.role!=='classleader')return;var group=_this.state.group;if(!ev.target.value.length){group.Students[index]={name:''};}var el=ev.currentTarget.parentElement;el.children[0].readOnly=true;el.classList.remove('hasFocus');Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/group/'+group.id+'/setStudents',{students:group.Students.filter(function(s){return s.name.length;})},'PUT');};_this.setStudentFocus=function(index){_this.setState({studentNameFocus:index});if(_this['studentInputRef'+index]&&_this['studentInputRef'+index].current){_this['studentInputRef'+index].current.focus();}};_this.prefillScores=function(){var body=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];while(body.length<4){body.push([[body.length+1+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdienen'),'','','',''],[body.length+1+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen'),'','','','']]);}return body.slice(0,4);};_this.prefillScoresEarn=function(){var body=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];while(body.length<4){body.push([body.length+1+'.','','']);}return body;};_this.checkShowPopup=function(){if(_this.allowUpdateName()===false){_this.openPopup('dlgmnaamopgeslagen');}};_this.renderStudentRows=function(){var students=[];while(students.length<6){var i=students.length;if(_this.state.group.Students[i]){students.push(_this.state.group.Students[i]);}else{students.push({name:''});}}return students.map(function(s,i){return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:function onClick(ev){var el=ev.currentTarget;el.children[0].readOnly=false;el.children[0].focus();el.classList.add('hasFocus');},className:'student-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{style:{width:'88%'},key:i,ref:function(){return _this['studentInputRef'+i]=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();}(),onChange:function onChange(ev){_this.studentNameUpdate(ev,i);},value:s.name,maxLength:35,readOnly:true,onBlur:function onBlur(ev){_this.studentNameBlur(ev,i);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'pen',src:__WEBPACK_IMPORTED_MODULE_14__assets_assets__["d" /* icons */].pen,alt:'pen'}))];});};_this.groupId=props.match.params.groupId;if(_this.groupId){props.dispatch(setGroupId(_this.groupId));}_this.state={submittingGroup:false,submittedAvatar:false,submittedName:false,group:props.group,studentNameFocus:null,uploadingAvatar:false,myDetailedRank:[],avatarChanged:false,nameChanged:false,showPopup:false,popupId:null,errorMessage:undefined};_this.ministries={};_this.fileUploadRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(TeamInfo,[{key:'componentWillMount',value:function componentWillMount(){var _this3=this;this.props.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* default */].project.refreshProject());Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/group/myDetailedRank?includeBonusPoints=true',null,'GET').then(function(myDetailedRank){_this3.setState({myDetailedRank:myDetailedRank});});__WEBPACK_IMPORTED_MODULE_11__Defines__["a" /* default */].fetch().then(function(defines){_this3.setState({defines:defines});});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(this.groupId&&props.group.id!==this.state.group.id){props.dispatch(setGroupId(this.groupId));}if(!this.state.group.loaded){this.setState({group:props.group});}if(props.user.role==='classleader'){var scGroup=props.schoolClass.group;if(scGroup&&this.state.group.id!==scGroup.id){this.setState({group:scGroup});}}if(Object(__WEBPACK_IMPORTED_MODULE_21__helpers_objectChanged__["a" /* default */])(this.state.group,props.group)){this.setState({group:props.group});}}},{key:'render',value:function render(){var _this4=this;var desktop=this.props.desktop;if(!this.state.group||!this.state.group.loaded||!this.state.defines){return null;}this.ministries=this.state.defines[this.props.project.difficulty.toLowerCase()].ministries;var roundSpliceIndex=this.state.group.Rounds.findIndex(function(gr){return gr.unsetScoreVisibility;});if(roundSpliceIndex<=0||this.props.gameState.showScores){roundSpliceIndex=this.state.group.Rounds.length;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'teaminfo '+this.props.user.role+' '+(desktop?'desktop-teaminfo':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'close-button-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_GoBackButton__["a" /* default */],{history:this.props.history,closeWindow:Object(__WEBPACK_IMPORTED_MODULE_22__helpers_getUrlVars__["a" /* default */])()['closeWindow']==='true'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'upload-avatar '+(this.state.uploadingAvatar?'disabled':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'avatar-upload-wrapper'},this.props.user.role==='classleader'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'lock'+(this.state.group.avatarLocked?' locked':''),onClick:this.toggleAvatarLocked}):null,this.props.user.role==='groupleader'&&this.state.submittedAvatar?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-avatar-saved-check'}):null,this.props.user.role==='groupleader'&&!this.state.group.avatarLocked&&!this.state.group.AvatarId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_upload_foto_button')):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{ref:this.fileUploadRef,type:'file',disabled:this.props.user.role==='classleader'?false:this.state.group.avatarLocked,name:'avatar',accept:'image/png,image/jpeg',onChange:function onChange(e){_this4.uploadAvatar(e.target.files[0]);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:'team-avatar',className:!this.state.group.Avatar?'no-avatar':'',src:Object(__WEBPACK_IMPORTED_MODULE_17__helpers_groupHelper__["a" /* getGroupAvatarUrl */])(this.state.group,this.props.project,__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_avatar_svg___default.a),alt:'avatar',onClick:function onClick(_){return _this4.openPopup('dlgmfotoopgeslagen');}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:function onSubmit(ev){ev.preventDefault();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-container',onClick:this.checkShowPopup},this.props.user.role==='classleader'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'lock text'+(this.state.group.countrynameLocked?' locked':''),onClick:this.toggleCountrynameLocked}):null,this.props.user.role==='groupleader'&&this.state.submittedName?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-name-saved-check'}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'group-badge',src:''+__WEBPACK_IMPORTED_MODULE_19__config___default.a.apiUrl+this.state.group.GroupTheme.badge,alt:'groupBadge'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'name',placeholder:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vul_landnaam_in_placeholder'),value:this.state.group.name.toUpperCase(),onChange:this.handleChange})),this.props.user.role.indexOf('leader')!==-1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:this.state.group.avatarLocked&&this.state.group.countrynameLocked&&['groupleader','groupmember'].includes(this.props.user.role)?'disabled':'',type:'submit',onClick:this.popupBeforeSubmitGroup},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_opslaan'))):null),this.state.errorMessage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{marginTop:'20px',color:'red'}},this.state.errorMessage):null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},this.props.user.role!=='classleader'?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_14__assets_assets__["d" /* icons */].team,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_teamleden')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Table__["a" /* default */],{body:this.renderStudentRows()}))),this.props.user.role==='classleader'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_12__apiCall__["a" /* default */])('/user/'+_this4.state.group.id+'/loginAsGroup',{},'POST').then(function(access){window.open('/login?token='+access.token+'&redirect=/portal/teaminfo?closeWindow=true');});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bekijk_scores'))):null,(this.props.user.role==='groupleader'||this.props.user.role==='groupmember')&&this.props.project.EducationProject.nameShort==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_14__assets_assets__["d" /* icons */].medal,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totaalscores')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Table__["a" /* default */],{head:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_spelronde'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_teaminfo_punten'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totaal'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_school',1),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_klas',1)],body:[].concat.apply([],this.prefillScores(this.state.group.Rounds.filter(function(r){return[1,2,3,4].includes(r.roundNumber);}).splice(0,roundSpliceIndex).map(function(r,i){var detailedTotalPoints=[].concat(_this4.state.group.detailedTotalPoints).splice(0,r.roundNumber);var _state$group$detailed=_this4.state.group.detailedTotalPoints[i],verdienen=_state$group$detailed.verdienen,verdelen=_state$group$detailed.verdelen;var bonusPoints=_this4.props.gameState.Rounds.reduce(function(bp,round){if(Array.isArray(round.GameStates)&&r.roundNumber>=round.roundNumber){var bonusAssignmentState=round.GameStates.find(function(g){return g.type==='BONUS_ASSIGNMENT';})||{points:0};var teacherInterventionState=round.GameStates.find(function(g){return g.type==='TEACHER_INTERVENTION';})||{points:0};bp+=bonusAssignmentState.points+teacherInterventionState.points;}return bp;},0);var verdienenTotal=detailedTotalPoints.reduce(function(acc,dtp){acc+=dtp.verdelen+dtp.verdienen;return acc;},bonusPoints);verdienenTotal-=verdelen;var verdelenTotal=detailedTotalPoints.reduce(function(acc,dtp){acc+=dtp.verdelen+dtp.verdienen;return acc;},bonusPoints);var myDetailedRank=_this4.state.myDetailedRank[i]||{};var verdienenSchoolRank=myDetailedRank.verdienenSchoolRank||0;var verdelenSchoolRank=myDetailedRank.verdelenSchoolRank||0;var verdienenSchoolClassRank=myDetailedRank.verdienenSchoolClassRank||0;var verdelenSchoolClassRank=myDetailedRank.verdelenSchoolClassRank||0;var scoreArr=[[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdienen'),'','','',''],[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen'),'','','','']];if(r.state==='PLAYING_GAME'){return scoreArr;}if(r.state.startsWith('SIMULATION_')||r.state==='END'||r.state==='SCORE_SUBMITTED'&&r.roundNumber===1){scoreArr[0]=[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdienen'),verdienen,verdienenTotal,verdienenSchoolRank,verdienenSchoolClassRank];}var nextRound=_this4.state.group.Rounds.find(function(nxtR){return nxtR.roundNumber===r.roundNumber+1;});if(nextRound&&(nextRound.state.startsWith('SIMULATION_')||nextRound.state==='END')){scoreArr[1]=[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen'),verdelen,verdelenTotal,verdelenSchoolRank,verdelenSchoolClassRank];}return scoreArr;}))),foot:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bonuspunten'),''+(this.state.group.Rounds.reduce(function(p,r){r.GameStates.filter(function(gs){return gs.type==='TEACHER_INTERVENTION'||gs.type==='BONUS_ASSIGNMENT';}).forEach(function(gs){return p+=gs.points;});return p;},0)||''),'','','']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_14__assets_assets__["d" /* icons */].medal,title:''+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_scores_globas_verdienen')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Table__["a" /* default */],{head:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_spelronde'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_teaminfo_punten')],body:this.prefillScoresEarn(this.state.group.Rounds.filter(function(r){return r.GameId;}).map(function(r){var _props$schoolClass$Sc=_this4.props.schoolClass.SchoolClassGames.find(function(g){return g.GameId===r.GameId;}),Game=_props$schoolClass$Sc.Game;if(r.state==='PLAYING_GAME'){return[r.roundNumber+'. '+Game.name,'',''];}return[r.roundNumber+'. '+Game.name,r.earnedGlobas,r.earnedPoints];}))})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_14__assets_assets__["d" /* icons */].medal,title:''+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_scores_globas_verdelen')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Table__["a" /* default */],{translate:false,head:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_onderdeel'),'S','R1','R2','R3','R4'],className:'scores-globas-verdelen-table',body:this.renderTaxScores().concat(this.renderMinistryScores()).concat(this.props.gameState.gameStateSum.remainingSavingsPoints>0?[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_overige_spaargeld'),'','','','',this.props.gameState.gameStateSum.remainingSavingsPoints]]:null).concat(this.props.gameState.gameStateSum.remainingProfitLossPoints!==0?[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_overige_wgvg'),'','','','',this.props.gameState.gameStateSum.remainingProfitLossPoints]]:null)}))):null,this.state.showPopup?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__elements_PopUp__["a" /* default */],{id:this.state.popupId,closePopUpClick:function closePopUpClick(res){_this4.closePopup(res);}}):null);}}]);return TeamInfo;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func}).isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(_ref3){var user=_ref3.user,project=_ref3.project,schoolClass=_ref3.schoolClass,group=_ref3.group,gameState=_ref3.gameState,gameStateInput=_ref3.gameStateInput,feedback=_ref3.feedback;return{user:user,project:project,schoolClass:schoolClass,group:group,gameState:gameState,gameStateInput:gameStateInput,feedback:feedback};})(TeamInfo));

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_load_image__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_blueimp_load_image___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_blueimp_load_image__);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}/* harmony default export */ __webpack_exports__["a"] = ((function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:return _context.abrupt('return',new Promise(function(resolve){__WEBPACK_IMPORTED_MODULE_1_blueimp_load_image___default()(file,function(canvas){canvas.toBlob(function(blob){resolve(blob);},'image/jpeg');},{canvas:true,orientation:1});}));case 1:case'end':return _context.stop();}}},_callee,this);}));function fixRotationOfFile(_x){return _ref.apply(this,arguments);}return fixRotationOfFile;})());

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

/* global module, require */

module.exports = __webpack_require__(53)

__webpack_require__(362)
__webpack_require__(97)
__webpack_require__(985)
__webpack_require__(363)
__webpack_require__(986)
__webpack_require__(364)
__webpack_require__(987)
__webpack_require__(988)


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Fetch
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2017, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-meta'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  if (typeof fetch !== 'undefined' && typeof Request !== 'undefined') {
    loadImage.fetchBlob = function (url, callback, options) {
      if (loadImage.hasMetaOption(options)) {
        fetch(new Request(url, options))
          .then(function (response) {
            return response.blob()
          })
          .then(callback)
          .catch(function (err) {
            console.log(err) // eslint-disable-line no-console
            callback()
          })
      } else {
        callback()
      }
    }
  } else if (
    // Check for XHR2 support:
    typeof XMLHttpRequest !== 'undefined' &&
    typeof ProgressEvent !== 'undefined'
  ) {
    loadImage.fetchBlob = function (url, callback, options) {
      if (loadImage.hasMetaOption(options)) {
        // eslint-disable-next-line no-param-reassign
        options = options || {}
        var req = new XMLHttpRequest()
        req.open(options.method || 'GET', url)
        if (options.headers) {
          Object.keys(options.headers).forEach(function (key) {
            req.setRequestHeader(key, options.headers[key])
          })
        }
        req.withCredentials = options.credentials === 'include'
        req.responseType = 'blob'
        req.onload = function () {
          callback(req.response)
        }
        req.onerror = req.onabort = req.ontimeout = function (e) {
          console.log(e) // eslint-disable-line no-console
          callback()
        }
        req.send(options.body)
      } else {
        callback()
      }
    }
  }
})


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Exif Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Exif tags mapping based on
 * https://github.com/jseidelin/exif-js
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(363)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-exif'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  loadImage.ExifMap.prototype.tags = {
    // =================
    // TIFF tags (IFD0):
    // =================
    0x0100: 'ImageWidth',
    0x0101: 'ImageHeight',
    0x8769: 'ExifIFDPointer',
    0x8825: 'GPSInfoIFDPointer',
    0xa005: 'InteroperabilityIFDPointer',
    0x0102: 'BitsPerSample',
    0x0103: 'Compression',
    0x0106: 'PhotometricInterpretation',
    0x0112: 'Orientation',
    0x0115: 'SamplesPerPixel',
    0x011c: 'PlanarConfiguration',
    0x0212: 'YCbCrSubSampling',
    0x0213: 'YCbCrPositioning',
    0x011a: 'XResolution',
    0x011b: 'YResolution',
    0x0128: 'ResolutionUnit',
    0x0111: 'StripOffsets',
    0x0116: 'RowsPerStrip',
    0x0117: 'StripByteCounts',
    0x0201: 'JPEGInterchangeFormat',
    0x0202: 'JPEGInterchangeFormatLength',
    0x012d: 'TransferFunction',
    0x013e: 'WhitePoint',
    0x013f: 'PrimaryChromaticities',
    0x0211: 'YCbCrCoefficients',
    0x0214: 'ReferenceBlackWhite',
    0x0132: 'DateTime',
    0x010e: 'ImageDescription',
    0x010f: 'Make',
    0x0110: 'Model',
    0x0131: 'Software',
    0x013b: 'Artist',
    0x8298: 'Copyright',
    // ==================
    // Exif Sub IFD tags:
    // ==================
    0x9000: 'ExifVersion', // EXIF version
    0xa000: 'FlashpixVersion', // Flashpix format version
    0xa001: 'ColorSpace', // Color space information tag
    0xa002: 'PixelXDimension', // Valid width of meaningful image
    0xa003: 'PixelYDimension', // Valid height of meaningful image
    0xa500: 'Gamma',
    0x9101: 'ComponentsConfiguration', // Information about channels
    0x9102: 'CompressedBitsPerPixel', // Compressed bits per pixel
    0x927c: 'MakerNote', // Any desired information written by the manufacturer
    0x9286: 'UserComment', // Comments by user
    0xa004: 'RelatedSoundFile', // Name of related sound file
    0x9003: 'DateTimeOriginal', // Date and time when the original image was generated
    0x9004: 'DateTimeDigitized', // Date and time when the image was stored digitally
    0x9290: 'SubSecTime', // Fractions of seconds for DateTime
    0x9291: 'SubSecTimeOriginal', // Fractions of seconds for DateTimeOriginal
    0x9292: 'SubSecTimeDigitized', // Fractions of seconds for DateTimeDigitized
    0x829a: 'ExposureTime', // Exposure time (in seconds)
    0x829d: 'FNumber',
    0x8822: 'ExposureProgram', // Exposure program
    0x8824: 'SpectralSensitivity', // Spectral sensitivity
    0x8827: 'PhotographicSensitivity', // EXIF 2.3, ISOSpeedRatings in EXIF 2.2
    0x8828: 'OECF', // Optoelectric conversion factor
    0x8830: 'SensitivityType',
    0x8831: 'StandardOutputSensitivity',
    0x8832: 'RecommendedExposureIndex',
    0x8833: 'ISOSpeed',
    0x8834: 'ISOSpeedLatitudeyyy',
    0x8835: 'ISOSpeedLatitudezzz',
    0x9201: 'ShutterSpeedValue', // Shutter speed
    0x9202: 'ApertureValue', // Lens aperture
    0x9203: 'BrightnessValue', // Value of brightness
    0x9204: 'ExposureBias', // Exposure bias
    0x9205: 'MaxApertureValue', // Smallest F number of lens
    0x9206: 'SubjectDistance', // Distance to subject in meters
    0x9207: 'MeteringMode', // Metering mode
    0x9208: 'LightSource', // Kind of light source
    0x9209: 'Flash', // Flash status
    0x9214: 'SubjectArea', // Location and area of main subject
    0x920a: 'FocalLength', // Focal length of the lens in mm
    0xa20b: 'FlashEnergy', // Strobe energy in BCPS
    0xa20c: 'SpatialFrequencyResponse',
    0xa20e: 'FocalPlaneXResolution', // Number of pixels in width direction per FPRUnit
    0xa20f: 'FocalPlaneYResolution', // Number of pixels in height direction per FPRUnit
    0xa210: 'FocalPlaneResolutionUnit', // Unit for measuring the focal plane resolution
    0xa214: 'SubjectLocation', // Location of subject in image
    0xa215: 'ExposureIndex', // Exposure index selected on camera
    0xa217: 'SensingMethod', // Image sensor type
    0xa300: 'FileSource', // Image source (3 == DSC)
    0xa301: 'SceneType', // Scene type (1 == directly photographed)
    0xa302: 'CFAPattern', // Color filter array geometric pattern
    0xa401: 'CustomRendered', // Special processing
    0xa402: 'ExposureMode', // Exposure mode
    0xa403: 'WhiteBalance', // 1 = auto white balance, 2 = manual
    0xa404: 'DigitalZoomRatio', // Digital zoom ratio
    0xa405: 'FocalLengthIn35mmFilm',
    0xa406: 'SceneCaptureType', // Type of scene
    0xa407: 'GainControl', // Degree of overall image gain adjustment
    0xa408: 'Contrast', // Direction of contrast processing applied by camera
    0xa409: 'Saturation', // Direction of saturation processing applied by camera
    0xa40a: 'Sharpness', // Direction of sharpness processing applied by camera
    0xa40b: 'DeviceSettingDescription',
    0xa40c: 'SubjectDistanceRange', // Distance to subject
    0xa420: 'ImageUniqueID', // Identifier assigned uniquely to each image
    0xa430: 'CameraOwnerName',
    0xa431: 'BodySerialNumber',
    0xa432: 'LensSpecification',
    0xa433: 'LensMake',
    0xa434: 'LensModel',
    0xa435: 'LensSerialNumber',
    // ==============
    // GPS Info tags:
    // ==============
    0x0000: 'GPSVersionID',
    0x0001: 'GPSLatitudeRef',
    0x0002: 'GPSLatitude',
    0x0003: 'GPSLongitudeRef',
    0x0004: 'GPSLongitude',
    0x0005: 'GPSAltitudeRef',
    0x0006: 'GPSAltitude',
    0x0007: 'GPSTimeStamp',
    0x0008: 'GPSSatellites',
    0x0009: 'GPSStatus',
    0x000a: 'GPSMeasureMode',
    0x000b: 'GPSDOP',
    0x000c: 'GPSSpeedRef',
    0x000d: 'GPSSpeed',
    0x000e: 'GPSTrackRef',
    0x000f: 'GPSTrack',
    0x0010: 'GPSImgDirectionRef',
    0x0011: 'GPSImgDirection',
    0x0012: 'GPSMapDatum',
    0x0013: 'GPSDestLatitudeRef',
    0x0014: 'GPSDestLatitude',
    0x0015: 'GPSDestLongitudeRef',
    0x0016: 'GPSDestLongitude',
    0x0017: 'GPSDestBearingRef',
    0x0018: 'GPSDestBearing',
    0x0019: 'GPSDestDistanceRef',
    0x001a: 'GPSDestDistance',
    0x001b: 'GPSProcessingMethod',
    0x001c: 'GPSAreaInformation',
    0x001d: 'GPSDateStamp',
    0x001e: 'GPSDifferential',
    0x001f: 'GPSHPositioningError'
  }

  loadImage.ExifMap.prototype.stringValues = {
    ExposureProgram: {
      0: 'Undefined',
      1: 'Manual',
      2: 'Normal program',
      3: 'Aperture priority',
      4: 'Shutter priority',
      5: 'Creative program',
      6: 'Action program',
      7: 'Portrait mode',
      8: 'Landscape mode'
    },
    MeteringMode: {
      0: 'Unknown',
      1: 'Average',
      2: 'CenterWeightedAverage',
      3: 'Spot',
      4: 'MultiSpot',
      5: 'Pattern',
      6: 'Partial',
      255: 'Other'
    },
    LightSource: {
      0: 'Unknown',
      1: 'Daylight',
      2: 'Fluorescent',
      3: 'Tungsten (incandescent light)',
      4: 'Flash',
      9: 'Fine weather',
      10: 'Cloudy weather',
      11: 'Shade',
      12: 'Daylight fluorescent (D 5700 - 7100K)',
      13: 'Day white fluorescent (N 4600 - 5400K)',
      14: 'Cool white fluorescent (W 3900 - 4500K)',
      15: 'White fluorescent (WW 3200 - 3700K)',
      17: 'Standard light A',
      18: 'Standard light B',
      19: 'Standard light C',
      20: 'D55',
      21: 'D65',
      22: 'D75',
      23: 'D50',
      24: 'ISO studio tungsten',
      255: 'Other'
    },
    Flash: {
      0x0000: 'Flash did not fire',
      0x0001: 'Flash fired',
      0x0005: 'Strobe return light not detected',
      0x0007: 'Strobe return light detected',
      0x0009: 'Flash fired, compulsory flash mode',
      0x000d: 'Flash fired, compulsory flash mode, return light not detected',
      0x000f: 'Flash fired, compulsory flash mode, return light detected',
      0x0010: 'Flash did not fire, compulsory flash mode',
      0x0018: 'Flash did not fire, auto mode',
      0x0019: 'Flash fired, auto mode',
      0x001d: 'Flash fired, auto mode, return light not detected',
      0x001f: 'Flash fired, auto mode, return light detected',
      0x0020: 'No flash function',
      0x0041: 'Flash fired, red-eye reduction mode',
      0x0045: 'Flash fired, red-eye reduction mode, return light not detected',
      0x0047: 'Flash fired, red-eye reduction mode, return light detected',
      0x0049: 'Flash fired, compulsory flash mode, red-eye reduction mode',
      0x004d: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected',
      0x004f: 'Flash fired, compulsory flash mode, red-eye reduction mode, return light detected',
      0x0059: 'Flash fired, auto mode, red-eye reduction mode',
      0x005d: 'Flash fired, auto mode, return light not detected, red-eye reduction mode',
      0x005f: 'Flash fired, auto mode, return light detected, red-eye reduction mode'
    },
    SensingMethod: {
      1: 'Undefined',
      2: 'One-chip color area sensor',
      3: 'Two-chip color area sensor',
      4: 'Three-chip color area sensor',
      5: 'Color sequential area sensor',
      7: 'Trilinear sensor',
      8: 'Color sequential linear sensor'
    },
    SceneCaptureType: {
      0: 'Standard',
      1: 'Landscape',
      2: 'Portrait',
      3: 'Night scene'
    },
    SceneType: {
      1: 'Directly photographed'
    },
    CustomRendered: {
      0: 'Normal process',
      1: 'Custom process'
    },
    WhiteBalance: {
      0: 'Auto white balance',
      1: 'Manual white balance'
    },
    GainControl: {
      0: 'None',
      1: 'Low gain up',
      2: 'High gain up',
      3: 'Low gain down',
      4: 'High gain down'
    },
    Contrast: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    Saturation: {
      0: 'Normal',
      1: 'Low saturation',
      2: 'High saturation'
    },
    Sharpness: {
      0: 'Normal',
      1: 'Soft',
      2: 'Hard'
    },
    SubjectDistanceRange: {
      0: 'Unknown',
      1: 'Macro',
      2: 'Close view',
      3: 'Distant view'
    },
    FileSource: {
      3: 'DSC'
    },
    ComponentsConfiguration: {
      0: '',
      1: 'Y',
      2: 'Cb',
      3: 'Cr',
      4: 'R',
      5: 'G',
      6: 'B'
    },
    Orientation: {
      1: 'top-left',
      2: 'top-right',
      3: 'bottom-right',
      4: 'bottom-left',
      5: 'left-top',
      6: 'right-top',
      7: 'right-bottom',
      8: 'left-bottom'
    }
  }

  loadImage.ExifMap.prototype.getText = function (id) {
    var value = this.get(id)
    switch (id) {
      case 'LightSource':
      case 'Flash':
      case 'MeteringMode':
      case 'ExposureProgram':
      case 'SensingMethod':
      case 'SceneCaptureType':
      case 'SceneType':
      case 'CustomRendered':
      case 'WhiteBalance':
      case 'GainControl':
      case 'Contrast':
      case 'Saturation':
      case 'Sharpness':
      case 'SubjectDistanceRange':
      case 'FileSource':
      case 'Orientation':
        return this.stringValues[id][value]
      case 'ExifVersion':
      case 'FlashpixVersion':
        if (!value) return
        return String.fromCharCode(value[0], value[1], value[2], value[3])
      case 'ComponentsConfiguration':
        if (!value) return
        return (
          this.stringValues[id][value[0]] +
          this.stringValues[id][value[1]] +
          this.stringValues[id][value[2]] +
          this.stringValues[id][value[3]]
        )
      case 'GPSVersionID':
        if (!value) return
        return value[0] + '.' + value[1] + '.' + value[2] + '.' + value[3]
    }
    return String(value)
  }
  ;(function (exifMapPrototype) {
    var tags = exifMapPrototype.tags
    var map = exifMapPrototype.map
    var prop
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        map[tags[prop]] = prop
      }
    }
  })(loadImage.ExifMap.prototype)

  loadImage.ExifMap.prototype.getAll = function () {
    var map = {}
    var prop
    var id
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        id = this.tags[prop]
        if (id) {
          map[id] = this.getText(id)
        }
      }
    }
    return map
  }
})


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image IPTC Map
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * Copyright 2018, Dave Bevan
 *
 * IPTC tags mapping based on
 * https://github.com/jseidelin/exif-js
 * https://iptc.org/standards/photo-metadata
 * http://www.iptc.org/std/IIM/4.1/specification/IIMV4.1.pdf
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(364)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(require('./load-image'), require('./load-image-iptc'))
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  loadImage.IptcMap.prototype.tags = {
    // ==========
    // IPTC tags:
    // ==========
    0x03: 'ObjectType',
    0x04: 'ObjectAttribute',
    0x05: 'ObjectName',
    0x07: 'EditStatus',
    0x08: 'EditorialUpdate',
    0x0a: 'Urgency',
    0x0c: 'SubjectRef',
    0x0f: 'Category',
    0x14: 'SupplCategory',
    0x16: 'FixtureID',
    0x19: 'Keywords',
    0x1a: 'ContentLocCode',
    0x1b: 'ContentLocName',
    0x1e: 'ReleaseDate',
    0x23: 'ReleaseTime',
    0x25: 'ExpirationDate',
    0x26: 'ExpirationTime',
    0x28: 'SpecialInstructions',
    0x2a: 'ActionAdvised',
    0x2d: 'RefService',
    0x2f: 'RefDate',
    0x32: 'RefNumber',
    0x37: 'DateCreated',
    0x3c: 'TimeCreated',
    0x3e: 'DigitalCreationDate',
    0x3f: 'DigitalCreationTime',
    0x41: 'OriginatingProgram',
    0x46: 'ProgramVersion',
    0x4b: 'ObjectCycle',
    0x50: 'Byline',
    0x55: 'BylineTitle',
    0x5a: 'City',
    0x5c: 'Sublocation',
    0x5f: 'State',
    0x64: 'CountryCode',
    0x65: 'CountryName',
    0x67: 'OrigTransRef',
    0x69: 'Headline',
    0x6e: 'Credit',
    0x73: 'Source',
    0x74: 'CopyrightNotice',
    0x76: 'Contact',
    0x78: 'Caption',
    0x7a: 'WriterEditor',
    0x82: 'ImageType',
    0x83: 'ImageOrientation',
    0x87: 'LanguageID'

    // We don't record these tags:
    //
    // 0x00: 'RecordVersion',
    // 0x7d: 'RasterizedCaption',
    // 0x96: 'AudioType',
    // 0x97: 'AudioSamplingRate',
    // 0x98: 'AudioSamplingRes',
    // 0x99: 'AudioDuration',
    // 0x9a: 'AudioOutcue',
    // 0xc8: 'PreviewFileFormat',
    // 0xc9: 'PreviewFileFormatVer',
    // 0xca: 'PreviewData'
  }

  loadImage.IptcMap.prototype.getText = function (id) {
    var value = this.get(id)
    return String(value)
  }
  ;(function (iptcMapPrototype) {
    var tags = iptcMapPrototype.tags
    var map = iptcMapPrototype.map || {}
    var prop
    // Map the tag names to tags:
    for (prop in tags) {
      if (Object.prototype.hasOwnProperty.call(tags, prop)) {
        map[tags[prop]] = prop
      }
    }
  })(loadImage.IptcMap.prototype)

  loadImage.IptcMap.prototype.getAll = function () {
    var map = {}
    var prop
    var id
    for (prop in this) {
      if (Object.prototype.hasOwnProperty.call(this, prop)) {
        id = this.tags[prop]
        if (id) {
          map[id] = this.getText(id)
        }
      }
    }
    return map
  }
})


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 * JavaScript Load Image Orientation
 * https://github.com/blueimp/JavaScript-Load-Image
 *
 * Copyright 2013, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 */

/* global define, module, require */

;(function (factory) {
  'use strict'
  if (true) {
    // Register as an anonymous AMD module:
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(53), __webpack_require__(362), __webpack_require__(97)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof module === 'object' && module.exports) {
    factory(
      require('./load-image'),
      require('./load-image-scale'),
      require('./load-image-meta')
    )
  } else {
    // Browser globals:
    factory(window.loadImage)
  }
})(function (loadImage) {
  'use strict'

  var originalHasCanvasOption = loadImage.hasCanvasOption
  var originalHasMetaOption = loadImage.hasMetaOption
  var originalTransformCoordinates = loadImage.transformCoordinates
  var originalGetTransformedOptions = loadImage.getTransformedOptions

  ;(function () {
    // black 2x1 JPEG, with the following meta information set:
    // - EXIF Orientation: 6 (Rotated 90° CCW)
    var testImageURL =
      'data:image/jpeg;base64,/9j/4QAiRXhpZgAATU0AKgAAAAgAAQESAAMAAAABAAYAAAA' +
      'AAAD/2wCEAAEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBA' +
      'QEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQE' +
      'BAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/AABEIAAEAAgMBEQACEQEDEQH/x' +
      'ABKAAEAAAAAAAAAAAAAAAAAAAALEAEAAAAAAAAAAAAAAAAAAAAAAQEAAAAAAAAAAAAAAAA' +
      'AAAAAEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8H//2Q=='
    var img = document.createElement('img')
    img.onload = function () {
      // Check if browser supports automatic image orientation:
      loadImage.orientation = img.width === 1 && img.height === 2
    }
    img.src = testImageURL
  })()

  // Determines if the target image should be a canvas element:
  loadImage.hasCanvasOption = function (options) {
    return (
      (!!options.orientation === true && !loadImage.orientation) ||
      (options.orientation > 1 && options.orientation < 9) ||
      originalHasCanvasOption.call(loadImage, options)
    )
  }

  // Determines if meta data should be loaded automatically:
  loadImage.hasMetaOption = function (options) {
    return (
      (options && options.orientation === true && !loadImage.orientation) ||
      originalHasMetaOption.call(loadImage, options)
    )
  }

  // Transform image orientation based on
  // the given EXIF orientation option:
  loadImage.transformCoordinates = function (canvas, options) {
    originalTransformCoordinates.call(loadImage, canvas, options)
    var ctx = canvas.getContext('2d')
    var width = canvas.width
    var height = canvas.height
    var styleWidth = canvas.style.width
    var styleHeight = canvas.style.height
    var orientation = options.orientation
    if (!(orientation > 1 && orientation < 9)) {
      return
    }
    if (orientation > 4) {
      canvas.width = height
      canvas.height = width
      canvas.style.width = styleHeight
      canvas.style.height = styleWidth
    }
    switch (orientation) {
      case 2:
        // horizontal flip
        ctx.translate(width, 0)
        ctx.scale(-1, 1)
        break
      case 3:
        // 180° rotate left
        ctx.translate(width, height)
        ctx.rotate(Math.PI)
        break
      case 4:
        // vertical flip
        ctx.translate(0, height)
        ctx.scale(1, -1)
        break
      case 5:
        // vertical flip + 90 rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.scale(1, -1)
        break
      case 6:
        // 90° rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(0, -height)
        break
      case 7:
        // horizontal flip + 90 rotate right
        ctx.rotate(0.5 * Math.PI)
        ctx.translate(width, -height)
        ctx.scale(-1, 1)
        break
      case 8:
        // 90° rotate left
        ctx.rotate(-0.5 * Math.PI)
        ctx.translate(-width, 0)
        break
    }
  }

  // Transforms coordinate and dimension options
  // based on the given orientation option:
  loadImage.getTransformedOptions = function (img, opts, data) {
    var options = originalGetTransformedOptions.call(loadImage, img, opts)
    var orientation = options.orientation
    var newOptions
    var i
    if (orientation === true) {
      if (loadImage.orientation) {
        // Browser supports automatic image orientation
        return options
      }
      orientation = data && data.exif && data.exif.get('Orientation')
    }
    if (!(orientation > 1 && orientation < 9)) {
      return options
    }
    newOptions = {}
    for (i in options) {
      if (Object.prototype.hasOwnProperty.call(options, i)) {
        newOptions[i] = options[i]
      }
    }
    newOptions.orientation = orientation
    switch (orientation) {
      case 2:
        // horizontal flip
        newOptions.left = options.right
        newOptions.right = options.left
        break
      case 3:
        // 180° rotate left
        newOptions.left = options.right
        newOptions.top = options.bottom
        newOptions.right = options.left
        newOptions.bottom = options.top
        break
      case 4:
        // vertical flip
        newOptions.top = options.bottom
        newOptions.bottom = options.top
        break
      case 5:
        // vertical flip + 90 rotate right
        newOptions.left = options.top
        newOptions.top = options.left
        newOptions.right = options.bottom
        newOptions.bottom = options.right
        break
      case 6:
        // 90° rotate right
        newOptions.left = options.top
        newOptions.top = options.right
        newOptions.right = options.bottom
        newOptions.bottom = options.left
        break
      case 7:
        // horizontal flip + 90 rotate right
        newOptions.left = options.bottom
        newOptions.top = options.right
        newOptions.right = options.top
        newOptions.bottom = options.left
        break
      case 8:
        // 90° rotate left
        newOptions.left = options.bottom
        newOptions.top = options.left
        newOptions.right = options.top
        newOptions.bottom = options.right
        break
    }
    if (newOptions.orientation > 4) {
      newOptions.maxWidth = options.maxHeight
      newOptions.maxHeight = options.maxWidth
      newOptions.minWidth = options.minHeight
      newOptions.minHeight = options.minWidth
      newOptions.sourceWidth = options.sourceHeight
      newOptions.sourceHeight = options.sourceWidth
    }
    return newOptions
  }
})


/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_RankingRow__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_Loading__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_groupHelper__ = __webpack_require__(52);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Rankings=(_temp=_class=function(_Component){_inherits(Rankings,_Component);function Rankings(props){_classCallCheck(this,Rankings);var _this=_possibleConstructorReturn(this,(Rankings.__proto__||Object.getPrototypeOf(Rankings)).call(this,props));_this.getTitle=function(){var project=_this.props.project;var schoolClasses=_this.state.schoolClasses;if(_this.schoolClassId&&Array.isArray(schoolClasses)){var _schoolClasses$find=schoolClasses.find(function(sc){return sc.id===_this.schoolClassId;}),className=_schoolClasses$find.className,classRoom=_schoolClasses$find.classRoom;return className+'-'+classRoom;}return project.nameSchoolPlace;};_this.state={schoolClasses:[]};_this.schoolClassId=parseInt(_this.props.match.params.schoolClassId,10);_this.projectId=parseInt(_this.props.match.params.projectId,10);_this.renderGroupRows=_this.renderGroupRows.bind(_this);return _this;}_createClass(Rankings,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_9__apiCall__["a" /* default */])('/schoolClass/'+(this.schoolClassId?this.schoolClassId+'/':'')+'simGameSchoolClasses/'+this.projectId).then(function(schoolClasses){_this2.setState({schoolClasses:schoolClasses});});}},{key:'renderGroupRows',value:function renderGroupRows(groups){var _this3=this;var _props=this.props,schoolClass=_props.schoolClass,gameState=_props.gameState;if(!groups||!groups.length)return null;if(gameState.hideScores){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],{className:'disabled-scores-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'disabled-scores'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_tussenstand_uitgeschakeld')));};// Split groups in chunks of 8 for desktop view
var arrayChunk=function arrayChunk(arr,chunkSize){var groups=[],i=void 0;for(i=0;i<arr.length;i+=chunkSize){groups.push(arr.slice(i,i+chunkSize));}return groups;};var columns=arrayChunk(groups,10);return columns.map(function(column,y){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:y,className:'class-column'+(groups.length<=10?' single-column':'')},column.map(function(grp,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:grp.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_RankingRow__["a" /* default */],{key:grp.id,rank:i+1+y*10,title:grp.name,schoolClassFilter:_this3.schoolClassId&&schoolClass.id,color:grp.GroupTheme.color,className:grp.SchoolClass.className,showSchoolClassName:!_this3.schoolClassId,points:grp.totalPoints,avatar:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_groupHelper__["a" /* getGroupAvatarUrl */])(grp,_this3.props.project,'')}));}));});}/**
   * Get page title from project or schoolclass
   * @return {String} Page title
   */},{key:'render',value:function render(){var schoolClasses=this.state.schoolClasses;var desktop=this.props.desktop;if(!schoolClasses.length)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_Loading__["a" /* default */],null);var groups=schoolClasses.reduce(function(acc,sc){return acc.concat(sc.Groups.map(function(g){return _extends({},g,{SchoolClass:sc});}));},[]).sort(function(a,b){return b.totalPoints-a.totalPoints;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'rankings '+(desktop?'portal-home school-ranking darkBckg':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block title-portal '+(desktop?'title-small-center':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,this.getTitle()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_ranglijst'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ranking-rows-container'+(groups.length<=20?' hidescroll':'')},desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_scrollbars_custom___default.a,{className:'horizontal',permanentTrackX:true,noScrollY:true,style:{width:'100%',height:'auto',minHeight:600}},this.renderGroupRows(groups),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:'2px'},className:'extra-spacing'})):this.renderGroupRows(groups))));}}]);return Rankings;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}).isRequired,match:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({params:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({projectId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,schoolClassId:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}).isRequired}).isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{project:state.project,schoolClass:state.schoolClass,gameState:state.gameState};})(Rankings));

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_GroupGameScoreRow__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_caret_down_grey_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_caret_down_grey_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_caret_down_grey_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_GameMaterials__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_popupHelper__ = __webpack_require__(19);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var refreshProject=__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].project.refreshProject;var BonusPoints=(_temp=_class=function(_Component){_inherits(BonusPoints,_Component);function BonusPoints(props){_classCallCheck(this,BonusPoints);var _this2=_possibleConstructorReturn(this,(BonusPoints.__proto__||Object.getPrototypeOf(BonusPoints)).call(this,props));_this2.gameScoreUpdate=function(groupId,value){var gameScores=_this2.state.gameScores;gameScores[groupId]=JSON.parse(value);if(_typeof(gameScores[groupId])!=='object')delete gameScores[groupId];_this2.setState({gameScores:gameScores});};_this2.fetchGeneralMaterials=function(){var _this2$props=_this2.props,project=_this2$props.project,schoolClass=_this2$props.schoolClass;Object(__WEBPACK_IMPORTED_MODULE_9__apiCall__["a" /* default */])('/generalMaterial/'+schoolClass.LanguageId+'/'+project.DefaultDifficultyId+'/'+_this2.game.id).then(function(generalMaterials){_this2.setState({gameMaterials:generalMaterials});});};_this2.submitGameScores=function(){if(!_this2.allowSubmit){_this2.setState({showWarning:true});var _this=_this2;setTimeout(function(){_this.setState({showWarning:false});},5000);return false;}Object(__WEBPACK_IMPORTED_MODULE_9__apiCall__["a" /* default */])('/simulatiespel/bonusAssignmentScores',_this2.state.gameScores,'POST').then(function(){_this2.props.dispatch(refreshProject());_this2.setState({isEditing:false});});};_this2.getRoundOneBonusPointsForGroup=function(group){if(!group.Rounds||group.Rounds.length===0)return{points:0,globas:0};var round1=group.Rounds.find(function(r){return r.roundNumber===1;});var gameState=round1?round1.GameStates.find(function(gs){return gs.type==='BONUS_ASSIGNMENT';}):null;if(gameState){return{globas:gameState.globas,points:gameState.points};}return{points:0,globas:0};};_this2.state={gameScores:{},showBonus:false,showWarning:false,gameMaterials:[],isEditing:false};_this2.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this2.props.gameState.DefaultDifficultyId);return _this2;}_createClass(BonusPoints,[{key:'componentWillMount',value:function componentWillMount(){var _this3=this;if(!this.game.id)return;this.fetchGeneralMaterials();var _props=this.props,dispatch=_props.dispatch,project=_props.project,schoolClass=_props.schoolClass;Object(__WEBPACK_IMPORTED_MODULE_12__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhbvtextraopdrachten_T1':'mlbvtextraopdrachten_T1',dispatch);var gameScores={};if(this.submittedScores){schoolClass.Groups.forEach(function(group){var bonus=_this3.getRoundOneBonusPointsForGroup(group);if(bonus&&(bonus.points>0||bonus.globas>0)){gameScores[group.id]=bonus;}});this.setState({gameScores:gameScores});}}},{key:'render',value:function render(){var _this4=this;var _props2=this.props,schoolClass=_props2.schoolClass,project=_props2.project;if(!this.game.id){return null;}var assignGameScoreOnce=this.assignGameScoreOnce;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.props.desktop?'portal-home portal-verdelen classleader-portal darkBckg':'portal-verdelen classleader-portal darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtextraopdrachten_1',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bonuspunten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-portal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__["a" /* default */],{popupId:'mlbvtextraopdrachten_1',tag:'h3'})),this.props.desktop?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],{style:{marginBottom:'20px',padding:'15px'},onClick:function onClick(){return _this4.state.showBonus?_this4.setState({showBonus:false}):_this4.setState({showBonus:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-container bekijk-bonusopdrachten-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bekijk_bonusopdrachten')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_img_caret_down_grey_svg___default.a,className:this.state.showBonus?'turn arrow-down':'arrow-down',alt:'arrow-down'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bonus-materials-wrapper'+(this.state.showBonus||this.props.desktop?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_GameMaterials__["a" /* default */],{items:this.state.gameMaterials}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'column-portal'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'group-rows-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtverdiendebonuspunten',tag:'h3'})),schoolClass.Groups.map(function(group){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_GroupGameScoreRow__["a" /* default */],{key:group.id,bonus:true,text:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(group.name),color:group.GroupTheme.color,score:_this4.state.gameScores[group.id]||{},editable:!_this4.submittedScores||_this4.state.isEditing,isPoints:true,gameScores:(project.overrideBonusScores&&project.customBonusScores&&project.customBonusScores.length?project.customBonusScores:_this4.game.GameScores).filter(function(gs){var gameScores=_this4.state.gameScores;var difficultyFilter=project.lite?gs.DifficultyId===null&&!!gs.lite:gs.DifficultyId===project.DefaultDifficultyId;if(!assignGameScoreOnce){return difficultyFilter;}var used=Object.keys(gameScores).find(function(key){// LITE scores are stored without globas, so normalise both
// sides before comparing: null/undefined must match 0.
return Number(gameScores[key].points)===Number(gs.points)&&Number(gameScores[key].globas||0)===Number(gs.globas||0)&&parseInt(key,10)!==group.id;});return difficultyFilter&&!used;}),onChange:function onChange(value){_this4.gameScoreUpdate(group.id,value);}});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!this.submittedScores||this.state.isEditing?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:!this.allowSubmit?'disabled':'',style:{pointerEvents:'all'},onClick:this.submitGameScores},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_opslaan'))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{style:{pointerEvents:'all',backgroundColor:'#e8ac1b'},onClick:function onClick(){return _this4.setState({isEditing:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bonuspunten_aanpassen'))),!this.allowSubmit&&this.state.showWarning?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'10px',fontWeight:'bold',color:'white',textShadow:'0 0px 4px rgba(0, 0, 0, 0.5)',textAlign:'center'}},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bonuspunten_toekennen_uitleg')):null))));}},{key:'game',get:function get(){var schoolClass=this.props.schoolClass;if(Array.isArray(schoolClass.SchoolClassGames)){var scg=schoolClass.SchoolClassGames.find(function(g){return g.GameId===3;});if(scg)return scg.Game;}return{};}},{key:'submittedScores',get:function get(){var Rounds=this.props.gameState.Rounds;return!!Rounds.find(function(r){return r.GameStates.find(function(gs){return gs.type==='BONUS_ASSIGNMENT';});});}},{key:'assignGameScoreOnce',get:function get(){var project=this.props.project;if(project.overrideBonusScores)return!!project.customAssignBonusScoreOnce;var settings=this.game.assignGameScoreOnce||{};var key=project.lite?'basic_lite':project.difficulty.toLowerCase();// A missing key means the setting was never stored for this difficulty (LITE was
// added after the game record). The admin checkbox shows those as enabled, so
// only an explicit false turns the restriction off.
return settings[key]!==false;}},{key:'allowSubmit',get:function get(){var rounds=this.props.gameState.Rounds;if(!rounds||rounds.length===0)return false;var round=rounds[rounds.length-1];// Use current round
if(!round)return false;return round.state.startsWith('SIMULATION_')||round.state==='END';}}]);return BonusPoints;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}).isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(_ref){var project=_ref.project,schoolClass=_ref.schoolClass,gameState=_ref.gameState;return{project:project,schoolClass:schoolClass,gameState:gameState};})(BonusPoints));

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_GameMaterials__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_popupHelper__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClassBonusPoints=(_temp=_class=function(_Component){_inherits(ClassBonusPoints,_Component);function ClassBonusPoints(props){_classCallCheck(this,ClassBonusPoints);var _this=_possibleConstructorReturn(this,(ClassBonusPoints.__proto__||Object.getPrototypeOf(ClassBonusPoints)).call(this,props));_this.fetchGeneralMaterials=function(){var _this$props=_this.props,project=_this$props.project,schoolClass=_this$props.schoolClass;Object(__WEBPACK_IMPORTED_MODULE_7__apiCall__["a" /* default */])('/generalMaterial/'+schoolClass.LanguageId+'/'+project.DefaultDifficultyId+'/'+_this.game.id).then(function(assignments){_this.setState({assignments:assignments});});};_this.state={gameScores:{},assignments:[],showBonus:false};return _this;}_createClass(ClassBonusPoints,[{key:'componentWillMount',value:function componentWillMount(){if(!this.game.id)return;var _props=this.props,dispatch=_props.dispatch,project=_props.project,gameState=_props.gameState;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(currentRound<=1){Object(__WEBPACK_IMPORTED_MODULE_8__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtextraopdrachten_T':'mlgvtextraopdrachten_T',dispatch);}this.fetchGeneralMaterials();}},{key:'render',value:function render(){var desktop=this.props.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'classleader-prepare '+(desktop?'portal-home darkBckg desktop-single':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container general-materials-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{history:this.props.history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_PopupTitle__["a" /* default */],{popupId:this.props.project.difficulty==="PRO"?'mhgvtextraopdrachten':'mlgvtextraopdrachten',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_bonuspunten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_GameMaterials__["a" /* default */],{items:this.state.assignments})));}},{key:'game',get:function get(){var schoolClass=this.props.schoolClass;if(Array.isArray(schoolClass.SchoolClassGames)){var scg=schoolClass.SchoolClassGames.find(function(g){return g.Game.abbreviation==='BO';});if(scg)return scg.Game;}return{};}}]);return ClassBonusPoints;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}).isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(_ref){var project=_ref.project,schoolClass=_ref.schoolClass,gameState=_ref.gameState;return{project:project,schoolClass:schoolClass,gameState:gameState};})(ClassBonusPoints));

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Pictures_js__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__history_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClassLeaderMedia=function(_Component){_inherits(ClassLeaderMedia,_Component);function ClassLeaderMedia(props){_classCallCheck(this,ClassLeaderMedia);var _this=_possibleConstructorReturn(this,(ClassLeaderMedia.__proto__||Object.getPrototypeOf(ClassLeaderMedia)).call(this,props));_this.toggleTab=function(no){_this.setState({activeTab:no});};_this.getTabPage=function(){var desktop=false;if(window.width>1024){desktop=true;}if(desktop){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom___default.a,{style:{margin:"20px auto",width:'800px',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Pictures_js__["a" /* default */],{history:__WEBPACK_IMPORTED_MODULE_4__history_js__["a" /* default */]}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Pictures_js__["a" /* default */],{history:__WEBPACK_IMPORTED_MODULE_4__history_js__["a" /* default */]});};_this.state={activeTab:0};return _this;}_createClass(ClassLeaderMedia,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portal-home school-class-media class-leader-media darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktop-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonRow media classleader'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_GoBackButton__["a" /* default */],{history:this.props.history}))),this.getTabPage());}}]);return ClassLeaderMedia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__["a" /* default */])(function(state){return{project:state.project};})(ClassLeaderMedia));

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_left_pad__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_left_pad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_left_pad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_imageResizer__ = __webpack_require__(186);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _actions$schoolClass=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].schoolClass,addPhoto=_actions$schoolClass.addPhoto,removePhoto=_actions$schoolClass.removePhoto;var Pictures=(_temp=_class=function(_Component){_inherits(Pictures,_Component);function Pictures(props){var _this2=this;_classCallCheck(this,Pictures);var _this=_possibleConstructorReturn(this,(Pictures.__proto__||Object.getPrototypeOf(Pictures)).call(this,props));_this.upload=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(files){var formData,localLastUploadName,maxUploads,lastPhotoUploaded,newPhotoNum;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:formData=new FormData();// eslint-disable-next-line
localLastUploadName=false;maxUploads=20-_this.props.schoolClass.SchoolClassPhotos.length;lastPhotoUploaded=_this.props.schoolClass.SchoolClassPhotos[_this.props.schoolClass.SchoolClassPhotos.length-1];newPhotoNum=lastPhotoUploaded&&lastPhotoUploaded.Photo&&lastPhotoUploaded.Photo.filename&&!isNaN(parseInt(lastPhotoUploaded.Photo.filename.split('-')[1],10))?parseInt(lastPhotoUploaded.Photo.filename.split('-')[1],10):0;_context2.next=7;return Object.keys(files).map(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(fileKey){var file,fileName,resized;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:file=files[fileKey];if(!(file&&file.name)){_context.next=13;break;}if(!(maxUploads<=0)){_context.next=4;break;}return _context.abrupt('return');case 4:maxUploads--;newPhotoNum++;fileName=('B-'+__WEBPACK_IMPORTED_MODULE_5_left_pad___default()(newPhotoNum,2,0)+'-'+_this.props.schoolClass.className+'-'+_this.props.schoolClass.classRoom).replace(/[^a-z0-9]/gi,'_')+'.jpeg';_context.next=9;return Object(__WEBPACK_IMPORTED_MODULE_11__helpers_imageResizer__["a" /* default */])(file,1200,1200,0.8,fileName);case 9:resized=_context.sent;formData.append('file',resized,resized.name);_context.next=13;return Object(__WEBPACK_IMPORTED_MODULE_6__apiCall__["a" /* default */])('/file/upload',formData,'POST').then(function(f){localLastUploadName=fileName;_this.props.dispatch(addPhoto(_this.props.schoolClass.id,{PhotoId:f[0].id}));});case 13:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}());case 7:case'end':return _context2.stop();}}},_callee2,_this2);}));return function(_x){return _ref.apply(this,arguments);};}();_this.deviceAndDifficulty=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_popupHelper__["h" /* getPopupDeviceDifficulty */])(_this.props.gameState.DefaultDifficultyId);return _this;}_createClass(Pictures,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,gameState=_props.gameState;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(currentRound<=1){Object(__WEBPACK_IMPORTED_MODULE_10__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(gameState.difficulty==="PRO"?'mhbvtfotos_T':'mlbvtfotos_T',dispatch);}}},{key:'render',value:function render(){var _this3=this;var schoolClass=this.props.schoolClass;if(!schoolClass.loaded)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:this.props.desktop?'portal-home darkBckg':''},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pictures pictures-view'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container classleader-portal'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_PopupTitle__["a" /* default */],{popupId:this.deviceAndDifficulty+'bvtfotos',tag:'h3'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'photos-container'},schoolClass.SchoolClassPhotos.map(function(photo,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'photo',key:photo.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'photo-wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'trash-button',onClick:function onClick(){if(window.confirm(Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bevestig_verwijder_photo_melding'))){_this3.props.dispatch(removePhoto(photo.id));}}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_7__assets_assets__["d" /* icons */].trash,alt:'trash'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:photo.Photo.url,alt:'afbeelding'}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,photo.Photo.filename));})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{position:'fixed',bottom:'20px',left:0,right:0}},schoolClass.SchoolClassPhotos.length<20?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'upload-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'upload-container-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_upload'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'file',name:'photo',accept:'image/png,image/jpeg',multiple:true,onChange:function onChange(e){_this3.upload(e.target.files);}}))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'warning-message'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_fotos_let_op_maximaal_fotos'))))));}}]);return Pictures;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{schoolClass:state.schoolClass,gameState:state.gameState};})(Pictures));

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GlobalPopup__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PopupContainer=function(_Component){_inherits(PopupContainer,_Component);function PopupContainer(){_classCallCheck(this,PopupContainer);return _possibleConstructorReturn(this,(PopupContainer.__proto__||Object.getPrototypeOf(PopupContainer)).apply(this,arguments));}_createClass(PopupContainer,[{key:"render",value:function render(){var props=this.props;var popupState=props.popupState;if(false)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,popupState.popupId?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__GlobalPopup__["a" /* default */],null):null);}}]);return PopupContainer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux_es_connect_connect__["a" /* default */])(function(state){return state;})(PopupContainer)));

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_close_png__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_close_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_close_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updatePopups=__WEBPACK_IMPORTED_MODULE_5__actions__["a" /* default */].popup.updatePopups;var GlobalPopup=(_temp=_class=function(_Component){_inherits(GlobalPopup,_Component);function GlobalPopup(props){_classCallCheck(this,GlobalPopup);var _this=_possibleConstructorReturn(this,(GlobalPopup.__proto__||Object.getPrototypeOf(GlobalPopup)).call(this,props));_initialiseProps.call(_this);_this.state={history:[props.popupState.popupId],count:null,cur:1};_this.closePopup=_this.closePopup.bind(_this);_this.handleKeyPress=_this.handleKeyPress.bind(_this);_this.handleClick=_this.handleClick.bind(_this);return _this;}_createClass(GlobalPopup,[{key:'componentWillMount',value:function componentWillMount(){document.body.classList.add('noScroll');document.addEventListener("keydown",this.handleKeyPress);document.addEventListener('click',this.handleClick);if(this.state.count===null){var first=this.props.popupState.popupId;var popupState=this.props.popupState;var tourCount=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["b" /* getAllTourPopups */])(first,popupState.tutorial);this.setState({history:[popupState.popupId],count:tourCount,desktop:popupState.isDesktop||false,oneTimePopup:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["c" /* getAuto */])(popupState.popupId),localRead:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["e" /* getLocalRead */])(popupState.popupId),tutorial:popupState.tutorial});}}},{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('noScroll');document.removeEventListener("keydown",this.handleKeyPress);document.removeEventListener('click',this.handleClick);if(this.state.oneTimePopup)Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["j" /* setLocalRead */])(this.state.history[0]);}},{key:'handleClick',value:function handleClick(event){if(this.state.hide){return;}if(document.getElementsByClassName('popup').length&&!document.getElementsByClassName('popup')[0].contains(event.target)&&!event.target.classList.contains("popupControl")&&this.props.popupState.closeable){this.closePopup();}}},{key:'handleKeyPress',value:function handleKeyPress(event){if(event.keyCode===27){if(this.props.popupState.closeable){this.closePopup();}}}/**
   * Method to show next popup
   *//**
   * Method to show previous popup
   */},{key:'closePopup',/**
   * Method to close the current pop-up and reset the Popup state
   * @returns {*}
   */value:function closePopup(){var dispatch=this.props.dispatch;dispatch(updatePopups({popupId:null,closeable:true}));this.setState({history:[],count:null,cur:1});}},{key:'render',value:function render(){var _this2=this;var props=this.props,showPrev=this.showPrev,showNext=this.showNext,state=this.state;var popupState=props.popupState,gameState=props.gameState;var popupId=popupState.popupId,closeable=popupState.closeable;var isPortal=window.location.pathname.indexOf('portal')!==-1;if(state.oneTimePopup&&state.localRead)this.closePopup();var nextId='';if(popupId){nextId=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["f" /* getNext */])(popupId,state.tutorial);}if(this.state.hide){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"popup-parent "+(popupId?'active':'')+(isPortal?' is-portal':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-page-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-spacer-desktop'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-holder'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-holder-inner'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup',ref:function ref(node){return _this2.node=node;}},!state.count&&closeable||state.count===1&&state.count===state.cur?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:this.closePopup,className:'top-right-close-button close-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'close-icon'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_8__assets_img_close_png___default.a,height:'15',alt:''}))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-content',dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["d" /* getContent */])(popupId,gameState.language)}}),state.count>=1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'popup-navigation'},nextId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'tut-next',onClick:function onClick(ev){showNext(ev,nextId);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'popupControl'},Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_volgende_button'))):null,state.count>1&&state.count===state.cur?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'tut-close',onClick:this.closePopup},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'popupControl'},Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_aan_de_slag_button'))):null,state.count>1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tutorial-counter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'popupControl'},state.cur),'/',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'popupControl'},state.count)):null,state.history.length>1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:"button--white tut-prev",onClick:function onClick(ev){showPrev(ev);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'popupControl'},Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_vorige_button'))):null):null))))));}}]);return GlobalPopup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={id:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,elementFocus:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string},_class.defaultProps={popupId:'',elementFocus:''},_initialiseProps=function _initialiseProps(){var _this3=this;this.showNext=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(ev,nextId){var state,props,dispatch,cur,stateHistory;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:state=_this3.state,props=_this3.props;dispatch=props.dispatch;cur=state.cur;stateHistory=state.history;stateHistory.push(nextId);cur++;dispatch(updatePopups({popupId:nextId}));_this3.setState({history:stateHistory,cur:cur});case 8:case'end':return _context.stop();}}},_callee,_this3);}));return function(_x,_x2){return _ref.apply(this,arguments);};}();this.showPrev=function(ev){var state=_this3.state,props=_this3.props;var dispatch=props.dispatch;var cur=state.cur;var stateHistory=state.history;stateHistory.pop();--cur;dispatch(updatePopups({popupId:stateHistory[stateHistory.length-1]}));_this3.setState({history:stateHistory,cur:cur});};},_temp);;/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_es_connect_connect__["a" /* default */])(function(state){return state;})(GlobalPopup)));

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ToggleFullscreen; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_icons_fullscreen_svg__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_icons_fullscreen_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_icons_fullscreen_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_fullscreen_close_svg__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_icons_fullscreen_close_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_fullscreen_close_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ToggleFullscreen=function(_Component){_inherits(ToggleFullscreen,_Component);function ToggleFullscreen(props){_classCallCheck(this,ToggleFullscreen);var _this=_possibleConstructorReturn(this,(ToggleFullscreen.__proto__||Object.getPrototypeOf(ToggleFullscreen)).call(this,props));_this.state={fullscreen:false};_this.toggleScreen=_this.toggleScreen.bind(_this);_this.handleEsc=_this.handleEsc.bind(_this);return _this;}_createClass(ToggleFullscreen,[{key:"componentWillMount",value:function componentWillMount(){document.addEventListener('fullscreenchange',this.handleEsc);document.addEventListener('webkitfullscreenchange',this.handleEsc);document.addEventListener('mozfullscreenchange',this.handleEsc);document.addEventListener('MSFullscreenChange',this.handleEsc);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener('fullscreenchange',this.handleEsc);document.removeEventListener('webkitfullscreenchange',this.handleEsc);document.removeEventListener('mozfullscreenchange',this.handleEsc);document.removeEventListener('MSFullscreenChange',this.handleEsc);}},{key:"handleEsc",value:function handleEsc(){if(!document.fullscreenElement&&!document.webkitIsFullScreen&&!document.mozFullScreen&&!document.msFullscreenElement){this.setState({fullscreen:!(false!==true)});}}},{key:"toggleScreen",value:function toggleScreen(){var state=this.state;var elem=document.documentElement;if(state.fullscreen){if(document.exitFullscreen){document.exitFullscreen();}else if(document.mozCancelFullScreen){document.mozCancelFullScreen();}else if(document.webkitExitFullscreen){document.webkitExitFullscreen();}else if(document.msExitFullscreen){document.msExitFullscreen();}this.setState({fullscreen:!state.fullscreen});}else{if(elem.requestFullscreen){elem.requestFullscreen();}else if(elem.mozRequestFullScreen){elem.mozRequestFullScreen();}else if(elem.webkitRequestFullscreen){elem.webkitRequestFullscreen();}else if(elem.msRequestFullscreen){elem.msRequestFullscreen();}this.setState({fullscreen:!state.fullscreen});}}},{key:"render",value:function render(){var fullscreen=this.state.fullscreen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"toggle-fullscreen orange-circle-button",onClick:this.toggleScreen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"viewType",src:fullscreen?__WEBPACK_IMPORTED_MODULE_2__assets_img_icons_fullscreen_close_svg___default.a:__WEBPACK_IMPORTED_MODULE_1__assets_img_icons_fullscreen_svg___default.a}));}}]);return ToggleFullscreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fullscreen.3b26ad37.svg";

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fullscreen_close.d521f6af.svg";

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HideDesktopMobileContents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HideDesktopMobileContents=function(_Component){_inherits(HideDesktopMobileContents,_Component);function HideDesktopMobileContents(){_classCallCheck(this,HideDesktopMobileContents);return _possibleConstructorReturn(this,(HideDesktopMobileContents.__proto__||Object.getPrototypeOf(HideDesktopMobileContents)).apply(this,arguments));}_createClass(HideDesktopMobileContents,[{key:'render',value:function render(){var desktop=document.querySelector('#root').clientWidth>=1240;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:(desktop?'desktop':'mobiele')+'-notification refresh-page'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_'+(desktop?'mobile':'desktop')+'_view_notification')));}}]);return HideDesktopMobileContents;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__desktop_Home__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__ = __webpack_require__(19);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var Desktop=(_temp=_class=function(_Component){_inherits(Desktop,_Component);function Desktop(props){_classCallCheck(this,Desktop);var _this=_possibleConstructorReturn(this,(Desktop.__proto__||Object.getPrototypeOf(Desktop)).call(this,props));_this.state={};return _this;}_createClass(Desktop,[{key:'componentWillUnmount',value:function componentWillUnmount(){document.body.classList.remove('desktop-map');}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,gameState=_props.gameState,dispatch=_props.dispatch,project=_props.project;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(currentRound===1&&gameState.currentStep===1){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'dhgvtlandbesturen1_T1':'dlgvtlandbesturen1_T1',dispatch,false,true);}if(currentRound===2&&gameState.currentStep===1){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'dhgvtlandbesturen2_T1':'dlgvtlandbesturen2_T1',dispatch,true,true);}if(currentRound===1&&gameState.currentStep===3){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'dhgvtbudgetverdelen_T1':'dlgvtbudgetverdelen_T1',dispatch,false,true);}if(currentRound===1&&gameState.currentStep===2){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'dhgvtbelastingheffen_T1':'dlgvtbelastingheffen1_T1',dispatch,false,true);}if(currentRound===2&&gameState.currentStep===2){if(project.difficulty==="BASIC"){Object(__WEBPACK_IMPORTED_MODULE_3__helpers_popupHelper__["a" /* dispatchUnreadPopup */])('dlgvtbelastingheffen2_T1',dispatch);}}document.body.classList.add('desktop-map');}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__desktop_Home__["a" /* default */],{history:this.props.history,currentMin:this.props.match.params.id}));}}]);return Desktop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return state;})(Desktop));

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_MapView__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_MapElement__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_MapEconomy__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_MapPolicy__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_logo_png__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DifficultyAwareComponent__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var Home=(_temp=_class=function(_DifficultyAwareCompo){_inherits(Home,_DifficultyAwareCompo);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.toggleTourPopUp=function(direction){if(direction==="prev"&&_this.state.tourPopUpCount>0){if(_this.state.tourPopups[_this.state.tourPopUpCount-1]){_this.setState({tourPopUpCount:_this.state.tourPopUpCount-1});}}else{if(_this.state.tourPopups[_this.state.tourPopUpCount+1]){_this.setState({tourPopUpCount:_this.state.tourPopUpCount+1});}else{_this.setState({tour:false});}}};_this.allowSave=function(){var _this$props=_this.props,gameState=_this$props.gameState,gameStateInput=_this$props.gameStateInput,policyChoice=_this$props.policyChoice;if(gameState.difficulty==='BASIC'&&Object(__WEBPACK_IMPORTED_MODULE_13__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,gameStateInput.myState.policyChoices,_this.props.project.minPolicyChoices)>0){return false;}return true;};_this.deselect=function(isHighlighted){console.log(isHighlighted);};_this.state={tour:false,tourPopUpCount:0,lowBudgetWarning:true,showWarning:'',tourPopups:[{title:'Welkom in Globaland',nextUpType:'nextPopUp',img:__WEBPACK_IMPORTED_MODULE_15__assets_img_logo_png___default.a,buttonText:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])('sim_volgende_button'),align:'center'},{title:'Om te beginnen',description:'Bedenk een leuke naam voor jullie land en upload je teamfoto. \n\n Let op: alleen de teamleider kan informatie invoeren. De overige teamleden kunnen alleen informatie bekijken. Je kunt per spelronde wisselen van rol.',nextUpType:'nextPopUp',buttonText:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])('sim_volgende_button')},{title:'Land besturen',description:'In deze app kun je je land besturen. Elke spelronde bestaat uit 3 stappen: 1. Hoe staat je land ervoor? 2. Belasting heffen 3. Budget verdelen Op sommige plekken kun je pas verder als alle groepen van de klas klaar zijn of als de begeleider het vervolg heeft geactiveerd.',nextUpType:'close',buttonText:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])('sim_sluiten')}]};_this.toggleTourPopUp=_this.toggleTourPopUp.bind(_this);return _this;}_createClass(Home,[{key:'renderLaag',value:function renderLaag(){var _this2=this;var position=__WEBPACK_IMPORTED_MODULE_10__Defines__["a" /* default */].position;var tour=this.state.tour;var currentPopUp=this.state.tourPopups[this.state.tourPopUpCount];var _props=this.props,gameState=_props.gameState,feedback=_props.feedback,myState=_props.myState,policyChoice=_props.policyChoice;var prevRoundSum=gameState.prevRoundSum,currentRound=gameState.currentRound;if(!prevRoundSum)return null;var niveau=this.props.project.difficulty.toLowerCase();var budget=gameState.totalGameStateSum.globas;var currentRoundGameState=gameState.Rounds[currentRound];var currentMin=this.props.currentMin;if(this.props.history.location.pathname.toLowerCase().indexOf('beleidskeuzes')>-1){currentMin='beleidskeuzes';}if(this.props.history.location.pathname.toLowerCase().indexOf('economy')>-1){currentMin='economy';}//Redirect to feedbackitem when solely the ministry is selected
if(this.props.currentMin){var target=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["n" /* getLowMinistryFeedbackLink */])(this.props.feedback.prevRoundFeedbackData,this.props.currentMin,this.props.gameState,this.props.gameStateInput,true);if(target.length>0){this.props.history.push(target[0]);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-map step-'+gameState.currentStep},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["CSSTransition"],{'in':tour,timeout:200,classNames:'animation',unmountOnExit:true},function(state){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{title:currentPopUp.title,description:currentPopUp.description,img:currentPopUp.img,align:currentPopUp.align,nextUpType:currentPopUp.nextUpType,buttonText:currentPopUp.buttonText,showPopUp:_this2.state.tour,nthPopup:_this2.state.tourPopUpCount,nPopups:_this2.state.tourPopups.length,closePopUpClick:_this2.toggleTourPopUp,navigation:true});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_MapView__["a" /* default */],{history:this.props.history,unHighlight:!!currentMin},gameState.currentStep!==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_MapEconomy__["a" /* default */],{target:currentMin==='economy'?'/':'/economy/total',title:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])("sim_economie"),top:position["economy"]['basic']["top"],left:!(gameState.currentStep===1&&gameState.currentRound>1&&this.props.project.minPolicyChoices>0)&&gameState.currentStep!==3?position["economy"]['pro']["left"]:position["economy"]['basic']["left"],history:this.props.history,roundPoints:currentRoundGameState.earnedPoints,economy:gameState.totalEconomy,feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(feedback.prevRoundFeedbackData),true),unHighlight:currentMin?currentMin.toLowerCase()!=='economy':''}):'',!(gameState.currentStep===1&&gameState.currentRound>1)&&gameState.currentStep!==3?null:this.props.project.minPolicyChoices>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_MapPolicy__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),target:currentMin==='beleidskeuzes'?'/':'/beleidskeuzes',step:gameState.currentStep,top:gameState.currentStep===3?position["economy"]['pro']["top"]:position["policy"]["top"],left:gameState.currentStep===3?position["economy"]['pro']["left"]:position["policy"]["left"],number:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_13__helpers_policyChoiceHelper__["k" /* getTotalCosts */])(myState.policyChoices,policyChoice):Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["v" /* getPolicyChoiceTotalPoints */])(feedback.prevRoundFeedbackData),suffix:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])('sim_miljard'):Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])('sim_punten'),history:this.props.history,feedbackCount:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_13__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,myState.policyChoices,this.props.project.minPolicyChoices):Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData),null,true),unHighlight:currentMin?currentMin.toLowerCase()!=='beleidskeuzes':''}):null,__WEBPACK_IMPORTED_MODULE_10__Defines__["a" /* default */].basic.ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_MapElement__["a" /* default */],{key:min,targetz:'/ministries/'+(gameState.currentStep===3?'budget/':'')+min.toLowerCase(),target:gameState.currentStep===3?'/ministries/budget/'+min.toLowerCase():Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["n" /* getLowMinistryFeedbackLink */])(_this2.props.feedback.prevRoundFeedbackData,min,_this2.props.gameState,_this2.props.gameStateInput).length>0?Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["n" /* getLowMinistryFeedbackLink */])(_this2.props.feedback.prevRoundFeedbackData,min,_this2.props.gameState,_this2.props.gameStateInput)[0]:'/ministries/'+min.toLowerCase(),title:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])(min),icon:min,value:gameState.gameStateSum[min+'_value'],stars:false,international:__WEBPACK_IMPORTED_MODULE_10__Defines__["a" /* default */].i18nMinistries.includes(min),top:position[min]["basic"]["top"],left:position[min]["basic"]["left"],globas:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(myState.ministerieGlobaVerdeling,min,gameState.currentStep),feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["z" /* getUnreadCount */])(min,_this2.props.feedback.prevRoundFeedbackData),difficulty:niveau,roundPoints:prevRoundSum[min+'_points'],budgetSet:false,policySet:false,disaster:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["C" /* ministryHasDisaster */])(min,_this2.props.feedback),history:_this2.props.history,unHighlight:currentMin?currentMin.toUpperCase()!==min:''});})),gameState.currentStep===3&&gameState.currentRound<4&&this.state.lowBudgetWarning&&budget<30&&!this.props.gameState.history&&this.props.project.bankEnabled!==false?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default.a,className:'desktopMapBottom',popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])('sim_beperkt_budget_melding'),showIfUnread:gameState.currentRound+'-limitedBudget',closePopUpCross:true,closePopUpClick:function closePopUpClick(){return _this2.setState({lowBudgetWarning:false});}}):null,this.state.showWarning.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default.a,className:'desktopMapBottom',popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])(this.state.showWarning),closePopUpClick:function closePopUpClick(){return _this2.setState({showWarning:''});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_NextStep__["a" /* default */],null));}},{key:'renderHoog',value:function renderHoog(){var _this3=this;var position=__WEBPACK_IMPORTED_MODULE_10__Defines__["a" /* default */].position;var tour=this.state.tour;var currentPopUp=this.state.tourPopups[this.state.tourPopUpCount];var _props2=this.props,gameState=_props2.gameState,myState=_props2.myState,feedback=_props2.feedback;var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;var niveau=this.props.project.difficulty.toLowerCase();var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling;var myPolicyChoices=Object.values(myState.policyChoices);var budget=gameState.totalGameStateSum.globas;var currentMin=this.props.currentMin;if(this.props.history.location.pathname.toLowerCase().indexOf('economy')>-1){currentMin='economy';}if(this.props.history.location.pathname.toLowerCase().indexOf('loss')>-1){currentMin='loss';}if(this.props.history.location.pathname.toLowerCase().indexOf('profit')>-1){currentMin='profit';}if(this.props.history.location.pathname.toLowerCase().indexOf('earned')>-1){currentMin='earned';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'home-map step-'+gameState.currentStep},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["CSSTransition"],{'in':tour,timeout:200,classNames:'animation',unmountOnExit:true},function(state){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{title:currentPopUp.title,description:currentPopUp.description,img:currentPopUp.img,align:currentPopUp.align,nextUpType:currentPopUp.nextUpType,buttonText:currentPopUp.buttonText,showPopUp:_this3.state.tour,nthPopup:_this3.state.tourPopUpCount,nPopups:_this3.state.tourPopups.length,closePopUpClick:_this3.toggleTourPopUp,navigation:true});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_MapView__["a" /* default */],{history:this.props.history,unHighlight:!!currentMin,onClick:function onClick(_){return _this3.deselect(!!currentMin);}},gameState.currentStep!==3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_MapEconomy__["a" /* default */],{to:'/economy/total',target:currentMin==='economy'?'/':'/economy/total',title:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])("sim_economie"),top:position["economy"]["pro"]["top"],left:position["economy"]["pro"]["left"],roundPoints:gameState.Rounds[gameState.currentRound].earnedPoints,economy:gameState.totalEconomy,history:this.props.history,feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(feedback.prevRoundFeedbackData),true),unHighlight:currentMin?!['economy','profit','loss','earned'].includes(currentMin.toLowerCase()):''}):null,__WEBPACK_IMPORTED_MODULE_10__Defines__["a" /* default */].pro.ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_MapElement__["a" /* default */],{key:min,target:'/ministries/'+(gameState.currentStep===3?'budget/':'')+min.toLowerCase(),title:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])(min),icon:min,value:gameState.gameStateSum[min+'_value'],stars:__WEBPACK_IMPORTED_MODULE_10__Defines__["a" /* default */].ministeryStars[min],international:__WEBPACK_IMPORTED_MODULE_10__Defines__["a" /* default */].i18nMinistries.includes(min),top:position[min]["pro"]["top"],left:position[min]["pro"]["left"],feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["z" /* getUnreadCount */])(min,_this3.props.feedback.prevRoundFeedbackData),difficulty:niveau,globas:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(ministerieGlobaVerdeling,min,gameState.currentStep,myPolicyChoices),roundPoints:prevRoundSum[min+'_points'],budgetSet:ministerieGlobaVerdeling[min]&&gameState.currentStep>1,policySet:myPolicyChoices.find(function(choice){return choice.ministry===min&&choice.selected;})&&gameState.currentStep>1,history:_this3.props.history,disaster:Object(__WEBPACK_IMPORTED_MODULE_12__helpers_feedbackHelpers__["C" /* ministryHasDisaster */])(min,_this3.props.feedback),unHighlight:currentMin?currentMin.toUpperCase()!==min:''});})),gameState.currentStep===3&&gameState.currentRound<4&&this.state.lowBudgetWarning&&budget<250&&!this.props.gameState.history?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{className:'desktopMapBottom',img:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])('sim_beperkt_budget_melding'),showIfUnread:gameState.currentRound+'-limitedBudget',closePopUpCross:true,closePopUpClick:function closePopUpClick(){return _this3.setState({lowBudgetWarning:false});}}):null,this.state.showWarning.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopUp__["a" /* default */],{className:'desktopMapBottom',img:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_16_i18n_for_browser__["a" /* __ */])(this.state.showWarning),closePopUpClick:function closePopUpClick(){return _this3.setState({showWarning:''});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_NextStep__["a" /* default */],null));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_17__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(_ref){var gameState=_ref.gameState,user=_ref.user,gameStateInput=_ref.gameStateInput,feedback=_ref.feedback,project=_ref.project,policyChoice=_ref.policyChoice;return{gameState:gameState,user:user,gameStateInput:gameStateInput,myState:gameStateInput.myState,feedback:feedback,project:project,policyChoice:policyChoice};})(Home));

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_EconomyTotal__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_EconomyEarned__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_ministriesHelper__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_sparen_bank_svg__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_sparen_bank_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_sparen_bank_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__elements_PolicyChoiceLaag__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__elements_StepThree_MinistryFeedbackStatus__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_img_icons_economy_up_min_globas_svg__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__assets_img_icons_economy_up_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__assets_img_icons_economy_up_min_globas_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var Ministries=(_temp=_class=function(_DifficultyAwareCompo){_inherits(Ministries,_DifficultyAwareCompo);function Ministries(props){_classCallCheck(this,Ministries);var _this=_possibleConstructorReturn(this,(Ministries.__proto__||Object.getPrototypeOf(Ministries)).call(this,props));_this.toggleOverviewPopUp=function(){_this.setState({showOverview:!_this.state.showOverview});};_this.state={showOverview:false,showWarning:''};return _this;}_createClass(Ministries,[{key:'componentDidMount',value:function componentDidMount(){var gameState=this.props.gameState;if(gameState.currentStep===3){document.querySelector('.sidebar').classList.add('step3');document.querySelector('.main').classList.add('step3');}else{document.querySelector('.sidebar').classList.remove('step3');document.querySelector('.main').classList.remove('step3');}}},{key:'renderLaag',value:function renderLaag(){var _this2=this;var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,feedback=_props.feedback,policyChoice=_props.policyChoice,group=_props.group;var prevRoundSum=gameState.prevRoundSum;var _gameStateInput$mySta=gameStateInput.myState,ministerieGlobaVerdeling=_gameStateInput$mySta.ministerieGlobaVerdeling,policyChoices=_gameStateInput$mySta.policyChoices,ministryCollaborations=_gameStateInput$mySta.ministryCollaborations;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];var prevRoundFeedbackData=feedback.prevRoundFeedbackData;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,policyChoices,ministerieGlobaVerdeling,savingsAndLoans,policyChoice);if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var filteredPolicyChoices=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_policyChoiceHelper__["l" /* groupByProblem */])(policyChoice);var unreadWinstGlobas=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["B" /* getUnreadWinstGlobas */])(prevRoundFeedbackData).length;var unreadVerliesGlobas=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["A" /* getUnreadVerliesGlobas */])(prevRoundFeedbackData).length;var params=this.props.match.params;var isFeedback=!!params.feedbackIdentifier;var isStartSituation=group.Rounds.length===2;var currentMin=params.ministryId||params.economyType||params.id||params.type;if(params.effect==='loss'){currentMin='loss';}if(params.effect==='profit'){currentMin='profit';}var policyLink='';if(this.props.match.path.includes('beleidskeuzes')){policyLink='/';}else{policyLink='/beleidskeuzes';}var _gameState$gameStateS=gameState.gameStateSum,remainingSavingsPoints=_gameState$gameStateS.remainingSavingsPoints,remainingProfitLossPoints=_gameState$gameStateS.remainingProfitLossPoints;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministries-list'},gameState.currentStep===3?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:'dlgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='total'?'/':'/economy/total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{className:'total-economy-list-button '+(currentMin==='total'||currentMin==='earned'?'show':''),bgColor:'darkblue',feedbackCount:unreadWinstGlobas+unreadVerliesGlobas,title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_totalglobas"),icon:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,points:currentRoundGameState.earnedPoints})),currentMin==='total'||currentMin==='earned'||currentMin==='profit'||currentMin==='loss'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='earned'?'/economy/total':'/economy/earned'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_earnedglobas"),icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg___default.a,globas:currentRound===5?'-':currentRoundGameState.earnedGlobas,points:currentRound===5?'-':currentRoundGameState.earnedPoints})),!(currentRound===5)&&currentMin==='earned'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_EconomyEarned__["a" /* default */],null)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktop-ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='profit'?'/economy/total':'/ministries/overview/basic/profit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_winstglobas'),className:currentMin==='profit'?'show':'',icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default.a,feedbackCount:unreadWinstGlobas,globas:isStartSituation?'-':OneTimeEffect.WG===0?0:'+ '+OneTimeEffect.WG}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktop-ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='loss'?'/economy/total':'/ministries/overview/basic/loss'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),className:currentMin==='loss'?'show':'',icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadVerliesGlobas,globas:isStartSituation?'-':OneTimeEffect.VG===0?0:'- '+-OneTimeEffect.VG})))):null),gameState.currentStep===1&&gameState.currentRound<=1?null:this.props.project.minPolicyChoices>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:'dlgvtstap3beleidskeuzes',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:policyLink},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),icon:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_beleidskeuze_L_svg___default.a,className:'beleidskeuze-listbutton-laag '+(this.props.match.path.includes('beleidskeuzes')?'show':''),feedbackCount:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_11__helpers_policyChoiceHelper__["a" /* choicesToMake */])(policyChoice,gameStateInput.myState.policyChoices,this.props.project.minPolicyChoices):Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["H" /* unreadCount */])(Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData),null,true),arrow:true,redNotification:gameState.currentStep===3,points:gameState.currentStep===1?Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["v" /* getPolicyChoiceTotalPoints */])(feedback.prevRoundFeedbackData):false,globas:gameState.currentStep===3?Object(__WEBPACK_IMPORTED_MODULE_11__helpers_policyChoiceHelper__["k" /* getTotalCosts */])(gameStateInput.myState.policyChoices,policyChoice):undefined})),this.props.match.path.includes('beleidskeuzes')?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'low-policy'},gameState.currentStep===3?filteredPolicyChoices.map(function(pc,i){if(i<_this2.props.project.minPolicyChoices){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:'/beleidskeuzes/'+i,key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__elements_PolicyChoiceLaag__["a" /* default */],{key:i,problem:pc,highlight:parseInt(_this2.props.match.params.beleidskeuze,10)===i,spendableGlobas:globas,listView:true}));}else{return false;}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData).map(function(feedback,i){var title=void 0;if(feedback.oplossing_code){title=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_policyChoiceHelper__["e" /* getOplossingTitle */])(feedback,gameState.language);}else{title=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_policyChoiceHelper__["j" /* getTitle */])(feedback,gameState.language);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-container-low',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["d" /* checkRead */])(feedback)?0:1,bgColor:feedback.kleur_balk,title:title,arrow:true,className:_this2.props.match.params.feedbackIdentifier===feedback.omschrijving?'show':'',feedback:true,thumbnail:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_policyChoiceHelper__["b" /* getIcon */])(feedback),points:feedback.puntenscore,onClick:function onClick(){_this2.props.history.push('/beleidskeuzes/beleidskeuze/'+feedback.omschrijving);}}));}))):''):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:'dlgvtministeries',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */]['basic'].ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:currentMin===min.toLowerCase()?'desktop-ministry-list show show--no-margin':'desktop-ministry-list',key:min},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{className:'min-link',to:currentMin===min.toLowerCase()?'/':gameState.currentStep===3?'/ministries/budget/'+min.toLowerCase():Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["n" /* getLowMinistryFeedbackLink */])(_this2.props.feedback.prevRoundFeedbackData,min,_this2.props.gameState,_this2.props.gameStateInput).length>0?Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["n" /* getLowMinistryFeedbackLink */])(_this2.props.feedback.prevRoundFeedbackData,min,_this2.props.gameState,_this2.props.gameStateInput)[0]:'/ministries/'+min.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{ministry:min,title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(min),hideOverflow:currentMin===min.toLowerCase(),icon:__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */].icons[min],arrow:true,points:gameState.currentStep===1?prevRoundSum?prevRoundSum[min+'_points']+'':'...':false,global:__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */].i18nMinistries.includes(min),globas:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(gameStateInput.myState.ministerieGlobaVerdeling,min,gameState.currentStep),collaboration:gameState.currentStep===1?ministryCollaborations[min]:ministerieGlobaVerdeling[min+'SW']})),currentMin===min.toLowerCase()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},gameState.currentStep===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_StepThree_MinistryFeedbackStatus__["a" /* default */],{ministry:min,showFeedback:isFeedback}):null):null);})),remainingSavingsPoints>0||remainingProfitLossPoints!==0&&!gameState.history?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overige-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtoverzicht_overige',tag:'h3'}),remainingSavingsPoints>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_overige_spaargeld'),icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_sparen_bank_svg___default.a,arrow:true,points:remainingSavingsPoints}):null,remainingProfitLossPoints!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_overige_wgvg'),icon:__WEBPACK_IMPORTED_MODULE_26__assets_img_icons_economy_up_min_globas_svg___default.a,arrow:true,points:remainingProfitLossPoints}):null):null,this.props.gameState.roundData.state==='SIMULATION_SPENDING'&&this.props.gameStateInput.myState.SIMULATION_SPENDING!=='PROCESSED'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonWrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.toggleOverviewPopUp,className:'button button--blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_overzicht_verdeling'))),this.state.showOverview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__elements_PopUp__["a" /* default */],{interactive:true,showPopUp:true,closePopUpCross:true,closePopUpClick:this.toggleOverviewPopUp},Object(__WEBPACK_IMPORTED_MODULE_12__helpers_ministriesHelper__["a" /* getOverviewData */])(this.props)):null):null),this.state.showWarning.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__elements_PopUp__["a" /* default */],{img:__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_warning_svg___default.a,popUpFooter:true,description:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(this.state.showWarning),closePopUpClick:function closePopUpClick(){return _this2.setState({showWarning:''});}}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}},{key:'renderHoog',value:function renderHoog(){var _this3=this;var _props2=this.props,gameState=_props2.gameState,gameStateInput=_props2.gameStateInput,feedback=_props2.feedback,group=_props2.group;var prevRoundSum=gameState.prevRoundSum;var ministerieGlobaVerdeling=gameStateInput.myState.ministerieGlobaVerdeling;var currentRound=gameState.currentRound;var currentRoundGameState=gameState.Rounds[currentRound];var prevRoundFeedbackData=feedback.prevRoundFeedbackData;if(!prevRoundSum)return null;var OneTimeEffect=prevRoundSum.OneTimeEffect;var policyChoicesArray=Object.values(gameStateInput.myState.policyChoices);var winstGlobasFeedbackCount=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(prevRoundFeedbackData,'profit').length;var verliesGlobasFeedbackCount=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(prevRoundFeedbackData,'loss').length;var unreadWinstGlobas=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["B" /* getUnreadWinstGlobas */])(prevRoundFeedbackData).length;var unreadVerliesGlobas=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["A" /* getUnreadVerliesGlobas */])(prevRoundFeedbackData).length;var params=this.props.match.params;var isFeedback=!!params.feedbackIdentifier;var isStartSituation=group.Rounds.length===2;var currentMin=params.ministryId||params.economyType||params.id||params.type;if(params.effect==='loss'){currentMin='loss';}if(params.effect==='profit'){currentMin='profit';}var _gameState$gameStateS2=gameState.gameStateSum,remainingSavingsPoints=_gameState$gameStateS2.remainingSavingsPoints,remainingProfitLossPoints=_gameState$gameStateS2.remainingProfitLossPoints;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministries-list'},gameState.currentStep===3?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:'dhgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='total'?'/':'/economy/total'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{className:'total-economy-list-button',bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_totalglobas'),icon:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,points:currentRoundGameState.earnedPoints})),currentMin==='total'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_EconomyTotal__["a" /* default */],null)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='earned'?'/':'/economy/earned'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_earnedglobas'),icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_economy_team_svg___default.a,globas:currentRound===5?'-':currentRoundGameState.earnedGlobas,points:currentRound===5?'-':currentRoundGameState.earnedPoints})),!(currentRound===5)&&currentMin==='earned'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'economy-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_EconomyEarned__["a" /* default */],null)):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:currentMin==='profit'&&winstGlobasFeedbackCount>0?'desktop-ministry-list show':'desktop-ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='profit'?'/':'/ministries/overview/profit'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_winstglobas'),className:currentMin==='profit'?'show':'',icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default.a,feedbackCount:unreadWinstGlobas,globas:isStartSituation?'-':OneTimeEffect.WG===0?0:'+ '+OneTimeEffect.WG})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["h" /* getEconomieFeedbackFormatted */])(this.props.feedback.prevRoundFeedbackData,'profit',gameState))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:currentMin==='loss'&&verliesGlobasFeedbackCount>0?'desktop-ministry-list show':'desktop-ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:currentMin==='loss'?'/':'/ministries/overview/loss'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{bgColor:'blue',title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),className:currentMin==='loss'?'show':'',icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_economy_min_globas_svg___default.a,feedbackCount:unreadVerliesGlobas,globas:isStartSituation?'-':OneTimeEffect.VG===0?0:'- '+-OneTimeEffect.VG})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["h" /* getEconomieFeedbackFormatted */])(this.props.feedback.prevRoundFeedbackData,'loss',gameState)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ministry-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:'dhgvtministeries',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */]['pro'].ministries.map(function(min){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:currentMin===min.toLowerCase()?'desktop-ministry-list show':'desktop-ministry-list',key:min},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{className:'min-link',to:currentMin===min.toLowerCase()?'/':'/ministries/'+(gameState.currentStep===3?'budget/':'')+min.toLowerCase()},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{ministry:min,title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(min),popupId:currentMin===min.toLowerCase()&&gameState.currentStep!==3?__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */].ministryPopupIds.pro[min]:false,icon:__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */].icons[min],arrow:true,stars:__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */].ministeryStars[min],hideOverflow:currentMin===min.toLowerCase(),points:gameState.currentStep===1?prevRoundSum?prevRoundSum[min+'_points']+'':0:false,globas:Object(__WEBPACK_IMPORTED_MODULE_14__helpers_calculationsHelper__["e" /* getMinistryGlobasSpent */])(ministerieGlobaVerdeling,min,gameState.currentStep,policyChoicesArray),global:__WEBPACK_IMPORTED_MODULE_9__Defines__["a" /* default */].i18nMinistries.includes(min),budgetSet:ministerieGlobaVerdeling[min]&&gameState.currentStep>1,policySet:policyChoicesArray.find(function(choice){return choice.ministry===min&&choice.selected;})&&gameState.currentStep>1,hideDisaster:currentMin===min.toLowerCase()})),currentMin===min.toLowerCase()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},gameState.currentStep===3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__elements_StepThree_MinistryFeedbackStatus__["a" /* default */],{ministry:min,showFeedback:isFeedback}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,Object(__WEBPACK_IMPORTED_MODULE_10__helpers_feedbackHelpers__["F" /* renderMinistryFeedbackList */])(_this3.props.feedback.prevRoundFeedbackData,min,_this3.props.gameState,_this3.props.gameStateInput,_this3.props.match.params.feedbackIdentifier))):null);})),remainingSavingsPoints>0||remainingProfitLossPoints!==0&&!gameState.history?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'overige-list'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtoverzicht_overige',tag:'h3'}),remainingSavingsPoints>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_overige_spaargeld'),icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_sparen_bank_svg___default.a,arrow:true,points:remainingSavingsPoints}):null,remainingProfitLossPoints!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_overige_wgvg'),icon:__WEBPACK_IMPORTED_MODULE_26__assets_img_icons_economy_up_min_globas_svg___default.a,arrow:true,points:remainingProfitLossPoints}):null):null,this.props.gameState.roundData.state==='SIMULATION_SPENDING'&&this.props.gameStateInput.myState.SIMULATION_SPENDING!=='PROCESSED'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonWrap'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.toggleOverviewPopUp,className:'button button--blue'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_overzicht_verdeling'))),this.state.showOverview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__elements_PopUp__["a" /* default */],{interactive:true,showPopUp:true,closePopUpCross:true,closePopUpClick:this.toggleOverviewPopUp},Object(__WEBPACK_IMPORTED_MODULE_12__helpers_ministriesHelper__["a" /* getOverviewData */])(this.props)):null):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_NextStep__["a" /* default */],null));}}]);return Ministries;}(__WEBPACK_IMPORTED_MODULE_13__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return state;})(Ministries));

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_groupHelper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__history_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_ScoreHistory__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_feedback_FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackHeader__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeedbackEffect__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_assets_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__elements_feedback_FeedbackStatusRounds__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_caret_down_grey_svg__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_caret_down_grey_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_caret_down_grey_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scroll_into_view__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scroll_into_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_scroll_into_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__elements_NextStep__ = __webpack_require__(35);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// functions / libraries
// components
// assets
var updateRead=__WEBPACK_IMPORTED_MODULE_8__actions__["a" /* default */].feedback.updateRead;var Feedback=function(_DifficultyAwareCompo){_inherits(Feedback,_DifficultyAwareCompo);function Feedback(props){_classCallCheck(this,Feedback);var _this=_possibleConstructorReturn(this,(Feedback.__proto__||Object.getPrototypeOf(Feedback)).call(this,props));_this.flipContainer=function(){_this.setState(function(prevState){return{flip:!prevState.flip};});};_this.toggleProbleem=function(){_this.setState(function(prevState){return{showProbleem:!prevState.showProbleem};});};_this.toggleOplossing=function(){_this.setState(function(prevState){return{showOplossing:!prevState.showOplossing};});};_this.renderFeedbackHeader=function(feedback,overigEffect,economie){var hideClose=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var isEffectCollection=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;var _this$props=_this.props,gameState=_this$props.gameState,history=_this$props.history;var points=false;/**
     * Een lelijke hack om de GoBackButton van de feedback header een custom handler te geven
     * wanneer je in stap 3 zit en de situatie aan het bekijken bent.
     *
     * Wanneer je op de button klikt, moet je weer in het verdelen gedeelte komen van de ministerie.
     */var closeButtonHandler=null;if(_this.props.gameState.currentStep===3&&_this.props.location.pathname.startsWith('/ministries')&&_this.props.match.params.feedbackIdentifier&&_this.props.match.params.id){closeButtonHandler=_this.props.history.goBack;}// EO ugly hack
if(_this.state.oe){points=overigEffect.puntenscore;}else if(_this.state.economie){points=economie.winstverliesglobas;}else if(feedback){points=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["s" /* getPoints */])(feedback,gameState,Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,_this.props.gameStateInput).length);}if(_this.state.pageType==='beleidskeuze'&&gameState.difficulty==='BASIC'||feedback.titel_oplossing_NL&&gameState.difficulty==='BASIC'){var title=void 0;if(feedback.oplossing_code){title=Object(__WEBPACK_IMPORTED_MODULE_20__helpers_policyChoiceHelper__["e" /* getOplossingTitle */])(feedback,gameState.language);}else{title=Object(__WEBPACK_IMPORTED_MODULE_20__helpers_policyChoiceHelper__["j" /* getTitle */])(feedback,gameState.language);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackHeader__["a" /* default */],{closeButtonHandler:closeButtonHandler,key:'header',currentRound:gameState.currentRound,history:history,type:title,icon:Object(__WEBPACK_IMPORTED_MODULE_20__helpers_policyChoiceHelper__["b" /* getIcon */])(feedback),prependEffect:gameState.difficulty==='BASIC'&&(feedback.type!=='BELEIDSKEUZE'||isEffectCollection===true)?true:null,points:gameState.difficulty==='BASIC'&&(feedback.type!=='BELEIDSKEUZE'||isEffectCollection===true)?feedback.economie.winstverliesglobas:feedback.puntenscore,miljard:gameState.difficulty==='BASIC'&&(feedback.type!=='BELEIDSKEUZE'||isEffectCollection===true)?true:false,hideClose:hideClose,niveau:gameState.difficulty});}if(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["j" /* getFeedbackTitle */])(feedback,gameState.language)){if(gameState.difficulty==='BASIC'){if(isEffectCollection===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackHeader__["a" /* default */],{closeButtonHandler:closeButtonHandler,key:'header',currentRound:gameState.currentRound,history:history,noTitle:false,type:feedback.type==="BELASTING"?Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["j" /* getFeedbackTitle */])(feedback,gameState.language):feedback.ministerie,prependEffect:gameState.difficulty==='BASIC'?true:null,points:economie.winstverliesglobas,miljard:true,icon:feedback.type==="BELASTING"?Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["k" /* getIcon */])(feedback):__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["g" /* ministryIcons */][feedback.ministerie],niveau:gameState.difficulty,hideClose:hideClose});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackHeader__["a" /* default */],{closeButtonHandler:closeButtonHandler,key:'header',currentRound:gameState.currentRound,history:history,noTitle:true,prependEffect:gameState.difficulty==='BASIC'?true:null,popUpTitle:__WEBPACK_IMPORTED_MODULE_3__Defines__["a" /* default */].ministryPopupIds.basic[feedback.ministerie],icon:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["g" /* ministryIcons */][feedback.ministerie],niveau:gameState.difficulty,hideClose:hideClose});}}if(feedback){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_feedback_FeedbackHeader__["a" /* default */],{closeButtonHandler:closeButtonHandler,key:'header',currentRound:gameState.currentRound,history:history,type:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["j" /* getFeedbackTitle */])(feedback),subtitle:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["x" /* getSubtitle */])(feedback,gameState.language),icon:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["k" /* getIcon */])(feedback),prependEffect:gameState.difficulty==='BASIC'?true:null,disaster:feedback.type==='RAMP',points:gameState.difficulty==='BASIC'?feedback.economie.winstverliesglobas:points,miljard:_this.state.economie||gameState.difficulty==='BASIC',hideClose:hideClose,niveau:gameState.difficulty});}return null;};_this.renderStatistics=function(feedback,overigEffect,economie){var _this$props2=_this.props,gameState=_this$props2.gameState,gameStateInput=_this$props2.gameStateInput,schoolClass=_this$props2.schoolClass;if(_this.state.pageType==='beleidskeuze'&&gameState.difficulty==='BASIC'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'low-dropdown-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],{outerClassName:''+(_this.state.showProbleem?' show':''),className:'problem-solution-container standardAnimation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar',onClick:_this.toggleProbleem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_feedback_wat_is_het_probleem')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_img_caret_down_grey_svg___default.a,alt:'close',className:'close-status'+(_this.state.showProbleem?' rotate':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'+(_this.state.showProbleem?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_probleem')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_20__helpers_policyChoiceHelper__["g" /* getProbleemTekst */])(feedback,gameState.language))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],{outerClassName:''+(_this.state.showOplossing?' show':''),className:'problem-solution-container standardAnimation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'top-bar',onClick:_this.toggleOplossing},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_feedback_wat_is_jullie_oplossing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_img_caret_down_grey_svg___default.a,alt:'close',className:'close-status'+(_this.state.showOplossing?' rotate':'')})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'+(_this.state.showOplossing?' show':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_oplossing')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_20__helpers_policyChoiceHelper__["d" /* getOplossingTekst */])(feedback,gameState.language))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_kosten'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,(feedback.kosten_globas||0)+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard'))))));}if(!_this.state.oe&&!_this.state.economie&&feedback){if(feedback.type==='STARTSITUATIE')return null;if(['ALGEMEEN','RAMP'].indexOf(feedback.type)!==-1){var groupIcons=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_groupHelper__["b" /* getGroupIcons */])(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput),schoolClass.Groups);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"flip-container "+(_this.state.flip?'':'flip')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'flipper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'front'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_kosten'),score:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["f" /* getCosts */])(feedback,gameState)+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}),__WEBPACK_IMPORTED_MODULE_3__Defines__["a" /* default */].i18nMinistries.includes(feedback.ministerie)?groupIcons.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{className:'align-right',text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerking'),imgs:groupIcons}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{className:'no-collaborations',text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerking'),score:'-'}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_score',1),score:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["s" /* getPoints */])(feedback,gameState,Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput).length)+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase()}),gameState.difficulty==="PRO"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_neveneffecten'),score:feedback.nevenEffecten||0}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:_this.flipContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bekijkhistorie')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'back'},gameState.Rounds.map(function(r,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_ScoreHistory__["a" /* default */],{key:i,round:i,ministerie:feedback.ministerie});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:_this.flipContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_terug'))))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'card',className:'card-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],{className:'standardAnimation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_kosten'),score:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["f" /* getCosts */])(feedback,gameState)+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}),feedback.type==='BELEIDSKEUZE'&&feedback.omschrijving.match(/SW(\d){1,2}$/i)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{className:'align-right',text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerking'),imgs:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_groupHelper__["b" /* getGroupIcons */])(Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput),schoolClass.Groups)}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_score',1),score:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["s" /* getPoints */])(feedback,gameState,Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["e" /* getCollaborations */])(feedback,gameStateInput).length)+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_neveneffecten'),score:feedback.nevenEffecten||0})));}return null;};_this.renderFeedbackImage=function(feedback,overigEffect,economie){var forceEconomy=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var gameState=_this.props.gameState;var text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(feedback,gameState.language);var img=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(feedback);if(_this.state.oe){text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(overigEffect,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(overigEffect,feedback);}if(feedback.niveau.toLowerCase()==='basic'){if(_this.state.economie||forceEconomy){if(feedback.type==='BELEIDSKEUZE'){text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(feedback.economie,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(feedback.economie);}else{text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(economie,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(economie);}}else if(feedback.type==='BELEIDSKEUZE'){img=feedback.img_2;}}else{if(_this.state.economie&&economie){text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(economie,gameState.language);img=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(economie,feedback);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_feedback_FeedbackImage__["a" /* default */],{disaster:feedback.type==='RAMP',description:text,image:img,desktop:true,forceShowText:feedback.type==='STARTSITUATIE'});};_this.renderFeedbackImageText=function(feedback,overigEffect,economie,counter){var forceEconomy=arguments.length>4&&arguments[4]!==undefined?arguments[4]:false;if(feedback.type==='STARTSITUATIE')return[];var gameState=_this.props.gameState;var text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(feedback,gameState.language);if(_this.state.oe){text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(overigEffect,gameState.language);}if(_this.state.economie||forceEconomy){text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(economie,gameState.language);}var elem=[];if(text&&text!=='<p>-</p>'&&text!=='<p>- </p>'&&text!=='<p> -</p>'){elem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'opt1',className:'feedback-image-text '+(counter%2===0?'left':'right')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:text}})));if(counter%2===0){elem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'opt2',className:'feedback-image-text right'}));}else{elem.unshift(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'opt3',className:'feedback-image-text left'}));}return elem;}else{if(feedback.niveau==='Basic'&&feedback.type==='BELEIDSKEUZE'){elem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'opt1',className:'feedback-image-text left'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)));elem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'opt2',className:'feedback-image-text right'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null)));return elem;}}};_this.renderPolicyChoiceMade=function(feedback){var lang=arguments.length>1&&arguments[1]!==undefined?arguments[1]:'NL';if(feedback.type==="BELEIDSKEUZE"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbackText'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],{className:'grey standardAnimation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{display:'block',width:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',1),': ',feedback['titel_beleidskeuze_'+lang].toLowerCase()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,feedback['tekst_beleidskeuze_'+lang]))));}return null;};_this.renderFeedbackText=function(feedback,overigEffect,economie){var forceEconomy=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var _this$props3=_this.props,gameState=_this$props3.gameState,identifier=_this$props3.match.params.identifier;var text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["y" /* getText */])(feedback,gameState.language);if(_this.state.oe){text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["y" /* getText */])(overigEffect,gameState.language);}if(_this.state.economie||forceEconomy){text=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["y" /* getText */])(economie,gameState.language);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedbackText',id:feedback.omschrijving,ref:feedback.omschrijving===identifier?_this.setScrollToRef:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_ContentContainer__["a" /* default */],{className:'standardAnimation'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:text}})));};_this.getFeedbackEffectLaag=function(oi,e,f){var icon=void 0,text=void 0,type=void 0,clickable=void 0;if(e){clickable=true;icon=e.winstverliesglobas>=0?__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].thumbsUp:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].thumbsDown;text=e.winstverliesglobas>=0?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_feedback_door_keuze_meer_globas'):Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_feedback_door_keuze_minder_globas');type=e.winstverliesglobas>=0?'profit':'loss';}else if(oi){clickable=false;// OI is altijd positief
icon=__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].thumbsUp;text=Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_feedback_keuze_extra_inkomsten');}var url='/ministries/overview/basic/'+type+'/'+f.omschrijving;if(e||oi){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-laag-oi'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:icon,alt:'thumbs'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Link */],{to:url,style:clickable?{}:{pointerEvents:'none'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:text}})));}return null;};_this.generateLowInnerFeedback=function(feedback,counter){var economie=feedback.economie;var eco=false;if(economie||_this.state.economie){eco=true;}// Check if OE
if(_this.state.oe||_this.state.economie)feedback.type='OVERIGEFFECT';// override type with OE
if(!Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["d" /* checkRead */])(feedback,_this.state.oe,_this.state.effectId,eco)){if(_this.state.oe){feedback.read['readOe_'+_this.state.effectId]=true;var array=feedback.read;array['readOe_'+_this.state.effectId]=true;_this.props.dispatch(updateRead(feedback.id,array));}else if(eco){feedback.read.economie=true;var _array=feedback.read;_array.economie=true;_this.props.dispatch(updateRead(feedback.id,_array));}else{feedback.read.read=true;var _array2=feedback.read;_this.props.dispatch(updateRead(feedback.id,_array2));}}var feedbackImageText=_this.renderFeedbackImageText(feedback,false,economie,counter+1,eco);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:feedback.id,className:_this.state.pageType==='beleidskeuze'?'container feedbackcontainer feedbackcontainer-collection beleidskeuze-low':'container feedbackcontainer feedbackcontainer-collection'},_this.renderFeedbackHeader(feedback,false,economie,counter>1,true),counter%2!==0?_this.renderFeedbackImage(feedback,undefined,economie,eco):_this.renderFeedbackText(feedback,undefined,economie,eco),counter%2===0?_this.renderFeedbackImage(feedback,undefined,economie,eco):_this.renderFeedbackText(feedback,undefined,economie,eco),feedbackImageText);};_this.state={flip:true,showEffects:false};_this.state.pageType=props.match.params.id;_this.state.feedbackId=props.match.params.feedbackIdentifier;_this.state.effectId=props.match.params.effect;_this.state.oe=_this.state.pageType==='overigEffect';_this.state.economie=_this.state.pageType==='economie';_this.scrollToRef=null;_this.setScrollToRef=function(element){_this.scrollToRef=element;};_this.scrollTo=function(){if(_this.scrollToRef){setTimeout(function(){__WEBPACK_IMPORTED_MODULE_21_scroll_into_view___default()(_this.scrollToRef,{topOffset:200});},500);}};return _this;}_createClass(Feedback,[{key:'componentDidMount',value:function componentDidMount(){this.scrollTo();}},{key:'renderHoog',value:function renderHoog(){var _this2=this;var _props=this.props,match=_props.match,gameState=_props.gameState,prevRoundFeedbackData=_props.feedback.prevRoundFeedbackData;var feedback=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["i" /* getFeedback */])(prevRoundFeedbackData,this.state.feedbackId);if(Object.entries(feedback).length===0&&feedback.constructor===Object){var url="/ministries/"+(match.params.ministryId!==undefined?match.params.ministryId:match.params.id);__WEBPACK_IMPORTED_MODULE_9__history_js__["a" /* default */].push(url);return null;}var overigEffect=feedback.overigeEffecten[this.state.effectId]||{};var economie=feedback.economie||{};if(!economie)this.state.economie=false;if(!overigEffect)this.state.oe=false;// Check if OE
if(this.state.oe||this.state.economie)feedback.type='OVERIGEFFECT';// override type with OE
if(!Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["d" /* checkRead */])(feedback,this.state.oe,this.state.effectId,this.state.economie)){if(this.state.oe){feedback.read['readOe_'+this.state.effectId]=true;var array=feedback.read;array['readOe_'+this.state.effectId]=true;this.props.dispatch(updateRead(feedback.id,array));}else if(this.state.economie){feedback.read.economie=true;var _array3=feedback.read;_array3.economie=true;this.props.dispatch(updateRead(feedback.id,_array3));}else{feedback.read.read=true;var _array4=feedback.read;this.props.dispatch(updateRead(feedback.id,_array4));}}var feedbackHeader=this.renderFeedbackHeader(feedback,overigEffect,economie);var statistics=this.renderStatistics(feedback,overigEffect,economie);var statusRounds=['ALGEMEEN','RAMP','STARTSITUATIE'].indexOf(feedback.type)!==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__elements_feedback_FeedbackStatusRounds__["a" /* default */],{desktop:true,ministry:feedback.ministerie}):null;var policyChoiceMade=this.renderPolicyChoiceMade(feedback,gameState.language);var feedbackImage=this.renderFeedbackImage(feedback,overigEffect,economie,policyChoiceMade);var feedbackText=this.renderFeedbackText(feedback,overigEffect,economie);var counter=0;if(feedbackHeader)counter++;if(statistics)counter++;if(policyChoiceMade)counter++;if(statusRounds)counter++;if(feedbackImage)counter++;var feedbackImageText=this.renderFeedbackImageText(feedback,overigEffect,economie,policyChoiceMade?counter+1:counter);var feedbackType=feedback.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg',style:{height:'100%'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default.a,{className:'custom-height-step-3',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'fbWrapper',className:'container feedbackcontainer '+(feedback.nevenEffecten&&!this.state.oe&&!this.state.economie?'hasEffect--pro':'')+' '+(feedback.type==='STARTSITUATIE'?'isStartsituation':'')},feedbackHeader,statistics,statusRounds,policyChoiceMade,policyChoiceMade?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,feedbackText,feedbackImage):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,feedbackImage,feedbackText),counter%2===0?feedbackImageText:null,feedback.nevenEffecten&&!this.state.oe&&!this.state.economie?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.showEffects?'effects-container show':'effects-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'effectsHeader',className:'effects-header',onClick:function onClick(){return _this2.state.showEffects?_this2.setState({showEffects:false}):_this2.setState({showEffects:true});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effectsTitle'},feedback.type==='BELEIDSKEUZE'?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_beleidskeuze_heeft_effect_op'):Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_budgetkeuze_heeft_effect_op'),':'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effectsIcons'},feedback.overigeInkomsten?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].gift,alt:'gift'}):'',Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["w" /* getSideEffects */])(feedback).map(function(oe,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["g" /* ministryIcons */][oe.ministerie],alt:'minIcon',key:i});}),feedback.economie?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:parseInt(feedback.economie.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].upGlobas:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].minGlobas,alt:'economy'}):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'dropdown-effects'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_19__assets_img_caret_down_grey_svg___default.a,alt:'caret'}))),Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["w" /* getSideEffects */])(feedback).map(function(oe,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FeedbackEffect__["a" /* default */],{className:feedbackType,key:i,image:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(oe)// minimal={minimal}
,ministry:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(oe.ministerie),ministryIcon:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["g" /* ministryIcons */][oe.ministerie],description:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(oe,gameState.language),unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten').toLowerCase(),points:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["s" /* getPoints */])(oe,gameState)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["y" /* getText */])(oe,gameState.language)}}));}),feedback.economie?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FeedbackEffect__["a" /* default */],{className:feedbackType,image:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(feedback.economie),ministry:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_economie'),pointsTitle:Math.abs(feedback.economie.winstverliesglobas)+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')+' '+(parseInt(feedback.economie.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verliesglobas')),ministryIcon:parseInt(feedback.economie.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].upGlobas:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].minGlobas,description:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(feedback.economie,gameState.language),unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas'),points:feedback.economie.winstverliesglobas},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["y" /* getText */])(feedback.economie,gameState.language)}})):null,feedback.overigeInkomsten?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FeedbackEffect__["a" /* default */],{className:feedbackType,image:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["l" /* getImage */])(feedback.economie),ministry:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_overige_inkomsten'),ministryIcon:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].gift,pointsTitle:feedback.overigeInkomsten.winstverliesglobas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas'),description:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["m" /* getImageText */])(feedback.overigeInkomsten,gameState.language),unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas'),points:feedback.overigeInkomsten.winstverliesglobas},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["y" /* getText */])(feedback.overigeInkomsten,gameState.language)}})):null):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_NextStep__["a" /* default */],null));}},{key:'renderLaag',value:function renderLaag(){var _this3=this;var _props2=this.props,match=_props2.match,prevRoundFeedbackData=_props2.feedback.prevRoundFeedbackData;var feedback=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["i" /* getFeedback */])(prevRoundFeedbackData,this.state.feedbackId);if(match.path==='/ministries/overview/basic/:type/:identifier?'){var _feedback=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["g" /* getEconomieFeedback */])(prevRoundFeedbackData,match.params.type);var _counter=0;var entries=_feedback.map(function(current){_counter++;return _this3.generateLowInnerFeedback(current,_counter);});if(!_counter){this.props.history.push("/economy/total");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},entries),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_NextStep__["a" /* default */],null));}if(Object.entries(feedback).length===0&&feedback.constructor===Object){var url="/ministries/"+(match.params.ministryId!==undefined?match.params.ministryId:match.params.id);__WEBPACK_IMPORTED_MODULE_9__history_js__["a" /* default */].push(url);return null;}var overigEffect=feedback.overigeEffecten[this.state.effectId];var economie=feedback.economie;if(!economie)this.state.economie=false;if(!overigEffect)this.state.oe=false;// Check if OE
if(this.state.oe||this.state.economie)feedback.type='OVERIGEFFECT';// override type with OE
if(!Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["d" /* checkRead */])(feedback,this.state.oe,this.state.effectId,this.state.economie)){if(this.state.oe){feedback.read['readOe_'+this.state.effectId]=true;var array=feedback.read;array['readOe_'+this.state.effectId]=true;this.props.dispatch(updateRead(feedback.id,array));}else if(this.state.economie){feedback.read.economie=true;var _array5=feedback.read;_array5.economie=true;this.props.dispatch(updateRead(feedback.id,_array5));}else{feedback.read.read=true;var _array6=feedback.read;this.props.dispatch(updateRead(feedback.id,_array6));}}var feedbackHeader=this.renderFeedbackHeader(feedback,overigEffect,economie);var statistics=this.renderStatistics(feedback,overigEffect,economie);var statusRounds=['ALGEMEEN','RAMP','STARTSITUATIE'].indexOf(feedback.type)!==-1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__elements_feedback_FeedbackStatusRounds__["a" /* default */],{desktop:true,ministry:feedback.ministerie}):null;var feedbackImage=this.renderFeedbackImage(feedback,overigEffect,economie);var feedbackText=this.renderFeedbackText(feedback,overigEffect,economie);var counter=0;if(feedbackHeader)counter++;if(statistics)counter++;if(statistics&&this.state.pageType==='beleidskeuze')counter++;if(statusRounds)counter++;if(feedbackImage)counter++;var feedbackImageText=this.renderFeedbackImageText(feedback,overigEffect,economie,counter);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'fbWrapper',className:'container feedbackcontainer '+(this.state.pageType==='beleidskeuze'?'beleidskeuze-low':'')+' '+(feedback.overigeInkomsten||feedback.economie?'hasEffect--basic':'')+' '+(feedback.type==='STARTSITUATIE'?'isStartsituation':'')},feedbackHeader,statistics,statusRounds,feedbackImage,counter%2!==0?feedbackImageText:null,feedbackText,counter%2===0?feedbackImageText:null,feedback.overigeInkomsten||feedback.economie?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-container laag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'effectsHeader',className:'effects-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effects-header-inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_17__assets_assets_js__["d" /* icons */].megafoon,alt:'megafoon'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_let_op')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__FeedbackEffect__["a" /* default */],{minimal:true,difficulty:'BASIC'},this.getFeedbackEffectLaag(feedback.overigeInkomsten,feedback.economie,feedback))):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_NextStep__["a" /* default */],null));}}],[{key:'getDerivedStateFromProps',value:function getDerivedStateFromProps(nextProps,prevState){var newState=_extends({},prevState);newState.pageType=nextProps.match.params.id;newState.feedbackId=nextProps.match.params.feedbackIdentifier;newState.effectId=nextProps.match.params.effect;newState.oe=newState.pageType==='overigEffect';newState.economie=newState.pageType==='economie';return newState;}}]);return Feedback;}(__WEBPACK_IMPORTED_MODULE_15__DifficultyAwareComponent__["a" /* default */]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,project=_ref.project,gameStateInput=_ref.gameStateInput,schoolClass=_ref.schoolClass;return{gameState:gameState,feedback:feedback,project:project,gameStateInput:gameStateInput,schoolClass:schoolClass};})(Feedback));

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FeedbackEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_feedback_FeedbackImage__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__ = __webpack_require__(12);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FeedbackEffect=(_temp=_class=function(_Component){_inherits(FeedbackEffect,_Component);function FeedbackEffect(props){_classCallCheck(this,FeedbackEffect);var _this=_possibleConstructorReturn(this,(FeedbackEffect.__proto__||Object.getPrototypeOf(FeedbackEffect)).call(this,props));_this.renderFeedbackImageText=function(text){var elem=[];if(text&&text!=='<p>-</p>'&&text!=='<p>- </p>'&&text!=='<p> -</p>'){elem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'fit-'+text.substr(0,10),className:'feedback-image-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{dangerouslySetInnerHTML:{__html:text}})));elem.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'fit-text',className:'feedback-image-text'}));return elem;}};_this.state={image:_this.props.image,ministry:_this.props.ministry,ministryIcon:_this.props.ministryIcon,description:_this.props.description,disaster:_this.props.disaster,subtitle:_this.props.subtitle};return _this;}_createClass(FeedbackEffect,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var points=this.props.points==="-"?0:this.props.points;if(this.props.points>=0)points='+'+points;var imageText=this.renderFeedbackImageText(this.state.description);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-effect-container '+(this.props.difficulty==='BASIC'?'single-effect-container--basic':'')+' '+this.props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},this.props.minimal?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effectItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_feedback_FeedbackImage__["a" /* default */],{description:this.state.description,image:this.state.image})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'effectItem'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__["a" /* default */],{darkBg:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-wrapper'},this.props.difficulty!=='BASIC'?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-effect-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-ministry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'ministry',src:this.state.ministryIcon})),this.props.pointsTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.ministry,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'thin-subtitle'},'| ',this.props.pointsTitle)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,this.state.ministry),this.state.subtitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,' |',this.state.subtitle):null),!this.props.pointsTitle?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'single-points'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{content:points},points,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{content:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(this.props.unit)},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])(this.props.unit)))):null):null,this.props.children))),imageText?imageText:null));}}]);return FeedbackEffect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,ministry:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,ministryIcon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,description:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,className:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string},_class.defaultProps={unit:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_punten'),className:''},_temp);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_QuestionButton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_IncomeDetail__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_TaxItemContainer__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TaxItem__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TaxesLow__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_buitenland_svg__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_buitenland_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_buitenland_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_belasting_1_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_belasting_2_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_belasting_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_belasting_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_belasting_3_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_belasting_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_belasting_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_4_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_6_svg__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_7_svg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_warning_svg__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__assets_img_icons_warning_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__assets_img_icons_warning_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_budget_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__assets_img_icons_budget_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_budget_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__elements_EconomyTotal__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__config__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var updateMyState=__WEBPACK_IMPORTED_MODULE_27__actions__["a" /* default */].gameStateInput.updateMyState;var openedVBelasting=false;var Taxes=(_temp=_class=function(_Component){_inherits(Taxes,_Component);function Taxes(props){_classCallCheck(this,Taxes);var _this=_possibleConstructorReturn(this,(Taxes.__proto__||Object.getPrototypeOf(Taxes)).call(this,props));_this.getGroupIcons=function(){var groups=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var schoolClass=_this.props.schoolClass;return groups.map(function(grp,i){var g=schoolClass.Groups.find(function(g){return g.GroupTheme.color===grp;});if(g)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:Math.random()+i+'lolimsorandom',className:'tax-item-badge',src:''+__WEBPACK_IMPORTED_MODULE_30__config___default.a.apiUrl+g.GroupTheme.badge,alt:'badge'});return null;});};_this.validateTaxOne=function(){var state=_this.props.gameStateInput.myState;var ab=state.arbeidsBelasting>=1&&state.arbeidsBelasting<=59;var bb=state.bedrijvenBelasting>=1&&state.bedrijvenBelasting<=34;return ab&&bb;};_this.validateTaxTwo=function(){var vSeen=openedVBelasting;var state=_this.props.gameStateInput.myState;var c=state.CBelasting>=1&&state.CBelasting<=34;var vv=state.VVBelasting>=1&&state.VVBelasting<=49;var v=state.VBelasting>=0&&state.VBelasting<=6;return c&&vv&&v&&vSeen;};_this.getWinstVerliesEffect=function(fb){return{icon:parseInt(fb.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_22__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_21__assets_img_icons_economy_min_globas_svg___default.a,title:parseInt(fb.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),contentTitle:fb.winstverliesglobas||0,contentUnit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')};};_this.getTotalBuitenland=function(state){return state.BL_AB_globas+state.BL_BB_globas+state.BL_CB_globas+state.BL_VVB_globas+state.BL_VB_globas;};_this.getTotalBudgetPoints=function(state){return state.AB_points+state.BB_points+state.VV_points+state.C_points+state.V_points;};_this.getTotalBudgetGlobas=function(state,oi,totalDebitCredit){return state.AB_globas+state.BB_globas+state.VV_globas+state.C_globas+state.V_globas+_this.getOISum(oi)+totalDebitCredit;};_this.getEffects=function(fb){var effects=[];if(fb.economie){effects.push(_this.getWinstVerliesEffect(fb.economie));}return effects.concat(fb.overigeEffecten.map(function(oe){return{icon:__WEBPACK_IMPORTED_MODULE_25__assets_assets__["g" /* ministryIcons */][oe.ministerie],title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(oe.ministerie),contentTitle:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["s" /* getPoints */])(oe),contentUnit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten')};}));};_this.getOISum=function(overigeInkomsten,replacementChar){return overigeInkomsten.reduce(function(sum,oi){sum+=parseInt(oi.winstverliesglobas,10)||0;return sum;},0)||replacementChar||0;};_this.state={showOtherIncomeDropdown:false,showBuitenlandDropdown:false,showInterestDropdown:false,showBudgetDropdown:false,showEconomy:false};return _this;}_createClass(Taxes,[{key:'toggleOther',value:function toggleOther(property){var state=_extends({},this.state);state[property]=!state[property];this.setState(state);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,feedback=_props.feedback,dispatch=_props.dispatch;var state=this.state;var myState=gameStateInput.myState;var _gameState$roundData=gameState.roundData,gameStateSum=_gameState$roundData.gameStateSum,roundGameStateInput=_gameState$roundData.gameStateInput,currentState=_gameState$roundData.state,roundNumber=_gameState$roundData.roundNumber;var feedbackAB=feedback.feedbackAB,feedbackBB=feedback.feedbackBB,feedbackCB=feedback.feedbackCB,feedbackVVB=feedback.feedbackVVB,feedbackVB=feedback.feedbackVB;var overigeInkomsten=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["r" /* getOverigeInkomsten */])(feedback.prevRoundFeedbackData,gameState);if(this.props.project.difficulty==='BASIC'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TaxesLow__["a" /* default */],{desktop:this.props.desktop,history:this.props.history,inheritedState:this.state,getGroupIcons:this.getGroupIcons,paramsTaxId:this.props.match.params.taxid});}var isBankDisabledForSimulation=false;if(this.props.gameStateInput&&this.props.gameStateInput.myState&&this.props.gameStateInput.myState.SIMULATION_TAX==='PROCESSED'){var currDC=this.props.gameState.roundData&&this.props.gameState.roundData.lastGameState&&this.props.gameState.roundData.lastGameState.OneTimeEffect&&this.props.gameState.roundData.lastGameState.OneTimeEffect.debitCredit;isBankDisabledForSimulation=currDC?currDC.some(function(c){return c.bankDisabledPayout;}):false;}else{isBankDisabledForSimulation=this.props.project.bankEnabled===false;}var debitCredit=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.filter(function(dc){return!dc.key.endsWith('NotConfirmed');}).map(function(dbCr){return Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["a" /* calculateDebitCreditOutcome */])(dbCr,roundNumber,isBankDisabledForSimulation);}).filter(function(entry){return entry&&entry.amount;});//filter out empty
var totalDebitCredit=debitCredit.reduce(function(acc,val){return acc-val.amount;},0);var AB_economie=gameStateSum.AB_economie,BB_economie=gameStateSum.BB_economie;AB_economie=AB_economie||Math.round(gameState.totalEconomy*myState.taxDividence);BB_economie=BB_economie||gameState.totalEconomy-AB_economie;var buitenland1=gameStateSum.BL_AB_globas+gameStateSum.BL_BB_globas;var buitenland2=gameStateSum.BL_VVB_globas+gameStateSum.BL_CB_globas+gameStateSum.BL_VB_globas;var taxAVideo=gameState.language==='NL'?__WEBPACK_IMPORTED_MODULE_30__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGA_NL_720p_1,5Mbps.mp4':__WEBPACK_IMPORTED_MODULE_30__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGA_ENG_720p_1,5Mbps.mp4';var taxBVideo=gameState.language==='NL'?__WEBPACK_IMPORTED_MODULE_30__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGB_NL_720p_1,5Mbps.mp4':__WEBPACK_IMPORTED_MODULE_30__config___default.a.uploadsUrl+'/assets/videos/belasting_HOOGB_ENG_720p_1,5Mbps.mp4';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__elements_PopupTitle__["a" /* default */],{popupId:'dhgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{reverseGlobasPoints:true,bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totalglobas'),icon:__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_economy_economy_svg___default.a,onClick:function onClick(){return _this2.setState({showEconomy:!state.showEconomy});},globas:gameState.totalEconomy,hidePoints:true}),state.showEconomy?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__elements_EconomyTotal__["a" /* default */],null):null,gameState.prevRoundSum.FB_value<=0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'warning-element content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_23__assets_img_icons_warning_svg___default.a,alt:'warning'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:Object(__WEBPACK_IMPORTED_MODULE_29__helpers_popupHelper__["d" /* getContent */])("dhgmstap2fb0",gameState.language)}}))):null,myState.SIMULATION_TAX==='PROCESSED'&&buitenland1+buitenland2>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_QuestionButton__["a" /* default */],{popupid:'dhgvtbuitenland'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_buitenland'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{feedbackCount:myState.buitenlandRead?0:1,onClick:function onClick(){if(!myState.buitenlandRead){dispatch(updateMyState({buitenlandRead:true}));}_this2.toggleOther('showBuitenlandDropdown');},bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_buitenland'),icon:__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_buitenland_svg___default.a,globas:this.getTotalBuitenland(gameStateSum),hidePoints:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buitenland interest-income country-budget'+(this.state.showBuitenlandDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaats_naar_buitenland')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_lonen_werknemers'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_AB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_BB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_CB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_VVB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_spaargeld_en_beleggingen'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BL_VB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totaal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBuitenland(gameStateSum),' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard'))))))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_TaxItemContainer__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_belastingen'),buttonConditions:this.validateTaxOne(),video:taxAVideo,saving:myState.SIMULATION_TAX==='SUBMITTED',saved:myState.SIMULATION_TAX==='PROCESSED',showSavedPopup:myState.showSavedPopup==='SIMULATION_TAX',buitenLandDialog:buitenland1,visible:true,step:'SIMULATION_TAX',savingMessage:'dhgmstap2opslaan1',feedbackMessage:'dhgmstap2opslaan1_2',part:1,popupId:'dhgvtbelastingendeel1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting'),selected:this.props.match&&this.props.match.params.taxid==='arbeidsbelasting',video:'https://player.vimeo.com/video/265045525',sliderKey:'arbeidsBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_globas,saving:myState.SIMULATION_TAX==='SUBMITTED',maxValue:100,cap:59,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.arbeidsBelasting,collaborationValue:myState.samenWerkingAB,collaborationKey:'samenWerkingAB',notification:{read:feedbackAB.read,reference:feedbackAB.id},icon:__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_belasting_1_svg___default.a,dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_lonenwerknemers'),globas:AB_economie}],feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_lonen_werknemers'),value:AB_economie+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).arbeidsBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.samenWerkingAB)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_arbeidsbelasting'),value:gameStateSum.AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_besteedbaar_inkomen_werknemers'),value:AB_economie-gameStateSum.BL_AB_globas-gameStateSum.AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["l" /* getImage */])(feedbackAB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackAB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["y" /* getText */])(feedbackAB,gameState.language),effects:this.getEffects(feedbackAB)},popupId:'dhgvtarbeidsbelasting',showDropdown:this.props.match.params.taxid==='arbeidsbelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting'),selected:this.props.match&&this.props.match.params.taxid==='bedrijvenbelasting',sliderKey:'bedrijvenBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.BB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.BB_globas,saving:myState.SIMULATION_TAX==='SUBMITTED',maxValue:100,cap:34,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.bedrijvenBelasting,collaborationValue:myState.samenWerkingBB,collaborationKey:'samenWerkingBB',notification:{read:feedbackBB.read,reference:feedbackBB.id},icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_belasting_2_svg___default.a,dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'),globas:BB_economie}],feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'),value:BB_economie+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).bedrijvenBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.samenWerkingBB)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_bedrijvenbelasting'),value:gameStateSum.BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_besteedbaar_inkomen_bedrijfseigenaren'),value:BB_economie-gameStateSum.BL_BB_globas-gameStateSum.BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["l" /* getImage */])(feedbackBB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackBB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["y" /* getText */])(feedbackBB,gameState.language),effects:this.getEffects(feedbackBB)},popupId:'dhgvtbedrijvenbelasting',showDropdown:this.props.match.params.taxid==='bedrijvenbelasting'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_TaxItemContainer__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_belastingen'),buttonConditions:this.validateTaxTwo(),video:taxBVideo,saving:myState.SIMULATION_TAX_2==='SUBMITTED',saved:myState.SIMULATION_TAX_2==='PROCESSED',showSavedPopup:myState.showSavedPopup==='SIMULATION_TAX_2',buitenLandDialog:!buitenland1&&buitenland2?buitenland2:false,visible:['SIMULATION_TAX_2','SIMULATION_SPENDING','END'].includes(currentState)&&Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["d" /* checkRead */])(feedbackAB,false,0,false)&&Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["d" /* checkRead */])(feedbackBB,false,0,false),step:'SIMULATION_TAX_2',savingMessage:'dhgmstap2opslaan2',feedbackMessage:'dhgmstap2opslaan2_2',part:2,popupId:'dhgvtbelastingendeel2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting'),selected:this.props.match&&this.props.match.params.taxid==='consumentenbelasting',video:'https://player.vimeo.com/video/265045525',sliderKey:'CBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.C_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.C_globas,saving:myState.SIMULATION_TAX_2==='SUBMITTED',maxValue:100,cap:34,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.CBelasting,collaborationValue:myState.CBelastingSW,collaborationKey:'CBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_belasting_3_svg___default.a,notification:{read:feedbackCB.read,reference:feedbackCB.id},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie'),globas:gameState.roundData.lastGameState.OneTimeEffect.CO}],feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie'),value:gameState.roundData.gameStateSum.CO_value+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).CBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.CBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_CB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_consumentenbelasting'),value:gameStateSum.C_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["l" /* getImage */])(feedbackCB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackCB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["y" /* getText */])(feedbackCB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackCB)},popupId:'dhgvtconsumentenbelasting',showDropdown:this.props.match.params.taxid==='consumentenbelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting'),selected:this.props.match&&this.props.match.params.taxid==='mensenmilieubelasting',video:'https://player.vimeo.com/video/265045525',sliderKey:'VVBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.VV_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.VV_globas,saving:myState.SIMULATION_TAX_2==='SUBMITTED',maxValue:100,cap:49,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.VVBelasting,collaborationValue:myState.VVBelastingSW,collaborationKey:'VVBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_belasting_4_svg___default.a,notification:{read:feedbackVVB.read,reference:feedbackVVB.id},feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'),value:gameState.roundData.gameStateSum.VV_value+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).VVBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.VVBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_VVB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_vervuilingsbelasting'),value:gameStateSum.VV_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["l" /* getImage */])(feedbackVVB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackVVB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["y" /* getText */])(feedbackVVB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackVVB)},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'),globas:gameState.roundData.lastGameState.OneTimeEffect.VV}],popupId:'dhgvtmensenmilieubelasting',showDropdown:this.props.match.params.taxid==='mensenmilieubelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vermogenbelasting'),selected:this.props.match&&this.props.match.params.taxid==='vermogensbelasting',video:'https://player.vimeo.com/video/265045525',sliderKey:'VBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.V_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.V_globas,saving:myState.SIMULATION_TAX_2==='SUBMITTED',maxValue:100,cap:6,minValue:0,registerShown:function registerShown(_){openedVBelasting=true;},capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vermogensbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.VBelasting,collaborationValue:myState.VBelastingSW,collaborationKey:'VBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg___default.a,notification:{read:feedbackVB.read,reference:feedbackVB.id},feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totale_vermogen_van_burgers'),value:gameState.totalGameStateSum.V_value+gameStateSum.V_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).VBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.VBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_VB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_vermogensbelasting'),value:gameStateSum.V_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["l" /* getImage */])(feedbackVB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackVB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["y" /* getText */])(feedbackVB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackVB)},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_besparingen_deze_periode'),globas:gameState.roundData.gameStateSum.V_value},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totale_vermogen_van_burgers'),globas:gameState.totalGameStateSum.V_value}],popupId:'dhgvtvermogensbelasting',showDropdown:this.props.match.params.taxid==='vermogensbelasting'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section overige-inkomsten'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__elements_PopupTitle__["a" /* default */],{popupId:'dhgvtoverigeinkomsten',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showOtherIncomeDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('Overige inkomsten'),icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_6_svg___default.a,globas:this.getOISum(overigeInkomsten,'-'),hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'other-income'+(this.state.showOtherIncomeDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],null,overigeInkomsten.map(function(oi,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_IncomeDetail__["a" /* default */],{key:i,img:oi.icon,title:oi.title,description:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["y" /* getText */])(oi,gameState.language),amount:oi.winstverliesglobas,unit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')});}))),debitCredit.length?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showInterestDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_aflossingen_en_rentes'),icon:__WEBPACK_IMPORTED_MODULE_20__assets_img_icons_belasting_7_svg___default.a,globas:totalDebitCredit,hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income'+(this.state.showInterestDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],null,debitCredit.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest',key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:item.icon,alt:'icon'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,item.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,-item.amount>0?'+'+-item.amount:-item.amount,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totaal')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,totalDebitCredit,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))))):''),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__elements_PopupTitle__["a" /* default */],{popupId:'dhgvtoverheidsbudget',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{reverseGlobasPoints:true,onClick:this.toggleOther.bind(this,'showBudgetDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_overheidsbudget'),icon:__WEBPACK_IMPORTED_MODULE_24__assets_img_icons_budget_png___default.a,globas:this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,totalDebitCredit),points:myState.SIMULATION_TAX!=='PROCESSED'?'-':this.getTotalBudgetPoints(gameStateSum),bigArrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income country-budget'+(this.state.showBudgetDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ContentContainer__["a" /* default */],null,gameStateSum.AB_point||gameStateSum.AB_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.AB_points,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.AB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.BB_points||gameStateSum.BB_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BB_points,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.BB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.C_points||gameStateSum.C_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.C_points,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.C_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.VV_points||gameStateSum.VV_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.VV_points,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.VV_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,gameStateSum.V_points||gameStateSum.V_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vermogenbelasting'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.V_points,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.V_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,this.getOISum(overigeInkomsten)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_overige_inkomsten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getOISum(overigeInkomsten),' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,totalDebitCredit?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_aflossingen_en_rentes'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,totalDebitCredit,' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totaal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBudgetPoints(gameStateSum),' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,totalDebitCredit),' ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')))))))));}}]);return Taxes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(state){return state;})(Taxes));

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Header__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_TaxItemContainer__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TaxItem__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_IncomeDetail__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__elements_EconomyTotal__ = __webpack_require__(126);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TaxesLow=(_temp=_class=function(_Component){_inherits(TaxesLow,_Component);function TaxesLow(props){_classCallCheck(this,TaxesLow);var _this=_possibleConstructorReturn(this,(TaxesLow.__proto__||Object.getPrototypeOf(TaxesLow)).call(this,props));_this.validateTaxOne=function(){var state=_this.props.gameStateInput.myState;var ab=state.arbeidsBelasting>=1&&state.arbeidsBelasting<=79;return ab;};_this.getWinstVerliesEffect=function(fb){return{icon:parseInt(fb.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_17__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_16__assets_img_icons_economy_min_globas_svg___default.a,title:parseInt(fb.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),contentTitle:fb.winstverliesglobas||0,contentUnit:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')};};_this.getEffects=function(fb){var effects=[];if(fb.economie){effects.push(_this.getWinstVerliesEffect(fb.economie));}return effects.concat((fb.overigeEffecten||[]).map(function(oe){return{icon:__WEBPACK_IMPORTED_MODULE_10__assets_assets__["g" /* ministryIcons */][oe.ministerie],title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])(oe.ministerie),contentTitle:Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["s" /* getPoints */])(oe),contentUnit:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_punten')};}));};_this.getOISum=function(overigeInkomsten,replacementChar){return overigeInkomsten.reduce(function(sum,oi){sum+=parseInt(oi.winstverliesglobas,10)||0;return sum;},0)||replacementChar||0;};_this.getTotalBudgetGlobas=function(state,oi,isBankDisabledForSimulation){var spaar=_this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(i){return i&&i.key;}).reduce(function(acc,i){if(i.key==='stortenSpaargeld'){return acc+-i.amount;}return acc+-i.amount;},0);return state.AB_globas+_this.getOISum(oi)+spaar;};_this.state={showReceivedInterestDropdown:false,showPaidInterestDropdown:false,showOtherIncomeDropdown:false,showBudgetDropdown:false,showEconomy:false};return _this;}_createClass(TaxesLow,[{key:'toggleOther',value:function toggleOther(property){var state=_extends({},this.state);state[property]=!state[property];this.setState(state);}},{key:'render',value:function render(){var _this2=this;var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,feedback=_props.feedback,desktop=_props.desktop,project=_props.project;var state=this.state;var myState=gameStateInput.myState;var gameStateSum=gameState.roundData.gameStateSum;var belastingFeedback=feedback.belastingFeedback;var overigeInkomsten=Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["r" /* getOverigeInkomsten */])(feedback.prevRoundFeedbackData,gameState,project.minPolicyChoices);var prevRoundSum=this.props.gameState.prevRoundSum;var teBetalen=null;var teOntvangen=null;var isBankDisabledForSimulation=false;if(myState&&myState.SIMULATION_TAX==='PROCESSED'){var currDC=gameState.roundData&&gameState.roundData.lastGameState&&gameState.roundData.lastGameState.OneTimeEffect&&gameState.roundData.lastGameState.OneTimeEffect.debitCredit;isBankDisabledForSimulation=currDC?currDC.some(function(c){return c.bankDisabledPayout;}):false;}else{isBankDisabledForSimulation=project.bankEnabled===false;}if(prevRoundSum&&prevRoundSum.OneTimeEffect&&prevRoundSum.OneTimeEffect.debitCredit){teBetalen=prevRoundSum.OneTimeEffect.debitCredit.map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(item){return item!=null&&item.amount>0;}).reduce(function(b,a){return a.amount+b;},0);teOntvangen=prevRoundSum.OneTimeEffect.debitCredit.map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(item){return item!=null&&item.amount<0&&item.key!=="stortenSpaargeld";}).reduce(function(b,a){return a.amount+b;},0);}var schuld=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.filter(function(i){return i.key==='lenenVanBank';}).map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(i){return i&&i.key;}).reduce(function(acc,i){return acc+-i.amount;},0);var spaargeld=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.filter(function(i){return i.key==='stortenSpaargeld';}).map(function(entry){return Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(entry,isBankDisabledForSimulation);}).filter(function(i){return i&&i.key;}).reduce(function(acc,i){if(i.key==='stortenSpaargeld'){return acc+-i.amount;}return acc+-i.amount;},0);if(!schuld)schuld=false;if(!spaargeld)spaargeld=false;spaargeld=spaargeld||0;schuld=schuld||0;var taxVideo=gameState.language==='NL'?__WEBPACK_IMPORTED_MODULE_20__config___default.a.uploadsUrl+'/assets/videos/belasting_LAAG_NL_720p_1,5Mbps.mp4':__WEBPACK_IMPORTED_MODULE_20__config___default.a.uploadsUrl+'/assets/videos/belasting_LAAG_ENG_720p_1,5Mbps.mp4';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,!desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Header__["a" /* default */],{history:this.props.history,historic:false,buttonType:'view',viewType:'list',showTitle:true}):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes laag'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__["a" /* default */],{popupId:'dlgvteconomie',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{bgColor:'darkblue',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_totalglobas'),icon:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_economy_economy_svg___default.a,globas:gameState.totalEconomy,hidePoints:true,onClick:function onClick(){return _this2.setState({showEconomy:!state.showEconomy});}}),state.showEconomy?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__elements_EconomyTotal__["a" /* default */],null):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_TaxItemContainer__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belasting'),video:taxVideo,saving:myState.SIMULATION_TAX==='SUBMITTED'||myState.SIMULATION_TAX_2==='SUBMITTED',saved:myState.SIMULATION_TAX==='PROCESSED'&&myState.SIMULATION_TAX_2==='PROCESSED',showSavedPopup:myState.showSavedPopup==='SIMULATION_TAX_2',visible:true,step:'SIMULATION_TAX',savingMessage:'dlgmstap3opslaan_2',feedbackMessage:'dlgmstap2opslaan_3',buttonConditions:this.validateTaxOne(),popupId:'dlgvtbelasting'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TaxItem__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belastinginkomsten'),video:'https://player.vimeo.com/video/265045525',reverseGlobasPoints:true,sliderKey:'arbeidsBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_globas,twoValueSlider:true,suffix:'%',sliderTitles:[Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belasting'),Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_bevolking')],maxValue:100,cap:79,minValue:0,capNotification:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_arbeidsbelasting_te_hoog_percentage_melding'),sliderValue:myState.arbeidsBelasting,notification:{read:belastingFeedback.read,reference:belastingFeedback.id},icon:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_L_belasting_1_svg___default.a,taxDescription:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_arbeidsbelasting_beschrijving'),feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[],img:Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["l" /* getImage */])(belastingFeedback),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["m" /* getImageText */])(belastingFeedback,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["y" /* getText */])(belastingFeedback,gameState.language),effects:this.getEffects(belastingFeedback)},popupId:'dlgvtbelasting',ignorePopup:true,showDropdown:this.props.paramsTaxId==='belasting'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section overige-inkomsten'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopupTitle__["a" /* default */],{popupId:'dlgvtoverigeinkomsten',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showOtherIncomeDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_overige_inkomsten'),icon:__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_6_svg___default.a,globas:this.getOISum(overigeInkomsten,'-'),hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'other-income'+(this.state.showOtherIncomeDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_ContentContainer__["a" /* default */],null,overigeInkomsten.map(function(oi,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__elements_IncomeDetail__["a" /* default */],{key:i,img:oi.icon,title:oi.title,description:Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["y" /* getText */])(oi,gameState.language),amount:oi.winstverliesglobas+"",unit:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')});}))),spaargeld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showReceivedInterestDropdown'),bgColor:'white',title:isBankDisabledForSimulation?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_spaargeld'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_rente_op_spaargeld'),icon:__WEBPACK_IMPORTED_MODULE_18__assets_img_icons_belasting_5_svg___default.a,globas:spaargeld,hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income'+(this.state.showReceivedInterestDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,isBankDisabledForSimulation?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_spaargeld_bank_uitgeschakeld_uitleg'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_ontvangen_rente_uitleg'))))):null,schuld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showPaidInterestDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_terug_te_betalen_lening'),icon:__WEBPACK_IMPORTED_MODULE_19__assets_img_icons_belasting_7_svg___default.a,globas:schuld,hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income'+(this.state.showPaidInterestDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_basic_bedrag_vorige_ronde_geleend_uitleg'))))):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'plus'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_budget')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{onClick:this.toggleOther.bind(this,'showBudgetDropdown'),bgColor:'white',title:Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_totale_budget'),icon:__WEBPACK_IMPORTED_MODULE_15__assets_img_icons_budget_png___default.a,globas:this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,isBankDisabledForSimulation),hidePoints:true,arrow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'interest-income country-budget'+(this.state.showBudgetDropdown?' active':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_ContentContainer__["a" /* default */],null,gameStateSum.AB_globas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_belastinginkomsten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,gameStateSum.AB_globas,' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',this.getOISum(overigeInkomsten)?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_overige_inkomsten'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getOISum(overigeInkomsten),' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',spaargeld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,isBankDisabledForSimulation?Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_spaargeld'):Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_rente_op_spaargeld'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,spaargeld,' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',schuld?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_terug_te_betalen_lening'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,schuld,' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))):'',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'plus-minus'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'table-interest bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_totaal'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,this.getTotalBudgetGlobas(gameStateSum,overigeInkomsten,isBankDisabledForSimulation),' ',Object(__WEBPACK_IMPORTED_MODULE_7_i18n_for_browser__["a" /* __ */])('sim_miljard')))))))));}}]);return TaxesLow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={inheritedState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,gameStateInput=_ref.gameStateInput,project=_ref.project,schoolClass=_ref.schoolClass;return{gameState:gameState,feedback:feedback,gameStateInput:gameStateInput,project:project,schoolClass:schoolClass};})(TaxesLow));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TaxItemMain__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TaxesLowMain__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_belasting_1_svg__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_belasting_2_svg__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_belasting_2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_belasting_2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_belasting_3_svg__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_belasting_3_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_belasting_3_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_belasting_4_svg__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_belasting_4_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_belasting_4_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_5_svg__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_5_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_5_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__config__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var Taxes=(_temp=_class=function(_Component){_inherits(Taxes,_Component);function Taxes(props){_classCallCheck(this,Taxes);var _this=_possibleConstructorReturn(this,(Taxes.__proto__||Object.getPrototypeOf(Taxes)).call(this,props));_this.getGroupIcons=function(){var groups=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var schoolClass=_this.props.schoolClass;return groups.map(function(grp,i){var g=schoolClass.Groups.find(function(g){return g.GroupTheme.color===grp;});if(g)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{key:Math.random()+i+'lolimsorandom',className:'tax-item-badge',src:''+__WEBPACK_IMPORTED_MODULE_17__config___default.a.apiUrl+g.GroupTheme.badge,alt:'badge'});return null;});};_this.getWinstVerliesEffect=function(fb){return{icon:parseInt(fb.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_14__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_economy_min_globas_svg___default.a,title:parseInt(fb.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),contentTitle:fb.winstverliesglobas||0,contentUnit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')};};_this.getEffects=function(fb){var effects=[];if(fb.economie){effects.push(_this.getWinstVerliesEffect(fb.economie));}return effects.concat(fb.overigeEffecten.map(function(oe){return{icon:__WEBPACK_IMPORTED_MODULE_15__assets_assets__["g" /* ministryIcons */][oe.ministerie],title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(oe.ministerie),contentTitle:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["s" /* getPoints */])(oe),contentUnit:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_punten')};}));};_this.state={showOtherIncomeDropdown:false,showBuitenlandDropdown:false,showInterestDropdown:false,showBudgetDropdown:false};return _this;}_createClass(Taxes,[{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,feedback=_props.feedback;var myState=gameStateInput.myState;var _gameState$roundData=gameState.roundData,gameStateSum=_gameState$roundData.gameStateSum,roundGameStateInput=_gameState$roundData.gameStateInput;var feedbackAB=feedback.feedbackAB,feedbackBB=feedback.feedbackBB,feedbackCB=feedback.feedbackCB,feedbackVVB=feedback.feedbackVVB,feedbackVB=feedback.feedbackVB;if(this.props.project.difficulty==='BASIC'){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TaxesLowMain__["a" /* default */],{desktop:this.props.desktop,history:this.props.history,inheritedState:this.state,getGroupIcons:this.getGroupIcons,paramsTaxId:this.props.match.params.taxid});}var AB_economie=gameStateSum.AB_economie,BB_economie=gameStateSum.BB_economie;AB_economie=AB_economie||Math.round(gameState.totalEconomy*myState.taxDividence);BB_economie=BB_economie||gameState.totalEconomy-AB_economie;var buitenland2=gameStateSum.BL_VVB_globas+gameStateSum.BL_CB_globas+gameStateSum.BL_VB_globas;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg taxes-main-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TaxItemMain__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'arbeidsBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_globas,maxValue:100,cap:59,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.arbeidsBelasting,collaborationValue:myState.samenWerkingAB,collaborationKey:'samenWerkingAB',notification:{read:feedbackAB.read,reference:feedbackAB.id},icon:__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_belasting_1_svg___default.a,dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_lonenwerknemers'),globas:AB_economie}],feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_lonenwerknemers'),value:AB_economie+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).arbeidsBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.samenWerkingAB)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_arbeidsbelasting'),value:gameStateSum.AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_besteedbaar_inkomen_werknemers'),value:AB_economie-gameStateSum.BL_AB_globas-gameStateSum.AB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["l" /* getImage */])(feedbackAB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackAB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["y" /* getText */])(feedbackAB,gameState.language),effects:this.getEffects(feedbackAB)},popupId:'dhgvtarbeidsbelasting',showDropdown:this.props.match.params.taxid==='arbeidsbelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TaxItemMain__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting'),sliderKey:'bedrijvenBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.BB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.BB_globas,maxValue:100,cap:34,minValue:1,buitenLandDialog:buitenland2,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.bedrijvenBelasting,collaborationValue:myState.samenWerkingBB,collaborationKey:'samenWerkingBB',notification:{read:feedbackBB.read,reference:feedbackBB.id},icon:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_belasting_2_svg___default.a,dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'),globas:BB_economie}],feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_winsten_bedrijfseigenaren'),value:BB_economie+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).bedrijvenBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.samenWerkingBB)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_bedrijvenbelasting'),value:gameStateSum.BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_besteedbaar_inkomen_bedrijfseigenaren'),value:BB_economie-gameStateSum.BL_BB_globas-gameStateSum.BB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["l" /* getImage */])(feedbackBB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackBB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["y" /* getText */])(feedbackBB,gameState.language),effects:this.getEffects(feedbackBB)},popupId:'dhgvtbedrijvenbelasting',showDropdown:this.props.match.params.taxid==='bedrijvenbelasting'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TaxItemMain__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'CBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.C_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.C_globas,maxValue:100,cap:34,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.CBelasting,collaborationValue:myState.CBelastingSW,collaborationKey:'CBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_belasting_3_svg___default.a,notification:{read:feedbackCB.read,reference:feedbackCB.id},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie'),globas:gameState.roundData.lastGameState.OneTimeEffect.CO}],feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie'),value:gameState.roundData.gameStateSum.CO_value+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).CBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.CBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_CB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_consumentenbelasting'),value:gameStateSum.C_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["l" /* getImage */])(feedbackCB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackCB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["y" /* getText */])(feedbackCB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackCB)},popupId:'dhgvtconsumentenbelasting',showDropdown:this.props.match.params.taxid==='consumentenbelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TaxItemMain__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'VVBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.VV_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.VV_globas,maxValue:100,cap:49,minValue:1,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.VVBelasting,collaborationValue:myState.VVBelastingSW,collaborationKey:'VVBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_belasting_4_svg___default.a,notification:{read:feedbackVVB.read,reference:feedbackVVB.id},feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'),value:gameState.roundData.gameStateSum.VV_value+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozen_belastingspercentage'),value:(roundGameStateInput||{}).VVBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.VVBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_VVB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_vervuilingsbelasting'),value:gameStateSum.VV_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["l" /* getImage */])(feedbackVVB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackVVB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["y" /* getText */])(feedbackVVB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackVVB)},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumptie_schadelijke_producten'),globas:gameState.roundData.lastGameState.OneTimeEffect.VV}],popupId:'mhgvtmensenmilieubelasting',showDropdown:this.props.match.params.taxid==='mensenmilieubelasting'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TaxItemMain__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vermogenbelasting'),video:'https://player.vimeo.com/video/265045525',sliderKey:'VBelasting',points:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.V_points,globas:myState.SIMULATION_TAX_2!=='PROCESSED'?'-':gameStateSum.V_globas,maxValue:100,cap:6,minValue:0,capNotification:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vermogensbelasting_te_hoog_percentage_melding'),type:'taxSlider',suffix:'%',sliderValue:myState.VBelasting,collaborationValue:myState.VBelastingSW,collaborationKey:'VBelastingSW',icon:__WEBPACK_IMPORTED_MODULE_12__assets_img_icons_belasting_5_svg___default.a,notification:{read:feedbackVB.read,reference:feedbackVB.id},feedbackData:{show:myState.SIMULATION_TAX_2==='PROCESSED',topData:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totale_vermogen_van_burgers'),value:gameState.totalGameStateSum.V_value+gameStateSum.V_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_gekozenbelastingpercentage'),value:(roundGameStateInput||{}).VBelasting+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_procent',1).toLowerCase()},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_samenwerkingmetanderelanden'),value:this.getGroupIcons(myState.collaborationMatches.VBelastingSW)},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verplaatst_naar_buitenland'),hideWhenZero:true,value:gameStateSum.BL_VB_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_geinde_vermogensbelasting'),value:gameStateSum.V_globas+' '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_miljard')}],img:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["l" /* getImage */])(feedbackVB),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["m" /* getImageText */])(feedbackVB,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_7__helpers_feedbackHelpers__["y" /* getText */])(feedbackVB,gameState.language),// TODO: multilanguage and niveau based and icons??
effects:this.getEffects(feedbackVB)},dataList:[{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_besparingen_deze_periode'),globas:gameState.roundData.gameStateSum.V_value},{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totale_vermogen_van_burgers'),globas:gameState.totalGameStateSum.V_value}],popupId:'dhgvtvermogensbelasting',showDropdown:this.props.match.params.taxid==='vermogensbelasting'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__elements_NextStep__["a" /* default */],null));}}]);return Taxes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({}).isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(state){return state;})(Taxes));

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowTax.2795e822.png";

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TaxItemMain__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_L_belasting_1_svg__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_L_belasting_1_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_L_belasting_1_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_min_globas_svg__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_min_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_min_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_up_globas_svg__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_up_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_up_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_NextStep__ = __webpack_require__(35);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var submitMyState=__WEBPACK_IMPORTED_MODULE_9__actions__["a" /* default */].gameStateInput.submitMyState;var TaxesLow=(_temp=_class=function(_Component){_inherits(TaxesLow,_Component);function TaxesLow(props){_classCallCheck(this,TaxesLow);var _this=_possibleConstructorReturn(this,(TaxesLow.__proto__||Object.getPrototypeOf(TaxesLow)).call(this,props));_this.getWinstVerliesEffect=function(fb){return{icon:parseInt(fb.winstverliesglobas,10)>=0?__WEBPACK_IMPORTED_MODULE_8__assets_img_icons_economy_up_globas_svg___default.a:__WEBPACK_IMPORTED_MODULE_7__assets_img_icons_economy_min_globas_svg___default.a,title:parseInt(fb.winstverliesglobas,10)>=0?Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_winstglobas'):Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_verliesglobas'),contentTitle:fb.winstverliesglobas||0,contentUnit:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_miljard')};};_this.getEffects=function(fb){var effects=[];if(fb.economie){effects.push(_this.getWinstVerliesEffect(fb.economie));}return effects.concat((fb.overigeEffecten||[]).map(function(oe){return{icon:__WEBPACK_IMPORTED_MODULE_6__assets_assets__["g" /* ministryIcons */][oe.ministerie],title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])(oe.ministerie),contentTitle:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["s" /* getPoints */])(oe),contentUnit:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_punten')};}));};_this.state={showReceivedInterestDropdown:false,showPaidInterestDropdown:false,showOtherIncomeDropdown:false,showBudgetDropdown:false};return _this;}_createClass(TaxesLow,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){// In this nasty hack, we fake a second tax step like we have in the PRO version.
// When the first tax step is processed, we dispatch the second (empty) step.
var myState=this.props.gameStateInput.myState;if(myState.SIMULATION_TAX==='PROCESSED'){this.props.dispatch(submitMyState('SIMULATION_TAX_2'));}}},{key:'render',value:function render(){var _props=this.props,gameState=_props.gameState,gameStateInput=_props.gameStateInput,feedback=_props.feedback;var myState=gameStateInput.myState;var gameStateSum=gameState.roundData.gameStateSum;var belastingFeedback=feedback.belastingFeedback;var isBankDisabledForSimulation=false;if(myState&&myState.SIMULATION_TAX==='PROCESSED'){var currDC=gameState.roundData&&gameState.roundData.lastGameState&&gameState.roundData.lastGameState.OneTimeEffect&&gameState.roundData.lastGameState.OneTimeEffect.debitCredit;isBankDisabledForSimulation=currDC?currDC.some(function(c){return c.bankDisabledPayout;}):false;}else{isBankDisabledForSimulation=this.props.project.bankEnabled===false;}var schuld=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.find(function(i){return i.key==='lenenVanBank';});var spaargeld=this.props.gameState.prevRoundSum.OneTimeEffect.debitCredit.find(function(i){return i.key==='stortenSpaargeld';});if(schuld)schuld=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(schuld,isBankDisabledForSimulation);if(spaargeld)spaargeld=Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["b" /* calculateDebitCreditOutcomeBasic */])(spaargeld,isBankDisabledForSimulation);if(!schuld)schuld={};if(!spaargeld)spaargeld={};spaargeld.amount=-spaargeld.amount||0;schuld.amount=-schuld.amount||0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container taxes'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'taxes-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TaxItemMain__["a" /* default */],{history:this.props.history,title:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belastinginkomsten'),video:'https://player.vimeo.com/video/265045525',reverseGlobasPoints:true,sliderKey:'arbeidsBelasting',points:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_points,globas:myState.SIMULATION_TAX!=='PROCESSED'?'-':gameStateSum.AB_globas,twoValueSlider:true,suffix:'%',sliderTitles:[Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_belasting'),Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_bevolking')],maxValue:100,cap:79,minValue:0,capNotification:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_basic_arbeidsbelasting_te_hoog_percentage_melding'),sliderValue:myState.arbeidsBelasting,notification:{read:belastingFeedback.read,reference:belastingFeedback.id},icon:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_L_belasting_1_svg___default.a,taxDescription:Object(__WEBPACK_IMPORTED_MODULE_3_i18n_for_browser__["a" /* __ */])('sim_basic_arbeidsbelasting_beschrijving'),feedbackData:{show:myState.SIMULATION_TAX==='PROCESSED',topData:[],img:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["l" /* getImage */])(belastingFeedback),imgDescription:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["m" /* getImageText */])(belastingFeedback,gameState.language),description:Object(__WEBPACK_IMPORTED_MODULE_11__helpers_feedbackHelpers__["y" /* getText */])(belastingFeedback,gameState.language),effects:this.getEffects(belastingFeedback)},popupId:'dlgvtbelasting',ignorePopup:true,showDropdown:this.props.paramsTaxId==='belasting'})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_NextStep__["a" /* default */],null));}}]);return TaxesLow;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={inheritedState:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired},_class.defaultProps={desktop:false},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,gameStateInput=_ref.gameStateInput,project=_ref.project,schoolClass=_ref.schoolClass;return{gameState:gameState,feedback:feedback,gameStateInput:gameStateInput,project:project,schoolClass:schoolClass};})(TaxesLow));

/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DifficultyAwareComponent__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_SectionHeading__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BudgetSlider__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_StepThree_BudgetCollaboration__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PolicyElement__ = __webpack_require__(1011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_globas_svg__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_globas_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_globas_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_MapElements_shadow_png__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_img_MapElements_shadow_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_img_MapElements_shadow_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_beleidskeuze_svg__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assets_img_icons_beleidskeuze_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_beleidskeuze_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__elements_PopUp__ = __webpack_require__(14);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updateMyState=__WEBPACK_IMPORTED_MODULE_18__actions__["c" /* gameStateInput */].updateMyState;var iconSize=2;/**
 * Import assets
 */var MinistryBudget=(_temp=_class=function(_DifficultyAwareCompo){_inherits(MinistryBudget,_DifficultyAwareCompo);function MinistryBudget(props){_classCallCheck(this,MinistryBudget);var _this=_possibleConstructorReturn(this,(MinistryBudget.__proto__||Object.getPrototypeOf(MinistryBudget)).call(this,props));_this.setImage=function(min,value,difficulty){var type=void 0;if(difficulty==='pro'){if(Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["D" /* ministryOverfinanced */])(min,_this.props.gameState))type=5;else type=Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["o" /* getMinistryARating */])(difficulty,min,value,_this.props.feedback.prevRoundFeedbackData)+1;if(__WEBPACK_IMPORTED_MODULE_17__Defines__["a" /* default */].i18nMinistries.indexOf(min)!==-1&&type>2)type-=1;}else if(difficulty==='basic'){var color=Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["p" /* getMinistryColor */])(difficulty,min,_this.props.gameState,_this.props.gameStateInput,_this.props.feedback.prevRoundFeedbackData);var internationalMinistry=__WEBPACK_IMPORTED_MODULE_17__Defines__["a" /* default */].i18nMinistries.indexOf(min)!==-1;if(internationalMinistry){if(color==='red')type=1;if(color==='orange'||color==='lowOrange')type=2;if(color==='yellow'||color==='lowYellow')type=2;if(color==='green')type=3;if(Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["D" /* ministryOverfinanced */])(min,_this.props.gameState))type=4;}else{if(color==='red')type=1;if(color==='orange'||color==='lowOrange')type=2;if(color==='yellow'||color==='lowYellow')type=3;if(color==='green')type=4;if(Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["D" /* ministryOverfinanced */])(min,_this.props.gameState))type=5;}}return __WEBPACK_IMPORTED_MODULE_16__assets_assets__["f" /* mapElements */]['map_'+min+'__'+min+type+(iconSize!==false?iconSize+'x':'')];};_this.setPlateau=function(min,value,difficulty){var color=Object(__WEBPACK_IMPORTED_MODULE_21__helpers_feedbackHelpers__["p" /* getMinistryColor */])(difficulty,min,_this.props.gameState,_this.props.gameStateInput,_this.props.feedback.prevRoundFeedbackData);return __WEBPACK_IMPORTED_MODULE_16__assets_assets__["e" /* mapColors */][difficulty+'_'+color];};_this.state={ministry:_this.props.match.params.id.toUpperCase(),allChoicesMadePopup:false};_this.maxVal=undefined;return _this;}_createClass(MinistryBudget,[{key:'renderLaag',value:function renderLaag(){var _props=this.props,gameState=_props.gameState,myState=_props.myState,dispatch=_props.dispatch,policyChoice=_props.policyChoice,loaded=_props.loaded,gameStateInput=_props.gameStateInput;var ministry=this.props.match.params.id.toUpperCase();var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling,policyChoices=myState.policyChoices;var globas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,policyChoices,ministerieGlobaVerdeling,Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput),policyChoice);var international=__WEBPACK_IMPORTED_MODULE_17__Defines__["a" /* default */].i18nMinistries.includes(ministry);if(!this.maxVal&&loaded){if(globas+(ministerieGlobaVerdeling[ministry]||0)>20){this.maxVal=20;}else{this.maxVal=globas+(ministerieGlobaVerdeling[ministry]||0);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-budget-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'small-policy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:__WEBPACK_IMPORTED_MODULE_16__assets_assets__["g" /* ministryIcons */][ministry]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__elements_PopupTitle__["a" /* default */],{customClass:'popup-heading',popupId:'d'+__WEBPACK_IMPORTED_MODULE_17__Defines__["a" /* default */].ministryPopupIds.basic[ministry].substring(1),tag:'h4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__elements_GoBackButton__["a" /* default */],{history:this.props.history})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policy-content-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'map-icon'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.setImage(ministry,gameState.gameStateSum[ministry+'_value'],gameState.difficulty.toLowerCase()),alt:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])(ministry)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'plateau',src:this.setPlateau(ministry,gameState.gameStateSum[ministry+'_value'],gameState.difficulty.toLowerCase()),alt:'plateau'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shadow',src:__WEBPACK_IMPORTED_MODULE_12__assets_img_MapElements_shadow_png___default.a,alt:'shadow'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',{className:'popup-heading'},Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])("sim_vraag_hoeveel_globas_aan_ministerie")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BudgetSlider__["a" /* default */],{role:this.props.user.role,key:ministry,unit:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])('sim_miljard'),value:ministerieGlobaVerdeling[ministry]||0,disabled:globas<0,customOnChange:function customOnChange(k,v){var globasLeft=globas+(ministerieGlobaVerdeling[ministry]||0)-v;if(globasLeft>=0||v<(ministerieGlobaVerdeling[ministry]||0)){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,v))}));return;}if(globasLeft<0){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,(ministerieGlobaVerdeling[ministry]||0)+globas))}));}},min:0,max:this.maxVal,ignoreMax:true}),international?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_StepThree_BudgetCollaboration__["a" /* default */],{value:ministerieGlobaVerdeling[ministry+'SW'],customOnChange:function customOnChange(k,v){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry+'SW',v))}));},title:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')+':'}):null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_NextStep__["a" /* default */],null));}},{key:'renderHoog',value:function renderHoog(){var _this2=this;var _props2=this.props,gameStateInput=_props2.gameStateInput,gameState=_props2.gameState,myState=_props2.myState,dispatch=_props2.dispatch,policyChoice=_props2.policyChoice,loaded=_props2.loaded;var ministry=this.props.match.params.id.toUpperCase();var ministerieGlobaVerdeling=myState.ministerieGlobaVerdeling,policyChoices=myState.policyChoices;var savingsAndLoans=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput);var globas=Object(__WEBPACK_IMPORTED_MODULE_9__helpers_calculationsHelper__["b" /* calculateBudgetPRO */])(gameState,gameStateInput,policyChoices,myState.ministerieGlobaVerdeling,savingsAndLoans);var international=__WEBPACK_IMPORTED_MODULE_17__Defines__["a" /* default */].i18nMinistries.includes(ministry);if(!this.maxVal&&loaded){if(globas+(ministerieGlobaVerdeling[ministry]||0)>100){this.maxVal=100;}else{this.maxVal=globas+(ministerieGlobaVerdeling[ministry]||0);}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ministry-budget-container hoog'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'icon',src:__WEBPACK_IMPORTED_MODULE_16__assets_assets__["g" /* ministryIcons */][ministry]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__elements_PopupTitle__["a" /* default */],{customClass:'popup-heading',popupId:'d'+__WEBPACK_IMPORTED_MODULE_17__Defines__["a" /* default */].ministryPopupIds.pro[ministry].substring(1),tag:'h4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__elements_GoBackButton__["a" /* default */],{history:this.props.history})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policy-content-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policy-content-box'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_SectionHeading__["a" /* default */],{icon:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_globas_svg___default.a,title:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])('sim_budgetkeuze'),popupId:'dhgvtbudgetkeuze'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ContentContainer__["a" /* default */],{className:international?'':'national-ministry'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_StepThree_BudgetSlider__["a" /* default */],{role:this.props.user.role,unit:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])('sim_miljard'),disabled:globas<0,value:ministerieGlobaVerdeling[ministry]||0,customOnChange:function customOnChange(k,v){var globasLeft=globas+(ministerieGlobaVerdeling[ministry]||0)-v;if(globasLeft>=0||v<(ministerieGlobaVerdeling[ministry]||0)){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,v))}));return;}if(globasLeft<0){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry,(ministerieGlobaVerdeling[ministry]||0)+globas))}));}},min:0,max:this.maxVal,ignoreMax:true}),international?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_StepThree_BudgetCollaboration__["a" /* default */],{value:ministerieGlobaVerdeling[ministry+'SW'],customOnChange:function customOnChange(k,v){dispatch(updateMyState({ministerieGlobaVerdeling:_extends({},ministerieGlobaVerdeling,_defineProperty({},ministry+'SW',v))}));},title:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')+':'}):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policy-content-box map-icon',style:{marginBottom:'-35px'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:this.setImage(ministry,gameState.gameStateSum[ministry+'_value'],gameState.difficulty.toLowerCase()),alt:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])(ministry)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'plateau',src:this.setPlateau(ministry,gameState.gameStateSum[ministry+'_value'],gameState.difficulty.toLowerCase()),alt:'plateau'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'shadow',src:__WEBPACK_IMPORTED_MODULE_12__assets_img_MapElements_shadow_png___default.a,alt:'shadow'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_SectionHeading__["a" /* default */],{style:{marginTop:'20px'},className:"noMargin",icon:__WEBPACK_IMPORTED_MODULE_13__assets_img_icons_beleidskeuze_svg___default.a,title:Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),popupId:'dhgvtbeleidskeuzes'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'policiesWrap'},Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["m" /* policiesForMinisterie */])(policyChoice,ministry).map(function(choice,key){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PolicyElement__["a" /* default */],{key:ministry+choice.Nummer+key,title:choice['titel_beleidskeuze_'+gameState.language],globas:parseInt(choice.kosten_globas[0],10),collaborationGlobas:choice.kosten_globas.length>1?parseInt(choice.kosten_globas[1],10):0,value:policyChoices[choice.omschrijving]||{},onChange:function onChange(v){if(v.selected===false){delete policyChoices[choice.omschrijving];dispatch(updateMyState({policyChoices:policyChoices}));}else{var newPolicyChoices=_extends({},policyChoices,_defineProperty({},choice.omschrijving,_extends({},v,{ministry:ministry,nummer:choice.Nummer})));var numChoices=Object(__WEBPACK_IMPORTED_MODULE_10__helpers_policyChoiceHelper__["h" /* getSelectedPolicyChoicesCount */])(newPolicyChoices);if(numChoices>10){_this2.setState({allChoicesMadePopup:true});return;}if(v.option&&globas-v.globas<0){return;}_this2.maxVal=undefined;dispatch(updateMyState({policyChoices:newPolicyChoices}));}}},choice['tekst_beleidskeuze_'+gameState.language]);})),this.state.allChoicesMadePopup?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__elements_PopUp__["a" /* default */],{interactive:true,closePopUpCross:true,closePopUpClick:function closePopUpClick(){_this2.setState({allChoicesMadePopup:false});}},Object(__WEBPACK_IMPORTED_MODULE_15_i18n_for_browser__["a" /* __ */])('sim_maximum_beleidskeuzes_bereikt')):null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_NextStep__["a" /* default */],null));}}]);return MinistryBudget;}(__WEBPACK_IMPORTED_MODULE_3__DifficultyAwareComponent__["a" /* default */]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var user=_ref.user,gameState=_ref.gameState,feedback=_ref.feedback,gameStateInput=_ref.gameStateInput,policyChoice=_ref.policyChoice,project=_ref.project;return{user:user,policyChoice:policyChoice,gameState:gameState,feedback:feedback,project:project,loaded:gameStateInput.loaded,myState:gameStateInput.myState,gameStateInput:gameStateInput};})(MinistryBudget));

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elements_StepThree_BudgetCollaboration__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_group_png__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_icons_group_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_group_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PolicyElement=(_temp=_class=function(_Component){_inherits(PolicyElement,_Component);function PolicyElement(props){_classCallCheck(this,PolicyElement);var _this=_possibleConstructorReturn(this,(PolicyElement.__proto__||Object.getPrototypeOf(PolicyElement)).call(this,props));_this.collaborationEl=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.policyOptions=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.policyHeader=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();_this.state={open:false};_this.onCollabChange=_this.onCollabChange.bind(_this);_this.selectOption=_this.selectOption.bind(_this);//this.openClose = this.openClose.bind(this);
return _this;}_createClass(PolicyElement,[{key:"selectOption",value:function selectOption(selected){if(this.props.value.option!==selected){this.setValues({option:selected,selected:true,collaboration:[]});}else{this.setValues({option:'',selected:false});}}},{key:"componentDidUpdate",value:function componentDidUpdate(oldProps){var props=this.props;if(oldProps&&props.value.option!==oldProps.value.option&&this.collaborationEl&&props.value.option==='collab'){if(this.collaborationEl.current){this.collaborationEl.current.scrollIntoView({behavior:'smooth'});}}}},{key:"openClose",value:function openClose(){var _this2=this;if(!this.state.open){this.setState(function(prevState){return{open:!prevState.open};},function(){if(_this2.state.open){if(_this2.policyOptions.current){_this2.policyOptions.current.scrollIntoView({behavior:'smooth'});}}else{if(_this2.policyHeader.current){_this2.policyHeader.current.scrollIntoView({behavior:'smooth'});}}});}}},{key:"onCollabChange",value:function onCollabChange(key,val){this.setValues({'collaboration':val});}},{key:"setValues",value:function setValues(values){var v=_extends({title:this.props.title,option:this.props.value.option,selected:this.props.value.selected,collaboration:this.props.value.collaboration},values);v.globas=0;if(v.option==='collab')v.globas=this.props.collaborationGlobas;if(v.option==='single')v.globas=this.props.globas;this.props.onChange(v);}},{key:"render",value:function render(){var _this3=this;var props=this.props;var value=props.value,schoolClass=props.schoolClass;var title=void 0;var maxGlobas=void 0,rows=void 0;var globas=props.globas;if(props.collaborationGlobas){title=globas+'/'+props.collaborationGlobas;maxGlobas=props.collaborationGlobas;}else{title=props.globas;maxGlobas=props.globas;}if(value.collaboration){rows='three';if(value.collaboration.length<=2){rows='one';}else if(value.collaboration.length<=4){rows='two';}}var groupBadge=function groupBadge(name,i){var matchedGroup=schoolClass.Groups.find(function(g){return g.GroupTheme.color===name;});if(matchedGroup)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{key:i,className:'collab-inline-item-badge',src:""+__WEBPACK_IMPORTED_MODULE_10__config___default.a.apiUrl+matchedGroup.GroupTheme.badge,alt:'badge'});};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"policy-element-pos"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:function onClick(){return _this3.openClose();},className:'policy-element'+(!this.state.open?' closed':'')+(value.selected?' checked':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'policy-header-element',ref:this.policyHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,value.selected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_5__assets_img_icons_check_svg___default.a,alt:'selected',className:'selected'}):null,props.title),value.collaboration?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'collab-icons '+rows},value.collaboration.map(function(group,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:i},groupBadge(group,i));})):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"point-holder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'point-holder-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:title},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{title:"Miljard"},"Miljard")))),this.state.open?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_PopUp__["a" /* default */],{closePopUpClick:function closePopUpClick(){return _this3.setState({open:false});},interactive:true,closePopUpCross:true,hideClose:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'hidden-content policy-choice-popup-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h4",null,props.title," ",props.collaborationGlobas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:{height:'14px',marginTop:'-2px'},src:__WEBPACK_IMPORTED_MODULE_11__assets_img_icons_global_svg___default.a,className:"global-icon",alt:"global-icon"}):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:'desc'},props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'policy-options',ref:this.policyOptions},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_PopupTitle__["a" /* default */],{popupId:'mhgvtselecteerbeleidskeuze',tag:'h5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:'options'+(this.props.user.role==='groupmember'?' groupmember-disabled':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:'delay-30 option'+(value.option==='single'?' active':''),onClick:this.selectOption.bind(this,'single')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Avatar",src:__WEBPACK_IMPORTED_MODULE_3__assets_img_icons_single_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"point-holder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'point-holder-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:props.globas},props.globas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))))),props.collaborationGlobas?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:'delay-45 option'+(value.option==='collab'?' active':''),onClick:this.selectOption.bind(this,'collab')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{alt:"Group",src:__WEBPACK_IMPORTED_MODULE_4__assets_img_icons_group_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"point-holder"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'point-holder-details'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{title:maxGlobas},maxGlobas),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard')},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_miljard'))))):'')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'show-hide-collab '+(value.option==='collab'?' show':''),ref:this.collaborationEl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__elements_StepThree_BudgetCollaboration__["a" /* default */],{customOnChange:this.onCollabChange,value:props.value.collaboration,title:Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_selecteer_samenwerk_landen')+':'})))):''));}}]);return PolicyElement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={onChange:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,globas:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,collaborationGlobas:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,value:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object// value obj is:
// globas: PropTypes.number,
// option: PropTypes.string,
// selected: PropTypes.bool,
},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var schoolClass=_ref.schoolClass,user=_ref.user;return{schoolClass:schoolClass,user:user};})(PolicyElement));

/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__elements_NextStep__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_PolicyChoiceLaag__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers_calculationsHelper__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_policyChoiceHelper__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_scrollbars_custom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Import assets
 */var Beleidskeuzes=(_temp=_class=function(_Component){_inherits(Beleidskeuzes,_Component);function Beleidskeuzes(){_classCallCheck(this,Beleidskeuzes);return _possibleConstructorReturn(this,(Beleidskeuzes.__proto__||Object.getPrototypeOf(Beleidskeuzes)).apply(this,arguments));}_createClass(Beleidskeuzes,[{key:'componentDidMount',value:function componentDidMount(){}},{key:'render',value:function render(){var _this2=this;var _props=this.props,gameState=_props.gameState,feedback=_props.feedback,policyChoice=_props.policyChoice,gameStateInput=_props.gameStateInput;var prevRoundSum=gameState.prevRoundSum;if(!prevRoundSum)return null;// Filter policy choices to show 1 per number
var filteredPolicyChoices=Object(__WEBPACK_IMPORTED_MODULE_8__helpers_policyChoiceHelper__["l" /* groupByProblem */])(policyChoice);var globas=Object(__WEBPACK_IMPORTED_MODULE_7__helpers_calculationsHelper__["a" /* calculateBudgetBASIC */])(gameState,gameStateInput.myState.policyChoices,gameStateInput.myState.ministerieGlobaVerdeling,Object(__WEBPACK_IMPORTED_MODULE_7__helpers_calculationsHelper__["c" /* calculateSavingsAndLoans */])(gameStateInput),policyChoice);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"darkBckg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_scrollbars_custom___default.a,{className:'custom-height',noScrollX:true,style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container policy-ministry-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'low-policy'},gameState.currentStep===3?filteredPolicyChoices.map(function(pc,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_PolicyChoiceLaag__["a" /* default */],{key:i,problem:pc,spendableGlobas:globas,mainView:true,setShow:parseInt(_this2.props.match.params.beleidskeuze,10)===i,history:_this2.props.history});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-list'},Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["u" /* getPolicyChoiceFeedback */])(feedback.prevRoundFeedbackData).map(function(feedback,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'feedback-container-low',key:i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{feedbackCount:Object(__WEBPACK_IMPORTED_MODULE_6__helpers_feedbackHelpers__["d" /* checkRead */])(feedback)?0:1,bgColor:Math.sign(feedback.puntenscore)?'green':'red',title:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_policyChoiceHelper__["j" /* getTitle */])(feedback,gameState.language),arrow:true,feedback:true,thumbnail:Object(__WEBPACK_IMPORTED_MODULE_8__helpers_policyChoiceHelper__["b" /* getIcon */])(feedback),points:feedback.puntenscore,onClick:function onClick(){_this2.props.history.push('/beleidskeuzes/beleidskeuze/'+feedback.omschrijving);}}));}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__elements_NextStep__["a" /* default */],null));}}]);return Beleidskeuzes;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux_es_connect_connect__["a" /* default */])(function(_ref){var gameState=_ref.gameState,feedback=_ref.feedback,policyChoice=_ref.policyChoice,gameStateInput=_ref.gameStateInput,project=_ref.project;return{gameState:gameState,feedback:feedback,policyChoice:policyChoice,gameStateInput:gameStateInput,project:project};})(Beleidskeuzes));

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_ScoreRow__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_avatar_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_icons_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_arrow_udown_green_svg__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_img_arrow_udown_green_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_img_arrow_udown_green_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__helpers_groupHelper__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupPortalHome=(_temp=_class=function(_Component){_inherits(GroupPortalHome,_Component);function GroupPortalHome(props){var _this2=this;_classCallCheck(this,GroupPortalHome);var _this=_possibleConstructorReturn(this,(GroupPortalHome.__proto__||Object.getPrototypeOf(GroupPortalHome)).call(this,props));_this.fetchMyRank=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_14__apiCall__["a" /* default */])('/group/myRank',null,'GET').then(function(_ref2){var schoolClassRank=_ref2.schoolClassRank,schoolRank=_ref2.schoolRank,totalPoints=_ref2.totalPoints;_this.setState({schoolClassRank:schoolClassRank,schoolRank:schoolRank,totalPoints:totalPoints});});case 1:case'end':return _context.stop();}}},_callee,_this2);}));_this.togglePopup=function(){_this.setState({showPopUp:!_this.state.showPopUp});};_this.renderGameButtons=function(){var schoolClass=_this.props.schoolClass;// Get games from my schoolClass
if(!Array.isArray(schoolClass.SchoolClassGames))return null;var games=schoolClass.SchoolClassGames.reduce(function(arr,val){// Ignore Simulationgame as it has a custom button
if(val.Game.abbreviation!=='SS'&&val.Game.abbreviation!=='BO')arr.push(val.Game);return arr;},[]);// Render game buttons
return games.map(function(g){var curGame=__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].gameLogos.find(function(game){return game.id===g.id;});var hasGamePage=__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].gamePageGames.findIndex(function(game){return game.id===g.id;})!==-1;var hasGamePageContent=Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["g" /* getPopupCurrentGame */])(g.abbreviation)!==false;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ListButton__["a" /* default */],{key:g.id,title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])(g.name),subtitle:''+(_this.props.project.EducationProject.nameShort==='GLXL'?Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_globas_verdienen'):''),icon:curGame.logo,className:'opacity gameButton',onClick:function onClick(){if(hasGamePage>-1&&hasGamePageContent){return _this.props.history.push('/portal/gameinfo/'+g.id);}}});});};_this.state={schoolClassRank:'-',schoolRank:'-',totalPoints:'-',showPopUp:false};_this.togglePopup=_this.togglePopup.bind(_this);return _this;}_createClass(GroupPortalHome,[{key:'componentWillMount',value:function componentWillMount(){this.fetchMyRank();window.socket.on('finishedSimulationStep',this.fetchMyRank);window.socket.on('activate',this.fetchMyRank);}},{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,dispatch=_props.dispatch,project=_props.project,gameState=_props.gameState;var currentRound=gameState.Rounds?gameState.Rounds.length-1:1;if(project.EducationProject.nameShort==='GLXL'&&currentRound<=1){Object(__WEBPACK_IMPORTED_MODULE_6__helpers_popupHelper__["a" /* dispatchUnreadPopup */])(project.difficulty==="PRO"?'mhgvtintro_welkom':'mlgvtintro_welkom',dispatch,false,true);}}/**
   * Render game buttons using redux state data
   */},{key:'render',value:function render(){var _this3=this;var bonus=this.props.schoolClass.SchoolClassGames.find(function(g){return g.Game.abbreviation==='BO';});var simGame=__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].gameLogos.find(function(game){return game.abbreviation.toLowerCase()==='ss';});var boGame=__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].gameLogos.find(function(game){return game.abbreviation.toLowerCase()==='bo';});var showPopUp=this.state.showPopUp;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-home class-portal '+(this.props.project.EducationProject.nameShort==='GLXL'?'':'non-glxl')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},this.props.project.EducationProject.nameShort==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'half'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:'/portal/teaminfo'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'team-info-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'avatar'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:!this.props.group.Avatar?'img no-avatar':'img'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{backgroundImage:'url('+Object(__WEBPACK_IMPORTED_MODULE_15__helpers_groupHelper__["a" /* getGroupAvatarUrl */])(this.props.group,this.props.project,__WEBPACK_IMPORTED_MODULE_10__assets_img_icons_avatar_svg___default.a)+')'}}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'small-list-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'inner-list-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h4',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])("sim_team_info")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'arrow-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{alt:'greenArrow',src:__WEBPACK_IMPORTED_MODULE_11__assets_img_arrow_udown_green_svg___default.a}))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'half'},this.props.gameState.hideScores?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_ContentContainer__["a" /* default */],{className:'disabled-scores-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'disabled-scores'},Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_tussenstand_uitgeschakeld'))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_puntentotaal'),score:this.state.totalPoints||0,showArrow:true,to:'/portal/teaminfo'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_ranglijst_school'),score:this.state.schoolRank||0,showMedal:true,showArrow:true,to:'/portal/rankings/'+this.props.group.ProjectId}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_ScoreRow__["a" /* default */],{text:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_ranglijst_klas'),score:this.state.schoolClassRank||0,showMedal:true,showArrow:true,to:'/portal/rankings/'+this.props.group.ProjectId+'/'+this.props.group.SchoolClassId})))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'list-button-container'},this.props.project.EducationProject.nameShort==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_land_besturen'),subtitle:''+Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_globas_verdelen'),icon:simGame.logo,className:'opacity gameButton',onClick:function onClick(){if(!_this3.props.gameState.simGameActive&&_this3.props.gameState.currentRound<=4||_this3.props.gameStateInput.processingStepThree!==false){_this3.togglePopup();}else{window.location.href=_this3.props.gameState.simGameEntry;}}}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["b" /* __n */])('sim_spel',1))),this.renderGameButtons(),bonus?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ListButton__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_extra_opdrachten'),subtitle:Object(__WEBPACK_IMPORTED_MODULE_5_i18n_for_browser__["a" /* __ */])('sim_bonuspunten'),icon:boGame.logo,className:'opacity gameButton',onClick:function onClick(){_this3.props.history.push('/portal/bonuspoints');}}):'',showPopUp?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__elements_PopUp__["a" /* default */],{popUpFooter:true,id:['SIMULATION_SPENDING','END'].includes(this.props.gameState.roundData.state)?'dlgmlandbesturen_1':'dlgmlandbesturen',closePopUpClick:this.togglePopup}):null))));}}]);return GroupPortalHome;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({push:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(state){return{user:state.user,project:state.project,group:state.group,schoolClass:state.schoolClass,gameState:state.gameState,feedBack:state.feedBack,gameStateInput:state.gameStateInput};})(GroupPortalHome));

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_avatar_svg__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_icons_avatar_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_avatar_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Table__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_SectionHeading__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_StatusBox__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Defines__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__helpers_gameStateHelpers__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__helpers_feedbackHelpers__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__helpers_groupHelper__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__helpers_imageResizer__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__config__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__helpers_objectChanged__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__helpers_getUrlVars__ = __webpack_require__(72);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var setGroupId=__WEBPACK_IMPORTED_MODULE_14__actions__["a" /* default */].schoolClass.setGroupId;var TeamInfo=(_temp=_class=function(_Component){_inherits(TeamInfo,_Component);function TeamInfo(props){var _this2=this;_classCallCheck(this,TeamInfo);var _this=_possibleConstructorReturn(this,(TeamInfo.__proto__||Object.getPrototypeOf(TeamInfo)).call(this,props));_this.handleChange=function(_ref){var _ref$target=_ref.target,value=_ref$target.value,name=_ref$target.name;if(_this.props.user.role.indexOf('leader')===-1||!_this.allowUpdateName())return false;if(name==='name')value=value.toUpperCase();var state=_this.state;if(value.length<17){state.group[name]=value;state.nameChanged=true;state.submittedName=false;_this.setState(state);}};_this.getValueFromRound=function(roundNumber,keyName,gameStateFilter){var round=_this.state.group.Rounds.find(function(r){return r.roundNumber===roundNumber;});if(round){if(['AB_points','BB_points'].includes(keyName)&&!['SIMULATION_TAX_2','SIMULATION_SPENDING','END'].includes(round.state))return'';if(['C_points','V_points','VV_points'].includes(keyName)&&!['SIMULATION_SPENDING','END'].includes(round.state))return'';if(['pc_points'].includes(keyName)&&!['END'].includes(round.state))return'';if(gameStateFilter==='POLICY_CHOICE'&&keyName==='points'&&round.state!=='END')return'';if(gameStateFilter){var sum=Object(__WEBPACK_IMPORTED_MODULE_16__helpers_gameStateHelpers__["getGameStateSum"])(round.GameStates.filter(function(gs){return gs.state===gameStateFilter;}));return sum[keyName]||0;}return round.gameStateSum[keyName]||0;}return'';};_this.getValueFromRoundForMinistry=function(roundNumber,keyName,gameStateFilter){var nextRound=_this.state.group.Rounds.find(function(r){return r.roundNumber===roundNumber+1;});if(nextRound&&(nextRound.state.startsWith('SIMULATION_')||nextRound.state==='END')){return _this.getValueFromRound(roundNumber,keyName,gameStateFilter);}return'';};_this.renderTaxScores=function(){if(_this.props.project.difficulty==='PRO'){return[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_arbeidsbelasting'),'',_this.getValueFromRound(1,'AB_points'),_this.getValueFromRound(2,'AB_points'),_this.getValueFromRound(3,'AB_points'),_this.getValueFromRound(4,'AB_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bedrijvenbelasting'),'',_this.getValueFromRound(1,'BB_points'),_this.getValueFromRound(2,'BB_points'),_this.getValueFromRound(3,'BB_points'),_this.getValueFromRound(4,'BB_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_consumentenbelasting'),'',_this.getValueFromRound(1,'C_points'),_this.getValueFromRound(2,'C_points'),_this.getValueFromRound(3,'C_points'),_this.getValueFromRound(4,'C_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_mensmilieubelasting'),'',_this.getValueFromRound(1,'VV_points'),_this.getValueFromRound(2,'VV_points'),_this.getValueFromRound(3,'VV_points'),_this.getValueFromRound(4,'VV_points')],[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vermogenbelasting'),'',_this.getValueFromRound(1,'V_points'),_this.getValueFromRound(2,'V_points'),_this.getValueFromRound(3,'V_points'),_this.getValueFromRound(4,'V_points')]];}var rows=[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_belasting'),'',_this.getValueFromRound(1,'AB_points'),_this.getValueFromRound(2,'AB_points'),_this.getValueFromRound(3,'AB_points'),_this.getValueFromRound(4,'AB_points')]];if(_this.props.project.minPolicyChoices>0){rows.push([Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_beleidskeuze',0),'',_this.getValueFromRound(1,'pc_points'),_this.getValueFromRound(2,'pc_points'),_this.getValueFromRound(3,'pc_points'),_this.getValueFromRound(4,'pc_points')]);}return rows;};_this.getColor=function(ministry){var roundNumber=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var _this$props=_this.props,project=_this$props.project,gameStateInput=_this$props.gameStateInput,feedback=_this$props.feedback,gameState=_this$props.gameState;var group=_this.state.group;if(gameState.Rounds.length<=roundNumber)return'';var currentRound=gameState.Rounds.find(function(r){return r.roundNumber===roundNumber;});var nextRound=gameState.Rounds.find(function(r){return r.roundNumber===roundNumber+1;});if(!currentRound)return'';if(roundNumber>0&&(!nextRound||nextRound.state==='PLAYING_GAME'||nextRound.state==='SCORE_SUBMITTED'))return'';var fb=(!feedback.all.length?[]:feedback.all[roundNumber]||{}).feedback||[];var gs={sumUpToPrevRound:Object(__WEBPACK_IMPORTED_MODULE_16__helpers_gameStateHelpers__["getGameStateSum"])(gameState.Rounds.slice(0,roundNumber+1).reduce(function(acc,r){return acc.concat(r.GameStates);},[])),currentRound:roundNumber};var ministryCollaborations={};if(gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling){var selectedCollabs=gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling[ministry+'SW']||[];var myTheme=gameStateInput.states[roundNumber][group.id].theme;var myValue=gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling[ministry];ministryCollaborations=_defineProperty({},ministry,selectedCollabs.filter(function(theme){var otherGroup=Object.values(gameStateInput.states[roundNumber]).find(function(g){return g.theme===theme;});return otherGroup&&otherGroup.ministerieGlobaVerdeling&&myValue===otherGroup.ministerieGlobaVerdeling[ministry]&&(otherGroup.ministerieGlobaVerdeling[ministry+'SW']||[]).includes(myTheme);}));}return Object(__WEBPACK_IMPORTED_MODULE_17__helpers_feedbackHelpers__["p" /* getMinistryColor */])(project.difficulty.toLowerCase(),ministry,gs,{ministryCollaborations:ministryCollaborations},fb,true);};_this.renderMinistryScores=function(){return _this.ministries.map(function(m){return[m,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,0)}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,1),text:_this.getValueFromRoundForMinistry(1,m+'_points')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,2),text:_this.getValueFromRoundForMinistry(2,m+'_points')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,3),text:_this.getValueFromRoundForMinistry(3,m+'_points')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_StatusBox__["a" /* default */],{status:_this.getColor(m,4),text:_this.getValueFromRoundForMinistry(4,m+'_points')})];});};_this.uploadAvatar=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(file){var _this$state,group,uploadingAvatar,formData,fileName,resized;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$state=_this.state,group=_this$state.group,uploadingAvatar=_this$state.uploadingAvatar;if(!uploadingAvatar){_context.next=3;break;}return _context.abrupt('return',null);case 3:_this.setState({uploadingAvatar:true,avatarChanged:true,submittedAvatar:false});formData=new FormData();fileName=(_this.props.schoolClass.className+'-'+_this.props.schoolClass.classRoom+'-'+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(_this.props.group.GroupTheme.color).toUpperCase()).replace(/[^a-z0-9]/gi,'_')+".jpeg";_context.next=8;return Object(__WEBPACK_IMPORTED_MODULE_19__helpers_imageResizer__["a" /* default */])(file,500,500,0.8,fileName);case 8:resized=_context.sent;formData.append('file',resized,resized.name);Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/file/upload',formData,'POST').then(function(f){if(f[0]){group.Avatar=f[0];group.AvatarId=f[0].id;_this.setState({group:group,uploadingAvatar:false});}}).catch(function(){_this.setState({uploadingAvatar:false,avatarChanged:false,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_fout_uploaden_groeps_foto')},function(){if(_this.timeout)clearTimeout(_this.timeout);_this.timeout=setTimeout(function(){_this.setState({errorMessage:undefined});},7000);});});case 11:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref2.apply(this,arguments);};}();_this.openPopup=function(){var id=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var callback=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;_this.setState({popupId:id,showPopup:true,popupCallBack:callback});};_this.closePopup=function(){var executeCallBack=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;_this.setState({popupId:null,showPopup:false});if(_this.state.popupCallBack!==null&&executeCallBack){_this.state.popupCallBack();}};_this.popupBeforeSubmitGroup=function(){var group=_this.state.group;if(_this.props.user.role==='classleader')return _this.submitGroup();var nameChangedOnce=group.name!==Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(group.GroupTheme.name);var avatarChangedOnce=group.AvatarId!==null;if(!avatarChangedOnce&&!nameChangedOnce){_this.openPopup('dlgmopslaan');}else if(!avatarChangedOnce&&nameChangedOnce){_this.openPopup('dlgmopslaanfoto',_this.submitGroup);}else if(avatarChangedOnce&&!nameChangedOnce){_this.openPopup('dlgmopslaannaam');}else{_this.submitGroup();}};_this.submitGroup=function(){if(_this.state.submittingGroup)return;var user=_this.props.user;_this.setState({submittingGroup:true});if(user.role.indexOf('leader')!==-1){var group=_this.state.group;if(_this.state.nameChanged){group.countrynameLocked=true;}if(_this.state.avatarChanged){group.avatarLocked=true;}Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/group/'+group.id+'/update',group,'PUT').then(function(group){_this.setState({submittedName:_this.state.nameChanged,submittedAvatar:_this.state.avatarChanged,submittingGroup:false,group:_extends({},_this.state.group,group)});});// this.props.dispatch(updateGroup({name: __(this.state.group.name)}));
}};_this.allowUpdateName=function(){if(_this.props.user.role==='classleader')return true;return _this.props.user.role==='groupleader'&&!_this.state.group.countrynameLocked;};_this.toggleAvatarLocked=function(ev){var group=_this.state.group;if(ev!==false)ev.preventDefault();Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/group/'+group.id+'/setAvatarLocked',!group.avatarLocked,'PUT').then(function(result){group.avatarLocked=result.avatarLocked;_this.setState({group:group});});};_this.toggleCountrynameLocked=function(ev){var group=_this.state.group;if(ev!==false)ev.preventDefault();Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/group/'+group.id+'/setCountryNameLocked',!group.countrynameLocked,'PUT').then(function(result){group.countrynameLocked=!group.countrynameLocked;_this.setState({group:group});});};_this.studentNameUpdate=function(ev,index){var group=_this.state.group;if(!group.Students[index]){group.Students[index]={name:''};}group.Students[index].name=ev.target.value;_this.setState({group:group});};_this.studentNameBlur=function(ev,index){if(_this.props.user.role!=='classleader')return;var group=_this.state.group;if(!ev.target.value.length){group.Students[index]={name:''};}var el=ev.currentTarget.parentElement;el.children[0].readOnly=true;el.classList.remove('hasFocus');Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/group/'+group.id+'/setStudents',{students:group.Students.filter(function(s){return s.name.length;})},'PUT');};_this.prefillScores=function(){var body=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];while(body.length<4){body.push([[body.length+1+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdienen'),'','','',''],[body.length+1+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen'),'','','','']]);}return body.slice(0,4);};_this.prefillScoresEarn=function(){var body=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];while(body.length<4){body.push([body.length+1+'.','','']);}return body;};_this.checkShowPopup=function(){if(_this.allowUpdateName()===false){_this.openPopup('dlgmnaamopgeslagen');}};_this.renderStudentRows=function(){var students=[];while(students.length<6){var i=students.length;if(_this.state.group.Students[i]){students.push(_this.state.group.Students[i]);}else{students.push({name:''});}}return students.map(function(s,i){return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{onClick:function onClick(ev){var el=ev.currentTarget;el.children[0].readOnly=false;el.children[0].focus();el.classList.add('hasFocus');},className:'student-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{style:{width:'88%'},key:i,ref:function(){return _this['studentInputRef'+i]=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();}(),onChange:function onChange(ev){_this.studentNameUpdate(ev,i);},value:s.name,maxLength:35,readOnly:true,onBlur:function onBlur(ev){_this.studentNameBlur(ev,i);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'pen',src:__WEBPACK_IMPORTED_MODULE_15__assets_assets__["d" /* icons */].pen,alt:'pen'}))];});};_this.groupId=props.match.params.groupId;if(_this.groupId){props.dispatch(setGroupId(_this.groupId));}_this.state={group:props.group,myDetailedRank:[],submittingGroup:false,submittedAvatar:false,submittedName:false,uploadingAvatar:false,avatarChanged:false,nameChanged:false,showPopup:false,popupId:null,errorMessage:undefined};_this.ministries={};_this.fileUploadRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(TeamInfo,[{key:'componentWillMount',value:function componentWillMount(){var _this3=this;this.props.dispatch(__WEBPACK_IMPORTED_MODULE_14__actions__["a" /* default */].project.refreshProject());Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/group/myDetailedRank?includeBonusPoints=true',null,'GET').then(function(myDetailedRank){_this3.setState({myDetailedRank:myDetailedRank});});__WEBPACK_IMPORTED_MODULE_12__Defines__["a" /* default */].fetch().then(function(defines){_this3.setState({defines:defines});});}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){if(this.groupId&&props.group.id!==this.state.group.id){props.dispatch(setGroupId(this.groupId));}if(!this.state.group.loaded){this.setState({group:props.group});}if(props.user.role==='classleader'){var scGroup=props.schoolClass.group;if(scGroup&&this.state.group.id!==scGroup.id){this.setState({group:scGroup});}}if(Object(__WEBPACK_IMPORTED_MODULE_22__helpers_objectChanged__["a" /* default */])(this.state.group,props.group)){this.setState({group:props.group});}}},{key:'render',value:function render(){var _this4=this;if(!this.state.group||!this.state.group.loaded||!this.state.defines){return null;}this.ministries=this.state.defines[this.props.project.difficulty.toLowerCase()].ministries;var roundSpliceIndex=this.state.group.Rounds.findIndex(function(gr){return gr.unsetScoreVisibility;});if(roundSpliceIndex<=0||this.props.gameState.showScores){roundSpliceIndex=this.state.group.Rounds.length;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-home darkBckg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-container teaminfo-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'teaminfo '+this.props.user.role},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'close-button-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_GoBackButton__["a" /* default */],{history:this.props.history,closeWindow:Object(__WEBPACK_IMPORTED_MODULE_23__helpers_getUrlVars__["a" /* default */])()['closeWindow']==='true'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default.a,{style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_ContentContainer__["a" /* default */],{className:"avatar-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'upload-avatar '+(this.state.uploadingAvatar?'disabled':'')},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'avatar-upload-wrapper'},this.props.user.role==='classleader'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'lock'+(this.state.group.avatarLocked?' locked':''),onClick:this.toggleAvatarLocked}):null,this.props.user.role==='groupleader'&&this.state.submittedAvatar?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-avatar-saved-check'}):null,this.props.user.role==='groupleader'&&!this.state.group.avatarLocked&&!this.state.group.AvatarId?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_upload_foto_button')):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{ref:this.fileUploadRef,type:'file',disabled:this.props.user.role==='classleader'?false:this.state.group.avatarLocked,name:'avatar',accept:'image/png,image/jpeg',onChange:function onChange(e){_this4.uploadAvatar(e.target.files[0]);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{id:'team-avatar',className:!this.state.group.Avatar?'no-avatar':'',src:Object(__WEBPACK_IMPORTED_MODULE_18__helpers_groupHelper__["a" /* getGroupAvatarUrl */])(this.state.group,this.props.project,__WEBPACK_IMPORTED_MODULE_6__assets_img_icons_avatar_svg___default.a),alt:'avatar',onClick:function onClick(_){return _this4.openPopup('dlgmfotoopgeslagen');}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',{onSubmit:function onSubmit(ev){ev.preventDefault();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-container',onClick:this.checkShowPopup},this.props.user.role==='classleader'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'lock text'+(this.state.group.countrynameLocked?' locked':''),onClick:this.toggleCountrynameLocked}):null,this.props.user.role==='groupleader'&&this.state.submittedName?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-name-saved-check'}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{className:'group-badge',src:''+__WEBPACK_IMPORTED_MODULE_20__config___default.a.apiUrl+this.state.group.GroupTheme.badge,alt:'groupBadge'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'name',placeholder:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_vul_landnaam_in_placeholder'),value:this.state.group.name.toUpperCase(),onChange:this.handleChange})),this.props.user.role.indexOf('leader')!==-1?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:this.state.group.avatarLocked&&this.state.group.countrynameLocked&&['groupleader','groupmember'].includes(this.props.user.role)?'disabled':'',type:'submit',onClick:this.popupBeforeSubmitGroup},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_opslaan'))):null),this.state.errorMessage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{style:{marginTop:'20px',color:'red'}},this.state.errorMessage):null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},this.props.user.role!=='classleader'?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_15__assets_assets__["d" /* icons */].team,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_teamleden')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_Table__["a" /* default */],{body:this.renderStudentRows()}))),this.props.user.role==='classleader'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{type:'submit',onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_13__apiCall__["a" /* default */])('/user/'+_this4.state.group.id+'/loginAsGroup',{},'POST').then(function(access){window.open('/login?token='+access.token+'&redirect=/portal/teaminfo?closeWindow=true');});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bekijk_scores'))):null))),(this.props.user.role==='groupleader'||this.props.user.role==='groupmember')&&this.props.project.EducationProject.nameShort==='GLXL'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default.a,{style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_15__assets_assets__["d" /* icons */].medal,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totaalscores')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_Table__["a" /* default */],{head:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_spelronde'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_teaminfo_punten'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_totaal'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_school',1),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_klas',1)],body:[].concat.apply([],this.prefillScores(this.state.group.Rounds.filter(function(r){return[1,2,3,4].includes(r.roundNumber);}).splice(0,roundSpliceIndex).map(function(r,i){var detailedTotalPoints=[].concat(_this4.state.group.detailedTotalPoints).splice(0,r.roundNumber);var _state$group$detailed=_this4.state.group.detailedTotalPoints[i],verdienen=_state$group$detailed.verdienen,verdelen=_state$group$detailed.verdelen;var bonusPoints=_this4.props.gameState.Rounds.reduce(function(bp,round){if(Array.isArray(round.GameStates)&&r.roundNumber>=round.roundNumber){var bonusAssignmentState=round.GameStates.find(function(g){return g.type==='BONUS_ASSIGNMENT';})||{points:0};var teacherInterventionState=round.GameStates.find(function(g){return g.type==='TEACHER_INTERVENTION';})||{points:0};bp+=bonusAssignmentState.points+teacherInterventionState.points;}return bp;},0);var verdienenTotal=detailedTotalPoints.reduce(function(acc,dtp){acc+=dtp.verdelen+dtp.verdienen;return acc;},bonusPoints);verdienenTotal-=verdelen;var verdelenTotal=detailedTotalPoints.reduce(function(acc,dtp){acc+=dtp.verdelen+dtp.verdienen;return acc;},bonusPoints);var myDetailedRank=_this4.state.myDetailedRank[i]||{};var verdienenSchoolRank=myDetailedRank.verdienenSchoolRank||0;var verdelenSchoolRank=myDetailedRank.verdelenSchoolRank||0;var verdienenSchoolClassRank=myDetailedRank.verdienenSchoolClassRank||0;var verdelenSchoolClassRank=myDetailedRank.verdelenSchoolClassRank||0;var scoreArr=[[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdienen'),'','','',''],[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen'),'','','','']];if(r.state==='PLAYING_GAME'){return scoreArr;}if(r.state.startsWith('SIMULATION_')||r.state==='END'||r.state==='SCORE_SUBMITTED'&&r.roundNumber===1){scoreArr[0]=[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdienen'),verdienen,verdienenTotal,verdienenSchoolRank,verdienenSchoolClassRank];}var nextRound=_this4.state.group.Rounds.find(function(nxtR){return nxtR.roundNumber===r.roundNumber+1;});if(nextRound&&(nextRound.state.startsWith('SIMULATION_')||nextRound.state==='END')){scoreArr[1]=[r.roundNumber+'. '+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verdelen'),verdelen,verdelenTotal,verdelenSchoolRank,verdelenSchoolClassRank];}return scoreArr;}))),foot:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bonuspunten'),''+(this.state.group.Rounds.reduce(function(p,r){r.GameStates.filter(function(gs){return gs.type==='TEACHER_INTERVENTION'||gs.type==='BONUS_ASSIGNMENT';}).forEach(function(gs){return p+=gs.points;});return p;},0)||''),'','','']})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_15__assets_assets__["d" /* icons */].medal,title:''+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_scores_globas_verdienen')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_Table__["a" /* default */],{head:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_spelronde'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas'),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_teaminfo_punten')],body:this.prefillScoresEarn(this.state.group.Rounds.filter(function(r){return r.GameId;}).map(function(r){var _props$schoolClass$Sc=_this4.props.schoolClass.SchoolClassGames.find(function(g){return g.GameId===r.GameId;}),Game=_props$schoolClass$Sc.Game;if(r.state==='PLAYING_GAME'){return[r.roundNumber+'. '+Game.name,'',''];}return[r.roundNumber+'. '+Game.name,r.earnedGlobas,r.earnedPoints];}))})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'third'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_scrollbars_custom___default.a,{style:{width:'100%',height:'100%',minHeight:300}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'table-block'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__elements_SectionHeading__["a" /* default */],{className:'small',questionButton:false,icon:__WEBPACK_IMPORTED_MODULE_15__assets_assets__["d" /* icons */].medal,title:''+Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_scores_globas_verdelen')}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__elements_Table__["a" /* default */],{translate:false,head:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_onderdeel'),'S','R1','R2','R3','R4'],className:'scores-globas-verdelen-table',body:this.renderTaxScores().concat(this.renderMinistryScores()).concat(this.props.gameState.gameStateSum.remainingSavingsPoints>0?[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_overige_spaargeld'),'','','','',this.props.gameState.gameStateSum.remainingSavingsPoints]]:null).concat(this.props.gameState.gameStateSum.remainingProfitLossPoints!==0?[[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_overige_wgvg'),'','','','',this.props.gameState.gameStateSum.remainingProfitLossPoints]]:null)}))))):null)),'x        ',this.state.showPopup?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__elements_PopUp__["a" /* default */],{id:this.state.popupId,closePopUpClick:function closePopUpClick(res){_this4.closePopup(res);}}):null);}}]);return TeamInfo;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={history:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({goBack:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func}).isRequired},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(function(_ref3){var user=_ref3.user,project=_ref3.project,schoolClass=_ref3.schoolClass,group=_ref3.group,gameState=_ref3.gameState,gameStateInput=_ref3.gameStateInput,feedback=_ref3.feedback;return{user:user,project:project,schoolClass:schoolClass,group:group,gameState:gameState,gameStateInput:gameStateInput,feedback:feedback};})(TeamInfo));

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_ListButton__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Table__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_assets__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_GameDetails__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_PopUp__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__elements_Loading__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__config__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var refreshProject=__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].project.refreshProject;var activeTab=0;var SchoolPortalHome=function(_Component){_inherits(SchoolPortalHome,_Component);function SchoolPortalHome(props){var _this2=this;_classCallCheck(this,SchoolPortalHome);var _this=_possibleConstructorReturn(this,(SchoolPortalHome.__proto__||Object.getPrototypeOf(SchoolPortalHome)).call(this,props));_this.toggleTab=function(no){activeTab=no;_this.setState({activeTab:no});};_this.deleteClass=function(classId){var schoolClasses=_this.state.schoolClasses;Object(__WEBPACK_IMPORTED_MODULE_9__apiCall__["a" /* default */])('/schoolClass/'+classId,null,'DELETE');var classIndex=0;schoolClasses.forEach(function(c,i){if(c.id===classId){classIndex=i;}});schoolClasses.splice(classIndex,1);_this.props.dispatch(refreshProject());_this.setState({confirmDeletion:false,deletionId:null});};_this.toggleDeletionPopup=function(ev){var classId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;ev.preventDefault();var parent=ev.target.parentElement;var closeButton=false;while(parent){if(parent.classList.contains('close-button')){closeButton=true;}if(!closeButton){if(parent.classList.contains('popup')){return false;}}parent=parent.parentElement;}if(_this.state.confirmDeletion){_this.setState({confirmDeletion:false,deletionId:null});}else{_this.setState({confirmDeletion:true,deletionId:classId});}};_this.downloadPdf=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(type){var token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!_this.state.downloading.includes(type)){_context.next=2;break;}return _context.abrupt('return',false);case 2:token=__WEBPACK_IMPORTED_MODULE_13_glxl_helpers__["cookie"].getCookie('token');window.open(__WEBPACK_IMPORTED_MODULE_14__config___default.a.apiUrl+'/pdf/'+type+'/'+_this.props.project.id+'?authorization='+token,'_blank');case 4:case'end':return _context.stop();}}},_callee,_this2);}));return function(_x2){return _ref.apply(this,arguments);};}();_this.getTabPage=function(){var project=_this.props.project;var schoolClasses=_this.state.schoolClasses;var classes=schoolClasses;var classObject=[];if(classes){classes.forEach(function(klas){var _this3=this;if(klas.id){classObject.push([klas.className,klas.classRoom,klas.StudentsCount,project.schoolClassesLocked?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'editButtons'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:'/portal/school/class/'+klas.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_assets__["d" /* icons */].pen,alt:'pen'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_6__assets_assets__["d" /* icons */].trash,alt:'trash',onClick:function onClick(ev){_this3.toggleDeletionPopup(ev,klas.id);}}))]);}},_this);}switch(_this.state.activeTab){//Voorbereiding
case 0:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{bgColor:'blue',icon:__WEBPACK_IMPORTED_MODULE_6__assets_assets__["d" /* icons */].groepsbewerk,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_groepsindeling_invoeren'),onClick:function onClick(){return _this.setState({showGroepsIndeling:!_this.state.showGroepsIndeling});}}),_this.state.showGroepsIndeling?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'fade-in dropdownSpacing'},classObject.length?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_Table__["a" /* default */],{className:'school-portal-table',head:[Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_klas',1),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_lokaal',1),Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_leerling',0),''],body:classObject}):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'buttonRow buttonRow--wide buttonRow--spacing-top'},project.schoolClassesLocked?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{className:'button button--darkblue',to:'/portal/school/class/add'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])("sim_klas_toevoegen"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button'+(_this.state.downloading.includes('projectGroupLayouts')?' disabled':''),onClick:function onClick(){_this.downloadPdf('projectGroupLayouts');}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'PDF ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_groepsindeling'))))):null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:'/portal/school/test'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{bgColor:'blue',icon:__WEBPACK_IMPORTED_MODULE_6__assets_assets__["d" /* icons */].testen,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_test_systeembeheer')})),_this.props.project.accompaniment==="docenten"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_ListButton__["a" /* default */],{bgColor:'blue',icon:__WEBPACK_IMPORTED_MODULE_6__assets_assets__["d" /* icons */].checklist,title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_voorbereiding_docenten'),onClick:function onClick(){window.open('/portal/school/voorbereiding/'+_this.props.project.id+'/'+_this.props.project.DefaultLanguageId+'/'+_this.props.project.DefaultDifficultyId);return false;}}):null));//Afronding
case 1:return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-row score-row--margin-bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_eindstand')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'links'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:''+(_this.state.downloading.includes('eindstand')?'disabled':''),href:'',onClick:function onClick(ev){ev.preventDefault();_this.downloadPdf('eindstand');}},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_pdf_eindstand')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-row score-row--margin-bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_eindcijfers')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'links'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:''+(_this.state.downloading.includes('eindcijfers')?'disabled':''),href:'',onClick:function onClick(ev){ev.preventDefault();_this.downloadPdf('eindcijfers');}},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_pdf_eindcijfers')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-row score-row--margin-bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_fotos_downloaden')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'links'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* Link */],{to:'/portal/school/media/'+_this.props.project.id},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_link')))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'score-row score-row--margin-bottom'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_schrijf_een_review')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'links'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{href:'http://goo.gl/H4yB1z',rel:'noopener noreferrer',target:'_blank'},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('Google'))))));default:return;}};_this.state={activeTab:activeTab||0,showGroepsIndeling:sessionStorage.getItem('showGroepsIndeling')||false,confirmDeletion:false,deletionId:null,schoolClasses:[],fetched:false,downloading:[]};if(sessionStorage.getItem('showGroepsIndeling')){sessionStorage.setItem('showGroepsIndeling','');}return _this;}_createClass(SchoolPortalHome,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){var _this4=this;if(props.project.id&&!this.state.fetched){Object(__WEBPACK_IMPORTED_MODULE_9__apiCall__["a" /* default */])('/schoolClass/overview/'+props.project.id).then(function(schoolClasses){_this4.setState({schoolClasses:schoolClasses,fetched:true});});}}},{key:'componentWillMount',value:function componentWillMount(){var _this5=this;if(this.props.project.id&&!this.state.fetched){Object(__WEBPACK_IMPORTED_MODULE_9__apiCall__["a" /* default */])('/schoolClass/overview/'+this.props.project.id).then(function(schoolClasses){_this5.setState({schoolClasses:schoolClasses,fetched:true});});}document.body.classList.add('schoolPage');}},{key:'render',value:function render(){var _this6=this;if(!this.state.fetched){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__elements_Loading__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-home portal-school'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'desktop-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_GameDetails__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'buttonRow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'tab '+(this.state.activeTab===0?'button--darkblue':'button--white'),onClick:function onClick(){return _this6.toggleTab(0);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_voorbereiding'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'tab '+(this.state.activeTab===1?'button--darkblue':'button--white'),onClick:function onClick(){return _this6.toggleTab(1);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_afronding')))),this.getTabPage()),this.state.confirmDeletion?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__elements_PopUp__["a" /* default */],{title:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verwijderen'),description:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_bevestig_klas_verwijderen_melding'),showPopUp:true,closePopUpCross:true,customButton:{text:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_verwijderen'),action:function action(){return _this6.deleteClass(_this6.state.deletionId);}},closePopUpClick:function closePopUpClick(ev){return _this6.toggleDeletionPopup(ev);}}):null);}}]);return SchoolPortalHome;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__["a" /* default */])(function(state){return{project:state.project};})(SchoolPortalHome));

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Table__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Loading__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_check_svg__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assets_img_icons_check_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_check_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_glxl_helpers__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_glxl_helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_glxl_helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__config___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__config__);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolPortalClass=(_temp=_class=function(_Component){_inherits(SchoolPortalClass,_Component);function SchoolPortalClass(props){_classCallCheck(this,SchoolPortalClass);var _this=_possibleConstructorReturn(this,(SchoolPortalClass.__proto__||Object.getPrototypeOf(SchoolPortalClass)).call(this,props));_initialiseProps.call(_this);_this.state={errorMessage:undefined,saving:false,saved:false,loading:true,downloading:false,schoolClass:{className:'',classRoom:'',Groups:[{name:"LAND ROOD",GroupThemeId:1,GroupTheme:{color:'red'},Students:[{name:''},{name:''},{name:''},{name:''},{name:''},{name:''}]},{name:"LAND ORANJE",GroupThemeId:2,GroupTheme:{color:'orange'},Students:[{name:''},{name:''},{name:''},{name:''},{name:''},{name:''}]},{name:"LAND GEEL",GroupThemeId:3,GroupTheme:{color:'yellow'},Students:[{name:''},{name:''},{name:''},{name:''},{name:''},{name:''}]},{name:"LAND GROEN",GroupThemeId:4,GroupTheme:{color:'green'},Students:[{name:''},{name:''},{name:''},{name:''},{name:''},{name:''}]},{name:"LAND BLAUW",GroupThemeId:5,GroupTheme:{color:'blue'},Students:[{name:''},{name:''},{name:''},{name:''},{name:''},{name:''}]},{name:"LAND PAARS",GroupThemeId:6,GroupTheme:{color:'purple'},Students:[{name:''},{name:''},{name:''},{name:''},{name:''},{name:''}]}]}};_this.interval=0;_this.errorMessageInterval=0;// Set schoolClassId
_this.schoolClassId=parseInt(_this.props.match.params.action,10);if(isNaN(_this.schoolClassId)){_this.schoolClassId=undefined;}return _this;}_createClass(SchoolPortalClass,[{key:'componentWillUnmount',value:function componentWillUnmount(){if(this.interval){clearInterval(this.interval);}if(this.errorMessageInterval){clearInterval(this.errorMessageInterval);}}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps,nextContext){// We got the project!
if(nextProps.project.id!==this.props.project.id&&!this.schoolClassId){this.translateGroupNames(nextProps);}}},{key:'componentWillMount',value:function componentWillMount(){var _this2=this;if(this.schoolClassId){Object(__WEBPACK_IMPORTED_MODULE_7__apiCall__["a" /* default */])('/schoolClass/'+this.schoolClassId,null,'GET').then(function(schoolClass){_this2.setState({loading:false,schoolClass:_extends({},schoolClass,{Groups:schoolClass.Groups.filter(function(g){return g.active;}).map(function(group,i){while(group.Students.length<6){group.Students.push({name:''});}return group;})})});});}else{this.translateGroupNames();this.setState({loading:false});}document.body.classList.add('schoolPage');}},{key:'render',value:function render(){var _this3=this;var _state=this.state,schoolClass=_state.schoolClass,loading=_state.loading;if(loading)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Loading__["a" /* default */],null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'portal-home portal-school-classManagement darkBckg'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'desktop-content-center',style:{maxWidth:600}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container container--semiwide',style:{minWidth:600}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content-container-background'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('form',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-container inline-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{width:'auto',marginRight:20}},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_klas',1),':'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_invoer_verplicht_placeholder'),value:schoolClass.className,name:'className',onChange:function onChange(ev){_this3.handleChange(ev);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'input-container inline-input'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('label',{style:{width:'auto',marginRight:20}},Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["b" /* __n */])('sim_lokaal',1),':'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',placeholder:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_invoer_optioneel_placeholder'),value:schoolClass.classRoom,name:'classRoom',onChange:function onChange(ev){_this3.handleChange(ev);}})))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GoBackButton__["a" /* default */],{history:this.props.history}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'container classInput'},this.getClassInput(schoolClass.Groups)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'desktop-content-center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'buttonRow center buttonRow--wide'},this.props.match.params.action!=='add'?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button'+(this.state.downloading?' disabled':''),onClick:this.downloadPdf},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,'PDF ',Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_groepsindeling'))):'',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{disabled:this.state.saving||this.props.project.schoolClassesLocked,className:'button'+(this.state.saving||this.props.project.schoolClassesLocked?' disabled':''),onClick:this.schoolClassId?this.handleUpdateSchoolClass:this.handleCreateSchoolClass},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_opslaan'))),this.state.saved?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_9__assets_img_icons_check_svg___default.a,style:{height:'30px',position:'absolute',right:'-35px'},alt:''}):null),this.state.errorMessage?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_ContentContainer__["a" /* default */],{style:{padding:'15px 24px',width:'fit-content',margin:'10px auto'}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])(this.state.errorMessage))):null));}}]);return SchoolPortalClass;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_initialiseProps=function _initialiseProps(){var _this4=this;this.translateGroupNames=function(){var props=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_this4.props;var schoolClass=_extends({},_this4.state.schoolClass);schoolClass.Groups=schoolClass.Groups.map(function(g){if(!props.project.defaultLanguage||!window.translations)return g;return _extends({},g,{name:window.translations[props.project.defaultLanguage.code][g.name]||g.name});});_this4.setState({schoolClass:schoolClass});};this.handleChange=function(_ref){var _ref$target=_ref.target,value=_ref$target.value,name=_ref$target.name;var schoolClass=_this4.state.schoolClass;var maxLen=5;if(name==='className'){maxLen=5;}if(value.length<=maxLen){schoolClass[name]=value;_this4.setState({schoolClass:schoolClass});}else{// To big
}};this.downloadPdf=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!_this4.state.downloading){_context.next=2;break;}return _context.abrupt('return',false);case 2:token=__WEBPACK_IMPORTED_MODULE_10_glxl_helpers__["cookie"].getCookie('token');window.open(__WEBPACK_IMPORTED_MODULE_11__config___default.a.apiUrl+'/pdf/groupLayout/'+parseInt(_this4.props.match.params.action,10)+'?authorization='+token,'_blank');case 4:case'end':return _context.stop();}}},_callee,_this4);}));this.handleStudentUpdate=function(_ref3,groupIndex,studentIndex){var _ref3$target=_ref3.target,name=_ref3$target.name,value=_ref3$target.value;value=value.substring(0,35);var schoolClass=_this4.state.schoolClass;var group=schoolClass.Groups[groupIndex];if(group){var student=group.Students[studentIndex];if(student){student[name]=value;}else{group.Students.push(_defineProperty({},name,value));}_this4.setState({schoolClass:schoolClass});}};this.validateSchoolClass=function(schoolClass){if(_this4.errorMessageInterval){clearInterval(_this4.errorMessageInterval);}if(!(schoolClass.className&&schoolClass.className.length>=1&&schoolClass.className.length<7)){_this4.setState({errorMessage:'sim_klas_verplicht_veld_melding'});_this4.errorMessageInterval=setInterval(function(){_this4.setState({errorMessage:undefined});},5000);return false;}var invalidGroup=schoolClass.Groups.find(function(g){var validStudents=Array.isArray(g.Students)?g.Students.filter(function(s){return s.name&&s.name.length>0;}):[];return validStudents.length<2||validStudents.length>6;});if(invalidGroup){_this4.setState({errorMessage:'sim_klas_minimaal_2_studenten_per_klas_melding'});_this4.errorMessageInterval=setInterval(function(){_this4.setState({errorMessage:undefined});},5000);return false;}return true;};this.handleCreateSchoolClass=function(ev){if(_this4.state.saving||_this4.props.project.schoolClassesLocked)return false;ev.preventDefault();var schoolClass=_this4.state.schoolClass;var project=_this4.props.project;var valid=_this4.validateSchoolClass(schoolClass);if(!valid)return;_this4.setState({saving:true});Object(__WEBPACK_IMPORTED_MODULE_7__apiCall__["a" /* default */])('/schoolClass',_extends({},schoolClass,{ProjectId:project.id}),'POST').then(function(result){sessionStorage.setItem('showGroepsIndeling','true');_this4.props.history.push('/portal/school');});};this.handleUpdateSchoolClass=function(ev){if(_this4.state.saving||_this4.props.project.schoolClassesLocked)return false;ev.preventDefault();var valid=_this4.validateSchoolClass(_this4.state.schoolClass);if(!valid)return;_this4.setState({saving:true});if(_this4.interval){clearInterval(_this4.interval);}Object(__WEBPACK_IMPORTED_MODULE_7__apiCall__["a" /* default */])('/schoolClass/'+_this4.schoolClassId,_this4.state.schoolClass,'PUT').then(function(){_this4.setState({saving:false,saved:true});_this4.interval=setInterval(function(){_this4.setState({saved:false});},5000);});};this.getClassInput=function(groups){return groups.map(function(group,groupIndex){var studentInputs=[];var _loop=function _loop(){var studentIndex=studentInputs.length;var student=group.Students[studentIndex];studentInputs.push([__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'student-container'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',name:'name',placeholder:Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_naam_teamlid_placeholder'),value:student?student.name:'',onChange:function onChange(ev){_this4.handleStudentUpdate(ev,groupIndex,studentIndex);}}))]);};while(studentInputs.length<6){_loop();}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'groupInputEntry',key:'form-'+groupIndex},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Table__["a" /* default */],{translate:false,className:'school-contact-group-layout',headColor:group.GroupTheme.color,headTextColor:'white',head:[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{position:'relative',top:'2px'}},group.name)],body:studentInputs}));},[]);};},_temp);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__["a" /* default */])(function(state){return{project:state.project};})(SchoolPortalClass));

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GameMaterials__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolPortalTest=function(_Component){_inherits(SchoolPortalTest,_Component);function SchoolPortalTest(props){_classCallCheck(this,SchoolPortalTest);var _this=_possibleConstructorReturn(this,(SchoolPortalTest.__proto__||Object.getPrototypeOf(SchoolPortalTest)).call(this,props));_this.fetchGeneralMaterials=function(){if(_this.props.project&&_this.props.project.id&&!_this.state.gameMaterialsFetched&&!_this.state.fetchingGameMaterials){_this.setState({fetchingGameMaterials:true});var project=_this.props.project;Object(__WEBPACK_IMPORTED_MODULE_2__apiCall__["a" /* default */])('/generalMaterial/'+project.DefaultLanguageId+'/'+project.DefaultDifficultyId+'/software_testen').then(function(gameMaterials){_this.setState({gameMaterials:gameMaterials});}).finally(function(){_this.setState({gameMaterialsFetched:true,fetchingGameMaterials:false});});}};_this.state={gameMaterials:[],gameMaterialsFetched:false,fetchingGameMaterials:false};return _this;}_createClass(SchoolPortalTest,[{key:'componentDidMount',value:function componentDidMount(){this.fetchGeneralMaterials();}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.fetchGeneralMaterials();}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portal-home portal-school-tests darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktop-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-section title-section-white'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'content-container-bigTitle'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_test_systeembeheer')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_software_testen')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_GoBackButton__["a" /* default */],{history:this.props.history})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',{className:'content-container-title'},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_software')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GameMaterials__["a" /* default */],{items:this.state.gameMaterials}))));}}]);return SchoolPortalTest;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(function(_ref){var project=_ref.project;return{project:project};})(SchoolPortalTest));

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jszip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jszip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_file_saver__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_GameDetails__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_ImageThumbnail__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_loader_svg__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_img_loader_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_img_loader_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SchoolPortalMedia=function(_Component){_inherits(SchoolPortalMedia,_Component);function SchoolPortalMedia(props){_classCallCheck(this,SchoolPortalMedia);var _this=_possibleConstructorReturn(this,(SchoolPortalMedia.__proto__||Object.getPrototypeOf(SchoolPortalMedia)).call(this,props));_this.toggleTab=function(no){_this.setState({activeTab:no},function(){_this.fetchData();});};_this.downloadImages=function(){var project=_this.props.project;if(!_this.state.downloading){(function(){_this.setState({downloading:true});var imgs=document.getElementsByClassName('imageThumbnail-download');var promises=[];var _loop=function _loop(i){promises.push(new Promise(function(resolve){return fetch(imgs[i].dataset.url).then(function(r){return resolve(r.blob());});}));};for(var i=0;i<imgs.length;i++){_loop(i);}Promise.all(promises).then(function(blobs){var zip=__WEBPACK_IMPORTED_MODULE_3_jszip___default()();blobs.forEach(function(blob,i){zip.file('foto-'+i+'.jpeg',blob);});zip.generateAsync({type:'blob'}).then(function(zipFile){var currentDate=new Date().getTime();var fileName='fotos-'+currentDate+'.zip';return __WEBPACK_IMPORTED_MODULE_4_file_saver___default.a.saveAs(zipFile,fileName);}).then(function(){return _this.setState({downloading:false});});});})();}};_this.getTabPage=function(){//Foto's
var images=_this.state.photos.projectPhotos.concat(_this.state.photos.schoolClassPhotos.reduce(function(acc,scp){return acc.concat(scp.photos);},[])).concat(_this.state.photos.teamPhotos);if(_this.props.project.photoPlaylist){images=images.filter(function(current){return _this.props.project.photoPlaylist.includes(current.PhotoId);});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-section'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_scrollbars_custom___default.a,{style:{margin:"20px auto",width:'800px',height:'70vh',minHeight:300}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container semiWide'},images.map(function(photo,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_ImageThumbnail__["a" /* ImageThumbnail */],{key:i,image:photo.Photo.url});}))));};_this.state={activeTab:0,showGroepsIndeling:false,downloading:false,videos:{projectVideos:[],schoolClassVideos:[]},photos:{projectPhotos:[],schoolClassPhotos:[],teamPhotos:[]}};return _this;}_createClass(SchoolPortalMedia,[{key:'componentWillMount',value:function componentWillMount(){this.fetchData();document.body.classList.add('schoolPage');}},{key:'fetchData',value:function fetchData(){var _this2=this;this.setState({downloading:true});Object(__WEBPACK_IMPORTED_MODULE_9__apiCall__["a" /* default */])('/project/'+this.props.match.params.projectId+'/'+(this.state.activeTab?'videos':'photos')).then(function(result){var _this2$setState;_this2.setState((_this2$setState={},_defineProperty(_this2$setState,_this2.state.activeTab?'videos':'photos',result),_defineProperty(_this2$setState,'downloading',false),_this2$setState));});}},{key:'render',value:function render(){var _this3=this;// const { state, props } = this;
var images=this.state.photos.projectPhotos.concat(this.state.photos.schoolClassPhotos.reduce(function(acc,scp){return acc.concat(scp.photos);},[])).concat(this.state.photos.teamPhotos);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portal-home school-class-media darkBckg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desktop-content-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__elements_GameDetails__["a" /* default */],{color:'white'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__elements_GoBackButton__["a" /* default */],{history:this.props.history})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'score-text-center',style:{marginTop:'10px',color:'white',fontWeight:'bold',zIndex:1,height:0,position:'relative',top:'-25px'}},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_fotos_filmpjes_blijven_2_maand_geldig")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'buttonRow media'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'download button--green '+(images.length?'':'disabled'),onClick:function onClick(){return _this3.downloadImages();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])("sim_download")+' '+Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["b" /* __n */])('sim_foto',0)))),this.getTabPage(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:this.state.downloading?'loader-download show':'loader-download'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_10__assets_img_loader_svg___default.a,alt:'loader'})));}}]);return SchoolPortalMedia;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8_react_redux_es_connect_connect__["a" /* default */])(function(state){return{project:state.project};})(SchoolPortalMedia));

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(a,b,c){var d=new XMLHttpRequest;d.open("GET",a),d.responseType="blob",d.onload=function(){g(d.response,b,c)},d.onerror=function(){console.error("could not download file")},d.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.navigator&&/Macintosh/.test(navigator.userAgent)&&/AppleWebKit/.test(navigator.userAgent)&&!/Safari/.test(navigator.userAgent),g=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype&&!a?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(b,d,e,g){if(g=g||open("","_blank"),g&&(g.document.title=g.document.body.innerText="downloading..."),"string"==typeof b)return c(b,d,e);var h="application/octet-stream"===b.type,i=/constructor/i.test(f.HTMLElement)||f.safari,j=/CriOS\/[\d]+/.test(navigator.userAgent);if((j||h&&i||a)&&"undefined"!=typeof FileReader){var k=new FileReader;k.onloadend=function(){var a=k.result;a=j?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),g?g.location.href=a:location=a,g=null},k.readAsDataURL(b)}else{var l=f.URL||f.webkitURL,m=l.createObjectURL(b);g?g.location=m:location.href=m,g=null,setTimeout(function(){l.revokeObjectURL(m)},4E4)}});f.saveAs=g.saveAs=g,"undefined"!=typeof module&&(module.exports=g)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(31)))

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageThumbnail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ImageThumbnail=function(_Component){_inherits(ImageThumbnail,_Component);function ImageThumbnail(props){_classCallCheck(this,ImageThumbnail);var _this=_possibleConstructorReturn(this,(ImageThumbnail.__proto__||Object.getPrototypeOf(ImageThumbnail)).call(this,props));_this.checkOrientation=function(ev){_this.setState({orientation:_this.refs.image.naturalWidth>_this.refs.image.naturalHeight?'landscape':'portrait'});};_this.state={orientation:'landscape'};return _this;}_createClass(ImageThumbnail,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container content-container--imageThumbnail'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content-container-background imageThumbnail-download orientation-'+this.state.orientation,'data-url':this.props.image},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{ref:'image',onLoad:function onLoad(ev){return _this2.checkOrientation(ev);},src:this.props.image,alt:"grpimg"})));}}]);return ImageThumbnail;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/loader.268463b4.svg";

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_PopupTitle__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_GameMaterials__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Prepare=function(_React$Component){_inherits(Prepare,_React$Component);function Prepare(props){_classCallCheck(this,Prepare);var _this=_possibleConstructorReturn(this,(Prepare.__proto__||Object.getPrototypeOf(Prepare)).call(this,props));_this.state={generalMaterial:[],project:{}};return _this;}_createClass(Prepare,[{key:'componentWillMount',value:function componentWillMount(){this.fetchMaterials();document.body.classList.add('schoolPage');}},{key:'fetchMaterials',value:function fetchMaterials(){var _this2=this;var _props$match$params=this.props.match.params,languageId=_props$match$params.languageId,difficultyId=_props$match$params.difficultyId,projectId=_props$match$params.projectId;var promises=[Object(__WEBPACK_IMPORTED_MODULE_5__apiCall__["a" /* default */])('/project/'+projectId+'/public',null,'GET'),Object(__WEBPACK_IMPORTED_MODULE_5__apiCall__["a" /* default */])('/generalMaterial/'+languageId+'/'+difficultyId+'/preparation',null,'GET')];Promise.all(promises).then(function(_ref){var _ref2=_slicedToArray(_ref,2),project=_ref2[0],generalMaterial=_ref2[1];_this2.setState({generalMaterial:generalMaterial,project:project||{}});});// Force update language in gamestate to fix issue with popups always being dutch on prepare page
this.props.dispatch(__WEBPACK_IMPORTED_MODULE_7__actions__["a" /* default */].gameState.forceUpdateLanguage(parseInt(languageId,10)===2?"EN":"NL"));}},{key:'render',value:function render(){var _state=this.state,generalMaterial=_state.generalMaterial,project=_state.project;var history=this.props.history;if(!project.id)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'classleader-prepare portal-home darkBckg desktop-single'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container general-materials-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__elements_GoBackButton__["a" /* default */],{history:history,closeWindow:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_PopupTitle__["a" /* default */],{forceLanguage:parseInt(this.props.match.params.languageId,10)===2?"EN":"NL",popupId:'dhbvtvoorbereiding',tag:'h3'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_docent')),project.expired?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{style:{marginTop:'20px'}},Object(__WEBPACK_IMPORTED_MODULE_1_i18n_for_browser__["a" /* __ */])('sim_project_is_verlopen_melding')):null),!project.expired?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__elements_GameMaterials__["a" /* default */],{projectId:this.state.project?this.state.project.id:null,items:generalMaterial}):null));}}]);return Prepare;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return state;})(Prepare));

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_apiCall__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_elements_AudioGameMaterial__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_GoBackButton__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_elements_QuestionButton__ = __webpack_require__(61);
var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EscapeRoute=function(_Component){_inherits(EscapeRoute,_Component);function EscapeRoute(props){_classCallCheck(this,EscapeRoute);var _this=_possibleConstructorReturn(this,(EscapeRoute.__proto__||Object.getPrototypeOf(EscapeRoute)).call(this,props));_this.state={items:[]};_this.language=props.schoolClass.LanguageId;_this.difficulty=props.schoolClass.DifficultyId;_this.game=props.schoolClass.SchoolClassGames.find(function(scg){return scg.GameId===4;});return _this;}_createClass(EscapeRoute,[{key:'componentWillMount',value:function componentWillMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_3__components_apiCall__["a" /* default */])('/escapeRouteItem/'+this.language+'/'+this.difficulty,null,'GET').then(function(items){var processedItems=items.map(function(item){return _extends({},item,{Material:item.Audio});});_this2.setState({items:processedItems});});}},{key:'render',value:function render(){var items=this.state.items;var _props=this.props,history=_props.history,gameState=_props.gameState,desktop=_props.desktop;if(gameState.roundData.GameId!==4||gameState.roundData.state!=='PLAYING_GAME'){history.goBack();return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'portal-verdienen classleader-prepare '+(desktop?'portal-home darkBckg':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_elements_GoBackButton__["a" /* default */],{history:history}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_elements_QuestionButton__["a" /* default */],null,this.game.Game.name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2_i18n_for_browser__["a" /* __ */])('sim_globas_verdienen')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-item-container'},items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{key:item.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_elements_AudioGameMaterial__["a" /* default */],{item:item}));}))));}}]);return EscapeRoute;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{group:state.group,schoolClass:state.schoolClass,gameState:state.gameState};})(EscapeRoute));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.6f0a277b.js